import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ConfirmModal from '../components/ConfirmModal';
import TareoModal from '../components/TareoModal';
import ExcelJS from 'exceljs';
import { useAuth } from '../hooks/useAuth';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import afpService from '../services/afpService';
import conceptosAfectosTareosService from '../services/conceptosAfectosTareosService';
import conceptosNoAfectanVacacionesService from '../services/conceptosNoAfectanVacacionesService';
import conceptosAfectanLicenciaGoceHaberService from '../services/conceptosAfectanLicenciaGoceHaberService';
import formulaService from '../services/formulaService';
import informacionGeneralService from '../services/informacionGeneralService';
import plameConfiguracionService from '../services/plameConfiguracionService';
import regimenLaboralService from '../services/regimenLaboralService';
import tramoRentaService from '../services/tramoRentaService';
import planillaService from '../services/planillaService';
import tareoService from '../services/tareoService';

import empleadoConceptoService from '../services/empleadoConceptoService';
import planillaCalculoService from '../services/planillaCalculoService';
import { logDiagnosticoBonificacionNocturna, logDiagnosticoBonificacionNocturnaVisible } from '../utils/bonificacionNocturnaPlanilla';
import conceptosEstaticosService from '../services/conceptosEstaticosService';
import configuracionTareoService from '../services/configuracionTareoService';
import compensacionService from '../services/compensacionService';
import planillaCierreService from '../services/planillaCierreService';
import JatsaIngestaEstado, { JatsaConexionBadge } from '../components/JatsaIngestaEstado';
import JatsaConceptosApiModal from '../components/JatsaConceptosApiModal';
import {
  anexarMensajeJatsa,
  debeAutoRecerrarJatsa,
  haySincronizacionJatsaParaRevertir,
  inspeccionDesdeRespuestaConceptosJatsa,
  limpiarAutoRecerrarJatsa,
  marcarAutoRecerrarJatsa,
  mensajeAplicarConceptosJatsa,
  mensajeCierreJatsa,
  mensajeReenvioJatsa,
  mensajeRevertirJatsa,
  motivoAutoRecerrarJatsa,
  mostrarConexionJatsa,
  mostrarIngestaJatsa,
  urlFichaCerradaJatsa,
  urlFichaCerradaJatsaConSesion,
} from '../utils/jatsaIngestaVisible';
import planillaCerradaService from '../services/planillaCerradaService';
import consideracionesConceptosService from '../services/consideracionesConceptosService';
import { mapaOverridesDesdeApi } from '../utils/tareoEventoEfectivo';
import { mapaTramosDesdeApi, textoAclaracionSueldoPartido, textoSueldoTramoInterna, tramoActivoParaEmpleado, anotarConceptosConSueldoTramo } from '../utils/boletaInternaTramos';
import { mapaSueldoTramosDesdeApi, tramoSueldoPlameActivo, destinoAplicaInterna as destinoSueldoAplicaInterna } from '../utils/sueldoTramosPlame';
import EventosBoletaOverrideModal from '../components/EventosBoletaOverrideModal';
import BoletaInternaTramosModal from '../components/BoletaInternaTramosModal';
import SueldoTramosPlameModal from '../components/SueldoTramosPlameModal';
import fechasComputoRhService from '../services/fechasComputoRhService';
import feriadosPagoDobleService from '../services/feriadosPagoDobleService';
import configuracionDescansoLaboradoService from '../services/configuracionDescansoLaboradoService';
import configuracionTasaNocturnaService from '../services/configuracionTasaNocturnaService';
import configuracionBoletaService from '../services/configuracionBoletaService';
import configuracionPlanillaAlternativaService from '../services/configuracionPlanillaAlternativaService';
import construccionCivilService from '../services/construccionCivilService';
import { completarCatalogoBoletaConstruccion, diasParaNetoConstruccion, esRegimenConstruccionCivil, resolverNetoPorDiaConstruccion } from '../services/calculoRemuneracionConstruccionCivil';
import { codigoPlameParaDeclaracionRem } from '../utils/horasExtrasConstruccionCivil';
import configuracionViaticosStandardService from '../services/configuracionViaticosStandardService';
import { evaluarCuadreViaticos, etiquetaCuadreViaticos } from '../utils/evaluarCuadreViaticos';
import { obtenerLogoEmpresaBase64 } from '../services/logoEmpresaService';
import { generarHtmlBoletaPago } from '../utils/boletaHtml';
import { calcularTasaNocturnaEmpleado } from '../utils/calcularTasaNocturnaEmpleado';
import CompensacionesModal from '../components/CompensacionesModal';
import SegurosPlanillaModal from '../components/SegurosPlanillaModal';
import PagoJornalModal from '../components/PagoJornalModal';
import GratificacionConsuModal from '../components/GratificacionConsuModal';
import PeriodoCalculoConsuModal from '../components/PeriodoCalculoConsuModal';
import planillaSeguroService from '../services/planillaSeguroService';
import { CODIGOS_SEGURO_PLANILLA } from '../constants/segurosPlanilla';
import { aplicarSegurosAlArrayUnificado, construirSeccionSegurosPlanilla } from '../utils/aplicarSegurosPlanilla';
import {
  empleadoParaBoletaOrdinaria,
  esConceptoDeclaracionGratificacion,
  esConceptoDeclaracionMovilidadJatsa,
  esConceptoDeclaracionViatico,
  esConceptoLiquidacionPlanilla,
  esConceptoSoloDeclaracion,
  esCalculoConceptoLiquidacionDescuento,
  esDescuentoLiquidacionPlanilla,
  esDescuentoSoloDeclaracion,
  conceptosSoloDeclaracionGratificacion,
  conceptosSoloDeclaracionViatico,
  montosDeclaracionPorBoleta,
  aplicarDeclaracionGratificacionDesdeModulo,
  fusionarLiquidacionPlanillaEnConceptos,
  normalizarConceptosSnapshotPlanillaCerrada,
  recalcularTotalesBoletaOrdinaria,
  alinearCalculosLiquidacionEstaticos,
  descripcionPlameFromCatalogo,
  etiquetaVisibleConceptoPlame,
  descripcionPlameParaLinea,
} from '../utils/gratificacionPlame';
import { esTareoSimple, horasTrabajadasEfectivas, usaHorasFijas8Simple } from '../utils/horasTareoSimple';
import { ENV_CONFIG } from '../config/environment';
import { generarExcelAfpnet } from '../utils/afpnetExport';
import {
  construirEmpleadoParaHistorialLaboral,
  construirEmpleadoParaHistorialInterno,
  obtenerFechasLaboralesEfectivasEnRango,
  obtenerPeriodoLaboralEnRango,
  obtenerRegistrosHistorial,
  tareoEnPeriodoLaboralEfectivo,
  empleadoActivoDuranteRango,
  empleadoActivoDuranteRangoInterno,
  empleadoVigenteEnRangoPlanilla,
  canalesBoletaEnPeriodo,
  vistaBoletaUsaCanalInterno,
} from '../utils/fechaImportacion';
import { extraerFechaNacimientoEmpleado, formatFechaSoloDiaDdMmYyyy } from '../utils/formatFechaSoloDia';
import {
  resolverFechaCeseReferencia,
  resolverFechaIngresoReferencia,
} from '../utils/fechaInicioReferenciaEmpleado';
import { partirEmpleadoMixtoParaPdf, planillaParaBoletaMixto } from '../utils/boletaMixtoPdf';
import {
  esDescuentoAbsorbidoEn0121Jornal,
  esFechaIsoCompleta,
  esPersonalJornalNoConstruccion,
  montoAbsorbido0121Jornal,
  montoDominicalFusionarEn0705,
  resolverDescuentoDominical,
  resolverModoPagoJornal,
} from '../utils/pagoJornalPlanilla';
import { armarSnapshotInternaCierre, aplicarSnapshotInternaCierre, fusionarTotalesVistaCerrada } from '../utils/snapshotInternaCierre';
import { esPlanillaModalidadConstruccion, resolverPeriodoCalculoConsu } from '../utils/periodoCalculoConsu';
import { codigoTipoDocumentoPlame } from '../utils/codigoTipoDocumentoPlame';
import {
  parseAjusteTemporal,
  getMontoDesdeAjuste,
  getDestinoDesdeAjuste,
  destinoAplicaInterna,
  destinoAplicaInternaParaEmpleado,
  codigoConceptoAjuste,
  conceptoVaABoletaPlame,
  fusionarAjustesEnInterna,
} from '../utils/ajusteConceptoDestino';
import {
  agruparConceptos,
  fusionarConceptosFichaConAjustes,
  aplicarAjustesAConceptosUsuario,
  aplicarPayloadAConceptosLocales,
  buscarValorPorConcepto,
  construirPayloadAjustesRecalculo,
  empleadoTieneCambiosAjustes,
} from '../utils/recalculoConsideracionesConceptos';

const resolverFechaIngresoEnPlanilla = resolverFechaIngresoReferencia;

const tareoIncluidoEnPlanillaYLaboral = (tareo, empleado, fechaInicio, fechaFin) => {
  if (!tareo.fecha || !fechaInicio || !fechaFin) return true;
  const fechaTareo = tareo.fecha.split('T')[0];
  const inicio = String(fechaInicio).split('T')[0];
  const fin = String(fechaFin).split('T')[0];
  if (fechaTareo < inicio || fechaTareo > fin) return false;
  return tareoEnPeriodoLaboralEfectivo(tareo.fecha, empleado, fechaInicio, fechaFin);
};

const camposHistorialInternoCalculo = (empleado) => ({
  historial_laboral_interno:
    empleado?.historial_laboral_interno
    || empleado?.historialLaboralInterno
    || [],
  fecha_ingreso_interna:
    empleado?.fecha_ingreso_interna
    || empleado?.fechaIngresoInterna
    || null,
});

/** Planilla cerrada / ajuste posterior: mismo shape de fechas e historial que planilla abierta para el motor de cálculo. */
const normalizarEmpleadoParaCalculoPlanilla = (empleado, planillaReal) => {
  if (!empleado) return empleado;
  const ingresoReferencia = resolverFechaIngresoEnPlanilla(
    empleado,
    planillaReal?.fecha_inicio,
    planillaReal?.fecha_fin,
  );
  const ingresoFallback =
    ingresoReferencia
    || empleado.fecha_ingreso_actual
    || empleado.fecha_ingreso
    || empleado.fechaIngreso
    || (planillaReal?.fecha_inicio ? String(planillaReal.fecha_inicio).split('T')[0] : null);

  const preparado = {
    ...empleado,
    id: empleado.id ?? empleado.empleado_id,
    regimen_laboral_id: empleado.regimen_laboral_id ?? empleado.regimen_laboral?.id,
    afp_id: empleado.afp_id ?? empleado.afp?.id,
    cuspp: empleado.cuspp ?? empleado.codigo_cuspp ?? empleado.cuspp_codigo,
    comision_tipo: empleado.comision_tipo ?? empleado.afp?.comision_tipo,
    tipo_afp: empleado.tipo_afp ?? empleado.afp?.tipo_afp ?? empleado.afp?.tipo,
    fecha_ingreso_actual: empleado.fecha_ingreso_actual || ingresoFallback,
    fecha_ingreso: empleado.fecha_ingreso || empleado.fecha_ingreso_actual || ingresoFallback,
    fechaIngreso: empleado.fechaIngreso || ingresoFallback,
    fecha_cese_actual: empleado.fecha_cese_actual ?? empleado.fecha_cese ?? null,
    fecha_cese: empleado.fecha_cese ?? empleado.fecha_cese_actual ?? null,
    historial_laboral:
      Array.isArray(empleado.historial_laboral) && empleado.historial_laboral.length > 0
        ? empleado.historial_laboral
        : empleado.historial_laboral,
  };
  return construirEmpleadoParaHistorialLaboral(preparado);
};

const filtrarTareosPlanillaPorHistorial = (tareos, empleado, fechaInicio, fechaFin, modo = 'plame') => {
  const empHist = modo === 'interno'
    ? construirEmpleadoParaHistorialInterno(empleado)
    : construirEmpleadoParaHistorialLaboral(empleado);
  return (tareos || []).filter((tareo) => tareoIncluidoEnPlanillaYLaboral(
    tareo,
    empHist,
    fechaInicio,
    fechaFin
  ));
};

const tareoIncluidoEnPeriodoPlanilla = (tareo, fechaInicio, fechaFin) => {
  if (!tareo?.fecha || !fechaInicio || !fechaFin) return true;
  const fechaTareo = String(tareo.fecha).split('T')[0];
  const inicio = String(fechaInicio).split('T')[0];
  const fin = String(fechaFin).split('T')[0];
  return fechaTareo >= inicio && fechaTareo <= fin;
};

const filtrarTareoSegunPlanilla = (tareo, empleado, fechaInicio, fechaFin, modo = 'plame') => {
  if (!tareoIncluidoEnPeriodoPlanilla(tareo, fechaInicio, fechaFin)) return false;
  const empleadoLaboral = modo === 'interno'
    ? construirEmpleadoParaHistorialInterno(empleado)
    : construirEmpleadoParaHistorialLaboral(empleado);
  if (!obtenerRegistrosHistorial(empleadoLaboral).length) return true;
  return tareoEnPeriodoLaboralEfectivo(tareo.fecha, empleadoLaboral, fechaInicio, fechaFin);
};

const armarTasaNocturnaEmpleado = (tareosEmpleado, empleado, configuracionTasaNocturna, conceptosPlame) => {
  const ingresos = agruparConceptos(empleado.conceptos).ingresos;
  const ingresoBasico = ingresos.find(
    (c) => String(c.plame_configuracion?.codigo_plame || c.codigo_plame || '') === '0121'
  );
  const remuneracionBasica = parseFloat(ingresoBasico?.monto || empleado.sueldo_basico || 0);
  logDiagnosticoBonificacionNocturna('armarTasaNocturnaEmpleado (PlanillaDetalle)', {
    empleado_id: empleado.id,
    empleado_nombre: empleado.nombre_completo,
    configuracionTasaNocturna,
    tareos_total: tareosEmpleado?.length ?? 0,
    remuneracion_basica_0121: remuneracionBasica,
  });
  return calcularTasaNocturnaEmpleado({
    tareos: tareosEmpleado,
    remuneracionBasica,
    configuracionTasaNocturna,
    conceptosPlame,
  });
};

const PlanillaDetalle = () => {
  //console.log('🔄🔄🔄 COMPONENTE PLANILLA DETALLE SE ESTÁ RENDERIZANDO 🔄🔄🔄');
  
  // 🔢 CONFIGURACIÓN PARA DIVISIÓN DE PDFs MASIVOS  
  const EMPLEADOS_POR_PDF = 25; // ✅ REDUCIDO a 25 empleados por PDF para mayor estabilidad
  
  const { id } = useParams();
  const navigate = useNavigate();
  const authContext = useAuth();
  const { selectedCompany } = authContext;
  
  //console.log('🔍 AuthContext completo:', authContext);
  //console.log('🔍 selectedCompany desde useAuth:', selectedCompany);
  //console.log('🔍 isAuthenticated:', authContext.isAuthenticated);
  //console.log('🔍 user:', authContext.user);
  const [planilla, setPlanilla] = useState({
    id: parseInt(id),
    nombre: 'Cargando...',
    periodo: 'Cargando...',
    fecha_inicio: null,
    fecha_fin: null,
    estado: 'proceso',
    total_empleados: 0,
    created_at: null,
    descripcion: 'Cargando información...'
  });
  const [planillaReal, setPlanillaReal] = useState(null); // Estado para almacenar la planilla real del backend
  const [empleados, setEmpleados] = useState([]);
  const [afps, setAfps] = useState([]);
  const [conceptosAfectos, setConceptosAfectos] = useState([]);
  const [conceptosNoAfectanVacaciones, setConceptosNoAfectanVacaciones] = useState([]);
  const [conceptosAfectanLicenciaGoceHaber, setConceptosAfectanLicenciaGoceHaber] = useState([]);
  const [formulas, setFormulas] = useState([]);
  const [informacionGeneral, setInformacionGeneral] = useState(null);
  const [configuracionesPlame, setConfiguracionesPlame] = useState([]);
  const [regimenesLaborales, setRegimenesLaborales] = useState([]);
  const [construccionCivilDatos, setConstruccionCivilDatos] = useState({ parametros: [], plame: [], fichas: [] });
  const [tramosRenta, setTramosRenta] = useState([]);
  const [conceptosEstaticos, setConceptosEstaticos] = useState([]);
  const [configuracionTareo, setConfiguracionTareo] = useState(null);
  const [empleadosConConceptos, setEmpleadosConConceptos] = useState([]);
  const [fechasComputoRhConfig, setFechasComputoRhConfig] = useState([]);
  const [feriadosPagoDobleConfig, setFeriadosPagoDobleConfig] = useState([]);
  const [configuracionDescansoLaboradoConfig, setConfiguracionDescansoLaboradoConfig] = useState({
    pago_doble: false,
  });
  const [configuracionTasaNocturnaConfig, setConfiguracionTasaNocturnaConfig] = useState({
    activo: false,
    calcular_en_planilla: true,
    horas_tasa_nocturna: 8,
  });
  const [empleadosActivosPlanilla, setEmpleadosActivosPlanilla] = useState([]); // Estado para empleados activos durante la planilla
  const [empleadosConBoletasCalculadas, setEmpleadosConBoletasCalculadas] = useState([]); // Estado para empleados con boletas calculadas
  const [procesamientoAutomaticoEjecutado, setProcesamientoAutomaticoEjecutado] = useState(false); // Control de procesamiento automático
  const [empleadoSeleccionadoAnalisis, setEmpleadoSeleccionadoAnalisis] = useState(null); // Estado para empleado seleccionado en análisis individual
  const [compensacionesTodosEmpleados, setCompensacionesTodosEmpleados] = useState([]); // Estado para compensaciones de todos los empleados
  const [generandoExcelCompensaciones, setGenerandoExcelCompensaciones] = useState(false); // Estado para exportación Excel compensaciones
  const [modalAnalisisAbierto, setModalAnalisisAbierto] = useState(false); // Estado para controlar el modal de análisis
  const [busquedaEmpleado, setBusquedaEmpleado] = useState(''); // Estado para la búsqueda de empleados
  const [empleadosFiltrados, setEmpleadosFiltrados] = useState([]); // Estado para empleados filtrados
  const [mostrarSugerencias, setMostrarSugerencias] = useState(false); // Estado para mostrar/ocultar sugerencias
  const [estadisticasEmpresa, setEstadisticasEmpresa] = useState(null);
  const [tareosPeriodo, setTareosPeriodo] = useState([]);
  const [resumenTareos, setResumenTareos] = useState(null);
  const [autorizacionesPeriodo, setAutorizacionesPeriodo] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('resumen');
  const [planillaCerrada, setPlanillaCerrada] = useState(false); // Estado para detectar si planilla está cerrada
  const [empleadosFotografiadosIds, setEmpleadosFotografiadosIds] = useState(() => new Set());
  const [snapshotsPreCierre, setSnapshotsPreCierre] = useState([]);
  const [guardandoPreCierreId, setGuardandoPreCierreId] = useState(null);
  const [reabriendoPreCierreId, setReabriendoPreCierreId] = useState(null);
  const [empleadosEnAjustePosteriorIds, setEmpleadosEnAjustePosteriorIds] = useState(() => new Set());
  const [ajustePosteriorDepsCargadas, setAjustePosteriorDepsCargadas] = useState(false);
  const [abriendoAjustePosteriorId, setAbriendoAjustePosteriorId] = useState(null);
  const [cerrandoAjustePosteriorId, setCerrandoAjustePosteriorId] = useState(null);
  const [reenviandoJatsa, setReenviandoJatsa] = useState(false);
  const [abriendoJatsa, setAbriendoJatsa] = useState(false);
  const [consultandoConceptosJatsa, setConsultandoConceptosJatsa] = useState(false);
  const [aplicandoConceptosJatsa, setAplicandoConceptosJatsa] = useState(false);
  const [revirtiendoJatsa, setRevirtiendoJatsa] = useState(false);
  const [jatsaConceptosInspeccion, setJatsaConceptosInspeccion] = useState(null);
  const [jatsaConceptosApiModalAbierto, setJatsaConceptosApiModalAbierto] = useState(false);
  const [cargandoInspeccionJatsa, setCargandoInspeccionJatsa] = useState(false);
  const [autoRecerrandoJatsa, setAutoRecerrandoJatsa] = useState(() => debeAutoRecerrarJatsa(id));
  const [motivoRecierreJatsa] = useState(() => motivoAutoRecerrarJatsa());
  const autoRecierreLanzado = useRef(false);
  const [firmaEmpresa, setFirmaEmpresa] = useState(null); // Estado para la firma de la empresa (URL)
  const [firmaEmpresaBase64, setFirmaEmpresaBase64] = useState(null); // Estado para la firma en base64
  const [loadingFirma, setLoadingFirma] = useState(false); // Estado de carga de la firma
  const [estiloBoletaActiva, setEstiloBoletaActiva] = useState('colorido');
  const [logoEmpresaBase64, setLogoEmpresaBase64] = useState(null);

  // 🔒 Efecto para redirigir pestañas no disponibles según el estado de la planilla
  useEffect(() => {
    if (planillaCerrada && activeTab === 'consideraciones' && empleadosEnAjustePosteriorIds.size === 0) {
      setActiveTab('resumen');
    }
    if (!planillaCerrada && (activeTab === 'plame' || activeTab === 'compensaciones')) {
      //console.log('🔓 Planilla abierta detectada - Redirigiendo de Archivos PLAME/Compensaciones a Resumen');
      setActiveTab('resumen');
    }
  }, [planillaCerrada, activeTab, empleadosEnAjustePosteriorIds.size]);

  useEffect(() => {
    const cargarSeguros = async () => {
      if (!planillaReal?.id) {
        setSegurosPlanillaResumen([]);
        setSegurosPlanillaRegistros([]);
        return;
      }

      try {
        const response = await planillaSeguroService.obtenerSeguros(planillaReal.id);
        if (response.success) {
          setSegurosPlanillaResumen(response.data?.resumen || []);
          setSegurosPlanillaRegistros(response.data?.registros || []);
        }
      } catch (error) {
        console.error('❌ Error al cargar seguros de planilla:', error);
      }
    };

    const cargarFlagsConsideraciones = async () => {
      if (!planillaReal?.id) {
        setConsideracionesEmpleadoFlags({});
        return;
      }
      try {
        const response = await consideracionesConceptosService.obtenerFlagsEmpleado(planillaReal.id);
        if (response?.success) {
          setConsideracionesEmpleadoFlags(response.data?.flags || {});
        }
      } catch (error) {
        console.error('❌ Error al cargar flags consideraciones empleado:', error);
        setConsideracionesEmpleadoFlags({});
      }
    };

    const cargarOverridesTareoEvento = async () => {
      if (!planillaReal?.id) {
        setOverridesTareoEvento({});
        return;
      }
      try {
        const response = await consideracionesConceptosService.obtenerOverridesTareoEvento(planillaReal.id);
        if (response?.success) {
          setOverridesTareoEvento(mapaOverridesDesdeApi(response.data));
        }
      } catch (error) {
        console.error('❌ Error al cargar overrides tareo evento:', error);
        setOverridesTareoEvento({});
      }
    };

    const cargarTramosBoletaInterna = async () => {
      if (!planillaReal?.id) {
        setTramosBoletaInterna({});
        return;
      }
      try {
        const response = await consideracionesConceptosService.obtenerTramosBoletaInterna(planillaReal.id);
        if (response?.success) {
          setTramosBoletaInterna(mapaTramosDesdeApi(response.data));
        }
      } catch (error) {
        console.error('❌ Error al cargar tramos boleta interna:', error);
        setTramosBoletaInterna({});
      }
    };

    const cargarTramosSueldoPlame = async () => {
      if (!planillaReal?.id) {
        setTramosSueldoPlame({});
        return;
      }
      try {
        const response = await consideracionesConceptosService.obtenerTramosSueldoPlame(planillaReal.id);
        if (response?.success) {
          setTramosSueldoPlame(mapaSueldoTramosDesdeApi(response.data));
        }
      } catch (error) {
        console.error('❌ Error al cargar tramos de sueldo PLAME:', error);
        setTramosSueldoPlame({});
      }
    };

    cargarSeguros();
    cargarFlagsConsideraciones();
    cargarOverridesTareoEvento();
    cargarTramosBoletaInterna();
    cargarTramosSueldoPlame();
  }, [planillaReal?.id]);

  // 🖼️ Función para cargar la firma de la empresa (disponible para planillas abiertas y cerradas)
  const cargarFirmaEmpresa = async () => {
    if (!selectedCompany?.id) return;
    
    setLoadingFirma(true);
    actualizarProgreso('🖼️ Firma Empresa'); // Iniciar tracking
    
    try {
      // Obtener token desde localStorage con las diferentes posibles claves
      const token = localStorage.getItem('token') || 
                   localStorage.getItem('planillas_sanctum_token') || 
                   localStorage.getItem(ENV_CONFIG.SANCTUM_TOKEN_KEY);
      
      console.log('🖼️ Cargando firma empresa. Empresa ID:', selectedCompany.id);
      
      const response = await fetch(`${ENV_CONFIG.API_BASE_URL}/get-firma/${selectedCompany.id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
        }
      });
      
      if (response.ok) {
        const result = await response.json();
        console.log('🖼️ Resultado carga firma:', result);
        
        if (result.success && result.firma_url) {
          // Construir URL completa para la firma
          const firmaUrl = result.firma_url.startsWith('http') 
            ? result.firma_url 
            : `${ENV_CONFIG.API_BASE_URL.replace('/api', '')}${result.firma_url}`;
          
          setFirmaEmpresa(firmaUrl);
          console.log('✅ Firma empresa cargada exitosamente para PDFs:', firmaUrl);
          
          // Obtener la imagen en base64 directamente desde el backend
          const firmaBase64 = await obtenerFirmaBase64Directa(selectedCompany.id);
          if (firmaBase64) {
            setFirmaEmpresaBase64(firmaBase64);
            console.log('✅ Firma base64 obtenida exitosamente desde API');
          } else {
            console.log('⚠️ No se pudo obtener la firma en base64 desde API');
            setFirmaEmpresaBase64(null);
          }
        } else {
          console.log('ℹ️ No hay firma registrada para esta empresa');
          setFirmaEmpresa(null);
          setFirmaEmpresaBase64(null);
        }
      } else {
        console.log('⚠️ No se pudo cargar la firma:', response.status);
        setFirmaEmpresa(null);
        setFirmaEmpresaBase64(null);
      }
      
      actualizarProgreso('🖼️ Firma Empresa', true); // Marcar como completada
      
    } catch (error) {
      console.error('❌ Error al cargar firma empresa:', error);
      setFirmaEmpresa(null);
      setFirmaEmpresaBase64(null);
      actualizarProgreso('🖼️ Firma Empresa', true); // Marcar como completada aunque falle
    } finally {
      setLoadingFirma(false);
    }
  };

  // 🖼️ Función para obtener firma en base64 directamente desde el backend
  const obtenerFirmaBase64Directa = async (empresaId) => {
    try {
      console.log('🔄 Obteniendo firma en base64 directamente desde API:', empresaId);
      
      // Obtener token desde localStorage
      const token = localStorage.getItem('token') || 
                   localStorage.getItem('planillas_sanctum_token') || 
                   localStorage.getItem(ENV_CONFIG.SANCTUM_TOKEN_KEY);
      
      const response = await fetch(`${ENV_CONFIG.API_BASE_URL}/get-firma-base64/${empresaId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      
      if (result.success && result.firma_base64) {
        console.log('✅ Firma base64 obtenida directamente desde backend');
        return result.firma_base64;
      } else {
        console.log('ℹ️ No hay firma base64 disponible desde API');
        return null;
      }
    } catch (error) {
      console.error('❌ Error obteniendo firma base64 directamente:', error);
      return null;
    }
  };

  // 🖼️ Efecto para cargar firma / estilo boleta / logo cuando hay empresa
  useEffect(() => {
    if (!selectedCompany?.id) {
      setEstiloBoletaActiva('colorido');
      setLogoEmpresaBase64(null);
      return;
    }

      console.log('🖼️ Iniciando carga de firma empresa. Estado planilla:', planillaCerrada ? 'Cerrada' : 'Abierta');
      cargarFirmaEmpresa();

    const cargarEstiloYLogoBoleta = async () => {
      try {
        const cfg = await configuracionBoletaService.obtenerConfiguracion(selectedCompany.id);
        if (cfg?.success) {
          const estilo = String(cfg?.data?.estilo_boleta || '').toLowerCase();
          if (estilo === 'estandar' || estilo === 'azul_oro' || estilo === 'colorido') {
            setEstiloBoletaActiva(estilo);
          } else {
            setEstiloBoletaActiva(cfg?.data?.boleta_estandar ? 'estandar' : 'colorido');
          }
        } else {
          setEstiloBoletaActiva('colorido');
        }
      } catch (_) {
        setEstiloBoletaActiva('colorido');
      }
      try {
        const logo = await obtenerLogoEmpresaBase64(selectedCompany.id);
        setLogoEmpresaBase64(logo || null);
      } catch (_) {
        setLogoEmpresaBase64(null);
      }
    };

    cargarEstiloYLogoBoleta();

    const onBoletaCfg = () => {
      cargarEstiloYLogoBoleta();
    };
    window.addEventListener('configuracion-boleta-actualizada', onBoletaCfg);
    return () => window.removeEventListener('configuracion-boleta-actualizada', onBoletaCfg);
  }, [selectedCompany?.id]);

  useEffect(() => {
    const cargarFechasComputoRhConfig = async () => {
      if (!selectedCompany?.id) {
        setFechasComputoRhConfig([]);
        return;
      }
      try {
        const response = await fechasComputoRhService.obtenerFechas(selectedCompany.id);
        if (response.success) {
          setFechasComputoRhConfig(response.data || []);
        } else {
          setFechasComputoRhConfig([]);
        }
      } catch (error) {
        console.error('❌ Error al cargar configuración de cómputo RH:', error);
        setFechasComputoRhConfig([]);
      }
    };

    cargarFechasComputoRhConfig();
  }, [selectedCompany?.id]);

  // 🖼️ Efecto para rastrear cambios en el estado de la firma
  useEffect(() => {
    if (firmaEmpresa) {
      console.log('📸 Estado firma empresa actualizado - Disponible para PDFs:', firmaEmpresa);
    } else if (!loadingFirma) {
      console.log('🚫 Sin firma empresa registrada para esta empresa');
    }
  }, [firmaEmpresa, loadingFirma]);

  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    type: 'success',
    title: '',
    message: '',
    onConfirm: null
  });
  const [tareoModal, setTareoModal] = useState({
    isOpen: false,
    empleado: null
  });
  const [generandoPDF, setGenerandoPDF] = useState(false);
  const [generandoConceptosPDF, setGenerandoConceptosPDF] = useState(false);
  const [generandoExcel, setGenerandoExcel] = useState(false);
  const [generandoBoletas, setGenerandoBoletas] = useState(false);
  const [generandoBoletaIndividual, setGenerandoBoletaIndividual] = useState(false);
  const [calculandoPlanilla, setCalculandoPlanilla] = useState(false);
  const [generandoPLAME, setGenerandoPLAME] = useState(false);
  const [progresoCierre, setProgresoCierre] = useState(null);
  


  // 🔍 ESTADOS PARA FILTROS - MULTIFILTRO
  const [filtrosCargosSeleccionados, setFiltrosCargosSeleccionados] = useState([]);
  const [filtrosAreasSeleccionadas, setFiltrosAreasSeleccionadas] = useState([]);
  const [filtrosProyectosSeleccionados, setFiltrosProyectosSeleccionados] = useState([]);
  const [planillaAlternativaActiva, setPlanillaAlternativaActiva] = useState(false);
  const [filtroTipoBoleta, setFiltroTipoBoleta] = useState('todas'); // todas | plame | interna

  useEffect(() => {
    let cancelled = false;
    const cargarPlanillaAlternativa = async () => {
      if (!selectedCompany?.id) {
        setPlanillaAlternativaActiva(false);
        return;
      }
      try {
        const resp = await configuracionPlanillaAlternativaService.verificarEstado(selectedCompany.id);
        if (!cancelled) {
          setPlanillaAlternativaActiva(
            Boolean(resp?.success && (resp?.data?.planilla_alternativa_activa || resp?.data?.activo))
          );
        }
      } catch (e) {
        if (!cancelled) setPlanillaAlternativaActiva(false);
      }
    };
    cargarPlanillaAlternativa();
    return () => { cancelled = true; };
  }, [selectedCompany?.id]);


  // 💤 ESTADO PARA MODAL DE COMPENSACIONES
  const [compensacionesModalOpen, setCompensacionesModalOpen] = useState(false);

  // 🛡️ ESTADOS PARA SEGUROS DE PLANILLA (consideraciones previas)
  const [segurosPlanillaResumen, setSegurosPlanillaResumen] = useState([]);
  const [segurosPlanillaRegistros, setSegurosPlanillaRegistros] = useState([]);
  const [segurosModalOpen, setSegurosModalOpen] = useState(false);
  const [pagoJornalModalOpen, setPagoJornalModalOpen] = useState(false);
  const [gratiConsuModalOpen, setGratiConsuModalOpen] = useState(false);
  const [periodoCalculoConsuModalOpen, setPeriodoCalculoConsuModalOpen] = useState(false);
  /** Flags por empleado en consideraciones (planilla+empleado). Key = empleado_id string */
  const [consideracionesEmpleadoFlags, setConsideracionesEmpleadoFlags] = useState({});
  const [guardandoFlagOmitirDesc, setGuardandoFlagOmitirDesc] = useState(false);
  /** Overrides tipo_evento PLAME/interna por empleado|fecha */
  const [overridesTareoEvento, setOverridesTareoEvento] = useState({});
  const [eventosBoletaModalOpen, setEventosBoletaModalOpen] = useState(false);
  const [guardandoOverridesTareo, setGuardandoOverridesTareo] = useState(false);
  const [tramosBoletaInterna, setTramosBoletaInterna] = useState({});
  const [tramosInternaModalOpen, setTramosInternaModalOpen] = useState(false);
  const [guardandoTramosInterna, setGuardandoTramosInterna] = useState(false);
  const [tramosSueldoPlame, setTramosSueldoPlame] = useState({});
  const [tramosSueldoModalOpen, setTramosSueldoModalOpen] = useState(false);
  const [guardandoTramosSueldo, setGuardandoTramosSueldo] = useState(false);

  // 💰 ESTADOS PARA MODALES DE AJUSTES DE SUELDOS
  const [ajustesSueldosModalOpen, setAjustesSueldosModalOpen] = useState(false);
  const [conceptosEmpleadoModalOpen, setConceptosEmpleadoModalOpen] = useState(false);
  const [conceptosPlameModalOpen, setConceptosPlameModalOpen] = useState(false);
  const [tabPlameActiva, setTabPlameActiva] = useState('ingresos'); // 'ingresos', 'descuentos', 'aportes'
  const [empleadoSeleccionadoAjustes, setEmpleadoSeleccionadoAjustes] = useState(null);
  const [conceptosTemporales, setConceptosTemporales] = useState({});
  const [conceptosEliminados, setConceptosEliminados] = useState({});
  const [empleadosConceptosRestaurados, setEmpleadosConceptosRestaurados] = useState(new Set()); // IDs de empleados con conceptos restaurados
  const [busquedaConceptoPlame, setBusquedaConceptoPlame] = useState('');

  // 📊 ESTADOS PARA BARRA DE PROGRESO Y TRACKING DE APIS
  const [viaticosConfig, setViaticosConfig] = useState(null);
  const [cargandoProgreso, setCargandoProgreso] = useState({
    progreso: 0,
    // Firma (paralelo) + Planilla + 15 del lote completo (AFPs…Empleados + viáticos) = 17
    total: 17,
    apiActual: '',
    apisCompletadas: [],
    tiempoInicio: null
  });

  // 🔍 FUNCIÓN PARA OBTENER CARGOS ÚNICOS DE LOS EMPLEADOS
  const obtenerCargosUnicos = () => {
    const empleadosParaUsar = empleadosConBoletasCalculadas.length > 0 ? empleadosConBoletasCalculadas : empleadosActivosPlanilla;
    
    if (!empleadosParaUsar || empleadosParaUsar.length === 0) {
      return [];
    }

    const cargosUnicos = [...new Set(empleadosParaUsar.map(emp => emp.cargo).filter(Boolean))];
    return cargosUnicos.sort();
  };

  // 🔍 FUNCIÓN PARA OBTENER ÁREAS DE TRABAJO ÚNICAS DE LOS EMPLEADOS
  const obtenerAreasUnicos = () => {
    const empleadosParaUsar = empleadosConBoletasCalculadas.length > 0 ? empleadosConBoletasCalculadas : empleadosActivosPlanilla;
    
    if (!empleadosParaUsar || empleadosParaUsar.length === 0) {
      return [];
    }

    const areasUnicos = [...new Set(empleadosParaUsar.map(emp => emp.areas_de_trabajo || emp.datosEmpleado?.areas_de_trabajo).filter(Boolean))];
    return areasUnicos.sort();
  };

  // 🔍 FUNCIÓN PARA OBTENER PROYECTOS ÚNICOS DE LOS EMPLEADOS
  const obtenerProyectosUnicos = () => {
    const empleadosParaUsar = empleadosConBoletasCalculadas.length > 0 ? empleadosConBoletasCalculadas : empleadosActivosPlanilla;
    
    if (!empleadosParaUsar || empleadosParaUsar.length === 0) {
      return [];
    }

    const proyectosUnicos = [...new Set(empleadosParaUsar.map(emp => emp.proyecto || emp.datosEmpleado?.proyecto).filter(Boolean))];
    return proyectosUnicos.sort();
  };

  // Filtro por cómputo RH (ej. 15 al 15): solo empleados cuyo cómputo coincide con el período de la planilla
  const filtrarEmpleadosPorComputoRh = (empleados, { omitirSiPlanillaCerrada = false } = {}) => {
    if (!Array.isArray(empleados)) return [];
    if (planillaReal?.modalidad_planilla !== 'planilla_rh' || !planillaReal?.fecha_inicio || !planillaReal?.fecha_fin) {
      return empleados;
    }
    if (omitirSiPlanillaCerrada && planillaCerrada) {
      return empleados;
    }

    const fechaInicioPlanilla = formatDateToYYYYMMDD(planillaReal.fecha_inicio);
    const fechaFinPlanilla = formatDateToYYYYMMDD(planillaReal.fecha_fin);
    const esMesCerrado = (() => {
      if (!fechaInicioPlanilla || !fechaFinPlanilla) return false;
      const [yI, mI, dI] = fechaInicioPlanilla.split('-').map(Number);
      const [yF, mF, dF] = fechaFinPlanilla.split('-').map(Number);
      if (!yI || !mI || !dI || !yF || !mF || !dF) return false;
      if (yI !== yF || mI !== mF) return false;
      const ultimoDiaMes = new Date(yI, mI, 0).getDate();
      return dI === 1 && dF === ultimoDiaMes;
    })();

    const calcularRangoRhPorDia = (fechaInicio, diaComputo) => {
      const [y, m] = (fechaInicio || '').split('-').map(Number);
      if (!y || !m || !diaComputo) return null;

      const lastDayMesInicio = new Date(y, m, 0).getDate();
      const diaInicio = Math.min(diaComputo, lastDayMesInicio);
      const inicio = `${y}-${String(m).padStart(2, '0')}-${String(diaInicio).padStart(2, '0')}`;

      let yFin = y;
      let mFin = m + 1;
      if (mFin > 12) {
        mFin = 1;
        yFin += 1;
      }
      const lastDayMesFin = new Date(yFin, mFin, 0).getDate();
      const diaTope = Math.min(diaComputo, lastDayMesFin);
      const fechaTope = new Date(yFin, mFin - 1, diaTope);
      fechaTope.setDate(fechaTope.getDate() - 1);
      const fin = `${fechaTope.getFullYear()}-${String(fechaTope.getMonth() + 1).padStart(2, '0')}-${String(fechaTope.getDate()).padStart(2, '0')}`;

      return { inicio, fin };
    };

    return empleados.filter((empleado) => {
      const tipoContratacion = String(
        empleado.tipo_contratacion || empleado.datosEmpleado?.tipo_contratacion || ''
      ).toLowerCase();
      const esRh = tipoContratacion.includes('honorario') || tipoContratacion.includes('rh');
      if (!esRh) return false;

      const computoId = empleado.fecha_computo_rh_id || empleado.datosEmpleado?.fecha_computo_rh_id;
      if (!computoId) {
        return esMesCerrado;
      }

      const config = fechasComputoRhConfig.find((item) => Number(item.id) === Number(computoId));
      const dia = Number(config?.dia_inicio_computo);
      if (!dia) return false;

      const rangoEsperado = calcularRangoRhPorDia(fechaInicioPlanilla, dia);
      if (!rangoEsperado) return false;

      return rangoEsperado.inicio === fechaInicioPlanilla && rangoEsperado.fin === fechaFinPlanilla;
    });
  };

  // 🔍 FUNCIÓN PARA APLICAR MULTIFILTROS A LOS EMPLEADOS
  const aplicarFiltros = (empleados) => {
    // Verificar que empleados sea un array válido
    if (!Array.isArray(empleados)) {
      console.warn('⚠️ aplicarFiltros: empleados no es un array válido:', empleados);
      return [];
    }
    
    let empleadosFiltrados = empleados;

    // Filtro por cargos
    if (filtrosCargosSeleccionados && filtrosCargosSeleccionados.length > 0) {
      empleadosFiltrados = empleadosFiltrados.filter(empleado => filtrosCargosSeleccionados.includes(empleado.cargo));
    }

    // Filtro por áreas de trabajo
    if (filtrosAreasSeleccionadas && filtrosAreasSeleccionadas.length > 0) {
      empleadosFiltrados = empleadosFiltrados.filter(empleado => 
        filtrosAreasSeleccionadas.includes(empleado.areas_de_trabajo || empleado.datosEmpleado?.areas_de_trabajo)
      );
    }

    // Filtro por proyectos
    if (filtrosProyectosSeleccionados && filtrosProyectosSeleccionados.length > 0) {
      empleadosFiltrados = empleadosFiltrados.filter(empleado => 
        filtrosProyectosSeleccionados.includes(empleado.proyecto || empleado.datosEmpleado?.proyecto)
      );
    }

    empleadosFiltrados = filtrarEmpleadosPorComputoRh(empleadosFiltrados, { omitirSiPlanillaCerrada: true });

    return empleadosFiltrados;
  };

  // 🔍 FUNCIÓN PARA MANEJAR SELECCIÓN/DESELECCIÓN DE CARGOS
  const toggleCargo = (cargo) => {
    setFiltrosCargosSeleccionados(prev => {
      if (prev.includes(cargo)) {
        return prev.filter(c => c !== cargo);
      } else {
        return [...prev, cargo];
      }
    });
  };

  // 🔍 FUNCIÓN PARA SELECCIONAR/DESELECCIONAR TODOS LOS CARGOS
  const toggleTodosCargos = () => {
    const todosLosCargos = obtenerCargosUnicos();
    if (filtrosCargosSeleccionados.length === todosLosCargos.length) {
      setFiltrosCargosSeleccionados([]);
    } else {
      setFiltrosCargosSeleccionados(todosLosCargos);
    }
  };

  // 🔍 FUNCIÓN PARA MANEJAR SELECCIÓN/DESELECCIÓN DE ÁREAS DE TRABAJO
  const toggleArea = (area) => {
    setFiltrosAreasSeleccionadas(prev => {
      if (prev.includes(area)) {
        return prev.filter(a => a !== area);
      } else {
        return [...prev, area];
      }
    });
  };

  // 🔍 FUNCIÓN PARA SELECCIONAR/DESELECCIONAR TODAS LAS ÁREAS DE TRABAJO
  const toggleTodasAreas = () => {
    const todasLasAreas = obtenerAreasUnicos();
    if (filtrosAreasSeleccionadas.length === todasLasAreas.length) {
      setFiltrosAreasSeleccionadas([]);
    } else {
      setFiltrosAreasSeleccionadas(todasLasAreas);
    }
  };

  // 🔍 FUNCIÓN PARA MANEJAR SELECCIÓN/DESELECCIÓN DE PROYECTOS
  const toggleProyecto = (proyecto) => {
    setFiltrosProyectosSeleccionados(prev => {
      if (prev.includes(proyecto)) {
        return prev.filter(p => p !== proyecto);
      } else {
        return [...prev, proyecto];
      }
    });
  };

  // 🔍 FUNCIÓN PARA SELECCIONAR/DESELECCIONAR TODOS LOS PROYECTOS
  const toggleTodosProyectos = () => {
    const todosLosProyectos = obtenerProyectosUnicos();
    if (filtrosProyectosSeleccionados.length === todosLosProyectos.length) {
      setFiltrosProyectosSeleccionados([]);
    } else {
      setFiltrosProyectosSeleccionados(todosLosProyectos);
    }
  };

  // 🔍 COMPONENTE MULTIFILTRO DE CARGOS
  const MultiFiltroCargoComponent = ({ idSufijo = "" }) => {
    const cargosUnicos = obtenerCargosUnicos();
    const [mostrarDropdown, setMostrarDropdown] = useState(false);
    
    return (
      <div className="relative">
        <div className="flex items-center space-x-2">
          <label className="text-sm font-medium text-gray-700">
            Filtrar por cargo:
          </label>
          
          {/* Botón principal del dropdown */}
          <div className="relative">
            <button
              type="button"
              onClick={() => setMostrarDropdown(!mostrarDropdown)}
              className="flex items-center justify-between w-48 px-3 py-2 text-sm border border-gray-300 rounded-md bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
            >
              <span className="truncate">
                {filtrosCargosSeleccionados.length === 0 
                  ? "Todos los cargos"
                  : filtrosCargosSeleccionados.length === 1
                  ? filtrosCargosSeleccionados[0]
                  : `${filtrosCargosSeleccionados.length} cargos seleccionados`
                }
              </span>
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            {/* Dropdown con checkboxes */}
            {mostrarDropdown && (
              <div className="absolute z-20 w-64 mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
                <div className="p-2 border-b border-gray-200">
                  <button
                    type="button"
                    onClick={toggleTodosCargos}
                    className="w-full text-left px-2 py-1 text-sm text-teal-600 hover:bg-teal-50 rounded"
                  >
                    {filtrosCargosSeleccionados.length === cargosUnicos.length 
                      ? "Deseleccionar todos" 
                      : "Seleccionar todos"
                    }
                  </button>
                </div>
                
                <div className="max-h-48 overflow-y-auto">
                  {cargosUnicos.map(cargo => (
                    <label
                      key={cargo}
                      className="flex items-center px-3 py-2 hover:bg-gray-50 cursor-pointer"
                    >
                      <input
                        type="checkbox"
                        checked={filtrosCargosSeleccionados.includes(cargo)}
                        onChange={() => toggleCargo(cargo)}
                        className="w-4 h-4 text-teal-600 border-gray-300 rounded focus:ring-teal-500"
                      />
                      <span className="ml-2 text-sm text-gray-700">{cargo}</span>
                    </label>
                  ))}
                </div>
                
                {filtrosCargosSeleccionados.length > 0 && (
                  <div className="p-2 border-t border-gray-200 bg-gray-50">
                    <div className="text-xs text-gray-600">
                      {empleadosParaVista.length} empleado(s) mostrados
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          
          {/* Indicador de filtros activos */}
          {filtrosCargosSeleccionados.length > 0 && (
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-teal-100 text-teal-800">
              {filtrosCargosSeleccionados.length} filtro(s) activo(s)
            </span>
          )}
        </div>

        {/* Overlay para cerrar dropdown */}
        {mostrarDropdown && (
          <div
            className="fixed inset-0 z-10"
            onClick={() => setMostrarDropdown(false)}
          />
        )}
      </div>
    );
  };

  // 🔍 COMPONENTE MULTIFILTRO DE ÁREAS DE TRABAJO
  const MultiFiltroAreaComponent = ({ idSufijo = "" }) => {
    const areasUnicos = obtenerAreasUnicos();
    const [mostrarDropdown, setMostrarDropdown] = useState(false);
    
    return (
      <div className="relative">
        <div className="flex items-center space-x-2">
          <label className="text-sm font-medium text-gray-700">
            Filtrar por área:
          </label>
          
          {/* Botón principal del dropdown */}
          <div className="relative">
            <button
              type="button"
              onClick={() => setMostrarDropdown(!mostrarDropdown)}
              className="flex items-center justify-between w-48 px-3 py-2 text-sm border border-gray-300 rounded-md bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
            >
              <span className="truncate">
                {filtrosAreasSeleccionadas.length === 0 
                  ? "Todas las áreas"
                  : filtrosAreasSeleccionadas.length === 1
                  ? filtrosAreasSeleccionadas[0]
                  : `${filtrosAreasSeleccionadas.length} áreas seleccionadas`
                }
              </span>
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            {/* Dropdown con checkboxes */}
            {mostrarDropdown && (
              <div className="absolute z-20 w-64 mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
                <div className="p-2 border-b border-gray-200">
                  <button
                    type="button"
                    onClick={toggleTodasAreas}
                    className="w-full text-left px-2 py-1 text-sm text-teal-600 hover:bg-teal-50 rounded"
                  >
                    {filtrosAreasSeleccionadas.length === areasUnicos.length 
                      ? "Deseleccionar todas" 
                      : "Seleccionar todas"
                    }
                  </button>
                </div>
                
                <div className="max-h-48 overflow-y-auto">
                  {areasUnicos.map(area => (
                    <label
                      key={area}
                      className="flex items-center px-3 py-2 hover:bg-gray-50 cursor-pointer"
                    >
                      <input
                        type="checkbox"
                        checked={filtrosAreasSeleccionadas.includes(area)}
                        onChange={() => toggleArea(area)}
                        className="w-4 h-4 text-teal-600 border-gray-300 rounded focus:ring-teal-500"
                      />
                      <span className="ml-2 text-sm text-gray-700">{area}</span>
                    </label>
                  ))}
                </div>
                
                {filtrosAreasSeleccionadas.length > 0 && (
                  <div className="p-2 border-t border-gray-200 bg-gray-50">
                    <div className="text-xs text-gray-600">
                      {empleadosParaVista.length} empleado(s) mostrados
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          
          {/* Indicador de filtros activos */}
          {filtrosAreasSeleccionadas.length > 0 && (
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
              {filtrosAreasSeleccionadas.length} área(s) activa(s)
            </span>
          )}
        </div>

        {/* Overlay para cerrar dropdown */}
        {mostrarDropdown && (
          <div
            className="fixed inset-0 z-10"
            onClick={() => setMostrarDropdown(false)}
          />
        )}
      </div>
    );
  };

  // 🔍 COMPONENTE MULTIFILTRO DE PROYECTOS
  const MultiFiltroProyectoComponent = ({ idSufijo = "" }) => {
    const proyectosUnicos = obtenerProyectosUnicos();
    const [mostrarDropdown, setMostrarDropdown] = useState(false);
    
    return (
      <div className="relative">
        <div className="flex items-center space-x-2">
          <label className="text-sm font-medium text-gray-700">
            Filtrar por proyecto:
          </label>
          
          {/* Botón principal del dropdown */}
          <div className="relative">
            <button
              type="button"
              onClick={() => setMostrarDropdown(!mostrarDropdown)}
              className="flex items-center justify-between w-48 px-3 py-2 text-sm border border-gray-300 rounded-md bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
            >
              <span className="truncate">
                {filtrosProyectosSeleccionados.length === 0 
                  ? "Todos los proyectos"
                  : filtrosProyectosSeleccionados.length === 1
                  ? filtrosProyectosSeleccionados[0]
                  : `${filtrosProyectosSeleccionados.length} proyectos seleccionados`
                }
              </span>
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            {/* Dropdown con checkboxes */}
            {mostrarDropdown && (
              <div className="absolute z-20 w-64 mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
                <div className="p-2 border-b border-gray-200">
                  <button
                    type="button"
                    onClick={toggleTodosProyectos}
                    className="w-full text-left px-2 py-1 text-sm text-teal-600 hover:bg-teal-50 rounded"
                  >
                    {filtrosProyectosSeleccionados.length === proyectosUnicos.length 
                      ? "Deseleccionar todos" 
                      : "Seleccionar todos"
                    }
                  </button>
                </div>
                
                <div className="max-h-48 overflow-y-auto">
                  {proyectosUnicos.map(proyecto => (
                    <label
                      key={proyecto}
                      className="flex items-center px-3 py-2 hover:bg-gray-50 cursor-pointer"
                    >
                      <input
                        type="checkbox"
                        checked={filtrosProyectosSeleccionados.includes(proyecto)}
                        onChange={() => toggleProyecto(proyecto)}
                        className="w-4 h-4 text-teal-600 border-gray-300 rounded focus:ring-teal-500"
                      />
                      <span className="ml-2 text-sm text-gray-700">{proyecto}</span>
                    </label>
                  ))}
                </div>
                
                {filtrosProyectosSeleccionados.length > 0 && (
                  <div className="p-2 border-t border-gray-200 bg-gray-50">
                    <div className="text-xs text-gray-600">
                      {empleadosParaVista.length} empleado(s) mostrados
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          
          {/* Indicador de filtros activos */}
          {filtrosProyectosSeleccionados.length > 0 && (
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
              {filtrosProyectosSeleccionados.length} proyecto(s) activo(s)
            </span>
          )}
        </div>

        {/* Overlay para cerrar dropdown */}
        {mostrarDropdown && (
          <div
            className="fixed inset-0 z-10"
            onClick={() => setMostrarDropdown(false)}
          />
        )}
      </div>
    );
  };

  // �� FUNCIÓN PARA GENERAR EMPLEADOS REALES PARA LA VISTA
  const obtenerEmpleadosParaVista = () => {
    // 🔍 DEBUG: Verificar qué empleados están disponibles
    //console.log(`🔍 === OBTENER EMPLEADOS PARA VISTA ===`);
    //console.log(`🔒 Es planilla cerrada: ${planillaCerrada}`);
    //console.log(`📊 empleadosConBoletasCalculadas.length: ${empleadosConBoletasCalculadas.length}`);
    //console.log(`📊 empleadosActivosPlanilla.length: ${empleadosActivosPlanilla.length}`);
    
    // Verificar que tenemos datos válidos
    if (!Array.isArray(empleadosConBoletasCalculadas) || !Array.isArray(empleadosActivosPlanilla)) {
      console.warn('⚠️ obtenerEmpleadosParaVista: Arrays de empleados no válidos');
      return [];
    }
    
    if (empleadosConBoletasCalculadas.length > 0) {
      //console.log(`📋 Primer empleado calculado:`, empleadosConBoletasCalculadas[0]?.nombre || empleadosConBoletasCalculadas[0]?.nombre_completo);
      //console.log(`📱 Teléfono primer calculado:`, empleadosConBoletasCalculadas[0]?.telefono);
      //console.log(`📧 Email primer calculado:`, empleadosConBoletasCalculadas[0]?.email);
      //console.log(`🏠 Dirección primer calculado:`, empleadosConBoletasCalculadas[0]?.direccion);
      //console.log(`🔧 Estructura primer calculado:`, empleadosConBoletasCalculadas[0]);
    }
    
    if (empleadosActivosPlanilla.length > 0) {
      //console.log(`📋 Primer empleado activo:`, empleadosActivosPlanilla[0]?.nombre || empleadosActivosPlanilla[0]?.nombre_completo);
      //console.log(`📱 Teléfono primer activo:`, empleadosActivosPlanilla[0]?.telefono);
      //console.log(`📧 Email primer activo:`, empleadosActivosPlanilla[0]?.email);
      //console.log(`🏠 Dirección primer activo:`, empleadosActivosPlanilla[0]?.direccion);
    }
    
    // ✅ PRIORIZAR EMPLEADOS CON BOLETAS CALCULADAS SI ESTÁN DISPONIBLES
    // En planilla abierta, los snapshots de pre-cierre no deben reducir la lista a 1 solo trabajador.
    const idEmpPlanillaVista = (emp) => {
      const n = Number(emp?.id ?? emp?.empleado_id);
      return Number.isFinite(n) && n > 0 ? n : null;
    };

    const fusionarPreCierresEnLista = (base, idsFoto, snaps) => {
      const fotografiados = (snaps || []).filter((e) => {
        const id = idEmpPlanillaVista(e);
        return id != null && idsFoto.has(id);
      });
      const restantes = (base || []).filter((e) => {
        const id = idEmpPlanillaVista(e);
        return id == null || !idsFoto.has(id);
      });
      return [...fotografiados, ...restantes];
    };

    const empleadosParaUsar = (() => {
      if (planillaCerrada || planillaReal?.estado === 'cerrada') {
        return empleadosConBoletasCalculadas.length > 0
          ? empleadosConBoletasCalculadas
          : empleadosActivosPlanilla;
      }

      const idsFoto = empleadosFotografiadosIds;
      const snaps =
        snapshotsPreCierre?.length > 0
          ? snapshotsPreCierre
          : empleadosConBoletasCalculadas.filter((e) => {
              const id = idEmpPlanillaVista(e);
              return id != null && idsFoto.has(id);
            });

      const mezclarSiHayPreCierres = (base) => {
        if (idsFoto.size > 0 && snaps.length > 0) {
          return fusionarPreCierresEnLista(base, idsFoto, snaps);
        }
        return base;
      };

      if (empleadosConBoletasCalculadas.length > 0) {
        const soloSnapshotsEnCalculadas =
          empleadosActivosPlanilla.length > 0 &&
          empleadosConBoletasCalculadas.length < empleadosActivosPlanilla.length &&
          empleadosConBoletasCalculadas.every((e) => {
            const id = idEmpPlanillaVista(e);
            return id != null && idsFoto.has(id);
          });

        const base = soloSnapshotsEnCalculadas
          ? empleadosActivosPlanilla
          : empleadosConBoletasCalculadas;
        return mezclarSiHayPreCierres(base);
      }

      return mezclarSiHayPreCierres(empleadosActivosPlanilla);
    })();
    const tipoEmpleados = empleadosConBoletasCalculadas.length > 0 ? 'calculados' : 'originales';
    
    // Si no tenemos empleados, retornar array vacío
    if (!Array.isArray(empleadosParaUsar) || empleadosParaUsar.length === 0) {
      console.warn('⚠️ No hay empleados válidos para mostrar en la vista:', empleadosParaUsar);
      return [];
    }

    //console.log(`🔄 Transformando empleados ${tipoEmpleados} para la vista...`);
    //console.log(`📊 Empleados a transformar: ${empleadosParaUsar.length}`);
    
            // 🔍 APLICAR FILTROS ANTES DE TRANSFORMAR
        const empleadosFiltrados = aplicarFiltros(empleadosParaUsar).filter((empleado) => {
          if (planillaCerrada || planillaReal?.estado === 'cerrada') return true;
          const idEmp = Number(empleado?.id ?? empleado?.empleado_id);
          if (Number.isFinite(idEmp) && empleadosFotografiadosIds.has(idEmp)) {
            return true;
          }
          if (!planillaReal?.fecha_inicio || !planillaReal?.fecha_fin) return true;
          return empleadoVigenteEnRangoPlanilla(
            empleado,
            planillaReal.fecha_inicio,
            planillaReal.fecha_fin
          );
        });
        
        // Verificar que el filtrado fue exitoso
        if (!Array.isArray(empleadosFiltrados)) {
          console.error('❌ Error en aplicarFiltros, resultado no es array:', empleadosFiltrados);
          return [];
        }
    //console.log(`🔍 Empleados después del filtro: ${empleadosFiltrados.length} (filtros cargo: ${filtrosCargosSeleccionados.length > 0 ? filtrosCargosSeleccionados.join(', ') : 'ninguno'}, áreas: ${filtrosAreasSeleccionadas.length > 0 ? filtrosAreasSeleccionadas.join(', ') : 'ninguno'}, proyectos: ${filtrosProyectosSeleccionados.length > 0 ? filtrosProyectosSeleccionados.join(', ') : 'ninguno'})`);

    // Obtener el array unificado más reciente de mostrarDatosSeleccionados
    // pero aquí solo transformamos lo que ya tenemos en los estados
    const empleadosTransformados = empleadosFiltrados.map((empleadoActivo, index) => {
      const esPlanillaCerradaVista = planillaCerrada || planillaReal?.estado === 'cerrada';
      const idEmpVista = empleadoActivo.id != null ? Number(empleadoActivo.id) : null;
      const tareosGuardadosEmpleado = (() => {
        const seen = new Set();
        const out = [];
        const listas = [empleadoActivo.tareosEmpleadoInterna, empleadoActivo.tareosEmpleado];
        listas.forEach((lista) => {
          (Array.isArray(lista) ? lista : []).forEach((t) => {
            if (!t?.fecha) return;
            const key = `${String(t.fecha).split('T')[0]}_${t.tipo_evento || ''}_${t.hora_entrada || ''}`;
            if (seen.has(key)) return;
            seen.add(key);
            out.push(t);
          });
        });
        return out;
      })();
      const empleadoLaboral = construirEmpleadoParaHistorialLaboral(empleadoActivo);
      const empleadoInterno = construirEmpleadoParaHistorialInterno(empleadoActivo);
      const tareosApiEmpleado = tareosPeriodo.filter(
        (t) => idEmpVista != null && Number(t.empleado_id) === idEmpVista
      );
      const tareosFuenteModal = esPlanillaCerradaVista && tareosGuardadosEmpleado.length > 0
        ? tareosGuardadosEmpleado
        : tareosApiEmpleado;
      const tareosModalEmpleado = tareosFuenteModal.filter((tareo) => (
        tareoEnPeriodoLaboralEfectivo(
          tareo.fecha,
          empleadoLaboral,
          planillaReal?.fecha_inicio,
          planillaReal?.fecha_fin
        )
        || tareoEnPeriodoLaboralEfectivo(
          tareo.fecha,
          empleadoInterno,
          planillaReal?.fecha_inicio,
          planillaReal?.fecha_fin
        )
      ));
      const usaTareosInternos = vistaBoletaUsaCanalInterno(
        empleadoActivo,
        filtroTipoBoleta,
        planillaReal?.fecha_inicio,
        planillaReal?.fecha_fin
      );
      const tareosCalculoPlame = tareosModalEmpleado.filter((tareo) => filtrarTareoSegunPlanilla(
        tareo,
        empleadoActivo,
        planillaReal?.fecha_inicio,
        planillaReal?.fecha_fin,
        'plame'
      ));
      const tareosCalculoInterna = tareosModalEmpleado.filter((tareo) => filtrarTareoSegunPlanilla(
        tareo,
        empleadoActivo,
        planillaReal?.fecha_inicio,
        planillaReal?.fecha_fin,
        'interno'
      ));
      const tareosCalculoEmpleado = usaTareosInternos ? tareosCalculoInterna : tareosCalculoPlame;

      // Simular la estructura del array unificado para cada empleado
      const empleadoParaVista = {
        tipo: 'empleado_activo_con_apis',
        empleado_nombre: empleadoActivo.nombre_completo,
        empleado_posicion_activos: index + 1,
                  datosEmpleado: empleadoActivo,
          conceptosUsuario: {
            ...(empleadoActivo.conceptos_separados || {
            ingresos: Array.isArray(empleadoActivo.conceptos) ? empleadoActivo.conceptos.filter(c => c.tipo_concepto === 'ingreso') : [],
            descuentos: Array.isArray(empleadoActivo.conceptos) ? empleadoActivo.conceptos.filter(c => c.tipo_concepto === 'descuento') : [],
            aportes: Array.isArray(empleadoActivo.conceptos) ? empleadoActivo.conceptos.filter(c => c.tipo_concepto === 'aporte') : []
            }),
            ingresosInternos: (() => {
              const src = empleadoActivo.conceptos_separados_internos?.ingresos
                || (Array.isArray(empleadoActivo.conceptos_internos)
                  ? empleadoActivo.conceptos_internos.filter(c => c.tipo_concepto === 'ingreso')
                  : []);
              return (src || []).map((c) => {
                const codigo = String(
                  c.codigoPlame
                  || c.codigo_plame
                  || c.codigo
                  || c.plame_configuracion?.codigo_plame
                  || c.plameConfiguracion?.codigo_plame
                  || ''
                );
                return {
                  ...c,
                  codigo,
                  codigo_plame: codigo,
                  codigoPlame: codigo,
                  monto: Number(c.monto ?? c.valor ?? c.monto_interna) || 0,
                };
              });
            })(),
            descuentosInternos: (() => {
              const src = empleadoActivo.conceptos_separados_internos?.descuentos
                || (Array.isArray(empleadoActivo.conceptos_internos)
                  ? empleadoActivo.conceptos_internos.filter(c => c.tipo_concepto === 'descuento')
                  : []);
              return (src || []).map((c) => {
                const codigo = String(
                  c.codigoPlame
                  || c.codigo_plame
                  || c.codigo
                  || c.plame_configuracion?.codigo_plame
                  || c.plameConfiguracion?.codigo_plame
                  || ''
                );
                return {
                  ...c,
                  codigo,
                  codigo_plame: codigo,
                  codigoPlame: codigo,
                  monto: Number(c.monto ?? c.valor ?? c.monto_interna) || 0,
                };
              });
            })(),
            aportesInternos: (() => {
              const src = empleadoActivo.conceptos_separados_internos?.aportes
                || (Array.isArray(empleadoActivo.conceptos_internos)
                  ? empleadoActivo.conceptos_internos.filter(c => c.tipo_concepto === 'aporte')
                  : []);
              return (src || []).map((c) => {
                const codigo = String(
                  c.codigoPlame
                  || c.codigo_plame
                  || c.codigo
                  || c.plame_configuracion?.codigo_plame
                  || c.plameConfiguracion?.codigo_plame
                  || ''
                );
                return {
                  ...c,
                  codigo,
                  codigo_plame: codigo,
                  codigoPlame: codigo,
                  monto: Number(c.monto ?? c.valor ?? c.monto_interna) || 0,
                };
              });
            })(),
          },
          conceptos: empleadoActivo.conceptos_separados || {
            ingresos: Array.isArray(empleadoActivo.conceptos) ? empleadoActivo.conceptos.filter(c => c.tipo_concepto === 'ingreso') : [],
            descuentos: Array.isArray(empleadoActivo.conceptos) ? empleadoActivo.conceptos.filter(c => c.tipo_concepto === 'descuento') : [],
            aportes: Array.isArray(empleadoActivo.conceptos) ? empleadoActivo.conceptos.filter(c => c.tipo_concepto === 'aporte') : []
          },
          conceptos_separados_internos: empleadoActivo.conceptos_separados_internos || null,
                datosSalariales: (() => {
          // ✅ LÓGICA AUTOMÁTICA DE AFP: Si tiene AFP definida, asumir que es AFP
          const afpEncontrada = afps.find(a => a.id === empleadoActivo.afp_id);
          const tieneAfp = empleadoActivo.afp?.nombre || empleadoActivo.afp_nombre || empleadoActivo.afp_id || afpEncontrada;
          const sistemaCalculado = tieneAfp ? 'AFP' : (empleadoActivo.sistema_pensionario || empleadoActivo.tipo_aporte || 'ONP');
          //console.log('Empleado Activo:', empleadoActivo);
          return {
          sueldoBasico: empleadoActivo.sueldo_basico || 0,
          sueldoInterno: empleadoActivo.sueldo_interno || 0,
          tipoPlanilla: empleadoActivo.tipo_planilla || null,
          montoViaticoStandard: empleadoActivo.monto_viatico_standard
            ?? empleadoActivo.montoViaticoStandard
            ?? 0,
          regimenLaboral: regimenesLaborales.find(r => Number(r.id) === Number(empleadoActivo.regimen_laboral_id))?.codigo
            || empleadoActivo.regimen_laboral?.codigo
            || empleadoActivo.datosSalariales?.regimenLaboral
            || empleadoActivo.regimenLaboral
            || null,
            sistemaPensionario: sistemaCalculado, // ✅ Calculado automáticamente basado en AFP
            afp: tieneAfp ? (afpEncontrada?.nombre || empleadoActivo.afp?.nombre || null) : null,
            cuspp: tieneAfp ? (empleadoActivo.cuspp || empleadoActivo.codigo_cuspp || null) : null,
            tipoAfp: tieneAfp ? (empleadoActivo.tipo_afp || empleadoActivo.afp?.tipo_afp || afpEncontrada?.tipo || empleadoActivo.comision_tipo || afpEncontrada?.comision_tipo || null) : null,
            fechaAfiliacionAfp: tieneAfp ? (empleadoActivo.fecha_afiliacion_afp || null) : null
          };
        })(),
        resumenTareos: (() => {
          const cfgHoras = empleadoActivo.configuracion_tareo || configuracionTareo;
          return {
            total_tareos: tareosCalculoEmpleado.length,
            dias_trabajados: tareosCalculoEmpleado.filter(t => t.tipo_evento === 'asistio').length,
            // Horas para planilla (puede ser 8 fijas si modo_horas_simple = fijas_8)
            horas_totales: tareosCalculoEmpleado.reduce(
              (sum, t) => sum + horasTrabajadasEfectivas(t, cfgHoras),
              0
            ),
            // Horas reales de tareos (siempre las del registro)
            horas_totales_reales: tareosCalculoEmpleado.reduce(
              (sum, t) => sum + (parseFloat(t.horas_trabajadas) || 0),
              0
            ),
            proyectos: [...new Set(tareosCalculoEmpleado.map(t => t.proyecto?.nombre).filter(Boolean))]
          };
        })(),
        tareosEmpleado: tareosModalEmpleado,
        tareosEmpleadoFiltrados: tareosCalculoEmpleado,
        tareosEmpleadoInterna: tareosCalculoInterna,
        _usarTareosInternos: usaTareosInternos,
        // Mismas claves de configuración que en el array unificado (cálculo / depuración)
        datosAPIs: {
          conceptosAfectosTareos: conceptosAfectos,
          conceptosNoAfectanVacaciones: conceptosNoAfectanVacaciones,
          conceptosAfectanLicenciaGoceHaber: conceptosAfectanLicenciaGoceHaber,
          feriadosPagoDoble: feriadosPagoDobleConfig,
          configuracionDescansoLaborado: configuracionDescansoLaboradoConfig,
          configuracionTasaNocturna: configuracionTasaNocturnaConfig,
        },
        liquidaciones_planilla: empleadoActivo.liquidaciones_planilla || [],
        gratificaciones_planilla: empleadoActivo.gratificaciones_planilla || [],
      };

      return transformarEmpleadoParaVista(empleadoParaVista);
    }).filter(emp => emp !== null);

    //console.log(`✅ Empleados transformados para vista: ${empleadosTransformados.length}`);
    return empleadosTransformados;
  };

  // Vista web: mostrar ingresos por horas extra en todas las modalidades (igual que modal Tareos y Excel/PDF).
  const esConceptoIngresoHorasExtrasVista = (concepto) => {
    const raw = `${concepto?.descripcion || concepto?.nombre || ''}`;
    const d = raw.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    if (!d.trim()) return false;
    if (d.includes('sobretiempo')) return true;
    if (d.includes('horas extra') || d.includes('hora extra')) return true;
    if (/\b(he\s*25|he\s*35|he25|he35)\b/.test(d)) return true;
    return false;
  };

  // 📊 FUNCIÓN PARA OBTENER CONCEPTOS ÚNICOS DE TODOS LOS EMPLEADOS
  const obtenerConceptosUnicos = (empleados, opciones = {}) => {
    const ocultarHEVista = opciones.ocultarConceptosHorasExtrasVista === true;
    const conceptosUnicos = {
      ingresos: [],
      descuentos: [],
      aportes: []
    };

    //console.log('🔍 OBTENIENDO CONCEPTOS ÚNICOS DE:', empleados.length, 'empleados');
    
    empleados.forEach((empleado, index) => {
      //console.log(`🔍 Procesando empleado ${index + 1}: ${empleado.nombre}`);
      //console.log('🔍 Estructura conceptos empleado:', empleado.conceptos);
      
      // ✅ USAR LA ESTRUCTURA CORRECTA DE DATOS TRANSFORMADOS
      const conceptosEmpleado = empleado.conceptos || {};
      
      // Procesar ingresos
      const ingresosArray = Array.isArray(conceptosEmpleado.ingresos) ? 
        conceptosEmpleado.ingresos : [];
        
      console.log(`📈 Ingresos encontrados para ${empleado.nombre}:`, ingresosArray.length, ingresosArray);
        
      ingresosArray.forEach(concepto => {
        if (esConceptoSoloDeclaracion(concepto)) return;
        if (ocultarHEVista && esConceptoIngresoHorasExtrasVista(concepto)) return;
        const codigoConcepto = concepto.codigo || concepto.codigoPlame;
        const descripcionConcepto = concepto.descripcion;
        
        console.log(`  💰 Analizando ingreso: ${descripcionConcepto} (${codigoConcepto}) - S/ ${concepto.monto}`);
        
        // ✅ USAR DESCRIPCIÓN COMO CLAVE PRINCIPAL PARA ELIMINAR DUPLICADOS
        const existeIngreso = conceptosUnicos.ingresos.find(c => 
          c.descripcion?.trim().toLowerCase() === descripcionConcepto?.trim().toLowerCase()
        );
        
        if (!existeIngreso && descripcionConcepto) {
          conceptosUnicos.ingresos.push({
            codigo: codigoConcepto,
            descripcion: descripcionConcepto
            // ✅ NO GUARDAR MONTO - cada empleado tiene su propio monto
          });
          console.log(`    ✅ Nuevo concepto único agregado: ${descripcionConcepto} (${codigoConcepto})`);
        } else if (existeIngreso) {
          console.log(`    ⚠️ Concepto duplicado (ya existe): ${descripcionConcepto}`);
        } else {
          console.log(`    ❌ Concepto sin descripción válida, omitido`);
        }
      });

      // Procesar descuentos
      const descuentosArray = Array.isArray(conceptosEmpleado.descuentos) ? 
        conceptosEmpleado.descuentos : [];
        
      //console.log(`📉 Descuentos encontrados para ${empleado.nombre}:`, descuentosArray.length, descuentosArray);
        
      descuentosArray.forEach(concepto => {
        const codigoConcepto = concepto.codigo || concepto.codigoPlame;
        const descripcionConcepto = concepto.descripcion;
        
        //console.log(`  💸 Analizando descuento: ${descripcionConcepto} (${codigoConcepto}) - S/ ${concepto.monto}`);
        
        // ✅ USAR DESCRIPCIÓN COMO CLAVE PRINCIPAL PARA ELIMINAR DUPLICADOS
        const existeDescuento = conceptosUnicos.descuentos.find(c => 
          c.descripcion?.trim().toLowerCase() === descripcionConcepto?.trim().toLowerCase()
        );
        
        if (!existeDescuento && descripcionConcepto) {
          conceptosUnicos.descuentos.push({
            codigo: codigoConcepto,
            descripcion: descripcionConcepto
            // ✅ NO GUARDAR MONTO - cada empleado tiene su propio monto
          });
          //console.log(`    ✅ Nuevo concepto único agregado: ${descripcionConcepto} (${codigoConcepto})`);
        } else if (existeDescuento) {
          //console.log(`    ⚠️ Concepto duplicado (ya existe): ${descripcionConcepto}`);
        } else {
          //console.log(`    ❌ Concepto sin descripción válida, omitido`);
        }
      });

      // Procesar aportes
      const aportesArray = Array.isArray(conceptosEmpleado.aportes) ? 
        conceptosEmpleado.aportes : [];
        
      console.log(`📊 Aportes encontrados para ${empleado.nombre}:`, aportesArray.length, aportesArray);
        
      aportesArray.forEach(concepto => {
        const codigoConcepto = concepto.codigo || concepto.codigoPlame;
        const descripcionConcepto = concepto.descripcion;
        
        console.log(`  🏛️ Analizando aporte: ${descripcionConcepto} (${codigoConcepto}) - S/ ${concepto.monto}`);
        
        // ✅ USAR DESCRIPCIÓN COMO CLAVE PRINCIPAL PARA ELIMINAR DUPLICADOS
        const existeAporte = conceptosUnicos.aportes.find(c => 
          c.descripcion?.trim().toLowerCase() === descripcionConcepto?.trim().toLowerCase()
        );
        
        if (!existeAporte && descripcionConcepto) {
          conceptosUnicos.aportes.push({
            codigo: codigoConcepto,
            descripcion: descripcionConcepto
            // ✅ NO GUARDAR MONTO - cada empleado tiene su propio monto
          });
          console.log(`    ✅ Nuevo concepto único agregado: ${descripcionConcepto} (${codigoConcepto})`);
        } else if (existeAporte) {
          console.log(`    ⚠️ Concepto duplicado (ya existe): ${descripcionConcepto}`);
        } else {
          console.log(`    ❌ Concepto sin descripción válida, omitido`);
        }
      });
    });

    // Orden fijo para egresos: estos 4 conceptos primero, luego el resto
    const ordenEgresosPrioritarios = [
      'SISTEMA NACIONAL DE PENSIONES - D.L 19990',
      'SISTEMA PRIVADO DE PENSIONES - COMISIÓN PORCENTUAL',
      'SISTEMA PRIVADO DE PENSIONES - PRIMA DE SEGURO',
      'SISTEMA PRIVADO DE PENSIONES - APORTACIÓN OBLIGATORIA'
    ];
    conceptosUnicos.descuentos.sort((a, b) => {
      const descA = (a.descripcion || '').trim().toUpperCase();
      const descB = (b.descripcion || '').trim().toUpperCase();
      const idxA = ordenEgresosPrioritarios.findIndex(t => descA.includes(t) || t.includes(descA));
      const idxB = ordenEgresosPrioritarios.findIndex(t => descB.includes(t) || t.includes(descB));
      if (idxA >= 0 && idxB >= 0) return idxA - idxB;
      if (idxA >= 0) return -1;
      if (idxB >= 0) return 1;
      return (a.descripcion || '').localeCompare(b.descripcion || '');
    });

    console.log('🎯 CONCEPTOS ÚNICOS DETECTADOS:');
    console.log('  📈 Ingresos:', conceptosUnicos.ingresos.map(c => `${c.descripcion} (${c.codigo})`));
    console.log('  📉 Descuentos:', conceptosUnicos.descuentos.map(c => `${c.descripcion} (${c.codigo})`));
    console.log('  📊 Aportes:', conceptosUnicos.aportes.map(c => `${c.descripcion} (${c.codigo})`));
    
    console.log('📊 TOTALES DE CONCEPTOS ÚNICOS:');
    console.log(`  📈 Total Ingresos únicos: ${conceptosUnicos.ingresos.length}`);
    console.log(`  📉 Total Descuentos únicos: ${conceptosUnicos.descuentos.length}`);
    console.log(`  📊 Total Aportes únicos: ${conceptosUnicos.aportes.length}`);
    
    return conceptosUnicos;
  };

  /** Conceptos solo-declaración (viáticos / grati) para columnas aparte en consolidado. */
  const obtenerConceptosUnicosDeclaracion = (empleados) => {
    const unicos = [];
    (empleados || []).forEach((empleado) => {
      const ingresos = empleado?.conceptos?.ingresos || [];
      ingresos.forEach((concepto) => {
        if (!esConceptoSoloDeclaracion(concepto)) return;
        if ((parseFloat(concepto.monto) || 0) <= 0) return;
        const descripcionConcepto = concepto.descripcion || concepto.concepto;
        if (!descripcionConcepto) return;
        const existe = unicos.find(
          (c) =>
            c.descripcion?.trim().toLowerCase() === descripcionConcepto.trim().toLowerCase()
        );
        if (!existe) {
          unicos.push({
            codigo: concepto.codigo || concepto.codigoPlame || '',
            descripcion: descripcionConcepto,
            esViatico: esConceptoDeclaracionViatico(concepto),
            esMovilidad: esConceptoDeclaracionMovilidadJatsa(concepto),
          });
        }
      });
    });
    return unicos;
  };

  const estiloConceptoDeclaracion = (concepto = {}) => {
    if (esConceptoLiquidacionPlanilla(concepto)) {
      return {
        icono: '📋',
        texto: 'text-violet-700',
        monto: 'text-violet-800',
        fondo: 'bg-violet-50/80',
        header: 'text-violet-800 bg-violet-50/80',
        total: 'text-violet-900 bg-violet-100',
      };
    }
    if (esDescuentoLiquidacionPlanilla(concepto)) {
      return {
        icono: '📋',
        texto: 'text-violet-700',
        monto: 'text-violet-800',
        fondo: 'bg-violet-50/80',
        header: 'text-violet-800 bg-violet-50/80',
        total: 'text-violet-900 bg-violet-100',
      };
    }
    if (concepto.esMovilidad || esConceptoDeclaracionMovilidadJatsa(concepto)) {
      return {
        icono: '🚗',
        texto: 'text-blue-700',
        monto: 'text-blue-800',
        fondo: 'bg-blue-50/80',
        header: 'text-blue-800 bg-blue-50/80',
        total: 'text-blue-900 bg-blue-100',
      };
    }
    if (concepto.esViatico || esConceptoDeclaracionViatico(concepto)) {
      return {
        icono: '🚕',
        texto: 'text-sky-700',
        monto: 'text-sky-800',
        fondo: 'bg-sky-50/80',
        header: 'text-sky-800 bg-sky-50/80',
        total: 'text-sky-900 bg-sky-100',
      };
    }
    return {
      icono: '🎁',
      texto: 'text-amber-700',
      monto: 'text-amber-800',
      fondo: 'bg-amber-50/80',
      header: 'text-amber-800 bg-amber-50/80',
      total: 'text-amber-900 bg-amber-100',
    };
  };

  const ingresosDeclaracionDeEmpleado = (empleadoId, boleta = 'plame') => {
    const full = empleadosParaVista.find(
      (e) => String(e.id ?? e.empleado_id) === String(empleadoId)
    );
    if (!full) return [];
    const ingresos =
      boleta === 'interna'
        ? full.conceptosInternos?.ingresos || []
        : full.conceptos?.ingresos || [];
    return (ingresos || []).filter(
      (c) => esConceptoSoloDeclaracion(c) && (parseFloat(c.monto) || 0) > 0
    );
  };

  // 🗂️ FUNCIÓN PARA TRANSFORMAR DATOS REALES AL FORMATO DE LA VISTA

  const mapearConceptosDesdeBoleta = (boleta, origen = 'calculado') => {
    const data = boleta?.data || {};
    const mapItem = (item, tipo) => ({
      id: item.id_concepto?.id,
      codigo_plame: item.id_concepto?.codigo_plame || item.id_concepto?.codigo,
      codigo: item.id_concepto?.codigo || item.id_concepto?.codigo_plame,
      nombre: item.id_concepto?.descripcion || item.id_concepto?.nombre,
      descripcion: item.id_concepto?.descripcion || item.id_concepto?.nombre,
      tipo_concepto: tipo,
      monto: parseFloat(item.valor) || 0,
      origen,
      base_calculo: parseFloat(item.base_calculo ?? item.base ?? item.base_imponible) || 0,
      codigoPlame: item.id_concepto?.codigo_plame || item.id_concepto?.codigo || item.codigoPlame || '',
      excluirBoletaOrdinaria: Boolean(item.excluir_boleta_ordinaria || item.excluirBoletaOrdinaria),
      origenCalculo: item.origen_calculo || item.origenCalculo || null,
      origen_calculo: item.origen_calculo || item.origenCalculo || null,
      exportable_plame: item.exportable_plame,
      absorberEn0121: Boolean(item.absorberEn0121),
      fusionarEn0705: Boolean(item.fusionarEn0705),
      excluirRem: Boolean(item.excluirRem || item.exportable_plame === false),
    });
    return {
      ingresos: (data.dataIngresos || []).map((i) => mapItem(i, 'ingreso')),
      descuentos: (data.dataDescuentos || []).map((i) => mapItem(i, 'descuento')),
      aportes: (data.dataAportes || []).map((i) => mapItem(i, 'aporte')),
    };
  };

  const totalesDesdeConceptosSeparados = (sep) => {
    const totalIngresos = (sep?.ingresos || []).reduce((s, c) => s + (parseFloat(c.monto) || 0), 0);
    const totalDescuentos = (sep?.descuentos || []).reduce((s, c) => s + (parseFloat(c.monto) || 0), 0);
    const totalAportes = (sep?.aportes || []).reduce((s, c) => s + (parseFloat(c.monto) || 0), 0);
    return {
      totalIngresos,
      totalDescuentos,
      totalAportes,
      netoAPagar: totalIngresos - totalDescuentos,
    };
  };

  const transformarEmpleadoParaVista = (empleadoDelArray) => {
    if (!empleadoDelArray || empleadoDelArray.tipo !== 'empleado_activo_con_apis') {
      return null;
    }

    //console.log('Data a Procesar en la vista:')
    //console.log(empleadoDelArray);

    // Extraer datos del empleado del array unificado con validaciones
    const emp = empleadoDelArray.datosEmpleado || {};
    const conceptos = empleadoDelArray.conceptosUsuario || {};
    const salarios = empleadoDelArray.datosSalariales || {};
    const tareos = empleadoDelArray.resumenTareos || {};
    const usaTareosInternos = empleadoDelArray._usarTareosInternos
      || vistaBoletaUsaCanalInterno(
        emp,
        filtroTipoBoleta,
        planillaReal?.fecha_inicio,
        planillaReal?.fecha_fin
      );
    const tareosDet = usaTareosInternos
      ? (empleadoDelArray.tareosEmpleadoInterna?.length
        ? empleadoDelArray.tareosEmpleadoInterna
        : (empleadoDelArray.tareosEmpleado || []))
      : (empleadoDelArray.tareosEmpleado || []);

    // Calcular tareos detallados (simulados basados en los datos reales)
    const diasProgramados = planillaReal ? 
      Math.ceil((new Date(planillaReal.fecha_fin) - new Date(planillaReal.fecha_inicio)) / (1000 * 60 * 60 * 24)) + 1 : 30;
    
    // Validar y asegurar que los conceptos sean arrays
    let ingresosArray = Array.isArray(conceptos.ingresos) ? conceptos.ingresos : [];
    let descuentosArray = Array.isArray(conceptos.descuentos) ? conceptos.descuentos : [];
    let aportesArray = Array.isArray(conceptos.aportes) ? conceptos.aportes : [];
    const esBoletaConstruccion = planillaReal?.modalidad_planilla === 'planilla_construccion'
      || esRegimenConstruccionCivil(emp, regimenesLaborales || [])
      || esRegimenConstruccionCivil({ datosSalariales: salarios, datosEmpleado: emp }, regimenesLaborales || []);
    if (esBoletaConstruccion) {
      const completados = completarCatalogoBoletaConstruccion(
        { ingresos: ingresosArray, descuentos: descuentosArray, aportes: aportesArray },
        {
          sinTareos: !(Number(tareos?.total_tareos) > 0 || tareosDet.length > 0),
          sistemaPensionario: salarios.sistemaPensionario || emp.sistema_pensionario || 'ONP',
          conceptosPlame: configuracionesPlame || empleadoDelArray.datosAPIs?.conceptosPlame || [],
          plameConsu: construccionCivilDatos?.plame || empleadoDelArray.datosAPIs?.construccionCivil?.plame || [],
        }
      );
      ingresosArray = completados.ingresos;
      descuentosArray = completados.descuentos;
      aportesArray = completados.aportes;
    }

    const liqParaFusion =
      empleadoDelArray.liquidaciones_planilla
      || emp.liquidaciones_planilla
      || [];
    const catalogoPlameFusion = [
      ...(Array.isArray(configuracionesPlame) ? configuracionesPlame : Object.values(configuracionesPlame || {})),
      ...Object.values(empleadoDelArray.datosAPIs?.conceptosPlame || {}),
    ];
    const sepConLiquidacion = fusionarLiquidacionPlanillaEnConceptos(
      { ingresos: ingresosArray, descuentos: descuentosArray, aportes: aportesArray },
      {
        liquidacionesPlanilla: liqParaFusion,
        conceptosUsuario: conceptos,
        catalogoPlame: catalogoPlameFusion,
      }
    );
    ingresosArray = sepConLiquidacion.ingresos;
    descuentosArray = sepConLiquidacion.descuentos;
    aportesArray = sepConLiquidacion.aportes;
    
    // 🔍 DEBUG: Logging detallado de conceptos por empleado
    //console.log(`💰 === CONCEPTOS DETALLADOS para ${empleadoDelArray.empleado_nombre} ===`);
    //console.log(`  📈 Ingresos (${ingresosArray.length}):`);
    ingresosArray.forEach((c, i) => {
      //console.log(`    ${i+1}. ${c.nombre || c.descripcion} - Monto: S/ ${c.monto} - Base: S/ ${c.base_calculo || 0} - PLAME: ${c.codigo_plame || c.codigo}`);
    });
    //console.log(`  📉 Descuentos (${descuentosArray.length}):`);
    descuentosArray.forEach((c, i) => {
      //console.log(`    ${i+1}. ${c.nombre || c.descripcion} - Monto: S/ ${c.monto} - Base: S/ ${c.base_calculo || 0} - PLAME: ${c.codigo_plame || c.codigo}`);
    });
    //console.log(`  📊 Aportes (${aportesArray.length}):`);
    aportesArray.forEach((c, i) => {
      //console.log(`    ${i+1}. ${c.nombre || c.descripcion} - Monto: S/ ${c.monto} - Base: S/ ${c.base_calculo || 0} - PLAME: ${c.codigo_plame || c.codigo}`);
    });
    
    // Calcular totales de conceptos (boleta ordinaria: sin solo-declaración)
    const totalIngresos = ingresosArray
      .filter((c) => !esConceptoSoloDeclaracion(c))
      .reduce((sum, c) => sum + parseFloat(c.monto || 0), 0);
    const totalDescuentos = descuentosArray
      .filter((c) => !esDescuentoSoloDeclaracion(c))
      .reduce((sum, c) => sum + parseFloat(c.monto || 0), 0);
    const totalAportes = aportesArray.reduce((sum, c) => sum + parseFloat(c.monto || 0), 0);
    const netoAPagar = totalIngresos - totalDescuentos;
    
    //console.log(`  💵 TOTALES: Ingresos=${totalIngresos}, Descuentos=${totalDescuentos}, Aportes=${totalAportes}, Neto=${netoAPagar}`);
    
    // 🔍 DEBUG: Verificar que los datos de contacto y descuento estén en el empleado original
    //console.log(`🔍 === VERIFICANDO DATOS DE CONTACTO EN EMPLEADO ORIGINAL ===`);

    //console.log(`👤 Empleado: ${emp.nombre_completo || emp.nombre}`);
    //console.log(`📱 Teléfono: ${emp.telefono || 'NO DISPONIBLE'}`);
    //console.log(`📧 Email: ${emp.email || 'NO DISPONIBLE'}`);
    //console.log(`🏠 Dirección: ${emp.direccion || 'NO DISPONIBLE'}`);
    //console.log(`💤 Descuento descanso: ${emp.descuento_descanso ? 'ACTIVADO' : 'DESACTIVADO'}`);
    //console.log(`🔍 === EMPLEADO ===`, emp);

    const resultadoVista = {
      id: emp.id,
      nombre: empleadoDelArray.empleado_nombre,
      nombre_completo: emp.nombre_completo || emp.nombre || empleadoDelArray.empleado_nombre,
      cargo: emp.cargo || 'Sin cargo',
      areas_de_trabajo: emp.areas_de_trabajo || 'Sin área',
      proyecto: emp.proyecto || 'Sin proyecto',
      documento: emp.numero_documento,
      regimenLaboral: salarios.regimenLaboral || emp.regimen_laboral_codigo || 'RG',
      regimen_laboral_nombre: emp.regimen_laboral_nombre || emp.regimen_laboral?.nombre || 'Sin régimen',
      numero_documento: emp.numero_documento || emp.documento || null,
      codigoPlame: empleadoDelArray.empleado_posicion_activos.toString().padStart(3, '0'),
      // ✅ INFORMACIÓN COMPLETA DE SISTEMA PENSIONARIO
      tipoAporte: salarios.sistemaPensionario || 'ONP',
      afp: salarios.afp || null,
      cuspp: salarios.cuspp || null,
      tipoAfp: salarios.tipoAfp || null,
      fechaAfiliacionAfp: salarios.fechaAfiliacionAfp || null,
      tipoHabitat: salarios.tipoAfp || null, // Usar tipoAfp si está disponible, no asignar por defecto
      categoria: emp.categoria || 'Empleado',
      situacion: 'Activo',
      
      // ✅ DATOS DE CONTACTO PARA PLANILLAS CERRADAS
      telefono: emp.telefono,
      email: emp.email,
      direccion: emp.direccion,
      descuento_descanso: emp.descuento_descanso,
      
      // ✅ INFORMACIÓN BANCARIA
      banco: emp.banco || null,
      cuenta_bancaria: emp.cuenta_bancaria || null,
      cci: emp.cci || null,

      // ✅ SUELDO BÁSICO (planilla cerrada: backend; planilla abierta: datosSalariales)
      sueldo_basico: emp.sueldo_basico != null ? Number(emp.sueldo_basico) : (salarios.sueldoBasico != null ? Number(salarios.sueldoBasico) : undefined),
      // ✅ Monto diario de viático standard (para alerta real vs esperado)
      monto_viatico_standard: (() => {
        const raw = emp.monto_viatico_standard
          ?? emp.montoViaticoStandard
          ?? salarios.montoViaticoStandard
          ?? empleadoDelArray.monto_viatico_standard;
        const n = parseFloat(raw);
        return Number.isFinite(n) ? n : 0;
      })(),
      
      tareos: (() => {
        // Calcular estadísticas detalladas basadas en los tareos individuales
        const tareosCompletos = tareosDet || [];
        
        // 📅 FILTRAR TAREOS SOLO DEL PERÍODO DE LA PLANILLA (NO FECHAS EXTENDIDAS)
        const empleadoLaboral = usaTareosInternos
          ? construirEmpleadoParaHistorialInterno(emp)
          : construirEmpleadoParaHistorialLaboral(emp);
        const tareosDetallados = tareosCompletos.filter(tareo => {
          if (!tareo.fecha || !planillaReal?.fecha_inicio || !planillaReal?.fecha_fin) {
            return true;
          }

          return tareoIncluidoEnPlanillaYLaboral(
            tareo,
            empleadoLaboral,
            planillaReal.fecha_inicio,
            planillaReal.fecha_fin
          );
        });
        
        //console.log(`📊 TAREOS FILTRADOS para ${empleadoDelArray.empleado_nombre}:`);
        //console.log(`  • Total tareos traídos (semanas completas): ${tareosCompletos.length}`);
        //console.log(`  • Tareos del período planilla: ${tareosDetallados.length}`);
        //console.log(`  • Período planilla: ${formatDateToYYYYMMDD(planillaReal?.fecha_inicio)} a ${formatDateToYYYYMMDD(planillaReal?.fecha_fin)}`);
        
        let diasTrabajados = 0;
        let horasOrdinarias = 0;
        let horasExtra25 = 0;
        let horasExtra35 = 0;
        let horasExtra60 = 0;
        let horasExtra100 = 0;
        const regimenTareo = String(
          salarios.regimenLaboral || emp.regimen_laboral_codigo || emp.regimen_laboral?.codigo || '',
        ).toUpperCase();
        const esConsuTareoResumen = regimenTareo === 'CONSU'
          || regimenTareo === 'CONSTRUCCION'
          || regimenTareo.includes('CONSTRUCC');
        let faltas = 0;
        let tardanzas = 0;
        let permisos = 0;
        let suspensiones = 0;
        let vacaciones = 0;
        let descansoMedico = 0;
        let reposoMedico = 0;
        let subsidioPorEnfermedad = 0;
        let licenciaConGoceHaber = 0;
        let feriados = 0;
        let feriadosLaborados = 0;
        let descansos = 0;
        let descansosLaborados = 0;

        // Config de horas: en planilla puede igualar a 8h; los tareos individuales no se tocan
        const cfgHorasPlanilla = emp.configuracion_tareo || configuracionTareo;

        tareosDetallados.forEach(tareo => {
          const tipoEvento = tareo.tipo_evento?.toLowerCase() || '';
          const horas = horasTrabajadasEfectivas(tareo, cfgHorasPlanilla);
          
          switch (tipoEvento) {
            case 'asistencia':
            case 'trabajo_normal':
            case 'asistió':
            case 'asistio':
              diasTrabajados++;
              horasOrdinarias += horas;
              break;
            case 'falta':
            case 'faltas':
              faltas++;
              break;
            case 'tardanza':
            case 'tardanzas':
              tardanzas++;
              diasTrabajados++;
              horasOrdinarias += horas;
              break;
            case 'permiso':
            case 'permisos':
              permisos++;
              break;
            case 'no_laborado':
              permisos++;
              break;
            case 'suspension':
            case 'suspensiones':
              suspensiones++;
              break;
            case 'vacaciones':
            case 'vacacion':
              vacaciones++;
              break;
            case 'descanso_medico':
            case 'descanso medico':
            case 'descanso médico':
              descansoMedico++;
              horasOrdinarias += 8; // Descanso médico = 8 horas
              break;
            case 'reposo_medico':
            case 'reposo medico':
            case 'reposo médico':
              reposoMedico++;
              // Reposo médico = 0 horas (no se agregan horas)
              break;
            case 'subsidio_por_enfermedad':
            case 'subsidio por enfermedad':
              subsidioPorEnfermedad++;
              horasOrdinarias += 8; // Subsidio por enfermedad = 8 horas
              break;
            case 'licencia_con_goce_de_haber':
            case 'licencia con goce de haber':
              licenciaConGoceHaber++;
              horasOrdinarias += 8; // Igual que subsidio: jornada computada 8 h
              break;
            case 'feriado':
            case 'feriados':
              feriados++;
              break;
            case 'feriado_laborado':
            case 'feriado laborado':
              feriadosLaborados++;
              horasOrdinarias += horas;
              break;
            case 'descanso':
            case 'descansos':
              descansos++;
              break;
            case 'descanso_laborado':
            case 'descanso laborado':
              descansosLaborados++;
              horasOrdinarias += horas;
              break;
            default:
              // Por defecto, considerar como día trabajado si tiene horas
              if (horas > 0) {
                diasTrabajados++;
                horasOrdinarias += horas;
              }
          }

          // Horas extra por registro (si el API las envía explícitas)
          const he25Api = parseFloat(tareo.horas_extra_25 ?? tareo.horas_extras_25 ?? tareo.horasExtras25 ?? 0);
          const he35Api = parseFloat(tareo.horas_extra_35 ?? tareo.horas_extras_35 ?? tareo.horasExtras35 ?? 0);
          const he60Api = parseFloat(tareo.horas_extra_60 ?? tareo.he_60 ?? 0);
          const he100Api = parseFloat(tareo.horas_extra_100 ?? tareo.he_100 ?? 0);
          if (!Number.isNaN(he25Api)) horasExtra25 += he25Api;
          if (!Number.isNaN(he35Api)) horasExtra35 += he35Api;
          if (!Number.isNaN(he60Api)) horasExtra60 += he60Api;
          if (!Number.isNaN(he100Api)) horasExtra100 += he100Api;
        });

        // Horas extra desde autorizaciones aprobadas (misma lógica que TareoModal + subtipos del backend)
        const idEmpAuth = emp.id != null ? Number(emp.id) : null;
        if (idEmpAuth != null && Array.isArray(autorizacionesPeriodo) && autorizacionesPeriodo.length > 0) {
          autorizacionesPeriodo.forEach((aut) => {
            if (Number(aut.empleado_id) !== idEmpAuth) return;
            if (aut.tipo_autorizacion !== 'horas-extra' || aut.estado !== 'aprobado') return;
            const horasAuth = parseFloat(aut.horas || 0);
            if (Number.isNaN(horasAuth) || horasAuth <= 0) return;
            const st = String(aut.sub_tipo || '').toLowerCase().trim();
            if (
              st === 'horas-extra-100'
              || st === '100%'
              || st === '100'
              || st.includes('extra-100')
              || st === 'he100'
            ) {
              horasExtra100 += horasAuth;
            } else if (
              st === 'horas-extra-60'
              || st === '60%'
              || st === '60'
              || st.includes('extra-60')
              || st === 'he60'
            ) {
              horasExtra60 += horasAuth;
            } else if (
              st === '35%' ||
              st === '35' ||
              st === 'horas-extra-35' ||
              st.includes('extra-35') ||
              st === 'he35'
            ) {
              horasExtra35 += horasAuth;
            } else if (
              st === '25%' ||
              st === '25' ||
              st === 'horas-extra-25' ||
              st.includes('extra-25') ||
              st === 'he25'
            ) {
              horasExtra25 += horasAuth;
            } else if (esConsuTareoResumen) {
              horasExtra60 += horasAuth;
            } else {
              horasExtra25 += horasAuth;
            }
          });
        }

        return {
          diasTrabajados,
          diasProgramados,
          horasOrdinarias: Math.round(horasOrdinarias),
          horasExtra25: Math.round(horasExtra25 * 100) / 100,
          horasExtra35: Math.round(horasExtra35 * 100) / 100,
          horasExtra60: Math.round(horasExtra60 * 100) / 100,
          horasExtra100: Math.round(horasExtra100 * 100) / 100,
          esConsuTareoResumen,
          faltas,
          tardanzas,
          permisos,
          suspensiones,
          vacaciones,
          descansoMedico,
          reposoMedico,
          subsidioPorEnfermedad,
          licenciaConGoceHaber,
          feriados,
          feriadosLaborados,
          descansos,
          descansosLaborados,
          asistenciaPerfecta: tareosDetallados.length === diasProgramados && faltas === 0
        };
      })(),
      conceptos: (() => {
        const conceptosTransformados = {
        ingresos: ingresosArray.map((c, index) => {
          const codigo = c.codigo_plame || c.codigo || c.codigoPlame || `ING${index + 1}`;
          return {
            // ✅ USAR LA ESTRUCTURA EXACTA DE LOS DATOS CALCULADOS
            id: c.id,
            codigo,
            descripcion: c.nombre || c.descripcion || c.concepto || 'Concepto de Ingreso',
          monto: parseFloat(c.monto || 0),
            codigoPlame: codigo,
            codigo_plame: codigo,
            base_calculo: parseFloat(c.base_calculo ?? c.base ?? 0),
            plame_configuracion_id: c.plame_configuracion_id || c.plame_configuracion?.id || null,
            plame_configuracion: c.plame_configuracion || null,
            tipo_concepto: c.tipo_concepto || 'ingreso',
            origen: c.origen || 'calculado',
            excluirBoletaOrdinaria: Boolean(c.excluirBoletaOrdinaria || c.excluir_boleta_ordinaria),
            excluir_boleta_ordinaria: Boolean(c.excluirBoletaOrdinaria || c.excluir_boleta_ordinaria),
            origenCalculo: c.origenCalculo || c.origen_calculo || null,
            origen_calculo: c.origenCalculo || c.origen_calculo || null,
            claveConstruccion: c.claveConstruccion || null,
            codigo_afectacion_tributos: c.codigo_afectacion_tributos || null,
            plame_configuracion_tributos: c.plame_configuracion_tributos || null,
          };
        }),
        descuentos: descuentosArray.map((c, index) => {
          const codigo = c.codigo_plame || c.codigo || c.codigoPlame || `DESC${index + 1}`;
          return {
            // ✅ USAR LA ESTRUCTURA EXACTA DE LOS DATOS CALCULADOS
            id: c.id,
            codigo,
            descripcion: c.nombre || c.descripcion || c.concepto || 'Concepto de Descuento',
          monto: parseFloat(c.monto || 0),
            codigoPlame: codigo,
            codigo_plame: codigo,
            base_calculo: parseFloat(c.base_calculo ?? c.base ?? 0),
            plame_configuracion_id: c.plame_configuracion_id || c.plame_configuracion?.id || null,
            plame_configuracion: c.plame_configuracion || null,
            tipo_concepto: c.tipo_concepto || 'descuento',
            origen: c.origen || 'calculado',
            excluirBoletaOrdinaria: Boolean(c.excluirBoletaOrdinaria || c.excluir_boleta_ordinaria),
            excluir_boleta_ordinaria: Boolean(c.excluirBoletaOrdinaria || c.excluir_boleta_ordinaria),
            origenCalculo: c.origenCalculo || c.origen_calculo || null,
            origen_calculo: c.origenCalculo || c.origen_calculo || null,
            exportable_plame: c.exportable_plame,
            absorberEn0121: Boolean(c.absorberEn0121),
            fusionarEn0705: Boolean(c.fusionarEn0705),
            excluirRem: Boolean(c.excluirRem || c.exportable_plame === false),
          };
        }),
        aportes: aportesArray.map((c, index) => {
          const codigo = c.codigo_plame || c.codigo || c.codigoPlame || `APO${index + 1}`;
          return {
            // ✅ USAR LA ESTRUCTURA EXACTA DE LOS DATOS CALCULADOS
            id: c.id,
            codigo,
            descripcion: c.nombre || c.descripcion || c.concepto || 'Concepto de Aporte',
          monto: parseFloat(c.monto || 0),
            codigoPlame: codigo,
            codigo_plame: codigo,
            base_calculo: parseFloat(c.base_calculo ?? c.base ?? 0),
            plame_configuracion_id: c.plame_configuracion_id || c.plame_configuracion?.id || null,
            plame_configuracion: c.plame_configuracion || null,
            tipo_concepto: c.tipo_concepto || 'aporte',
            origen: c.origen || 'calculado'
          };
        })
        };

        // ✅ LOGGING DE CONCEPTOS TRANSFORMADOS
        //console.log(`🎯 === CONCEPTOS TRANSFORMADOS para ${empleadoDelArray.empleado_nombre} ===`);
        //console.log('📈 Ingresos transformados:', conceptosTransformados.ingresos);
        //console.log('📉 Descuentos transformados:', conceptosTransformados.descuentos);
        //console.log('📊 Aportes transformados:', conceptosTransformados.aportes);

        return conceptosTransformados;
      })(),
      totales: {
        totalIngresos,
        totalDescuentos,
        totalAportes,
        netoAPagar
      },
      // ✅ AGREGAR LOS DATOS REALES DE TAREOS QUE FALTABAN
      tareosEmpleado: tareosDet, // Tareos individuales del backend
      tareosEmpleadoInterna: Array.isArray(empleadoDelArray.tareosEmpleadoInterna)
        ? empleadoDelArray.tareosEmpleadoInterna
        : [],
      tareosEmpleadoFiltrados: Array.isArray(empleadoDelArray.tareosEmpleadoFiltrados)
        ? empleadoDelArray.tareosEmpleadoFiltrados
        : tareosDet,
      configuracion_tareo: emp.configuracion_tareo || empleadoDelArray.configuracion_tareo || configuracionTareo || null,
      resumenTareos: tareos, // Resumen estadístico de tareos
      // Historial laboral (cerradas: se reconstruye desde fecha_ingreso/cese_actual del snapshot)
      historial_laboral: construirEmpleadoParaHistorialLaboral(emp).historial_laboral || emp.historial_laboral || [],
      historial_laboral_interno: emp.historial_laboral_interno || emp.historialLaboralInterno || [],
      fecha_ingreso_interna: emp.fecha_ingreso_interna || emp.fechaIngresoInterna || null,
      // ✅ AGREGAR LOS CAMPOS ADICIONALES QUE ESTÁN EN LA API
      email: emp.email || null,
      telefono: emp.telefono || null,
      direccion: emp.direccion || null,
      distrito: emp.distrito || null,
      provincia: emp.provincia || null,
      departamento: emp.departamento || null,
      proyecto: emp.proyecto || null,
      tipo_documento: emp.tipo_documento || 'DNI',
      fecha_nacimiento: extraerFechaNacimientoEmpleado(emp) || extraerFechaNacimientoEmpleado(empleadoDelArray) || null,
      fechaNacimiento: extraerFechaNacimientoEmpleado(emp) || extraerFechaNacimientoEmpleado(empleadoDelArray) || null,
      sexo: emp.sexo || null,
      estado_civil: emp.estado_civil || null,
      tipo_contratacion: emp.tipo_contratacion || null,
      fecha_computo_rh_id: emp.fecha_computo_rh_id ?? null,
      // Fechas laborales (AFPnet / tareo / historial). En cerradas vienen del snapshot.
      fecha_ingreso_actual: emp.fecha_ingreso_actual || emp.fechaIngreso || emp.fecha_ingreso || null,
      fecha_cese_actual: emp.fecha_cese_actual || emp.fechaCese || emp.fecha_cese || null,
      fecha_ingreso: emp.fecha_ingreso || emp.fecha_ingreso_actual || null,
      fecha_cese: emp.fecha_cese || emp.fecha_cese_actual || null,
      fechaIngreso: resolverFechaIngresoEnPlanilla(
        construirEmpleadoParaHistorialLaboral(emp),
        planillaReal?.fecha_inicio,
        planillaReal?.fecha_fin
      ),
      sistema_pensionario: emp.sistema_pensionario || salarios.sistemaPensionario || null,
      regimen_laboral_codigo: emp.regimen_laboral_codigo || emp.regimen_laboral?.codigo || salarios.regimenLaboral || null,
      regimen_laboral_nombre: emp.regimen_laboral_nombre || emp.regimen_laboral?.nombre || emp.regimenLaboral || null,
      afp_aporte: emp.afp_aporte ?? emp.afp?.aporte ?? null,
      // Configuración alineada con `datosAPIs` del array unificado (p. ej. licencia con goce de haber)
      datosAPIs: empleadoDelArray.datosAPIs || null,
      tipo_planilla: emp.tipo_planilla || salarios.tipoPlanilla || null,
      forma_pago: emp.forma_pago === 'jornal' || salarios.formaPago === 'jornal'
        ? 'jornal'
        : (empleadoDelArray.forma_pago === 'jornal' ? 'jornal' : 'mensual'),
      forma_pago_planilla: emp.forma_pago_planilla
        || salarios.formaPagoPlanilla
        || empleadoDelArray.forma_pago_planilla
        || null,
      fecha_desde_jornal: emp.fecha_desde_jornal
        || salarios.fechaDesdeJornal
        || empleadoDelArray.fecha_desde_jornal
        || null,
      aplicar_descuento_dominical: emp.aplicar_descuento_dominical
        ?? salarios.aplicarDescuentoDominical
        ?? empleadoDelArray.aplicar_descuento_dominical
        ?? null,
      fecha_calculo_desde: emp.fecha_calculo_desde
        || empleadoDelArray.fecha_calculo_desde
        || null,
      fecha_calculo_hasta: emp.fecha_calculo_hasta
        || empleadoDelArray.fecha_calculo_hasta
        || null,
      pagoJornal: emp.pagoJornal || empleadoDelArray.pagoJornal || null,
      sueldo_interno: emp.sueldo_interno != null
        ? Number(emp.sueldo_interno)
        : (salarios.sueldoInterno != null ? Number(salarios.sueldoInterno) : null),
      conceptosInternos: (() => {
        const sep = empleadoDelArray.conceptos_separados_internos
          || emp.conceptos_separados_internos
          || null;
        const ing = Array.isArray(conceptos.ingresosInternos)
          ? conceptos.ingresosInternos
          : (sep?.ingresos || []);
        const des = Array.isArray(conceptos.descuentosInternos)
          ? conceptos.descuentosInternos
          : (sep?.descuentos || []);
        const apo = Array.isArray(conceptos.aportesInternos)
          ? conceptos.aportesInternos
          : (sep?.aportes || []);
        const mapC = (arr, tipo, prefix) => (arr || []).map((c, index) => {
          const codigo = c.codigo_plame || c.codigo || c.codigoPlame || `${prefix}${index + 1}`;
          return {
            id: c.id,
            codigo,
            descripcion: c.nombre || c.descripcion || c.concepto || 'Concepto',
            monto: parseFloat(c.monto || 0),
            codigoPlame: codigo,
            base_calculo: parseFloat(c.base_calculo || 0),
            tipo_concepto: c.tipo_concepto || tipo,
            origen: c.origen || 'calculado_interno',
            excluirBoletaOrdinaria: Boolean(c.excluirBoletaOrdinaria || c.excluir_boleta_ordinaria),
            excluir_boleta_ordinaria: Boolean(c.excluirBoletaOrdinaria || c.excluir_boleta_ordinaria),
            origenCalculo: c.origenCalculo || c.origen_calculo || null,
            origen_calculo: c.origenCalculo || c.origen_calculo || null,
          };
        });
        return {
          ingresos: mapC(ing, 'ingreso', 'IING'),
          descuentos: mapC(des, 'descuento', 'IDESC'),
          aportes: mapC(apo, 'aporte', 'IAPO'),
        };
      })(),
      totalesInternos: (() => {
        const sep = empleadoDelArray.conceptos_separados_internos
          || emp.conceptos_separados_internos
          || null;
        const ing = Array.isArray(conceptos.ingresosInternos)
          ? conceptos.ingresosInternos
          : (sep?.ingresos || []);
        const des = Array.isArray(conceptos.descuentosInternos)
          ? conceptos.descuentosInternos
          : (sep?.descuentos || []);
        const apo = Array.isArray(conceptos.aportesInternos)
          ? conceptos.aportesInternos
          : (sep?.aportes || []);
        // Neto interna = boleta ordinaria (sin grati/viáticos solo-declaración)
        const ti = (ing || [])
          .filter((c) => !esConceptoSoloDeclaracion(c))
          .reduce((s, c) => s + (parseFloat(c.monto) || 0), 0);
        const td = (des || []).reduce((s, c) => s + (parseFloat(c.monto) || 0), 0);
        const ta = (apo || []).reduce((s, c) => s + (parseFloat(c.monto) || 0), 0);
        return { totalIngresos: ti, totalDescuentos: td, totalAportes: ta, netoAPagar: ti - td };
      })(),
      conceptosInternos1: (() => {
        const sep = empleadoDelArray.conceptos_separados_internos_1 || emp.conceptos_separados_internos_1 || null;
        if (!sep) return null;
        const mapC = (arr, tipo, prefix) => (arr || []).map((c, index) => {
          const codigo = c.codigo_plame || c.codigo || c.codigoPlame || `${prefix}${index + 1}`;
          return {
            id: c.id,
            codigo,
            descripcion: c.nombre || c.descripcion || c.concepto || 'Concepto',
            monto: parseFloat(c.monto || 0),
            codigoPlame: codigo,
            base_calculo: parseFloat(c.base_calculo || 0),
            tipo_concepto: c.tipo_concepto || tipo,
            origen: c.origen || 'calculado_interno_1',
            excluirBoletaOrdinaria: Boolean(c.excluirBoletaOrdinaria || c.excluir_boleta_ordinaria),
            origenCalculo: c.origenCalculo || c.origen_calculo || null,
          };
        });
        return {
          ingresos: mapC(sep.ingresos, 'ingreso', 'I1ING'),
          descuentos: mapC(sep.descuentos, 'descuento', 'I1DESC'),
          aportes: mapC(sep.aportes, 'aporte', 'I1APO'),
        };
      })(),
      conceptosInternos2: (() => {
        const sep = empleadoDelArray.conceptos_separados_internos_2 || emp.conceptos_separados_internos_2 || null;
        if (!sep) return null;
        const mapC = (arr, tipo, prefix) => (arr || []).map((c, index) => {
          const codigo = c.codigo_plame || c.codigo || c.codigoPlame || `${prefix}${index + 1}`;
          return {
            id: c.id,
            codigo,
            descripcion: c.nombre || c.descripcion || c.concepto || 'Concepto',
            monto: parseFloat(c.monto || 0),
            codigoPlame: codigo,
            base_calculo: parseFloat(c.base_calculo || 0),
            tipo_concepto: c.tipo_concepto || tipo,
            origen: c.origen || 'calculado_interno_2',
            excluirBoletaOrdinaria: Boolean(c.excluirBoletaOrdinaria || c.excluir_boleta_ordinaria),
            origenCalculo: c.origenCalculo || c.origen_calculo || null,
          };
        });
        return {
          ingresos: mapC(sep.ingresos, 'ingreso', 'I2ING'),
          descuentos: mapC(sep.descuentos, 'descuento', 'I2DESC'),
          aportes: mapC(sep.aportes, 'aporte', 'I2APO'),
        };
      })(),
      totalesInternos1: (() => {
        const sep = empleadoDelArray.conceptos_separados_internos_1 || emp.conceptos_separados_internos_1 || null;
        if (!sep) return null;
        const ti = (sep.ingresos || []).filter((c) => !esConceptoSoloDeclaracion(c)).reduce((s, c) => s + (parseFloat(c.monto) || 0), 0);
        const td = (sep.descuentos || []).reduce((s, c) => s + (parseFloat(c.monto) || 0), 0);
        const ta = (sep.aportes || []).reduce((s, c) => s + (parseFloat(c.monto) || 0), 0);
        return { totalIngresos: ti, totalDescuentos: td, totalAportes: ta, netoAPagar: ti - td };
      })(),
      totalesInternos2: (() => {
        const sep = empleadoDelArray.conceptos_separados_internos_2 || emp.conceptos_separados_internos_2 || null;
        if (!sep) return null;
        const ti = (sep.ingresos || []).filter((c) => !esConceptoSoloDeclaracion(c)).reduce((s, c) => s + (parseFloat(c.monto) || 0), 0);
        const td = (sep.descuentos || []).reduce((s, c) => s + (parseFloat(c.monto) || 0), 0);
        const ta = (sep.aportes || []).reduce((s, c) => s + (parseFloat(c.monto) || 0), 0);
        return { totalIngresos: ti, totalDescuentos: td, totalAportes: ta, netoAPagar: ti - td };
      })(),
      diasInterna1: empleadoDelArray.dias_interna_1 ?? emp.dias_interna_1 ?? null,
      diasInterna2: empleadoDelArray.dias_interna_2 ?? emp.dias_interna_2 ?? null,
      boletaInternaPartida: (() => {
        const empId = empleadoDelArray.empleado_id || emp.id;
        if (tramoActivoParaEmpleado(tramosBoletaInterna, empId)) return true;
        return Boolean(empleadoDelArray.boleta_interna_partida || emp.boleta_interna_partida);
      })(),
      sueldoPartido: (() => {
        const empId = empleadoDelArray.empleado_id || emp.id;
        if (tramoActivoParaEmpleado(tramosBoletaInterna, empId) || empleadoDelArray.boleta_interna_partida || emp.boleta_interna_partida) {
          return null;
        }
        const saved = empleadoDelArray.sueldo_partido || emp.sueldo_partido;
        if (saved?.sueldo1 != null && saved?.sueldo2 != null) return saved;
        const cfgSueldo = tramoSueldoPlameActivo(tramosSueldoPlame, empId);
        if (cfgSueldo && destinoSueldoAplicaInterna(cfgSueldo)) {
          return {
            dias1: empleadoDelArray.dias_interna_1 ?? emp.dias_interna_1 ?? null,
            dias2: empleadoDelArray.dias_interna_2 ?? emp.dias_interna_2 ?? null,
            sueldo1: cfgSueldo.sueldo_1,
            sueldo2: cfgSueldo.sueldo_2,
          };
        }
        return saved || null;
      })(),
      liquidaciones_planilla: Array.isArray(emp.liquidaciones_planilla)
        ? emp.liquidaciones_planilla
        : (Array.isArray(empleadoDelArray.liquidaciones_planilla) ? empleadoDelArray.liquidaciones_planilla : []),
      gratificaciones_planilla: Array.isArray(emp.gratificaciones_planilla)
        ? emp.gratificaciones_planilla
        : (Array.isArray(empleadoDelArray.gratificaciones_planilla) ? empleadoDelArray.gratificaciones_planilla : []),
    };

    const empIdTramo = empleadoDelArray.empleado_id || emp.id;
    const cfgTramoVista = tramoActivoParaEmpleado(tramosBoletaInterna, empIdTramo);
    resultadoVista.sueldoInterno1 = emp.sueldo_interno_1
      ?? empleadoDelArray.sueldo_interno_1
      ?? cfgTramoVista?.sueldo_interno_1
      ?? emp.boleta_interna_1_calculada?.sueldo_base_tramo
      ?? null;
    resultadoVista.sueldoInterno2 = emp.sueldo_interno_2
      ?? empleadoDelArray.sueldo_interno_2
      ?? cfgTramoVista?.sueldo_interno_2
      ?? emp.boleta_interna_2_calculada?.sueldo_base_tramo
      ?? null;

    if (resultadoVista.boletaInternaPartida) {
      resultadoVista.conceptosInternos1 = anotarConceptosConSueldoTramo(
        resultadoVista.conceptosInternos1,
        {
          numero: 1,
          sueldo: resultadoVista.sueldoInterno1,
          dias: resultadoVista.diasInterna1,
        }
      );
      resultadoVista.conceptosInternos2 = anotarConceptosConSueldoTramo(
        resultadoVista.conceptosInternos2,
        {
          numero: 2,
          sueldo: resultadoVista.sueldoInterno2,
          dias: resultadoVista.diasInterna2,
        }
      );
    }

    if (esBoletaConstruccion) {
      const calcConsu = empleadoDelArray.calculoConstruccionCivil || {};
      const diasConsu = diasParaNetoConstruccion({
        resumen: calcConsu.resumen,
        detalleDias: calcConsu.detalleDias,
        diasTrabajadosTareo: 0,
      }) || Number(empleadoDelArray.totales?.diasNeto) || 0;
      const extra = resolverNetoPorDiaConstruccion({
        neto: resultadoVista.totales?.netoAPagar,
        diasAsistencia: diasConsu,
        diasComputables: Number(calcConsu.resumen?.diasComputables) || 0,
        diasTrabajados: diasConsu > 0 ? 0 : (resultadoVista.tareos?.diasTrabajados || 0),
      });
      resultadoVista.totales = { ...(resultadoVista.totales || {}), ...extra };
      resultadoVista.calculoConstruccionCivil = calcConsu;
      resultadoVista.fecha_calculo_desde = resultadoVista.fecha_calculo_desde
        || empleadoDelArray.fecha_calculo_desde
        || null;
      resultadoVista.fecha_calculo_hasta = resultadoVista.fecha_calculo_hasta
        || empleadoDelArray.fecha_calculo_hasta
        || null;
      if (resultadoVista.totalesInternos) {
        resultadoVista.totalesInternos = {
          ...resultadoVista.totalesInternos,
          ...resolverNetoPorDiaConstruccion({
            neto: resultadoVista.totalesInternos.netoAPagar,
            diasAsistencia: extra.diasNeto,
          }),
        };
      }
    }

    const liqPlanilla =
      resultadoVista.liquidaciones_planilla
      || empleadoDelArray.liquidaciones_planilla
      || empleadoDelArray.datosEmpleado?.liquidaciones_planilla
      || [];
    if (resultadoVista.conceptos) {
      const fusionLiq = fusionarLiquidacionPlanillaEnConceptos(resultadoVista.conceptos, {
        liquidacionesPlanilla: liqPlanilla,
        conceptosUsuario: empleadoDelArray.conceptosUsuario,
        catalogoPlame: Object.values(
          configuracionesPlame || empleadoDelArray.datosAPIs?.conceptosPlame || []
        ),
      });
      const totalIngresosOrd = fusionLiq.ingresos
        .filter((c) => !esConceptoSoloDeclaracion(c))
        .reduce((s, c) => s + (parseFloat(c.monto) || 0), 0);
      const totalDescOrd = fusionLiq.descuentos
        .filter((c) => !esDescuentoSoloDeclaracion(c))
        .reduce((s, c) => s + (parseFloat(c.monto) || 0), 0);
      const totalAportesOrd = (fusionLiq.aportes || []).reduce(
        (s, c) => s + (parseFloat(c.monto) || 0),
        0
      );
      resultadoVista.conceptos = fusionLiq;
      resultadoVista.totales = {
        totalIngresos: totalIngresosOrd,
        totalDescuentos: totalDescOrd,
        totalAportes: totalAportesOrd,
        netoAPagar: totalIngresosOrd - totalDescOrd,
      };
    }

    // Inyectar 0406/0313 del módulo (declaración PLAME) en planilla abierta
    return aplicarDeclaracionGratificacionDesdeModulo(resultadoVista);
  };

  useEffect(() => {
    //console.clear(); // Limpiar consola para mejor visibilidad
    //console.log('🚀🚀🚀 === PLANILLA DETALLE - INICIANDO CARGA === 🚀🚀🚀');
    //console.log('🆔 ID de planilla:', id);
    //console.log('🏢 Empresa seleccionada:', selectedCompany);
    //console.log('🔍 selectedCompany?.id:', selectedCompany?.id);
    //console.log('🔍 selectedCompany?.name:', selectedCompany?.name);
    
    // Verificar si tenemos empresa seleccionada
    if (!selectedCompany) {
      //console.log('⏳⏳⏳ ESPERANDO A QUE SE CARGUE LA EMPRESA SELECCIONADA...');
      return;
    }
    
    //console.log('✅✅✅ EMPRESA DISPONIBLE - PROCEDIENDO CON LA CARGA');
    
    // Usar la nueva función optimizada para cargar todos los datos
    cargarTodosLosDatos();
    
  }, [id, selectedCompany]); // Agregar selectedCompany como dependencia

  // Efecto adicional para monitorear cambios en selectedCompany
  useEffect(() => {
    //console.log('🔍🔍🔍 EFECTO SELECTEDCOMPANY - CAMBIO DETECTADO');
    //console.log('🏢 selectedCompany actual:', selectedCompany);
    if (selectedCompany) {
      //console.log('✅ Empresa disponible:', selectedCompany.name);
      //console.log('🆔 ID de empresa:', selectedCompany.id);
    } else {
      //console.log('❌ No hay empresa seleccionada');
    }
  }, [selectedCompany]);

  useEffect(() => {
    const nombre = planillaReal?.nombre;
    document.title = nombre
      ? `Detalle de planilla: ${nombre} | Sistema de Planillas`
      : 'Detalle de planilla | Sistema de Planillas';
    return () => {
      document.title = 'Sistema de Planillas';
    };
  }, [planillaReal?.nombre]);

  // Efecto para filtrar empleados activos cuando se actualicen planillaReal y empleadosConConceptos
  useEffect(() => {
    if (planillaCerrada || planillaReal?.estado === 'cerrada') {
      return;
    }

    if (planillaReal && planillaReal.fecha_inicio && planillaReal.fecha_fin && empleadosConConceptos.length > 0) {
      console.log('🔍 AUTO-FILTRADO: Filtrando empleados activos automáticamente...');
      console.log(`📅 Período planilla: ${planillaReal.fecha_inicio} - ${planillaReal.fecha_fin}`);
      console.log(`👥 Total empleados a evaluar: ${empleadosConConceptos.length}`);
      
      let empleadosActivos = empleadosConConceptos.filter(empleado => {
        return empleadoActivoDurantePeriodo(empleado, planillaReal.fecha_inicio, planillaReal.fecha_fin);
      });

      // Filtrar por tipo de contratación según modalidad de la planilla
      const modalidad = planillaReal.modalidad_planilla || null;
      const esPlanillaRH = modalidad === 'planilla_rh' || (planillaReal.nombre && (String(planillaReal.nombre).toUpperCase().trim() === 'RH' || String(planillaReal.nombre).toUpperCase().includes('RH')));
      const esPlanillaNormal = modalidad === 'planilla_normal';
      const tipoContratacionDe = (emp) => String(emp.tipo_contratacion || emp.datosSalariales?.tipoContratacion || emp.datosEmpleado?.tipo_contratacion || '').trim();
      const esJornalNoConsu = (emp) => esPersonalJornalNoConstruccion(
        emp,
        esRegimenConstruccionCivil(emp, regimenesLaborales || [])
      );

      if (esPlanillaRH) {
        const antes = empleadosActivos.length;
        empleadosActivos = empleadosActivos.filter(emp => tipoContratacionDe(emp) === 'Recibo por Honorarios');
        console.log(`📋 Planilla RH: solo personal en Recibo por Honorarios. ${antes} → ${empleadosActivos.length} empleados`);
      } else if (modalidad === 'planilla_construccion') {
        const antes = empleadosActivos.length;
        empleadosActivos = empleadosActivos.filter((emp) => esRegimenConstruccionCivil(emp, regimenesLaborales || []));
        console.log(`📋 Planilla Construcción: solo personal CONSU. ${antes} → ${empleadosActivos.length} empleados`);
      } else if (modalidad === 'planilla_jornales') {
        const antes = empleadosActivos.length;
        empleadosActivos = empleadosActivos.filter((emp) => esJornalNoConsu(emp));
        console.log(`📋 Planilla Jornales: solo personal jornal (excl. CONSU). ${antes} → ${empleadosActivos.length} empleados`);
      } else if (esPlanillaNormal) {
        const antes = empleadosActivos.length;
        empleadosActivos = empleadosActivos.filter(emp => tipoContratacionDe(emp) !== 'Recibo por Honorarios');
        console.log(`📋 Planilla Normal: solo personal de planilla (excl. RH). ${antes} → ${empleadosActivos.length} empleados`);
      }
      
      console.log(`✅ AUTO-FILTRADO COMPLETADO: ${empleadosActivos.length} empleados activos encontrados`);
      setEmpleadosActivosPlanilla(empleadosActivos);
    } else if (!planillaCerrada && planillaReal?.estado !== 'cerrada') {
      console.log('⏳ AUTO-FILTRADO: Esperando datos necesarios (planillaReal y empleadosConConceptos)');
      setEmpleadosActivosPlanilla([]);
    }
  }, [planillaReal, empleadosConConceptos, planillaCerrada, regimenesLaborales]);

  // Función utilitaria para reintentar peticiones con backoff exponencial
  const reintentarConBackoff = async (funcionPeticion, maxIntentos = 3, delayInicial = 500) => {
    for (let intento = 1; intento <= maxIntentos; intento++) {
      try {
        const resultado = await funcionPeticion();
        return resultado;
      } catch (error) {
        console.log(`❌ Intento ${intento}/${maxIntentos} falló:`, error.message);
        
        if (error.response?.status === 429 && intento < maxIntentos) {
          const delay = delayInicial * Math.pow(2, intento - 1);
          console.log(`⏳ Esperando ${delay}ms antes del siguiente intento...`);
          await new Promise(resolve => setTimeout(resolve, delay));
          continue;
        }
        
        if (intento === maxIntentos) {
          throw error;
        }
      }
    }
  };

  // Función OPTIMIZADA para cargar todos los datos de forma controlada
  // 📊 FUNCIÓN PARA ACTUALIZAR PROGRESO DE CARGA
  const actualizarProgreso = (apiNombre, completada = false) => {
    setCargandoProgreso(prev => {
      const nuevasCompletadas = completada && !prev.apisCompletadas.includes(apiNombre)
        ? [...prev.apisCompletadas, apiNombre]
        : prev.apisCompletadas;
      
      return {
        ...prev,
        progreso: nuevasCompletadas.length,
        apiActual: completada ? '' : apiNombre,
        apisCompletadas: nuevasCompletadas
      };
    });
  };

  const cargarTodosLosDatos = async () => {
    try {
      console.log('🔄🔄🔄 === INICIANDO CARGA OPTIMIZADA CON PROGRESO === 🔄🔄🔄');
      setLoading(true);
      
      // Inicializar progreso
      setCargandoProgreso(prev => ({
        ...prev,
        progreso: 0,
        apisCompletadas: [],
        tiempoInicio: Date.now(),
        apiActual: 'Inicializando...'
      }));

      // FASE 1: Datos básicos - SIEMPRE cargar planilla primero
      console.log('📋 FASE 1: Cargando planilla real...');
      actualizarProgreso('📋 Planilla Real');
      const planillaReal = await cargarDatosPlanilla();
      actualizarProgreso('📋 Planilla Real', true);
      
      // Verificar si planilla está cerrada para decidir flujo
      const estaCerrada = planillaReal?.estado === 'cerrada';
      console.log('🔒 DECISIÓN DE FLUJO - Planilla cerrada:', estaCerrada);
      
      if (estaCerrada) {
        // 🔒 FLUJO PARA PLANILLA CERRADA
        await cargarDatosPlanillaCerrada();
      } else {
        // 🔓 FLUJO NORMAL PARA PLANILLA ABIERTA
        await cargarDatosCompletos();
        await cargarPreCierresPlanilla();
      }
      
      // Finalizar carga común
      await finalizarCarga();
      
    } catch (error) {
      console.error('❌ Error en carga optimizada:', error);
      manejarErrorCarga();
    }
  };

  // 🔧 TRANSFORMAR EMPLEADOS CERRADOS PARA COMPATIBILIDAD CON LA VISTA
  const finalizarEmpleadoCerradoParaVista = (empleado) => {
    const liq = Array.isArray(empleado.liquidaciones_planilla) ? empleado.liquidaciones_planilla : [];
    const grati = Array.isArray(empleado.gratificaciones_planilla) ? empleado.gratificaciones_planilla : [];
    let emp = empleado;
    if (emp.conceptos?.ingresos) {
      const norm = normalizarConceptosSnapshotPlanillaCerrada(emp.conceptos, {
        liquidacionesPlanilla: liq,
        gratificacionesPlanilla: grati,
        fechaCeseActual: emp.fecha_cese_actual || emp.fechaCese || emp.fecha_cese,
        catalogoPlame: Object.values(configuracionesPlame || []),
      });
      emp = {
        ...emp,
        conceptos: norm.conceptos,
        conceptos_separados: norm.conceptos,
        totales: norm.totales,
      };
    }
    emp = aplicarDeclaracionGratificacionDesdeModulo(emp);
    return {
      ...emp,
      totales: recalcularTotalesBoletaOrdinaria(emp.conceptos),
    };
  };

  const transformarEmpleadosCerradosParaVista = (empleadosCerrados) => {
    return empleadosCerrados.map(empleadoRaw => {
      const empleado = aplicarSnapshotInternaCierre(empleadoRaw);
      const totalesNormalizados = fusionarTotalesVistaCerrada({
        totalIngresos: Number(
          empleado?.totales?.totalIngresos ??
          empleado?.boleta_calculada?.data?.totales?.totalIngresos ??
          empleado?.total_ingresos ??
          0
        ),
        totalDescuentos: Number(
          empleado?.totales?.totalDescuentos ??
          empleado?.boleta_calculada?.data?.totales?.totalDescuentos ??
          empleado?.total_descuentos ??
          0
        ),
        totalAportes: Number(
          empleado?.totales?.totalAportes ??
          empleado?.boleta_calculada?.data?.totales?.totalAportes ??
          empleado?.total_aportes ??
          0
        ),
        netoAPagar: Number(
          empleado?.totales?.netoAPagar ??
          empleado?.boleta_calculada?.data?.totales?.netoAPagar ??
          empleado?.neto_a_pagar ??
          0
        )
      }, empleado);

      // Si ya tiene la estructura de conceptos, solo agregar campos de contacto que falten

      if (empleado.conceptos?.ingresos) {
        console.log('✅ Empleado ya transformado, agregando campos de contacto:', empleado.nombre_completo);
        const ya = finalizarEmpleadoCerradoParaVista({
          ...empleado,
          totales: totalesNormalizados,
          sueldo_basico: empleado.sueldo_basico != null ? Number(empleado.sueldo_basico) : undefined,
          monto_viatico_standard: empleado.monto_viatico_standard
            ?? empleado.montoViaticoStandard
            ?? null,
          montoViaticoStandard: empleado.montoViaticoStandard
            ?? empleado.monto_viatico_standard
            ?? null,
          nombre: empleado.nombre || empleado.nombre_completo,
          documento: empleado.documento || empleado.numero_documento,
          fecha_nacimiento: extraerFechaNacimientoEmpleado(empleado),
          fechaNacimiento: extraerFechaNacimientoEmpleado(empleado),
          telefono: empleado.telefono,
          email: empleado.email,
          direccion: empleado.direccion,
          descuento_descanso: empleado.descuento_descanso,
          liquidaciones_planilla: Array.isArray(empleado.liquidaciones_planilla) ? empleado.liquidaciones_planilla : [],
          gratificaciones_planilla: Array.isArray(empleado.gratificaciones_planilla) ? empleado.gratificaciones_planilla : [],
        });
        return ya;
      }

      // Extraer conceptos de boleta_calculada
      const boletaData = empleado.boleta_calculada?.data;
      if (!boletaData) {
        console.warn('⚠️ Empleado sin boleta_calculada:', empleado.nombre_completo);
        return {
          ...empleado,
          totales: totalesNormalizados,
          conceptos: { ingresos: [], descuentos: [], aportes: [] }
        };
      }


      


      // Transformar conceptos al formato esperado por la vista
      const conceptosTransformados = {
        ingresos: (boletaData.dataIngresos || []).map((concepto, index) => {
          const descripcionFinal = concepto.descripcion || `Concepto de Ingreso ${index + 1}`;
          const codigo = String(concepto.codigo || concepto.codigo_plame || '');
          
          return {
            id: concepto.id || `ing_${index}`,
            codigo,
            descripcion: descripcionFinal,
            monto: parseFloat(concepto.valor || 0),
            codigoPlame: codigo,
            base_calculo: parseFloat(concepto.base_imponible || 0),
            tipo_concepto: 'ingreso',
            origen: 'cerrado',
            excluirBoletaOrdinaria: Boolean(concepto.excluir_boleta_ordinaria || concepto.excluirBoletaOrdinaria),
            origenCalculo: concepto.origen_calculo || concepto.origenCalculo || null,
            destino_ajuste: concepto.destino_ajuste || concepto.destino || null,
          };
        }),
        descuentos: (boletaData.dataDescuentos || []).map((concepto, index) => {
          console.log(`🔍 Procesando descuento ${index}:`, concepto);
          return {
            id: concepto.id || `desc_${index}`,
            codigo: concepto.codigo,
            descripcion: concepto.descripcion || `Concepto de Descuento ${index + 1}`,
            monto: parseFloat(concepto.valor || 0),
            codigoPlame: concepto.codigo,
            base_calculo: parseFloat(concepto.base_imponible || 0),
            tipo_concepto: 'descuento',
            origen: 'cerrado',
            origenCalculo: concepto.origen_calculo || concepto.origenCalculo || null,
            origen_calculo: concepto.origen_calculo || concepto.origenCalculo || null,
            exportable_plame: concepto.exportable_plame,
            absorberEn0121: Boolean(concepto.absorberEn0121),
            fusionarEn0705: Boolean(concepto.fusionarEn0705),
            excluirRem: Boolean(concepto.excluirRem || concepto.exportable_plame === false),
          };
        }),
        aportes: (boletaData.dataAportes || []).map((concepto, index) => {
          console.log(`🔍 Procesando aporte ${index}:`, concepto);
          return {
            id: concepto.id || `ap_${index}`,
            codigo: concepto.codigo,
            descripcion: concepto.descripcion || `Concepto de Aporte ${index + 1}`,
            monto: parseFloat(concepto.valor || 0),
            codigoPlame: concepto.codigo,
            base_calculo: parseFloat(concepto.base_imponible || 0),
            tipo_concepto: 'aporte',
            origen: 'cerrado'
          };
        })
      };

      // Fusionar liquidaciones y gratificaciones: visibles en ingresos/REM, no entran al neto a pagar.
      // 0406/0313 manuales (sin estar en el módulo) NO se convierten a declaración.
      const liquidacionesPlanilla = Array.isArray(empleado.liquidaciones_planilla)
        ? empleado.liquidaciones_planilla
        : [];
      const gratificacionesPlanilla = Array.isArray(empleado.gratificaciones_planilla)
        ? empleado.gratificaciones_planilla
        : [];

      const codigosLiq = new Set();
      liquidacionesPlanilla.forEach((liq) => {
        alinearCalculosLiquidacionEstaticos(liq).forEach((cc) => {
          const codigo = String(cc.codigo_plame || '');
          if (codigo) codigosLiq.add(codigo);
        });
      });

      const codigosGratiModulo = new Set();
      gratificacionesPlanilla.forEach((grat) => {
        (grat.calculos_conceptos || []).forEach((cc) => {
          const codigo = String(cc.codigo_plame || '');
          const monto = parseFloat(cc.monto) || 0;
          if (!codigo || monto <= 0) return;
          codigosGratiModulo.add(codigo);
        });
      });

      // Etiquetar líneas del snapshot que vienen del módulo (mismas códigos en gratificaciones_planilla)
      conceptosTransformados.ingresos = conceptosTransformados.ingresos.map((ing) => {
        const codigo = String(ing.codigoPlame || ing.codigo || '');
        if (ing.origenCalculo === 'liquidacion' || ing.origen_calculo === 'liquidacion') {
          return {
            ...ing,
            origenCalculo: 'liquidacion',
            excluirBoletaOrdinaria: true,
            excluir_boleta_ordinaria: true,
          };
        }
        if (codigosGratiModulo.has(codigo)) {
          return {
            ...ing,
            origenCalculo: 'gratificacion',
            excluirBoletaOrdinaria: true,
            origen: ing.origen || 'gratificacion_declaracion',
          };
        }
        if (codigosLiq.has(codigo)) {
          return {
            ...ing,
            origenCalculo: 'liquidacion',
            origen_calculo: 'liquidacion',
            excluirBoletaOrdinaria: true,
            excluir_boleta_ordinaria: true,
          };
        }
        return ing;
      });

      // Pensión de liquidación mal ubicada en ingresos (snapshots viejos) → descuentos informativos
      const ingresosSinDescLiq = [];
      (conceptosTransformados.ingresos || []).forEach((ing) => {
        if (esDescuentoLiquidacionPlanilla(ing)) {
          conceptosTransformados.descuentos.push({
            ...ing,
            descripcion: ing.descripcion || ing.concepto || ing.codigoPlame,
            tipo_concepto: ing.tipo_concepto || 'descuento_pension',
            origenCalculo: 'liquidacion',
            excluirBoletaOrdinaria: true,
            excluir_boleta_ordinaria: true,
          });
        } else {
          ingresosSinDescLiq.push(ing);
        }
      });
      conceptosTransformados.ingresos = ingresosSinDescLiq;

      const tieneDeclaracionCodigo = (codigo) =>
        conceptosTransformados.ingresos.some(
          (ing) =>
            String(ing.codigoPlame || ing.codigo || '') === codigo &&
            esConceptoDeclaracionGratificacion(ing)
        );
      const tieneLiquidacionIngresoCodigo = (codigo) =>
        conceptosTransformados.ingresos.some(
          (ing) =>
            String(ing.codigoPlame || ing.codigo || '') === codigo
            && esConceptoLiquidacionPlanilla(ing)
        );
      const tieneLiquidacionDescuentoCodigo = (codigo) =>
        conceptosTransformados.descuentos.some(
          (d) =>
            String(d.codigoPlame || d.codigo || '') === codigo
            && esDescuentoLiquidacionPlanilla(d)
        );

      // Inyectar conceptos de liquidación faltantes (informados, no neto a pagar)
      const catalogoPlameCerrada = Object.values(configuracionesPlame || []);
      liquidacionesPlanilla.forEach((liq) => {
        alinearCalculosLiquidacionEstaticos(liq).forEach((cc, idx) => {
          const codigo = String(cc.codigo_plame || '');
          const monto = parseFloat(cc.monto) || 0;
          if (!codigo || monto <= 0) return;
          const descripcionLiq = descripcionPlameParaLinea(codigo, cc, catalogoPlameCerrada);
          const filaBase = {
            id: cc.id || `liq_${codigo}_${idx}`,
            codigo,
            descripcion: descripcionLiq,
            monto,
            codigoPlame: codigo,
            base_calculo: 0,
            origen: 'liquidacion',
            excluirBoletaOrdinaria: true,
            excluir_boleta_ordinaria: true,
            origenCalculo: 'liquidacion',
            origen_calculo: 'liquidacion',
          };
          if (esCalculoConceptoLiquidacionDescuento(cc)) {
            conceptosTransformados.descuentos = conceptosTransformados.descuentos.filter((d) => {
              if (String(d.codigoPlame || d.codigo || '') !== codigo) return true;
              return !esDescuentoLiquidacionPlanilla(d);
            });
            conceptosTransformados.descuentos.push({
              ...filaBase,
              id: cc.id || `liq_desc_${codigo}`,
              tipo_concepto: 'descuento_pension',
            });
            return;
          }
          conceptosTransformados.ingresos = conceptosTransformados.ingresos.filter(
            (ing) => String(ing.codigoPlame || ing.codigo || '') !== codigo
          );
          conceptosTransformados.ingresos.push({
            ...filaBase,
            tipo_concepto: 'ingreso',
          });
        });
      });

      const codigosGratiBloqueadosPorLiq = new Set();
      liquidacionesPlanilla.forEach((liq) => {
        alinearCalculosLiquidacionEstaticos(liq).forEach((cc) => {
          const cod = String(cc.codigo_plame || '').replace(/\D/g, '').padStart(4, '0');
          if ((parseFloat(cc.monto) || 0) > 0 && (cod === '0406' || cod === '0313')) {
            codigosGratiBloqueadosPorLiq.add(cod);
          }
        });
      });

      // Inyectar 0406/0313 del módulo si faltan en el snapshot (planillas cerradas sin esos conceptos guardados)
      gratificacionesPlanilla.forEach((grat) => {
        (grat.calculos_conceptos || []).forEach((cc, idx) => {
          const codigo = String(cc.codigo_plame || '');
          const codNorm = codigo.replace(/\D/g, '').padStart(4, '0');
          const monto = parseFloat(cc.monto) || 0;
          if (!codigo || monto <= 0) return;
          if (codigosGratiBloqueadosPorLiq.has(codNorm)) return;
          if (tieneDeclaracionCodigo(codigo)) return;
          // Si ya hay línea del mismo código (p. ej. manual), no pisar: solo inyectar si no existe
          const yaExisteCodigo = conceptosTransformados.ingresos.some(
            (ing) => String(ing.codigoPlame || ing.codigo || '') === codigo
          );
          if (yaExisteCodigo) return;
          conceptosTransformados.ingresos.push({
            id: cc.id || `grati_${codigo}_${idx}`,
            codigo,
            descripcion: cc.descripcion || codigo,
            monto,
            codigoPlame: codigo,
            base_calculo: 0,
            tipo_concepto: 'ingreso',
            origen: 'gratificacion_declaracion',
            excluirBoletaOrdinaria: true,
            origenCalculo: 'gratificacion',
          });
        });
      });

      const normCerrada = normalizarConceptosSnapshotPlanillaCerrada(conceptosTransformados, {
        liquidacionesPlanilla,
        gratificacionesPlanilla,
        fechaCeseActual: empleado.fecha_cese_actual || empleado.fechaCese || empleado.fecha_cese,
        catalogoPlame: catalogoPlameCerrada,
      });
      Object.assign(conceptosTransformados, normCerrada.conceptos);
      Object.assign(totalesNormalizados, normCerrada.totales);

      // ✅ DETERMINAR TIPO DE APORTE Y AFP PARA PLANILLAS CERRADAS
      const sistemaPensionario = empleado.sistema_pensionario || empleado.tipo_aporte || 'ONP';
      const tieneAfp = sistemaPensionario === 'AFP' || empleado.afp || empleado.cuspp;
      
      
      const empleadoTransformado = {
        ...empleado,
        id: Number(empleado.empleado_id ?? empleado.id),
        empleado_id: Number(empleado.empleado_id ?? empleado.id),
        totales: totalesNormalizados,
        conceptos: conceptosTransformados,
        // Mantener también la estructura original para compatibilidad
        conceptos_separados: conceptosTransformados,
        // Asegurar nombres de campos consistentes para la vista
        nombre: empleado.nombre_completo,
        documento: empleado.numero_documento,
        fecha_nacimiento: extraerFechaNacimientoEmpleado(empleado),
        fechaNacimiento: extraerFechaNacimientoEmpleado(empleado),
        regimenLaboral:
          empleado.regimen_laboral_nombre ||
          empleado.regimen_laboral?.nombre ||
          'Sin régimen',
        sueldo_basico: empleado.sueldo_basico != null ? Number(empleado.sueldo_basico) : undefined,
        monto_viatico_standard: empleado.monto_viatico_standard
          ?? empleado.montoViaticoStandard
          ?? null,
        montoViaticoStandard: empleado.montoViaticoStandard
          ?? empleado.monto_viatico_standard
          ?? null,
        
        // ✅ CAMPOS DE CONTACTO Y EXTRAS DE PLANILLAS CERRADAS
        telefono: empleado.telefono,
        email: empleado.email,
        direccion: empleado.direccion,
        descuento_descanso: empleado.descuento_descanso,
        
        // ✅ INFORMACIÓN BANCARIA
        banco: empleado.banco || null,
        cuenta_bancaria: empleado.cuenta_bancaria || null,
        cci: empleado.cci || null,
        
        // ✅ INFORMACIÓN DE SISTEMA PENSIONARIO Y AFP (PARA EXPORTACIÓN EXCEL)
        tipoAporte: sistemaPensionario,
        afp: tieneAfp ? (empleado.afp || empleado.afp_nombre || null) : null,
        cuspp: tieneAfp ? (empleado.cuspp || empleado.afp?.cuspp || null) : null,
        tipoAfp: tieneAfp ? (empleado.tipo_afp || empleado.afp?.tipo_afp || null) : null,
        
        // ✅ NOMBRE DEL RÉGIMEN LABORAL PARA BOLETAS PDF
        regimen_laboral_nombre:
          empleado.regimen_laboral_nombre ||
          empleado.regimen_laboral?.nombre ||
          'Sin régimen',
        liquidaciones_planilla: liquidacionesPlanilla,
        gratificaciones_planilla: gratificacionesPlanilla,
      };


      return finalizarEmpleadoCerradoParaVista(empleadoTransformado);
    });
  };

  // 🔒 Función para cargar datos de planilla cerrada (modo read-only)
  const cargarDatosPlanillaCerrada = async () => {
    try {
      console.log('🔒🔒🔒 === INICIANDO CARGA DE PLANILLA CERRADA === 🔒🔒🔒');
      
      // APIs esenciales para planillas cerradas
      actualizarProgreso('⚙️ Configuración de tareos');
      await cargarConfiguracionTareo();
      actualizarProgreso('⚙️ Configuración de tareos', true);

      actualizarProgreso('🔒 Empleados Cerrados');
      const datosCompletos = await planillaCerradaService.obtenerDatosCompletos(id);
      actualizarProgreso('🔒 Empleados Cerrados', true);
      
      // 🔧 TRANSFORMAR EMPLEADOS PARA COMPATIBILIDAD CON VISTA
      console.log('🔍 DATOS ORIGINALES DESDE BACKEND:', datosCompletos.empleados?.length || 0);
      if (datosCompletos.empleados && datosCompletos.empleados.length > 0) {
        const primerEmpleadoOriginal = datosCompletos.empleados[0];
        console.log('📋 Primer empleado original desde backend:', primerEmpleadoOriginal?.nombre_completo);
        console.log('📱 Teléfono original:', primerEmpleadoOriginal?.telefono);
        console.log('📧 Email original:', primerEmpleadoOriginal?.email);
        console.log('🏠 Dirección original:', primerEmpleadoOriginal?.direccion);
        console.log('💤 Descuento descanso original:', primerEmpleadoOriginal?.descuento_descanso);
        console.log('🔧 Estructura completa original:', primerEmpleadoOriginal);
      }
      
      const empleadosTransformados = transformarEmpleadosCerradosParaVista(datosCompletos.empleados);
      
      console.log('✅ Empleados transformados para planilla cerrada:', empleadosTransformados.length);
      if (empleadosTransformados.length > 0) {
        const primerEmpleadoTransformado = empleadosTransformados[0];
        console.log('🎯 Primer empleado DESPUÉS de transformación:', primerEmpleadoTransformado?.nombre);
        console.log('📱 Teléfono DESPUÉS de transformación:', primerEmpleadoTransformado?.telefono);
        console.log('📧 Email DESPUÉS de transformación:', primerEmpleadoTransformado?.email);
        console.log('🏠 Dirección DESPUÉS de transformación:', primerEmpleadoTransformado?.direccion);
        console.log('💤 Descuento descanso DESPUÉS de transformación:', primerEmpleadoTransformado?.descuento_descanso);
      }
      
      // Actualizar estados con datos cerrados transformados
      setEmpleados(empleadosTransformados);
      setEmpleadosActivosPlanilla(empleadosTransformados);
      setEmpleadosConBoletasCalculadas(empleadosTransformados);
      
      // Compensaciones: usar las que vienen del backend al cargar planilla cerrada (tabla compensaciones)
      actualizarProgreso('💰 Compensaciones');
      if (datosCompletos.compensaciones_planilla && Array.isArray(datosCompletos.compensaciones_planilla)) {
        setCompensacionesTodosEmpleados(datosCompletos.compensaciones_planilla);
        console.log(`✅ Compensaciones cargadas desde backend (planilla cerrada): ${datosCompletos.compensaciones_planilla.length} registros`);
      } else {
      await cargarCompensacionesActuales();
      }
      actualizarProgreso('💰 Compensaciones', true);
      
      // 🏛️ CARGAR CONFIGURACIONES PLAME PARA PLANILLAS CERRADAS
      // Necesario para mostrar códigos PLAME en TareoModal y exportaciones
      console.log('🏛️ Cargando configuraciones PLAME para planilla cerrada...');
      actualizarProgreso('🏛️ Configuraciones PLAME');
      await cargarConfiguracionesPlame();
      actualizarProgreso('🏛️ Configuraciones PLAME', true);
      console.log('✅ Configuraciones PLAME cargadas para planilla cerrada');

      actualizarProgreso('🚕 Viáticos standard');
      await cargarConfiguracionViaticos();
      actualizarProgreso('🚕 Viáticos standard', true);
      
      // 🖼️ CARGAR FIRMA DE LA EMPRESA PARA PDFs
      console.log('🖼️ Cargando firma empresa...');
      await cargarFirmaEmpresa();
      console.log('✅ Carga de firma empresa completada');
      
      console.log('✅✅✅ PLANILLA CERRADA CARGADA - EMPLEADOS:', empleadosTransformados.length);
      console.log('🎯 Primer empleado transformado:', empleadosTransformados[0]);

      await sincronizarEmpleadosEnAjustePosterior();
      
    } catch (error) {
      console.error('❌ Error cargando planilla cerrada:', error);
      throw error;
    }
  };

  // 🔓 Función para cargar datos completos (planilla abierta)
  const cargarDatosCompletos = async () => {
    try {
      console.log('🔓🔓🔓 === INICIANDO CARGA COMPLETA === 🔓🔓🔓');
      
      // Pequeño delay antes de continuar
      await new Promise(resolve => setTimeout(resolve, 200));
      
      // LOTE 1: AFP, Información General
      console.log('📊 Lote 1: AFP, Información General...');
      actualizarProgreso('🏦 AFPs');
      await cargarAfps();
      actualizarProgreso('🏦 AFPs', true);
      
      actualizarProgreso('ℹ️ Información General');
      await cargarInformacionGeneral();
      actualizarProgreso('ℹ️ Información General', true);
      
      // Delay entre lotes
      await new Promise(resolve => setTimeout(resolve, 300));
      
      // LOTE 2: Fórmulas, Regímenes Laborales
      console.log('📊 Lote 2: Fórmulas, Regímenes Laborales...');
      actualizarProgreso('🧮 Fórmulas');
      await cargarFormulas();
      actualizarProgreso('🧮 Fórmulas', true);
      
      actualizarProgreso('📊 Regímenes Laborales');
      await cargarRegimenesLaborales();
      actualizarProgreso('📊 Regímenes Laborales', true);
      await cargarConstruccionCivil();
      
      // Delay entre lotes
      await new Promise(resolve => setTimeout(resolve, 300));
      
      // LOTE 3: Configuraciones PLAME, Tramos Renta
      console.log('📊 Lote 3: Configuraciones PLAME, Tramos Renta...');
      actualizarProgreso('⚙️ Configuraciones PLAME');
      await cargarConfiguracionesPlame();
      actualizarProgreso('⚙️ Configuraciones PLAME', true);
      
      actualizarProgreso('💰 Tramos de Renta');
      await cargarTramosRenta();
      actualizarProgreso('💰 Tramos de Renta', true);
      
      // Delay antes del último lote
      await new Promise(resolve => setTimeout(resolve, 300));
      
      // LOTE 4: Conceptos afectos, Conceptos estáticos, Empleados con conceptos
      console.log('📊 Lote 4: Conceptos afectos, Conceptos estáticos, Empleados con conceptos...');
      actualizarProgreso('📈 Conceptos Afectos');
      await cargarConceptosAfectos();
      actualizarProgreso('📈 Conceptos Afectos', true);

      actualizarProgreso('🏖️ Ingresos sin afectar vacaciones');
      await cargarConceptosNoAfectanVacaciones();
      actualizarProgreso('🏖️ Ingresos sin afectar vacaciones', true);

      actualizarProgreso('🧾 Conceptos licencia con goce');
      await cargarConceptosAfectanLicenciaGoceHaber();
      actualizarProgreso('🧾 Conceptos licencia con goce', true);
      
      actualizarProgreso('🔧 Conceptos Estáticos');
      await cargarConceptosEstaticos();
      actualizarProgreso('🔧 Conceptos Estáticos', true);
      
      actualizarProgreso('⚙️ Configuración de Tareos');
      await cargarConfiguracionTareo();
      actualizarProgreso('⚙️ Configuración de Tareos', true);

      actualizarProgreso('🎉 Feriados pago doble');
      await cargarFeriadosPagoDoble();
      actualizarProgreso('🎉 Feriados pago doble', true);

      actualizarProgreso('😴 Descanso laborado (0107)');
      await cargarConfiguracionDescansoLaborado();
      actualizarProgreso('😴 Descanso laborado (0107)', true);

      actualizarProgreso('🌙 Tasa nocturna');
      await cargarConfiguracionTasaNocturna();
      actualizarProgreso('🌙 Tasa nocturna', true);

      actualizarProgreso('🚕 Viáticos standard');
      await cargarConfiguracionViaticos();
      actualizarProgreso('🚕 Viáticos standard', true);
      
      actualizarProgreso('👥 Empleados con Conceptos');
      await cargarEmpleadosConConceptos();
      actualizarProgreso('👥 Empleados con Conceptos', true);

      console.log('✅✅✅ CARGA COMPLETA FINALIZADA');
      
    } catch (error) {
      console.error('❌ Error en carga completa:', error);
      throw error;
    }
  };

  // Función para finalizar la carga común
  const finalizarCarga = async () => {
    try {
      console.log('🔍 FASE FINAL: Completando carga...');
      
      // Finalizar progreso
      const tiempoTotal = Date.now() - cargandoProgreso.tiempoInicio;
      console.log(`✅✅✅ CARGA COMPLETADA EN ${tiempoTotal}ms`);
      console.log(`📊 APIs cargadas: ${cargandoProgreso.apisCompletadas.length}/${cargandoProgreso.total}`);
      
      // Limpiar progreso
      setCargandoProgreso(prev => ({
        ...prev,
        apiActual: '',
        progreso: prev.total
      }));
      
      setLoading(false);
      
    } catch (error) {
      console.error('❌ Error finalizando carga:', error);
      throw error;
    }
  };
      
  // Función para manejar errores de carga
  const manejarErrorCarga = () => {
      // Error en progreso
      setCargandoProgreso(prev => ({
        ...prev,
        apiActual: 'Error en la carga',
        progreso: 0
      }));
      
      setLoading(false);
  };

  // Función para cargar datos reales de la planilla desde el backend
  const cargarDatosPlanilla = async () => {
    try {
      console.log('🔄 === INICIANDO CARGA DE DATOS REALES DE LA PLANILLA ===');
      console.log('🆔 ID de planilla a cargar:', id);
      
      const response = await reintentarConBackoff(() => planillaService.obtenerPlanilla(id));
      console.log('📨📨📨 RESPUESTA DEL SERVICIO PLANILLA:', response);
      console.log('✅ Response.success:', response?.success);
      console.log('📋 Response.data:', response?.data);
      console.log('📊 Response.planilla:', response?.planilla);
      
      if (response.success && response.data) {
        const planillaReal = response.data;
        console.log('✅✅✅ PLANILLA REAL OBTENIDA:', planillaReal);
        console.log('📊 Detalles de la planilla real:');
        console.log('  - ID:', planillaReal.id);
        console.log('  - Nombre:', planillaReal.nombre);
        console.log('  - Periodo:', planillaReal.periodo);
        console.log('  - Estado:', planillaReal.estado);
        console.log('  - Fecha Inicio:', planillaReal.fecha_inicio);
        console.log('  - Fecha Fin:', planillaReal.fecha_fin);
        
        // 🔍 DEBUG ADICIONAL: Verificar el formato de las fechas
        console.log('🔍 ANÁLISIS DE FECHAS EN PLANILLA DETALLE:');
        console.log('  - Tipo fecha_inicio:', typeof planillaReal.fecha_inicio);
        console.log('  - Tipo fecha_fin:', typeof planillaReal.fecha_fin);
        console.log('  - Fecha inicio parseada:', new Date(planillaReal.fecha_inicio));
        console.log('  - Fecha fin parseada:', new Date(planillaReal.fecha_fin));
        console.log('  - Mes fecha inicio (0-11):', new Date(planillaReal.fecha_inicio).getMonth());
        console.log('  - Mes fecha fin (0-11):', new Date(planillaReal.fecha_fin).getMonth());
        console.log('  - ¿Son el mismo mes?:', new Date(planillaReal.fecha_inicio).getMonth() === new Date(planillaReal.fecha_fin).getMonth());
        console.log('  - Descripción:', planillaReal.descripcion);
        console.log('  - Empresa ID:', planillaReal.empresa_id);
        console.log('  - Total Empleados:', planillaReal.total_empleados);
        
        // Actualizar el estado con los datos reales
        console.log('🔄 Guardando planilla real en el estado...');
        setPlanillaReal(planillaReal);
        setPlanilla((prev) => ({
          ...prev,
          ...planillaReal,
          periodo: planillaReal.periodo || planillaReal.nombre || prev.periodo,
        }));
        
        // Detectar si la planilla está cerrada
        const estaCerrada = planillaReal.estado === 'cerrada';
        console.log('🔒 Estado de planilla:', planillaReal.estado, '| Está cerrada:', estaCerrada);
        setPlanillaCerrada(estaCerrada);
        
        console.log('📊 DATOS REALES DE PLANILLA CARGADOS Y GUARDADOS EXITOSAMENTE');
        
        // Cargar tareos del período de la planilla real
        console.log('🔄 Iniciando carga de tareos basándose en la planilla real...');
        await cargarTareosPorPeriodo(planillaReal);
        
        return planillaReal;
    } else {
        console.log('⚠️ No se encontraron datos de planilla o respuesta inválida');
        console.log('❌ Response completo:', response);
        return null;
      }
    } catch (error) {
      console.error('❌ Error al cargar datos de planilla:', error);
      console.error('❌ Error stack:', error.stack);
      console.error('❌ Error message:', error.message);
      return null;
    }
  };

  // Función para cargar AFP
  const cargarAfps = async () => {
    try {
      const response = await afpService.obtenerAfps();
      
      if (response.success && response.data) {
        setAfps(response.data);
      } else {
        setAfps([]);
      }
    } catch (error) {
      console.error('❌ Error al cargar AFP:', error);
      setAfps([]);
    }
  };

  const cargarFeriadosPagoDoble = async () => {
    try {
      if (!selectedCompany?.id) {
        setFeriadosPagoDobleConfig([]);
        return;
      }
      const response = await feriadosPagoDobleService.obtenerFeriados(selectedCompany.id);
      if (response.success && response.data) {
        setFeriadosPagoDobleConfig(response.data);
      } else {
        setFeriadosPagoDobleConfig([]);
      }
    } catch (error) {
      console.error('❌ Error al cargar feriados con pago doble:', error);
      setFeriadosPagoDobleConfig([]);
    }
  };

  const cargarConfiguracionDescansoLaborado = async () => {
    try {
      if (!selectedCompany?.id) {
        setConfiguracionDescansoLaboradoConfig({ pago_doble: false });
        return;
      }
      const response = await configuracionDescansoLaboradoService.obtenerConfiguracion(selectedCompany.id);
      if (response.success && response.data) {
        setConfiguracionDescansoLaboradoConfig({
          pago_doble: Boolean(response.data.pago_doble),
        });
      } else {
        setConfiguracionDescansoLaboradoConfig({ pago_doble: false });
      }
    } catch (error) {
      console.error('❌ Error al cargar configuración de descanso laborado:', error);
      setConfiguracionDescansoLaboradoConfig({ pago_doble: false });
    }
  };

  const cargarConfiguracionTasaNocturna = async () => {
    try {
      if (!selectedCompany?.id) {
        setConfiguracionTasaNocturnaConfig({ activo: false, calcular_en_planilla: true, horas_tasa_nocturna: 8 });
        return;
      }
      const response = await configuracionTasaNocturnaService.obtenerConfiguracion(selectedCompany.id);
      if (response.success && response.data) {
        setConfiguracionTasaNocturnaConfig(response.data);
        logDiagnosticoBonificacionNocturna('Config cargada desde API (PlanillaDetalle)', {
          empresa_id: selectedCompany.id,
          config: response.data,
        });
      } else {
        setConfiguracionTasaNocturnaConfig({ activo: false, calcular_en_planilla: true, horas_tasa_nocturna: 8 });
        logDiagnosticoBonificacionNocturna('Config API sin datos → desactivada por defecto', {
          empresa_id: selectedCompany.id,
          response,
        });
      }
    } catch (error) {
      console.error('❌ Error al cargar configuración de tasa nocturna:', error);
      setConfiguracionTasaNocturnaConfig({ activo: false, calcular_en_planilla: true, horas_tasa_nocturna: 8 });
    }
  };

  // Función para cargar conceptos afectos a tareos para la empresa
  const cargarConceptosAfectos = async () => {
    try {
      if (!selectedCompany?.id) {
        console.log('⚠️ No hay empresa seleccionada para cargar conceptos afectos');
        setConceptosAfectos([]);
        return;
      }

      const empresaId = selectedCompany.id;
      const response = await conceptosAfectosTareosService.obtenerConceptosAfectos(empresaId);
      
      if (response.success && response.data) {
        setConceptosAfectos(response.data);
      } else {
        setConceptosAfectos([]);
      }
    } catch (error) {
      console.error('❌ Error al cargar conceptos afectos:', error);
      setConceptosAfectos([]);
    }
  };

  const cargarConceptosNoAfectanVacaciones = async () => {
    try {
      if (!selectedCompany?.id) {
        setConceptosNoAfectanVacaciones([]);
        return;
      }
      const empresaId = selectedCompany.id;
      const response = await conceptosNoAfectanVacacionesService.obtenerConceptos(empresaId);
      if (response.success && response.data) {
        setConceptosNoAfectanVacaciones(response.data);
      } else {
        setConceptosNoAfectanVacaciones([]);
      }
    } catch (error) {
      console.error('❌ Error al cargar conceptos que no afectan vacaciones:', error);
      setConceptosNoAfectanVacaciones([]);
    }
  };

  const cargarConceptosAfectanLicenciaGoceHaber = async () => {
    try {
      if (!selectedCompany?.id) {
        setConceptosAfectanLicenciaGoceHaber([]);
        return;
      }
      const empresaId = selectedCompany.id;
      const response = await conceptosAfectanLicenciaGoceHaberService.obtenerConceptos(empresaId);
      if (response.success && response.data) {
        setConceptosAfectanLicenciaGoceHaber(response.data);
      } else {
        setConceptosAfectanLicenciaGoceHaber([]);
      }
    } catch (error) {
      console.error('❌ Error al cargar conceptos licencia con goce de haber:', error);
      setConceptosAfectanLicenciaGoceHaber([]);
    }
  };

  // Función para cargar fórmulas
  const cargarFormulas = async () => {
    try {
      const response = await formulaService.obtenerFormulas();
      
      if (response.success && response.data) {
        // Manejar tanto response.data como response.data.data (para consistencia con EmpleadoForm)
        const formulasData = Array.isArray(response.data.data) ? response.data.data : 
                           Array.isArray(response.data) ? response.data : [];
        
        setFormulas(formulasData);
      } else {
        setFormulas([]);
      }
    } catch (error) {
      console.error('❌ Error al cargar fórmulas:', error);
      setFormulas([]);
    }
  };

  // Función para cargar información general
  const cargarInformacionGeneral = async () => {
    try {
      const response = await informacionGeneralService.obtenerInformacionActual();
      setInformacionGeneral(response);
    } catch (error) {
      console.error('❌ Error al cargar información general:', error);
      setInformacionGeneral(null);
    }
  };

  // Función para cargar configuraciones PLAME
  const cargarConfiguracionesPlame = async () => {
    try {
      const response = await plameConfiguracionService.obtenerConfiguraciones({ per_page: 1000 });
      
      if (response.success && response.data) {
        const configuraciones = Array.isArray(response.data.data) ? response.data.data : 
                              Array.isArray(response.data) ? response.data : [];
        
        setConfiguracionesPlame(configuraciones);
      } else {
        setConfiguracionesPlame([]);
      }
    } catch (error) {
      console.error('❌ Error al cargar configuraciones PLAME:', error);
      setConfiguracionesPlame([]);
    }
  };

  // Función para cargar regímenes laborales
  const cargarConstruccionCivil = async () => {
    try {
      const empresaId = selectedCompany?.id;
      if (!empresaId) return;
      const [ctx, fichas] = await Promise.all([
        construccionCivilService.contexto(empresaId),
        construccionCivilService.fichas(empresaId),
      ]);
      setConstruccionCivilDatos({
        parametros: ctx.data?.parametros || [],
        plame: ctx.data?.plame || [],
        obras: ctx.data?.obras || [],
        fichas: fichas.data || [],
      });
    } catch (error) {
      console.error('Error al cargar construcción civil:', error);
    }
  };

  const cargarRegimenesLaborales = async () => {
    try {
      const response = await regimenLaboralService.getAll();
      
      if (response.success && response.data) {
        const regimenes = Array.isArray(response.data) ? response.data : [];
        setRegimenesLaborales(regimenes);
      } else {
        setRegimenesLaborales([]);
      }
    } catch (error) {
      console.error('❌ Error al cargar regímenes laborales:', error);
      setRegimenesLaborales([]);
    }
  };

  // Función para cargar tramos de renta
  const cargarTramosRenta = async () => {
    try {
      const response = await tramoRentaService.obtenerTramosRenta();
      
      if (response.success && response.data) {
        const tramos = Array.isArray(response.data) ? response.data : [];
        setTramosRenta(tramos);
      } else {
        setTramosRenta([]);
      }
    } catch (error) {
      console.error('❌ Error al cargar tramos de renta:', error);
      setTramosRenta([]);
    }
  };

  // Función para cargar conceptos estáticos
  const cargarConceptosEstaticos = async () => {
    try {
      console.log('🔄 === INICIANDO CARGA DE CONCEPTOS ESTÁTICOS ===');
      
      if (!selectedCompany?.id) {
        console.log('⚠️ No hay empresa seliccionada para cargar conceptos estáticos');
        setConceptosEstaticos([]);
        return;
      }

      const response = await reintentarConBackoff(() => 
        conceptosEstaticosService.obtenerConceptosEstaticos(selectedCompany.id)
      );
      
      console.log('📨📨📨 RESPUESTA CONCEPTOS ESTÁTICOS:', response);
      console.log('✅ Response.success:', response?.success);
      console.log('📋 Response.data:', response?.data);
      console.log('🔢 Response.data es array?:', Array.isArray(response?.data));
      console.log('📊 Response.data.length:', response?.data?.length);
      
      if (response.success && response.data) {
        const conceptos = Array.isArray(response.data) ? response.data : [];
        setConceptosEstaticos(conceptos);
        console.log(`✅✅✅ CONCEPTOS ESTÁTICOS CARGADOS: ${conceptos.length} conceptos`);
        return conceptos;
      } else {
        console.log('⚠️ No se encontraron conceptos estáticos - Response:', response);
        setConceptosEstaticos([]);
        return [];
      }
    } catch (error) {
      console.error('❌ Error al cargar conceptos estáticos:', error);
      setConceptosEstaticos([]);
      return [];
    }
  };

  // Función para cargar configuración de tareos
  const cargarConfiguracionTareo = async () => {
    try {
      console.log('🔄 === INICIANDO CARGA DE CONFIGURACIÓN DE TAREOS ===');
      
      if (!selectedCompany?.id) {
        console.log('⚠️ No hay empresa seleccionada para cargar configuración de tareos');
        setConfiguracionTareo(null);
        return;
      }

      const response = await reintentarConBackoff(() => 
        configuracionTareoService.obtenerConfiguracionTareo(selectedCompany.id)
      );
      
      console.log('📨📨📨 RESPUESTA CONFIGURACIÓN TAREOS:', response);
      console.log('✅ Response.success:', response?.success);
      console.log('📋 Response.data:', response?.data);
      
      if (response.success && response.data) {
        setConfiguracionTareo(response.data);
        console.log(`✅✅✅ CONFIGURACIÓN DE TAREOS CARGADA:`, response.data);
        return response.data;
      } else {
        console.log('⚠️ No se encontró configuración de tareos - Response:', response);
        // Configuración por defecto
        const configDefault = {
          tipo_tareo: 2,
          descontar_descansos: true,
          modo_horas_simple: 'reales',
          es_simple: false,
          es_detallado: true,
          es_por_horas: false
        };
        setConfiguracionTareo(configDefault);
        return configDefault;
      }
    } catch (error) {
      console.error('❌ Error al cargar configuración de tareos:', error);
      // Configuración por defecto en caso de error
      const configDefault = {
        tipo_tareo: 2,
        descontar_descansos: true,
        modo_horas_simple: 'reales',
        es_simple: false,
        es_detallado: true,
        es_por_horas: false
      };
      setConfiguracionTareo(configDefault);
      return configDefault;
    }
  };

  const cargarConfiguracionViaticos = async () => {
    try {
      if (!selectedCompany?.id) {
        setViaticosConfig(null);
        return null;
      }
      const response = await reintentarConBackoff(() =>
        configuracionViaticosStandardService.obtenerConfiguracion(selectedCompany.id)
      );
      if (response?.success && response?.data) {
        setViaticosConfig(response.data);
        return response.data;
      }
      setViaticosConfig(null);
      return null;
    } catch (error) {
      console.error('Error al cargar configuración de viáticos:', error);
      setViaticosConfig(null);
      return null;
    }
  };

  // Función para cargar empleados con conceptos por empresa CON OPTIMIZACIÓN
  const cargarEmpleadosConConceptos = async () => {
    try {
      console.log('🔄 === INICIANDO CARGA DE EMPLEADOS CON CONCEPTOS (OPTIMIZADA) ===');
      console.log('📋 Estado actual de empleadosConConceptos:', empleadosConConceptos);
      console.log('📋 Longitud actual:', empleadosConConceptos.length);
      
      // Usar la empresa seleccionada del contexto
      const empresaId = selectedCompany.id;
      const planillaId = parseInt(id); // ID de la planilla actual
      
      console.log('🏢 selectedCompany completo:', selectedCompany);
      console.log('🏢 Empresa ID desde contexto:', empresaId);
      console.log('🏢 Empresa nombre:', selectedCompany.name);
      console.log('📋 Planilla ID:', planillaId);
      
      // 🚀 PASO 1: VERIFICAR SI YA EXISTEN CONCEPTOS GUARDADOS EN BD
      console.log('🔍 === VERIFICANDO CONCEPTOS EXISTENTES EN BD ===');
      
      try {
        const verificacion = await consideracionesConceptosService.verificarConceptosExistentes(planillaId);
        
        if (verificacion.data.tiene_conceptos) {
          // CASO A: Ya existen conceptos guardados → Cargar datos completos + conceptos optimizados
          console.log('✅ === DATOS EXISTENTES ENCONTRADOS EN BD ===');
          console.log('📊 Información de datos existentes:', {
            ultima_actualizacion: verificacion.data.ultima_actualizacion,
            conteo_conceptos: verificacion.data.conteo_conceptos
          });
          
          // PASO 1: Cargar datos COMPLETOS de empleados del service original
          console.log('📞 OBTENIENDO DATOS COMPLETOS DE EMPLEADOS DEL SERVICE ORIGINAL...');
          const responseEmpleados = await reintentarConBackoff(() => 
            empleadoConceptoService.obtenerEmpleadosConConceptosPorEmpresa(empresaId)
          );
          
          if (!responseEmpleados.success || !responseEmpleados.data) {
            throw new Error('Error obteniendo datos completos de empleados del service original');
          }
          
          const empleadosCompletos = Array.isArray(responseEmpleados.data) ? responseEmpleados.data : [];
          console.log(`📋 Empleados completos obtenidos: ${empleadosCompletos.length}`);
          
          // PASO 2: Obtener SOLO conceptos optimizados del backend
          console.log('📥 OBTENIENDO CONCEPTOS OPTIMIZADOS DEL BACKEND...');
          const datosGuardados = await consideracionesConceptosService.obtenerDatosParaCalculo(planillaId);
          const conceptosOptimizados = datosGuardados.data.empleados;
          
          console.log('🎯 Conceptos optimizados obtenidos:', conceptosOptimizados.length);
          console.log('📊 Estadísticas de BD:', datosGuardados.data.estadisticas);
          
          // PASO 3: COMBINAR datos completos + conceptos optimizados
          console.log('🔄 COMBINANDO DATOS COMPLETOS + CONCEPTOS OPTIMIZADOS...');
          const empleadosHibridos = empleadosCompletos.map(empleadoCompleto => {
            // Buscar conceptos optimizados para este empleado
            const conceptosEmpleado = conceptosOptimizados.find(emp => emp.id === empleadoCompleto.id);
            
            if (conceptosEmpleado) {
              // Ajustes (Jatsa / consideraciones) se añaden a la ficha; no la reemplazan.
              const conceptosCombinados = [
                ...(conceptosEmpleado.conceptos.ingresos || []),
                ...(conceptosEmpleado.conceptos.descuentos || []),
                ...(conceptosEmpleado.conceptos.aportes || [])
              ];
              // Liquidaciones del periodo que se incluyen en planilla (solo planilla abierta; backend las envía en datos-calculo)
              const liquidacionesPlanilla = Array.isArray(conceptosEmpleado.liquidaciones_planilla)
                ? conceptosEmpleado.liquidaciones_planilla
                : [];
              const gratificacionesPlanilla = Array.isArray(conceptosEmpleado.gratificaciones_planilla)
                ? conceptosEmpleado.gratificaciones_planilla
                : [];
              
              console.log(`🔗 Empleado ${empleadoCompleto.nombre_completo}: ${conceptosCombinados.length} conceptos optimizados aplicados${liquidacionesPlanilla.length ? `, ${liquidacionesPlanilla.length} liquidación(es) en planilla` : ''}${gratificacionesPlanilla.length ? `, ${gratificacionesPlanilla.length} gratificación(es) en declaración` : ''}`);
              
              return {
                ...empleadoCompleto, // ✅ TODOS los datos originales (historial, etc.)
                // Si hay ajuste interna de 0121, pisa sueldo_interno para el cálculo
                sueldo_interno: (() => {
                  const c0121 = (conceptosEmpleado.conceptos?.ingresos || []).find(
                    (c) => String(c.codigo || c.codigo_plame || '') === '0121'
                  );
                  if (
                    c0121
                    && destinoAplicaInterna(c0121.destino_ajuste || 'plame')
                    && c0121.monto_interna != null
                  ) {
                    return Number(c0121.monto_interna);
                  }
                  return empleadoCompleto.sueldo_interno;
                })(),
                conceptos: fusionarConceptosFichaConAjustes(
                  empleadoCompleto.conceptos,
                  conceptosCombinados,
                ),
                liquidaciones_planilla: liquidacionesPlanilla, // ✅ Liquidaciones con incluir_en_planilla del periodo
                gratificaciones_planilla: gratificacionesPlanilla,
              };
            } else {
              // Mantener conceptos originales si no hay optimizados; sin liquidaciones del periodo
              console.log(`⚠️ Empleado ${empleadoCompleto.nombre_completo}: usando conceptos originales`);
              return {
                ...empleadoCompleto,
                liquidaciones_planilla: [],
                gratificaciones_planilla: [],
              };
            }
          });
          
          console.log(`✅ DATOS HÍBRIDOS CREADOS: ${empleadosHibridos.length} empleados con datos completos + conceptos optimizados`);
          
          setEmpleadosConConceptos(empleadosHibridos);
          console.log('✅ EMPLEADOS CARGADOS CON HÍBRIDO (DATOS COMPLETOS + CONCEPTOS BD)');
          
          return empleadosHibridos;
          
        } else {
          // CASO B: No existen conceptos → Cargar desde empleadoConceptoService y enviar a BD
          console.log('❌ === NO EXISTEN DATOS EN BD - CARGANDO DATOS ORIGINALES ===');
          
          console.log('📞 LLAMANDO A empleadoConceptoService.obtenerEmpleadosConConceptosPorEmpresa...');
          const response = await reintentarConBackoff(() => 
            empleadoConceptoService.obtenerEmpleadosConConceptosPorEmpresa(empresaId)
          );
          
          console.log('📨 RESPUESTA COMPLETA DEL SERVICIO:', response);
          console.log('✅ Response.success:', response?.success);
          console.log('📊 Response.data.length:', response?.data?.length);
          
          if (response.success && response.data) {
            const empleados = Array.isArray(response.data) ? response.data : [];
            console.log(`📋 Empleados obtenidos del servicio original: ${empleados.length}`);
            
            // Establecer empleados en el estado
            setEmpleadosConConceptos(empleados);
            
            // 🚀 ENVIAR CONCEPTOS AL BACKEND PARA OPTIMIZACIÓN FUTURA
            console.log('💾 === ENVIANDO CONCEPTOS AL BACKEND PARA GUARDAR ===');
            
            try {
              const resultadoGuardado = await consideracionesConceptosService.guardarConceptosPlanilla(planillaId, empleados);
              console.log('✅ CONCEPTOS GUARDADOS EN BD EXITOSAMENTE:', resultadoGuardado.data);
            } catch (errorGuardado) {
              console.error('⚠️ Error guardando conceptos en BD (no crítico):', errorGuardado);
              // No es crítico si falla el guardado, continuamos con los datos originales
            }
            
            console.log('✅ EMPLEADOS CARGADOS DESDE SERVICIO ORIGINAL');
            return empleados;
            
          } else {
            console.error('❌ Error en respuesta del servicio original');
            setEmpleadosConConceptos([]);
            return [];
          }
        }
        
      } catch (errorVerificacion) {
        console.error('⚠️ Error en verificación de BD, usando flujo original:', errorVerificacion);
        
        // FALLBACK: Si falla la verificación, usar el flujo original
        console.log('🔄 === FALLBACK - USANDO FLUJO ORIGINAL ===');
        
        const response = await reintentarConBackoff(() => 
          empleadoConceptoService.obtenerEmpleadosConConceptosPorEmpresa(empresaId)
        );
        
        if (response.success && response.data) {
          const empleados = Array.isArray(response.data) ? response.data : [];
          setEmpleadosConConceptos(empleados);
          return empleados;
        } else {
          setEmpleadosConConceptos([]);
          return [];
        }
      }
      
    } catch (error) {
      console.error('❌ Error general en cargarEmpleadosConConceptos:', error);
      setEmpleadosConConceptos([]);
      return [];
    }
  };

  // Función para cargar estadísticas de la empresa
  const cargarEstadisticasEmpresa = async () => {
    try {
      console.log('🔄 === INICIANDO CARGA DE ESTADÍSTICAS DE EMPRESA ===');
      
      if (!selectedCompany?.id) {
        console.log('⚠️ No hay empresa seleccionada para cargar estadísticas');
        setEstadisticasEmpresa(null);
        return;
      }

      const response = await empleadoConceptoService.obtenerEstadisticasEmpresa(selectedCompany.id);
      
      if (response.success && response.data) {
        setEstadisticasEmpresa(response.data);
        console.log('✅ Estadísticas de empresa cargadas exitosamente');
        console.log('📊 Estadísticas:', response.data);
        
        return response.data;
      } else {
        console.log('⚠️ No se encontraron estadísticas - Response:', response);
        setEstadisticasEmpresa(null);
        return null;
      }
    } catch (error) {
      console.error('❌ Error al cargar estadísticas de empresa:', error);
      setEstadisticasEmpresa(null);
      return null;
    }
  };

  // 📅 FUNCIÓN PARA CALCULAR FECHAS EXTENDIDAS (SEMANAS COMPLETAS)
  const calcularFechasSemanasCompletas = (fechaInicio, fechaFin) => {
    try {
      console.log('🔄 === CALCULANDO FECHAS DE SEMANAS COMPLETAS ===');
      console.log('📅 Fechas originales:', { fechaInicio, fechaFin });
      
      // Crear objetos Date a partir de las fechas
      const fechaInicioDate = new Date(fechaInicio + 'T00:00:00');
      const fechaFinDate = new Date(fechaFin + 'T00:00:00');
      
      console.log('📅 Fechas como Date objects:', { fechaInicioDate, fechaFinDate });
      
      // Calcular el lunes de la semana donde cae la fecha de inicio
      // getDay(): 0=domingo, 1=lunes, 2=martes, ..., 6=sábado
      const diaSemanaInicio = fechaInicioDate.getDay();
      const diasHastaLunes = diaSemanaInicio === 0 ? 6 : (diaSemanaInicio - 1); // Si es domingo, retroceder 6 días
      
      const lunesInicio = new Date(fechaInicioDate);
      lunesInicio.setDate(fechaInicioDate.getDate() - diasHastaLunes);
      
      // Calcular el domingo de la semana donde cae la fecha de fin
      const diaSemanaFin = fechaFinDate.getDay();
      const diasHastaDomingo = diaSemanaFin === 0 ? 0 : (7 - diaSemanaFin); // Si es domingo, no mover
      
      const domingoFin = new Date(fechaFinDate);
      domingoFin.setDate(fechaFinDate.getDate() + diasHastaDomingo);
      
      // Formatear las fechas extendidas
      const fechaInicioExtendida = lunesInicio.toISOString().split('T')[0];
      const fechaFinExtendida = domingoFin.toISOString().split('T')[0];
      
      console.log('📅 Fechas extendidas calculadas:');
      console.log(`  • Lunes inicio: ${fechaInicioExtendida} (retrocedió ${diasHastaLunes} días)`);
      console.log(`  • Domingo fin: ${fechaFinExtendida} (avanzó ${diasHastaDomingo} días)`);
      console.log(`  • Rango original: ${fechaInicio} a ${fechaFin}`);
      console.log(`  • Rango extendido: ${fechaInicioExtendida} a ${fechaFinExtendida}`);
      
      return {
        fechaInicioExtendida,
        fechaFinExtendida,
        fechaInicioOriginal: fechaInicio,
        fechaFinOriginal: fechaFin,
        diasRetrocedidos: diasHastaLunes,
        diasAvanzados: diasHastaDomingo
      };
      
    } catch (error) {
      console.error('❌ Error calculando fechas de semanas completas:', error);
      // En caso de error, devolver las fechas originales
      return {
        fechaInicioExtendida: fechaInicio,
        fechaFinExtendida: fechaFin,
        fechaInicioOriginal: fechaInicio,
        fechaFinOriginal: fechaFin,
        diasRetrocedidos: 0,
        diasAvanzados: 0
      };
    }
  };

  /** Tareos/autorizaciones del periodo (retorno inmediato; evita depender de setState en el mismo tick). */
  const fetchTareosAutorizacionesParaPlanilla = async (planillaReal) => {
    if (!planillaReal || !selectedCompany?.id) {
      return { tareos: [], autorizaciones: [] };
    }
    const fechaInicioOriginal = planillaReal.fecha_inicio;
    const fechaFinOriginal = planillaReal.fecha_fin;
    const fechaInicioBase = formatDateToYYYYMMDD(fechaInicioOriginal);
    const fechaFinBase = formatDateToYYYYMMDD(fechaFinOriginal);
    const fechasExtendidas = calcularFechasSemanasCompletas(fechaInicioBase, fechaFinBase);
    const fechaInicio = fechasExtendidas.fechaInicioExtendida;
    const fechaFin = fechasExtendidas.fechaFinExtendida;
    const empresaId = selectedCompany.id;
    if (!fechaInicio || !fechaFin) {
      return { tareos: [], autorizaciones: [] };
    }
    const responseTareos = await reintentarConBackoff(() =>
      tareoService.obtenerTareosPorPeriodo(fechaInicio, fechaFin, empresaId)
    );
    if (!responseTareos?.success || !responseTareos.data) {
      return { tareos: [], autorizaciones: [] };
    }
    const tareos = Array.isArray(responseTareos.data) ? responseTareos.data : [];
    const autorizacionesBrutas = Array.isArray(responseTareos.autorizaciones)
      ? responseTareos.autorizaciones
      : [];
    const planIni = fechaInicioBase;
    const planFin = fechaFinBase;
    const autorizaciones = autorizacionesBrutas.filter((a) => {
      const authIni = a.fecha_inicio
        ? typeof a.fecha_inicio === 'string'
          ? a.fecha_inicio.split('T')[0]
          : formatDateToYYYYMMDD(a.fecha_inicio)
        : '';
      const authFin =
        (a.fecha_fin
          ? typeof a.fecha_fin === 'string'
            ? a.fecha_fin.split('T')[0]
            : formatDateToYYYYMMDD(a.fecha_fin)
          : authIni) || authIni;
      if (!authIni || !planIni || !planFin) return false;
      return authIni <= planFin && authFin >= planIni;
    });
    return { tareos, autorizaciones };
  };

  // Función para cargar tareos por período basándose en la planilla real
  const cargarTareosPorPeriodo = async (planillaReal) => {
    try {
      console.log('🔄 === INICIANDO CARGA DE TAREOS POR PERÍODO ===');
      console.log('📋 Planilla real recibida:', planillaReal);
      
      if (!planillaReal) {
        console.log('⚠️ No se recibió planilla real para cargar tareos');
        setTareosPeriodo([]);
        setResumenTareos(null);
        setAutorizacionesPeriodo([]);
        return;
      }

      if (!selectedCompany?.id) {
        console.log('⚠️ No hay empresa seleccionada para cargar tareos');
        setTareosPeriodo([]);
        setResumenTareos(null);
        setAutorizacionesPeriodo([]);
        return;
      }

      // Formatear fechas a formato yyyy-mm-dd para el API
      const fechaInicioOriginal = planillaReal.fecha_inicio;
      const fechaFinOriginal = planillaReal.fecha_fin;
      const fechaInicioBase = formatDateToYYYYMMDD(fechaInicioOriginal);
      const fechaFinBase = formatDateToYYYYMMDD(fechaFinOriginal);
      
      // 📅 CALCULAR FECHAS EXTENDIDAS PARA SEMANAS COMPLETAS
      const fechasExtendidas = calcularFechasSemanasCompletas(fechaInicioBase, fechaFinBase);
      
      // Usar las fechas extendidas para la API de tareos
      const fechaInicio = fechasExtendidas.fechaInicioExtendida;
      const fechaFin = fechasExtendidas.fechaFinExtendida;
      const empresaId = selectedCompany.id;

      console.log('📅 Período para API de tareos (EXTENDIDO A SEMANAS COMPLETAS):');
      console.log('  - Fecha Inicio Planilla:', fechaInicioOriginal);
      console.log('  - Fecha Fin Planilla:', fechaFinOriginal);
      console.log('  - Fecha Inicio Base:', fechaInicioBase);
      console.log('  - Fecha Fin Base:', fechaFinBase);
      console.log('  - 🔄 Fecha Inicio EXTENDIDA (Lunes):', fechaInicio);
      console.log('  - 🔄 Fecha Fin EXTENDIDA (Domingo):', fechaFin);
      console.log('  - Días retrocedidos:', fechasExtendidas.diasRetrocedidos);
      console.log('  - Días avanzados:', fechasExtendidas.diasAvanzados);
      console.log('🏢 Empresa ID:', empresaId);

      if (!fechaInicio || !fechaFin) {
        console.log('⚠️ La planilla no tiene fechas válidas de inicio o fin después del formateo');
        console.log('❌ fechaInicio formateada:', fechaInicio);
        console.log('❌ fechaFin formateada:', fechaFin);
        setTareosPeriodo([]);
        setResumenTareos(null);
        setAutorizacionesPeriodo([]);
        return;
      }

      console.log('📞📞📞 LLAMANDO A fetchTareosAutorizacionesParaPlanilla...');
      const { tareos, autorizaciones } = await fetchTareosAutorizacionesParaPlanilla(planillaReal);
      console.log('📊 Total tareos encontrados:', tareos.length);
      console.log('📊 Total autorizaciones en periodo planilla:', autorizaciones.length);
      setTareosPeriodo(tareos);
      setAutorizacionesPeriodo(autorizaciones);

      // Pequeño delay antes de cargar el resumen para evitar throttling
      await new Promise(resolve => setTimeout(resolve, 200));

      // Cargar resumen de tareos del período
      console.log('📞📞📞 LLAMANDO A tareoService.obtenerResumenPorPeriodo...');
      try {
        const responseResumen = await reintentarConBackoff(() =>
          tareoService.obtenerResumenPorPeriodo(fechaInicio, fechaFin, empresaId)
        );
        
        console.log('📨📨📨 RESPUESTA RESUMEN TAREOS:', responseResumen);
        
        if (responseResumen.success && responseResumen.data) {
          console.log('✅✅✅ RESUMEN DE TAREOS CARGADO EXITOSAMENTE');
          setResumenTareos(responseResumen.data);
        } else {
          console.log('⚠️ No se pudo obtener resumen de tareos');
          setResumenTareos(null);
        }
      } catch (error) {
        console.error('❌ Error al cargar resumen de tareos (no crítico):', error);
        setResumenTareos(null);
      }

      console.log('🏁🏁🏁 CARGA DE TAREOS FINALIZADA');
      return tareosPeriodo;
    } catch (error) {
      console.error('❌ Error al cargar tareos por período:', error);
      console.error('❌ Error stack:', error.stack);
      console.error('❌ Error message:', error.message);
      setTareosPeriodo([]);
      setResumenTareos(null);
      setAutorizacionesPeriodo([]);
      return [];
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-PE', {
      style: 'currency',
      currency: 'PEN'
    }).format(amount);
  };

  const formatDateToDDMMYYYY = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const [year, month, day] = dateString.split('T')[0].split('-');
      return `${day}/${month}/${year}`;
    } catch (error) {
      return 'N/A';
    }
  };

  // Función para formatear fecha a formato yyyy-mm-dd (para APIs)
  const formatDateToYYYYMMDD = (dateString) => {
    if (!dateString) return null;
    try {
      // Si la fecha ya está en formato yyyy-mm-dd, devolverla tal como está
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        return dateString;
      }
      
      // Si tiene timestamp ISO, extraer solo la parte de la fecha
      if (dateString.includes('T')) {
        return dateString.split('T')[0];
      }
      
      // Si es un objeto Date
      if (dateString instanceof Date) {
        return dateString.toISOString().split('T')[0];
      }
      
      // Intentar crear una fecha y formatearla
      const date = new Date(dateString);
      if (!isNaN(date.getTime())) {
        return date.toISOString().split('T')[0];
      }
      
      return null;
    } catch (error) {
      console.error('Error al formatear fecha:', error);
      return null;
    }
  };

  // 🕐 FUNCIÓN PARA CONVERTIR HORAS DECIMALES A HORAS Y MINUTOS
  const formatHorasMinutos = (horasDecimales) => {
    if (!horasDecimales || horasDecimales === 0) {
      return '0h 0min';
    }
    
    const horas = Math.floor(horasDecimales);
    const minutos = Math.round((horasDecimales - horas) * 60);
    
    return `${horas}h ${minutos}min`;
  };

  const getEstadoBadge = (estado) => {
    const estadoConfig = {
      proceso: { class: 'bg-blue-100 text-blue-800', text: 'En Proceso', icon: '⚙️' },
      cerrado: { class: 'bg-green-100 text-green-800', text: 'Cerrado', icon: '✅' }
    };
    return estadoConfig[estado] || estadoConfig.proceso;
  };

  // 💤 FUNCIÓN PARA CALCULAR COMPENSACIONES DE TODOS LOS EMPLEADOS
  const calcularCompensacionesTodosEmpleados = () => {
    if (!planillaCerrada || empleadosParaVista.length === 0) {
      return [];
    }

    console.log('💤 === CALCULANDO COMPENSACIONES PARA TODOS LOS EMPLEADOS ===');
    console.log(`📊 Total empleados para vista: ${empleadosParaVista.length}`);
    console.log(`📊 Total compensaciones cargadas: ${compensacionesTodosEmpleados.length}`);
    console.log(`🔍 IDs de empleados disponibles:`, empleadosParaVista.map(e => e.id).slice(0, 5));
    console.log(`🔍 IDs de compensaciones disponibles:`, compensacionesTodosEmpleados.map(c => c.empleado_id).slice(0, 5));
    
    // Función helper para verificar si fecha está fuera del período (igual que TareoModal)
    const esFechaFueraDePeriodo = (fechaTareo) => {
      if (!planillaReal?.fecha_inicio || !planillaReal?.fecha_fin || !fechaTareo) {
        return false;
      }
      
      try {
        const fechaTareoStr = fechaTareo.split('T')[0];
        const fechaInicioStr = planillaReal.fecha_inicio.split('T')[0]; 
        const fechaFinStr = planillaReal.fecha_fin.split('T')[0];
        
        return fechaTareoStr < fechaInicioStr || fechaTareoStr > fechaFinStr;
      } catch (error) {
        console.error('Error comparando fechas:', error);
        return false;
      }
    };

    // Función helper para formatear tareos (simplificada del TareoModal)
    const formatearTareosParaCompensaciones = (tareosReales, empleadoRef = null) => {
      return tareosReales.map((tareo) => {
        // Determinar tipo de tareo basado en los campos reales del backend
        let tipo = 'Asistió';
        
        if (tareo.tipo_evento === 'falta') {
          tipo = 'Falta';
        } else if (tareo.tipo_evento === 'feriado') {
          tipo = 'Feriado';
        } else if (tareo.tipo_evento === 'feriado_laborado') {
          tipo = 'Feriado Laborado';
        } else if (tareo.tipo_evento === 'descanso') {
          tipo = 'Descanso';
        } else if (tareo.tipo_evento === 'descanso_laborado') {
          tipo = 'Descanso Laborado';
        } else if (tareo.tipo_evento === 'descanso_medico') {
          tipo = 'Descanso Médico';
        } else if (tareo.tipo_evento === 'reposo_medico') {
          tipo = 'Reposo Médico';
        } else if (tareo.tipo_evento === 'subsidio_por_enfermedad') {
          tipo = 'Subsidio por Enfermedad';
        } else if (tareo.tipo_evento === 'licencia_con_goce_de_haber') {
          tipo = 'Licencia con Goce de Haber';
        } else if (tareo.tipo_evento === 'permiso') {
          tipo = 'Permiso';
        } else if (tareo.tipo_evento === 'no_laborado') {
          tipo = 'No laborado (contrato)';
        } else if (tareo.tipo_evento === 'suspension') {
          tipo = 'Suspensión';
        } else if (tareo.tipo_evento === 'vacaciones') {
          tipo = 'Vacaciones';
        }

        // Formatear horas según el tipo de evento (igual que TareoModal)
        let horasOrdinarias = parseFloat(tareo.horas_trabajadas) || 0;
        
        if (tareo.tipo_evento === 'falta') {
          horasOrdinarias = 0;
        } else if (tareo.tipo_evento === 'vacaciones' || tareo.tipo_evento === 'permiso' || tareo.tipo_evento === 'no_laborado' || tareo.tipo_evento === 'suspension') {
          horasOrdinarias = 0;
        } else if (tareo.tipo_evento === 'feriado') {
          horasOrdinarias = 8; // Igual que TareoModal
        } else if (tareo.tipo_evento === 'descanso' && horasOrdinarias > 0) {
          horasOrdinarias = 0;
        } else if (tareo.tipo_evento === 'descanso_medico') {
          horasOrdinarias = 8;
        } else if (tareo.tipo_evento === 'reposo_medico') {
          horasOrdinarias = 0; // Igual que TareoModal
        } else if (tareo.tipo_evento === 'subsidio_por_enfermedad') {
          horasOrdinarias = 8;
        } else if (tareo.tipo_evento === 'licencia_con_goce_de_haber') {
          horasOrdinarias = 8;
        }

        // Misma regla que TareoModal: tareo simple + fijas_8 → mostrar/contar 8h
        const cfgHoras = empleadoRef?.configuracion_tareo || configuracionTareo;
        if (usaHorasFijas8Simple(cfgHoras)) {
          const tipoEv = String(tareo.tipo_evento || '').toLowerCase().trim();
          if (['asistio', 'feriado_laborado', 'descanso_laborado'].includes(tipoEv)) {
            horasOrdinarias = horasTrabajadasEfectivas(tareo, cfgHoras);
          }
        }

        // Calcular horas teóricas (igual que TareoModal)
        const horaEntradaTeorica = tareo.hora_entrada_teorica || '08:00:00';
        const horaSalidaTeorica = tareo.hora_salida_teorica || '17:00:00';
        
        const [horaEntrada, minutoEntrada] = horaEntradaTeorica.split(':').map(Number);
        const [horaSalida, minutoSalida] = horaSalidaTeorica.split(':').map(Number);
        
        const minutosEntrada = horaEntrada * 60 + minutoEntrada;
        const minutosSalida = horaSalida * 60 + minutoSalida;
        
        let diferenciaMinutos = minutosSalida - minutosEntrada;
        if (diferenciaMinutos < 0) diferenciaMinutos += 24 * 60;
        
        let horasTeoricasDecimales = diferenciaMinutos / 60;
        if (horasTeoricasDecimales > 6) horasTeoricasDecimales -= 1; // Descuento almuerzo

        return {
          fecha: tareo.fecha,
          tipo,
          horasOrdinarias,
          horasTeoricasDecimales
        };
      });
    };
    
    const resultados = empleadosParaVista.map((empleado) => {
      console.log(`💤 Procesando empleado: ${empleado.nombre}`);
      
      // Usar tareos reales del empleado
      const tareosReales = empleado.tareosEmpleado || [];
      
      // Formatear tareos para la vista (igual que TareoModal)
      const tareosDiarios = formatearTareosParaCompensaciones(tareosReales, empleado);
      
      // Filtrar tareos del período actual (no en plomo) - IGUAL QUE TAREOMODAL
      const tareosPeriodoActual = tareosDiarios.filter(registro => 
        !esFechaFueraDePeriodo(registro.fecha)
      );

      console.log(`  • Tareos del período: ${tareosPeriodoActual.length}`);

      // LÓGICA EXACTA DEL TAREOMODAL - CALCULAR COMPENSACIÓN
      // Tareo simple: no descuenta/agrega minutos vs horario teórico
      let minutosExtrasMes = 0;
      let diasProcesados = 0;
      let diasLaborables = 0;
      const cfgComp = empleado.configuracion_tareo || configuracionTareo;
      const omitirDiferenciaMinutos = esTareoSimple(cfgComp);
      
      tareosPeriodoActual.forEach(tareo => {
        // ✅ PROCESAR TODOS LOS DÍAS (NO FILTRAR SÁBADOS Y DOMINGOS) - IGUAL QUE TAREOMODAL
        diasLaborables++;
        
        // Solo procesar días de asistencia efectiva (igual que TareoModal: incluye días con 0h para que reste teóricas)
        const esAsistenciaEfectiva = tareo.tipo === 'Asistió' || 
                                    tareo.tipo === 'Feriado Laborado' || 
                                    tareo.tipo === 'Descanso Laborado';
        
        if (esAsistenciaEfectiva) {
          diasProcesados++;
          if (omitirDiferenciaMinutos) {
            return;
          }
          // 🧮 LÓGICA EXACTA DEL TAREOMODAL: Reales - Teóricas = Diferencia (0h cuenta como -teóricas)
          const horasTeoricasCalculadas = tareo.horasTeoricasDecimales || 8;
          const horasRealesTrabajadas = tareo.horasOrdinarias;
          const diferenciaDia = horasRealesTrabajadas - horasTeoricasCalculadas;
          const minutosDiferencia = Math.round(diferenciaDia * 60);
          minutosExtrasMes += minutosDiferencia;
        }
      });
      
      // Convertir minutos totales de vuelta a horas decimales
      const horasGeneradasMes = minutosExtrasMes / 60;
      
      // Obtener compensaciones de meses anteriores desde el servicio (igual que TareoModal)
      let horasMesesAnteriores = 0;
      
      // 🔍 DEBUG: Log detallado del mapeo
      console.log(`  🔍 Buscando compensación para empleado ID: ${empleado.id} (${empleado.nombre})`);
      
      // Buscar compensación del empleado en los datos cargados del servicio (comparación numérica para evitar string vs number)
      const idEmpleadoNum = empleado.id != null ? Number(empleado.id) : null;
      const compensacionDelEmpleado = compensacionesTodosEmpleados.find(comp => 
        idEmpleadoNum != null && Number(comp.empleado_id) === idEmpleadoNum
      );
      
      if (compensacionDelEmpleado) {
        horasMesesAnteriores = parseFloat(compensacionDelEmpleado.horas_compensadas) || 0;
        console.log(`  ✅ Compensación encontrada en servicio: ${horasMesesAnteriores}h (ID coincidió: ${compensacionDelEmpleado.empleado_id} === ${empleado.id})`);
      } else {
        console.log(`  ⚠️ No se encontró compensación en servicio para empleado ${empleado.id}`);
        console.log(`  🔍 Compensaciones disponibles con empleado_id:`, compensacionesTodosEmpleados.map(c => c.empleado_id));
        
        // Fallback: buscar en los datos del empleado (si existe el campo)
        if (empleado.compensacion_anterior !== undefined) {
          horasMesesAnteriores = parseFloat(empleado.compensacion_anterior) || 0;
          console.log(`  🔄 Usando fallback compensacion_anterior: ${horasMesesAnteriores}h`);
        } else if (empleado.horas_compensadas !== undefined) {
          horasMesesAnteriores = parseFloat(empleado.horas_compensadas) || 0;
          console.log(`  🔄 Usando fallback horas_compensadas: ${horasMesesAnteriores}h`);
        } else {
          console.log(`  ⚠️ No hay fallback disponible - usando 0h`);
        }
      }
      
      // Total para el próximo mes - IGUAL QUE TAREOMODAL
      const totalProximoMes = horasMesesAnteriores + horasGeneradasMes;
      
      console.log(`  • Días procesados: ${diasProcesados}/${diasLaborables}`);
      console.log(`  • Minutos extras: ${minutosExtrasMes}`);
      console.log(`  • Horas generadas: ${horasGeneradasMes.toFixed(2)}h`);
      console.log(`  • Horas meses anteriores: ${horasMesesAnteriores.toFixed(2)}h`);
      console.log(`  • Total próximo mes: ${totalProximoMes.toFixed(2)}h`);
      
      return {
        empleado: {
          id: empleado.id,
          nombre: empleado.nombre,
          documento: empleado.documento,
          cargo: empleado.cargo,
          areas_de_trabajo: empleado.areas_de_trabajo,
          proyecto: empleado.proyecto
        },
        compensacion: {
          horasMesesAnteriores,
          horasGeneradasMes,
          totalProximoMes,
          minutosExtrasMes,
          diasLaborables,
          diasProcesados,
          tareosProcesados: tareosPeriodoActual.length
        }
      };
    }); // Mostrar todos los empleados sin filtrar por diferencia significativa
    
    // Ordenar alfabéticamente por nombre del empleado
    return resultados.sort((a, b) => a.empleado.nombre.localeCompare(b.empleado.nombre));
  };

  // 🔒 Pestañas disponibles (filtrar Consideraciones Previas para planillas cerradas)
  const allTabs = [
    { id: 'resumen', name: 'Resumen General', icon: '📊' },
    { id: 'consideraciones', name: 'Consideraciones Previas', icon: '⚙️' },
    { id: 'empleados', name: 'Por Empleado', icon: '👥' },
    { id: 'conceptos', name: 'Por Conceptos', icon: '📋' },
    { id: 'compensaciones', name: 'Compensaciones', icon: '💤' }, // 🔒 Solo para planillas cerradas
    { id: 'netos', name: 'Netos a Pagar', icon: '💰' },
    { id: 'plame', name: 'Archivos PLAME', icon: '📄' }
  ];
  
  const tabs = planillaCerrada 
    ? allTabs.filter((tab) => tab.id !== 'consideraciones' || empleadosEnAjustePosteriorIds.size > 0)
    : allTabs.filter(tab => tab.id !== 'plame' && tab.id !== 'compensaciones');

  // 📊 OBTENER EMPLEADOS REALES PARA LA VISTA Y CALCULAR TOTALES
  const empleadosParaVista = obtenerEmpleadosParaVista();

  /** Pre-cierre (abierta) o snapshot congelado (cerrada sin ajuste posterior). */
  const empleadoEnAjustePosterior = (empOrId) => {
    const id =
      typeof empOrId === 'object'
        ? Number(empOrId?.id ?? empOrId?.empleado_id)
        : Number(empOrId);
    return Number.isFinite(id) && id > 0 && empleadosEnAjustePosteriorIds.has(id);
  };

  const empleadoTienePreCierreCongelado = (empOrId) => {
    const id =
      typeof empOrId === 'object'
        ? Number(empOrId?.id ?? empOrId?.empleado_id)
        : Number(empOrId);
    if (!Number.isFinite(id) || id <= 0) return false;
    if (planillaCerrada || planillaReal?.estado === 'cerrada') {
      return !empleadosEnAjustePosteriorIds.has(id);
    }
    return empleadosFotografiadosIds.has(id);
  };

  const empleadosEditablesConsideraciones = (planillaCerrada || planillaReal?.estado === 'cerrada')
    ? empleadosParaVista.filter((e) => empleadoEnAjustePosterior(e))
    : empleadosParaVista.filter((e) => !empleadoTienePreCierreCongelado(e));

  const filtrarEmpleadosEditablesPlanilla = (lista) =>
    (lista || []).filter((e) => !empleadoTienePreCierreCongelado(e));
  
  // 🔍 DEBUG: Verificar estructura de empleados para PDF
  if (empleadosParaVista.length > 0) {
    const primerEmpleado = empleadosParaVista[0];
    //console.log(`🔍 === EMPLEADOS PARA VISTA (${planillaCerrada ? 'CERRADA' : 'ABIERTA'}) ===`);
    //console.log(`📊 Total empleados: ${empleadosParaVista.length}`);
    //console.log(`👤 Primer empleado:`, primerEmpleado.nombre);
    //console.log(`📱 Teléfono del primer empleado:`, primerEmpleado.telefono);
    //console.log(`📧 Email del primer empleado:`, primerEmpleado.email);
    //console.log(`🏠 Dirección del primer empleado:`, primerEmpleado.direccion);
    //console.log(`💤 Descuento descanso del primer empleado:`, primerEmpleado.descuento_descanso);
    //console.log(`🔍 Estructura completa del primer empleado:`, primerEmpleado);
  }
  
  // Vista/totales de haberes (boleta ordinaria): sin 0406/0313 de declaración de gratificaciones
  const empleadosParaVistaHaberesBase = empleadosParaVista.map((emp) => empleadoParaBoletaOrdinaria(emp));

  const empleadoTieneBoletaInterna = (emp) => {
    const tipo = String(emp?.tipo_planilla || '').toLowerCase();
    if (tipo === 'dual' || tipo === 'solo_interna') return true;
    if (emp?.sueldo_interno != null && Number(emp.sueldo_interno) > 0) return true;
    const ci = emp?.conceptosInternos;
    return Boolean(
      (ci?.ingresos?.length || 0) + (ci?.descuentos?.length || 0) + (ci?.aportes?.length || 0)
    );
  };

  const canalesBoletaDe = (emp) => canalesBoletaEnPeriodo(
    emp,
    planillaReal?.fecha_inicio,
    planillaReal?.fecha_fin
  );

  /** Según filtro PLAME/interna, expone conceptos/totales de la boleta elegida (para matriz y Excel). */
  const adaptarEmpleadoPorFiltroBoleta = (emp) => {
    if (!planillaAlternativaActiva) return emp;
    const tipo = String(emp?.tipo_planilla || '').toLowerCase();
    const canales = canalesBoletaDe(emp);
    const usarInterna =
      filtroTipoBoleta === 'interna' ||
      (filtroTipoBoleta === 'todas' && (tipo === 'solo_interna' || (!canales.plame && canales.interna)));
    if (usarInterna && emp.conceptosInternos) {
      return {
        ...emp,
        conceptos: emp.conceptosInternos,
        totales: emp.totalesInternos || emp.totales,
        _boletaVista: 'interna',
      };
    }
    return { ...emp, _boletaVista: 'plame' };
  };

  const empleadoVisibleSegunFiltroBoleta = (emp) => {
    if (!planillaAlternativaActiva) return true;
    const tipo = String(emp?.tipo_planilla || '').toLowerCase();
    const canales = canalesBoletaDe(emp);
    if (filtroTipoBoleta === 'plame') {
      if (tipo === 'solo_interna') return false;
      return canales.plame;
    }
    if (filtroTipoBoleta === 'interna') {
      if (!empleadoTieneBoletaInterna(emp)) return false;
      return canales.interna;
    }
    return canales.plame || canales.interna;
  };

  const empleadosParaVistaHaberes = empleadosParaVistaHaberesBase
    .map(adaptarEmpleadoPorFiltroBoleta)
    .filter(empleadoVisibleSegunFiltroBoleta);

  /** Lista Por Empleado respetando filtro Boleta (Solo PLAME oculta solo_interna). */
  const empleadosParaVistaPorBoleta = empleadosParaVista.filter(empleadoVisibleSegunFiltroBoleta);

  const FiltroTipoBoletaControl = ({ idSufijo = '' }) => {
    if (!planillaAlternativaActiva) return null;
    return (
      <div className="flex items-center gap-2">
        <label htmlFor={`filtro-boleta-${idSufijo}`} className="text-xs font-medium text-gray-600 whitespace-nowrap">
          Boleta
        </label>
        <select
          id={`filtro-boleta-${idSufijo}`}
          value={filtroTipoBoleta}
          onChange={(e) => setFiltroTipoBoleta(e.target.value)}
          className="text-sm border border-gray-300 rounded-md px-2 py-1.5 bg-white focus:outline-none focus:ring-1 focus:ring-teal-500"
        >
          <option value="todas">Todas (PLAME + Interna)</option>
          <option value="plame">Solo PLAME</option>
          <option value="interna">Solo Interna</option>
        </select>
      </div>
    );
  };

  const netoPorDiaDeEmpleado = (emp, totalesFuente) => {
    const esConsu = planillaReal?.modalidad_planilla === 'planilla_construccion'
      || esRegimenConstruccionCivil(emp, regimenesLaborales || []);
    if (!esConsu) return null;
    const totales = totalesFuente || emp?.totales || {};
    const calc = emp?.calculoConstruccionCivil || {};
    const diasConsu = diasParaNetoConstruccion({
      resumen: calc.resumen,
      detalleDias: calc.detalleDias,
      diasTrabajadosTareo: 0,
    });
    if (diasConsu > 0) {
      return resolverNetoPorDiaConstruccion({
        neto: totales.netoAPagar,
        diasAsistencia: diasConsu,
      });
    }
    const periodo = (() => {
      const flags = consideracionesEmpleadoFlags?.[String(emp?.id || emp?.empleado_id)] || {};
      return resolverPeriodoCalculoConsu({
        planilla: planillaReal,
        fechaCalculoDesde: emp?.fecha_calculo_desde || flags.fecha_calculo_desde,
        fechaCalculoHasta: emp?.fecha_calculo_hasta || flags.fecha_calculo_hasta,
      });
    })();
    if (periodo.override && periodo.fechaInicio && periodo.fechaFin) {
      const tareos = emp?.tareosEmpleadoFiltrados || emp?.tareosEmpleado || [];
      const diasEnRango = (Array.isArray(tareos) ? tareos : []).filter((t) => {
        const f = String(t?.fecha || '').slice(0, 10);
        if (f < periodo.fechaInicio || f > periodo.fechaFin) return false;
        const tipo = String(t?.tipo_evento || '').toLowerCase();
        return tipo.includes('asist') || tipo === 'tardanza' || tipo === 'trabajo_normal';
      }).length;
      return resolverNetoPorDiaConstruccion({
        neto: totales.netoAPagar,
        diasAsistencia: diasEnRango || 1,
      });
    }
    if (Number(totales.diasNeto) > 0 && totales.netoPorDia != null) {
      return { netoPorDia: Number(totales.netoPorDia), diasNeto: Number(totales.diasNeto) };
    }
    return resolverNetoPorDiaConstruccion({
      neto: totales.netoAPagar,
      diasAsistencia: emp?.calculoConstruccionCivil?.resumen?.diasAsistencia,
      diasComputables: emp?.calculoConstruccionCivil?.resumen?.diasComputables,
      diasTrabajados: emp?.tareos?.diasTrabajados,
    });
  };

  const etiquetaCategoriaConsu = (emp) => {
    const empleadoId = emp?.id || emp?.empleado_id;
    const ficha = construccionCivilDatos?.fichas?.find(
      (f) => Number(f.empleado_id) === Number(empleadoId)
    );
    const crudo = emp?.calculoConstruccionCivil?.parametrosUsados?.categoria
      || emp?.calculoConstruccionCivil?.ficha?.categoria
      || emp?.datosAPIs?.construccionCivil?.ficha?.categoria
      || emp?.datosEmpleado?.construccion?.categoria
      || ficha?.categoria;
    const n = String(crudo || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    if (n === 'operario') return { texto: 'Operario', className: 'bg-orange-100 text-orange-800' };
    if (n === 'oficial') return { texto: 'Oficial', className: 'bg-indigo-100 text-indigo-800' };
    if (n === 'peon') return { texto: 'Peón', className: 'bg-amber-100 text-amber-900' };
    return null;
  };

  const periodoCalculoPersonalizadoDe = (emp) => {
    if (!esPlanillaModalidadConstruccion(planillaReal)) return null;
    const empleadoId = emp?.id || emp?.empleado_id;
    const flags = consideracionesEmpleadoFlags?.[String(empleadoId)] || {};
    const resumen = emp?.calculoConstruccionCivil?.resumen || {};
    const periodoSnap = emp?.calculoConstruccionCivil?.periodoCalculo || {};
    if (resumen.overridePeriodo || periodoSnap.override) {
      return {
        fechaInicio: resumen.fechaInicio || periodoSnap.fechaInicio,
        fechaFin: resumen.fechaFin || periodoSnap.fechaFin,
      };
    }
    const periodo = resolverPeriodoCalculoConsu({
      planilla: planillaReal,
      fechaCalculoDesde: emp?.fecha_calculo_desde || flags.fecha_calculo_desde,
      fechaCalculoHasta: emp?.fecha_calculo_hasta || flags.fecha_calculo_hasta,
    });
    if (!periodo.override) return null;
    return { fechaInicio: periodo.fechaInicio, fechaFin: periodo.fechaFin };
  };

  const textoPeriodoCalculoCorto = (periodo) => {
    if (!periodo?.fechaInicio || !periodo?.fechaFin) return '';
    return `${formatFechaSoloDiaDdMmYyyy(periodo.fechaInicio, '')} – ${formatFechaSoloDiaDdMmYyyy(periodo.fechaFin, '')}`;
  };

  const fechasRangoTareoDe = (emp) => {
    const personalizado = periodoCalculoPersonalizadoDe(emp);
    return {
      inicio: personalizado?.fechaInicio || planillaParaVista?.fecha_inicio || planillaReal?.fecha_inicio,
      fin: personalizado?.fechaFin || planillaParaVista?.fecha_fin || planillaReal?.fecha_fin,
    };
  };

  const fechasPlanillaParaReferenciaInicio = () => ({
    inicio: planillaParaVista?.fecha_inicio || planillaReal?.fecha_inicio,
    fin: planillaParaVista?.fecha_fin || planillaReal?.fecha_fin,
  });

  const textoFechaInicioReferencia = (emp) => {
    const { inicio, fin } = fechasPlanillaParaReferenciaInicio();
    const raw = resolverFechaIngresoReferencia(emp, inicio, fin);
    if (!raw) return null;
    return formatFechaSoloDiaDdMmYyyy(raw, '—');
  };

  const textoFechaCeseReferencia = (emp) => {
    const { inicio, fin } = fechasPlanillaParaReferenciaInicio();
    const raw = resolverFechaCeseReferencia(emp, inicio, fin);
    if (!raw) return null;
    return formatFechaSoloDiaDdMmYyyy(raw, '—');
  };

  const renderBloqueConceptosBoleta = (empleadoVista, titulo, tono = 'plame', aclaracion = null) => {
    const esInterna = tono === 'interna';
    const conceptos = esInterna ? (empleadoVista.conceptosInternos || { ingresos: [], descuentos: [], aportes: [] }) : empleadoVista.conceptos;
    const totales = esInterna ? (empleadoVista.totalesInternos || {}) : empleadoVista.totales;
    const wrap = esInterna
      ? 'border border-amber-200 rounded-lg p-3 bg-amber-50/40'
      : 'border border-slate-200 rounded-lg p-3 bg-slate-50/40';
    const badge = esInterna
      ? 'bg-amber-100 text-amber-900'
      : 'bg-slate-700 text-white';

    // Haberes: sin declaración. Viáticos/grati van en bloque aparte (no suman al pago).
    const catalogoEtiquetasBoleta = [
      ...(Array.isArray(configuracionesPlame) ? configuracionesPlame : Object.values(configuracionesPlame || {})),
      ...Object.values(empleadoVista?.datosAPIs?.conceptosPlame || {}),
    ];
    const etiquetaConceptoBoleta = (concepto) =>
      etiquetaVisibleConceptoPlame(concepto, catalogoEtiquetasBoleta);
    const ingresosVista = (conceptos.ingresos || []).filter((c) => {
      if (esConceptoSoloDeclaracion(c)) return false;
      if (ocultarHorasExtrasEnVista && esConceptoIngresoHorasExtrasVista(c)) return false;
      if (!esInterna && !conceptoVaABoletaPlame(c)) return false;
      return true;
    });
    const ingresosDeclaracion = (conceptos.ingresos || []).filter(
      (c) => esConceptoSoloDeclaracion(c) && (parseFloat(c.monto) || 0) > 0
    );
    const descuentosVista = (conceptos.descuentos || []).filter((c) => {
      if (esDescuentoSoloDeclaracion(c)) return false;
      if (!esInterna && !conceptoVaABoletaPlame(c)) return false;
      return true;
    });
    const descuentosDeclaracion = (conceptos.descuentos || []).filter(
      (c) => esDescuentoSoloDeclaracion(c) && (parseFloat(c.monto) || 0) > 0
    );
    const aportesVista = conceptos.aportes || [];
    const totalIngresosVista = ingresosVista.reduce((s, c) => s + parseFloat(c.monto || 0), 0);
    const totalDescuentosVista = descuentosVista.reduce((s, c) => s + parseFloat(c.monto || 0), 0);
    const totalDescuentosDeclaracion = descuentosDeclaracion.reduce(
      (s, c) => s + parseFloat(c.monto || 0),
      0
    );
    const totalAportesVista = aportesVista.reduce((s, c) => s + parseFloat(c.monto || 0), 0);
    const totalDeclaracion = ingresosDeclaracion.reduce((s, c) => s + parseFloat(c.monto || 0), 0);

    return (
      <div className={wrap}>
        <div className="flex items-center mb-3">
          <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold ${badge}`}>
            {titulo}
          </span>
        </div>
        {aclaracion ? (
          <div className="mb-3 rounded-md border border-amber-200 bg-white/80 px-3 py-2 text-xs text-amber-900">
            {aclaracion}
          </div>
        ) : null}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <div className="bg-green-50 rounded p-3">
            <h5 className="font-medium text-green-800 mb-2">Ingresos: {formatCurrency(totalIngresosVista)}</h5>
            <div className="space-y-1">
              {ingresosVista.map((concepto, index) => (
                <div key={index} className="flex justify-between text-xs items-start gap-2">
                  <span className="text-green-700">
                    {etiquetaConceptoBoleta(concepto)}
                    {concepto.detalleSueldoTramo ? (
                      <span className="block text-[10px] text-amber-800 font-medium mt-0.5">
                        {concepto.detalleSueldoTramo}
                      </span>
                    ) : null}
                  </span>
                  <span className="font-medium whitespace-nowrap">{formatCurrency(concepto.monto)}</span>
                </div>
              ))}
            </div>
            {ingresosDeclaracion.length > 0 && (
              <div className="mt-2 pt-2 border-t border-green-200/80">
                <p className="text-[10px] font-medium text-slate-500 mb-1 uppercase tracking-wide">
                  No ingresan al pago · {formatCurrency(totalDeclaracion)}
                </p>
                <div className="space-y-1">
                  {ingresosDeclaracion.map((concepto, index) => {
                    const estilo = estiloConceptoDeclaracion(concepto);
                    return (
                      <div key={`decl-${index}`} className="flex justify-between text-xs">
                        <span className={estilo.texto}>
                          {estilo.icono}{' '}
                          {etiquetaConceptoBoleta(concepto)}
                        </span>
                        <span className={`font-medium ${estilo.monto}`}>
                          {formatCurrency(concepto.monto)}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
          <div className="bg-red-50 rounded p-3">
            <h5 className="font-medium text-red-800 mb-2">Descuentos: {formatCurrency(totalDescuentosVista)}</h5>
            <div className="space-y-1">
              {descuentosVista.map((concepto, index) => (
                <div key={index} className="flex justify-between text-xs">
                  <span className="text-red-700">{etiquetaConceptoBoleta(concepto)}</span>
                  <span className="font-medium">{formatCurrency(concepto.monto)}</span>
                </div>
              ))}
            </div>
            {descuentosDeclaracion.length > 0 && (
              <div className="mt-2 pt-2 border-t border-red-200/80">
                <p className="text-[10px] font-medium text-slate-500 mb-1 uppercase tracking-wide">
                  No ingresan al pago · {formatCurrency(totalDescuentosDeclaracion)}
                </p>
                <div className="space-y-1">
                  {descuentosDeclaracion.map((concepto, index) => {
                    const estilo = estiloConceptoDeclaracion(concepto);
                    return (
                      <div key={`desc-liq-${index}`} className="flex justify-between text-xs">
                        <span className={estilo.texto}>
                          {estilo.icono}{' '}
                          {etiquetaConceptoBoleta(concepto)}
                        </span>
                        <span className={`font-medium ${estilo.monto}`}>
                          {formatCurrency(concepto.monto)}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
          {!esRegimenFormacionLaboral(empleadoVista) && (
            <div className="bg-blue-50 rounded p-3">
              <h5 className="font-medium text-blue-800 mb-2">Aportes: {formatCurrency(totalAportesVista)}</h5>
              <div className="space-y-1">
                {aportesVista.map((concepto, index) => (
                  <div key={index} className="flex justify-between text-xs">
                    <span className="text-blue-700">{etiquetaConceptoBoleta(concepto)}</span>
                    <span className="font-medium">{formatCurrency(concepto.monto)}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const empleadoTieneDeclaracionGratificacion = (empleado) =>
    conceptosSoloDeclaracionGratificacion(empleado).length > 0;

  const empleadoTieneDeclaracionViatico = (empleado) =>
    conceptosSoloDeclaracionViatico(empleado).length > 0;

  const empleadoTieneDeclaracionMovilidad = (empleado) =>
    (empleado?.conceptos?.ingresos || []).some(esConceptoDeclaracionMovilidadJatsa)
    || (empleado?.conceptosInternos?.ingresos || []).some(esConceptoDeclaracionMovilidadJatsa);

  // Calcular totales generales basados en lo que se paga en boleta (sin declaración grati)
  const sumarTotalesEmpleados = (empleadosLista, obtenerTotales) =>
    (empleadosLista || []).reduce(
      (acc, emp) => {
        const t = obtenerTotales(emp) || {};
        return {
          totalIngresos: acc.totalIngresos + (Number(t.totalIngresos) || 0),
          totalDescuentos: acc.totalDescuentos + (Number(t.totalDescuentos) || 0),
          totalAportes: acc.totalAportes + (Number(t.totalAportes) || 0),
          netoTotal: acc.netoTotal + (Number(t.netoAPagar) || 0),
        };
      },
      { totalIngresos: 0, totalDescuentos: 0, totalAportes: 0, netoTotal: 0 }
    );

  // Base sin adaptar filtro (para poder totalizar PLAME e interna a la vez)
  const empleadosHaberesParaTotales = empleadosParaVistaHaberesBase;

  const totalesGeneralesPlame = sumarTotalesEmpleados(
    empleadosHaberesParaTotales.filter((emp) => canalesBoletaDe(emp).plame),
    (emp) => emp?.totales
  );

  const totalesGeneralesInterna = sumarTotalesEmpleados(
    empleadosHaberesParaTotales.filter((emp) => canalesBoletaDe(emp).interna),
    (emp) => emp?.totalesInternos
  );

  // Compat: según filtro de boleta (o PLAME si no hay alternativa)
  const totalesGenerales = !planillaAlternativaActiva
    ? sumarTotalesEmpleados(empleadosParaVistaHaberes, (emp) => emp?.totales)
    : filtroTipoBoleta === 'interna'
      ? totalesGeneralesInterna
      : filtroTipoBoleta === 'plame'
        ? totalesGeneralesPlame
        : {
            totalIngresos: totalesGeneralesPlame.totalIngresos + totalesGeneralesInterna.totalIngresos,
            totalDescuentos: totalesGeneralesPlame.totalDescuentos + totalesGeneralesInterna.totalDescuentos,
            totalAportes: totalesGeneralesPlame.totalAportes + totalesGeneralesInterna.totalAportes,
            netoTotal: totalesGeneralesPlame.netoTotal + totalesGeneralesInterna.netoTotal,
          };

  // Empleados en régimen de formación laboral: no mostrar ONP/AFP ni sección Aportes
  const esRegimenFormacionLaboral = (empleado) => {
    const codigo = String(empleado.regimenLaboral || empleado.datosSalariales?.regimenLaboral || '').trim().toUpperCase();
    const nombre = String(empleado.regimen_laboral_nombre || empleado.datosEmpleado?.regimen_laboral?.nombre || '').trim().toLowerCase();
    return codigo === 'FORMACION' || codigo === 'RF' || nombre.includes('formación') || nombre.includes('formacion');
  };

  // Solo interna: no hay PLAME → no aplica ONP/AFP/EsSalud en UI ni en resumen pensionario
  const esEmpleadoSoloInterna = (empleado) => {
    const tipo = String(
      empleado?.tipo_planilla || empleado?.datosEmpleado?.tipo_planilla || ''
    ).toLowerCase();
    const contratacion = String(
      empleado?.tipo_contratacion
        || empleado?.datosEmpleado?.tipo_contratacion
        || ''
    ).trim();
    return tipo === 'solo_interna' || contratacion === 'Interno';
  };

  const empleadoEntraEnArchivosPlame = (empleado) => {
    if (esRegimenFormacionLaboral(empleado) || esEmpleadoSoloInterna(empleado)) return false;
    if (planillaAlternativaActiva && !canalesBoletaDe(empleado).plame) return false;
    return true;
  };

  const CODIGOS_REGIMEN_MINERO = ['MINGEN', 'MINMIC', 'MINMYP'];
  const esRegimenMinero = (empleado) => {
    const codigo = String(empleado.regimenLaboral || empleado.datosSalariales?.regimenLaboral || '').trim().toUpperCase();
    const nombre = String(empleado.regimen_laboral_nombre || empleado.datosEmpleado?.regimen_laboral?.nombre || '').trim().toLowerCase();
    if (CODIGOS_REGIMEN_MINERO.includes(codigo)) return true;
    return nombre.includes('régimen minero') || nombre.includes('regimen minero') || nombre.includes('minero general');
  };

  const obtenerMontoConceptoPorCodigo = (conceptos = [], codigoPlame) => {
    const codigo = String(codigoPlame);
    return conceptos.reduce((sum, concepto) => {
      const cod = String(concepto.codigo || concepto.codigoPlame || '');
      if (cod !== codigo) return sum;
      return sum + (parseFloat(concepto.monto || concepto.valor || 0) || 0);
    }, 0);
  };

  const empleadoTieneRentaQuinta = (empleado) => (
    obtenerMontoConceptoPorCodigo(empleado.conceptos?.descuentos, '0605') > 0
  );

  // 📊 FUNCIÓN PARA CALCULAR RESUMEN POR TIPO DE AFP, ONP Y ESSALUD
  const calcularResumenSistemasPensionarios = () => {
    const resumen = {
      afp: {},
      tieneRegimenMinero: false,
      onp: {
        empleados: [],
        totalEmpleados: 0,
        totalNeto: 0,
        totalDescuentos: 0
      },
      essalud: {
        empleados: [],
        totalEmpleados: 0,
        totalAporte: 0
      },
      renta: {
        totalEmpleados: 0,
        totalDescuentos: 0
      },
      fcjmus0616: {
        totalEmpleados: 0,
        totalAporte: 0
      },
      // Informativos: no entran al neto a pagar (PLAME e interna por separado)
      gratificaciones: {
        totalEmpleados: 0,
        totalMonto: 0,
        totalMontoPlame: 0,
        totalMontoInterna: 0,
        totalEmpleadosPlame: 0,
        totalEmpleadosInterna: 0,
      },
      viaticos: {
        totalEmpleados: 0,
        totalMonto: 0,
        totalMontoPlame: 0,
        totalMontoInterna: 0,
        totalEmpleadosPlame: 0,
        totalEmpleadosInterna: 0,
      },
      movilidades: {
        totalEmpleados: 0,
        totalMonto: 0,
        totalMontoPlame: 0,
        totalMontoInterna: 0,
        totalEmpleadosPlame: 0,
        totalEmpleadosInterna: 0,
      },
    };

    // Alineado al filtro de boleta / Excel: no sumar PLAME+interna juntos (doble conteo en dual)
    const boletaResumen =
      !planillaAlternativaActiva
        ? 'plame'
        : filtroTipoBoleta === 'interna'
          ? 'interna'
          : filtroTipoBoleta === 'plame'
            ? 'plame'
            : 'ambas';

    empleadosParaVista.forEach((empleado, index) => {
      const decl = montosDeclaracionPorBoleta(empleado);
      resumen.gratificaciones.totalMontoPlame += decl.gratiPlame;
      resumen.gratificaciones.totalMontoInterna += decl.gratiInterna;
      resumen.viaticos.totalMontoPlame += decl.viaticosPlame;
      resumen.viaticos.totalMontoInterna += decl.viaticosInterna;
      resumen.movilidades.totalMontoPlame += decl.movilidadPlame || 0;
      resumen.movilidades.totalMontoInterna += decl.movilidadInterna || 0;
      if (decl.gratiPlame > 0) resumen.gratificaciones.totalEmpleadosPlame += 1;
      if (decl.gratiInterna > 0) resumen.gratificaciones.totalEmpleadosInterna += 1;
      if (decl.viaticosPlame > 0) resumen.viaticos.totalEmpleadosPlame += 1;
      if (decl.viaticosInterna > 0) resumen.viaticos.totalEmpleadosInterna += 1;
      if (decl.movilidadPlame > 0) resumen.movilidades.totalEmpleadosPlame += 1;
      if (decl.movilidadInterna > 0) resumen.movilidades.totalEmpleadosInterna += 1;

      let montosGrati = 0;
      let montosViaticos = 0;
      let montosMovilidad = 0;
      if (boletaResumen === 'interna') {
        montosGrati = decl.gratiInterna;
        montosViaticos = decl.viaticosInterna;
        montosMovilidad = decl.movilidadInterna;
      } else if (boletaResumen === 'plame') {
        montosGrati = decl.gratiPlame;
        montosViaticos = decl.viaticosPlame;
        montosMovilidad = decl.movilidadPlame;
      } else {
        // Vista "todas": totales principales = suma de ambas boletas (mostramos desglose en UI)
        montosGrati = decl.gratiPlame + decl.gratiInterna;
        montosViaticos = decl.viaticosPlame + decl.viaticosInterna;
        montosMovilidad = decl.movilidadPlame + decl.movilidadInterna;
      }
      if (montosGrati > 0) {
        resumen.gratificaciones.totalMonto += montosGrati;
        resumen.gratificaciones.totalEmpleados += 1;
      }
      if (montosViaticos > 0) {
        resumen.viaticos.totalMonto += montosViaticos;
        resumen.viaticos.totalEmpleados += 1;
      }
      if (montosMovilidad > 0) {
        resumen.movilidades.totalMonto += montosMovilidad;
        resumen.movilidades.totalEmpleados += 1;
      }

      // Renta 5ta (0605): se cuenta para todos, aunque no haya AFP/ONP
      const montoRenta = obtenerMontoConceptoPorCodigo(empleado.conceptos?.descuentos, '0605');
      if (montoRenta > 0) {
        resumen.renta.totalDescuentos += montoRenta;
        resumen.renta.totalEmpleados += 1;
      }

      // No incluir formación laboral ni solo_interna en resumen ONP/AFP/EsSalud
      if (esRegimenFormacionLaboral(empleado) || esEmpleadoSoloInterna(empleado)) return;
      // ✅ LÓGICA UNIFICADA: Usar la misma lógica que en obtenerEmpleadosParaVista
      // Detectar AFP basado en: tipoAporte, afp definida, o cuspp
      const tieneAfp = empleado.tipoAporte === 'AFP' || empleado.afp || empleado.cuspp;
      
      // ✅ NOMBRE AFP CONSISTENTE: Usar el nombre real de la AFP o un fallback claro
      let nombreAfp = 'ONP'; // Por defecto
      if (tieneAfp) {
        nombreAfp = empleado.afp || 'AFP Sin Nombre';
      }

      // 🔍 DEBUG: Log para verificar clasificación
      if (index < 5) { // Solo los primeros 5 empleados para no saturar console
        //console.log(`🔍 EMPLEADO ${index + 1}: ${empleado.nombre}`);
        //console.log(`  - tipoAporte: ${empleado.tipoAporte}`);
        //console.log(`  - afp: ${empleado.afp}`);
        //console.log(`  - cuspp: ${empleado.cuspp}`);
        //console.log(`  - tieneAfp: ${tieneAfp}`);
        //console.log(`  - nombreAfp: ${nombreAfp}`);
        //console.log(`  - Clasificado como: ${tieneAfp ? 'AFP' : 'ONP'}`);
        //console.log('---');
      }

      if (tieneAfp) {
        // EMPLEADO CON AFP
        if (!resumen.afp[nombreAfp]) {
          resumen.afp[nombreAfp] = {
            empleados: [],
            totalEmpleados: 0,
            totalNeto: 0,
            totalDescuentosAfp: 0,
            aportacionObligatoria: 0,
            comisionPorcentual: 0,
            primaSeguro: 0,
            aportacionTrabajador0611: 0,
            aporteEmpleador0809: 0,
            empleadosMinero: 0,
            tipoAfp: empleado.tipoAfp || empleado.tipoHabitat || null
          };
        }

        // 🔍 LOG DETALLADO: Inicio de cálculo AFP para empleado
        //console.log(`\n🏦 === CÁLCULO AFP: ${empleado.nombre} (${nombreAfp}) ===`);
        //console.log(`📊 Total descuentos disponibles: ${empleado.conceptos?.descuentos?.length || 0}`);

        // Buscar descuentos relacionados con AFP
        let aportacionObligatoria = 0;
        let comisionPorcentual = 0;
        let primaSeguro = 0;

        // 🔍 CONTADOR DETALLADO para Aportación Obligatoria
        let contadorAportacion = {
          total: 0,
          items: [],
          criterios: {
            descripcionObligatoria: 0,
            aporteAfp: 0,
            aporte10porciento: 0,
            codigo0601: 0,
            fallbackAfp: 0
          }
        };

        if (empleado.conceptos?.descuentos) {
          empleado.conceptos.descuentos.forEach((descuento, descIndex) => {
            const descripcion = descuento.descripcion?.toLowerCase() || '';
            const codigo = descuento.codigo || descuento.codigoPlame || '';
            const monto = parseFloat(descuento.monto || 0);
            
            //console.log(`\n📋 Descuento ${descIndex + 1}:`);
            //console.log(`  • Descripción Original: "${descuento.descripcion}"`);
            //console.log(`  • Descripción Lowercase: "${descripcion}"`);
            //console.log(`  • Código: "${codigo}"`);
            //console.log(`  • Monto: S/ ${monto.toFixed(2)}`);
            
            // 🔍 ANÁLISIS DETALLADO DE CRITERIOS PARA APORTACIÓN OBLIGATORIA - SOLO AFP
            let esAportacionObligatoria = false;
            let criterioUsado = '';
            let aportacionAnterior = aportacionObligatoria;
            
            // ✅ CRITERIOS BASADOS ÚNICAMENTE EN CÓDIGOS PLAME REALES DEL SISTEMA
            
            // ÚNICO CRITERIO: Código PLAME 0608 (APORTACIÓN OBLIGATORIA AFP)
            if (codigo === '0608') {
              esAportacionObligatoria = true;
              criterioUsado = 'Código PLAME: 0608 (Aportación Obligatoria AFP)';
              contadorAportacion.criterios.codigo0601 += monto; // Mantengo la variable para no romper el contador
            }
            // ❌ NO SE ACEPTAN OTROS CRITERIOS - SOLO CÓDIGO PLAME OFICIAL

            if (esAportacionObligatoria) {
              aportacionObligatoria += monto;
              contadorAportacion.total += monto;
              contadorAportacion.items.push({
                descripcion: descuento.descripcion,
                codigo: codigo,
                monto: monto,
                criterio: criterioUsado
              });
              
              //console.log(`  ✅ CLASIFICADO COMO: Aportación Obligatoria`);
              //console.log(`  📌 Criterio usado: ${criterioUsado}`);
              //console.log(`  📊 Aportación antes: S/ ${aportacionAnterior.toFixed(2)}`);
              //console.log(`  📊 Monto sumado: S/ ${monto.toFixed(2)}`);
              //console.log(`  📊 Aportación después: S/ ${aportacionObligatoria.toFixed(2)}`);
            }
            // ✅ COMISIÓN AFP - CÓDIGO PLAME 0601 (REAL DEL SISTEMA)
            else if (codigo === '0601') {
              comisionPorcentual += monto;
              //console.log(`  ✅ CLASIFICADO COMO: Comisión AFP`);
              //console.log(`  📌 Criterio: Código PLAME 0601 (Comisión Porcentual AFP)`);
            }
            // ✅ PRIMA DE SEGURO AFP - CÓDIGO PLAME 0606 (REAL DEL SISTEMA)
            else if (codigo === '0606') {
              primaSeguro += monto;
              //console.log(`  ✅ CLASIFICADO COMO: Prima de Seguro AFP`);
              //console.log(`  📌 Criterio: Código PLAME 0606 (Prima de Seguro AFP)`);
            }
            else {
              //console.log(`  ❌ NO CLASIFICADO: No tiene código PLAME AFP válido`);
              //console.log(`  🔍 Códigos PLAME AFP válidos EN ESTE SISTEMA:`);
              //console.log(`    • 0608 = Aportación Obligatoria AFP (10%)`);
              //console.log(`    • 0601 = Comisión Porcentual AFP`);
              //console.log(`    • 0606 = Prima de Seguro AFP`);
              //console.log(`  📋 Código actual: "${codigo}"`);
              //console.log(`  ⚠️ Este descuento NO será incluido en los cálculos AFP`);
            }
          });
        }

        // 🔍 RESUMEN DETALLADO DE APORTACIÓN OBLIGATORIA
        //console.log(`\n🎯 === RESUMEN DETALLADO APORTACIÓN OBLIGATORIA ===`);
        //console.log(`📊 Total items clasificados: ${contadorAportacion.items.length}`);
        //console.log(`💰 TOTAL APORTACIÓN OBLIGATORIA: S/ ${aportacionObligatoria.toFixed(2)}`);
        //console.log(`\n📋 DESGLOSE POR CRITERIO:`);
        //console.log(`  • Por descripción "aportacion" + "obligatoria": S/ ${contadorAportacion.criterios.descripcionObligatoria.toFixed(2)}`);
        //console.log(`  • Por descripción "aporte" + "afp/10%": S/ ${contadorAportacion.criterios.aporteAfp.toFixed(2)}`);
        //console.log(`  • Por código PLAME 0601: S/ ${contadorAportacion.criterios.codigo0601.toFixed(2)}`);
        //console.log(`  • Por fallback AFP: S/ ${contadorAportacion.criterios.fallbackAfp.toFixed(2)}`);
        
        //console.log(`\n📋 ITEMS INDIVIDUALES:`);
        //contadorAportacion.items.forEach((item, idx) => {
        //  console.log(`  ${idx + 1}. "${item.descripcion}" (${item.codigo}) - S/ ${item.monto.toFixed(2)} [${item.criterio}]`);
        //});
        //console.log(`================================================`);

        const totalDescuentosAfp = aportacionObligatoria + comisionPorcentual + primaSeguro;
        const esMinero = esRegimenMinero(empleado);
        const aportacionTrabajador0611 = esMinero
          ? obtenerMontoConceptoPorCodigo(empleado.conceptos?.descuentos, '0611')
          : 0;
        const aporteEmpleador0809 = esMinero
          ? obtenerMontoConceptoPorCodigo(empleado.conceptos?.aportes, '0809')
          : 0;

        if (esMinero) {
          resumen.tieneRegimenMinero = true;
        }

        // 🔍 LOG: Resumen del empleado
        //console.log(`\n💰 RESUMEN EMPLEADO ${empleado.nombre}:`);
        //console.log(`  • Aportación Obligatoria: S/ ${aportacionObligatoria.toFixed(2)}`);
        //console.log(`  • Comisión Porcentual: S/ ${comisionPorcentual.toFixed(2)}`);
        //console.log(`  • Prima de Seguro: S/ ${primaSeguro.toFixed(2)}`);
        //console.log(`  • TOTAL DESCUENTOS AFP: S/ ${totalDescuentosAfp.toFixed(2)}`);
        //console.log(`  • Neto a Pagar: S/ ${(empleado.totales?.netoAPagar || 0).toFixed(2)}`);
        //console.log(`==========================================`);

        resumen.afp[nombreAfp].empleados.push(empleado);
        resumen.afp[nombreAfp].totalEmpleados += 1;
        resumen.afp[nombreAfp].totalNeto += empleado.totales?.netoAPagar || 0;
        resumen.afp[nombreAfp].totalDescuentosAfp += totalDescuentosAfp;
        resumen.afp[nombreAfp].aportacionObligatoria += aportacionObligatoria;
        resumen.afp[nombreAfp].comisionPorcentual += comisionPorcentual;
        resumen.afp[nombreAfp].primaSeguro += primaSeguro;
        resumen.afp[nombreAfp].aportacionTrabajador0611 += aportacionTrabajador0611;
        resumen.afp[nombreAfp].aporteEmpleador0809 += aporteEmpleador0809;
        if (esMinero) {
          resumen.afp[nombreAfp].empleadosMinero += 1;
        }

        // 🔍 LOG: Acumulado actual de la AFP
        //console.log(`\n📈 ACUMULADO ACTUAL ${nombreAfp}:`);
        //console.log(`  👥 Empleados procesados: ${resumen.afp[nombreAfp].totalEmpleados}`);
        //console.log(`  💰 Total Aportación Obligatoria: S/ ${resumen.afp[nombreAfp].aportacionObligatoria.toFixed(2)}`);
        //console.log(`  💰 Total Comisión: S/ ${resumen.afp[nombreAfp].comisionPorcentual.toFixed(2)}`);
        //console.log(`  💰 Total Prima Seguro: S/ ${resumen.afp[nombreAfp].primaSeguro.toFixed(2)}`);
        //console.log(`  💰 TOTAL DESCUENTOS ${nombreAfp}: S/ ${resumen.afp[nombreAfp].totalDescuentosAfp.toFixed(2)}`);
        //console.log(`  💰 Total Neto: S/ ${resumen.afp[nombreAfp].totalNeto.toFixed(2)}`);
        //console.log(`==========================================\n`);
      } else {
        // EMPLEADO CON ONP
        let descuentosOnp = 0;
        
        // 🔍 LOG DETALLADO: Inicio de cálculo ONP para empleado
        //console.log(`\n🟣 === CÁLCULO ONP: ${empleado.nombre} ===`);
        //console.log(`📊 Total descuentos disponibles: ${empleado.conceptos?.descuentos?.length || 0}`);
        
        // 🔍 CONTADOR DETALLADO para ONP
        let contadorOnp = {
          total: 0,
          items: [],
          criterio: {
            codigo0607: 0
          }
        };
        
        if (empleado.conceptos?.descuentos) {
          empleado.conceptos.descuentos.forEach((descuento, descIndex) => {
            const descripcion = descuento.descripcion?.toLowerCase() || '';
            const codigo = descuento.codigo || descuento.codigoPlame || '';
            const monto = parseFloat(descuento.monto || 0);
            
            //console.log(`\n📋 Descuento ${descIndex + 1}:`);
            //console.log(`  • Descripción Original: "${descuento.descripcion}"`);
            //console.log(`  • Descripción Lowercase: "${descripcion}"`);
            //console.log(`  • Código: "${codigo}"`);
            //console.log(`  • Monto: S/ ${monto.toFixed(2)}`);
            
            // 🔍 ANÁLISIS DETALLADO DE CRITERIOS PARA ONP - SOLO CÓDIGO PLAME REAL
            let esDescuentoOnp = false;
            let criterioUsado = '';
            let onpAnterior = descuentosOnp;
            
            // ✅ CRITERIOS BASADOS ÚNICAMENTE EN CÓDIGOS PLAME REALES DEL SISTEMA
            
            // ÚNICO CRITERIO: Código PLAME 0607 (ONP - SISTEMA NACIONAL DE PENSIONES)
            if (codigo === '0607') {
              esDescuentoOnp = true;
              criterioUsado = 'Código PLAME: 0607 (ONP - Sistema Nacional de Pensiones)';
              contadorOnp.criterio.codigo0607 += monto;
            }
            // ❌ NO SE ACEPTAN OTROS CRITERIOS - SOLO CÓDIGO PLAME OFICIAL
            
            if (esDescuentoOnp) {
              descuentosOnp += monto;
              contadorOnp.total += monto;
              contadorOnp.items.push({
                descripcion: descuento.descripcion,
                codigo: codigo,
                monto: monto,
                criterio: criterioUsado
              });
              
              //console.log(`  ✅ CLASIFICADO COMO: Descuento ONP`);
              //console.log(`  📌 Criterio usado: ${criterioUsado}`);
              //console.log(`  📊 ONP antes: S/ ${onpAnterior.toFixed(2)}`);
              //console.log(`  📊 Monto sumado: S/ ${monto.toFixed(2)}`);
              //console.log(`  📊 ONP después: S/ ${descuentosOnp.toFixed(2)}`);
            } else {
              //console.log(`  ❌ NO CLASIFICADO: No tiene código PLAME ONP válido`);
              //console.log(`  🔍 Código PLAME ONP válido EN ESTE SISTEMA:`);
              //console.log(`    • 0607 = ONP - Sistema Nacional de Pensiones (13%)`);
              //console.log(`  📋 Código actual: "${codigo}"`);
              //console.log(`  ⚠️ Este descuento NO será incluido en los cálculos ONP`);
            }
          });
        }
        
        // 🔍 RESUMEN DETALLADO DE ONP
        //console.log(`\n🎯 === RESUMEN DETALLADO ONP ===`);
        //console.log(`📊 Total items clasificados: ${contadorOnp.items.length}`);
        //console.log(`💰 TOTAL DESCUENTOS ONP: S/ ${descuentosOnp.toFixed(2)}`);
        //console.log(`\n📋 DESGLOSE POR CRITERIO:`);
        //console.log(`  • Por código PLAME 0607: S/ ${contadorOnp.criterio.codigo0607.toFixed(2)}`);
        
        //console.log(`\n📋 ITEMS INDIVIDUALES:`);
        contadorOnp.items.forEach((item, idx) => {
          //console.log(`  ${idx + 1}. "${item.descripcion}" (${item.codigo}) - S/ ${item.monto.toFixed(2)} [${item.criterio}]`);
        });
        //console.log(`================================================`);
        
        //console.log(`  💰 Total ONP para ${empleado.nombre}: S/ ${descuentosOnp.toFixed(2)}`);
        
        // Si no hay descuentos específicos de ONP, verificar si debería tener alguno
        if (descuentosOnp === 0 && empleado.conceptos?.descuentos && empleado.conceptos.descuentos.length > 0) {
          //console.log(`  ⚠️ ALERTA: Empleado ONP sin descuentos pensionarios. Total descuentos: ${empleado.totales?.totalDescuentos || 0}`);
          // Como fallback, si es empleado ONP y no tiene descuentos pensionarios específicos,
          // podríamos considerar un porcentaje de sus ingresos (13% estándar ONP)
          const posibleDescuentoOnp = (empleado.totales?.totalIngresos || 0) * 0.13;
          if (posibleDescuentoOnp > 0) {
            //console.log(`    🔄 Aplicando descuento estimado ONP (13%): S/ ${posibleDescuentoOnp.toFixed(2)}`);
            // Por ahora solo lo reportamos, no lo sumamos automáticamente
          }
        }

        // 🔍 LOG: Resumen del empleado ONP
        //console.log(`\n💰 RESUMEN EMPLEADO ONP ${empleado.nombre}:`);
        //console.log(`  • Descuentos ONP: S/ ${descuentosOnp.toFixed(2)}`);
        //console.log(`  • Neto a Pagar: S/ ${(empleado.totales?.netoAPagar || 0).toFixed(2)}`);
        //console.log(`==========================================`);

        resumen.onp.empleados.push(empleado);
        resumen.onp.totalEmpleados += 1;
        resumen.onp.totalNeto += empleado.totales?.netoAPagar || 0;
        resumen.onp.totalDescuentos += descuentosOnp;
        
        // 🔍 LOG: Acumulado actual de ONP
        //console.log(`\n📈 ACUMULADO ACTUAL ONP:`);
        //console.log(`  👥 Empleados procesados: ${resumen.onp.totalEmpleados}`);
        //console.log(`  💰 Total Descuentos ONP: S/ ${resumen.onp.totalDescuentos.toFixed(2)}`);
        //console.log(`  💰 Total Neto: S/ ${resumen.onp.totalNeto.toFixed(2)}`);
        //console.log(`==========================================\n`);
      }

      // ESSALUD - todos los empleados deberían tener aporte a ESSALUD
      const aporteEssalud = empleado.conceptos?.aportes?.find(aporte => 
        aporte.descripcion?.toLowerCase().includes('essalud') || 
        aporte.descripcion?.toLowerCase().includes('es salud') ||
        aporte.codigo === '0702' ||
        aporte.codigoPlame === '0702'
      );
      
      // ✅ Si se encuentra el aporte ESSALUD, usar su monto; si no, usar 0
      const montoEssalud = aporteEssalud?.monto || 0;
      
      if (aporteEssalud || empleado.totales?.totalAportes > 0) {
        resumen.essalud.empleados.push({
          ...empleado,
          aporteEssalud: montoEssalud
        });
        resumen.essalud.totalEmpleados += 1;
        resumen.essalud.totalAporte += montoEssalud;
      }

      if (esRegimenMinero(empleado)) {
        const monto0616 = obtenerMontoConceptoPorCodigo(empleado.conceptos?.descuentos, '0616');
        resumen.fcjmus0616.totalAporte += monto0616;
        if (monto0616 > 0) {
          resumen.fcjmus0616.totalEmpleados += 1;
        }
      }
    });

    // Resumen específico de ONP
    //console.log(`\n🟣 === RESUMEN ONP ===`);
    //console.log(`👥 Total empleados ONP: ${resumen.onp.totalEmpleados}`);
    //console.log(`💰 Total descuentos ONP: S/ ${resumen.onp.totalDescuentos.toFixed(2)}`);
    if (resumen.onp.totalEmpleados > 0 && resumen.onp.totalDescuentos === 0) {
      //console.log(`⚠️ PROBLEMA: Hay ${resumen.onp.totalEmpleados} empleados ONP pero el total de descuentos es S/ 0.00`);
      //console.log(`💡 Esto podría indicar que los descuentos ONP no se están detectando correctamente`);
    }
    
    // Verificar clasificación completa
    const totalAfp = Object.values(resumen.afp).reduce((sum, afp) => sum + afp.totalEmpleados, 0);
    const totalClasificados = totalAfp + resumen.onp.totalEmpleados;
    
    if (totalClasificados !== empleadosParaVista.length) {
        //console.warn(`⚠️ ALERTA: ${empleadosParaVista.length - totalClasificados} empleados NO CLASIFICADOS en sistemas pensionarios`);
    }

    // 🔍 DEBUG: Resumen final de clasificación
    //console.log(`\n📊 === RESUMEN FINAL SISTEMAS PENSIONARIOS ===`);
    //console.log(`👥 Total empleados procesados: ${empleadosParaVista.length}`);
    //console.log(`🏦 Empleados AFP por sistema:`);
    Object.entries(resumen.afp).forEach(([afp, data]) => {
      //console.log(`  - ${afp}: ${data.totalEmpleados} empleados, S/ ${data.totalDescuentosAfp.toFixed(2)}`);
    });
         //console.log(`🟣 Empleados ONP: ${resumen.onp.totalEmpleados}, S/ ${resumen.onp.totalDescuentos.toFixed(2)}`);
     //console.log(`🟢 Empleados ESSALUD: ${resumen.essalud.totalEmpleados}, S/ ${resumen.essalud.totalAporte.toFixed(2)}`);
     
     // Calcular total general AFP
     const totalGeneralAfp = Object.values(resumen.afp).reduce((sum, afp) => {
       const totalAfp = afp.totalDescuentosAfp
         + (resumen.tieneRegimenMinero ? (afp.aportacionTrabajador0611 + afp.aporteEmpleador0809) : 0);
       return sum + totalAfp;
     }, 0);
     resumen.totalGeneralAfp = totalGeneralAfp;
     //console.log(`💰 TOTAL GENERAL ONP: S/ ${resumen.onp.totalDescuentos.toFixed(2)}`);

    // 🔍 ARRAY DETALLADO POR AFP PARA COMPARACIÓN
    //console.log(`\n📋 === ARRAYS DETALLADOS POR AFP (PARA COMPARACIÓN) ===`);
    Object.entries(resumen.afp).forEach(([nombreAfp, dataAfp]) => {
      //console.log(`\n🏦 ${nombreAfp.toUpperCase()} - ${dataAfp.totalEmpleados} empleados:`);
      
      // Array de aportaciones obligatorias
      const aportacionesArray = [];
      const comisionesArray = [];
      const primasArray = [];
      const totalesAfpArray = [];
      const netosArray = [];
      
      dataAfp.empleados.forEach((empleado, idx) => {
        // Calcular los montos individuales del empleado
        let aportacionEmpleado = 0;
        let comisionEmpleado = 0;
        let primaEmpleado = 0;
        
        if (empleado.conceptos?.descuentos) {
          empleado.conceptos.descuentos.forEach(descuento => {
            const descripcion = descuento.descripcion?.toLowerCase() || '';
            const codigo = descuento.codigo || descuento.codigoPlame || '';
            const monto = parseFloat(descuento.monto || 0);
            
            // ✅ SOLO CÓDIGOS PLAME REALES DEL SISTEMA
            if (codigo === '0608') {
              // Aportación Obligatoria AFP (10%)
              aportacionEmpleado += monto;
            }
            else if (codigo === '0601') {
              // Comisión Porcentual AFP
              comisionEmpleado += monto;
            }
            else if (codigo === '0606') {
              // Prima de Seguro AFP
              primaEmpleado += monto;
            }
          });
        }
        
        const totalAfpEmpleado = aportacionEmpleado + comisionEmpleado + primaEmpleado;
        const netoEmpleado = empleado.totales?.netoAPagar || 0;
        
        aportacionesArray.push(aportacionEmpleado);
        comisionesArray.push(comisionEmpleado);
        primasArray.push(primaEmpleado);
        totalesAfpArray.push(totalAfpEmpleado);
        netosArray.push(netoEmpleado);
      });
      
      // Mostrar arrays para copy/paste fácil
      //console.log(`\n💰 APORTACIONES OBLIGATORIAS (${aportacionesArray.length} empleados):`);
      //console.log(`[${aportacionesArray.map(m => m.toFixed(2)).join(', ')}]`);
      //console.log(`📊 SUMA: S/ ${aportacionesArray.reduce((sum, m) => sum + m, 0).toFixed(2)}`);
      
      //console.log(`\n💳 COMISIONES (${comisionesArray.length} empleados):`);
      //console.log(`[${comisionesArray.map(m => m.toFixed(2)).join(', ')}]`);
      //console.log(`📊 SUMA: S/ ${comisionesArray.reduce((sum, m) => sum + m, 0).toFixed(2)}`);
      
      //console.log(`\n🛡️ PRIMAS DE SEGURO (${primasArray.length} empleados):`);
      //console.log(`[${primasArray.map(m => m.toFixed(2)).join(', ')}]`);
      //console.log(`📊 SUMA: S/ ${primasArray.reduce((sum, m) => sum + m, 0).toFixed(2)}`);
      
      //console.log(`\n🏦 TOTAL AFP POR EMPLEADO (${totalesAfpArray.length} empleados):`);
      //console.log(`[${totalesAfpArray.map(m => m.toFixed(2)).join(', ')}]`);
      //console.log(`📊 SUMA TOTAL AFP: S/ ${totalesAfpArray.reduce((sum, m) => sum + m, 0).toFixed(2)}`);
      
      //console.log(`\n💵 NETO A PAGAR (${netosArray.length} empleados):`);
      //console.log(`[${netosArray.map(m => m.toFixed(2)).join(', ')}]`);
      //console.log(`📊 SUMA NETOS: S/ ${netosArray.reduce((sum, m) => sum + m, 0).toFixed(2)}`);
      
      // Lista con nombres y montos para identificar empleados
      //console.log(`\n👥 DETALLE EMPLEADO POR EMPLEADO:`);
      dataAfp.empleados.forEach((empleado, idx) => {
        //console.log(`  ${idx + 1}. ${empleado.nombre}: Aportación S/ ${aportacionesArray[idx].toFixed(2)}, Total AFP S/ ${totalesAfpArray[idx].toFixed(2)}, Neto S/ ${netosArray[idx].toFixed(2)}`);
      });
      
             //console.log(`\n==========================================`);
     });
     
     // 🔍 ARRAY DETALLADO PARA ONP
     if (resumen.onp.totalEmpleados > 0) {
       //console.log(`\n🟣 === ARRAYS DETALLADOS PARA ONP (PARA COMPARACIÓN) ===`);
       //console.log(`\n🟣 ONP - ${resumen.onp.totalEmpleados} empleados:`);
       
       // Array de descuentos ONP
       const descuentosOnpArray = [];
       const netosOnpArray = [];
       
       resumen.onp.empleados.forEach((empleado, idx) => {
         // Calcular los montos individuales del empleado ONP
         let descuentoEmpleado = 0;
         
         if (empleado.conceptos?.descuentos) {
           empleado.conceptos.descuentos.forEach(descuento => {
             const codigo = descuento.codigo || descuento.codigoPlame || '';
             const monto = parseFloat(descuento.monto || 0);
             
             // ✅ SOLO CÓDIGO PLAME REAL DEL SISTEMA ONP
             if (codigo === '0607') {
               // Descuento ONP - Sistema Nacional de Pensiones (13%)
               descuentoEmpleado += monto;
             }
           });
         }
         
         const netoEmpleado = empleado.totales?.netoAPagar || 0;
         
         descuentosOnpArray.push(descuentoEmpleado);
         netosOnpArray.push(netoEmpleado);
       });
       
       // Mostrar arrays para copy/paste fácil
       //console.log(`\n💰 DESCUENTOS ONP (${descuentosOnpArray.length} empleados):`);
       //console.log(`[${descuentosOnpArray.map(m => m.toFixed(2)).join(', ')}]`);
       //console.log(`📊 SUMA: S/ ${descuentosOnpArray.reduce((sum, m) => sum + m, 0).toFixed(2)}`);
       
       //console.log(`\n💵 NETO A PAGAR ONP (${netosOnpArray.length} empleados):`);
       //console.log(`[${netosOnpArray.map(m => m.toFixed(2)).join(', ')}]`);
       //console.log(`📊 SUMA NETOS: S/ ${netosOnpArray.reduce((sum, m) => sum + m, 0).toFixed(2)}`);
       
       // Lista con nombres y montos para identificar empleados
       //console.log(`\n👥 DETALLE EMPLEADO POR EMPLEADO (ONP):`);
       resumen.onp.empleados.forEach((empleado, idx) => {
         //console.log(`  ${idx + 1}. ${empleado.nombre}: Descuento ONP S/ ${descuentosOnpArray[idx].toFixed(2)}, Neto S/ ${netosOnpArray[idx].toFixed(2)}`);
       });
       
       //console.log(`\n==========================================`);
     }
     
     //console.log(`==============================================\n`);

    return resumen;
  };

  // Calcular el resumen de sistemas pensionarios
  const resumenSistemasPensionarios = calcularResumenSistemasPensionarios();

  // Función para verificar que todos los tareos estén completos
  const verificarTareosCompletos = () => {
    if (!empleadosParaVista || empleadosParaVista.length === 0) {
      return { completos: false, mensaje: 'No hay empleados para verificar.' };
    }

    const empleadosConTareoIncompleto = [];
    
    empleadosParaVista.forEach(empleado => {
      const tareoStatus = getTareoStatus(
        empleado.tareos, 
        empleado, 
        planillaParaVista.fecha_inicio, 
        planillaParaVista.fecha_fin
      );
      
      if (tareoStatus.status === 'incompleto') {
        empleadosConTareoIncompleto.push({
          nombre: empleado.nombre_completo,
          diasRegistrados: tareoStatus.diasRegistrados,
          diasQueDebia: tareoStatus.diasQueDebiaTrabajar
        });
      }
    });

    if (empleadosConTareoIncompleto.length > 0) {
      const mensaje = `❌ NO SE PUEDE CERRAR LA PLANILLA\n\nLos tareos están incompletos.`;
      
      return { completos: false, mensaje };
    }

    return { completos: true };
  };

  const handleAbrirJatsa = async () => {
    if (!id || abriendoJatsa) {
      return;
    }
    const periodo = (planillaReal || planilla)?.periodo || (planillaReal || planilla)?.nombre;
    const popup = window.open('about:blank', '_blank');
    if (!popup) {
      alert('El navegador bloqueó la pestaña. Permite ventanas emergentes para Jatsa.');
      return;
    }
    setAbriendoJatsa(true);
    try {
      const respuesta = await planillaCierreService.enlaceJatsa(id);
      const baseJatsa = String(
        respuesta?.data?.frontend_url || ENV_CONFIG.JATSA_FRONTEND_URL || '',
      ).replace(/\/+$/, '');
      const hrefConSesion = urlFichaCerradaJatsaConSesion(
        periodo,
        baseJatsa,
        respuesta?.data?.token,
      );
      const hrefBase = urlFichaCerradaJatsa(periodo, baseJatsa);
      if (!hrefConSesion && !hrefBase) {
        popup.close();
        alert('No se pudo armar el enlace a Jatsa. Revisa JATSA_FRONTEND_URL en el servidor.');
        return;
      }
      popup.location.replace(hrefConSesion || hrefBase);
    } catch (error) {
      console.error('No se pudo abrir Jatsa con sesión', error);
      const hrefRespaldo = urlFichaCerradaJatsa(periodo, ENV_CONFIG.JATSA_FRONTEND_URL);
      if (hrefRespaldo) {
        popup.location.replace(hrefRespaldo);
      } else {
        popup.close();
        alert('No se pudo abrir Jatsa con sesión.');
      }
    } finally {
      setAbriendoJatsa(false);
    }
  };

  const handleReenviarJatsa = async () => {
    if (!id || reenviandoJatsa) {
      return;
    }
    setReenviandoJatsa(true);
    try {
      const respuesta = await planillaCierreService.reenviarAJatsa(id);
      if (respuesta?.success && respuesta.data) {
        setPlanillaReal((prev) => ({
          ...(prev || {}),
          jatsa_estado: respuesta.data.jatsa_estado,
          jatsa_enviado_en: respuesta.data.jatsa_enviado_en,
          jatsa_error: respuesta.data.jatsa_error,
        }));
        alert(mensajeReenvioJatsa(true));
      } else {
        alert(mensajeReenvioJatsa(false));
      }
    } catch (error) {
      console.error('No se pudo reenviar a Jatsa', error);
      alert(mensajeReenvioJatsa(false));
    } finally {
      setReenviandoJatsa(false);
    }
  };

  const aplicarEstadoConceptosJatsa = (data) => {
    if (!data) return;
    setPlanillaReal((prev) => ({
      ...(prev || {}),
      jatsa_conceptos_estado: data.jatsa_conceptos_estado,
      jatsa_conceptos_aplicados_en: data.jatsa_conceptos_aplicados_en,
      jatsa_conceptos_error: data.jatsa_conceptos_error,
    }));
  };

  const handleConsultarConceptosJatsa = async ({ silencioso = false } = {}) => {
    if (!id || consultandoConceptosJatsa || aplicandoConceptosJatsa) {
      return;
    }
    setConsultandoConceptosJatsa(true);
    try {
      const respuesta = await planillaCierreService.consultarConceptosPlameJatsa(id);
      aplicarEstadoConceptosJatsa(respuesta?.data);
      setJatsaConceptosInspeccion(inspeccionDesdeRespuestaConceptosJatsa(respuesta));
      if (!silencioso && respuesta?.disponible) {
        alert(
          `Jatsa publicó conceptos PLAME (${respuesta.data?.trabajadores || 0} trabajadores).`
        );
      }
    } catch (error) {
      console.error('No se pudo consultar conceptos Jatsa', error);
      if (!silencioso) {
        alert('No se pudo consultar conceptos PLAME en Jatsa.');
      }
    } finally {
      setConsultandoConceptosJatsa(false);
    }
  };

  const handleVerDatosConceptosJatsa = async () => {
    if (!id || consultandoConceptosJatsa || aplicandoConceptosJatsa || cargandoInspeccionJatsa) {
      return;
    }
    setJatsaConceptosApiModalAbierto(true);
    setCargandoInspeccionJatsa(true);
    try {
      const respuesta = await planillaCierreService.consultarConceptosPlameJatsa(id);
      aplicarEstadoConceptosJatsa(respuesta?.data);
      setJatsaConceptosInspeccion(inspeccionDesdeRespuestaConceptosJatsa(respuesta));
    } catch (error) {
      console.error('No se pudo obtener datos de conceptos Jatsa', error);
      setJatsaConceptosInspeccion({
        consultadoEn: new Date().toLocaleString(),
        disponible: false,
        jatsa_api: error.response?.data ?? { error: error.message || 'Error al consultar Jatsa' },
        paquete_plame: null,
        jatsa_http_status: error.response?.status ?? null,
      });
    } finally {
      setCargandoInspeccionJatsa(false);
    }
  };

  const handleAplicarConceptosJatsa = async () => {
    if (!id || aplicandoConceptosJatsa) {
      return;
    }
    setAplicandoConceptosJatsa(true);
    try {
      const respuesta = await planillaCierreService.aplicarConceptosPlameJatsa(id);
      aplicarEstadoConceptosJatsa(respuesta?.data);
      if (respuesta?.data?.jatsa_api || respuesta?.data?.paquete_plame) {
        setJatsaConceptosInspeccion(inspeccionDesdeRespuestaConceptosJatsa({
          disponible: true,
          data: respuesta.data,
        }));
      }
      if (respuesta?.success) {
        if (respuesta.data?.reabierta || respuesta.data?.reabrir) {
          marcarAutoRecerrarJatsa(id);
          setAutoRecerrandoJatsa(true);
          window.location.reload();
          return;
        }
        alert(mensajeAplicarConceptosJatsa(true, false));
      } else {
        alert(respuesta?.error || mensajeAplicarConceptosJatsa(false));
      }
    } catch (error) {
      const data = error.response?.data;
      aplicarEstadoConceptosJatsa(data?.data);
      alert(data?.error || mensajeAplicarConceptosJatsa(false));
    } finally {
      setAplicandoConceptosJatsa(false);
    }
  };

  const confirmarRevertirJatsa = async () => {
    if (!id || revirtiendoJatsa) {
      return;
    }
    setRevirtiendoJatsa(true);
    try {
      const respuesta = await planillaCierreService.revertirSincronizacionJatsa(id);
      aplicarEstadoConceptosJatsa(respuesta?.data);
      if (respuesta?.success) {
        if (respuesta.data?.reabierta || respuesta.data?.reabrir) {
          marcarAutoRecerrarJatsa(id, 'revertir');
          setAutoRecerrandoJatsa(true);
          window.location.reload();
          return;
        }
        alert(mensajeRevertirJatsa(true));
      } else {
        alert(respuesta?.error || mensajeRevertirJatsa(false));
      }
    } catch (error) {
      const data = error.response?.data;
      aplicarEstadoConceptosJatsa(data?.data);
      alert(data?.error || mensajeRevertirJatsa(false));
    } finally {
      setRevirtiendoJatsa(false);
    }
  };

  const handleRevertirJatsa = () => {
    setConfirmModal({
      isOpen: true,
      type: 'warning',
      title: 'Revertir sincronización Jatsa',
      message:
        'Se retira esta planilla del módulo Jatsa y se quitan los conceptos 0909, 0902 y 0917 que trajo. La planilla se recierra sin volver a enviarla. Los bonos originales de ficha se conservan.',
      confirmText: 'Revertir',
      onConfirm: () => confirmarRevertirJatsa(),
    });
  };

  useEffect(() => {
    if (!id || !planillaCerrada || !planillaReal?.jatsa_ingesta_enabled) {
      return undefined;
    }
    if (String(planillaReal?.jatsa_conceptos_estado || '').toLowerCase() === 'aplicado') {
      return undefined;
    }
    let cancelado = false;
    const consultar = async () => {
      try {
        const respuesta = await planillaCierreService.consultarConceptosPlameJatsa(id);
        if (!cancelado) {
          aplicarEstadoConceptosJatsa(respuesta?.data);
        }
      } catch (_) {
        // silencio: el botón Consultar Jatsa muestra el error
      }
    };
    consultar();
    const timer = setInterval(consultar, 20000);
    return () => {
      cancelado = true;
      clearInterval(timer);
    };
  }, [id, planillaCerrada, planillaReal?.jatsa_ingesta_enabled, planillaReal?.jatsa_conceptos_estado]);

  const idsEsperadosPeriodoPlanilla = () =>
    filtrarEmpleadosPorComputoRh(empleadosActivosPlanilla).map((e) => Number(e.id));

  const idEmpleadoEnPlanilla = (emp) => {
    const n = Number(emp?.id ?? emp?.empleado_id);
    return Number.isFinite(n) && n > 0 ? n : null;
  };

  const mezclarCalculadosConPreCierres = (calculados, idsFoto = empleadosFotografiadosIds, snaps = snapshotsPreCierre) => {
    const fotografiados = (snaps || []).filter((e) => {
      const id = idEmpleadoEnPlanilla(e);
      return id != null && idsFoto.has(id);
    });
    const restantes = (calculados || []).filter((e) => {
      const id = idEmpleadoEnPlanilla(e);
      return id == null || !idsFoto.has(id);
    });
    return [...fotografiados, ...restantes];
  };

  const cargarPreCierresPlanilla = async () => {
    if (!id || planillaReal?.estado === 'cerrada') {
      return;
    }
    try {
      const lista = await planillaCierreService.listarFotografiados(parseInt(id, 10));
      if (!lista.success) {
        return;
      }
      const ids = new Set((lista.data?.empleado_ids || []).map((x) => Number(x)));
      setEmpleadosFotografiadosIds(ids);
      if (ids.size === 0) {
        setSnapshotsPreCierre([]);
        return;
      }
      const datos = await planillaCierreService.obtenerSnapshotsPreCierreVista(parseInt(id, 10));
      if (datos.success && Array.isArray(datos.data)) {
        const transformados = transformarEmpleadosCerradosParaVista(datos.data).map((e) => ({
          ...e,
          id: idEmpleadoEnPlanilla(e) ?? e.id,
          pre_cierre_guardado: true,
          boleta_calculada: e.boleta_calculada?.success
            ? e.boleta_calculada
            : datos.data.find((r) => idEmpleadoEnPlanilla(r) === idEmpleadoEnPlanilla(e))?.boleta_calculada,
        }));
        setSnapshotsPreCierre(transformados);
        setEmpleadosConBoletasCalculadas((prev) => {
          if (!prev?.length) {
            return prev;
          }
          return mezclarCalculadosConPreCierres(prev, ids, transformados);
        });
      }
    } catch (err) {
      console.error('Error cargando pre-cierres:', err);
    }
  };

  const enriquecerEmpleadosParaEnvioCierre = (empleadosParaCierre) => {
    const esPlanillaRHActual =
      planillaReal?.modalidad_planilla === 'planilla_rh' ||
      (planillaReal?.nombre &&
        (String(planillaReal.nombre).toUpperCase().trim() === 'RH' ||
          String(planillaReal.nombre).toUpperCase().includes('RH')));
    const regimenGeneral =
      regimenesLaborales.find((r) => String(r?.codigo || '').trim().toUpperCase() === 'RG') ||
      regimenesLaborales[0] ||
      null;

    return empleadosParaCierre.map((emp) => {
      let sueldoBasicoNum = 0;
      if (emp.sueldo_basico != null && emp.sueldo_basico !== '' && !isNaN(Number(emp.sueldo_basico))) {
        sueldoBasicoNum = Number(emp.sueldo_basico);
      } else if (emp.datosSalariales?.sueldoBasico != null && !isNaN(Number(emp.datosSalariales.sueldoBasico))) {
        sueldoBasicoNum = Number(emp.datosSalariales.sueldoBasico);
      } else {
        const conceptoRemu = emp.conceptos?.ingresos?.find(
          (c) =>
            (c.descripcion || '').toLowerCase().includes('remuneración') &&
            ((c.descripcion || '').toLowerCase().includes('básico') ||
              (c.descripcion || '').toLowerCase().includes('jornal')),
        );
        sueldoBasicoNum = conceptoRemu?.monto != null ? Number(conceptoRemu.monto) : 0;
      }

      const codigoRegimenEmpleado = String(emp.regimenLaboral || emp.datosSalariales?.regimenLaboral || '')
        .trim()
        .toUpperCase();
      const regimenPorCodigo = regimenesLaborales.find(
        (r) => String(r?.codigo || '').trim().toUpperCase() === codigoRegimenEmpleado,
      );

      const regimenLaboralIdResuelto =
        emp.regimen_laboral_id ||
        emp.regimenSeleccionado?.id ||
        regimenPorCodigo?.id ||
        (esPlanillaRHActual ? regimenGeneral?.id : null);

      return {
        ...emp,
        banco: emp.banco || null,
        cuenta_bancaria: emp.cuenta_bancaria || null,
        cci: emp.cci || null,
        regimen_laboral_id: regimenLaboralIdResuelto || null,
        sueldo_basico: sueldoBasicoNum,
        datosSalariales: {
          ...(emp.datosSalariales || {}),
          sueldoBasico: sueldoBasicoNum,
          montoViaticoStandard:
            emp.monto_viatico_standard ??
            emp.montoViaticoStandard ??
            emp.datosSalariales?.montoViaticoStandard ??
            emp.datosEmpleado?.monto_viatico_standard ??
            null,
        },
        monto_viatico_standard:
          emp.monto_viatico_standard ??
          emp.montoViaticoStandard ??
          emp.datosSalariales?.montoViaticoStandard ??
          emp.datosEmpleado?.monto_viatico_standard ??
          null,
        snapshot_interna: armarSnapshotInternaCierre({
          ...emp,
          monto_viatico_standard:
            emp.monto_viatico_standard ??
            emp.montoViaticoStandard ??
            emp.datosSalariales?.montoViaticoStandard ??
            emp.datosEmpleado?.monto_viatico_standard ??
            null,
        }),
      };
    });
  };

  const guardarPreCierreEmpleado = async (empleadoId) => {
    const idNum = Number(empleadoId);
    if (empleadosFotografiadosIds.has(idNum)) {
      alert('Este trabajador ya tiene pre-cierre guardado.');
      return;
    }
    const emp = empleadosConBoletasCalculadas.find((e) => Number(e.id) === idNum);
    if (!emp?.boleta_calculada?.success && !emp?.totales?.netoAPagar) {
      alert('Calcula la planilla de este trabajador antes de guardar el pre-cierre.');
      return;
    }
    setGuardandoPreCierreId(idNum);
    try {
      const [enriquecido] = enriquecerEmpleadosParaEnvioCierre([emp]);
      const resp = await planillaCierreService.fotografiarEmpleados(parseInt(id, 10), [enriquecido], {
        empleadosEsperadosIds: idsEsperadosPeriodoPlanilla(),
        completarSiListo: true,
      });
      if (!resp.success) {
        alert(resp.error || resp.message || 'No se pudo guardar el pre-cierre');
        return;
      }
      await cargarPreCierresPlanilla();
      if (resp.data?.planilla_cerrada) {
        setPlanillaCerrada(true);
        alert('Todos los trabajadores están guardados. La planilla quedó cerrada.');
        await cargarDatosPlanillaCerrada();
      } else {
        alert(`Pre-cierre guardado.\n\nGuardados: ${resp.data?.empleados_fotografiados ?? '—'} de ${idsEsperadosPeriodoPlanilla().length}`);
      }
    } catch (err) {
      console.error('Error guardando pre-cierre:', err);
      alert(err?.message || 'No se pudo guardar el pre-cierre');
    } finally {
      setGuardandoPreCierreId(null);
    }
  };

  const reabrirPreCierreEmpleado = async (empleadoId) => {
    const idNum = Number(empleadoId);
    if (!empleadosFotografiadosIds.has(idNum)) {
      return;
    }
    if (
      !window.confirm(
        '¿Quitar el pre-cierre de este trabajador?\n\nVolverá a calcularse con Recalcular planilla.'
      )
    ) {
      return;
    }
    setReabriendoPreCierreId(idNum);
    try {
      const resp = await planillaCierreService.reabrirEmpleadoPreCierre(parseInt(id, 10), idNum);
      if (!resp.success) {
        alert(resp.error || 'No se pudo quitar el pre-cierre');
        return;
      }
      setEmpleadosFotografiadosIds((prev) => {
        const next = new Set(prev);
        next.delete(idNum);
        return next;
      });
      setSnapshotsPreCierre((prev) => prev.filter((e) => idEmpleadoEnPlanilla(e) !== idNum));
      setEmpleadosConBoletasCalculadas((prev) => {
        const baseActivo = empleadosActivosPlanilla.find((e) => Number(e.id) === idNum);
        const sinSnapshot = (prev || []).filter((e) => idEmpleadoEnPlanilla(e) !== idNum);
        if (baseActivo && !sinSnapshot.some((e) => Number(e.id) === idNum)) {
          return [...sinSnapshot, baseActivo];
        }
        return sinSnapshot;
      });
      await cargarPreCierresPlanilla();
    } finally {
      setReabriendoPreCierreId(null);
    }
  };

  const sincronizarEmpleadosEnAjustePosterior = async () => {
    if (!id) return;
    try {
      const lista = await planillaCierreService.listarFotografiados(parseInt(id, 10));
      if (!lista.success) return;
      const ids = (lista.data?.empleados_en_ajuste_posterior || []).map((x) => Number(x));
      setEmpleadosEnAjustePosteriorIds(new Set(ids.filter((n) => Number.isFinite(n) && n > 0)));
    } catch (err) {
      console.error('Error sincronizando ajustes posteriores:', err);
    }
  };

  const fetchDepsCalculoAjustePosterior = async () => {
    const empresaId = selectedCompany?.id;
    const [
      afpsRes,
      infoGeneral,
      formulasRes,
      regimenesRes,
      construccionCtx,
      construccionFichas,
      plameRes,
      tramosRes,
      conceptosAfectosRes,
      conceptosNoVacRes,
      conceptosLicenciaRes,
      conceptosEstaticosRes,
      feriadosRes,
      descansoLabRes,
      tasaNoctRes,
      configTareoRes,
    ] = await Promise.all([
      afpService.obtenerAfps(),
      informacionGeneralService.obtenerInformacionActual(),
      formulaService.obtenerFormulas(),
      regimenLaboralService.getAll(),
      empresaId ? construccionCivilService.contexto(empresaId) : Promise.resolve({ data: {} }),
      empresaId ? construccionCivilService.fichas(empresaId) : Promise.resolve({ data: [] }),
      plameConfiguracionService.obtenerConfiguraciones({ per_page: 1000 }),
      tramoRentaService.obtenerTramosRenta(),
      empresaId
        ? conceptosAfectosTareosService.obtenerConceptosAfectos(empresaId)
        : Promise.resolve({ success: true, data: [] }),
      empresaId
        ? conceptosNoAfectanVacacionesService.obtenerConceptos(empresaId)
        : Promise.resolve({ success: true, data: [] }),
      empresaId
        ? conceptosAfectanLicenciaGoceHaberService.obtenerConceptos(empresaId)
        : Promise.resolve({ success: true, data: [] }),
      empresaId
        ? reintentarConBackoff(() => conceptosEstaticosService.obtenerConceptosEstaticos(empresaId))
        : Promise.resolve({ success: true, data: [] }),
      empresaId
        ? feriadosPagoDobleService.obtenerFeriados(empresaId)
        : Promise.resolve({ success: true, data: [] }),
      empresaId
        ? configuracionDescansoLaboradoService.obtenerConfiguracion(empresaId)
        : Promise.resolve({ success: true, data: { pago_doble: false } }),
      empresaId
        ? configuracionTasaNocturnaService.obtenerConfiguracion(selectedCompany.id)
        : Promise.resolve({ success: true, data: null }),
      empresaId
        ? reintentarConBackoff(() => configuracionTareoService.obtenerConfiguracionTareo(empresaId))
        : Promise.resolve({ success: true, data: null }),
    ]);

    const afpsData = afpsRes?.success && afpsRes.data ? afpsRes.data : [];
    const formulasData =
      formulasRes?.success && formulasRes.data
        ? Array.isArray(formulasRes.data.data)
          ? formulasRes.data.data
          : Array.isArray(formulasRes.data)
            ? formulasRes.data
            : []
        : [];
    const regimenesData =
      regimenesRes?.success && Array.isArray(regimenesRes.data) ? regimenesRes.data : [];
    const construccionData = {
      parametros: construccionCtx?.data?.parametros || [],
      plame: construccionCtx?.data?.plame || [],
      obras: construccionCtx?.data?.obras || [],
      fichas: construccionFichas?.data || [],
    };
    let plameData = [];
    if (plameRes?.success && plameRes.data) {
      plameData = Array.isArray(plameRes.data.data)
        ? plameRes.data.data
        : Array.isArray(plameRes.data)
          ? plameRes.data
          : [];
    }
    const tramosData = tramosRes?.success && Array.isArray(tramosRes.data) ? tramosRes.data : [];
    const afectosData =
      conceptosAfectosRes?.success && Array.isArray(conceptosAfectosRes.data)
        ? conceptosAfectosRes.data
        : [];
    const noVacData =
      conceptosNoVacRes?.success && Array.isArray(conceptosNoVacRes.data)
        ? conceptosNoVacRes.data
        : [];
    const licenciaData =
      conceptosLicenciaRes?.success && Array.isArray(conceptosLicenciaRes.data)
        ? conceptosLicenciaRes.data
        : [];
    const estaticosData =
      conceptosEstaticosRes?.success && Array.isArray(conceptosEstaticosRes.data)
        ? conceptosEstaticosRes.data
        : [];
    const feriadosData =
      feriadosRes?.success && Array.isArray(feriadosRes.data) ? feriadosRes.data : [];
    const descansoLabData = descansoLabRes?.success
      ? { pago_doble: Boolean(descansoLabRes.data?.pago_doble) }
      : { pago_doble: false };
    const tasaNoctDefault = { activo: false, calcular_en_planilla: true, horas_tasa_nocturna: 8 };
    const tasaNoctData =
      tasaNoctRes?.success && tasaNoctRes.data ? tasaNoctRes.data : tasaNoctDefault;
    const configTareoDefault = {
      tipo_tareo: 2,
      descontar_descansos: true,
      modo_horas_simple: 'reales',
      es_simple: false,
      es_detallado: true,
      es_por_horas: false,
    };
    const configTareoData =
      configTareoRes?.success && configTareoRes.data ? configTareoRes.data : configTareoDefault;

    setAfps(afpsData);
    setInformacionGeneral(infoGeneral);
    setFormulas(formulasData);
    setRegimenesLaborales(regimenesData);
    setConstruccionCivilDatos(construccionData);
    setConfiguracionesPlame(plameData);
    setTramosRenta(tramosData);
    setConceptosAfectos(afectosData);
    setConceptosNoAfectanVacaciones(noVacData);
    setConceptosAfectanLicenciaGoceHaber(licenciaData);
    setConceptosEstaticos(estaticosData);
    setFeriadosPagoDobleConfig(feriadosData);
    setConfiguracionDescansoLaboradoConfig(descansoLabData);
    setConfiguracionTasaNocturnaConfig(tasaNoctData);
    setConfiguracionTareo(configTareoData);

    return {
      afps: afpsData,
      informacionGeneral: infoGeneral,
      formulas: formulasData,
      regimenesLaborales: regimenesData,
      construccionCivilDatos: construccionData,
      configuracionesPlame: plameData,
      tramosRenta: tramosData,
      conceptosAfectos: afectosData,
      conceptosNoAfectanVacaciones: noVacData,
      conceptosAfectanLicenciaGoceHaber: licenciaData,
      conceptosEstaticos: estaticosData,
      feriadosPagoDobleConfig: feriadosData,
      configuracionDescansoLaboradoConfig: descansoLabData,
      configuracionTasaNocturnaConfig: tasaNoctData,
      configuracionTareo: configTareoData,
    };
  };

  const asegurarDepsCalculoAjustePosterior = async (empleadoIdsObjetivo = null) => {
    let depsCalculo = null;
    if (!ajustePosteriorDepsCargadas) {
      depsCalculo = await fetchDepsCalculoAjustePosterior();
      setAjustePosteriorDepsCargadas(true);
    }

    const hibridos = await cargarEmpleadosConConceptos();
    const idsObjetivo = (empleadoIdsObjetivo?.length
      ? empleadoIdsObjetivo
      : [...empleadosEnAjustePosteriorIds]
    ).map((x) => Number(x)).filter((n) => Number.isFinite(n) && n > 0);

    const fuenteHibridos = Array.isArray(hibridos) && hibridos.length > 0 ? hibridos : empleadosConConceptos;

    const historialLaboralPreferido = (snap, live) => {
      if (Array.isArray(snap?.historial_laboral) && snap.historial_laboral.length > 0) {
        return snap.historial_laboral;
      }
      if (Array.isArray(live?.historial_laboral) && live.historial_laboral.length > 0) {
        return live.historial_laboral;
      }
      return [];
    };

    const enriquecidos = (empleadosActivosPlanilla || [])
      .filter((emp) => idsObjetivo.includes(Number(emp.id ?? emp.empleado_id)))
      .map((emp) => {
        const idEmp = Number(emp.id ?? emp.empleado_id);
        const live = fuenteHibridos.find((e) => Number(e.id ?? e.empleado_id) === idEmp);
        const fusionado = live
          ? {
              ...live,
              ...emp,
              conceptos: live.conceptos || emp.conceptos,
              liquidaciones_planilla: live.liquidaciones_planilla ?? emp.liquidaciones_planilla,
              gratificaciones_planilla: live.gratificaciones_planilla ?? emp.gratificaciones_planilla,
              historial_laboral: historialLaboralPreferido(emp, live),
              historial_laboral_interno:
                (Array.isArray(emp.historial_laboral_interno) && emp.historial_laboral_interno.length > 0
                  ? emp.historial_laboral_interno
                  : live.historial_laboral_interno) || [],
              fecha_ingreso_actual:
                emp.fecha_ingreso_actual
                || live.fecha_ingreso_actual
                || live.fecha_ingreso
                || emp.fecha_ingreso,
              fecha_ingreso:
                emp.fecha_ingreso
                || live.fecha_ingreso
                || emp.fecha_ingreso_actual
                || live.fecha_ingreso_actual,
              fecha_cese_actual: emp.fecha_cese_actual ?? live.fecha_cese_actual ?? null,
              fecha_cese: emp.fecha_cese ?? live.fecha_cese ?? null,
              regimen_laboral_id: emp.regimen_laboral_id ?? live.regimen_laboral_id,
              afp_id: emp.afp_id ?? live.afp_id,
              sueldo_basico: emp.sueldo_basico ?? live.sueldo_basico,
              sueldo_interno: emp.sueldo_interno ?? live.sueldo_interno,
              tareos: emp.tareos ?? live.tareos,
              resumenTareos: emp.resumenTareos ?? live.resumenTareos,
              boleta_calculada: emp.boleta_calculada,
              totales: emp.totales,
              totalesInternos: emp.totalesInternos,
            }
          : emp;
        return normalizarEmpleadoParaCalculoPlanilla(fusionado, planillaReal);
      });

    if (enriquecidos.length > 0) {
      const porId = new Map(enriquecidos.map((e) => [Number(e.id), e]));
      setEmpleadosActivosPlanilla((prev) =>
        (prev || []).map((e) => porId.get(Number(e.id)) || e),
      );
    }

    return { enriquecidos, depsCalculo };
  };

  const mezclarCalculadosPlanillaCerrada = (calculadosNuevos, listaBase = empleadosConBoletasCalculadas) => {
    const idsNuevos = new Set(
      (calculadosNuevos || []).map((e) => Number(e.id ?? e.empleado_id)),
    );
    const resto = (listaBase || []).filter(
      (e) => !idsNuevos.has(Number(e.id ?? e.empleado_id)),
    );
    return [...resto, ...(calculadosNuevos || [])];
  };

  const abrirAjustePosteriorEmpleado = async (empleadoId) => {
    const idNum = Number(empleadoId);
    if (!planillaCerrada || !Number.isFinite(idNum) || idNum <= 0) return;
    if (empleadosEnAjustePosteriorIds.has(idNum)) return;
    if (
      !window.confirm(
        '¿Reabrir este trabajador para ajustes posteriores?\n\nPodrá usar Consideraciones previas y recalcular solo su boleta hasta cerrar el ajuste.'
      )
    ) {
      return;
    }
    setAbriendoAjustePosteriorId(idNum);
    try {
      const resp = await planillaCierreService.abrirAjustePosteriorEmpleado(parseInt(id, 10), idNum);
      if (!resp.success) {
        alert(resp.error || 'No se pudo reabrir el trabajador');
        return;
      }
      const ids = (resp.data?.empleados_en_ajuste_posterior || [idNum]).map((x) => Number(x));
      setEmpleadosEnAjustePosteriorIds(new Set(ids.filter((n) => Number.isFinite(n) && n > 0)));
      const asegurar = await asegurarDepsCalculoAjustePosterior([idNum]);
      await procesarEmpleadosConPlanilla({
        omitirConfirmacion: true,
        soloAjustePosteriorIds: [idNum],
        empleadosAjustePosteriorEnriquecidos: asegurar.enriquecidos,
        depsCalculo: asegurar.depsCalculo,
      });
      setActiveTab('consideraciones');
    } finally {
      setAbriendoAjustePosteriorId(null);
    }
  };

  const cerrarAjustePosteriorEmpleado = async (empleadoId) => {
    const idNum = Number(empleadoId);
    if (!empleadosEnAjustePosteriorIds.has(idNum)) return;
    const emp = empleadosConBoletasCalculadas.find((e) => Number(e.id) === idNum);
    if (!emp?.boleta_calculada?.success && !emp?.totales?.netoAPagar) {
      alert('Recalcula la boleta de este trabajador antes de cerrar el ajuste.');
      return;
    }
    if (
      !window.confirm(
        '¿Cerrar ajuste y guardar la boleta actualizada?\n\nEl trabajador volverá a solo lectura.'
      )
    ) {
      return;
    }
    setCerrandoAjustePosteriorId(idNum);
    try {
      const [enriquecido] = enriquecerEmpleadosParaEnvioCierre([emp]);
      const resp = await planillaCierreService.cerrarAjustePosteriorEmpleado(
        parseInt(id, 10),
        idNum,
        [enriquecido],
      );
      if (!resp.success) {
        alert(resp.error || 'No se pudo cerrar el ajuste');
        return;
      }
      const ids = (resp.data?.empleados_en_ajuste_posterior || []).map((x) => Number(x));
      setEmpleadosEnAjustePosteriorIds(new Set(ids.filter((n) => Number.isFinite(n) && n > 0)));
      await cargarDatosPlanillaCerrada();
      alert('Ajuste posterior guardado. Boleta actualizada.');
    } catch (err) {
      console.error(err);
      alert(err?.message || 'Error al cerrar ajuste');
    } finally {
      setCerrandoAjustePosteriorId(null);
    }
  };

  const handleCerrarPlanilla = () => {
    // Verificar que todos los tareos estén completos antes de abrir el modal
    const validacionTareos = verificarTareosCompletos();
    
    if (!validacionTareos.completos) {
      alert(validacionTareos.mensaje);
      return; // No abrir el modal si los tareos no están completos
    }

    // Si todos los tareos están completos, abrir el modal de confirmación
    setConfirmModal({
      isOpen: true,
      type: 'success',
      title: 'Cerrar Planilla',
      message: anexarMensajeJatsa(
        '¿Está seguro que desea cerrar esta planilla? Esta acción no se puede deshacer y la planilla no podrá ser modificada.',
        mensajeCierreJatsa(planillaReal?.jatsa_ingesta_enabled)
      ),
      confirmText: 'Cerrar Planilla',
      onConfirm: () => confirmarCerrarPlanilla()
    });
  };

  const confirmarCerrarPlanilla = async ({ silencioso = false, recargaDetalle = false } = {}) => {
    try {
      console.log('🔄 === CERRANDO PLANILLA ===');
      console.log('🆔 Planilla ID:', id);
      setProgresoCierre({
        visible: true,
        progreso: 2,
        texto: silencioso
          ? 'Recerrando con conceptos Jatsa...'
          : 'Preparando envío por partes...',
      });
      
      // Verificar que los empleados estén calculados
      if (!empleadosConBoletasCalculadas || empleadosConBoletasCalculadas.length === 0) {
        alert('❌ ERROR: Debes calcular la planilla antes de cerrarla.\nHaz clic en "Calcular" primero.');
        return;
      }

      const empleadosParaCierre = filtrarEmpleadosPorComputoRh(empleadosConBoletasCalculadas);
      if (empleadosParaCierre.length === 0) {
        alert('❌ ERROR: No hay empleados que correspondan al cómputo RH de esta planilla para cerrar.');
        return;
      }
      
      // 🔧 VERIFICAR CONFIGURACIÓN DE TAREOS EN EMPLEADOS
      const empleadosConConfiguracion = empleadosParaCierre.filter(emp => emp.configuracion_tareo);
      //console.log(`⚙️ Empleados con configuración de tareos: ${empleadosConConfiguracion.length}/${empleadosConBoletasCalculadas.length}`);
      
      // Detectar si la planilla actual es RH para aplicar fallback de régimen laboral
      const empleadosConDatosBancarios = enriquecerEmpleadosParaEnvioCierre(empleadosParaCierre);

      // Si aún hay empleados sin régimen, detener el cierre con mensaje claro.
      const empleadosSinRegimen = empleadosConDatosBancarios.filter(emp => !emp.regimen_laboral_id);
      if (empleadosSinRegimen.length > 0) {
        const lista = empleadosSinRegimen.slice(0, 5).map(emp => `- ${emp.nombre_completo || `ID ${emp.id}`}`).join('\n');
        alert(
          `❌ ERROR: No se puede cerrar la planilla porque hay empleados sin régimen laboral.\n\n${lista}\n\n` +
          `Asigna un régimen laboral en Empleados y vuelve a intentar.`
        );
        return;
      }
      
      // 🔍 LOG PARA VERIFICAR DATOS BANCARIOS Y SUELDO BÁSICO
      console.log('💳 Verificando datos para cierre (bancarios + sueldo_basico):', empleadosConDatosBancarios.slice(0, 3).map(emp => ({
        id: emp.id,
        nombre: emp.nombre_completo,
        banco: emp.banco,
        cuenta_bancaria: emp.cuenta_bancaria,
        cci: emp.cci,
        regimen_laboral_id: emp.regimen_laboral_id,
        sueldo_basico: emp.sueldo_basico
      })));
      
      // Usar el nuevo servicio de cierre con datos calculados (cada empleado incluye su configuración de tareos)
      const response = await planillaCierreService.cerrarPlanillaCompleta(
        parseInt(id), 
        empleadosConDatosBancarios,
        {
          onProgress: (p) => {
            const enviando = p?.fase === 'enviando';
            setProgresoCierre({
              visible: true,
              progreso: p?.progreso ?? 0,
              texto: enviando
                ? `Enviando parte ${p.lote} de ${p.total}...`
                : (p?.fase === 'listo'
                  ? 'Cierre completado'
                  : 'Guardando el cierre en el servidor...'),
            });
          },
        }
      );
      //console.log('📨 Respuesta del servicio cierre planilla:', response);
      
      if (response.success) {
        //console.log('✅ Planilla cerrada exitosamente en el backend');
        //console.log('📊 Datos del cierre:', response.data);
      
      // Actualizar el estado local
      setPlanilla(prev => ({ ...prev, estado: 'cerrado' }));
      
        // Usar las nuevas estadísticas del backend
        const stats = response.estadisticas || response.data?.estadisticas || {};
        const fechaCierre = response.data?.fecha_cierre || new Date().toISOString();

        if (silencioso) {
          alert(
          motivoRecierreJatsa === 'revertir'
            ? mensajeRevertirJatsa(true)
            : mensajeAplicarConceptosJatsa(true)
        );
        } else {
          alert(anexarMensajeJatsa(
            `✅ ¡PLANILLA CERRADA EXITOSAMENTE!\n\n` +
                `📊 ESTADÍSTICAS DEL CIERRE:\n` +
                `👥 Empleados procesados: ${stats.empleados_procesados || empleadosParaCierre.length}\n` +
                `💰 Conceptos guardados: ${stats.conceptos_guardados || 0}\n` +
                `📅 Eventos guardados: ${stats.eventos_guardados || 0} (temporalmente deshabilitado)\n` +
                `⏰ Horas extras guardadas: ${stats.horas_extras_guardadas || 0} (temporalmente deshabilitado)\n` +
                `❌ Errores: ${(stats.errores && stats.errores.length) || 0}\n\n` +
                `📅 Fecha de cierre: ${new Date(fechaCierre).toLocaleString()}\n\n` +
                `🗂️ Todos los datos han sido almacenados permanentemente en la base de datos.\n` +
                `✅ La planilla ha sido cerrada y está lista para consultas y reportes.`,
            mensajeCierreJatsa(response.jatsa_ingesta_enabled ?? planillaReal?.jatsa_ingesta_enabled)
          ));
        }

        if (recargaDetalle) {
          window.location.reload();
          return;
        }

      // Redirigir a la lista de planillas después del cierre exitoso
      navigate('/planillas');
      } else {
        console.error('❌ Error en la respuesta del servicio:', response);
        
        // ❌ MANEJAR ERRORES CONTROLADOS DEL BACKEND
        if (response.es_error_controlado) {
          const errorData = response.data || {};
          
          let mensajeError = `❌ CIERRE DE PLANILLA FALLIDO\n\n`;
          mensajeError += `🚨 ERROR: ${response.error}\n\n`;
          
          if (response.detalle_error) {
            mensajeError += `📋 DETALLE: ${response.detalle_error}\n\n`;
          }
          
          if (errorData.empleados_enviados) {
            mensajeError += `📊 ESTADÍSTICAS DEL INTENTO:\n`;
            mensajeError += `👥 Empleados enviados: ${errorData.empleados_enviados}\n`;
            mensajeError += `✅ Empleados procesados antes del error: ${errorData.empleados_procesados_antes_error || 0}\n`;
            mensajeError += `💰 Conceptos guardados antes del error: ${errorData.conceptos_guardados_antes_error || 0}\n\n`;
          }
          
          mensajeError += `🔄 ESTADO: ${errorData.estado_planilla || 'No cerrada - Rollback completo realizado'}\n\n`;
          
          if (errorData.mensaje_usuario) {
            mensajeError += `💬 ${errorData.mensaje_usuario}\n\n`;
          }
          
          if (errorData.recomendacion) {
            mensajeError += `💡 RECOMENDACIÓN: ${errorData.recomendacion}`;
          }
          
          alert(mensajeError);
        } else {
          // ❌ ERRORES DE COMUNICACIÓN U OTROS
          let mensajeError = `❌ ERROR DE COMUNICACIÓN\n\n`;
          mensajeError += `🚨 ${response.error || 'Error desconocido'}\n\n`;
          
          if (response.http_status) {
            mensajeError += `🌐 Código HTTP: ${response.http_status}\n\n`;
          }
          
          mensajeError += `🔧 Verifica tu conexión a internet y que el servidor esté funcionando.\n`;
          mensajeError += `💡 Si el problema persiste, contacta al administrador del sistema.`;
          
          alert(mensajeError);
        }
      }
    } catch (error) {
      console.error('❌ Error al cerrar planilla:', error);
      console.error('❌ Error stack:', error.stack);
      
      alert(`❌ Error al cerrar planilla: ${error.message}\n\nPor favor verifica que la planilla esté calculada e inténtalo nuevamente.`);
    } finally {
      if (!recargaDetalle) {
        setProgresoCierre(null);
      }
    }
  };

  useEffect(() => {
    if (!autoRecerrandoJatsa || autoRecierreLanzado.current) {
      return undefined;
    }
    if (loading || planillaCerrada || calculandoPlanilla) {
      return undefined;
    }
    if (!empleadosConBoletasCalculadas.length) {
      return undefined;
    }
    autoRecierreLanzado.current = true;
    limpiarAutoRecerrarJatsa();
    const validacionTareos = verificarTareosCompletos();
    if (!validacionTareos.completos) {
      autoRecierreLanzado.current = false;
      setAutoRecerrandoJatsa(false);
      alert(validacionTareos.mensaje);
      return undefined;
    }
    confirmarCerrarPlanilla({ silencioso: true, recargaDetalle: true });
    return undefined;
  }, [autoRecerrandoJatsa, loading, planillaCerrada, calculandoPlanilla, empleadosConBoletasCalculadas.length]);

  const closeConfirmModal = () => {
    setConfirmModal({
      isOpen: false,
      type: 'success',
      title: '',
      message: '',
      confirmText: undefined,
      onConfirm: null
    });
  };

  const openTareoModal = (empleado) => {
    setTareoModal({
      isOpen: true,
      empleado: aplicarDeclaracionGratificacionDesdeModulo(empleado)
    });
  };

  const closeTareoModal = () => {
    setTareoModal({
      isOpen: false,
      empleado: null
    });
  };

  // 💤 FUNCIONES PARA MODAL DE COMPENSACIONES
  const openCompensacionesModal = () => {
    console.log('💤 Abriendo modal de compensaciones...');
    setCompensacionesModalOpen(true);
  };

  const closeCompensacionesModal = () => {
    console.log('💤 Cerrando modal de compensaciones...');
    setCompensacionesModalOpen(false);
  };

  const openPagoJornalModal = () => {
    setPagoJornalModalOpen(true);
  };

  const closePagoJornalModal = () => {
    setPagoJornalModalOpen(false);
  };

  const openGratiConsuModal = () => {
    setGratiConsuModalOpen(true);
  };

  const closeGratiConsuModal = () => {
    setGratiConsuModalOpen(false);
  };

  const openPeriodoCalculoConsuModal = () => {
    setPeriodoCalculoConsuModalOpen(true);
  };

  const closePeriodoCalculoConsuModal = () => {
    setPeriodoCalculoConsuModalOpen(false);
  };

  // 🔍 FUNCIONES PARA MODAL DE ANÁLISIS INDIVIDUAL
  const openAnalisisModal = () => {
    console.log('🔍 Abriendo modal de análisis individual...');
    setModalAnalisisAbierto(true);
  };

  const closeAnalisisModal = () => {
    console.log('🔍 Cerrando modal de análisis individual...');
    setModalAnalisisAbierto(false);
    setEmpleadoSeleccionadoAnalisis(null); // Limpiar selección al cerrar
    setBusquedaEmpleado(''); // Limpiar búsqueda
    setEmpleadosFiltrados([]); // Limpiar filtrados
    setMostrarSugerencias(false); // Ocultar sugerencias
  };

  // 💰 FUNCIONES PARA MODALES DE AJUSTES DE SUELDOS
  const openAjustesSueldosModal = () => {
    console.log('💰 Abriendo modal de ajustes de sueldos...');
    setAjustesSueldosModalOpen(true);
  };

  const closeAjustesSueldosModal = () => {
    console.log('💰 Cerrando modal de ajustes de sueldos...');
    setAjustesSueldosModalOpen(false);
    setEmpleadoSeleccionadoAjustes(null);
    setConceptosEmpleadoModalOpen(false);
  };

  const cargarSegurosPlanilla = async (planillaIdOverride = null) => {
    const planillaId = planillaIdOverride || planillaReal?.id;
    if (!planillaId) {
      setSegurosPlanillaResumen([]);
      setSegurosPlanillaRegistros([]);
      return;
    }

    try {
      const response = await planillaSeguroService.obtenerSeguros(planillaId);
      if (response.success) {
        setSegurosPlanillaResumen(response.data?.resumen || []);
        setSegurosPlanillaRegistros(response.data?.registros || []);
      } else {
        setSegurosPlanillaResumen([]);
        setSegurosPlanillaRegistros([]);
      }
    } catch (error) {
      console.error('❌ Error al cargar seguros de planilla:', error);
      setSegurosPlanillaResumen([]);
      setSegurosPlanillaRegistros([]);
    }
  };

  const openSegurosModal = () => {
    setSegurosModalOpen(true);
  };

  const closeSegurosModal = () => {
    setSegurosModalOpen(false);
  };

  const openEventosBoletaModal = () => {
    if (planillaCerrada || planillaReal?.estado === 'cerrada') return;
    setEventosBoletaModalOpen(true);
  };

  const closeEventosBoletaModal = () => {
    setEventosBoletaModalOpen(false);
  };

  const handleGuardarOverridesTareoEvento = async (payload) => {
    const planillaId = planillaReal?.id || parseInt(id, 10);
    if (!planillaId) return;

    setGuardandoOverridesTareo(true);
    try {
      const response = await consideracionesConceptosService.guardarOverridesTareoEvento(
        planillaId,
        payload
      );
      if (response?.success) {
        const mapaNuevo = mapaOverridesDesdeApi(response.data);
        setOverridesTareoEvento(mapaNuevo);
        setEventosBoletaModalOpen(false);
        setGuardandoOverridesTareo(false);
        // Pasar mapa fresco: setState aún no está reflejado en el cierre
        await procesarEmpleadosConPlanilla({ overridesTareoEvento: mapaNuevo });
      } else {
        alert(response?.message || 'No se pudieron guardar los eventos por boleta');
      }
    } catch (error) {
      console.error('❌ Error guardando eventos por boleta:', error);
      alert('Error al guardar eventos distintos por boleta');
    } finally {
      setGuardandoOverridesTareo(false);
    }
  };

  const openTramosInternaModal = () => {
    if (planillaCerrada || planillaReal?.estado === 'cerrada') return;
    setTramosInternaModalOpen(true);
  };

  const closeTramosInternaModal = () => {
    setTramosInternaModalOpen(false);
  };

  const openTramosSueldoModal = () => {
    if (planillaCerrada || planillaReal?.estado === 'cerrada') return;
    setTramosSueldoModalOpen(true);
  };

  const closeTramosSueldoModal = () => {
    setTramosSueldoModalOpen(false);
  };

  const handleGuardarTramosSueldoPlame = async (payload) => {
    const planillaId = planillaReal?.id || parseInt(id, 10);
    if (!planillaId) return;

    setGuardandoTramosSueldo(true);
    try {
      const response = await consideracionesConceptosService.guardarTramosSueldoPlame(
        planillaId,
        payload
      );
      if (response?.success) {
        const mapaNuevo = mapaSueldoTramosDesdeApi(response.data);
        setTramosSueldoPlame(mapaNuevo);
        setTramosSueldoModalOpen(false);
        setGuardandoTramosSueldo(false);
        await procesarEmpleadosConPlanilla({ tramosSueldoPlame: mapaNuevo });
      } else {
        alert(response?.message || 'No se pudo guardar el cambio de sueldo');
      }
    } catch (error) {
      console.error('❌ Error guardando tramos de sueldo PLAME:', error);
      alert('Error al guardar cambio de sueldo por día');
    } finally {
      setGuardandoTramosSueldo(false);
    }
  };

  const handleGuardarTramosBoletaInterna = async (payload) => {
    const planillaId = planillaReal?.id || parseInt(id, 10);
    if (!planillaId) return;

    setGuardandoTramosInterna(true);
    try {
      const response = await consideracionesConceptosService.guardarTramosBoletaInterna(
        planillaId,
        payload
      );
      if (response?.success) {
        const mapaNuevo = mapaTramosDesdeApi(response.data);
        setTramosBoletaInterna(mapaNuevo);
        setTramosInternaModalOpen(false);
        setGuardandoTramosInterna(false);
        await procesarEmpleadosConPlanilla({ tramosBoletaInterna: mapaNuevo });
      } else {
        alert(response?.message || 'No se pudieron guardar los tramos de boleta interna');
      }
    } catch (error) {
      console.error('❌ Error guardando tramos boleta interna:', error);
      alert('Error al guardar boleta interna en dos partes');
    } finally {
      setGuardandoTramosInterna(false);
    }
  };

  const handleActualizarResumenSeguros = (data) => {
    setSegurosPlanillaResumen(data?.resumen || []);
    setSegurosPlanillaRegistros(data?.registros || []);
  };

  const obtenerDescripcionSeguro = (codigoPlame) => {
    const catalogo = CODIGOS_SEGURO_PLANILLA.find((item) => item.codigo === codigoPlame);
    return catalogo?.descripcionCorta || codigoPlame;
  };

  const omitirDescuentosPlameInternaDe = (empleadoId) => Boolean(
    consideracionesEmpleadoFlags?.[String(empleadoId)]?.omitir_descuentos_plame_interna
  );

  const periodoGratiConsuDe = (empleadoId) => {
    const raw = consideracionesEmpleadoFlags?.[String(empleadoId)]?.periodo_gratificacion_consu;
    const n = String(raw || '').toLowerCase();
    return n === 'fp' || n === 'navidad' ? n : 'auto';
  };

  const formaPagoPlanillaDe = (empleadoId) => {
    const raw = consideracionesEmpleadoFlags?.[String(empleadoId)]?.forma_pago_planilla;
    const n = String(raw || '').toLowerCase();
    return n === 'mensual' || n === 'jornal' || n === 'mixto' ? n : '';
  };

  const fechaDesdeJornalDe = (empleadoId) => {
    const raw = consideracionesEmpleadoFlags?.[String(empleadoId)]?.fecha_desde_jornal;
    const iso = raw ? String(raw).split('T')[0].slice(0, 10) : '';
    return esFechaIsoCompleta(iso) ? iso : '';
  };

  const fechaCalculoDesdeDe = (empleadoId) => {
    const raw = consideracionesEmpleadoFlags?.[String(empleadoId)]?.fecha_calculo_desde;
    const iso = raw ? String(raw).split('T')[0].slice(0, 10) : '';
    return esFechaIsoCompleta(iso) ? iso : '';
  };

  const fechaCalculoHastaDe = (empleadoId) => {
    const raw = consideracionesEmpleadoFlags?.[String(empleadoId)]?.fecha_calculo_hasta;
    const iso = raw ? String(raw).split('T')[0].slice(0, 10) : '';
    return esFechaIsoCompleta(iso) ? iso : '';
  };

  const descuentoDominicalDe = (empleadoId) => {
    const raw = consideracionesEmpleadoFlags?.[String(empleadoId)]?.aplicar_descuento_dominical;
    if (raw === true || raw === 1 || raw === '1' || raw === 'si') return 'si';
    if (raw === false || raw === 0 || raw === '0' || raw === 'no') return 'no';
    return '';
  };

  const valorDominicalApi = (ui) => {
    if (ui === 'si') return true;
    if (ui === 'no') return false;
    return null;
  };

  const payloadFlagsEmpleado = (empleadoId, extra = {}) => ({
    id: Number(empleadoId),
    omitir_descuentos_plame_interna: omitirDescuentosPlameInternaDe(empleadoId),
    periodo_gratificacion_consu: periodoGratiConsuDe(empleadoId),
    forma_pago_planilla: formaPagoPlanillaDe(empleadoId) || null,
    fecha_desde_jornal: fechaDesdeJornalDe(empleadoId) || null,
    aplicar_descuento_dominical: valorDominicalApi(descuentoDominicalDe(empleadoId)),
    fecha_calculo_desde: fechaCalculoDesdeDe(empleadoId) || null,
    fecha_calculo_hasta: fechaCalculoHastaDe(empleadoId) || null,
    ...extra,
  });

  const debeDescontarDescansosEmpleado = (empleado) => {
    const empresaOn = planillaCerrada
      ? empleado.descuento_descanso
      : configuracionTareo?.descontar_descansos;
    return resolverDescuentoDominical({
      empresaActiva: empresaOn,
      override: descuentoDominicalDe(empleado?.id),
    });
  };

  const etiquetaFormaPagoVista = (emp) => {
    if (!emp || esRegimenConstruccionCivil(emp, regimenesLaborales || [])) return null;
    const empleadoId = emp.id || emp.empleado_id;
    const origen = (empleadosActivosPlanilla || []).find((e) => String(e.id) === String(empleadoId))
      || (empleadosConConceptos || []).find((e) => String(e.id) === String(empleadoId))
      || (empleadosConBoletasCalculadas || []).find((e) => String(e.id || e.empleado_id) === String(empleadoId))
      || {};
    const modoCalc = emp.pagoJornal?.modo || origen.pagoJornal?.modo;
    if (modoCalc === 'jornal' || modoCalc === 'mixto') {
      return modoCalc === 'mixto'
        ? {
          modo: 'mixto',
          texto: 'Mixto',
          className: 'bg-amber-100 text-amber-800 border border-amber-200',
        }
        : {
          modo: 'jornal',
          texto: 'Jornal',
          className: 'bg-emerald-100 text-emerald-800 border border-emerald-200',
        };
    }
    const resuelto = resolverModoPagoJornal({
      esConsu: false,
      formaPagoFicha:
        emp.forma_pago
        || origen.forma_pago
        || emp.datosSalariales?.formaPago
        || origen.datosSalariales?.formaPago,
      formaPagoPlanilla:
        emp.forma_pago_planilla
        || origen.forma_pago_planilla
        || formaPagoPlanillaDe(empleadoId),
      fechaDesdeJornal:
        emp.fecha_desde_jornal
        || origen.fecha_desde_jornal
        || fechaDesdeJornalDe(empleadoId),
    });
    if (resuelto.modo === 'jornal') {
      return {
        modo: 'jornal',
        texto: 'Jornal',
        className: 'bg-emerald-100 text-emerald-800 border border-emerald-200',
      };
    }
    if (resuelto.modo === 'mixto') {
      return {
        modo: 'mixto',
        texto: 'Mixto',
        className: 'bg-amber-100 text-amber-800 border border-amber-200',
      };
    }
    return {
      modo: 'mensual',
      texto: 'Mensual',
      className: 'bg-slate-100 text-slate-700 border border-slate-200',
    };
  };

  const periodoGratiConsuAutomatico = () => {
    const fecha = planillaReal?.fecha_inicio || planilla?.fecha_inicio || '';
    const mes = Number(String(fecha).slice(5, 7));
    return mes && mes <= 7 ? 'fp' : 'navidad';
  };

  const etiquetaPeriodoGratiConsu = (valor) => {
    if (valor === 'fp') return 'Fiestas Patrias (ene–jul)';
    if (valor === 'navidad') return 'Navidad (ago–dic)';
    const auto = periodoGratiConsuAutomatico();
    return auto === 'fp'
      ? 'Según las fechas (Fiestas Patrias)'
      : 'Según las fechas (Navidad)';
  };

  const empleadoTieneBoletaInternaParaFlag = (emp) => {
    if (!planillaAlternativaActiva) return false;
    const tipo = String(emp?.tipo_planilla || emp?.datosEmpleado?.tipo_planilla || '').toLowerCase();
    return tipo === 'dual' || tipo === 'solo_interna';
  };

  const toggleOmitirDescuentosPlameInterna = async (empleadoId, valor) => {
    const planillaId = planillaReal?.id || parseInt(id, 10);
    if (!planillaId || !empleadoId) return;

    setGuardandoFlagOmitirDesc(true);
    const prevFlags = consideracionesEmpleadoFlags;
    setConsideracionesEmpleadoFlags((prev) => ({
      ...prev,
      [String(empleadoId)]: {
        ...(prev[String(empleadoId)] || {}),
        omitir_descuentos_plame_interna: Boolean(valor),
      },
    }));

    try {
      const response = await consideracionesConceptosService.guardarFlagsEmpleado(planillaId, [
        payloadFlagsEmpleado(empleadoId, {
          omitir_descuentos_plame_interna: Boolean(valor),
        }),
      ]);
      if (response?.success && response.data?.flags) {
        setConsideracionesEmpleadoFlags(response.data.flags);
      }
    } catch (error) {
      console.error('❌ Error guardando flag omitir descuentos PLAME interna:', error);
      setConsideracionesEmpleadoFlags(prevFlags);
      alert('No se pudo guardar la opción. Intente de nuevo.');
    } finally {
      setGuardandoFlagOmitirDesc(false);
    }
  };

  const cambiarPeriodoGratiConsu = async (empleadoId, valor) => {
    const planillaId = planillaReal?.id || parseInt(id, 10);
    if (!planillaId || !empleadoId) return;

    const normalizado = valor === 'fp' || valor === 'navidad' ? valor : 'auto';
    setGuardandoFlagOmitirDesc(true);
    const prevFlags = consideracionesEmpleadoFlags;
    setConsideracionesEmpleadoFlags((prev) => ({
      ...prev,
      [String(empleadoId)]: {
        ...(prev[String(empleadoId)] || {}),
        periodo_gratificacion_consu: normalizado,
      },
    }));

    try {
      const response = await consideracionesConceptosService.guardarFlagsEmpleado(planillaId, [
        payloadFlagsEmpleado(empleadoId, {
          periodo_gratificacion_consu: normalizado,
        }),
      ]);
      if (response?.success && response.data?.flags) {
        setConsideracionesEmpleadoFlags(response.data.flags);
      }
    } catch (error) {
      console.error('❌ Error guardando periodo de gratificación CONSU:', error);
      setConsideracionesEmpleadoFlags(prevFlags);
      alert('No se pudo guardar el periodo de gratificación. Intente de nuevo.');
    } finally {
      setGuardandoFlagOmitirDesc(false);
    }
  };

  const cambiarFormaPagoJornal = async (empleadoId, formaPagoPlanilla, fechaDesdeJornal) => {
    const planillaId = planillaReal?.id || parseInt(id, 10);
    if (!planillaId || !empleadoId) return;

    const forma = ['mensual', 'jornal', 'mixto'].includes(String(formaPagoPlanilla))
      ? String(formaPagoPlanilla)
      : null;
    const fechaCruda = forma === 'mixto' && fechaDesdeJornal
      ? String(fechaDesdeJornal).slice(0, 10)
      : null;
    const fecha = esFechaIsoCompleta(fechaCruda) ? fechaCruda : null;

    setGuardandoFlagOmitirDesc(true);
    const prevFlags = consideracionesEmpleadoFlags;
    setConsideracionesEmpleadoFlags((prev) => ({
      ...prev,
      [String(empleadoId)]: {
        ...(prev[String(empleadoId)] || {}),
        forma_pago_planilla: forma,
        fecha_desde_jornal: fecha,
      },
    }));

    try {
      const response = await consideracionesConceptosService.guardarFlagsEmpleado(planillaId, [
        payloadFlagsEmpleado(empleadoId, {
          forma_pago_planilla: forma,
          fecha_desde_jornal: fecha,
        }),
      ]);
      if (response?.success && response.data?.flags) {
        setConsideracionesEmpleadoFlags(response.data.flags);
      }
    } catch (error) {
      console.error('❌ Error guardando forma de pago jornal:', error);
      setConsideracionesEmpleadoFlags(prevFlags);
      alert('No se pudo guardar la forma de pago. Intente de nuevo.');
    } finally {
      setGuardandoFlagOmitirDesc(false);
    }
  };

  const cambiarDescuentoDominical = async (empleadoId, valorUi) => {
    const planillaId = planillaReal?.id || parseInt(id, 10);
    if (!planillaId || !empleadoId) return;

    const ui = valorUi === 'si' || valorUi === 'no' ? valorUi : '';
    const apiVal = valorDominicalApi(ui);

    setGuardandoFlagOmitirDesc(true);
    const prevFlags = consideracionesEmpleadoFlags;
    setConsideracionesEmpleadoFlags((prev) => ({
      ...prev,
      [String(empleadoId)]: {
        ...(prev[String(empleadoId)] || {}),
        aplicar_descuento_dominical: apiVal,
      },
    }));

    try {
      const response = await consideracionesConceptosService.guardarFlagsEmpleado(planillaId, [
        payloadFlagsEmpleado(empleadoId, {
          aplicar_descuento_dominical: apiVal,
        }),
      ]);
      if (response?.success && response.data?.flags) {
        setConsideracionesEmpleadoFlags(response.data.flags);
      }
    } catch (error) {
      console.error('❌ Error guardando descuento dominical:', error);
      setConsideracionesEmpleadoFlags(prevFlags);
      alert('No se pudo guardar el descuento dominical. Intente de nuevo.');
    } finally {
      setGuardandoFlagOmitirDesc(false);
    }
  };

  const cambiarFechaCalculoConsu = async (empleadoId, fechaDesde, fechaHasta) => {
    const planillaId = planillaReal?.id || parseInt(id, 10);
    if (!planillaId || !empleadoId) return;
    if (!esPlanillaModalidadConstruccion(planillaReal)) return;

    const inicio = String(planillaReal?.fecha_inicio || '').slice(0, 10);
    const fin = String(planillaReal?.fecha_fin || '').slice(0, 10);
    const norm = (raw) => {
      const iso = raw ? String(raw).split('T')[0].slice(0, 10) : '';
      return esFechaIsoCompleta(iso) ? iso : null;
    };
    const desde = norm(fechaDesde);
    const hasta = norm(fechaHasta);

    if (desde && inicio && (desde < inicio || (fin && desde > fin))) {
      alert('La fecha desde debe estar dentro del periodo de la planilla.');
      return;
    }
    if (hasta && inicio && ((fin && hasta > fin) || hasta < inicio)) {
      alert('La fecha hasta debe estar dentro del periodo de la planilla.');
      return;
    }
    if (desde && hasta && desde > hasta) {
      alert('La fecha desde no puede ser posterior a la fecha hasta.');
      return;
    }

    setGuardandoFlagOmitirDesc(true);
    const prevFlags = consideracionesEmpleadoFlags;
    setConsideracionesEmpleadoFlags((prev) => ({
      ...prev,
      [String(empleadoId)]: {
        ...(prev[String(empleadoId)] || {}),
        fecha_calculo_desde: desde,
        fecha_calculo_hasta: hasta,
      },
    }));

    try {
      const response = await consideracionesConceptosService.guardarFlagsEmpleado(planillaId, [
        payloadFlagsEmpleado(empleadoId, {
          fecha_calculo_desde: desde,
          fecha_calculo_hasta: hasta,
        }),
      ]);
      if (response?.success && response.data?.flags) {
        setConsideracionesEmpleadoFlags(response.data.flags);
      }
    } catch (error) {
      console.error('❌ Error guardando fecha de cálculo CONSU:', error);
      setConsideracionesEmpleadoFlags(prevFlags);
      alert(error?.response?.data?.errors?.empleados?.[0]
        || error?.response?.data?.message
        || 'No se pudo guardar la fecha de cálculo. Intente de nuevo.');
    } finally {
      setGuardandoFlagOmitirDesc(false);
    }
  };

  const openConceptosEmpleadoModal = async (empleadoVista) => {
      if (empleadoTienePreCierreCongelado(empleadoVista)) {
      alert(
        planillaCerrada || planillaReal?.estado === 'cerrada'
          ? 'Este trabajador está en solo lectura (planilla cerrada).\n\nUse «Reabrir» en su ficha para ajustes posteriores.'
          : 'Este trabajador tiene pre-cierre guardado (cálculo congelado).\n\nNo admite ajustes de consideraciones. Use «Volver a recalcular» en su ficha si necesita modificarlo.',
      );
      return;
    }
    try {
      console.log('💰 === ABRIENDO MODAL DE CONCEPTOS (DESDE BACKEND) ===');
      console.log('📋 Empleado solicitado:', empleadoVista.nombre);
      console.log('🆔 ID del empleado:', empleadoVista.id);
      console.log('📋 Planilla ID:', id);
      
      // 🚀 SOLICITAR CONCEPTOS DIRECTAMENTE DEL BACKEND
      console.log('📡 Solicitando conceptos del empleado al backend...');
      const response = await consideracionesConceptosService.obtenerConceptosEmpleado(parseInt(id), empleadoVista.id);
      
      console.log('📨 Respuesta del backend:', response);
      
      if (response.success) {
        const conceptosDelBackend = response.data.conceptos;
        const estadisticas = response.data.estadisticas;
        
        console.log('✅ === CONCEPTOS OBTENIDOS DEL BACKEND ===');
        console.log('📊 Estadísticas:', estadisticas);
        console.log('📋 Conceptos recibidos:', {
          ingresos: conceptosDelBackend.ingresos.length,
          descuentos: conceptosDelBackend.descuentos.length,
          aportes: conceptosDelBackend.aportes.length
        });
        
        // 🔍 Debug de estructura de conceptos
        if (conceptosDelBackend.ingresos.length > 0) {
          console.log('🔍 Primer concepto de ingreso del backend:', conceptosDelBackend.ingresos[0]);
          console.log('🔍 Campos del concepto:', Object.keys(conceptosDelBackend.ingresos[0]));
        }
        
        // 🎯 BUSCAR DATOS BÁSICOS DEL EMPLEADO (para info adicional)
        const empleadoOriginal = empleadosActivosPlanilla.find(emp => emp.id === empleadoVista.id) ||
                                empleadosConBoletasCalculadas.find(emp => emp.id === empleadoVista.id);
        
        // 🎯 PREPARAR EMPLEADO PARA EL MODAL CON CONCEPTOS DEL BACKEND
        const empleadoParaModal = {
          id: empleadoVista.id,
          nombre: empleadoVista.nombre,
          nombre_completo: empleadoVista.nombre,
          tipo_planilla:
            empleadoVista.tipo_planilla
            || empleadoOriginal?.tipo_planilla
            || empleadoOriginal?.datosEmpleado?.tipo_planilla
            || null,
          // Datos adicionales del empleado original si están disponibles
          ...(empleadoOriginal ? {
            documento: empleadoOriginal.numero_documento || empleadoOriginal.documento || empleadoVista.documento,
            cargo: empleadoOriginal.cargo || empleadoVista.cargo,
            areas_de_trabajo: empleadoOriginal.areas_de_trabajo || empleadoVista.areas_de_trabajo
          } : {
            documento: empleadoVista.documento,
            cargo: empleadoVista.cargo,
            areas_de_trabajo: empleadoVista.areas_de_trabajo,
          }),
          // 🎯 CONCEPTOS DIRECTOS DEL BACKEND
          conceptos: conceptosDelBackend
        };
        
        console.log('🎯 === EMPLEADO PREPARADO PARA MODAL ===');
        console.log('👤 Empleado para modal:', {
          id: empleadoParaModal.id,
          nombre: empleadoParaModal.nombre,
          conceptos_ingresos: empleadoParaModal.conceptos.ingresos.length,
          conceptos_descuentos: empleadoParaModal.conceptos.descuentos.length,
          conceptos_aportes: empleadoParaModal.conceptos.aportes.length
        });
        
        // 🎯 ACTUALIZAR ESTADO DE empleadosConConceptos CON DATOS DEL BACKEND
        setEmpleadosConConceptos(prevEmpleados => {
          const empleadoExistente = prevEmpleados.find(emp => emp.id === empleadoVista.id);
          
          if (empleadoExistente) {
            // Actualizar empleado existente con conceptos del backend
            return prevEmpleados.map(emp => {
              if (emp.id === empleadoVista.id) {
                console.log('🔄 Actualizando empleado existente con conceptos del backend');
                return {
                  ...emp,
                  conceptos: conceptosDelBackend
                };
              }
              return emp;
            });
          } else {
            // Agregar nuevo empleado con conceptos del backend
            console.log('➕ Agregando nuevo empleado con conceptos del backend');
            const nuevoEmpleado = {
              id: empleadoVista.id,
              nombre: empleadoVista.nombre,
              conceptos: conceptosDelBackend
            };
            return [...prevEmpleados, nuevoEmpleado];
          }
        });
        
        // 🎯 ABRIR MODAL CON DATOS DEL BACKEND
        setEmpleadoSeleccionadoAjustes(empleadoParaModal);
        setConceptosEmpleadoModalOpen(true);
        
        console.log('✅ Modal abierto con conceptos del backend exitosamente');
        
      } else {
        console.warn('⚠️ No se encontraron conceptos para este empleado en el backend');
        
        // Crear empleado con conceptos vacíos
        const empleadoSinConceptos = {
          id: empleadoVista.id,
          nombre: empleadoVista.nombre,
          conceptos: {
            ingresos: [],
            descuentos: [],
            aportes: []
          }
        };
        
        setEmpleadoSeleccionadoAjustes(empleadoSinConceptos);
        setConceptosEmpleadoModalOpen(true);
        
        console.log('✅ Modal abierto con conceptos vacíos');
      }
      
    } catch (error) {
      console.error('❌ Error obteniendo conceptos del empleado desde backend:', error);
      
      // En caso de error, mostrar modal con conceptos vacíos
      const empleadoConError = {
        id: empleadoVista.id,
        nombre: empleadoVista.nombre,
        conceptos: {
          ingresos: [],
          descuentos: [],
          aportes: []
        }
      };
      
      setEmpleadoSeleccionadoAjustes(empleadoConError);
      setConceptosEmpleadoModalOpen(true);
      
      console.log('⚠️ Modal abierto con conceptos vacíos debido a error');
    }
  };

  const closeConceptosEmpleadoModal = () => {
    console.log('💰 Cerrando modal de conceptos de empleado...');
    setConceptosEmpleadoModalOpen(false);
    setEmpleadoSeleccionadoAjustes(null);
  };

  const actualizarConceptoTemporal = (empleadoId, conceptoId, nuevoMonto, destino = null) => {
    console.log(`💰 Actualizando concepto temporal: Empleado ${empleadoId}, Concepto ${conceptoId}, Monto ${nuevoMonto}, Destino ${destino}`);
    setConceptosTemporales((prev) => {
      const prevVal = parseAjusteTemporal(prev[empleadoId]?.[conceptoId]);
      const monto =
        nuevoMonto !== null && nuevoMonto !== undefined
          ? nuevoMonto
          : prevVal?.monto;
      const dest =
        destino != null
          ? destino
          : (prevVal?.destino || defaultDestinoAjusteEmpleado(empleadoId));
      return {
      ...prev,
      [empleadoId]: {
        ...prev[empleadoId],
          [conceptoId]: { monto, destino: dest },
        },
      };
    });
  };

  const defaultDestinoAjusteEmpleado = (empleadoId) => {
    if (!planillaAlternativaActiva) return 'plame';
    const emp =
      empleadosActivosPlanilla.find((e) => String(e.id) === String(empleadoId))
      || empleadosConBoletasCalculadas.find((e) => String(e.id) === String(empleadoId))
      || empleadosConConceptos.find((e) => String(e.id) === String(empleadoId))
      || empleadoSeleccionadoAjustes;
    const tipo = String(emp?.tipo_planilla || emp?.datosEmpleado?.tipo_planilla || '').toLowerCase();
    if (tipo === 'solo_interna') return 'interna';
    // Dual: por defecto el ajuste afecta solo PLAME.
    // AFP/ONP/EsSalud/minera se sincronizan desde el motor, no por destino "ambas".
    return 'plame';
  };

  const mostrarSelectorDestinoAjuste = (empleadoId) => {
    if (!planillaAlternativaActiva) return false;
    const emp =
      empleadosActivosPlanilla.find((e) => String(e.id) === String(empleadoId))
      || empleadosConBoletasCalculadas.find((e) => String(e.id) === String(empleadoId))
      || empleadosConConceptos.find((e) => String(e.id) === String(empleadoId))
      || empleadoSeleccionadoAjustes;
    const tipo = String(emp?.tipo_planilla || emp?.datosEmpleado?.tipo_planilla || '').toLowerCase();
    return tipo === 'dual' || tipo === 'solo_interna' || empleadoTieneBoletaInterna(emp);
  };

  const getAjusteTemporalConcepto = (empleadoId, conceptoId, concepto = null) => {
    const raw = conceptosTemporales[empleadoId]?.[conceptoId];
    if (raw != null) {
      return {
        monto: getMontoDesdeAjuste(raw, concepto?.monto),
        destino: getDestinoDesdeAjuste(raw, defaultDestinoAjusteEmpleado(empleadoId)),
        tieneAjuste: true,
      };
    }
    // Destino/monto interna ya guardados en consideraciones
    if (concepto?.destino_ajuste || concepto?.monto_interna != null) {
      const dest = concepto.destino_ajuste || defaultDestinoAjusteEmpleado(empleadoId);
      const montoMostrar =
        dest === 'interna' && concepto.monto_interna != null
          ? concepto.monto_interna
          : concepto.monto;
      return {
        monto: montoMostrar,
        destino: dest,
        tieneAjuste: Boolean(
          concepto.destino_ajuste && concepto.destino_ajuste !== 'ambas'
          || concepto.monto_interna != null
        ),
      };
    }
    return {
      monto: concepto?.monto,
      destino: defaultDestinoAjusteEmpleado(empleadoId),
      tieneAjuste: false,
    };
  };

  const resetearAjustesEmpleado = (empleadoId) => {
    console.log(`💰 Reseteando ajustes del empleado ${empleadoId}`);
    setConceptosTemporales(prev => {
      const nuevos = { ...prev };
      delete nuevos[empleadoId];
      return nuevos;
    });
    setConceptosEliminados(prev => {
      const nuevos = { ...prev };
      delete nuevos[empleadoId];
      return nuevos;
    });
  };

  const restaurarConceptosOriginalesEmpleado = async (empleadoId) => {
    try {
      console.log(`🔄 Restaurando conceptos originales del empleado ${empleadoId}...`);
      
      // Llamar al nuevo endpoint específico para restaurar conceptos originales
      const response = await consideracionesConceptosService.restaurarConceptosOriginalesEmpleado(empleadoId);
      
      if (response.success) {
        const conceptosOriginales = response.data.conceptos;
        const estadisticas = response.data.estadisticas;
        
        console.log('✅ Conceptos originales obtenidos del backend:', {
          total: estadisticas.total_conceptos,
          ingresos: conceptosOriginales.ingresos.length,
          descuentos: conceptosOriginales.descuentos.length,
          aportes: conceptosOriginales.aportes.length
        });
        
        // El backend ya devuelve los conceptos en el formato correcto y agrupados
        // No necesitamos transformar, solo actualizar los estados
        
        // Actualizar empleadosConConceptos con los conceptos originales
        setEmpleadosConConceptos(prevEmpleados => {
          return prevEmpleados.map(empleado => {
            if (empleado.id === empleadoId) {
              return {
                ...empleado,
                conceptos: conceptosOriginales
              };
            }
            return empleado;
          });
        });
        
        // Actualizar el empleado seleccionado en el modal
        setEmpleadoSeleccionadoAjustes(prevEmpleado => {
          if (!prevEmpleado || prevEmpleado.id !== empleadoId) return prevEmpleado;
          return {
            ...prevEmpleado,
            conceptos: conceptosOriginales
          };
        });
        
        // Limpiar ajustes temporales y eliminados
        setConceptosTemporales(prev => {
          const nuevos = { ...prev };
          delete nuevos[empleadoId];
          return nuevos;
        });
        setConceptosEliminados(prev => {
          const nuevos = { ...prev };
          delete nuevos[empleadoId];
          return nuevos;
        });
        
        // Marcar el empleado como restaurado (necesita guardarse en backend)
        setEmpleadosConceptosRestaurados(prev => {
          const nuevos = new Set(prev);
          nuevos.add(empleadoId);
          return nuevos;
        });
        
        console.log(`✅ Empleado ${empleadoId} marcado como restaurado - necesita guardarse en backend`);
        
        alert(`✅ Conceptos restaurados desde configuración\n\nSe han restaurado ${estadisticas.total_conceptos} conceptos desde la configuración del empleado:\n• Ingresos: ${conceptosOriginales.ingresos.length}\n• Descuentos: ${conceptosOriginales.descuentos.length}\n• Aportes: ${conceptosOriginales.aportes.length}\n\n⚠️ Recuerda hacer clic en "Guardar y Recalcular" para aplicar los cambios.`);
        
      } else {
        throw new Error('No se pudieron obtener los conceptos originales');
      }
      
    } catch (error) {
      console.error('❌ Error restaurando conceptos originales:', error);
      alert('❌ Error al restaurar conceptos\n\nNo se pudieron restaurar los conceptos desde la configuración del empleado.\n\nVerifica que el empleado tenga conceptos configurados.');
    }
  };

  const openConceptosPlameModal = () => {
    setConceptosPlameModalOpen(true);
  };

  const closeConceptosPlameModal = () => {
    setConceptosPlameModalOpen(false);
    setBusquedaConceptoPlame(''); // Limpiar búsqueda al cerrar
  };

  const agregarConceptoPlameAlEmpleado = (conceptoPlame) => {
    if (!empleadoSeleccionadoAjustes || !conceptoPlame) return;
    
    console.log('✅ Agregando concepto PLAME al empleado:', {
      empleado: empleadoSeleccionadoAjustes.nombre,
      concepto: conceptoPlame.descripcion,
      codigo: conceptoPlame.codigo_plame || conceptoPlame.codigo
    });

    // 🔍 Función local para asegurar estructura completa de concepto
    const asegurarEstructuraCompletaLocal = (concepto) => {
      // 🎯 EXTRAER DATOS DE PLAME_CONFIGURACION (AQUÍ ESTÁN LOS DATOS REALES)
      const plameConfig = concepto.plame_configuracion || {};
      
      // 🔍 PRIORIZAR DATOS DE PLAME_CONFIGURACION
      const codigo = plameConfig.codigo_plame || concepto.codigo || concepto.codigo_plame || "0000";
      const descripcion = plameConfig.descripcion || concepto.descripcion || "Sin descripción";
      
      console.log(`🔧 Procesando nuevo concepto ID ${concepto.id}:`, {
        codigo_extraido: codigo,
        descripcion_extraida: descripcion,
        fuente_codigo: plameConfig.codigo_plame ? 'plame_configuracion.codigo_plame' : 'concepto.codigo',
        fuente_descripcion: plameConfig.descripcion ? 'plame_configuracion.descripcion' : 'concepto.descripcion'
      });
      
      return {
        created_at: concepto.created_at || new Date().toISOString(),
        empleado_id: concepto.empleado_id || empleadoSeleccionadoAjustes.id,
        id: concepto.id,
        monto: concepto.monto || "0.00",
        
        // 🎯 CAMPOS REQUERIDOS PARA EL MODAL (nivel raíz) - EXTRAÍDOS DE PLAME_CONFIGURACION
        codigo: codigo,
        descripcion: descripcion,
        codigoPlame: codigo,
        
        // 🎯 ESTRUCTURA COMPLETA PLAME_CONFIGURACION (PRESERVAR ORIGINAL)
        plame_configuracion: concepto.plame_configuracion,
        plame_configuracion_id: concepto.plame_configuracion_id,
        tipo_concepto: concepto.tipo_concepto,
        updated_at: concepto.updated_at || new Date().toISOString(),
        
        // 🆕 Campos adicionales del modal si existen
        esNuevo: concepto.esNuevo,
        esModificado: concepto.esModificado
      };
    };

    // Determinar el tipo de concepto basado en la clasificación
    const idTipo = conceptoPlame.clasificacion?.id_tipo || 1;
    let tipoConcepto = 'ingreso';
    let clasificacionDescripcion = 'INGRESOS';
    let codigoClasificacion = '0100';
    
    if (idTipo === 2) {
      tipoConcepto = 'descuento';
      clasificacionDescripcion = 'DESCUENTOS';
      codigoClasificacion = '0600';
    } else if (idTipo === 3) {
      tipoConcepto = 'aporte';
      clasificacionDescripcion = 'APORTES';
      codigoClasificacion = '0800';
    }
    
    console.log('🔍 Tipo de concepto detectado:', {
      id_tipo: idTipo,
      tipo_concepto: tipoConcepto,
      clasificacion: clasificacionDescripcion
    });

    // Crear el nuevo concepto con la estructura completa que necesitas
    const conceptoBase = {
      created_at: new Date().toISOString(),
      empleado_id: empleadoSeleccionadoAjustes.id,
      id: conceptoPlame.id,
      monto: "0.00", // Monto inicial en 0
      plame_configuracion: {
        clasificacion: { 
          id: conceptoPlame.clasificacion?.id || 12, 
          codigo: codigoClasificacion, 
          descripcion: clasificacionDescripcion, 
          id_tipo: idTipo 
        },
        codigo_plame: conceptoPlame.codigo_plame || conceptoPlame.codigo,
        descripcion: conceptoPlame.descripcion,
        id: conceptoPlame.id
      },
      plame_configuracion_id: conceptoPlame.id,
      tipo_concepto: tipoConcepto,
      updated_at: new Date().toISOString(),
      // 🆕 Campos adicionales del modal
      esNuevo: true // Marcar como nuevo para diferenciarlo
    };

    // 🎯 APLICAR FUNCIÓN PARA ASEGURAR ESTRUCTURA COMPLETA (incluir código y descripción a nivel raíz)
    const nuevoConcepto = asegurarEstructuraCompletaLocal(conceptoBase);
    
    console.log('🆕 Nuevo concepto creado con estructura completa:', {
      codigo: nuevoConcepto.codigo,
      descripcion: nuevoConcepto.descripcion,
      codigoPlame: nuevoConcepto.codigoPlame,
      concepto_completo: nuevoConcepto
    });

    // Determinar a qué sección agregar el concepto
    const tipoSeccion = tipoConcepto === 'ingreso' ? 'ingresos' : 
                        tipoConcepto === 'descuento' ? 'descuentos' : 'aportes';

    // Actualizar los conceptos del empleado seleccionado
    setEmpleadosConConceptos(prevEmpleados => {
      return prevEmpleados.map(empleado => {
        if (empleado.id === empleadoSeleccionadoAjustes.id) {
          const grouped = agruparConceptos(empleado.conceptos);
          const nuevosConceptos = [...grouped[tipoSeccion], nuevoConcepto];
          console.log(`🔄 Actualizando empleadosConConceptos después de agregar concepto PLAME (${tipoSeccion}):`, {
            tipo: tipoSeccion,
            conceptosAnteriores: grouped[tipoSeccion].length,
            conceptosNuevos: nuevosConceptos.length,
            conceptoAgregado: nuevoConcepto.descripcion
          });
          return {
            ...empleado,
            conceptos: {
              ...grouped,
              [tipoSeccion]: nuevosConceptos
            }
          };
        }
        return empleado;
      });
    });

    // Actualizar también el empleado seleccionado para reflejar el cambio inmediatamente
    setEmpleadoSeleccionadoAjustes(prevEmpleado => ({
      ...prevEmpleado,
      conceptos: {
        ...prevEmpleado.conceptos,
        [tipoSeccion]: [...(prevEmpleado.conceptos?.[tipoSeccion] || []), nuevoConcepto]
      }
    }));
    
    console.log('✅ Concepto agregado exitosamente:', {
      nombre: conceptoPlame.descripcion,
      codigo: conceptoPlame.codigo_plame || conceptoPlame.codigo,
      estructura_final: nuevoConcepto
    });

    // Cerrar modal de PLAME y regresar al modal anterior
    setConceptosPlameModalOpen(false);
    setBusquedaConceptoPlame('');
  };

  const eliminarConcepto = (empleadoId, conceptoId) => {
    console.log(`🗑️ Eliminando concepto ${conceptoId} del empleado ${empleadoId}`);
    setConceptosEliminados(prev => ({
      ...prev,
      [empleadoId]: {
        ...prev[empleadoId],
        [conceptoId]: true
      }
    }));
    
    // También eliminar de conceptos temporales si existe
    setConceptosTemporales(prev => {
      const nuevos = { ...prev };
      if (nuevos[empleadoId]) {
        delete nuevos[empleadoId][conceptoId];
        if (Object.keys(nuevos[empleadoId]).length === 0) {
          delete nuevos[empleadoId];
        }
      }
      return nuevos;
    });
  };

  const restaurarConcepto = (empleadoId, conceptoId) => {
    console.log(`🔄 Restaurando concepto ${conceptoId} del empleado ${empleadoId}`);
    setConceptosEliminados(prev => {
      const nuevos = { ...prev };
      if (nuevos[empleadoId]) {
        delete nuevos[empleadoId][conceptoId];
        if (Object.keys(nuevos[empleadoId]).length === 0) {
          delete nuevos[empleadoId];
        }
      }
      return nuevos;
    });
  };

  // 🔄 FUNCIÓN PRINCIPAL PARA APLICAR AJU
  // ES TEMPORALES AL ARRAY UNIFICADO
  const aplicarAjustesTemporalesAlArrayUnificado = (arrayUnificado) => {
    console.log('🔄 === APLICANDO AJUSTES TEMPORALES AL ARRAY UNIFICADO ===');
    console.log('🔍 Array unificado recibido:', arrayUnificado.length, 'elementos');
    console.log('🔍 Estado empleadosConConceptos:', empleadosConConceptos.length, 'empleados');
    console.log('empleadosConConceptos:', empleadosConConceptos);
    // DEBUG: Mostrar estructura de empleadosConConceptos
    empleadosConConceptos.forEach((emp, idx) => {
      if (idx < 2) { // Solo los primeros 2 para no saturar
        console.log(`🔍 EmpleadosConConceptos[${idx}]:`, {
          id: emp.id,
          nombre: emp.nombre,
          tieneConceptos: !!emp.conceptos,
          tieneIngresos: !!emp.conceptos?.ingresos,
          cantidadIngresos: emp.conceptos?.ingresos?.length || 0,
          primerosIngresos: emp.conceptos?.ingresos?.slice(0, 2)?.map(c => ({
            codigo: c.codigo,
            descripcion: c.descripcion,
            monto: c.monto,
            esNuevo: c.esNuevo,
            esModificado: c.esModificado
          }))
        });
      }
    });
    
    // Clonar el array para no modificar el original
    const arrayModificado = [...arrayUnificado];
    let empleadosProcesados = 0;
    let empleadosConCambios = 0;
    
    // Buscar empleados en el array (tipo: 'empleado_activo_con_apis')
    arrayModificado.forEach((elemento, index) => {
      if (elemento.tipo === 'empleado_activo_con_apis') {
        empleadosProcesados++;
        const empleadoId = elemento.empleado_id;

        if (empleadoTienePreCierreCongelado(empleadoId)) {
          return;
        }
        
        console.log(`🔍 Procesando empleado ${empleadosProcesados}: ${elemento.empleado_nombre} (ID: ${empleadoId})`);
        console.log(`🔍 Conceptos originales en array unificado:`, elemento.conceptosUsuario?.ingresos?.length || 0);
        
        const empleadoConAjustes = empleadosConConceptos.find(emp => emp.id === empleadoId);
        const tieneCambios = empleadoTieneCambiosAjustes({
          empleadoId,
          conceptosTemporales,
          conceptosEliminados,
          empleadosConceptosRestaurados,
          empleado: empleadoConAjustes,
        });

        if (!tieneCambios) {
          return;
        }

        empleadosConCambios++;
          console.log(`💰 ✅ EMPLEADO CON AJUSTES: ${elemento.empleado_nombre}`);
          
        const conceptosUsuarioAjustados = aplicarAjustesAConceptosUsuario({
          conceptosUsuario: elemento.conceptosUsuario || {},
          conceptosAjustes: empleadoConAjustes?.conceptos,
          temporales: conceptosTemporales[empleadoId] || conceptosTemporales[String(empleadoId)] || {},
          eliminados: conceptosEliminados[empleadoId] || conceptosEliminados[String(empleadoId)] || {},
          defaultDestino: defaultDestinoAjusteEmpleado(empleadoId),
        });

        const ingresosFinales = conceptosUsuarioAjustados.ingresos || [];
        const descuentosFinales = conceptosUsuarioAjustados.descuentos || [];
        const aportesFinales = conceptosUsuarioAjustados.aportes || [];

          // Ajustes hacia boleta interna (sueldo_interno / ingresosInternos)
          let sueldoInternoAjustado = Number(
            elemento.datosSalariales?.sueldoInterno
            ?? elemento.datosEmpleado?.sueldo_interno
            ?? 0
          );
          let ingresosInternosAjustados = [...(elemento.conceptosUsuario?.ingresosInternos || [])];
          let descuentosInternosAjustados = [...(elemento.conceptosUsuario?.descuentosInternos || [])];

          const aplicarAjusteInterna = (conceptos, bucketInterno, esIngreso) => {
            // No cruzar conceptos PLAME → interna por default.
            // Solo si el usuario destinó explícitamente a interna (o ambas con monto_interna).
            // AFP/ONP/EsSalud/minera se copian desde el motor, no por este camino.
            conceptos.forEach((concepto) => {
              const codigo = codigoConceptoAjuste(concepto);
              const rawAjuste = buscarValorPorConcepto(
                conceptosTemporales[empleadoId] || conceptosTemporales[String(empleadoId)] || {},
                concepto
              );
              const destinoGuardado = concepto.destino_ajuste
                ? String(concepto.destino_ajuste).toLowerCase()
                : null;

              let destino;
              let montoNuevo;

              if (rawAjuste != null) {
                destino = String(
                  getDestinoDesdeAjuste(rawAjuste, 'plame') || 'plame'
                ).toLowerCase();
                if (!destinoAplicaInternaParaEmpleado(destino, elemento)) return;
                montoNuevo = Number(
                  getMontoDesdeAjuste(rawAjuste, concepto.monto_interna ?? concepto.monto)
                );
              } else if (destinoGuardado === 'interna') {
                destino = 'interna';
                montoNuevo = Number(concepto.monto_interna ?? concepto.monto);
              } else if (destinoGuardado === 'ambas' && concepto.monto_interna != null) {
                // Legacy/ambas solo si hay monto_interna real (no el default antiguo vacío)
                destino = 'ambas';
                if (!destinoAplicaInternaParaEmpleado(destino, elemento)) return;
                montoNuevo = Number(concepto.monto_interna);
              } else {
                return;
              }
              if (codigo === '0917') return;

              if (!(montoNuevo >= 0)) return;

              if (esIngreso && codigo === '0121') {
                sueldoInternoAjustado = montoNuevo;
                console.log(`🚕 Ajuste interna 0121 → sueldo_interno S/ ${montoNuevo}`);
                return;
              }

              const existente = bucketInterno.find(
                (x) => String(
                  x.codigoPlame
                  || x.codigo_plame
                  || x.codigo
                  || x.plame_configuracion?.codigo_plame
                  || x.plameConfiguracion?.codigo_plame
                  || ''
                ) === codigo
              );
              if (existente) {
                existente.monto = montoNuevo;
              } else if (codigo) {
                bucketInterno.push({
                  id: concepto.plame_configuracion_id || concepto.id,
                  codigo,
                  codigo_plame: codigo,
                  codigoPlame: codigo,
                  monto: montoNuevo,
                  tipo_concepto: esIngreso ? 'ingreso' : 'descuento',
                  descripcion: concepto.descripcion || concepto.concepto || codigo,
                  origenCalculo: 'ajuste_sueldo_interna',
                });
              }
              });
          };
          
          aplicarAjusteInterna(ingresosFinales, ingresosInternosAjustados, true);
          aplicarAjusteInterna(descuentosFinales, descuentosInternosAjustados, false);
          
          console.log(`🔍 Conceptos CON AJUSTES:`, {
            ingresos: ingresosFinales.length,
            descuentos: descuentosFinales.length,
            aportes: aportesFinales.length,
            conceptosTemporalesEmpleado: conceptosTemporales[empleadoId] || {},
            conceptosEliminadosEmpleado: conceptosEliminados[empleadoId] || {},
            sueldoInternoAjustado,
          });
          
          // Reemplazar con conceptos ajustados
          arrayModificado[index] = {
            ...elemento,
            datosSalariales: {
              ...elemento.datosSalariales,
              sueldoInterno: sueldoInternoAjustado,
            },
            datosEmpleado: {
              ...elemento.datosEmpleado,
              sueldo_interno: sueldoInternoAjustado,
            },
            conceptosUsuario: {
              ...elemento.conceptosUsuario,
              ingresos: ingresosFinales,
              descuentos: descuentosFinales,
              aportes: aportesFinales,
              ingresosInternos: ingresosInternosAjustados,
              descuentosInternos: descuentosInternosAjustados,
            }
          };
        console.log(`🔍 =====================================`);
      }
    });
    
    console.log(`🔄 === RESUMEN DE APLICACIÓN DE AJUSTES ===`);
    console.log(`📊 Empleados procesados: ${empleadosProcesados}`);
    console.log(`📊 Empleados con cambios aplicados: ${empleadosConCambios}`);
    console.log(`🔄 =========================================`);
    
    return arrayModificado;
  };

  // 💾 FUNCIÓN PARA ACTUALIZAR CONCEPTOS EN EL BACKEND
  const actualizarConceptosEnBackend = async () => {
    try {
      console.log('💾 === INICIANDO ACTUALIZACIÓN DE CONCEPTOS EN BACKEND ===');
      const payload = construirPayloadAjustesRecalculo({
        empleadosConConceptos,
        conceptosTemporales,
        conceptosEliminados,
        empleadosConceptosRestaurados,
        defaultDestinoFn: defaultDestinoAjusteEmpleado,
      }).filter((item) => !empleadoTienePreCierreCongelado(item.id));

      console.log('🔍 Payload recálculo (solo cambios):', payload);

      if (payload.length === 0) {
        console.log('ℹ️ No hay empleados con cambios para actualizar en el backend');
        return;
      }

      const response = await consideracionesConceptosService.guardarConceptosPlanilla(parseInt(id), payload);
      if (!response.success) {
        throw new Error('Error del backend al actualizar conceptos');
      }

      setEmpleadosConConceptos((prev) => prev.map((emp) => {
        const item = payload.find((x) => Number(x.id) === Number(emp.id));
        if (!item) return emp;
                return {
          ...emp,
          conceptos: aplicarPayloadAConceptosLocales(emp.conceptos, item),
        };
      }));

      console.log('💾 === ACTUALIZACIÓN EN BACKEND COMPLETADA ===', response.data);
    } catch (error) {
      console.error('❌ Error actualizando conceptos en backend:', error);
      throw error;
    }
  };

  // 🚀 FUNCIÓN DE RECÁLCULO CON AJUSTES TEMPORALES
  const recalcularPlanillaConAjustes = async () => {
    try {
      console.log('🚀 === INICIANDO RECÁLCULO CON AJUSTES TEMPORALES ===');
      const idEmpleadoModal = Number(empleadoSeleccionadoAjustes?.id);
      const esCerradaConAjuste =
        (planillaCerrada || planillaReal?.estado === 'cerrada')
        && empleadosEnAjustePosteriorIds.size > 0;

      console.log('📊 empleadosConConceptos:', empleadosConConceptos.length, 'empleados');
      console.log('📊 conceptosTemporales:', Object.keys(conceptosTemporales).length, 'empleados con ajustes');

      console.log('💾 === ACTUALIZANDO CONCEPTOS EN BACKEND ANTES DEL RECÁLCULO ===');
      await actualizarConceptosEnBackend();

      window.aplicarAjustesTemporales = true;

      const opcionesRecalc = {
        omitirConfirmacion: true,
      };
      if (esCerradaConAjuste && Number.isFinite(idEmpleadoModal) && idEmpleadoModal > 0) {
        opcionesRecalc.soloAjustePosteriorIds = [idEmpleadoModal];
        const asegurar = await asegurarDepsCalculoAjustePosterior([idEmpleadoModal]);
        opcionesRecalc.empleadosAjustePosteriorEnriquecidos = asegurar.enriquecidos;
        opcionesRecalc.depsCalculo = asegurar.depsCalculo;
      } else if (esCerradaConAjuste) {
        opcionesRecalc.soloAjustePosteriorIds = [...empleadosEnAjustePosteriorIds];
        const asegurar = await asegurarDepsCalculoAjustePosterior([...empleadosEnAjustePosteriorIds]);
        opcionesRecalc.empleadosAjustePosteriorEnriquecidos = asegurar.enriquecidos;
        opcionesRecalc.depsCalculo = asegurar.depsCalculo;
      }

      await procesarEmpleadosConPlanilla(opcionesRecalc);

      window.aplicarAjustesTemporales = false;

      setConceptosTemporales({});
      setConceptosEliminados({});
      setEmpleadosConceptosRestaurados(new Set());

      alert('✅ ¡Recálculo completado!\n\n🎯 Los ajustes han sido aplicados exitosamente.\n📊 La boleta se actualizó con los nuevos conceptos y montos.\n\n✨ Puedes continuar editando o cerrar este modal.');

    } catch (error) {
      console.error('❌ Error en recálculo con ajustes:', error);
      window.aplicarAjustesTemporales = false;
      alert('❌ Error en el recálculo\n\n⚠️ Hubo un problema al aplicar los ajustes.\n🔄 Por favor, inténtalo nuevamente.\n\nConsulta la consola para más detalles.');
    }
  };

  // 🔍 FUNCIÓN PARA MANEJAR LA BÚSQUEDA DE EMPLEADOS
  const manejarBusquedaEmpleado = (valorBusqueda) => {
    setBusquedaEmpleado(valorBusqueda);
    
    if (valorBusqueda.trim() === '') {
      setEmpleadosFiltrados([]);
      setMostrarSugerencias(false);
      return;
    }

    // Filtrar empleados que coincidan con la búsqueda
    const empleadosFiltrados = empleadosActivosPlanilla.filter(empleado =>
      empleado.nombre_completo.toLowerCase().includes(valorBusqueda.toLowerCase()) ||
      empleado.numero_documento?.toLowerCase().includes(valorBusqueda.toLowerCase()) ||
      empleado.codigo_empleado?.toLowerCase().includes(valorBusqueda.toLowerCase())
    );

    setEmpleadosFiltrados(empleadosFiltrados);
    setMostrarSugerencias(empleadosFiltrados.length > 0);
  };

  // 🔍 FUNCIÓN PARA SELECCIONAR UN EMPLEADO DE LAS SUGERENCIAS
  const seleccionarEmpleado = (empleado) => {
    setEmpleadoSeleccionadoAnalisis(empleado.id);
    setBusquedaEmpleado(empleado.nombre_completo);
    setMostrarSugerencias(false);
    setEmpleadosFiltrados([]);
  };

  // 🔍 FUNCIÓN PARA OCULTAR SUGERENCIAS AL HACER CLIC FUERA
  const ocultarSugerencias = () => {
    setTimeout(() => {
      setMostrarSugerencias(false);
    }, 200); // Delay para permitir que el click en la sugerencia se procese
  };

  // 🔄 FUNCIÓN PARA CARGAR COMPENSACIONES (útil para debugging)
  const cargarCompensacionesActuales = async () => {
    if (!planillaReal?.id) {
      console.log('⚠️ No hay planilla ID disponible para cargar compensaciones');
      setCompensacionesTodosEmpleados([]);
      return [];
    }

    try {
      console.log(`📊 Cargando compensaciones para planilla ${planillaReal.id}...`);
      
      const resultado = await compensacionService.obtenerCompensacionesPorPlanilla(planillaReal.id);
      
      if (resultado.success) {
        console.log(`✅ Compensaciones cargadas: ${resultado.total} registros | Total horas: ${resultado.totalHoras}h`);
        console.log(`🔍 Datos de compensaciones recibidos:`, resultado.data);
        
        // Log detallado de las primeras compensaciones para debugging
        if (resultado.data && resultado.data.length > 0) {
          console.log(`📋 Primeras 3 compensaciones cargadas:`);
          resultado.data.slice(0, 3).forEach((comp, index) => {
            console.log(`  ${index + 1}. Empleado ID: ${comp.empleado_id} | Horas: ${comp.horas_compensadas}`);
          });
        }
        
        setCompensacionesTodosEmpleados(resultado.data);
        return resultado.data;
      } else {
        console.error(`❌ Error al cargar compensaciones: ${resultado.error}`);
        setCompensacionesTodosEmpleados([]);
        return [];
      }
    } catch (error) {
      console.error(`❌ Error inesperado al cargar compensaciones:`, error);
      setCompensacionesTodosEmpleados([]);
      return [];
    }
  };

  const getTareoStatus = (tareos, empleado, fechaInicioPlanilla = null, fechaFinPlanilla = null) => {
    // Verificar si hay tareos registrados para todos los días del período
            const totalDiasConTareos = empleado?.resumenTareos?.total_tareos || 0;
    
    // Calcular los días que REALMENTE debía trabajar considerando fechas de ingreso/cese
    let diasQueDebiaTrabajar = tareos.diasProgramados; // Valor por defecto
    
    if (fechaInicioPlanilla && fechaFinPlanilla && empleado) {
      const empleadoParaDias = vistaBoletaUsaCanalInterno(
        empleado,
        filtroTipoBoleta,
        fechaInicioPlanilla,
        fechaFinPlanilla
      )
        ? construirEmpleadoParaHistorialInterno(empleado)
        : empleado;
      const fechasLaborales = obtenerFechasLaboralesEfectivasEnRango(
        empleadoParaDias,
        fechaInicioPlanilla,
        fechaFinPlanilla
      );

      if (fechasLaborales.fechaIngreso && fechasLaborales.fechaCese) {
        const [añoIni, mesIni, diaIni] = fechasLaborales.fechaIngreso.split('-').map(Number);
        const [añoFin, mesFin, diaFin] = fechasLaborales.fechaCese.split('-').map(Number);
        const fechaInicioReal = new Date(añoIni, mesIni - 1, diaIni);
        const fechaFinReal = new Date(añoFin, mesFin - 1, diaFin);

        const diferenciaMilisegundos = fechaFinReal.getTime() - fechaInicioReal.getTime();
        diasQueDebiaTrabajar = Math.ceil(diferenciaMilisegundos / (1000 * 60 * 60 * 24)) + 1;
        diasQueDebiaTrabajar = Math.max(0, diasQueDebiaTrabajar);
      }
    }
    
    // Tareo completo si hay registros para todos los días que debía trabajar
    // 🔒 Para planillas cerradas, todos los tareos se consideran completos
    const isCompleto = planillaCerrada ? true : (totalDiasConTareos >= diasQueDebiaTrabajar);
    
    return {
      status: isCompleto ? 'completo' : 'incompleto',
      text: isCompleto ? 'Tareo Completo' : 'Tareo Incompleto',
      color: isCompleto ? 'text-green-600' : 'text-yellow-600',
      bgColor: isCompleto ? 'bg-green-100' : 'bg-yellow-100',
      icon: isCompleto ? '✓' : '⚠',
      diasQueDebiaTrabajar: diasQueDebiaTrabajar,
      diasRegistrados: totalDiasConTareos
    };
  };

  /** Emoji 🚕✅ / 🚕⚠️ / 🚕❓ según viáticos real vs monto × días asistidos */
  const getCuadreViaticosEmpleado = (empleadoFull) => {
    if (!viaticosConfig?.activo || !viaticosConfig?.plame_configuracion_id || !empleadoFull) return null;
    const idEmp = empleadoFull.id != null ? Number(empleadoFull.id) : null;
    if (idEmp == null) return null;
    const tareosInterna = Array.isArray(empleadoFull.tareosEmpleadoInterna)
      ? empleadoFull.tareosEmpleadoInterna
      : [];
    const tareosFiltrados = Array.isArray(empleadoFull.tareosEmpleadoFiltrados)
      ? empleadoFull.tareosEmpleadoFiltrados
      : [];
    const tareosPlame = Array.isArray(empleadoFull.tareosEmpleado)
      ? empleadoFull.tareosEmpleado
      : [];
    const tareosApi = (tareosPeriodo || []).filter((t) => Number(t.empleado_id) === idEmp);
    const tareosEmp = tareosInterna.length > 0
      ? tareosInterna
      : (tareosFiltrados.length > 0
        ? tareosFiltrados
        : (tareosPlame.length > 0 ? tareosPlame : tareosApi));
    const montoDia = parseFloat(
      empleadoFull.monto_viatico_standard
      ?? empleadoFull.montoViaticoStandard
      ?? empleadoFull.datosEmpleado?.monto_viatico_standard
      ?? empleadoFull.datosSalariales?.montoViaticoStandard
      ?? 0
    ) || 0;
    return evaluarCuadreViaticos({
      tareos: tareosEmp,
      plameConfiguracionId: viaticosConfig.plame_configuracion_id,
      montoDia,
      fechaInicio: planillaReal?.fecha_inicio || planilla?.fecha_inicio,
      fechaFin: planillaReal?.fecha_fin || planilla?.fecha_fin,
      activo: true,
    });
  };

  // Función para mostrar datos de empleados con conceptos
  // Función para determinar si un empleado estaba activo durante el período de la planilla
  const empleadoActivoDurantePeriodo = (empleado, fechaInicioPlanilla, fechaFinPlanilla) => {
    const activo = empleadoVigenteEnRangoPlanilla(empleado, fechaInicioPlanilla, fechaFinPlanilla);
    if (!activo) {
      console.log(`❌ Empleado ${empleado.nombre_completo} sin contrato vigente en el período de planilla`);
      return false;
    }
    return true;
  };

  const mostrarDatosSeleccionados = async () => {
    console.log('📋 === DATOS DE EMPLEADOS ===');

    // NOTA: No cargar datos adicionales aquí para evitar peticiones duplicadas
    // Los datos ya deben estar cargados por cargarTodosLosDatos()
    // Usar los datos de la planilla real desde el estado
    
    // ESTADO ACTUAL DE EMPLEADOS
    //console.log('\n👥 === ESTADO ACTUAL DE EMPLEADOS ===');
    //console.log('📊 empleadosConConceptos (datos reales):', empleadosConConceptos);
    //console.log('📊 empleadosConConceptos.length:', empleadosConConceptos.length);
    //console.log('📊 loading:', loading);
    //console.log('📊 planillaReal (datos del backend):', planillaReal);

    // FILTRAR EMPLEADOS ACTIVOS DURANTE EL PERÍODO DE LA PLANILLA
    let empleadosActivos = [];
    if (planillaReal && planillaReal.fecha_inicio && planillaReal.fecha_fin && empleadosConConceptos.length > 0) {
      //console.log('\n🔍 === FILTRADO DE EMPLEADOS ACTIVOS ===');
      //console.log(`📅 Período de planilla: ${planillaReal.fecha_inicio} - ${planillaReal.fecha_fin}`);
      
      empleadosActivos = empleadosConConceptos.filter(empleado => {
        return empleadoActivoDurantePeriodo(empleado, planillaReal.fecha_inicio, planillaReal.fecha_fin);
      });

      // Filtrar por tipo de contratación según modalidad de la planilla
      const modalidad = planillaReal.modalidad_planilla || null;
      const esPlanillaRH = modalidad === 'planilla_rh' || (planillaReal.nombre && (String(planillaReal.nombre).toUpperCase().trim() === 'RH' || String(planillaReal.nombre).toUpperCase().includes('RH')));
      const esPlanillaNormal = modalidad === 'planilla_normal';
      const tipoContratacionDe = (emp) => String(emp.tipo_contratacion || emp.datosSalariales?.tipoContratacion || emp.datosEmpleado?.tipo_contratacion || '').trim();
      const esJornalNoConsu = (emp) => esPersonalJornalNoConstruccion(
        emp,
        esRegimenConstruccionCivil(emp, regimenesLaborales || [])
      );

      if (esPlanillaRH) {
        empleadosActivos = empleadosActivos.filter(emp => tipoContratacionDe(emp) === 'Recibo por Honorarios');
        console.log(`📋 Planilla RH: filtrado solo personal en Recibo por Honorarios. Total: ${empleadosActivos.length} empleados`);
      } else if (modalidad === 'planilla_construccion') {
        empleadosActivos = empleadosActivos.filter((emp) => esRegimenConstruccionCivil(emp, regimenesLaborales || []));
        console.log(`📋 Planilla Construcción: solo personal CONSU. Total: ${empleadosActivos.length} empleados`);
      } else if (modalidad === 'planilla_jornales') {
        empleadosActivos = empleadosActivos.filter((emp) => esJornalNoConsu(emp));
        console.log(`📋 Planilla Jornales: solo personal jornal (excl. CONSU). Total: ${empleadosActivos.length} empleados`);
      } else if (esPlanillaNormal) {
        empleadosActivos = empleadosActivos.filter(emp => tipoContratacionDe(emp) !== 'Recibo por Honorarios');
        console.log(`📋 Planilla Normal: solo personal de planilla (excl. RH). Total: ${empleadosActivos.length} empleados`);
      }

      //console.log(`\n📊 RESULTADO DEL FILTRADO:`);
      //console.log(`  📋 Total empleados: ${empleadosConConceptos.length}`);
      //console.log(`  ✅ Empleados activos durante planilla: ${empleadosActivos.length}`);
      //console.log(`  ❌ Empleados no activos: ${empleadosConConceptos.length - empleadosActivos.length}`);
      //console.log(`\n👥 Lista de empleados activos:`, empleadosActivos.map(emp => emp.nombre_completo));
      
      // Actualizar el estado con los empleados activos
      setEmpleadosActivosPlanilla(empleadosActivos);
    } else {
      console.log('⚠️ No se puede filtrar empleados activos: faltan datos de planilla real o empleados');
      setEmpleadosActivosPlanilla([]);
    }
    
    // Datos de la Empresa
    console.log('\n🏢 === EMPRESA SELECCIONADA ===');
    console.log('Empresa seleccionada:', selectedCompany);
    
    let empresaInfo = '';
    if (selectedCompany) {
      console.log('📊 Detalles de la empresa:');
      console.log('  - ID:', selectedCompany.id);
      console.log('  - RUC:', selectedCompany.ruc);
      console.log('  - Nombre:', selectedCompany.name);
      console.log('  - Descripción:', selectedCompany.description);
      console.log('  - Empleados:', selectedCompany.employees);
      
      empresaInfo = `🏢 EMPRESA SELECCIONADA:\n• ID: ${selectedCompany.id}\n• RUC: ${selectedCompany.ruc}\n• Nombre: ${selectedCompany.name}\n• Descripción: ${selectedCompany.description}\n• Empleados: ${selectedCompany.employees}\n\n`;
    } else {
      console.log('⚠️ No hay empresa seleccionada');
      empresaInfo = '⚠️ No hay empresa seleccionada\n\n';
    }
    
    // Datos de la Planilla Real
    console.log('\n📋 === DATOS DE LA PLANILLA REAL ===');
    let planillaInfo = '';
    
    if (planillaReal) {
      console.log('📊 Planilla real del backend:');
      console.log('  - ID:', planillaReal.id);
      console.log('  - Nombre:', planillaReal.nombre);
      console.log('  - Periodo:', planillaReal.periodo);
      console.log('  - Estado:', planillaReal.estado);
      console.log('  - Fecha Inicio:', planillaReal.fecha_inicio);
      console.log('  - Fecha Fin:', planillaReal.fecha_fin);
      console.log('  - Descripción:', planillaReal.descripcion);
      console.log('  - Empresa ID:', planillaReal.empresa_id);
      console.log('  - Total Empleados:', planillaReal.total_empleados);
      
      planillaInfo += `📋 PLANILLA REAL (BACKEND):\n`;
      planillaInfo += `• ID: ${planillaReal.id}\n`;
      planillaInfo += `• Nombre: ${planillaReal.nombre || 'N/A'}\n`;
      planillaInfo += `• Periodo: ${planillaReal.periodo || 'N/A'}\n`;
      planillaInfo += `• Estado: ${planillaReal.estado || 'N/A'}\n`;
      planillaInfo += `• Fecha Inicio: ${planillaReal.fecha_inicio || 'N/A'}\n`;
      planillaInfo += `• Fecha Fin: ${planillaReal.fecha_fin || 'N/A'}\n`;
      planillaInfo += `• Descripción: ${planillaReal.descripcion || 'N/A'}\n`;
      planillaInfo += `• Empresa ID: ${planillaReal.empresa_id || 'N/A'}\n`;
      planillaInfo += `• Total Empleados: ${planillaReal.total_empleados || 0}\n\n`;
    } else {
      planillaInfo = '⚠️ No hay datos de planilla real disponibles\n\n';
    }
    
    // Datos de Tareos por Período
    console.log('\n⏰ === TAREOS POR PERÍODO ===');
    let tareosInfo = '';
    
    if (tareosPeriodo.length > 0) {
      console.log('📊 Tareos del período:');
      console.log('  - Total tareos:', tareosPeriodo.length);
      console.log('  - Array tareos:', tareosPeriodo);
      
    // Datos de Autorizaciones por Período
    console.log('\n🔐 === AUTORIZACIONES POR PERÍODO ===');
    console.log('📊 Autorizaciones del período:');
    console.log('  - Total autorizaciones:', autorizacionesPeriodo.length);
    console.log('  - Array autorizaciones:', autorizacionesPeriodo);
      
      tareosInfo += `⏰ TAREOS DEL PERÍODO (${tareosPeriodo.length} registros):\n\n`;
      
      // Agregar información de autorizaciones
      if (autorizacionesPeriodo.length > 0) {
        tareosInfo += `🔐 AUTORIZACIONES DEL PERÍODO (${autorizacionesPeriodo.length} registros):\n\n`;
        
        // Agrupar por empleado
        const autorizacionesPorEmpleado = {};
        autorizacionesPeriodo.forEach(autorizacion => {
          const empleadoId = autorizacion.empleado_id;
          const empleadoNombre = autorizacion.empleado?.nombre_completo || `Empleado ${empleadoId}`;
          
          if (!autorizacionesPorEmpleado[empleadoId]) {
            autorizacionesPorEmpleado[empleadoId] = {
              nombre: empleadoNombre,
              autorizaciones: []
            };
          }
          autorizacionesPorEmpleado[empleadoId].autorizaciones.push(autorizacion);
        });
        
        Object.values(autorizacionesPorEmpleado).forEach((empleadoAutorizaciones, index) => {
          tareosInfo += `${index + 1}. ${empleadoAutorizaciones.nombre}\n`;
          tareosInfo += `   • Total autorizaciones: ${empleadoAutorizaciones.autorizaciones.length}\n`;
          
          // Mostrar primeras 3 autorizaciones
          empleadoAutorizaciones.autorizaciones.slice(0, 3).forEach((autorizacion, aIndex) => {
            tareosInfo += `     - ${autorizacion.tipo_autorizacion}${autorizacion.sub_tipo ? ` (${autorizacion.sub_tipo})` : ''}\n`;
            tareosInfo += `       ${autorizacion.fecha_inicio} - ${autorizacion.fecha_fin || 'Sin fin'}\n`;
            tareosInfo += `       ${autorizacion.dias || 0} días | ${autorizacion.horas || 0}h | ${autorizacion.estado}\n`;
            if (autorizacion.motivo) {
              tareosInfo += `       Motivo: ${autorizacion.motivo}\n`;
            }
          });
          
          if (empleadoAutorizaciones.autorizaciones.length > 3) {
            tareosInfo += `     ... y ${empleadoAutorizaciones.autorizaciones.length - 3} autorizaciones más\n`;
          }
          tareosInfo += '\n';
        });
      } else {
        tareosInfo += `🔐 AUTORIZACIONES DEL PERÍODO: No hay autorizaciones en este período\n\n`;
      }
      
      // Agrupar por empleado
      const tareosPorEmpleado = {};
      tareosPeriodo.forEach(tareo => {
        const empleadoId = tareo.empleado_id;
        const empleadoNombre = tareo.empleado?.nombre_completo || `Empleado ${empleadoId}`;
        
        if (!tareosPorEmpleado[empleadoId]) {
          tareosPorEmpleado[empleadoId] = {
            nombre: empleadoNombre,
            tareos: []
          };
        }
        tareosPorEmpleado[empleadoId].tareos.push(tareo);
      });
      
      Object.values(tareosPorEmpleado).forEach((empleadoTareos, index) => {
        //console.log(`👤 Empleado ${index + 1}: ${empleadoTareos.nombre}`);
        //console.log(`  - Total tareos: ${empleadoTareos.tareos.length}`);
        
        tareosInfo += `${index + 1}. ${empleadoTareos.nombre}\n`;
        tareosInfo += `   • Total registros: ${empleadoTareos.tareos.length}\n`;
        
        // Mostrar primeros 3 tareos
        empleadoTareos.tareos.slice(0, 3).forEach((tareo, tIndex) => {
          //console.log(`    ${tIndex + 1}. Fecha: ${tareo.fecha} | Tipo: ${tareo.tipo_evento}`);
          //console.log(`       Entrada: ${tareo.hora_entrada_real || tareo.hora_entrada_teorica} | Salida: ${tareo.hora_salida_real || tareo.hora_salida_teorica}`);
          //console.log(`       Horas: ${tareo.horas_trabajadas || 0}h | Proyecto: ${tareo.proyecto?.nombre || 'N/A'}`);
          
          tareosInfo += `     - ${tareo.fecha}: ${tareo.tipo_evento}\n`;
          tareosInfo += `       ${tareo.hora_entrada_real || tareo.hora_entrada_teorica || 'N/A'} - ${tareo.hora_salida_real || tareo.hora_salida_teorica || 'N/A'}\n`;
          tareosInfo += `       ${tareo.horas_trabajadas || 0}h | ${tareo.proyecto?.nombre || 'Sin proyecto'}\n`;
        });
        
        if (empleadoTareos.tareos.length > 3) {
          tareosInfo += `     ... y ${empleadoTareos.tareos.length - 3} tareos más\n`;
        }
        tareosInfo += '\n';
      });
    } else {
      //console.log('⚠️ No hay tareos para el período');
      tareosInfo = '⚠️ No hay tareos para el período de la planilla\n\n';
    }
    
    // Resumen de Tareos
    if (resumenTareos) {
      //console.log('📈 Resumen de tareos:', resumenTareos);
      tareosInfo += `📈 RESUMEN DE TAREOS:\n`;
      tareosInfo += `• Total días trabajados: ${resumenTareos.total_dias_trabajados || 0}\n`;
      tareosInfo += `• Total horas trabajadas: ${resumenTareos.total_horas_trabajadas || 0}h\n`;
      tareosInfo += `• Total empleados con tareos: ${resumenTareos.total_empleados || 0}\n`;
      tareosInfo += `• Promedio horas por día: ${resumenTareos.promedio_horas_dia || 0}h\n`;
      if (resumenTareos.tipos_evento) {
        tareosInfo += `• Distribución de eventos:\n`;
        Object.entries(resumenTareos.tipos_evento).forEach(([tipo, cantidad]) => {
          tareosInfo += `  - ${tipo}: ${cantidad}\n`;
        });
      }
      tareosInfo += '\n';
    } else {
      tareosInfo += '📈 RESUMEN DE TAREOS: No disponible\n\n';
    }
    
    // Datos de Empleados CON CONCEPTOS
    //console.log('\n👤 === EMPLEADOS CON CONCEPTOS ===');
    //console.log('Total empleados con conceptos:', empleadosConConceptos.length);
    //console.log('Array empleados con conceptos:', empleadosConConceptos);
    
    let empleadosInfo = '';
      let totalConceptos = 0;
    let totalConceptosIngresos = 0;
    let totalConceptosDescuentos = 0;
    let totalConceptosAportes = 0;
      let totalConceptosPlame = 0;
    
    if (empleadosConConceptos.length > 0) {
      //console.log('📊 Detalles de empleados con conceptos:');
      
      empleadosInfo = `👤 EMPLEADOS CON CONCEPTOS (${empleadosConConceptos.length}):\n\n`;
      
      empleadosConConceptos.forEach((empleado, index) => {
        totalConceptos += empleado.total_conceptos || 0;
        totalConceptosIngresos += empleado.conceptos_ingresos || 0;
        totalConceptosDescuentos += empleado.conceptos_descuentos || 0;
        totalConceptosAportes += empleado.conceptos_aportes || 0;
        totalConceptosPlame += empleado.conceptos_plame || 0;
        
        //console.log(`\n👤 Empleado ${index + 1}:`);
        //console.log('  - ID:', empleado.id);
        //console.log('  - Nombre:', empleado.nombre_completo);
        //console.log('  - Documento:', empleado.numero_documento);
        //console.log('  - Cargo:', empleado.cargo);
        //console.log('  - Estado:', empleado.estado);
        //console.log('  - Sueldo Básico:', empleado.sueldo_basico);
        //console.log('  - Fecha Ingreso:', empleado.fecha_ingreso);
        //console.log('  - Empresa ID:', empleado.empresa_id);
        //console.log('  - AFP ID:', empleado.afp_id);
        //console.log('  - Régimen Laboral ID:', empleado.regimen_laboral_id);
        //console.log('  - Total Conceptos:', empleado.total_conceptos);
        //console.log('  - Conceptos Ingresos:', empleado.conceptos_ingresos);
        //console.log('  - Conceptos Descuentos:', empleado.conceptos_descuentos);
        //console.log('  - Conceptos Aportes:', empleado.conceptos_aportes);
        //console.log('  - Conceptos PLAME:', empleado.conceptos_plame);
        //console.log('  - AFP:', empleado.afp);
        //console.log('  - Empresa:', empleado.empresa);
        //console.log('  - Historial Laboral:', empleado.historial_laboral);
        
        empleadosInfo += `${index + 1}. ${empleado.nombre_completo}\n`;
        empleadosInfo += `   • Doc: ${empleado.numero_documento} | Cargo: ${empleado.cargo}\n`;
        empleadosInfo += `   • Estado: ${empleado.estado} | Sueldo: S/ ${empleado.sueldo_basico}\n`;
        empleadosInfo += `   • Fecha Ingreso: ${empleado.fecha_ingreso || 'N/A'}\n`;
        empleadosInfo += `   • Total Conceptos: ${empleado.total_conceptos}\n`;
        empleadosInfo += `   • Ingresos: ${empleado.conceptos_ingresos} | Descuentos: ${empleado.conceptos_descuentos} | Aportes: ${empleado.conceptos_aportes}\n`;
        empleadosInfo += `   • Conceptos PLAME: ${empleado.conceptos_plame}\n`;
        
        if (empleado.empresa) {
          empleadosInfo += `   • Empresa: ${empleado.empresa.nombre_empresa || empleado.empresa.ruc}\n`;
        }
        
        if (empleado.afp) {
          empleadosInfo += `   • AFP: ${empleado.afp.nombre}\n`;
        }
        
        if (empleado.conceptos && empleado.conceptos.length > 0) {
          //console.log('  - Conceptos detallados:');
          empleadosInfo += `   • Conceptos (${empleado.conceptos.length}):\n`;
          
          empleado.conceptos.slice(0, 5).forEach((concepto, cIndex) => {
            //console.log(`    ${cIndex + 1}. Tipo: ${concepto.tipo_concepto} | Monto: ${concepto.monto}`);
            //console.log(`       PLAME Config: ${concepto.plame_configuracion?.descripcion || 'N/A'}`);
            //console.log(`       Código PLAME: ${concepto.plame_configuracion?.codigo_plame || 'N/A'}`);
            
            empleadosInfo += `     - ${concepto.tipo_concepto}: S/ ${concepto.monto}\n`;
            empleadosInfo += `       ${concepto.plame_configuracion?.descripcion || 'Sin descripción'}\n`;
            empleadosInfo += `       PLAME: ${concepto.plame_configuracion?.codigo_plame || 'N/A'}\n`;
          });
          
          if (empleado.conceptos.length > 5) {
            empleadosInfo += `     ... y ${empleado.conceptos.length - 5} conceptos más\n`;
          }
        }
        empleadosInfo += '\n';
      });
      
      //console.log(`\n📊 RESUMEN:`);
      //console.log(`  - Total empleados: ${empleadosConConceptos.length}`);
      //console.log(`  - Total conceptos: ${totalConceptos}`);
      //console.log(`  - Total conceptos ingresos: ${totalConceptosIngresos}`);
      //console.log(`  - Total conceptos descuentos: ${totalConceptosDescuentos}`);
      //console.log(`  - Total conceptos aportes: ${totalConceptosAportes}`);
      //console.log(`  - Total conceptos PLAME: ${totalConceptosPlame}`);
    } else {
      console.log('⚠️ No hay empleados con conceptos disponibles');
      empleadosInfo = '⚠️ No hay empleados con conceptos disponibles\n\n';
    }

    // Datos de Empleados ACTIVOS durante el período de la planilla
    //console.log('\n✅ === EMPLEADOS ACTIVOS DURANTE PLANILLA ===');
    //console.log('Total empleados activos:', empleadosActivos.length);
    //console.log('Array empleados activos:', empleadosActivos);
    
    let empleadosActivosInfo = '';
    if (empleadosActivos.length > 0) {
      //console.log('📊 Detalles de empleados activos durante el período:');
      
      empleadosActivosInfo = `✅ EMPLEADOS ACTIVOS DURANTE PLANILLA (${empleadosActivos.length}):\n\n`;
      
      empleadosActivos.forEach((empleado, index) => {
        const historial = empleado.historial_laboral && empleado.historial_laboral.length > 0 ? 
                         empleado.historial_laboral[empleado.historial_laboral.length - 1] : null;
        
        //console.log(`\n✅ Empleado activo ${index + 1}:`);
        //console.log('  - ID:', empleado.id);
        //console.log('  - Nombre:', empleado.nombre_completo);
        //console.log('  - Documento:', empleado.numero_documento);
        //console.log('  - Cargo:', empleado.cargo);
        //console.log('  - Estado:', empleado.estado);
        //console.log('  - Sueldo Básico:', empleado.sueldo_basico);
        if (historial) {
          //console.log('  - Fecha Ingreso:', historial.fecha_ingreso);
          //console.log('  - Fecha Cese:', historial.fecha_cese || 'Activo');
        }
        //console.log('  - Total Conceptos:', empleado.total_conceptos);
        
        empleadosActivosInfo += `${index + 1}. ${empleado.nombre_completo}\n`;
        empleadosActivosInfo += `   • Doc: ${empleado.numero_documento} | Cargo: ${empleado.cargo}\n`;
        empleadosActivosInfo += `   • Estado: ${empleado.estado} | Sueldo: S/ ${empleado.sueldo_basico}\n`;
        if (historial) {
          empleadosActivosInfo += `   • Ingreso: ${historial.fecha_ingreso} | Cese: ${historial.fecha_cese || 'Activo'}\n`;
        }
        empleadosActivosInfo += `   • Total Conceptos: ${empleado.total_conceptos}\n`;
        
        if (empleado.empresa) {
          empleadosActivosInfo += `   • Empresa: ${empleado.empresa.nombre_empresa || empleado.empresa.ruc}\n`;
        }
        
        if (empleado.afp) {
          empleadosActivosInfo += `   • AFP: ${empleado.afp.nombre}\n`;
        }
        empleadosActivosInfo += '\n';
      });

      //console.log(`\n📊 RESUMEN EMPLEADOS ACTIVOS:`);
      //console.log(`  - Total empleados activos: ${empleadosActivos.length}`);
      //console.log(`  - Porcentaje de empleados activos: ${((empleadosActivos.length / empleadosConConceptos.length) * 100).toFixed(1)}%`);
    } else {
      console.log('⚠️ No hay empleados activos durante el período de la planilla');
      empleadosActivosInfo = '⚠️ No hay empleados activos durante el período de la planilla\n\n';
    }
    
    // Información detallada de otros servicios cargados
    let serviciosInfo = `📊 OTROS SERVICIOS CARGADOS:\n\n`;
    
    // AFP
    serviciosInfo += `💳 AFP (${afps.length} registros):\n`;
    if (afps.length > 0) {
      afps.forEach((afp, index) => {
        serviciosInfo += `  ${index + 1}. ${afp.nombre}\n`;
        serviciosInfo += `     • Comisión Fija: ${afp.comision_fija}%\n`;
        serviciosInfo += `     • Comisión Variable: ${afp.comision_variable}%\n`;
        serviciosInfo += `     • Seguro: ${afp.seguro}%\n`;
        serviciosInfo += `     • Aporte: ${afp.aporte}%\n\n`;
      });
    } else {
      serviciosInfo += `  No hay AFP cargadas\n\n`;
    }
    
    // Conceptos Afectos
    serviciosInfo += `📋 INGRESOS QUE NO AFECTAN VACACIONES (${conceptosNoAfectanVacaciones.length} registros):\n`;
    if (conceptosNoAfectanVacaciones.length > 0) {
      conceptosNoAfectanVacaciones.slice(0, 10).forEach((concepto, index) => {
        serviciosInfo += `  ${index + 1}. ${concepto.nombre || concepto.descripcion || concepto.id_concepto_plame} (${concepto.codigo || ''})\n`;
      });
      if (conceptosNoAfectanVacaciones.length > 10) {
        serviciosInfo += `  ... y ${conceptosNoAfectanVacaciones.length - 10} conceptos más\n`;
      }
    } else {
      serviciosInfo += `  (ninguno configurado)\n`;
    }
    serviciosInfo += `\n📋 CONCEPTOS AFECTOS (${conceptosAfectos.length} registros):\n`;
    if (conceptosAfectos.length > 0) {
      conceptosAfectos.slice(0, 10).forEach((concepto, index) => {
        serviciosInfo += `  ${index + 1}. ${concepto.nombre || concepto.descripcion || `Concepto ${concepto.id}`}\n`;
        if (concepto.codigo) serviciosInfo += `     • Código: ${concepto.codigo}\n`;
        if (concepto.tipo) serviciosInfo += `     • Tipo: ${concepto.tipo}\n`;
      });
      if (conceptosAfectos.length > 10) {
        serviciosInfo += `  ... y ${conceptosAfectos.length - 10} conceptos más\n`;
      }
    } else {
      serviciosInfo += `  No hay conceptos afectos cargados\n`;
    }
    serviciosInfo += `\n📋 INGRESOS QUE AFECTAN PROPORCIONAL POR LIC. CON GOCE DE HABER (${conceptosAfectanLicenciaGoceHaber.length} registros):\n`;
    if (conceptosAfectanLicenciaGoceHaber.length > 0) {
      conceptosAfectanLicenciaGoceHaber.slice(0, 10).forEach((concepto, index) => {
        serviciosInfo += `  ${index + 1}. ${concepto.nombre || concepto.descripcion || concepto.id_concepto_plame || '—'} (${concepto.codigo || ''})\n`;
      });
      if (conceptosAfectanLicenciaGoceHaber.length > 10) {
        serviciosInfo += `  ... y ${conceptosAfectanLicenciaGoceHaber.length - 10} conceptos más\n`;
      }
    } else {
      serviciosInfo += `  (ninguno configurado)\n`;
    }
    serviciosInfo += `\n`;
    
    // Fórmulas
    serviciosInfo += `🧮 FÓRMULAS (${formulas.length} registros):\n`;
    if (formulas.length > 0) {
      formulas.slice(0, 5).forEach((formula, index) => {
        serviciosInfo += `  ${index + 1}. ${formula.nombre || formula.descripcion || `Fórmula ${formula.id}`}\n`;
        if (formula.codigo) serviciosInfo += `     • Código: ${formula.codigo}\n`;
        if (formula.tipo) serviciosInfo += `     • Tipo: ${formula.tipo}\n`;
        if (formula.formula) serviciosInfo += `     • Fórmula: ${formula.formula.substring(0, 50)}${formula.formula.length > 50 ? '...' : ''}\n`;
      });
      if (formulas.length > 5) {
        serviciosInfo += `  ... y ${formulas.length - 5} fórmulas más\n`;
      }
    } else {
      serviciosInfo += `  No hay fórmulas cargadas\n`;
    }
    serviciosInfo += `\n`;
    
    // Configuraciones PLAME
    serviciosInfo += `🏛️ CONFIGURACIONES PLAME (${configuracionesPlame.length} registros):\n`;
    if (configuracionesPlame.length > 0) {
      configuracionesPlame.slice(0, 10).forEach((config, index) => {
        serviciosInfo += `  ${index + 1}. ${config.descripcion || `Config ${config.id}`}\n`;
        if (config.codigo_plame) serviciosInfo += `     • Código PLAME: ${config.codigo_plame}\n`;
        if (config.clasificacion) serviciosInfo += `     • Clasificación: ${config.clasificacion}\n`;
      });
      if (configuracionesPlame.length > 10) {
        serviciosInfo += `  ... y ${configuracionesPlame.length - 10} configuraciones más\n`;
      }
    } else {
      serviciosInfo += `  No hay configuraciones PLAME cargadas\n`;
    }
    serviciosInfo += `\n`;
    
    // Regímenes Laborales
    serviciosInfo += `👔 REGÍMENES LABORALES (${regimenesLaborales.length} registros):\n`;
    if (regimenesLaborales.length > 0) {
      regimenesLaborales.forEach((regimen, index) => {
        serviciosInfo += `  ${index + 1}. ${regimen.nombre || regimen.descripcion || `Régimen ${regimen.id}`}\n`;
        if (regimen.codigo) serviciosInfo += `     • Código: ${regimen.codigo}\n`;
        if (regimen.descripcion && regimen.nombre) serviciosInfo += `     • Descripción: ${regimen.descripcion}\n`;
      });
    } else {
      serviciosInfo += `  No hay regímenes laborales cargados\n`;
    }
    serviciosInfo += `\n`;
    
    // Tramos de Renta
    serviciosInfo += `💰 TRAMOS DE RENTA (${tramosRenta.length} registros):\n`;
    if (tramosRenta.length > 0) {
      tramosRenta.forEach((tramo, index) => {
        serviciosInfo += `  ${index + 1}. Desde: S/ ${tramo.desde || 0} - Hasta: S/ ${tramo.hasta || 'Sin límite'}\n`;
        if (tramo.tasa) serviciosInfo += `     • Tasa: ${tramo.tasa}%\n`;
        if (tramo.descripcion) serviciosInfo += `     • Descripción: ${tramo.descripcion}\n`;
      });
    } else {
      serviciosInfo += `  No hay tramos de renta cargados\n`;
    }
    serviciosInfo += `\n`;
    
    // Conceptos Estáticos
    serviciosInfo += `🔧 CONCEPTOS ESTÁTICOS (${conceptosEstaticos.length} registros):\n`;
    if (conceptosEstaticos.length > 0) {
      conceptosEstaticos.slice(0, 5).forEach((concepto, index) => {
        serviciosInfo += `  ${index + 1}. ${concepto.nombre || concepto.descripcion || `Concepto ${concepto.id}`}\n`;
        if (concepto.codigo) serviciosInfo += `     • Código: ${concepto.codigo}\n`;
        if (concepto.descripcion && concepto.nombre) serviciosInfo += `     • Descripción: ${concepto.descripcion}\n`;
      });
      if (conceptosEstaticos.length > 5) {
        serviciosInfo += `  ... y ${conceptosEstaticos.length - 5} conceptos más\n`;
      }
    } else {
      serviciosInfo += `  No hay conceptos estáticos configurados\n`;
    }
    serviciosInfo += `\n`;
    
    // Compensaciones (si están disponibles)
    if (typeof cargarCompensacionesActuales === 'function') {
      serviciosInfo += `💤 COMPENSACIONES DE MESES PASADOS:\n`;
      serviciosInfo += `  • Función de carga disponible para planilla actual\n`;
      serviciosInfo += `  • Se cargarán automáticamente en el array unificado durante el procesamiento\n`;
      serviciosInfo += `  • Incluye horas pendientes de meses anteriores por empleado\n`;
    } else {
      serviciosInfo += `💤 COMPENSACIONES: No disponibles\n`;
    }
    serviciosInfo += `\n`;
    
    // Información General
    serviciosInfo += `ℹ️ INFORMACIÓN GENERAL:\n`;
    if (informacionGeneral) {
      serviciosInfo += `  • Configuración del sistema cargada\n`;
      if (informacionGeneral.version) serviciosInfo += `  • Versión: ${informacionGeneral.version}\n`;
      if (informacionGeneral.empresa) serviciosInfo += `  • Empresa: ${informacionGeneral.empresa}\n`;
    } else {
      serviciosInfo += `  • No hay información general cargada\n`;
    }
    serviciosInfo += `\n`;
    
    // Resumen final
    let resumenInfo = `📈 RESUMEN TOTAL:\n`;
    resumenInfo += `• Planilla Real (Backend): ${planillaReal ? 'Disponible' : 'No disponible'}\n`;
    resumenInfo += `• Tareos del Período: ${tareosPeriodo.length} registros\n`;
    resumenInfo += `• Resumen de Tareos: ${resumenTareos ? 'Disponible' : 'No disponible'}\n`;
    resumenInfo += `• Empleados Reales (con conceptos): ${empleadosConConceptos.length}\n`;
    resumenInfo += `• ✅ Empleados ACTIVOS durante planilla: ${empleadosActivos.length}\n`;
    if (empleadosConConceptos.length > 0) {
      resumenInfo += `• 📊 Porcentaje de empleados activos: ${((empleadosActivos.length / empleadosConConceptos.length) * 100).toFixed(1)}%\n`;
    }
    resumenInfo += `• Total Conceptos: ${totalConceptos}\n`;
    resumenInfo += `• Conceptos por tipo:\n`;
    resumenInfo += `  - Ingresos: ${totalConceptosIngresos}\n`;
    resumenInfo += `  - Descuentos: ${totalConceptosDescuentos}\n`;
    resumenInfo += `  - Aportes: ${totalConceptosAportes}\n`;
    resumenInfo += `• Conceptos con código PLAME: ${totalConceptosPlame}\n`;
    resumenInfo += `• Conceptos estáticos configurados: ${conceptosEstaticos.length}\n`;
    resumenInfo += `• Configuración de tareos: ${configuracionTareo ? 'Configurada' : 'No configurada'}\n`;
    resumenInfo += `• Total de servicios auxiliares: ${afps.length + conceptosAfectos.length + conceptosNoAfectanVacaciones.length + conceptosAfectanLicenciaGoceHaber.length + formulas.length + configuracionesPlame.length + regimenesLaborales.length + tramosRenta.length + conceptosEstaticos.length + (configuracionTareo ? 1 : 0)}\n`;
    
    // 📊 RESUMEN GENERAL DE APIS (para información de disponibilidad) - DEFINIR PRIMERO
    const resumenAPIsDisponibles = {
      total_regimenes_laborales: regimenesLaborales.length,
      total_configuraciones_plame: configuracionesPlame.length,
      total_formulas: Array.isArray(formulas) ? formulas.length : 0,
      total_afps: afps.length,
      total_tramos_renta: tramosRenta.length,
      total_conceptos_afectos: conceptosAfectos.length,
      total_conceptos_no_afectan_vacaciones: conceptosNoAfectanVacaciones.length,
      total_conceptos_afectan_licencia_goce_haber: conceptosAfectanLicenciaGoceHaber.length,
      total_conceptos_estaticos: conceptosEstaticos.length,
      total_feriados_pago_doble: feriadosPagoDobleConfig.length,
      tiene_configuracion_tasa_nocturna: Boolean(configuracionTasaNocturnaConfig?.activo),
      horas_tasa_nocturna_config: parseFloat(configuracionTasaNocturnaConfig?.horas_tasa_nocturna ?? 0),
      tiene_configuracion_tareo: !!configuracionTareo,
      tiene_informacion_general: !!informacionGeneral,
      apis_completas: regimenesLaborales.length > 0 && 
                     configuracionesPlame.length > 0 && 
                     Array.isArray(formulas) && formulas.length > 0 && 
                     afps.length > 0 && 
                     !!informacionGeneral && 
                     tramosRenta.length > 0 &&
                     Array.isArray(conceptosEstaticos) &&
                     !!configuracionTareo
    };
    
    // ✅ EMPLEADOS ACTIVOS CON DATOS API INDIVIDUALES - SECCIÓN MÁS IMPORTANTE - DEFINIR SEGUNDO
    const empleadosActivosConDatosAPI = empleadosActivos.map((empleado, index) => {
      // 🏢 DATOS DE LA EMPRESA (para este empleado)
      const datosEmpresa = selectedCompany;
      
      // 📊 DATOS DE LAS APIs (completos para este empleado)
      const datosAPIs = {
        // Regímenes Laborales
        regimenesLaborales: regimenesLaborales,
        regimenSeleccionado: regimenesLaborales.find(r => r.id === empleado.regimen_laboral_id),
        construccionCivil: construccionCivilDatos,
        
        // Conceptos PLAME - Todos los conceptos disponibles
        conceptosPlame: configuracionesPlame,
        conceptosIngresos: configuracionesPlame.filter(c => c.clasificacion?.id_tipo === 1),
        conceptosDescuentos: configuracionesPlame.filter(c => c.clasificacion?.id_tipo === 2),
        conceptosAportes: configuracionesPlame.filter(c => c.clasificacion?.id_tipo === 3),
        
        // Fórmulas - Todas las fórmulas disponibles
      formulas: formulas,
        formulasIngresos: Array.isArray(formulas) ? formulas.filter(f => f.id_tipo === 1) : [],
        formulasDescuentos: Array.isArray(formulas) ? formulas.filter(f => f.id_tipo === 2) : [],
        formulasAportes: Array.isArray(formulas) ? formulas.filter(f => f.id_tipo === 3) : [],
        
        // AFPs - Todos los datos de AFP con porcentajes
        afps: afps,
        afpSeleccionada: afps.find(afp => afp.id === empleado.afp_id),
        
        // Información General - UIT y Sueldo Mínimo (extraídos del objeto completo)
        uit: informacionGeneral.data.uit, // Todo el objeto informacionGeneral incluye UIT
        sueldoMinimo: informacionGeneral.data.sueldo_minimo, // Todo el objeto informacionGeneral incluye sueldo mínimo  
        informacionGeneral: informacionGeneral.data,
        
        // Tramos de Renta - Para cálculo de impuesto a la renta
        tramosRenta: tramosRenta,
        
        // Conceptos Afectos a Tareos
        conceptosAfectosTareos: conceptosAfectos,

        // Ingresos PLAME que no se reducen por días de vacaciones en el proporcional de planilla
        conceptosNoAfectanVacaciones: conceptosNoAfectanVacaciones,

        // Ingresos PLAME cuyo proporcional descuenta días de licencia con goce de haber (config. empresa)
        conceptosAfectanLicenciaGoceHaber: conceptosAfectanLicenciaGoceHaber,
        
        // Conceptos Estáticos - Conceptos fijos configurados por la empresa
        conceptosEstaticos: conceptosEstaticos,
        conceptosEstaticosIngresos: conceptosEstaticos.filter(c => 
          c.codigo && (c.codigo.startsWith('01') || c.codigo.startsWith('02') || 
                      c.codigo.startsWith('03') || c.codigo.startsWith('04') || 
                      c.codigo.startsWith('05') || c.codigo.startsWith('09') || 
                      c.codigo.startsWith('10') || c.codigo.startsWith('20'))
        ),
        
        // Configuración de Tareos - Configuración empresarial de tareos
        configuracionTareo: configuracionTareo,

        // Feriados laborados con pago doble (fechas específicas por empresa)
        feriadosPagoDoble: feriadosPagoDobleConfig,

        // Descanso laborado: 1 o 2 jornales en PLAME 0107
        configuracionDescansoLaborado: configuracionDescansoLaboradoConfig,

        // Configuración de tasa nocturna (horas por día y activación)
        configuracionTasaNocturna: configuracionTasaNocturnaConfig,
      };
      
      // 💰 DATOS SALARIALES Y APORTES DEL EMPLEADO
      const datosSalariales = {
        sueldoBasico: parseFloat(empleado.sueldo_basico) || 0,
        // ✅ CORREGIR SISTEMA PENSIONARIO: usar tanto sistema_pensionario como tipo_aporte
        sistemaPensionario: empleado.sistema_pensionario || empleado.tipo_aporte || 'ONP',
        // ✅ AFP: si es AFP, obtener el nombre de la AFP
        afp: (empleado.sistema_pensionario === 'AFP' || empleado.tipo_aporte === 'AFP') ? 
             (empleado.afp?.nombre || empleado.afp_nombre || null) : null,
        // ✅ TIPO AFP: adicional info sobre la AFP
        tipoAfp: empleado.tipo_afp || empleado.afp?.tipo_afp || empleado.afp?.tipo || null,
        // ✅ CUSPP: código único del empleado en AFP
        cuspp: empleado.cuspp || empleado.codigo_cuspp || null,
        regimenLaboral: regimenesLaborales.find(r => r.id === empleado.regimen_laboral_id)?.codigo || null,
        asignacionFamiliar: empleado.asignacion_familiar || false,
        tipoContratacion: empleado.tipo_contratacion || null,
        sueldoInterno: parseFloat(empleado.sueldo_interno) || 0,
        tipoPlanilla: empleado.tipo_planilla || null,
        omitirDescuentosPlameInterna: omitirDescuentosPlameInternaDe(empleado.id),
        periodoGratificacionConsu: periodoGratiConsuDe(empleado.id),
        formaPago: empleado.forma_pago === 'jornal' ? 'jornal' : 'mensual',
        formaPagoPlanilla: formaPagoPlanillaDe(empleado.id) || null,
        fechaDesdeJornal: fechaDesdeJornalDe(empleado.id) || null,
        aplicarDescuentoDominical: valorDominicalApi(descuentoDominicalDe(empleado.id)),
        fechaIngresoInterna: empleado.fecha_ingreso_interna || empleado.fechaIngresoInterna || null,
        // ✅ INFORMACIÓN ADICIONAL DE AFP
        comisionTipo: empleado.comision_tipo || empleado.afp?.comision_tipo || null,
        fechaAfiliacionAfp: empleado.fecha_afiliacion_afp || null
      };
      
      // 📋 CONCEPTOS DEL EMPLEADO (ingresos, descuentos, aportes)
      const normalizarConceptoInternoSrc = (c) => {
        const codigo = String(
          c.codigoPlame
          || c.codigo_plame
          || c.codigo
          || c.plame_configuracion?.codigo_plame
          || c.plameConfiguracion?.codigo_plame
          || ''
        );
        return {
          ...c,
          codigo,
          codigo_plame: codigo,
          codigoPlame: codigo,
          descripcion:
            c.descripcion
            || c.concepto
            || c.plame_configuracion?.descripcion
            || c.plameConfiguracion?.descripcion
            || codigo,
          monto: Number(c.monto ?? c.valor ?? c.monto_interna) || 0,
        };
      };
      const conceptosInternosSrc = (Array.isArray(empleado.conceptos_internos) ? empleado.conceptos_internos : [])
        .map(normalizarConceptoInternoSrc);
        const conceptosAgrupados = agruparConceptos(empleado.conceptos);
        const fusionInterna = fusionarAjustesEnInterna({
          ingresos: conceptosAgrupados.ingresos,
          descuentos: conceptosAgrupados.descuentos,
          ingresosInternos: conceptosInternosSrc.filter((c) => c.tipo_concepto === 'ingreso'),
          descuentosInternos: conceptosInternosSrc.filter((c) => c.tipo_concepto === 'descuento'),
        });
      const conceptosUsuario = {
          ingresos: conceptosAgrupados.ingresos,
          descuentos: conceptosAgrupados.descuentos,
          aportes: conceptosAgrupados.aportes,
        ingresosInternos: fusionInterna.ingresosInternos,
        descuentosInternos: fusionInterna.descuentosInternos,
        aportesInternos: conceptosInternosSrc.filter(c => c.tipo_concepto === 'aporte'),
      };
      if (fusionInterna.sueldoInternoOverride != null) {
        datosSalariales.sueldoInterno = fusionInterna.sueldoInternoOverride;
      }
      
      // 👤 DATOS DEL EMPLEADO
      const datosEmpleado = {
        id: empleado.id,
        nombres: empleado.nombre_completo?.split(' ').slice(0, 2).join(' ') || '',
        apellidos: empleado.nombre_completo?.split(' ').slice(2).join(' ') || '',
        nombreCompleto: empleado.nombre_completo,
        numeroDocumento: empleado.numero_documento,
        tipoDocumento: empleado.tipo_documento || 'DNI',
        fecha_nacimiento: extraerFechaNacimientoEmpleado(empleado),
        fechaNacimiento: extraerFechaNacimientoEmpleado(empleado),
        fechaIngreso: resolverFechaIngresoEnPlanilla(empleado, planillaReal?.fecha_inicio, planillaReal?.fecha_fin),
        cargo: empleado.cargo,
        areas_de_trabajo: empleado.areas_de_trabajo,
        estado: empleado.estado,
        categoria: empleado.categoria,
        proyecto: empleado.proyecto,
        // ✅ INCLUIR HISTORIAL LABORAL PARA CÁLCULO DE TAREO COMPLETO
        historial_laboral: empleado.historial_laboral || [],
        ...camposHistorialInternoCalculo(empleado),
        // ✅ INFORMACIÓN BANCARIA
        banco: empleado.banco || null,
        cuenta_bancaria: empleado.cuenta_bancaria || null,
        cci: empleado.cci || null,
        monto_viatico_standard: parseFloat(empleado.monto_viatico_standard) || 0,
        sueldo_basico: parseFloat(empleado.sueldo_basico) || 0,
        telefono: empleado.telefono,
        email: empleado.email,
        direccion: empleado.direccion,
        descuento_descanso: empleado.descuento_descanso,
        nombre_completo: empleado.nombre_completo,
        numero_documento: empleado.numero_documento,
      };
      
      // ⏰ TAREOS DEL EMPLEADO (filtrados por empleado_id Y por período de planilla; comparación numérica para evitar string vs number)
      const idEmpNum = empleado.id != null ? Number(empleado.id) : null;
      const tareosEmpleadoCompletos = tareosPeriodo.filter(tareo => idEmpNum != null && Number(tareo.empleado_id) === idEmpNum);
      const tareosEmpleado = filtrarTareosPlanillaPorHistorial(
        tareosEmpleadoCompletos,
        empleado,
        planillaReal?.fecha_inicio,
        planillaReal?.fecha_fin,
        'plame'
      );
      const tareosEmpleadoInterna = filtrarTareosPlanillaPorHistorial(
        tareosEmpleadoCompletos,
        empleado,
        planillaReal?.fecha_inicio,
        planillaReal?.fecha_fin,
        'interno'
      );
      
      // 🔐 AUTORIZACIONES DEL EMPLEADO (filtradas por empleado_id; comparación numérica)
      const autorizacionesEmpleado = autorizacionesPeriodo.filter(autorizacion => idEmpNum != null && Number(autorizacion.empleado_id) === idEmpNum);
      
      const resumenTareosEmpleado = {
        total_tareos: tareosEmpleado.length, // Ya filtrado por período
        tareos_por_tipo: {},
        dias_trabajados: 0,
        horas_totales: 0,
        proyectos: [...new Set(tareosEmpleado.map(t => t.proyecto?.nombre).filter(Boolean))]
      };
      
      const resumenAutorizacionesEmpleado = {
        total_autorizaciones: autorizacionesEmpleado.length,
        autorizaciones_por_tipo: {},
        total_dias_autorizados: 0,
        total_horas_autorizadas: 0
      };
      
      // Procesar tareos del empleado
      tareosEmpleado.forEach(tareo => {
        // Contar por tipo de evento
        const tipoEvento = tareo.tipo_evento || 'Desconocido';
        resumenTareosEmpleado.tareos_por_tipo[tipoEvento] = (resumenTareosEmpleado.tareos_por_tipo[tipoEvento] || 0) + 1;
        
        // Sumar días y horas
        if (tareo.tipo_evento === 'asistio' || tareo.tipo_evento === 'asistencia_completa') {
          resumenTareosEmpleado.dias_trabajados += 1;
        }
        resumenTareosEmpleado.horas_totales += parseFloat(tareo.horas_trabajadas || 0);
      });

      // 💤 CALCULAR DESCANSOS SEMANALES PROPORCIONALES (SOLO DÍAS DEL PERÍODO)
      const calcularDescansosSemanales = () => {
        // ✅ PARA PLANILLAS CERRADAS: usar descuento_descanso individual del empleado
        // ✅ PARA PLANILLAS ABIERTAS: usar configuracionTareo general
        const debeDescontarDescansos = debeDescontarDescansosEmpleado(empleado);
          
        if (!debeDescontarDescansos || tareosEmpleado.length === 0) {
          return [];
        }

        //console.log(`💤 CALCULANDO DESCANSOS SEMANALES - Empleado: ${empleado.nombre_completo}`);
        //console.log(`💤 Planilla cerrada: ${planillaCerrada ? 'SÍ' : 'NO'}`);
        //console.log(`💤 Descuento descansos (individual): ${empleado.descuento_descanso ? 'ACTIVADO' : 'DESACTIVADO'}`);
        //console.log(`💤 Configuración general: ${configuracionTareo?.descontar_descansos ? 'ACTIVADO' : 'DESACTIVADO'}`);
        //console.log(`💤 Valor usado: ${debeDescontarDescansos ? 'ACTIVADO' : 'DESACTIVADO'}`);
        
        // Agrupar tareos por semanas (de lunes a domingo)
        const semanasEmpleado = [];
        let semanaActual = [];
        
        // Formatear tareos para procesamiento
        const tareosFormateados = tareosEmpleado.map(tareo => {
          // ✅ USAR FECHA LOCAL SIN PROBLEMAS DE ZONA HORARIA
          const fechaTexto = tareo.fecha.split('T')[0]; // Obtener solo YYYY-MM-DD
          const [año, mes, dia] = fechaTexto.split('-');
          const fecha = new Date(parseInt(año), parseInt(mes) - 1, parseInt(dia)); // Crear fecha local
          
          const diaSemana = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'][fecha.getDay()];
          const fechaFormateada = fecha.toLocaleDateString('es-PE', { 
            weekday: 'short', 
            day: '2-digit', 
            month: '2-digit' 
          });
          
          return {
            ...tareo,
            fecha: tareo.fecha,
            fechaFormateada,
            diaSemana,
            tipo: tareo.tipo_evento === 'falta' ? 'Falta' : 'Asistió'
          };
        }).sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
        
        tareosFormateados.forEach((tareo, index) => {
          semanaActual.push(tareo);
          
          // Si es domingo O es el último tareo, cerrar la semana
          const esDomingo = tareo.diaSemana === 'Dom';
          const esUltimoTareo = index === tareosFormateados.length - 1;
          
          if (esDomingo || esUltimoTareo) {
            if (semanaActual.length > 0) {
              // Contar faltas en la semana
              const faltasSemana = semanaActual.filter(t => t.tipo === 'Falta').length;
              
              // Determinar días laborables del período (INCLUIR TODOS LOS DÍAS)
              const diasLaborablesSemana = semanaActual.length;
              
              // Días trabajados efectivos (sin faltas)
              const diasTrabajadosEfectivos = Math.max(0, diasLaborablesSemana - faltasSemana);
              
              // ✅ NUEVA LÓGICA: Descanso base 8h - descuento por faltas (8/7 × faltas)
              const descansoBase = 8;
              const descuentoPorFalta = (8 / 7) * faltasSemana;
              const descansoProporcionado = Math.max(0, descansoBase - descuentoPorFalta);
              
              const fechaInicio = semanaActual[0].fechaFormateada;
              const fechaFin = semanaActual[semanaActual.length - 1].fechaFormateada;
              
              //console.log(`💤 Semana ${fechaInicio} - ${fechaFin}:`);
              //console.log(`  • Días laborables: ${diasLaborablesSemana}`);
              //console.log(`  • Faltas: ${faltasSemana}`);
              //console.log(`  • Días trabajados efectivos: ${diasTrabajadosEfectivos}`);
              //console.log(`  • Descanso proporcionado: ${descansoProporcionado.toFixed(2)}h de 8h`);
              
              semanasEmpleado.push({
                fechaInicio,
                fechaFin,
                diasLaborables: diasLaborablesSemana,
                faltas: faltasSemana,
                diasTrabajadosEfectivos,
                descansoCompleto: 8,
                descansoProporcionado,
                totalTareos: semanaActual.length
              });
            }
            
            // Reiniciar para la siguiente semana
            semanaActual = [];
          }
        });
        
        console.log(`💤 Total semanas calculadas para ${empleado.nombre_completo}: ${semanasEmpleado.length}`);
        return semanasEmpleado;
      };

      // Calcular descansos semanales y agregarlos al resumen
      const descansosSemanales = calcularDescansosSemanales();
      resumenTareosEmpleado.descansos_semanales = descansosSemanales;

      // Procesar autorizaciones del empleado
      autorizacionesEmpleado.forEach(autorizacion => {
        // Contar por tipo de autorización
        const tipoAutorizacion = `${autorizacion.tipo_autorizacion || 'Desconocido'}${autorizacion.sub_tipo ? ` - ${autorizacion.sub_tipo}` : ''}`;
        resumenAutorizacionesEmpleado.autorizaciones_por_tipo[tipoAutorizacion] = (resumenAutorizacionesEmpleado.autorizaciones_por_tipo[tipoAutorizacion] || 0) + 1;
        
        // Sumar días y horas autorizadas
        resumenAutorizacionesEmpleado.total_dias_autorizados += parseFloat(autorizacion.dias || 0);
        resumenAutorizacionesEmpleado.total_horas_autorizadas += parseFloat(autorizacion.horas || 0);
      });

      // 📈 METADATOS DEL PROCESAMIENTO
      const metadatos = {
        origen: 'planilla_detalle_empleado_activo',
        timestamp: new Date().toISOString(),
        fuente: 'Empleado activo durante período de planilla',
        contexto: `Empleado ${index + 1} de ${empleadosActivos.length} activos`,
        periodo_planilla: planillaReal ? `${planillaReal.fecha_inicio} - ${planillaReal.fecha_fin}` : 'No definido'
      };
      
      return {
        // 👤 IDENTIFICACIÓN DEL EMPLEADO
        empleado_id: empleado.id,
        empleado_nombre: empleado.nombre_completo,
        empleado_posicion: index + 1,
        omitir_descuentos_plame_interna: omitirDescuentosPlameInternaDe(empleado.id),
        periodo_gratificacion_consu: periodoGratiConsuDe(empleado.id),
        forma_pago: empleado.forma_pago === 'jornal' ? 'jornal' : 'mensual',
        forma_pago_planilla: formaPagoPlanillaDe(empleado.id) || null,
        fecha_desde_jornal: fechaDesdeJornalDe(empleado.id) || null,
        aplicar_descuento_dominical: valorDominicalApi(descuentoDominicalDe(empleado.id)),
        ...(esPlanillaModalidadConstruccion(planillaReal) ? {
          fecha_calculo_desde: fechaCalculoDesdeDe(empleado.id) || null,
          fecha_calculo_hasta: fechaCalculoHastaDe(empleado.id) || null,
        } : {}),
        
        // 📊 ESTRUCTURA COMPLETA DE DATOS (Siguiendo patrón calculosBoletaService)
        datosEmpresa,
        datosAPIs,
        datosSalariales,
        conceptosUsuario,
        datosEmpleado,
        
        // ⏰ DATOS DE TAREOS DEL EMPLEADO
        tareosEmpleado: tareosEmpleado,
        tareosEmpleadoInterna: tareosEmpleadoInterna,
        resumenTareos: resumenTareosEmpleado,

        // 🌙 Tasa nocturna calculada desde tareos del período
        tasaNocturna: armarTasaNocturnaEmpleado(
          tareosEmpleado,
          empleado,
          configuracionTasaNocturnaConfig,
          configuracionesPlame
        ),
        
        // 🔐 DATOS DE AUTORIZACIONES DEL EMPLEADO
        autorizacionesEmpleado: autorizacionesEmpleado,
        resumenAutorizaciones: resumenAutorizacionesEmpleado,
        
        metadatos
      };
    });

    // 📊 RESUMEN DE EMPLEADOS ACTIVOS CON DATOS API
    const empleadosActivosData = {
      empleados_activos_con_datos_api: empleadosActivosConDatosAPI,
      total_empleados_activos: empleadosActivos.length,
      porcentaje_empleados_activos: empleadosConConceptos.length > 0 ? 
        parseFloat(((empleadosActivos.length / empleadosConConceptos.length) * 100).toFixed(1)) : 0,
      periodo_planilla: {
        fecha_inicio: planillaReal?.fecha_inicio,
        fecha_fin: planillaReal?.fecha_fin,
        planilla_id: planillaReal?.id
      },
      analisis_empleo: {
        total_empleados_empresa: empleadosConConceptos.length,
        empleados_no_activos: empleadosConConceptos.length - empleadosActivos.length,
        tasa_empleados_activos: empleadosConConceptos.length > 0 ? 
          ((empleadosActivos.length / empleadosConConceptos.length) * 100).toFixed(1) + '%' : '0%'
      }
    };

    // 📋 CREAR ARRAY UNIFICADO - TODO JUNTO EN UNA ESTRUCTURA DE ARRAY
    const todosLosDatosArray = [
      // 🎯 ELEMENTO 1: METADATOS DEL SISTEMA
      {
        tipo: 'metadatos_sistema',
        timestamp: new Date().toISOString(),
        origen: 'planilla_detalle_empleados_activos',
        version: '1.0',
        descripcion: 'Array unificado con empleados activos y todos sus datos API individuales'
      },
      
      // 🏢 ELEMENTO 2: CONTEXTO EMPRESARIAL
              {
          tipo: 'contexto_empresarial',
          empresa: selectedCompany,
          planilla_real: planillaReal,
          tareos_periodo: {
            tareos: tareosPeriodo,
            resumen: resumenTareos,
            total_tareos: tareosPeriodo.length
          },
          autorizaciones_periodo: {
            autorizaciones: autorizacionesPeriodo,
            total_autorizaciones: autorizacionesPeriodo.length
          },
          periodo: {
            fecha_inicio: planillaReal?.fecha_inicio,
            fecha_fin: planillaReal?.fecha_fin,
            planilla_id: planillaReal?.id
          },
          // Viáticos: se informan en planilla/REM pero no afectan neto a pagar
          viaticos_standard: viaticosConfig
            ? {
                activo: Boolean(viaticosConfig.activo),
                plame_configuracion_id: viaticosConfig.plame_configuracion_id || null,
              }
            : null,
          overrides_tareo_evento: overridesTareoEvento,
          tramos_boleta_interna: tramosBoletaInterna,
          tramos_sueldo_plame: tramosSueldoPlame,
          configuracion_tareo: configuracionTareo,
        },
      
      // 📊 ELEMENTO 3: RESUMEN APIS DISPONIBLES
      {
        tipo: 'resumen_apis_disponibles',
        ...resumenAPIsDisponibles,
        estado_sistema: resumenAPIsDisponibles.apis_completas ? 'COMPLETO' : 'INCOMPLETO'
      },
      
      // 📈 ELEMENTO 4: ESTADÍSTICAS GENERALES
      {
        tipo: 'estadisticas_generales',
        empleados: {
          total_empleados_empresa: empleadosConConceptos.length,
          empleados_activos_planilla: empleadosActivos.length,
          empleados_no_activos: empleadosConConceptos.length - empleadosActivos.length,
          porcentaje_empleados_activos: empleadosConConceptos.length > 0 ? 
            parseFloat(((empleadosActivos.length / empleadosConConceptos.length) * 100).toFixed(1)) : 0
        },
        conceptos: {
        total_conceptos: totalConceptos,
        total_conceptos_ingresos: totalConceptosIngresos,
        total_conceptos_descuentos: totalConceptosDescuentos,
        total_conceptos_aportes: totalConceptosAportes,
          total_conceptos_plame: totalConceptosPlame
        },
        tareos: {
          total_tareos_periodo: tareosPeriodo.length,
          tiene_resumen_tareos: !!resumenTareos,
          empleados_con_tareos: resumenTareos?.total_empleados || 0,
          // Estadísticas agregadas de tareos de empleados activos
          tareos_empleados_activos: {
            total_registros: empleadosActivosConDatosAPI.reduce((sum, emp) => sum + emp.resumenTareos.total_tareos, 0),
            total_dias_trabajados: empleadosActivosConDatosAPI.reduce((sum, emp) => sum + emp.resumenTareos.dias_trabajados, 0),
            total_horas_trabajadas: empleadosActivosConDatosAPI.reduce((sum, emp) => sum + emp.resumenTareos.horas_totales, 0),
            empleados_con_tareos: empleadosActivosConDatosAPI.filter(emp => emp.resumenTareos.total_tareos > 0).length,
            porcentaje_cobertura: empleadosActivosConDatosAPI.length > 0 ? 
              parseFloat(((empleadosActivosConDatosAPI.filter(emp => emp.resumenTareos.total_tareos > 0).length / empleadosActivosConDatosAPI.length) * 100).toFixed(1)) : 0,
            proyectos_unicos: [...new Set(empleadosActivosConDatosAPI.flatMap(emp => emp.resumenTareos.proyectos))],
            promedio_tareos_por_empleado: empleadosActivosConDatosAPI.length > 0 ? 
              parseFloat((empleadosActivosConDatosAPI.reduce((sum, emp) => sum + emp.resumenTareos.total_tareos, 0) / empleadosActivosConDatosAPI.length).toFixed(2)) : 0
          }
        },
        autorizaciones: {
          total_autorizaciones_periodo: autorizacionesPeriodo.length,
          // Estadísticas agregadas de autorizaciones de empleados activos
          autorizaciones_empleados_activos: {
            total_registros: empleadosActivosConDatosAPI.reduce((sum, emp) => sum + emp.resumenAutorizaciones.total_autorizaciones, 0),
            total_dias_autorizados: empleadosActivosConDatosAPI.reduce((sum, emp) => sum + emp.resumenAutorizaciones.total_dias_autorizados, 0),
            total_horas_autorizadas: empleadosActivosConDatosAPI.reduce((sum, emp) => sum + emp.resumenAutorizaciones.total_horas_autorizadas, 0),
            empleados_con_autorizaciones: empleadosActivosConDatosAPI.filter(emp => emp.resumenAutorizaciones.total_autorizaciones > 0).length,
            porcentaje_cobertura: empleadosActivosConDatosAPI.length > 0 ? 
              parseFloat(((empleadosActivosConDatosAPI.filter(emp => emp.resumenAutorizaciones.total_autorizaciones > 0).length / empleadosActivosConDatosAPI.length) * 100).toFixed(1)) : 0,
            tipos_autorizacion_unicos: [...new Set(empleadosActivosConDatosAPI.flatMap(emp => Object.keys(emp.resumenAutorizaciones.autorizaciones_por_tipo)))],
            promedio_autorizaciones_por_empleado: empleadosActivosConDatosAPI.length > 0 ? 
              parseFloat((empleadosActivosConDatosAPI.reduce((sum, emp) => sum + emp.resumenAutorizaciones.total_autorizaciones, 0) / empleadosActivosConDatosAPI.length).toFixed(2)) : 0
          }
        }
      },
      
      // 🎯 ELEMENTOS 5+: EMPLEADOS ACTIVOS CON DATOS API INDIVIDUALES (LO MÁS IMPORTANTE)
      ...empleadosActivosConDatosAPI.map((empleadoConAPI, index) => ({
        tipo: 'empleado_activo_con_apis',
        posicion_en_array: index + 5, // Posición en el array principal
        empleado_posicion_activos: index + 1, // Posición entre empleados activos
        total_empleados_activos: empleadosActivos.length,
        ...empleadoConAPI
      }))
    ];
    
    // Crear mensaje para el array unificado
    const metadatos = todosLosDatosArray.find(e => e.tipo === 'metadatos_sistema');
    const contexto = todosLosDatosArray.find(e => e.tipo === 'contexto_empresarial');
    const apis = todosLosDatosArray.find(e => e.tipo === 'resumen_apis_disponibles');
    const estadisticas = todosLosDatosArray.find(e => e.tipo === 'estadisticas_generales');
    const empleadosArray = todosLosDatosArray.filter(e => e.tipo === 'empleado_activo_con_apis');
    
    let alertMessage = `🗂️ === ARRAY UNIFICADO - TODO JUNTO ===\n\n`;
    alertMessage += `📊 TOTAL ELEMENTOS EN ARRAY: ${todosLosDatosArray.length}\n\n`;
    
    // Estructura del array
    alertMessage += `📋 ESTRUCTURA DEL ARRAY:\n`;
    alertMessage += `  [0] 📈 Metadatos del Sistema (v${metadatos?.version})\n`;
    alertMessage += `  [1] 🏢 Contexto Empresarial (${contexto?.empresa?.name || 'N/A'})\n`;
    alertMessage += `  [2] 📊 Resumen APIs (${apis?.apis_completas ? 'COMPLETAS ✅' : 'INCOMPLETAS ❌'})\n`;
    alertMessage += `  [3] 📈 Estadísticas Generales (${estadisticas?.empleados.empleados_activos_planilla || 0} activos)\n`;
    alertMessage += `  [4+] 👥 Empleados Activos con APIs (${empleadosArray.length} empleados)\n\n`;
    
    // Detalle de empleados en el array
    if (empleadosArray.length > 0) {
      alertMessage += `🎯 EMPLEADOS ACTIVOS EN EL ARRAY:\n\n`;
      
             empleadosArray.forEach((empleado, index) => {
         alertMessage += `[${empleado.posicion_en_array}] 👤 ${empleado.empleado_nombre}\n`;
         alertMessage += `      📍 Posición: ${empleado.empleado_posicion_activos}/${empleado.total_empleados_activos} activos\n`;
         alertMessage += `      💰 Sueldo: S/ ${empleado.datosSalariales.sueldoBasico}\n`;
         alertMessage += `      🏛️ ${empleado.datosSalariales.regimenLaboral || 'Sin régimen'}\n`;
         // ✅ INFORMACIÓN COMPLETA DE AFP
         if (empleado.datosSalariales.sistemaPensionario === 'AFP') {
           alertMessage += `      💳 AFP: ${empleado.datosSalariales.afp || 'Sin AFP'}`;
           if (empleado.datosSalariales.tipoAfp) {
             alertMessage += ` | Tipo: ${empleado.datosSalariales.tipoAfp}`;
           }
           alertMessage += `\n`;
         } else {
           alertMessage += `      💳 ${empleado.datosSalariales.sistemaPensionario}\n`;
         }
         alertMessage += `      📊 APIs: ${empleado.datosAPIs.regimenesLaborales.length}🏛️ + ${empleado.datosAPIs.conceptosPlame.length}📋 + ${empleado.datosAPIs.formulas.length}🧮 + ${empleado.datosAPIs.afps.length}💳\n`;
         alertMessage += `      📋 Conceptos: ${empleado.conceptosUsuario.ingresos.length}⬆️ + ${empleado.conceptosUsuario.descuentos.length}⬇️ + ${empleado.conceptosUsuario.aportes.length}🏛️\n`;
         alertMessage += `      ⏰ Tareos: ${empleado.resumenTareos.total_tareos} registros | ${empleado.resumenTareos.dias_trabajados} días | ${empleado.resumenTareos.horas_totales}h`;
         if (empleado.resumenTareos.proyectos.length > 0) {
           alertMessage += ` | ${empleado.resumenTareos.proyectos.length} proyectos`;
         }
         alertMessage += `\n`;
         alertMessage += `      🔐 Autorizaciones: ${empleado.resumenAutorizaciones.total_autorizaciones} registros | ${empleado.resumenAutorizaciones.total_dias_autorizados} días | ${empleado.resumenAutorizaciones.total_horas_autorizadas}h\n`;
         if (index < empleadosArray.length - 1) alertMessage += `\n`;
       });
    } else {
      alertMessage += `⚠️ No hay empleados activos en el array\n`;
    }
    
    // Resumen del array
    alertMessage += `\n\n📊 === RESUMEN DEL ARRAY UNIFICADO ===\n`;
    alertMessage += `🔗 Total elementos: ${todosLosDatosArray.length}\n`;
    alertMessage += `📈 Metadatos: ${metadatos ? '✅' : '❌'}\n`;
    alertMessage += `🏢 Contexto: ${contexto ? '✅' : '❌'}\n`;
    alertMessage += `📊 APIs: ${apis ? '✅' : '❌'} (${apis?.estado_sistema})\n`;
    alertMessage += `📈 Estadísticas: ${estadisticas ? '✅' : '❌'}\n`;
         alertMessage += `👥 Empleados: ${empleadosArray.length} elementos\n`;
     
     // Calcular estadísticas de tareos de todos los empleados activos
     const totalTareosEmpleados = empleadosArray.reduce((sum, emp) => sum + emp.resumenTareos.total_tareos, 0);
     const totalDiasTrabajados = empleadosArray.reduce((sum, emp) => sum + emp.resumenTareos.dias_trabajados, 0);
     const totalHorasTrabajadas = empleadosArray.reduce((sum, emp) => sum + emp.resumenTareos.horas_totales, 0);
     const empleadosConTareos = empleadosArray.filter(emp => emp.resumenTareos.total_tareos > 0).length;
     
     // Calcular estadísticas de autorizaciones de todos los empleados activos
     const totalAutorizacionesEmpleados = empleadosArray.reduce((sum, emp) => sum + emp.resumenAutorizaciones.total_autorizaciones, 0);
     const totalDiasAutorizados = empleadosArray.reduce((sum, emp) => sum + emp.resumenAutorizaciones.total_dias_autorizados, 0);
     const totalHorasAutorizadas = empleadosArray.reduce((sum, emp) => sum + emp.resumenAutorizaciones.total_horas_autorizadas, 0);
     const empleadosConAutorizaciones = empleadosArray.filter(emp => emp.resumenAutorizaciones.total_autorizaciones > 0).length;
     
     alertMessage += `⏰ Tareos Empleados Activos: ${totalTareosEmpleados} registros | ${totalDiasTrabajados} días | ${totalHorasTrabajadas.toFixed(1)}h\n`;
     alertMessage += `🔐 Autorizaciones Empleados Activos: ${totalAutorizacionesEmpleados} registros | ${totalDiasAutorizados} días | ${totalHorasAutorizadas.toFixed(1)}h\n`;
     alertMessage += `📊 Empleados con Tareos: ${empleadosConTareos}/${empleadosArray.length} (${empleadosArray.length > 0 ? ((empleadosConTareos/empleadosArray.length)*100).toFixed(1) : 0}%)\n`;
     alertMessage += `📊 Empleados con Autorizaciones: ${empleadosConAutorizaciones}/${empleadosArray.length} (${empleadosArray.length > 0 ? ((empleadosConAutorizaciones/empleadosArray.length)*100).toFixed(1) : 0}%)\n`;
     alertMessage += `📋 Planilla Real: ${planillaReal ? 'Disponible ✅' : 'No disponible ❌'}\n`;
    alertMessage += `\n🔍 Revisa la consola para ver el array completo con todos los elementos detallados.`;
    

    
    
    //alert(alertMessage);
  };

  // 🎯 FUNCIÓN PARA PROCESAR EMPLEADOS CON LÓGICA DE PLANILLA
  const procesarEmpleadosConPlanilla = async (opciones = {}) => {
    const omitirConfirmacion = Boolean(opciones.omitirConfirmacion);
    // Permite pasar el mapa fresco tras guardar (evita estado React desactualizado)
    const overridesTareoParaCalculo =
      opciones.overridesTareoEvento != null
        ? opciones.overridesTareoEvento
        : overridesTareoEvento;
    const tramosInternaParaCalculo =
      opciones.tramosBoletaInterna != null
        ? opciones.tramosBoletaInterna
        : tramosBoletaInterna;
    const tramosSueldoParaCalculo =
      opciones.tramosSueldoPlame != null
        ? opciones.tramosSueldoPlame
        : tramosSueldoPlame;
    try {

      
      setCalculandoPlanilla(true);
      
      // 🔒 Planilla cerrada: solo recalcular trabajadores en ajuste posterior
      const modoAjustePosteriorCerrada = planillaCerrada && empleadosEnAjustePosteriorIds.size > 0;
      if (planillaCerrada && !modoAjustePosteriorCerrada) {
        console.log('🔒🔒🔒 PLANILLA CERRADA - ABORTANDO CÁLCULOS');
        alert('📦 Esta planilla está cerrada.\n\nLos datos son de solo lectura. Use «Reabrir» en la ficha del trabajador para ajustes posteriores.');
        setCalculandoPlanilla(false);
        return;
      }

      if (!empleadosActivosPlanilla || empleadosActivosPlanilla.length === 0) {
        alert('⚠️ No hay empleados activos para procesar. Primero carga los datos.');
        setCalculandoPlanilla(false);
        return;
      }

      const idsAjusteObjetivo = opciones.soloAjustePosteriorIds
        ? opciones.soloAjustePosteriorIds.map((x) => Number(x)).filter((n) => Number.isFinite(n) && n > 0)
        : [...empleadosEnAjustePosteriorIds];

      let depsCalculoAjuste = opciones.depsCalculo || null;

      let empleadosParaProcesar;
      if (modoAjustePosteriorCerrada) {
        empleadosParaProcesar = filtrarEmpleadosPorComputoRh(empleadosActivosPlanilla).filter((e) =>
          idsAjusteObjetivo.includes(Number(e.id ?? e.empleado_id)),
        );
      } else {
        empleadosParaProcesar = filtrarEmpleadosPorComputoRh(empleadosActivosPlanilla).filter(
          (e) => !empleadosFotografiadosIds.has(Number(e.id)),
        );
      }

      if (modoAjustePosteriorCerrada) {
        const asegurar = await asegurarDepsCalculoAjustePosterior(idsAjusteObjetivo);
        if (asegurar?.depsCalculo) {
          depsCalculoAjuste = asegurar.depsCalculo;
        }
        let enriquecidos =
          Array.isArray(opciones.empleadosAjustePosteriorEnriquecidos)
          && opciones.empleadosAjustePosteriorEnriquecidos.length > 0
            ? opciones.empleadosAjustePosteriorEnriquecidos
            : asegurar?.enriquecidos;
        if (enriquecidos?.length) {
          const porId = new Map(
            enriquecidos.map((e) => [Number(e.id ?? e.empleado_id), e]),
          );
          empleadosParaProcesar = empleadosParaProcesar.map(
            (e) => porId.get(Number(e.id ?? e.empleado_id)) || e,
          );
        }
      }

      if (empleadosParaProcesar.length === 0) {
        if (modoAjustePosteriorCerrada) {
          alert('No hay trabajadores en ajuste posterior para recalcular.');
        } else if (empleadosFotografiadosIds.size > 0) {
          alert('Todos los trabajadores del periodo ya tienen pre-cierre guardado.');
        } else {
          alert('⚠️ No hay empleados RH que correspondan al cómputo de esta planilla.');
        }
        setCalculandoPlanilla(false);
        return;
      }

      // Si ya hay cálculos previos, preguntar si desea recalcular (solo planilla abierta)
      if (!modoAjustePosteriorCerrada && empleadosConBoletasCalculadas.length > 0 && !omitirConfirmacion) {
        const extraPreCierre =
          empleadosFotografiadosIds.size > 0
            ? `\n\nLos ${empleadosFotografiadosIds.size} trabajador(es) con pre-cierre guardado no se recalcularán.`
            : '';
        const confirmar = window.confirm(
          `⚠️ Ya existen cálculos de planilla previos.\n\n¿Desea recalcular la planilla completa?\n\nEsto sobrescribirá los datos de quienes aún no tienen pre-cierre.${extraPreCierre}`,
        );
        if (!confirmar) {
          setCalculandoPlanilla(false);
          return;
        }
        
        // Limpiar datos previos para recálculo (conservar pre-cierres)
        setEmpleadosConBoletasCalculadas(mezclarCalculadosConPreCierres([]));
      } else if (!modoAjustePosteriorCerrada && empleadosConBoletasCalculadas.length > 0 && omitirConfirmacion) {
        setEmpleadosConBoletasCalculadas(mezclarCalculadosConPreCierres([]));
      }

      let tareosCalculoCtx = tareosPeriodo;
      let autorizacionesCalculoCtx = autorizacionesPeriodo;
      if (modoAjustePosteriorCerrada && planillaReal && (!tareosCalculoCtx || tareosCalculoCtx.length === 0)) {
        const fetched = await fetchTareosAutorizacionesParaPlanilla(planillaReal);
        tareosCalculoCtx = fetched.tareos;
        autorizacionesCalculoCtx = fetched.autorizaciones;
        setTareosPeriodo(fetched.tareos);
        setAutorizacionesPeriodo(fetched.autorizaciones);
      }

      const calcCtx = depsCalculoAjuste || {
        regimenesLaborales,
        configuracionesPlame,
        formulas,
        afps,
        informacionGeneral,
        tramosRenta,
        conceptosAfectos,
        conceptosNoAfectanVacaciones,
        conceptosAfectanLicenciaGoceHaber,
        conceptosEstaticos,
        feriadosPagoDobleConfig,
        configuracionDescansoLaboradoConfig,
        configuracionTasaNocturnaConfig,
        configuracionTareo,
        construccionCivilDatos,
      };

      if (
        modoAjustePosteriorCerrada
        && (
          !calcCtx.informacionGeneral?.data
          || calcCtx.regimenesLaborales.length === 0
          || calcCtx.configuracionesPlame.length === 0
          || !Array.isArray(calcCtx.formulas)
          || calcCtx.formulas.length === 0
          || !calcCtx.configuracionTareo
        )
      ) {
        alert(
          'No se pudieron cargar los datos maestros (AFP, fórmulas, PLAME, tareos) para recalcular.\n\nRecargue la página e intente de nuevo.',
        );
        setCalculandoPlanilla(false);
        return;
      }

      // Construir el array unificado completo (igual que en mostrarDatosSeleccionados)
      const resumenAPIsDisponibles = {
        total_regimenes_laborales: calcCtx.regimenesLaborales.length,
        total_configuraciones_plame: calcCtx.configuracionesPlame.length,
        total_formulas: Array.isArray(calcCtx.formulas) ? calcCtx.formulas.length : 0,
        total_afps: calcCtx.afps.length,
        total_tramos_renta: calcCtx.tramosRenta.length,
        total_conceptos_afectos: calcCtx.conceptosAfectos.length,
        total_conceptos_no_afectan_vacaciones: calcCtx.conceptosNoAfectanVacaciones.length,
        total_conceptos_afectan_licencia_goce_haber: calcCtx.conceptosAfectanLicenciaGoceHaber.length,
        total_conceptos_estaticos: calcCtx.conceptosEstaticos.length,
        total_feriados_pago_doble: calcCtx.feriadosPagoDobleConfig.length,
        tiene_configuracion_tasa_nocturna: Boolean(calcCtx.configuracionTasaNocturnaConfig?.activo),
        horas_tasa_nocturna_config: parseFloat(calcCtx.configuracionTasaNocturnaConfig?.horas_tasa_nocturna ?? 0),
        tiene_configuracion_tareo: !!calcCtx.configuracionTareo,
        tiene_informacion_general: !!calcCtx.informacionGeneral,
        apis_completas: calcCtx.regimenesLaborales.length > 0 && 
                       calcCtx.configuracionesPlame.length > 0 && 
                       Array.isArray(calcCtx.formulas) && calcCtx.formulas.length > 0 && 
                       calcCtx.afps.length > 0 && 
                       !!calcCtx.informacionGeneral && 
                       calcCtx.tramosRenta.length > 0 &&
                       Array.isArray(calcCtx.conceptosEstaticos) &&
                       !!calcCtx.configuracionTareo
      };

      // Construir empleados activos con datos API (solo los del cómputo RH de esta planilla)
      const empleadosActivosConDatosAPI = empleadosParaProcesar.map((empleadoRaw, index) => {
        const empleado = normalizarEmpleadoParaCalculoPlanilla(empleadoRaw, planillaReal);
        const datosEmpresa = selectedCompany;
        
        const datosAPIs = {
          regimenesLaborales: calcCtx.regimenesLaborales,
          regimenSeleccionado: calcCtx.regimenesLaborales.find(r => r.id === empleado.regimen_laboral_id),
        construccionCivil: calcCtx.construccionCivilDatos,
          conceptosPlame: calcCtx.configuracionesPlame,
          conceptosIngresos: calcCtx.configuracionesPlame.filter(c => c.clasificacion?.id_tipo === 1),
          conceptosDescuentos: calcCtx.configuracionesPlame.filter(c => c.clasificacion?.id_tipo === 2),
          conceptosAportes: calcCtx.configuracionesPlame.filter(c => c.clasificacion?.id_tipo === 3),
          formulas: calcCtx.formulas,
          formulasIngresos: Array.isArray(calcCtx.formulas) ? calcCtx.formulas.filter(f => f.id_tipo === 1) : [],
          formulasDescuentos: Array.isArray(calcCtx.formulas) ? calcCtx.formulas.filter(f => f.id_tipo === 2) : [],
          formulasAportes: Array.isArray(calcCtx.formulas) ? calcCtx.formulas.filter(f => f.id_tipo === 3) : [],
          afps: calcCtx.afps,
          afpSeleccionada: calcCtx.afps.find(afp => afp.id === empleado.afp_id),
          uit: calcCtx.informacionGeneral?.data?.uit,
          sueldoMinimo: calcCtx.informacionGeneral?.data?.sueldo_minimo,
          informacionGeneral: calcCtx.informacionGeneral?.data,
          tramosRenta: calcCtx.tramosRenta,
          conceptosAfectosTareos: calcCtx.conceptosAfectos,
          conceptosNoAfectanVacaciones: calcCtx.conceptosNoAfectanVacaciones,
          conceptosAfectanLicenciaGoceHaber: calcCtx.conceptosAfectanLicenciaGoceHaber,
          conceptosEstaticos: calcCtx.conceptosEstaticos,
          conceptosEstaticosIngresos: calcCtx.conceptosEstaticos.filter(c => 
            c.codigo && (c.codigo.startsWith('01') || c.codigo.startsWith('02') || 
                        c.codigo.startsWith('03') || c.codigo.startsWith('04') || 
                        c.codigo.startsWith('05') || c.codigo.startsWith('09') || 
                        c.codigo.startsWith('10') || c.codigo.startsWith('20'))
          ),
          configuracionTareo: calcCtx.configuracionTareo,
          feriadosPagoDoble: calcCtx.feriadosPagoDobleConfig,
          configuracionDescansoLaborado: calcCtx.configuracionDescansoLaboradoConfig,
          configuracionTasaNocturna: calcCtx.configuracionTasaNocturnaConfig,
        };
        
        // ✅ LÓGICA AUTOMÁTICA DE AFP: Si tiene AFP definida, asumir que es AFP
        const afpEncontrada = calcCtx.afps.find(a => a.id === empleado.afp_id);
        const tieneAfp = empleado.afp?.nombre || empleado.afp_nombre || empleado.afp_id || afpEncontrada;
        const sistemaCalculado = tieneAfp ? 'AFP' : (empleado.sistema_pensionario || empleado.tipo_aporte || 'ONP');
        
        const datosSalariales = {
          sueldoBasico: parseFloat(empleado.sueldo_basico) || 0,
          sistemaPensionario: sistemaCalculado,
          afp: tieneAfp ? (afpEncontrada?.nombre || empleado.afp?.nombre || empleado.afp_nombre || null) : null,
          tipoAfp: tieneAfp ? (empleado.tipo_afp || empleado.afp?.tipo_afp || afpEncontrada?.tipo || empleado.afp?.tipo || null) : null,
          cuspp: tieneAfp ? (empleado.cuspp || empleado.codigo_cuspp || null) : null,
          regimenLaboral: calcCtx.regimenesLaborales.find(r => r.id === empleado.regimen_laboral_id)?.codigo || null,
          asignacionFamiliar: empleado.asignacion_familiar || false,
          tipoContratacion: empleado.tipo_contratacion || null,
          sueldoInterno: parseFloat(empleado.sueldo_interno) || 0,
          tipoPlanilla: empleado.tipo_planilla || null,
          omitirDescuentosPlameInterna: omitirDescuentosPlameInternaDe(empleado.id),
          periodoGratificacionConsu: periodoGratiConsuDe(empleado.id),
          formaPago: empleado.forma_pago === 'jornal' ? 'jornal' : 'mensual',
          formaPagoPlanilla: formaPagoPlanillaDe(empleado.id) || null,
          fechaDesdeJornal: fechaDesdeJornalDe(empleado.id) || null,
          aplicarDescuentoDominical: valorDominicalApi(descuentoDominicalDe(empleado.id)),
        fechaIngresoInterna: empleado.fecha_ingreso_interna || empleado.fechaIngresoInterna || null,
          comisionTipo: tieneAfp ? (empleado.comision_tipo || afpEncontrada?.comision_tipo || empleado.afp?.comision_tipo || null) : null,
          fechaAfiliacionAfp: tieneAfp ? (empleado.fecha_afiliacion_afp || null) : null
        };
        
        const conceptosInternosSrc = (Array.isArray(empleado.conceptos_internos) ? empleado.conceptos_internos : [])
          .map((c) => {
            const codigo = String(
              c.codigoPlame
              || c.codigo_plame
              || c.codigo
              || c.plame_configuracion?.codigo_plame
              || c.plameConfiguracion?.codigo_plame
              || ''
            );
            return {
              ...c,
              codigo,
              codigo_plame: codigo,
              codigoPlame: codigo,
              descripcion:
                c.descripcion
                || c.concepto
                || c.plame_configuracion?.descripcion
                || c.plameConfiguracion?.descripcion
                || codigo,
              monto: Number(c.monto ?? c.valor ?? c.monto_interna) || 0,
            };
          });
        const conceptosAgrupados = agruparConceptos(empleado.conceptos);
        const fusionInterna = fusionarAjustesEnInterna({
          ingresos: conceptosAgrupados.ingresos,
          descuentos: conceptosAgrupados.descuentos,
          ingresosInternos: conceptosInternosSrc.filter((c) => c.tipo_concepto === 'ingreso'),
          descuentosInternos: conceptosInternosSrc.filter((c) => c.tipo_concepto === 'descuento'),
        });
        const conceptosUsuario = {
          ingresos: conceptosAgrupados.ingresos,
          descuentos: conceptosAgrupados.descuentos,
          aportes: conceptosAgrupados.aportes,
          ingresosInternos: fusionInterna.ingresosInternos,
          descuentosInternos: fusionInterna.descuentosInternos,
          aportesInternos: conceptosInternosSrc.filter(c => c.tipo_concepto === 'aporte'),
        };
        if (fusionInterna.sueldoInternoOverride != null) {
          datosSalariales.sueldoInterno = fusionInterna.sueldoInternoOverride;
        }
        
        const datosEmpleado = {
          id: empleado.id,
          nombres: empleado.nombre_completo?.split(' ').slice(0, 2).join(' ') || '',
          apellidos: empleado.nombre_completo?.split(' ').slice(2).join(' ') || '',
          nombreCompleto: empleado.nombre_completo,
          numeroDocumento: empleado.numero_documento,
          tipoDocumento: empleado.tipo_documento || 'DNI',
          fecha_nacimiento: extraerFechaNacimientoEmpleado(empleado),
          fechaNacimiento: extraerFechaNacimientoEmpleado(empleado),
          fechaIngreso: resolverFechaIngresoEnPlanilla(empleado, planillaReal?.fecha_inicio, planillaReal?.fecha_fin)
            || empleado.fecha_ingreso_actual
            || empleado.fecha_ingreso,
          cargo: empleado.cargo,
          areas_de_trabajo: empleado.areas_de_trabajo,
          estado: empleado.estado,
          categoria: empleado.categoria,
          proyecto: empleado.proyecto,
          historial_laboral: Array.isArray(empleado.historial_laboral) ? empleado.historial_laboral : [],
          ...camposHistorialInternoCalculo(empleado),
          // ✅ INFORMACIÓN BANCARIA
          banco: empleado.banco || null,
          cuenta_bancaria: empleado.cuenta_bancaria || null,
          cci: empleado.cci || null,
          monto_viatico_standard: parseFloat(empleado.monto_viatico_standard) || 0,
          sueldo_basico: parseFloat(empleado.sueldo_basico) || 0,
          telefono: empleado.telefono,
          email: empleado.email,
          direccion: empleado.direccion,
          descuento_descanso: empleado.descuento_descanso,
          nombre_completo: empleado.nombre_completo,
          numero_documento: empleado.numero_documento,
        };
        
        // ⏰ TAREOS DEL EMPLEADO (filtrados por empleado_id Y por período de planilla)
        const idEmpCalc = Number(empleado.id ?? empleado.empleado_id);
        let tareosEmpleadoCompletos = tareosCalculoCtx.filter(
          (tareo) => Number(tareo.empleado_id) === idEmpCalc,
        );
        if (modoAjustePosteriorCerrada && tareosEmpleadoCompletos.length === 0) {
          const snapTareos = [
            ...(Array.isArray(empleado.tareosEmpleado) ? empleado.tareosEmpleado : []),
            ...(Array.isArray(empleado.tareosEmpleadoInterna) ? empleado.tareosEmpleadoInterna : []),
            ...(Array.isArray(empleado.tareos) ? empleado.tareos : []),
          ];
          if (snapTareos.length > 0) {
            tareosEmpleadoCompletos = snapTareos;
          }
        }
        const tareosEmpleado = filtrarTareosPlanillaPorHistorial(
          tareosEmpleadoCompletos,
          empleado,
          planillaReal?.fecha_inicio,
          planillaReal?.fecha_fin,
          'plame'
        );
        const tareosEmpleadoInterna = filtrarTareosPlanillaPorHistorial(
          tareosEmpleadoCompletos,
          empleado,
          planillaReal?.fecha_inicio,
          planillaReal?.fecha_fin,
          'interno'
        );
        const autorizacionesEmpleado = autorizacionesCalculoCtx.filter(
          (autorizacion) => Number(autorizacion.empleado_id) === idEmpCalc,
        );
        
        const resumenTareosEmpleado = {
          total_tareos: tareosEmpleado.length, // Ya filtrado por período
          tareos_por_tipo: {},
          dias_trabajados: 0,
          horas_totales: 0,
          proyectos: [...new Set(tareosEmpleado.map(t => t.proyecto?.nombre).filter(Boolean))]
        };
        
        const resumenAutorizacionesEmpleado = {
          total_autorizaciones: autorizacionesEmpleado.length,
          autorizaciones_por_tipo: {},
          total_dias_autorizados: 0,
          total_horas_autorizadas: 0
        };
        
        tareosEmpleado.forEach(tareo => {
          const tipoEvento = tareo.tipo_evento || 'Desconocido';
          resumenTareosEmpleado.tareos_por_tipo[tipoEvento] = (resumenTareosEmpleado.tareos_por_tipo[tipoEvento] || 0) + 1;
          if (tareo.tipo_evento === 'asistio' || tareo.tipo_evento === 'asistencia_completa') {
            resumenTareosEmpleado.dias_trabajados += 1;
          }
          resumenTareosEmpleado.horas_totales += parseFloat(tareo.horas_trabajadas || 0);
        });

        // 💤 CALCULAR DESCANSOS SEMANALES PROPORCIONALES (SOLO DÍAS DEL PERÍODO) - SEGUNDA UBICACIÓN
        const calcularDescansosSemanalesPlanilla = () => {
          // ✅ PARA PLANILLAS CERRADAS: usar descuento_descanso individual del empleado
          // ✅ PARA PLANILLAS ABIERTAS: usar configuracionTareo general
          const debeDescontarDescansos = debeDescontarDescansosEmpleado(empleado);
            
          if (!debeDescontarDescansos || tareosEmpleado.length === 0) {
            return [];
          }

          //console.log(`💤 CALCULANDO DESCANSOS SEMANALES PLANILLA - Empleado: ${empleado.nombre_completo}`);
          //console.log(`💤 Planilla cerrada: ${planillaCerrada ? 'SÍ' : 'NO'}`);
          //console.log(`💤 Valor usado: ${debeDescontarDescansos ? 'ACTIVADO' : 'DESACTIVADO'}`);
          
          // Agrupar tareos por semanas (de lunes a domingo)
          const semanasEmpleado = [];
          let semanaActual = [];
          
          // Formatear tareos para procesamiento
          const tareosFormateados = tareosEmpleado.map(tareo => {
            // ✅ USAR FECHA LOCAL SIN PROBLEMAS DE ZONA HORARIA
            const fechaTexto = tareo.fecha.split('T')[0]; // Obtener solo YYYY-MM-DD
            const [año, mes, dia] = fechaTexto.split('-');
            const fecha = new Date(parseInt(año), parseInt(mes) - 1, parseInt(dia)); // Crear fecha local
            
            const diaSemana = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'][fecha.getDay()];
            const fechaFormateada = fecha.toLocaleDateString('es-PE', { 
              weekday: 'short', 
              day: '2-digit', 
              month: '2-digit' 
            });
            
            return {
              ...tareo,
              fecha: tareo.fecha,
              fechaFormateada,
              diaSemana,
              tipo: tareo.tipo_evento === 'falta' ? 'Falta' : 'Asistió'
            };
          }).sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
          
          tareosFormateados.forEach((tareo, index) => {
            semanaActual.push(tareo);
            
            // Si es domingo O es el último tareo, cerrar la semana
            const esDomingo = tareo.diaSemana === 'Dom';
            const esUltimoTareo = index === tareosFormateados.length - 1;
            
            if (esDomingo || esUltimoTareo) {
              if (semanaActual.length > 0) {
                // Contar faltas en la semana
                const faltasSemana = semanaActual.filter(t => t.tipo === 'Falta').length;
                
                // Determinar días laborables del período (INCLUIR TODA LA SEMANA)
                // Todos los días se consideran laborables porque solo se identifican eventos "falta"
                const diasLaborablesSemana = semanaActual.length;
                
                // Días trabajados efectivos (sin faltas)
                const diasTrabajadosEfectivos = Math.max(0, diasLaborablesSemana - faltasSemana);
                
                // ✅ NUEVA LÓGICA: Descanso base 8h - descuento por faltas (8/7 × faltas)
                const descansoBase = 8;
                const descuentoPorFalta = (8 / 7) * faltasSemana;
                const descansoProporcionado = Math.max(0, descansoBase - descuentoPorFalta);
                
                const fechaInicio = semanaActual[0].fechaFormateada;
                const fechaFin = semanaActual[semanaActual.length - 1].fechaFormateada;
                
                //console.log(`💤 PLANILLA - Semana ${fechaInicio} - ${fechaFin}:`);
                //console.log(`  • Días laborables: ${diasLaborablesSemana}`);
                //console.log(`  • Faltas: ${faltasSemana}`);
                //console.log(`  • Días trabajados efectivos: ${diasTrabajadosEfectivos}`);
                //console.log(`  • Descanso proporcionado: ${descansoProporcionado.toFixed(2)}h de 8h`);
                
                semanasEmpleado.push({
                  fechaInicio,
                  fechaFin,
                  diasLaborables: diasLaborablesSemana,
                  faltas: faltasSemana,
                  diasTrabajadosEfectivos,
                  descansoCompleto: 8,
                  descansoProporcionado,
                  totalTareos: semanaActual.length
                });
              }
              
              // Reiniciar para la siguiente semana
              semanaActual = [];
            }
          });
          
          //console.log(`💤 Total semanas calculadas PLANILLA para ${empleado.nombre_completo}: ${semanasEmpleado.length}`);
          return semanasEmpleado;
        };

        // Calcular descansos semanales y agregarlos al resumen
        const descansosSemanales = calcularDescansosSemanalesPlanilla();
        resumenTareosEmpleado.descansos_semanales = descansosSemanales;

        autorizacionesEmpleado.forEach(autorizacion => {
          const tipoAutorizacion = `${autorizacion.tipo_autorizacion || 'Desconocido'}${autorizacion.sub_tipo ? ` - ${autorizacion.sub_tipo}` : ''}`;
          resumenAutorizacionesEmpleado.autorizaciones_por_tipo[tipoAutorizacion] = (resumenAutorizacionesEmpleado.autorizaciones_por_tipo[tipoAutorizacion] || 0) + 1;
          resumenAutorizacionesEmpleado.total_dias_autorizados += parseFloat(autorizacion.dias || 0);
          resumenAutorizacionesEmpleado.total_horas_autorizadas += parseFloat(autorizacion.horas || 0);
        });

        const metadatos = {
          origen: 'planilla_detalle_empleado_activo',
          timestamp: new Date().toISOString(),
          fuente: 'Empleado activo durante período de planilla',
          contexto: `Empleado ${index + 1} de ${empleadosParaProcesar.length} activos`,
          periodo_planilla: planillaReal ? `${planillaReal.fecha_inicio} - ${planillaReal.fecha_fin}` : 'No definido'
        };
        
        return {
          tipo: 'empleado_activo_con_apis',
          posicion_en_array: index + 5,
          empleado_posicion_activos: index + 1,
          total_empleados_activos: empleadosParaProcesar.length,
          empleado_id: empleado.id,
          empleado_nombre: empleado.nombre_completo,
          empleado_posicion: index + 1,
          omitir_descuentos_plame_interna: omitirDescuentosPlameInternaDe(empleado.id),
          periodo_gratificacion_consu: periodoGratiConsuDe(empleado.id),
          forma_pago: empleado.forma_pago === 'jornal' ? 'jornal' : 'mensual',
          forma_pago_planilla: formaPagoPlanillaDe(empleado.id) || null,
          fecha_desde_jornal: fechaDesdeJornalDe(empleado.id) || null,
          aplicar_descuento_dominical: valorDominicalApi(descuentoDominicalDe(empleado.id)),
          ...(esPlanillaModalidadConstruccion(planillaReal) ? {
            fecha_calculo_desde: fechaCalculoDesdeDe(empleado.id) || null,
            fecha_calculo_hasta: fechaCalculoHastaDe(empleado.id) || null,
          } : {}),
          overridesTareoEvento: overridesTareoParaCalculo,
          tramosBoletaInterna: tramosInternaParaCalculo,
          tramosSueldoPlame: tramosSueldoParaCalculo,
          datosEmpresa,
          datosAPIs,
          datosSalariales,
          conceptosUsuario,
          datosEmpleado,
          tareosEmpleado: tareosEmpleado,
          tareosEmpleadoInterna: tareosEmpleadoInterna,
          resumenTareos: resumenTareosEmpleado,
          tasaNocturna: armarTasaNocturnaEmpleado(
            tareosEmpleado,
            empleado,
            configuracionTasaNocturnaConfig,
            configuracionesPlame
          ),
          autorizacionesEmpleado: autorizacionesEmpleado,
          resumenAutorizaciones: resumenAutorizacionesEmpleado,
          liquidaciones_planilla: Array.isArray(empleado.liquidaciones_planilla) ? empleado.liquidaciones_planilla : [],
          gratificaciones_planilla: Array.isArray(empleado.gratificaciones_planilla) ? empleado.gratificaciones_planilla : [],
          metadatos
        };
      });

      // Construir array unificado completo
      const arrayUnificado = [
        {
          tipo: 'metadatos_sistema',
          timestamp: new Date().toISOString(),
          origen: 'planilla_detalle_empleados_activos',
          version: '1.0',
          descripcion: 'Array unificado con empleados activos y todos sus datos API individuales'
        },
        {
          tipo: 'contexto_empresarial',
          empresa: selectedCompany,
          planilla_real: planillaReal,
          tareos_periodo: {
            tareos: tareosCalculoCtx,
            resumen: resumenTareos,
            total_tareos: tareosCalculoCtx.length
          },
          autorizaciones_periodo: {
            autorizaciones: autorizacionesCalculoCtx,
            total_autorizaciones: autorizacionesCalculoCtx.length
          },
          periodo: {
            fecha_inicio: planillaReal?.fecha_inicio,
            fecha_fin: planillaReal?.fecha_fin,
            planilla_id: planillaReal?.id
          },
          // Viáticos: se informan en planilla/REM pero no afectan neto a pagar
          viaticos_standard: viaticosConfig
            ? {
                activo: Boolean(viaticosConfig.activo),
                plame_configuracion_id: viaticosConfig.plame_configuracion_id || null,
              }
            : null,
          overrides_tareo_evento: overridesTareoParaCalculo,
          tramos_boleta_interna: tramosInternaParaCalculo,
          tramos_sueldo_plame: tramosSueldoParaCalculo,
          configuracion_tareo: calcCtx.configuracionTareo,
        },
        {
          tipo: 'resumen_apis_disponibles',
          ...resumenAPIsDisponibles,
          estado_sistema: resumenAPIsDisponibles.apis_completas ? 'COMPLETO' : 'INCOMPLETO'
        },
        {
          tipo: 'estadisticas_generales',
          empleados: {
            total_empleados_empresa: empleadosConConceptos.length,
            empleados_activos_planilla: empleadosParaProcesar.length,
            empleados_no_activos: empleadosConConceptos.length - empleadosParaProcesar.length,
            porcentaje_empleados_activos: empleadosConConceptos.length > 0 ? 
              parseFloat(((empleadosParaProcesar.length / empleadosConConceptos.length) * 100).toFixed(1)) : 0
          }
        },
        ...empleadosActivosConDatosAPI
      ];

      // 💤 INICIALIZAR COMPENSACIONES EN EL BACKEND
      //console.log(`📊 Empleados activos preparados: ${empleadosParaProcesar.length}`);
      //console.log(`🔍 Planilla ID: ${planillaReal?.id}`);
      
      if (planillaReal?.id && empleadosParaProcesar.length > 0) {
        const empleadosIds = empleadosParaProcesar.map(emp => emp.id);
        
        try {
          //console.log(`💤 Enviando ${empleadosIds.length} empleados al backend para inicializar compensaciones...`);
          
          const resultadoCompensaciones = await compensacionService.inicializarCompensacionesPlanilla(
            planillaReal.id,
            empleadosIds
          );
          
          if (resultadoCompensaciones.success) {
            const { data } = resultadoCompensaciones;
            if (data.accion === 'creado') {
              //console.log(`✅ Compensaciones creadas: ${data.compensaciones_creadas} registros con horas en 0`);
            } else if (data.accion === 'saltado') {
              //console.log(`⏭️ Compensaciones ya existían: ${data.compensaciones_existentes} registros`);
            }
          } else {
            console.error(`❌ Error al inicializar compensaciones: ${resultadoCompensaciones.error}`);
            // No detener el flujo, solo registrar el error
          }
          
        } catch (error) {
          console.error(`❌ Error inesperado al inicializar compensaciones:`, error);
          // No detener el flujo, continuar con el cálculo
        }
      } else {
        console.log(`⚠️ No se inicializaron compensaciones: planilla_id=${planillaReal?.id}, empleados=${empleadosActivosPlanilla.length}`);
      }

      // 💤 CARGAR COMPENSACIONES ACTUALES PARA EL ARRAY UNIFICADO
      let compensacionesActuales = [];
      if (planillaReal?.id) {
        try {
          console.log(`📊 Cargando compensaciones actuales para planilla ${planillaReal.id}...`);
          
          const resultadoCompensacionesActuales = await compensacionService.obtenerCompensacionesPorPlanilla(planillaReal.id);
          
          if (resultadoCompensacionesActuales.success) {
            compensacionesActuales = resultadoCompensacionesActuales.data;
            console.log(`✅ Compensaciones cargadas: ${compensacionesActuales.length} registros | Total horas: ${resultadoCompensacionesActuales.totalHoras}h`);
          } else {
            console.error(`❌ Error al cargar compensaciones: ${resultadoCompensacionesActuales.error}`);
          }
        } catch (error) {
          console.error(`❌ Error inesperado al cargar compensaciones:`, error);
        }
      }

      // 📋 AGREGAR COMPENSACIONES AL ARRAY UNIFICADO
      const seccionCompensaciones = {
        tipo: 'compensaciones_meses_pasados',
        planilla_id: planillaReal?.id,
        total_compensaciones: compensacionesActuales.length,
        total_horas_compensadas: compensacionesActuales.reduce((sum, comp) => sum + parseFloat(comp.horas_compensadas || 0), 0),
        compensaciones_activas: compensacionesActuales.filter(comp => parseFloat(comp.horas_compensadas || 0) > 0).length,
        compensaciones: compensacionesActuales,
        resumen_por_empleado: compensacionesActuales.reduce((acc, comp) => {
          acc[comp.empleado_id] = {
            horas_compensadas: parseFloat(comp.horas_compensadas || 0),
            empleado_nombre: comp.empleado?.nombre_completo || 'Sin nombre',
            compensacion_id: comp.id
          };
          return acc;
        }, {}),
        timestamp: new Date().toISOString(),
        metadatos: {
          origen: 'procesamiento_planilla',
          descripcion: 'Compensaciones de meses pasados cargadas para incluir en cálculos',
          fecha_carga: new Date().toISOString()
        }
      };

      // Insertar compensaciones en el array unificado
      arrayUnificado.splice(4, 0, seccionCompensaciones);

      // 🛡️ CARGAR SEGUROS FRESCOS Y AGREGAR AL ARRAY UNIFICADO
      let registrosSegurosActivos = [];
      try {
        if (planillaReal?.id) {
          const responseSeguros = await planillaSeguroService.obtenerSeguros(planillaReal.id);
          if (responseSeguros.success) {
            registrosSegurosActivos = responseSeguros.data?.registros || [];
            setSegurosPlanillaResumen(responseSeguros.data?.resumen || []);
            setSegurosPlanillaRegistros(registrosSegurosActivos);
          }
        }
      } catch (error) {
        console.error('❌ Error al cargar seguros antes del procesamiento:', error);
        registrosSegurosActivos = segurosPlanillaRegistros;
      }

      const seccionSeguros = construirSeccionSegurosPlanilla(registrosSegurosActivos, planillaReal?.id);
      arrayUnificado.splice(5, 0, seccionSeguros);

      console.log(`🛡️ Seguros agregados al array unificado:`);
      console.log(`  📊 Total registros activos: ${seccionSeguros.total_registros}`);
      console.log(`  💰 Total monto: S/ ${seccionSeguros.total_monto.toFixed(2)}`);
      console.log(`  🏷️ Códigos activos: ${seccionSeguros.codigos_activos.join(', ') || 'ninguno'}`);

      console.log(`💤 Compensaciones agregadas al array unificado:`);
      console.log(`  📊 Total compensaciones: ${seccionCompensaciones.total_compensaciones}`);
      console.log(`  ⏰ Total horas: ${seccionCompensaciones.total_horas_compensadas}h`);
      console.log(`  ✅ Compensaciones activas: ${seccionCompensaciones.compensaciones_activas}`);

      // 🔄 APLICAR AJUSTES TEMPORALES SI ES NECESARIO
      let arrayFinal = arrayUnificado;
      if (window.aplicarAjustesTemporales) {
        console.log('💰 === APLICANDO AJUSTES TEMPORALES ANTES DEL PROCESAMIENTO ===');
        console.log('🔍 Array unificado original:', arrayUnificado.length, 'elementos');
        console.log('🔍 Empleados en array original:', arrayUnificado.filter(e => e.tipo === 'empleado_activo_con_apis').length);
        
        arrayFinal = aplicarAjustesTemporalesAlArrayUnificado(arrayUnificado);
        
        console.log('🔍 Array final modificado:', arrayFinal.length, 'elementos');
        console.log('🔍 Empleados en array final:', arrayFinal.filter(e => e.tipo === 'empleado_activo_con_apis').length);
        
        // Comparar conceptos antes y después
        const empleadoComparacion = arrayFinal.find(e => e.tipo === 'empleado_activo_con_apis');
        if (empleadoComparacion) {
          console.log('🔍 Ejemplo - conceptos finales en array:', {
            empleado: empleadoComparacion.empleado_nombre,
            ingresos: empleadoComparacion.conceptosUsuario?.ingresos?.length || 0,
            primerosIngresos: empleadoComparacion.conceptosUsuario?.ingresos?.slice(0, 3)?.map(c => ({
              codigo: c.codigo,
              descripcion: c.descripcion,
              monto: c.monto
            }))
          });
        }
        console.log('💰 === FIN APLICACIÓN DE AJUSTES TEMPORALES ===');
      } else {
        console.log('ℹ️ No se aplicarán ajustes temporales (flag desactivado)');
      }

      console.log(`🛡️ Aplicando seguros de planilla al cálculo (${registrosSegurosActivos.length} registro(s) con monto)`);
      arrayFinal = aplicarSegurosAlArrayUnificado(
        arrayFinal,
        registrosSegurosActivos,
        configuracionesPlame
      );

      logDiagnosticoBonificacionNocturnaVisible('Inicio recálculo planilla — config tasa nocturna', {
        planilla_id: planillaReal?.id,
        empresa_id: selectedCompany?.id,
        configuracionTasaNocturnaConfig,
        empleados_a_procesar: empleadosParaProcesar.length,
        filtrar_consola: 'DIAG-0309',
      });

      // 🚀 LLAMAR AL SERVICE DE PROCESAMIENTO
      const resultado = await planillaCalculoService.procesarEmpleadosParaPlanilla(arrayFinal);
      
      if (resultado.success) {
        const stats = planillaCalculoService.obtenerEstadisticasResumen(resultado.data);
        
        // ✅ EXTRAER EMPLEADOS CON BOLETAS CALCULADAS Y ACTUALIZAR VISTA
        console.log(`🔍 === TRANSFORMANDO EMPLEADOS PROCESADOS ===`);
        console.log(`📊 Total empleados procesados por servicio: ${resultado.data.empleadosProcesados.length}`);
        console.log(`📊 Total empleados activos en planilla: ${empleadosActivosPlanilla.length}`);
        console.log(`🔍 IDs de empleados procesados:`, resultado.data.empleadosProcesados.map(ep => ep.empleado_id));
        console.log(`🔍 IDs de empleados activos:`, empleadosActivosPlanilla.map(emp => emp.id));
        
        const empleadosConBoletas = resultado.data.empleadosProcesados.map(empleadoProcesado => {
          const boleta = empleadoProcesado.boleta;
          
          // 🔍 LOG DETALLADO PARA EMPLEADO 190 O CUALQUIER EMPLEADO SIN BOLETA VÁLIDA
          if (!boleta || !boleta.success || !boleta.data) {
            console.warn(`⚠️ Empleado ${empleadoProcesado.empleado_id} sin boleta válida`);
            console.log(`🔍 === ANÁLISIS DETALLADO EMPLEADO ${empleadoProcesado.empleado_id} ===`);
            console.log(`📋 Empleado procesado completo:`, empleadoProcesado);
            console.log(`📋 Boleta objeto:`, boleta);
            console.log(`❌ Verificaciones:`);
            console.log(`   - boleta existe: ${!!boleta}`);
            console.log(`   - boleta.success: ${boleta?.success}`);
            console.log(`   - boleta.data existe: ${!!boleta?.data}`);
            if (boleta) {
              console.log(`   - Estructura completa de boleta:`, JSON.stringify(boleta, null, 2));
              if (boleta.error) {
                console.error(`   - Error en boleta:`, boleta.error);
              }
              if (boleta.message) {
                console.warn(`   - Mensaje en boleta:`, boleta.message);
              }
            }
            return null;
          }
          
          // Transformar los datos de la boleta al formato de la vista
          const idProc = Number(empleadoProcesado.empleado_id);
          const datosOriginal =
            empleadosParaProcesar.find((emp) => Number(emp.id ?? emp.empleado_id) === idProc)
            || empleadosActivosPlanilla.find((emp) => Number(emp.id ?? emp.empleado_id) === idProc);
          
          if (!datosOriginal) {
            console.error(`❌ EMPLEADO PERDIDO: No se encontró empleado con ID ${empleadoProcesado.empleado_id} en empleadosActivosPlanilla`);
            console.error(`   Empleado procesado:`, empleadoProcesado);
            console.error(`   IDs disponibles en empleadosActivosPlanilla:`, empleadosActivosPlanilla.map(e => e.id));
            return null;
          }

          // 🔍 BUSCAR DATOS ACTUALIZADOS CON RESUMEN DE TAREOS
          const datosActualizados = resultado.data.empleadosProcesados.find(ep => ep.empleado_id === empleadoProcesado.empleado_id);
          const resumenTareosActualizado = datosActualizados?.resumenTareos || datosOriginal?.resumenTareos;

          const conceptosCalculados = mapearConceptosDesdeBoleta(boleta, 'calculado');
          const rellenarBaseDesdeUsuario = (calculados, originales) => {
            const porCodigo = new Map(
              (originales || []).map((c) => [
                String(c.codigo_plame || c.codigoPlame || c.codigo || ''),
                c,
              ])
            );
            return (calculados || []).map((c) => {
              if (Number(c.base_calculo) > 0) return c;
              const orig = porCodigo.get(String(c.codigo_plame || c.codigoPlame || c.codigo || ''));
              const base = orig?.base_calculo ?? orig?.base;
              if (base == null || base === '') return c;
              return { ...c, base_calculo: parseFloat(base) || 0 };
            });
          };
          conceptosCalculados.ingresos = rellenarBaseDesdeUsuario(
            conceptosCalculados.ingresos,
            empleadoProcesado.conceptosUsuario?.ingresos
          );
          conceptosCalculados.descuentos = rellenarBaseDesdeUsuario(
            conceptosCalculados.descuentos,
            empleadoProcesado.conceptosUsuario?.descuentos
          );
          conceptosCalculados.aportes = rellenarBaseDesdeUsuario(
            conceptosCalculados.aportes,
            empleadoProcesado.conceptosUsuario?.aportes
          );
          const conceptosConLiquidacion = fusionarLiquidacionPlanillaEnConceptos(conceptosCalculados, {
            liquidacionesPlanilla: datosOriginal.liquidaciones_planilla || [],
            conceptosUsuario: empleadoProcesado.conceptosUsuario,
            catalogoPlame: Object.values(
              configuracionesPlame || empleadoProcesado.datosAPIs?.conceptosPlame || []
            ),
          });
          const boletaInterna = empleadoProcesado.boleta_interna;
          const boletaInterna1 = empleadoProcesado.boleta_interna_1;
          const boletaInterna2 = empleadoProcesado.boleta_interna_2;
          const conceptosInternosCalculados = (boletaInterna && boletaInterna.success && boletaInterna.data)
            ? mapearConceptosDesdeBoleta(boletaInterna, 'calculado_interno')
            : { ingresos: [], descuentos: [], aportes: [] };
          const conceptosInternos1 = (boletaInterna1 && boletaInterna1.success && boletaInterna1.data)
            ? mapearConceptosDesdeBoleta(boletaInterna1, 'calculado_interno_1')
            : null;
          const conceptosInternos2 = (boletaInterna2 && boletaInterna2.success && boletaInterna2.data)
            ? mapearConceptosDesdeBoleta(boletaInterna2, 'calculado_interno_2')
            : null;
          
          // Crear empleado actualizado con conceptos calculados (PLAME + interna)
          return {
            ...datosOriginal,
            conceptos: [...conceptosConLiquidacion.ingresos, ...conceptosConLiquidacion.descuentos, ...conceptosConLiquidacion.aportes],
            conceptos_separados: conceptosConLiquidacion,
            conceptos_internos: [...conceptosInternosCalculados.ingresos, ...conceptosInternosCalculados.descuentos, ...conceptosInternosCalculados.aportes],
            conceptos_separados_internos: conceptosInternosCalculados,
            conceptos_separados_internos_1: conceptosInternos1,
            conceptos_separados_internos_2: conceptosInternos2,
            dias_interna_1: boletaInterna1?.dias_tramo ?? null,
            dias_interna_2: boletaInterna2?.dias_tramo ?? null,
            sueldo_partido: empleadoProcesado.boleta_interna_partida
              ? null
              : (boletaInterna?.sueldo_partido || (
              boletaInterna1 && boletaInterna2
                ? {
                    dias1: boletaInterna1.dias_tramo ?? null,
                    dias2: boletaInterna2.dias_tramo ?? null,
                    sueldo1: boletaInterna1.sueldo_base_tramo ?? null,
                    sueldo2: boletaInterna2.sueldo_base_tramo ?? null,
                  }
                : null
            )),
            boleta_calculada: boleta,
            boleta_interna_calculada: boletaInterna || null,
            boleta_interna_1_calculada: boletaInterna1 || null,
            boleta_interna_2_calculada: boletaInterna2 || null,
            boleta_interna_partida: Boolean(empleadoProcesado.boleta_interna_partida),
            tipo_planilla: empleadoProcesado.tipo_planilla || datosOriginal.tipo_planilla || null,
            sueldo_interno: empleadoProcesado.sueldo_interno ?? datosOriginal.sueldo_interno ?? null,
            sueldo_interno_1: empleadoProcesado.boleta_interna_1?.sueldo_base_tramo
              ?? datosOriginal.sueldo_interno_1
              ?? null,
            sueldo_interno_2: empleadoProcesado.boleta_interna_2?.sueldo_base_tramo
              ?? datosOriginal.sueldo_interno_2
              ?? null,
            fecha_ingreso_interna: empleadoProcesado.datosEmpleado?.fecha_ingreso_interna
              || empleadoProcesado.datosSalariales?.fechaIngresoInterna
              || datosOriginal.fecha_ingreso_interna
              || null,
            historial_laboral_interno: empleadoProcesado.datosEmpleado?.historial_laboral_interno
              || datosOriginal.historial_laboral_interno
              || [],
            omitir_descuentos_plame_interna: Boolean(
              empleadoProcesado.omitir_descuentos_plame_interna
              ?? datosOriginal.omitir_descuentos_plame_interna
            ),
            periodo_gratificacion_consu: empleadoProcesado.periodo_gratificacion_consu
              || empleadoProcesado.datosSalariales?.periodoGratificacionConsu
              || datosOriginal.periodo_gratificacion_consu
              || 'auto',
            forma_pago: empleadoProcesado.forma_pago
              || empleadoProcesado.datosSalariales?.formaPago
              || datosOriginal.forma_pago
              || 'mensual',
            forma_pago_planilla: empleadoProcesado.forma_pago_planilla
              || empleadoProcesado.datosSalariales?.formaPagoPlanilla
              || datosOriginal.forma_pago_planilla
              || null,
            fecha_desde_jornal: empleadoProcesado.fecha_desde_jornal
              || empleadoProcesado.datosSalariales?.fechaDesdeJornal
              || datosOriginal.fecha_desde_jornal
              || null,
            aplicar_descuento_dominical: empleadoProcesado.aplicar_descuento_dominical
              ?? empleadoProcesado.datosSalariales?.aplicarDescuentoDominical
              ?? datosOriginal.aplicar_descuento_dominical
              ?? null,
            fecha_calculo_desde: empleadoProcesado.fecha_calculo_desde
              || datosOriginal.fecha_calculo_desde
              || null,
            fecha_calculo_hasta: empleadoProcesado.fecha_calculo_hasta
              || datosOriginal.fecha_calculo_hasta
              || null,
            pagoJornal: empleadoProcesado.pagoJornal || datosOriginal.pagoJornal || null,
            calculoConstruccionCivil: empleadoProcesado.calculoConstruccionCivil
              || datosOriginal.calculoConstruccionCivil
              || null,
            tareosEmpleado: (() => {
              const plame = empleadoProcesado.tareosEmpleado || [];
              const interna = empleadoProcesado.tareosEmpleadoInterna
                || datosOriginal.tareosEmpleadoInterna
                || [];
              if (plame.length) return plame;
              if (interna.length) return interna;
              return datosOriginal.tareosEmpleado || [];
            })(),
            tareosEmpleadoInterna: empleadoProcesado.tareosEmpleadoInterna || datosOriginal.tareosEmpleadoInterna || [],
            estado_procesamiento: 'calculado',
            timestamp_calculo: new Date().toISOString(),
            // ✅ AGREGAR TOTAL DE REGISTROS DE TAREOS PARA BACKEND
            total_registros_tareos: resumenTareosActualizado?.total_tareos || 0,
            // ✅ AGREGAR CONFIGURACIÓN DE TAREOS CON CADA EMPLEADO
            configuracion_tareo: configuracionTareo
          };
        }).filter(emp => emp !== null);
        
        console.log(`✅ Empleados después del filtro: ${empleadosConBoletas.length} (se perdieron ${resultado.data.empleadosProcesados.length - empleadosConBoletas.length} empleados)`);
        
        // ✅ ACTUALIZAR ESTADO CON EMPLEADOS CALCULADOS
        if (modoAjustePosteriorCerrada) {
          setEmpleadosConBoletasCalculadas((prev) => mezclarCalculadosPlanillaCerrada(empleadosConBoletas, prev));
          setEmpleados((prev) => mezclarCalculadosPlanillaCerrada(empleadosConBoletas, prev));
          setEmpleadosActivosPlanilla((prev) => mezclarCalculadosPlanillaCerrada(empleadosConBoletas, prev));
        } else {
          setEmpleadosConBoletasCalculadas(mezclarCalculadosConPreCierres(empleadosConBoletas));
        }
        
        //alert(`🎯 PROCESAMIENTO COMPLETADO\n\n` +
              //`✅ Empleados procesados: ${stats.procesadosExitosos}/${stats.totalEmpleados}\n` +
              //`❌ Errores: ${stats.procesadosConErrores}\n` +
              //`📊 Porcentaje de éxito: ${stats.porcentajeExito}%\n` +
              //`⏱️ Duración: ${stats.duracionSegundos}s\n` +
          //    `🚀 Velocidad: ${stats.empleadosPorSegundo} empleados/segundo\n\n` +
            //  `💡 Los datos en la vista han sido actualizados con los cálculos.`);
        
      } else {
        alert(`❌ Error en procesamiento:\n${resultado.error}`);
      }
      
    } catch (error) {
      alert(`❌ Error general: ${error.message}`);
    } finally {
      setCalculandoPlanilla(false);
    }
  };

  // 🎯 FUNCIÓN DUPLICADA PARA PROCESAR EMPLEADOS CON LÓGICA DE PLANILLA - ANÁLISIS INDIVIDUAL
  const procesarEmpleadosConPlanillaDuplicada = async () => {
    try {

      
      setCalculandoPlanilla(true);
      
      // 🔒 VERIFICAR SI PLANILLA ESTÁ CERRADA (modo read-only)
      if (planillaCerrada) {
        console.log('🔒🔒🔒 ANÁLISIS INDIVIDUAL: PLANILLA CERRADA - ABORTANDO CÁLCULOS');
        alert('📦 Esta planilla está cerrada.\n\nLos datos son de solo lectura y no se pueden recalcular.');
        setCalculandoPlanilla(false);
        return;
      }
      
      // Verificar que tenemos empleados activos
      if (!empleadosActivosPlanilla || empleadosActivosPlanilla.length === 0) {
        alert('⚠️ No hay empleados activos para procesar. Primero carga los datos.');
        setCalculandoPlanilla(false);
        return;
      }

      // 🎯 VERIFICAR QUE HAY UN EMPLEADO SELECCIONADO PARA ANÁLISIS
      if (!empleadoSeleccionadoAnalisis) {
        alert('⚠️ Debes seleccionar un empleado para realizar el análisis individual.\n\nUsa el selector que aparece junto al botón.');
        setCalculandoPlanilla(false);
        return;
      }

      // Encontrar el empleado seleccionado en la lista activa
      const empleadoEncontrado = empleadosActivosPlanilla.find(emp => emp.id === empleadoSeleccionadoAnalisis);
      if (!empleadoEncontrado) {
        alert('❌ No se encontró el empleado seleccionado en la lista de empleados activos.');
        setCalculandoPlanilla(false);
        return;
      }

      console.log(`🎯🎯🎯 ANÁLISIS INDIVIDUAL INICIADO`);
      console.log(`👤 Empleado seleccionado: ${empleadoEncontrado.nombre_completo} (ID: ${empleadoEncontrado.id})`);
      console.log(`📊 Total empleados activos disponibles: ${empleadosActivosPlanilla.length}`);

      // Confirmación para análisis individual (sin afectar cálculos existentes)
      if (empleadosConBoletasCalculadas.length > 0) {
        const confirmar = window.confirm(
          `🔍 Análisis individual del empleado:\n${empleadoEncontrado.nombre_completo}\n\nEste análisis NO modificará los cálculos existentes en la vista.\nSolo generará logs internos para revisar.\n\n¿Continuar con el análisis?`
        );
        if (!confirmar) {
          setCalculandoPlanilla(false);
          return;
        }
      } else {
        const confirmar = window.confirm(
          `🔍 Análisis individual del empleado:\n${empleadoEncontrado.nombre_completo}\n\nEste análisis generará logs internos para revisar el procesamiento sin afectar la vista.\n\n¿Continuar?`
        );
        if (!confirmar) {
          setCalculandoPlanilla(false);
          return;
        }
      }

      // Construir el array unificado para ANÁLISIS INDIVIDUAL (solo empleado seleccionado)
      const resumenAPIsDisponibles = {
        total_regimenes_laborales: regimenesLaborales.length,
        total_configuraciones_plame: configuracionesPlame.length,
        total_formulas: Array.isArray(formulas) ? formulas.length : 0,
        total_afps: afps.length,
        total_tramos_renta: tramosRenta.length,
        total_conceptos_afectos: conceptosAfectos.length,
        total_conceptos_no_afectan_vacaciones: conceptosNoAfectanVacaciones.length,
        total_conceptos_afectan_licencia_goce_haber: conceptosAfectanLicenciaGoceHaber.length,
        total_conceptos_estaticos: conceptosEstaticos.length,
        total_feriados_pago_doble: feriadosPagoDobleConfig.length,
        tiene_configuracion_tasa_nocturna: Boolean(configuracionTasaNocturnaConfig?.activo),
        horas_tasa_nocturna_config: parseFloat(configuracionTasaNocturnaConfig?.horas_tasa_nocturna ?? 0),
        tiene_configuracion_tareo: !!configuracionTareo,
        tiene_informacion_general: !!informacionGeneral,
        apis_completas: regimenesLaborales.length > 0 && 
                       configuracionesPlame.length > 0 && 
                       Array.isArray(formulas) && formulas.length > 0 && 
                       afps.length > 0 && 
                       !!informacionGeneral && 
                       tramosRenta.length > 0 &&
                       Array.isArray(conceptosEstaticos) &&
                       !!configuracionTareo
      };

      // 🎯 CONSTRUIR DATOS SOLO PARA EL EMPLEADO SELECCIONADO (ANÁLISIS INDIVIDUAL)
      // Solo procesar el empleado seleccionado en lugar de todos los empleados activos
      const empleadosActivosConDatosAPI = [empleadoEncontrado].map((empleado, index) => {
        const datosEmpresa = selectedCompany;
        
        const datosAPIs = {
          regimenesLaborales: regimenesLaborales,
          regimenSeleccionado: regimenesLaborales.find(r => r.id === empleado.regimen_laboral_id),
        construccionCivil: construccionCivilDatos,
          conceptosPlame: configuracionesPlame,
          conceptosIngresos: configuracionesPlame.filter(c => c.clasificacion?.id_tipo === 1),
          conceptosDescuentos: configuracionesPlame.filter(c => c.clasificacion?.id_tipo === 2),
          conceptosAportes: configuracionesPlame.filter(c => c.clasificacion?.id_tipo === 3),
          formulas: formulas,
          formulasIngresos: Array.isArray(formulas) ? formulas.filter(f => f.id_tipo === 1) : [],
          formulasDescuentos: Array.isArray(formulas) ? formulas.filter(f => f.id_tipo === 2) : [],
          formulasAportes: Array.isArray(formulas) ? formulas.filter(f => f.id_tipo === 3) : [],
          afps: afps,
          afpSeleccionada: afps.find(afp => afp.id === empleado.afp_id),
          uit: informacionGeneral.data.uit,
          sueldoMinimo: informacionGeneral.data.sueldo_minimo,
          informacionGeneral: informacionGeneral.data,
          tramosRenta: tramosRenta,
          conceptosAfectosTareos: conceptosAfectos,
          conceptosNoAfectanVacaciones: conceptosNoAfectanVacaciones,
          conceptosAfectanLicenciaGoceHaber: conceptosAfectanLicenciaGoceHaber,
          conceptosEstaticos: conceptosEstaticos,
          conceptosEstaticosIngresos: conceptosEstaticos.filter(c => 
            c.codigo && (c.codigo.startsWith('01') || c.codigo.startsWith('02') || 
                        c.codigo.startsWith('03') || c.codigo.startsWith('04') || 
                        c.codigo.startsWith('05') || c.codigo.startsWith('09') || 
                        c.codigo.startsWith('10') || c.codigo.startsWith('20'))
          ),
          configuracionTareo: configuracionTareo,
          feriadosPagoDoble: feriadosPagoDobleConfig,
          configuracionDescansoLaborado: configuracionDescansoLaboradoConfig,
          configuracionTasaNocturna: configuracionTasaNocturnaConfig,
        };
        
        // ✅ LÓGICA AUTOMÁTICA DE AFP: Si tiene AFP definida, asumir que es AFP
        const afpEncontrada = afps.find(a => a.id === empleado.afp_id);
        const tieneAfp = empleado.afp?.nombre || empleado.afp_nombre || empleado.afp_id || afpEncontrada;
        const sistemaCalculado = tieneAfp ? 'AFP' : (empleado.sistema_pensionario || empleado.tipo_aporte || 'ONP');
        
        const datosSalariales = {
          sueldoBasico: parseFloat(empleado.sueldo_basico) || 0,
          sistemaPensionario: sistemaCalculado, // ✅ Calculado automáticamente basado en AFP
          afp: tieneAfp ? (afpEncontrada?.nombre || empleado.afp?.nombre || empleado.afp_nombre || null) : null,
          tipoAfp: tieneAfp ? (empleado.tipo_afp || empleado.afp?.tipo_afp || afpEncontrada?.tipo || empleado.afp?.tipo || null) : null,
          cuspp: tieneAfp ? (empleado.cuspp || empleado.codigo_cuspp || null) : null,
          regimenLaboral: regimenesLaborales.find(r => r.id === empleado.regimen_laboral_id)?.codigo || null,
          asignacionFamiliar: empleado.asignacion_familiar || false,
          tipoContratacion: empleado.tipo_contratacion || null,
          sueldoInterno: parseFloat(empleado.sueldo_interno) || 0,
          tipoPlanilla: empleado.tipo_planilla || null,
          omitirDescuentosPlameInterna: omitirDescuentosPlameInternaDe(empleado.id),
          periodoGratificacionConsu: periodoGratiConsuDe(empleado.id),
          formaPago: empleado.forma_pago === 'jornal' ? 'jornal' : 'mensual',
          formaPagoPlanilla: formaPagoPlanillaDe(empleado.id) || null,
          fechaDesdeJornal: fechaDesdeJornalDe(empleado.id) || null,
          aplicarDescuentoDominical: valorDominicalApi(descuentoDominicalDe(empleado.id)),
        fechaIngresoInterna: empleado.fecha_ingreso_interna || empleado.fechaIngresoInterna || null,
          comisionTipo: tieneAfp ? (empleado.comision_tipo || afpEncontrada?.comision_tipo || empleado.afp?.comision_tipo || null) : null,
          fechaAfiliacionAfp: tieneAfp ? (empleado.fecha_afiliacion_afp || null) : null
        };
        
        const conceptosInternosSrc = (Array.isArray(empleado.conceptos_internos) ? empleado.conceptos_internos : [])
          .map((c) => {
            const codigo = String(
              c.codigoPlame
              || c.codigo_plame
              || c.codigo
              || c.plame_configuracion?.codigo_plame
              || c.plameConfiguracion?.codigo_plame
              || ''
            );
            return {
              ...c,
              codigo,
              codigo_plame: codigo,
              codigoPlame: codigo,
              descripcion:
                c.descripcion
                || c.concepto
                || c.plame_configuracion?.descripcion
                || c.plameConfiguracion?.descripcion
                || codigo,
              monto: Number(c.monto ?? c.valor ?? c.monto_interna) || 0,
            };
          });
        const conceptosAgrupados = agruparConceptos(empleado.conceptos);
        const fusionInterna = fusionarAjustesEnInterna({
          ingresos: conceptosAgrupados.ingresos,
          descuentos: conceptosAgrupados.descuentos,
          ingresosInternos: conceptosInternosSrc.filter((c) => c.tipo_concepto === 'ingreso'),
          descuentosInternos: conceptosInternosSrc.filter((c) => c.tipo_concepto === 'descuento'),
        });
        const conceptosUsuario = {
          ingresos: conceptosAgrupados.ingresos,
          descuentos: conceptosAgrupados.descuentos,
          aportes: conceptosAgrupados.aportes,
          ingresosInternos: fusionInterna.ingresosInternos,
          descuentosInternos: fusionInterna.descuentosInternos,
          aportesInternos: conceptosInternosSrc.filter(c => c.tipo_concepto === 'aporte'),
        };
        if (fusionInterna.sueldoInternoOverride != null) {
          datosSalariales.sueldoInterno = fusionInterna.sueldoInternoOverride;
        }
        
        const datosEmpleado = {
          id: empleado.id,
          nombres: empleado.nombre_completo?.split(' ').slice(0, 2).join(' ') || '',
          apellidos: empleado.nombre_completo?.split(' ').slice(2).join(' ') || '',
          nombreCompleto: empleado.nombre_completo,
          numeroDocumento: empleado.numero_documento,
          tipoDocumento: empleado.tipo_documento || 'DNI',
          fecha_nacimiento: extraerFechaNacimientoEmpleado(empleado),
          fechaNacimiento: extraerFechaNacimientoEmpleado(empleado),
          fechaIngreso: resolverFechaIngresoEnPlanilla(empleado, planillaReal?.fecha_inicio, planillaReal?.fecha_fin),
          cargo: empleado.cargo,
          areas_de_trabajo: empleado.areas_de_trabajo,
          estado: empleado.estado,
          categoria: empleado.categoria,
          proyecto: empleado.proyecto,
          historial_laboral: empleado.historial_laboral || [],
          ...camposHistorialInternoCalculo(empleado),
          // ✅ INFORMACIÓN BANCARIA
          banco: empleado.banco || null,
          cuenta_bancaria: empleado.cuenta_bancaria || null,
          cci: empleado.cci || null,
          monto_viatico_standard: parseFloat(empleado.monto_viatico_standard) || 0,
          sueldo_basico: parseFloat(empleado.sueldo_basico) || 0,
          telefono: empleado.telefono,
          email: empleado.email,
          direccion: empleado.direccion,
          descuento_descanso: empleado.descuento_descanso,
          nombre_completo: empleado.nombre_completo,
          numero_documento: empleado.numero_documento,
        };
        
        // ⏰ TAREOS DEL EMPLEADO (filtrados por empleado_id Y por período de planilla)
        const tareosEmpleadoCompletos = tareosPeriodo.filter(tareo => tareo.empleado_id === empleado.id);
        const tareosEmpleado = filtrarTareosPlanillaPorHistorial(
          tareosEmpleadoCompletos,
          empleado,
          planillaReal?.fecha_inicio,
          planillaReal?.fecha_fin,
          'plame'
        );
        const tareosEmpleadoInterna = filtrarTareosPlanillaPorHistorial(
          tareosEmpleadoCompletos,
          empleado,
          planillaReal?.fecha_inicio,
          planillaReal?.fecha_fin,
          'interno'
        );
        const autorizacionesEmpleado = autorizacionesPeriodo.filter(autorizacion => autorizacion.empleado_id === empleado.id);
        
        const resumenTareosEmpleado = {
          total_tareos: tareosEmpleado.length, // Ya filtrado por período
          tareos_por_tipo: {},
          dias_trabajados: 0,
          horas_totales: 0,
          proyectos: [...new Set(tareosEmpleado.map(t => t.proyecto?.nombre).filter(Boolean))]
        };
        
        const resumenAutorizacionesEmpleado = {
          total_autorizaciones: autorizacionesEmpleado.length,
          autorizaciones_por_tipo: {},
          total_dias_autorizados: 0,
          total_horas_autorizadas: 0
        };
        
        tareosEmpleado.forEach(tareo => {
          const tipoEvento = tareo.tipo_evento || 'Desconocido';
          resumenTareosEmpleado.tareos_por_tipo[tipoEvento] = (resumenTareosEmpleado.tareos_por_tipo[tipoEvento] || 0) + 1;
          if (tareo.tipo_evento === 'asistio' || tareo.tipo_evento === 'asistencia_completa') {
            resumenTareosEmpleado.dias_trabajados += 1;
          }
          resumenTareosEmpleado.horas_totales += parseFloat(tareo.horas_trabajadas || 0);
        });

        // 💤 CALCULAR DESCANSOS SEMANALES PROPORCIONALES (SOLO DÍAS DEL PERÍODO) - FUNCIÓN DUPLICADA
        const calcularDescansosSemanalesPlanillaDuplicada = () => {
          // ✅ PARA PLANILLAS CERRADAS: usar descuento_descanso individual del empleado
          // ✅ PARA PLANILLAS ABIERTAS: usar configuracionTareo general
          const debeDescontarDescansos = debeDescontarDescansosEmpleado(empleado);
            
          if (!debeDescontarDescansos || tareosEmpleado.length === 0) {
            return [];
          }

          //console.log(`💤 CALCULANDO DESCANSOS SEMANALES PLANILLA DUPLICADA - Empleado: ${empleado.nombre_completo}`);
          //console.log(`💤 Planilla cerrada: ${planillaCerrada ? 'SÍ' : 'NO'}`);
          //console.log(`💤 Valor usado: ${debeDescontarDescansos ? 'ACTIVADO' : 'DESACTIVADO'}`);
          
          // Agrupar tareos por semanas (de lunes a domingo)
          const semanasEmpleado = [];
          let semanaActual = [];
          
          // Formatear tareos para procesamiento
          const tareosFormateados = tareosEmpleado.map(tareo => {
            // ✅ USAR FECHA LOCAL SIN PROBLEMAS DE ZONA HORARIA
            const fechaTexto = tareo.fecha.split('T')[0]; // Obtener solo YYYY-MM-DD
            const [año, mes, dia] = fechaTexto.split('-');
            const fecha = new Date(parseInt(año), parseInt(mes) - 1, parseInt(dia)); // Crear fecha local
            
            const diaSemana = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'][fecha.getDay()];
            const fechaFormateada = fecha.toLocaleDateString('es-PE', { 
              weekday: 'short', 
              day: '2-digit', 
              month: '2-digit' 
            });
            
            return {
              ...tareo,
              fecha: tareo.fecha,
              fechaFormateada,
              diaSemana,
              tipo: tareo.tipo_evento === 'falta' ? 'Falta' : 'Asistió'
            };
          }).sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
          
          tareosFormateados.forEach((tareo, index) => {
            semanaActual.push(tareo);
            
            // Si es domingo O es el último tareo, cerrar la semana
            const esDomingo = tareo.diaSemana === 'Dom';
            const esUltimoTareo = index === tareosFormateados.length - 1;
            
            if (esDomingo || esUltimoTareo) {
              if (semanaActual.length > 0) {
                // Contar faltas en la semana
                const faltasSemana = semanaActual.filter(t => t.tipo === 'Falta').length;
                
                // Determinar días laborables del período (INCLUIR TODA LA SEMANA)
                // Todos los días se consideran laborables porque solo se identifican eventos "falta"
                const diasLaborablesSemana = semanaActual.length;
                
                // Días trabajados efectivos (sin faltas)
                const diasTrabajadosEfectivos = Math.max(0, diasLaborablesSemana - faltasSemana);
                
                // ✅ NUEVA LÓGICA: Descanso base 8h - descuento por faltas (8/7 × faltas)
                const descansoBase = 8;
                const descuentoPorFalta = (8 / 7) * faltasSemana;
                const descansoProporcionado = Math.max(0, descansoBase - descuentoPorFalta);
                
                const fechaInicio = semanaActual[0].fechaFormateada;
                const fechaFin = semanaActual[semanaActual.length - 1].fechaFormateada;
                
                //console.log(`💤 PLANILLA DUPLICADA - Semana ${fechaInicio} - ${fechaFin}:`);
                //console.log(`  • Días laborables: ${diasLaborablesSemana}`);
                //console.log(`  • Faltas: ${faltasSemana}`);
                //console.log(`  • Días trabajados efectivos: ${diasTrabajadosEfectivos}`);
                //console.log(`  • Descanso proporcionado: ${descansoProporcionado.toFixed(2)}h de 8h`);
                
                semanasEmpleado.push({
                  fechaInicio,
                  fechaFin,
                  diasLaborables: diasLaborablesSemana,
                  faltas: faltasSemana,
                  diasTrabajadosEfectivos,
                  descansoCompleto: 8,
                  descansoProporcionado,
                  totalTareos: semanaActual.length
                });
              }
              
              // Reiniciar para la siguiente semana
              semanaActual = [];
            }
          });
          
          //console.log(`💤 Total semanas calculadas PLANILLA DUPLICADA para ${empleado.nombre_completo}: ${semanasEmpleado.length}`);
          return semanasEmpleado;
        };

        // Calcular descansos semanales y agregarlos al resumen
        const descansosSemanales = calcularDescansosSemanalesPlanillaDuplicada();
        resumenTareosEmpleado.descansos_semanales = descansosSemanales;

        autorizacionesEmpleado.forEach(autorizacion => {
          const tipoAutorizacion = `${autorizacion.tipo_autorizacion || 'Desconocido'}${autorizacion.sub_tipo ? ` - ${autorizacion.sub_tipo}` : ''}`;
          resumenAutorizacionesEmpleado.autorizaciones_por_tipo[tipoAutorizacion] = (resumenAutorizacionesEmpleado.autorizaciones_por_tipo[tipoAutorizacion] || 0) + 1;
          resumenAutorizacionesEmpleado.total_dias_autorizados += parseFloat(autorizacion.dias || 0);
          resumenAutorizacionesEmpleado.total_horas_autorizadas += parseFloat(autorizacion.horas || 0);
        });

        const metadatos = {
          origen: 'planilla_detalle_empleado_activo_DUPLICADA',
          timestamp: new Date().toISOString(),
          fuente: 'Empleado activo durante período de planilla - FUNCIÓN DUPLICADA',
          contexto: `Empleado ${index + 1} de ${empleadosActivosPlanilla.length} activos`,
          periodo_planilla: planillaReal ? `${planillaReal.fecha_inicio} - ${planillaReal.fecha_fin}` : 'No definido'
        };
        
        return {
          tipo: 'empleado_activo_con_apis',
          posicion_en_array: index + 5,
          empleado_posicion_activos: index + 1,
          total_empleados_activos: empleadosActivosPlanilla.length,
          empleado_id: empleado.id,
          empleado_nombre: empleado.nombre_completo,
          empleado_posicion: index + 1,
          omitir_descuentos_plame_interna: omitirDescuentosPlameInternaDe(empleado.id),
          periodo_gratificacion_consu: periodoGratiConsuDe(empleado.id),
          forma_pago: empleado.forma_pago === 'jornal' ? 'jornal' : 'mensual',
          forma_pago_planilla: formaPagoPlanillaDe(empleado.id) || null,
          fecha_desde_jornal: fechaDesdeJornalDe(empleado.id) || null,
          aplicar_descuento_dominical: valorDominicalApi(descuentoDominicalDe(empleado.id)),
          ...(esPlanillaModalidadConstruccion(planillaReal) ? {
            fecha_calculo_desde: fechaCalculoDesdeDe(empleado.id) || null,
            fecha_calculo_hasta: fechaCalculoHastaDe(empleado.id) || null,
          } : {}),
          overridesTareoEvento,
          datosEmpresa,
          datosAPIs,
          datosSalariales,
          conceptosUsuario,
          datosEmpleado,
          tareosEmpleado: tareosEmpleado,
          tareosEmpleadoInterna: tareosEmpleadoInterna,
          resumenTareos: resumenTareosEmpleado,
          tasaNocturna: armarTasaNocturnaEmpleado(
            tareosEmpleado,
            empleado,
            configuracionTasaNocturnaConfig,
            configuracionesPlame
          ),
          autorizacionesEmpleado: autorizacionesEmpleado,
          resumenAutorizaciones: resumenAutorizacionesEmpleado,
          liquidaciones_planilla: Array.isArray(empleadoEncontrado.liquidaciones_planilla) ? empleadoEncontrado.liquidaciones_planilla : [],
          gratificaciones_planilla: Array.isArray(empleadoEncontrado.gratificaciones_planilla) ? empleadoEncontrado.gratificaciones_planilla : [],
          metadatos
        };
      });

      // Construir array unificado completo - VERSIÓN DUPLICADA
      const arrayUnificado = [
        {
          tipo: 'metadatos_sistema',
          timestamp: new Date().toISOString(),
          origen: 'planilla_detalle_empleados_activos_DUPLICADA',
          version: '2.0',
          descripcion: 'Array unificado DUPLICADO con empleados activos y todos sus datos API individuales'
        },
        {
          tipo: 'contexto_empresarial',
          empresa: selectedCompany,
          planilla_real: planillaReal,
          tareos_periodo: {
            tareos: tareosPeriodo,
            resumen: resumenTareos,
            total_tareos: tareosPeriodo.length
          },
          autorizaciones_periodo: {
            autorizaciones: autorizacionesPeriodo,
            total_autorizaciones: autorizacionesPeriodo.length
          },
          periodo: {
            fecha_inicio: planillaReal?.fecha_inicio,
            fecha_fin: planillaReal?.fecha_fin,
            planilla_id: planillaReal?.id
          },
          // Viáticos: se informan en planilla/REM pero no afectan neto a pagar
          viaticos_standard: viaticosConfig
            ? {
                activo: Boolean(viaticosConfig.activo),
                plame_configuracion_id: viaticosConfig.plame_configuracion_id || null,
              }
            : null,
          overrides_tareo_evento: overridesTareoEvento,
          configuracion_tareo: configuracionTareo,
        },
        {
          tipo: 'resumen_apis_disponibles',
          ...resumenAPIsDisponibles,
          estado_sistema: resumenAPIsDisponibles.apis_completas ? 'COMPLETO' : 'INCOMPLETO'
        },
        {
          tipo: 'estadisticas_generales',
          empleados: {
            total_empleados_empresa: empleadosConConceptos.length,
            empleados_activos_planilla: 1, // Solo el empleado seleccionado
            empleados_no_activos: empleadosConConceptos.length - 1,
            porcentaje_empleados_activos: empleadosConConceptos.length > 0 ? 
              parseFloat(((1 / empleadosConConceptos.length) * 100).toFixed(1)) : 0,
            // 🎯 INFORMACIÓN ESPECÍFICA DEL ANÁLISIS INDIVIDUAL
            empleado_analizado: empleadoEncontrado.nombre_completo,
            empleado_id_analizado: empleadoEncontrado.id,
            tipo_analisis: 'individual'
          }
        },
        ...empleadosActivosConDatosAPI
      ]; // feriados pago doble: datosAPIs.feriadosPagoDoble (carga en cargarTodosLosDatos)

      // 💤 INICIALIZAR COMPENSACIONES EN EL BACKEND - ANÁLISIS INDIVIDUAL
      // Solo inicializar compensaciones para el empleado seleccionado
      console.log(`📊 ANÁLISIS INDIVIDUAL: Empleado seleccionado preparado: ${empleadoEncontrado.nombre_completo}`);
      console.log(`🔍 ANÁLISIS INDIVIDUAL: Planilla ID: ${planillaReal?.id}`);
      
      if (planillaReal?.id && empleadoEncontrado) {
        const empleadosIds = [empleadoEncontrado.id]; // Solo el empleado seleccionado
        
        try {
          console.log(`💤 FUNCIÓN DUPLICADA: Enviando ${empleadosIds.length} empleados al backend para inicializar compensaciones...`);
          
          const resultadoCompensaciones = await compensacionService.inicializarCompensacionesPlanilla(
            planillaReal.id,
            empleadosIds
          );
          
          if (resultadoCompensaciones.success) {
            const { data } = resultadoCompensaciones;
            if (data.accion === 'creado') {
              console.log(`✅ FUNCIÓN DUPLICADA: Compensaciones creadas: ${data.compensaciones_creadas} registros con horas en 0`);
            } else if (data.accion === 'saltado') {
              console.log(`⏭️ FUNCIÓN DUPLICADA: Compensaciones ya existían: ${data.compensaciones_existentes} registros`);
            }
          } else {
            console.error(`❌ FUNCIÓN DUPLICADA: Error al inicializar compensaciones: ${resultadoCompensaciones.error}`);
            // No detener el flujo, solo registrar el error
          }
          
        } catch (error) {
          console.error(`❌ FUNCIÓN DUPLICADA: Error inesperado al inicializar compensaciones:`, error);
          // No detener el flujo, continuar con el cálculo
        }
      } else {
        console.log(`⚠️ FUNCIÓN DUPLICADA: No se inicializaron compensaciones: planilla_id=${planillaReal?.id}, empleados=${empleadosActivosPlanilla.length}`);
      }

      // 💤 CARGAR COMPENSACIONES ACTUALES PARA EL ARRAY UNIFICADO - FUNCIÓN DUPLICADA
      let compensacionesActuales = [];
      if (planillaReal?.id) {
        try {
          console.log(`📊 FUNCIÓN DUPLICADA: Cargando compensaciones actuales para planilla ${planillaReal.id}...`);
          
          const resultadoCompensacionesActuales = await compensacionService.obtenerCompensacionesPorPlanilla(planillaReal.id);
          
          if (resultadoCompensacionesActuales.success) {
            compensacionesActuales = resultadoCompensacionesActuales.data;
            console.log(`✅ FUNCIÓN DUPLICADA: Compensaciones cargadas: ${compensacionesActuales.length} registros | Total horas: ${resultadoCompensacionesActuales.totalHoras}h`);
          } else {
            console.error(`❌ FUNCIÓN DUPLICADA: Error al cargar compensaciones: ${resultadoCompensacionesActuales.error}`);
          }
        } catch (error) {
          console.error(`❌ FUNCIÓN DUPLICADA: Error inesperado al cargar compensaciones:`, error);
        }
      }

      // 📋 AGREGAR COMPENSACIONES AL ARRAY UNIFICADO - FUNCIÓN DUPLICADA
      const seccionCompensaciones = {
        tipo: 'compensaciones_meses_pasados',
        planilla_id: planillaReal?.id,
        total_compensaciones: compensacionesActuales.length,
        total_horas_compensadas: compensacionesActuales.reduce((sum, comp) => sum + parseFloat(comp.horas_compensadas || 0), 0),
        compensaciones_activas: compensacionesActuales.filter(comp => parseFloat(comp.horas_compensadas || 0) > 0).length,
        compensaciones: compensacionesActuales,
        resumen_por_empleado: compensacionesActuales.reduce((acc, comp) => {
          acc[comp.empleado_id] = {
            horas_compensadas: parseFloat(comp.horas_compensadas || 0),
            empleado_nombre: comp.empleado?.nombre_completo || 'Sin nombre',
            compensacion_id: comp.id
          };
          return acc;
        }, {}),
        timestamp: new Date().toISOString(),
        metadatos: {
          origen: 'procesamiento_planilla_DUPLICADA',
          descripcion: 'Compensaciones de meses pasados cargadas para incluir en cálculos - FUNCIÓN DUPLICADA',
          fecha_carga: new Date().toISOString()
        }
      };

      // Insertar compensaciones en el array unificado
      arrayUnificado.splice(4, 0, seccionCompensaciones);

      console.log(`💤 FUNCIÓN DUPLICADA: Compensaciones agregadas al array unificado:`);
      console.log(`  📊 Total compensaciones: ${seccionCompensaciones.total_compensaciones}`);
      console.log(`  ⏰ Total horas: ${seccionCompensaciones.total_horas_compensadas}h`);
      console.log(`  ✅ Compensaciones activas: ${seccionCompensaciones.compensaciones_activas}`);

      // 🚀 LLAMAR AL SERVICE DE PROCESAMIENTO - FUNCIÓN DUPLICADA
      console.log('🚀🚀🚀 FUNCIÓN DUPLICADA: ENVIANDO ARRAY UNIFICADO AL SERVICE');
      const resultado = await planillaCalculoService.procesarEmpleadosParaPlanilla(arrayUnificado);
      
      if (resultado.success) {
        const stats = planillaCalculoService.obtenerEstadisticasResumen(resultado.data);
        
        // ✅ EXTRAER EMPLEADOS CON BOLETAS CALCULADAS Y ACTUALIZAR VISTA
        const empleadosConBoletas = resultado.data.empleadosProcesados.map(empleadoProcesado => {
          const boleta = empleadoProcesado.boleta;
          
          if (!boleta || !boleta.success || !boleta.data) {
            return null;
          }
          
          // Transformar los datos de la boleta al formato de la vista
          const datosOriginal = empleadosActivosPlanilla.find(emp => emp.id === empleadoProcesado.empleado_id);
          
          if (!datosOriginal) {
            return null;
          }

          // 🔍 BUSCAR DATOS ACTUALIZADOS CON RESUMEN DE TAREOS
          const datosActualizados = resultado.data.empleadosProcesados.find(ep => ep.empleado_id === empleadoProcesado.empleado_id);
          const resumenTareosActualizado = datosActualizados?.resumenTareos || datosOriginal?.resumenTareos;

          // Convertir los conceptos de la boleta al formato de conceptos de empleado
          const conceptosCalculados = {
            ingresos: boleta.data.dataIngresos?.map(ingreso => ({
              id: ingreso.id_concepto?.id,
              codigo_plame: ingreso.id_concepto?.codigo_plame,
              nombre: ingreso.id_concepto?.descripcion || ingreso.id_concepto?.nombre,
              tipo_concepto: 'ingreso',
              monto: parseFloat(ingreso.valor) || 0,
              origen: 'calculado_duplicada',
              base_calculo: parseFloat(ingreso.base_calculo) || 0,
              excluirBoletaOrdinaria: Boolean(ingreso.excluir_boleta_ordinaria || ingreso.excluirBoletaOrdinaria),
              origenCalculo: ingreso.origen_calculo || ingreso.origenCalculo || null,
            })) || [],
            descuentos: boleta.data.dataDescuentos?.map(descuento => ({
              id: descuento.id_concepto?.id,
              codigo_plame: descuento.id_concepto?.codigo_plame,
              nombre: descuento.id_concepto?.descripcion || descuento.id_concepto?.nombre,
              tipo_concepto: 'descuento',
              monto: parseFloat(descuento.valor) || 0,
              origen: 'calculado_duplicada',
              base_calculo: parseFloat(descuento.base_calculo) || 0
            })) || [],
            aportes: boleta.data.dataAportes?.map(aporte => ({
              id: aporte.id_concepto?.id,
              codigo_plame: aporte.id_concepto?.codigo_plame,
              nombre: aporte.id_concepto?.descripcion || aporte.id_concepto?.nombre,
              tipo_concepto: 'aporte',
              monto: parseFloat(aporte.valor) || 0,
              origen: 'calculado_duplicada',
              base_calculo: parseFloat(aporte.base_calculo) || 0
            })) || []
          };
          
          // Crear empleado actualizado con conceptos calculados
          return {
            ...datosOriginal,
            conceptos: [...conceptosCalculados.ingresos, ...conceptosCalculados.descuentos, ...conceptosCalculados.aportes],
            conceptos_separados: conceptosCalculados,
            boleta_calculada: boleta,
            estado_procesamiento: 'calculado_duplicada',
            timestamp_calculo: new Date().toISOString(),
            // ✅ AGREGAR TOTAL DE REGISTROS DE TAREOS PARA BACKEND
            total_registros_tareos: resumenTareosActualizado?.total_tareos || 0,
            // ✅ AGREGAR CONFIGURACIÓN DE TAREOS CON CADA EMPLEADO
            configuracion_tareo: configuracionTareo
          };
        }).filter(emp => emp !== null);
        
        // 🔍 SOLO LOGS INTERNOS - NO ACTUALIZAR LA VISTA
        // Esta función es solo para análisis interno y logs, no modifica la interfaz
        console.log(`🎯🎯🎯 ANÁLISIS INDIVIDUAL COMPLETADO - SOLO LOGS`);
        console.log(`👤 Empleado analizado: ${empleadoEncontrado.nombre_completo}`);
        console.log(`📊 Datos procesados:`, empleadosConBoletas);
        console.log(`📈 Estadísticas:`, stats);
        
        alert(`🔍 ANÁLISIS INDIVIDUAL COMPLETADO (SOLO LOGS)\n\n` +
              `👤 Empleado: ${empleadoEncontrado.nombre_completo}\n` +
              `✅ Procesado exitosamente: ${stats.procesadosExitosos}/${stats.totalEmpleados}\n` +
              `❌ Errores: ${stats.procesadosConErrores}\n` +
              `📊 Porcentaje de éxito: ${stats.porcentajeExito}%\n` +
              `⏱️ Duración: ${stats.duracionSegundos}s\n` +
              `🚀 Velocidad: ${stats.empleadosPorSegundo} empleados/segundo\n\n` +
              `🔍 NOTA: Este análisis NO modifica la vista.\n` +
              `📋 Revisa la consola para ver los logs detallados del procesamiento.`);
        
      } else {
        alert(`❌ Error en procesamiento (FUNCIÓN DUPLICADA):\n${resultado.error}`);
      }
      
    } catch (error) {
      alert(`❌ Error general (FUNCIÓN DUPLICADA): ${error.message}`);
    } finally {
      setCalculandoPlanilla(false);
    }
  };

    //console.log('🔍 ESTADO LOADING:', loading);
  //console.log('📊 EMPLEADOS ACTUALES:', empleados);
  //console.log('📊 EMPLEADOS LENGTH:', empleados.length);
  
  if (loading) {
    //console.log('⏳⏳⏳ MOSTRANDO PANTALLA DE LOADING CON PROGRESO');
    const totalEfectivo = Math.max(
      cargandoProgreso.total || 1,
      cargandoProgreso.progreso || 0,
      cargandoProgreso.apisCompletadas?.length || 0
    );
    const porcentajeProgreso = Math.min(
      100,
      Math.round((cargandoProgreso.progreso / totalEfectivo) * 100)
    );
    const tiempoTranscurrido = cargandoProgreso.tiempoInicio ? 
      Math.round((Date.now() - cargandoProgreso.tiempoInicio) / 1000) : 0;
    
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="max-w-md w-full mx-4">
          {/* Card principal */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            {/* Header */}
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">Cargando Planilla</h2>
              <p className="text-gray-600">Preparando datos para la visualización...</p>
            </div>

            {/* Barra de progreso */}
            <div className="mb-6">
              <div className="flex justify-between items-center mb-2">
                <span className="text-sm font-medium text-gray-700">
                  {cargandoProgreso.progreso}/{totalEfectivo} APIs cargadas
                </span>
                <span className="text-sm font-medium text-teal-600">{porcentajeProgreso}%</span>
              </div>
              
              <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
                <div 
                  className="bg-gradient-to-r from-teal-500 to-teal-600 h-3 rounded-full transition-all duration-500 ease-out"
                  style={{ width: `${porcentajeProgreso}%` }}
                ></div>
              </div>
            </div>

            {/* API actual */}
            {cargandoProgreso.apiActual && (
              <div className="flex items-center justify-center space-x-2 mb-4">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-teal-500"></div>
                <span className="text-sm text-gray-600">{cargandoProgreso.apiActual}</span>
              </div>
            )}

            {/* APIs completadas - mostrar discretamente */}
            {cargandoProgreso.apisCompletadas.length > 0 && (
              <div className="border-t pt-4">
                <p className="text-xs text-gray-500 mb-2">APIs cargadas:</p>
                <div className="flex flex-wrap gap-1">
                  {cargandoProgreso.apisCompletadas.map((api, index) => (
                    <span
                      key={index}
                      className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-green-100 text-green-800"
                    >
                      ✓ {api.replace(/[📋🏦ℹ️🧮📊⚙️💰📈👥🏖️🖼️🔒🏛️🔧]/g, '').trim()}
                    </span>
                  ))}
                </div>
                
                {/* Tiempo transcurrido */}
                {tiempoTranscurrido > 0 && (
                  <p className="text-xs text-gray-400 mt-2">
                    Tiempo transcurrido: {tiempoTranscurrido}s
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
  
  // 🚀 PROCESAMIENTO AUTOMÁTICO DE PLANILLA AL CARGAR
  const ejecutarProcesamientoAutomatico = async () => {
    // Verificar condiciones para procesamiento automático
    if (procesamientoAutomaticoEjecutado || 
        empleadosConBoletasCalculadas.length > 0 || 
        loading || 
        !planillaReal || 
        empleadosActivosPlanilla.length === 0) {
      return;
    }
    
    try {
      setProcesamientoAutomaticoEjecutado(true);
      
      await procesarEmpleadosConPlanilla({ omitirConfirmacion: autoRecerrandoJatsa });
      
    } catch (error) {
      // Resetear el flag para permitir reintento manual
      setProcesamientoAutomaticoEjecutado(false);
    }
  };

  // Ejecutar procesamiento automático cuando se cumplan las condiciones
  // ✅ PROCESAMIENTO AUTOMÁTICO HABILITADO - BOTÓN MANUAL REMOVIDO
  // 🔒 EXCLUIR PLANILLAS CERRADAS DEL PROCESAMIENTO AUTOMÁTICO
  if (!procesamientoAutomaticoEjecutado && 
      !loading && 
      planillaReal && 
      !planillaCerrada &&  // ← 🎯 LÍNEA CRÍTICA AGREGADA
      empleadosActivosPlanilla.length > 0 && 
      empleadosConBoletasCalculadas.length === 0) {
    
    // Usar setTimeout para evitar bloquear el render
    setTimeout(() => {
      ejecutarProcesamientoAutomatico();
    }, 100);
  }

  // 📊 FUNCIÓN PARA EXPORTAR NETOS A PAGAR A EXCEL (ExcelJS)
  const exportarNetosExcel = async () => {
    try {
      setGenerandoPDF(true);
      
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Netos a Pagar');

      const headerStyle = {
        font: { bold: true, color: { argb: 'FFFFFFFF' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF059669' } },
        alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      };
      const headerStylePlame = {
        ...headerStyle,
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0F766E' } },
      };
      const headerStyleInterna = {
        ...headerStyle,
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFB45309' } },
      };

      const esPlanillaRHNetos = planillaParaVista?.modalidad_planilla === 'planilla_rh' ||
        (planillaParaVista?.nombre && (String(planillaParaVista.nombre).toUpperCase().trim() === 'RH' || String(planillaParaVista.nombre).toUpperCase().includes('RH')));
      const conDualNetos = Boolean(planillaAlternativaActiva);
      const numColumnasBase = esPlanillaRHNetos ? 11 : 12;
      const numColumnas = conDualNetos ? numColumnasBase + 2 : numColumnasBase + 1;

      const titleRow = worksheet.addRow([conDualNetos ? 'Netos a Pagar (PLAME + Interna)' : 'Netos a Pagar']);
      titleRow.height = 24;
      worksheet.mergeCells(1, 1, 1, numColumnas);
      const titleCell = titleRow.getCell(1);
      titleCell.font = { bold: true, size: 14 };
      titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
      titleCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF3F4F6' } };

      const periodoInicio = planillaParaVista.fecha_inicio ? formatDateToDDMMYYYY(planillaParaVista.fecha_inicio) : 'N/A';
      const periodoFin = planillaParaVista.fecha_fin ? formatDateToDDMMYYYY(planillaParaVista.fecha_fin) : 'N/A';
      const fechaGen = new Date().toLocaleDateString('es-PE');
      const subtitleRow = worksheet.addRow([`Período: ${periodoInicio} - ${periodoFin}  |  Fecha de generación: ${fechaGen}`]);
      worksheet.mergeCells(2, 1, 2, numColumnas);
      subtitleRow.getCell(1).font = { size: 11, italic: true };
      subtitleRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
      worksheet.addRow([]);

      const headersBase = esPlanillaRHNetos
        ? ['DNI', 'Empleado', 'Fecha inicio', 'Fecha cese', 'Proyecto', 'Área', 'Cargo', 'Categoría', 'Banco', 'Cuenta Bancaria', 'CCI']
        : ['DNI', 'Empleado', 'Fecha inicio', 'Fecha cese', 'Proyecto', 'Área', 'Cargo', 'Categoría', 'Régimen', 'Banco', 'Cuenta Bancaria', 'CCI'];
      const headersNetos = conDualNetos
        ? [...headersBase, 'Neto PLAME', 'Neto Interna']
        : [...headersBase, 'Neto a Pagar'];
      const headerRow = worksheet.addRow(headersNetos);
      headerRow.height = 22;
      headerRow.eachCell((cell, colNumber) => {
        if (conDualNetos && colNumber === numColumnas - 1) Object.assign(cell, headerStylePlame);
        else if (conDualNetos && colNumber === numColumnas) Object.assign(cell, headerStyleInterna);
        else Object.assign(cell, headerStyle);
      });

      const widthsBase = esPlanillaRHNetos
        ? [12, 28, 12, 12, 32, 22, 28, 14, 20, 22, 22]
        : [12, 28, 12, 12, 32, 22, 28, 14, 18, 20, 22, 22];
      const widthsNetos = conDualNetos ? [...widthsBase, 16, 16] : [...widthsBase, 16];
      widthsNetos.forEach((w, i) => { worksheet.getColumn(i + 1).width = w; });

      let sumaPlame = 0;
      let sumaInterna = 0;
      let sumaUnico = 0;

      empleadosParaVista.forEach((empleado, index) => {
        const tipo = String(empleado?.tipo_planilla || '').toLowerCase();
        const esSoloInterna = tipo === 'solo_interna';
        const tieneInterna = empleadoTieneBoletaInterna(empleado) || esSoloInterna;
        const netoPlame = esSoloInterna ? null : Number(empleado.totales?.netoAPagar ?? 0);
        const netoInterna = tieneInterna ? Number(empleado.totalesInternos?.netoAPagar ?? 0) : null;
        if (netoPlame != null) sumaPlame += netoPlame;
        if (netoInterna != null) sumaInterna += netoInterna;
        sumaUnico += Number(empleado.totales?.netoAPagar ?? 0);

        const baseData = esPlanillaRHNetos
          ? [
              empleado.documento,
              empleado.nombre,
              textoFechaInicioReferencia(empleado) || '',
              textoFechaCeseReferencia(empleado) || '',
              empleado.proyecto || 'Sin proyecto',
              empleado.areas_de_trabajo || 'Sin área',
              empleado.cargo,
              empleado.categoria,
              empleado.banco ?? '',
              empleado.cuenta_bancaria ?? '',
              empleado.cci ?? '',
            ]
          : [
              empleado.documento,
              empleado.nombre,
              textoFechaInicioReferencia(empleado) || '',
              textoFechaCeseReferencia(empleado) || '',
              empleado.proyecto || 'Sin proyecto',
              empleado.areas_de_trabajo || 'Sin área',
              empleado.cargo,
              empleado.categoria,
              empleado.regimenLaboral,
              empleado.banco ?? '',
              empleado.cuenta_bancaria ?? '',
              empleado.cci ?? '',
            ];
        const rowData = conDualNetos
          ? [...baseData, netoPlame == null ? '' : netoPlame, netoInterna == null ? '' : netoInterna]
          : [...baseData, Number(empleado.totales?.netoAPagar ?? 0)];
        const row = worksheet.addRow(rowData);
        row.eachCell((cell, colNumber) => {
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          cell.alignment = { vertical: 'middle', wrapText: true };
          const esColNeto = conDualNetos
            ? (colNumber === numColumnas - 1 || colNumber === numColumnas)
            : colNumber === numColumnas;
          if (esColNeto && cell.value !== '' && cell.value != null) {
            cell.numFmt = '"S/"#,##0.00';
            cell.font = { bold: true };
            cell.alignment.horizontal = 'right';
          }
          if (index % 2 === 1) {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF9FAFB' } };
          }
        });
      });

      const celdasVaciasTotal = Array(numColumnasBase - 1).fill('');
      const totalRowData = conDualNetos
        ? [...celdasVaciasTotal, 'TOTALES:', Number(sumaPlame), Number(sumaInterna)]
        : [...celdasVaciasTotal, 'TOTAL GENERAL:', Number(totalesGenerales?.netoTotal ?? sumaUnico)];
      const totalRow = worksheet.addRow(totalRowData);
      totalRow.height = 22;
      totalRow.eachCell((cell, colNumber) => {
        cell.font = { bold: true };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFECFDF5' } };
        cell.border = { top: { style: 'medium' }, left: { style: 'thin' }, bottom: { style: 'medium' }, right: { style: 'thin' } };
        cell.alignment = { vertical: 'middle' };
        if (colNumber === numColumnasBase) cell.alignment.horizontal = 'right';
        if (colNumber > numColumnasBase) {
          cell.numFmt = '"S/"#,##0.00';
          cell.alignment.horizontal = 'right';
        }
      });

      worksheet.addRow([]);
      const pieRow = worksheet.addRow([`Total de empleados: ${empleadosParaVista.length}  |  Generado por: Sistema de Planillas - ${selectedCompany?.name || 'Empresa'}`]);
      worksheet.mergeCells(pieRow.number, 1, pieRow.number, numColumnas);
      pieRow.getCell(1).font = { size: 10, italic: true };
      pieRow.getCell(1).alignment = { horizontal: 'center' };

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const fechaActual = new Date().toISOString().split('T')[0];
      const periodoNombre = (planillaParaVista.periodo || planillaParaVista.nombre || 'Planilla').replace(/\s+/g, '_');
      link.download = `Netos_a_Pagar_${periodoNombre}_${fechaActual}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      alert('Excel generado exitosamente');
    } catch (error) {
      console.error('Error generando Excel:', error);
      alert('Error al generar el Excel: ' + error.message);
    } finally {
      setGenerandoPDF(false);
    }
  };

  // 📄 FUNCIÓN PARA EXPORTAR CONSOLIDADO POR CONCEPTOS A PDF - MEJORADA
  const exportarConceptosPDF = async () => {
    try {
      setGenerandoConceptosPDF(true);
      
      // Haberes / boleta: sin gratificaciones de declaración PLAME
      const conceptosUnicos = obtenerConceptosUnicos(empleadosParaVistaHaberes);
      
      // Calcular el ancho dinámicamente basado en el número de conceptos
      const totalConceptos = conceptosUnicos.ingresos.length + conceptosUnicos.descuentos.length + conceptosUnicos.aportes.length;
      const anchoMinimo = 200; // Para empleado y totales
      const anchoPorConcepto = 70; // Ancho por cada concepto
      const anchoCalculado = anchoMinimo + (totalConceptos * anchoPorConcepto) + 300; // +300 para columnas de totales
      const anchoFinal = Math.max(1400, anchoCalculado); // Mínimo 1400px
      
      // Crear un contenedor temporal para el contenido del PDF
      const contenedorTemporal = document.createElement('div');
      contenedorTemporal.style.position = 'absolute';
      contenedorTemporal.style.left = '-9999px';
      contenedorTemporal.style.top = '0';
      contenedorTemporal.style.width = `${anchoFinal}px`;
      contenedorTemporal.style.backgroundColor = 'white';
      contenedorTemporal.style.padding = '15px';
      contenedorTemporal.style.fontFamily = 'Arial, sans-serif';
      
      // Generar el contenido HTML para el PDF
      let headerIngresos = '';
      let headerDescuentos = '';
      let headerAportes = '';
      let filasEmpleados = '';
      let filaTotales = '';
      
      // Crear headers dinámicos con texto horizontal y mejor legibilidad
      conceptosUnicos.ingresos.forEach(concepto => {
        const textoCorto = concepto.descripcion.length > 12 ? 
          concepto.descripcion.substring(0, 12) + '...' : 
          concepto.descripcion;
        headerIngresos += `<th style="border: 1px solid #d1d5db; padding: 6px 4px; text-align: center; font-weight: bold; color: #065f46; background-color: #d1fae5; font-size: 8px; min-width: 65px; max-width: 65px; word-wrap: break-word; line-height: 1.1;" title="${concepto.descripcion}">${textoCorto}</th>`;
      });
      
      conceptosUnicos.descuentos.forEach(concepto => {
        const textoCorto = concepto.descripcion.length > 12 ? 
          concepto.descripcion.substring(0, 12) + '...' : 
          concepto.descripcion;
        headerDescuentos += `<th style="border: 1px solid #d1d5db; padding: 6px 4px; text-align: center; font-weight: bold; color: #7f1d1d; background-color: #fee2e2; font-size: 8px; min-width: 65px; max-width: 65px; word-wrap: break-word; line-height: 1.1;" title="${concepto.descripcion}">${textoCorto}</th>`;
      });
      
      conceptosUnicos.aportes.forEach(concepto => {
        const textoCorto = concepto.descripcion.length > 12 ? 
          concepto.descripcion.substring(0, 12) + '...' : 
          concepto.descripcion;
        headerAportes += `<th style="border: 1px solid #d1d5db; padding: 6px 4px; text-align: center; font-weight: bold; color: #1e3a8a; background-color: #dbeafe; font-size: 8px; min-width: 65px; max-width: 65px; word-wrap: break-word; line-height: 1.1;" title="${concepto.descripcion}">${textoCorto}</th>`;
      });
      
      // Crear filas de empleados
      empleadosParaVistaHaberes.forEach((empleado, index) => {
        let filaIngresos = '';
        let filaDescuentos = '';
        let filaAportes = '';
        
        // Ingresos
        conceptosUnicos.ingresos.forEach(conceptoUnico => {
          const concepto = empleado.conceptos?.ingresos?.find(c => 
            c.descripcion?.trim().toLowerCase() === conceptoUnico.descripcion?.trim().toLowerCase()
          );
          const monto = concepto?.monto || 0;
          filaIngresos += `<td style="border: 1px solid #d1d5db; padding: 4px 2px; text-align: center; font-size: 7px; color: ${monto > 0 ? '#065f46' : '#9ca3af'}; min-width: 65px;">${monto > 0 ? formatCurrency(monto) : '-'}</td>`;
        });
        
        // Descuentos
        conceptosUnicos.descuentos.forEach(conceptoUnico => {
          const concepto = empleado.conceptos?.descuentos?.find(c => 
            c.descripcion?.trim().toLowerCase() === conceptoUnico.descripcion?.trim().toLowerCase()
          );
          const monto = concepto?.monto || 0;
          filaDescuentos += `<td style="border: 1px solid #d1d5db; padding: 4px 2px; text-align: center; font-size: 7px; color: ${monto > 0 ? '#7f1d1d' : '#9ca3af'}; min-width: 65px;">${monto > 0 ? formatCurrency(monto) : '-'}</td>`;
        });
        
        // Aportes
        conceptosUnicos.aportes.forEach(conceptoUnico => {
          const concepto = empleado.conceptos?.aportes?.find(c => 
            c.descripcion?.trim().toLowerCase() === conceptoUnico.descripcion?.trim().toLowerCase()
          );
          const monto = concepto?.monto || 0;
          filaAportes += `<td style="border: 1px solid #d1d5db; padding: 4px 2px; text-align: center; font-size: 7px; color: ${monto > 0 ? '#1e3a8a' : '#9ca3af'}; min-width: 65px;">${monto > 0 ? formatCurrency(monto) : '-'}</td>`;
        });
        
        // Nombre del empleado más compacto
        const nombreCorto = empleado.nombre.length > 25 ? 
          empleado.nombre.substring(0, 25) + '...' : 
          empleado.nombre;
        
        filasEmpleados += `
          <tr style="background-color: ${index % 2 === 0 ? '#ffffff' : '#f9fafb'};">
            <td style="border: 1px solid #d1d5db; padding: 4px 6px; color: #111827; font-weight: 500; font-size: 8px; min-width: 150px; max-width: 150px; line-height: 1.2;">${nombreCorto}<br><span style="color: #6b7280; font-size: 7px;">${empleado.categoria} • ${empleado.documento}</span></td>
            ${filaIngresos}
            <td style="border: 1px solid #d1d5db; padding: 4px; text-align: center; color: #065f46; font-weight: bold; background-color: #d1fae5; font-size: 8px; min-width: 80px;">${formatCurrency(empleado.totales.totalIngresos)}</td>
            ${filaDescuentos}
            <td style="border: 1px solid #d1d5db; padding: 4px; text-align: center; color: #7f1d1d; font-weight: bold; background-color: #fee2e2; font-size: 8px; min-width: 80px;">${formatCurrency(empleado.totales.totalDescuentos)}</td>
            <td style="border: 1px solid #d1d5db; padding: 4px; text-align: center; color: #0f766e; font-weight: bold; background-color: #ccfbf1; font-size: 8px; min-width: 80px;">${formatCurrency(empleado.totales.netoAPagar)}</td>
            ${filaAportes}
          </tr>
        `;
      });
      
      // Crear fila de totales
      let totalesIngresos = '';
      let totalesDescuentos = '';
      let totalesAportes = '';
      
      conceptosUnicos.ingresos.forEach(conceptoUnico => {
        const total = empleadosParaVistaHaberes.reduce((sum, emp) => {
          const concepto = emp.conceptos?.ingresos?.find(c => 
            c.descripcion?.trim().toLowerCase() === conceptoUnico.descripcion?.trim().toLowerCase()
          );
          return sum + (concepto?.monto || 0);
        }, 0);
        totalesIngresos += `<td style="border: 1px solid #d1d5db; padding: 4px 2px; text-align: center; font-weight: bold; color: #065f46; background-color: #a7f3d0; font-size: 7px; min-width: 65px;">${formatCurrency(total)}</td>`;
      });
      
      conceptosUnicos.descuentos.forEach(conceptoUnico => {
        const total = empleadosParaVistaHaberes.reduce((sum, emp) => {
          const concepto = emp.conceptos?.descuentos?.find(c => 
            c.descripcion?.trim().toLowerCase() === conceptoUnico.descripcion?.trim().toLowerCase()
          );
          return sum + (concepto?.monto || 0);
        }, 0);
        totalesDescuentos += `<td style="border: 1px solid #d1d5db; padding: 4px 2px; text-align: center; font-weight: bold; color: #7f1d1d; background-color: #fca5a5; font-size: 7px; min-width: 65px;">${formatCurrency(total)}</td>`;
      });
      
      conceptosUnicos.aportes.forEach(conceptoUnico => {
        const total = empleadosParaVistaHaberes.reduce((sum, emp) => {
          const concepto = emp.conceptos?.aportes?.find(c => 
            c.descripcion?.trim().toLowerCase() === conceptoUnico.descripcion?.trim().toLowerCase()
          );
          return sum + (concepto?.monto || 0);
        }, 0);
        totalesAportes += `<td style="border: 1px solid #d1d5db; padding: 4px 2px; text-align: center; font-weight: bold; color: #1e3a8a; background-color: #93c5fd; font-size: 7px; min-width: 65px;">${formatCurrency(total)}</td>`;
      });
      
      filaTotales = `
        <tr style="background-color: #f3f4f6; font-weight: bold;">
          <td style="border: 1px solid #d1d5db; padding: 4px 6px; text-align: center; color: #374151; font-weight: bold; font-size: 8px; min-width: 150px;">TOTALES</td>
          ${totalesIngresos}
          <td style="border: 1px solid #d1d5db; padding: 4px; text-align: center; color: white; font-weight: bold; background-color: #047857; font-size: 8px; min-width: 80px;">${formatCurrency(totalesGenerales.totalIngresos)}</td>
          ${totalesDescuentos}
          <td style="border: 1px solid #d1d5db; padding: 4px; text-align: center; color: white; font-weight: bold; background-color: #dc2626; font-size: 8px; min-width: 80px;">${formatCurrency(totalesGenerales.totalDescuentos)}</td>
          <td style="border: 1px solid #d1d5db; padding: 4px; text-align: center; color: white; font-weight: bold; background-color: #0d9488; font-size: 8px; min-width: 80px;">${formatCurrency(totalesGenerales.netoTotal)}</td>
          ${totalesAportes}
        </tr>
      `;
      
      contenedorTemporal.innerHTML = `
        <div style="text-align: center; margin-bottom: 15px;">
          <h1 style="color: #1f2937; margin-bottom: 6px; font-size: 16px; font-weight: bold;">Consolidado por Conceptos</h1>
          <h2 style="color: #6b7280; font-size: 12px; margin-bottom: 3px; font-weight: 600;">${planillaParaVista.periodo || planillaParaVista.nombre || 'Planilla'}</h2>
          <p style="color: #6b7280; font-size: 10px; margin: 2px 0;">Período: ${planillaParaVista.fecha_inicio ? formatDateToDDMMYYYY(planillaParaVista.fecha_inicio) : 'N/A'} - ${planillaParaVista.fecha_fin ? formatDateToDDMMYYYY(planillaParaVista.fecha_fin) : 'N/A'}</p>
          <p style="color: #6b7280; font-size: 10px; margin: 2px 0;">Fecha de generación: ${new Date().toLocaleDateString('es-PE')}</p>
        </div>
        
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px;">
          <thead>
            <tr>
              <th style="border: 1px solid #d1d5db; padding: 6px; text-align: center; font-weight: bold; color: #374151; background-color: #f9fafb; font-size: 8px; min-width: 150px; max-width: 150px;">Empleado</th>
              ${headerIngresos}
              <th style="border: 1px solid #d1d5db; padding: 6px; text-align: center; font-weight: bold; color: white; background-color: #047857; font-size: 8px; min-width: 80px;">Total<br>Ingresos</th>
              ${headerDescuentos}
              <th style="border: 1px solid #d1d5db; padding: 6px; text-align: center; font-weight: bold; color: white; background-color: #dc2626; font-size: 8px; min-width: 80px;">Total<br>Descuentos</th>
              <th style="border: 1px solid #d1d5db; padding: 6px; text-align: center; font-weight: bold; color: white; background-color: #0d9488; font-size: 8px; min-width: 80px;">Neto a<br>Pagar</th>
              ${headerAportes}
            </tr>
          </thead>
          <tbody>
            ${filasEmpleados}
            ${filaTotales}
          </tbody>
        </table>
        
        <div style="margin-top: 10px; text-align: center; color: #6b7280; font-size: 8px; line-height: 1.3;">
          <p style="margin: 2px 0;">Total de empleados: ${empleadosParaVista.length} | Conceptos: ${totalConceptos} (${conceptosUnicos.ingresos.length} ingresos, ${conceptosUnicos.descuentos.length} descuentos, ${conceptosUnicos.aportes.length} aportes)</p>
          <p style="margin: 2px 0;">Generado por: Sistema de Planillas - ${selectedCompany?.name || 'Empresa'}</p>
        </div>
      `;
      
      document.body.appendChild(contenedorTemporal);
      
      // Usar html2canvas para convertir el contenido a imagen con mayor resolución
      const canvas = await html2canvas(contenedorTemporal, {
        scale: 2, // Mayor resolución
        useCORS: true,
        backgroundColor: '#ffffff',
        width: contenedorTemporal.scrollWidth,
        height: contenedorTemporal.scrollHeight,
        logging: false
      });
      
      // Remover el contenedor temporal
      document.body.removeChild(contenedorTemporal);
      
      // Calcular el tamaño del PDF basado en el contenido real
      const imgData = canvas.toDataURL('image/png', 1.0);
      const canvasWidthMM = (canvas.width * 25.4) / 96; // Convertir px a mm
      const canvasHeightMM = (canvas.height * 25.4) / 96; // Convertir px a mm
      
      // Crear PDF con dimensiones personalizadas para ajustarse al contenido
      const pdfWidth = Math.max(canvasWidthMM, 210); // Mínimo A4 portrait width
      const pdfHeight = Math.max(canvasHeightMM, 297); // Mínimo A4 portrait height
      
      const pdf = new jsPDF({
        orientation: pdfWidth > pdfHeight ? 'landscape' : 'portrait',
        unit: 'mm',
        format: [pdfWidth, pdfHeight]
      });
      
      // Calcular la escala para ajustar la imagen al PDF
      const scaleX = pdfWidth / canvasWidthMM;
      const scaleY = pdfHeight / canvasHeightMM;
      const scale = Math.min(scaleX, scaleY, 1); // No escalar más grande que el original
      
      const finalWidth = canvasWidthMM * scale;
      const finalHeight = canvasHeightMM * scale;
      
      // Centrar la imagen en el PDF
      const offsetX = (pdfWidth - finalWidth) / 2;
      const offsetY = (pdfHeight - finalHeight) / 2;
      
      // Agregar la imagen al PDF
      pdf.addImage(imgData, 'PNG', offsetX, offsetY, finalWidth, finalHeight);
      
      // Generar nombre del archivo
      const fechaActual = new Date().toISOString().split('T')[0];
      const periodoNombre = planillaParaVista.periodo || planillaParaVista.nombre || 'Planilla';
      const nombreArchivo = `Consolidado_Conceptos_${periodoNombre.replace(/\s+/g, '_')}_${fechaActual}.pdf`;
      
      // Descargar el PDF
      pdf.save(nombreArchivo);
      
      alert('PDF de conceptos generado exitosamente con formato optimizado');
      
    } catch (error) {
      console.error('Error generando PDF de conceptos:', error);
      alert('Error al generar el PDF de conceptos: ' + error.message);
    } finally {
      setGenerandoConceptosPDF(false);
    }
  };

  // 📊 FUNCIÓN PARA EXPORTAR COMPENSACIONES A EXCEL (ExcelJS)
  const exportarCompensacionesExcel = async () => {
    try {
      setGenerandoExcelCompensaciones(true);
      console.log('📊 === INICIANDO EXPORTACIÓN DE COMPENSACIONES A EXCEL (ExcelJS) ===');
      
      const compensacionesData = calcularCompensacionesTodosEmpleados();
      if (compensacionesData.length === 0) {
        alert('No hay datos de compensaciones para exportar.');
        return;
      }
      
      const periodoNombre = planillaParaVista.periodo || planillaParaVista.nombre || 'Planilla';
      const fechaExp = new Date().toLocaleDateString('es-PE');
      const workbook = new ExcelJS.Workbook();
      workbook.creator = 'Sistema Planillas';
      workbook.created = new Date();

      const headerStyle = {
        font: { bold: true, color: { argb: 'FFFFFFFF' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0D9488' } },
        alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      };

      // —— Hoja 1: Resumen ——
      const wsResumen = workbook.addWorksheet('Resumen', { properties: { defaultRowHeight: 20 } });
      wsResumen.getColumn(1).width = 38;
      wsResumen.getColumn(2).width = 28;

      const tituloResumen = wsResumen.getRow(1);
      tituloResumen.getCell(1).value = 'Resumen de Compensaciones';
      wsResumen.mergeCells(1, 1, 1, 2);
      tituloResumen.getCell(1).font = { size: 14, bold: true, color: { argb: 'FFFFFFFF' } };
      tituloResumen.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0F766E' } };
      tituloResumen.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
      tituloResumen.height = 26;

      const subResumen = wsResumen.getRow(2);
      subResumen.getCell(1).value = `${periodoNombre}  |  Exportado: ${fechaExp}`;
      wsResumen.mergeCells(2, 1, 2, 2);
      subResumen.getCell(1).font = { size: 10, italic: true };
      subResumen.getCell(1).alignment = { horizontal: 'center' };
      wsResumen.getRow(3).height = 8;

      const resumenRows = [
        ['Total Empleados con Compensaciones', compensacionesData.length],
        ['Empleados A Favor', compensacionesData.filter(i => i.compensacion.totalProximoMes > 0).length],
        ['Empleados En Contra', compensacionesData.filter(i => i.compensacion.totalProximoMes < 0).length],
        ['No debe nada', compensacionesData.filter(i => Math.abs(i.compensacion.totalProximoMes) < 0.01).length],
        ['Total Horas Acumuladas (h)', compensacionesData.reduce((s, i) => s + i.compensacion.totalProximoMes, 0).toFixed(2)],
        ['', ''],
        ['Información de la Planilla', ''],
        ['Período', planillaParaVista.periodo || 'N/A'],
        ['Fecha de Exportación', fechaExp],
        ['Empresa', selectedCompany?.name || 'N/A']
      ];
      resumenRows.forEach(([concepto, valor], idx) => {
        const r = wsResumen.getRow(4 + idx);
        r.getCell(1).value = concepto;
        r.getCell(2).value = valor;
        r.eachCell((cell, colNumber) => {
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          cell.alignment = { vertical: 'middle' };
          if (idx < 5 && colNumber === 1) cell.font = { bold: true };
          if (idx === 0 && colNumber === 1) {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE0F2F1' } };
          }
        });
      });

      // —— Hoja 2: Compensaciones Detalle ——
      const wsDetalle = workbook.addWorksheet('Compensaciones Detalle', {
        views: [{ state: 'frozen', ySplit: 4, activeCell: 'A5' }],
        properties: { defaultRowHeight: 20 }
      });

      const rowTitulo = wsDetalle.getRow(1);
      rowTitulo.getCell(1).value = `COMPENSACIONES DE EMPLEADOS - ${periodoNombre}`;
      wsDetalle.mergeCells(1, 1, 1, 13);
      rowTitulo.getCell(1).font = { size: 16, bold: true, color: { argb: 'FFFFFFFF' } };
      rowTitulo.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0F766E' } };
      rowTitulo.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
      rowTitulo.height = 28;

      const fechaIni = planillaParaVista.fecha_inicio ? formatDateToDDMMYYYY(planillaParaVista.fecha_inicio) : 'N/A';
      const fechaFin = planillaParaVista.fecha_fin ? formatDateToDDMMYYYY(planillaParaVista.fecha_fin) : 'N/A';
      const rowSub = wsDetalle.getRow(2);
      rowSub.getCell(1).value = `Período: ${fechaIni} - ${fechaFin}  |  Exportado: ${fechaExp}`;
      wsDetalle.mergeCells(2, 1, 2, 13);
      rowSub.getCell(1).font = { size: 10, color: { argb: 'FF6B7280' } };
      rowSub.getCell(1).alignment = { horizontal: 'center' };
      rowSub.height = 20;
      wsDetalle.getRow(3).height = 8;

      const headersDetalle = [
        'Nº', 'DNI', 'Empleado', 'Cargo', 'Área de Trabajo', 'Proyecto',
        'Meses Anteriores (h)', 'Este Mes (h)', 'Total Próximo Mes (h)', 'Estado',
        'Días Laborables', 'Minutos Acumulados', 'Tareos Procesados'
      ];
      const rowHeader = wsDetalle.getRow(4);
      headersDetalle.forEach((h, i) => {
        const cell = rowHeader.getCell(i + 1);
        cell.value = h;
        Object.assign(cell, headerStyle);
      });
      rowHeader.height = 22;

      const datosOrdenados = [...compensacionesData].sort((a, b) => (a.empleado.nombre || '').localeCompare(b.empleado.nombre || '', 'es'));
      datosOrdenados.forEach((item, index) => {
        const { empleado, compensacion } = item;
        const estado = compensacion.totalProximoMes > 0 ? 'A FAVOR' : Math.abs(compensacion.totalProximoMes) < 0.01 ? 'NO DEBE NADA' : 'EN CONTRA';
        const row = wsDetalle.getRow(5 + index);
        row.getCell(1).value = index + 1;
        row.getCell(2).value = empleado.documento;
        row.getCell(3).value = empleado.nombre;
        row.getCell(4).value = empleado.cargo || 'No especificado';
        row.getCell(5).value = empleado.areas_de_trabajo || 'No especificado';
        row.getCell(6).value = empleado.proyecto || 'No especificado';
        row.getCell(7).value = Number(compensacion.horasMesesAnteriores);
        row.getCell(8).value = Number(compensacion.horasGeneradasMes);
        row.getCell(9).value = Number(compensacion.totalProximoMes);
        row.getCell(10).value = estado;
        row.getCell(11).value = compensacion.diasLaborables;
        row.getCell(12).value = compensacion.minutosExtrasMes;
        row.getCell(13).value = compensacion.tareosProcesados;
        row.eachCell((cell, colNumber) => {
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          cell.alignment = { vertical: 'middle', wrapText: true };
          if ([7, 8, 9].includes(colNumber)) {
            cell.numFmt = '#,##0.00';
            cell.alignment.horizontal = 'right';
          }
          if ([11, 12, 13].includes(colNumber)) cell.alignment.horizontal = 'right';
          if (index % 2 === 1) cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF0FDF4' } };
        });
      });

      const widths = [6, 12, 32, 24, 22, 18, 16, 14, 16, 14, 14, 14, 14];
      widths.forEach((w, i) => { wsDetalle.getColumn(i + 1).width = w; });

      const nombreArchivo = `Compensaciones_${(periodoNombre || 'Planilla').replace(/[/\\?*:[\]]/g, '_')}_${new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19)}.xlsx`;
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = nombreArchivo;
      a.click();
      URL.revokeObjectURL(url);
      console.log('✅ === EXPORTACIÓN DE COMPENSACIONES (ExcelJS) COMPLETADA ===');
    } catch (error) {
      console.error('❌ Error al exportar compensaciones a Excel:', error);
      alert('Error al generar el archivo Excel. Por favor, inténtelo nuevamente.');
    } finally {
      setGenerandoExcelCompensaciones(false);
    }
  };

  const exportarDatosExcel = async () => {
    try {
      setGenerandoExcel(true);
      
      // empleadosParaVista ya pasó por aplicarFiltros dentro de obtenerEmpleadosParaVista().
      // No volver a aplicarFiltros aquí: el objeto de vista no incluye fecha_computo_rh_id y el
      // bloque RH de planilla abierta descarta a todos → Excel vacío (p. ej. 8 al 8, 16 al 16).
      //
      // PLAME: solo personal en planilla (dual / sin solo_interna).
      // Los solo_interna van únicamente a la hoja "Planilla Interna".
      const esEmpleadoSoloInterna = (emp) => {
        const tipo = String(emp?.tipo_planilla || '').toLowerCase();
        const contratacion = String(
          emp?.tipo_contratacion || emp?.datosEmpleado?.tipo_contratacion || ''
        ).trim();
        return tipo === 'solo_interna' || contratacion === 'Interno';
      };

      const fillDeclHeader = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0284C7' } };
      const fillDeclData = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE0F2FE' } };
      const fillDeclAlt = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFBAE6FD' } };
      const fillDeclTotal = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF7DD3FC' } };

      let empleadosFiltrados;
      if (planillaAlternativaActiva && filtroTipoBoleta === 'interna') {
        empleadosFiltrados = empleadosParaVistaHaberes
        .slice()
        .sort((a, b) => (a.nombre || '').localeCompare(b.nombre || '', 'es'));
      } else if (planillaAlternativaActiva) {
        // Hoja PLAME (filtro plame o todas): excluir solo_interna / contratación Interna
        empleadosFiltrados = empleadosParaVistaHaberesBase
          .filter((emp) => !esEmpleadoSoloInterna(emp) && canalesBoletaDe(emp).plame)
          .map((emp) => ({ ...emp, _boletaVista: 'plame' }))
          .sort((a, b) => (a.nombre || '').localeCompare(b.nombre || '', 'es'));
      } else {
        empleadosFiltrados = empleadosParaVistaHaberes
          .slice()
          .sort((a, b) => (a.nombre || '').localeCompare(b.nombre || '', 'es'));
      }

      // Empleados completos (con grati/viáticos) alineados al filtro del Excel
      const idsExport = new Set(
        empleadosFiltrados.map((e) => String(e.id ?? e.empleado_id)).filter(Boolean)
      );
      const empleadosCompletosExport = empleadosParaVista
        .filter((e) => idsExport.has(String(e.id ?? e.empleado_id)))
        .sort((a, b) => (a.nombre || '').localeCompare(b.nombre || '', 'es'));
      const boletaDeclaracionPrincipal =
        planillaAlternativaActiva && filtroTipoBoleta === 'interna' ? 'interna' : 'plame';

      const empleadosParaDeclExport = empleadosCompletosExport.map((emp) =>
        boletaDeclaracionPrincipal === 'interna'
          ? {
              ...emp,
              conceptos: emp.conceptosInternos || { ingresos: [], descuentos: [], aportes: [] },
            }
          : emp
      );
      
      // Obtener conceptos únicos para mantener orden consistente (sin declaración grati)
      const conceptosUnicos = obtenerConceptosUnicos(empleadosFiltrados);
      const conceptosDeclaracionUnicos = obtenerConceptosUnicosDeclaracion(empleadosParaDeclExport);
      const declHeadersSet = new Set(
        conceptosDeclaracionUnicos.map((c) => c.descripcion).filter(Boolean)
      );
      
      // En planilla RH no se incluyen columnas de régimen/AFP/CUSPP
      const esPlanillaRHExport = planillaParaVista?.modalidad_planilla === 'planilla_rh' ||
        (planillaParaVista?.nombre && (String(planillaParaVista.nombre).toUpperCase().trim() === 'RH' || String(planillaParaVista.nombre).toUpperCase().includes('RH')));
      
      // Crear datos para Excel con orden correcto (ya ordenados alfabéticamente)
      const datosExcel = empleadosFiltrados.map(empleado => {
        const fila = {};
        
        console.log('🔍 === EMPLEADO ===', empleado);
        // 1. Información básica del empleado
        fila['DNI'] = empleado.documento;
        fila['Empleado'] = empleado.nombre;
        fila['Fecha de Nacimiento'] = (() => {
          const fechaNac = extraerFechaNacimientoEmpleado(empleado);
          return fechaNac ? formatFechaSoloDiaDdMmYyyy(fechaNac, 'No disponible') : 'No disponible';
        })();
        
        // ✅ NUEVOS CAMPOS DE CONTACTO Y EXTRAS
        fila['Teléfono'] = empleado.telefono || 'No disponible';
        fila['Email'] = empleado.email || 'No disponible';
        fila['Dirección'] = empleado.direccion || 'No disponible';
        fila['Descuento Descanso'] = empleado.descuento_descanso ? 'Sí' : 'No';
        
        fila['Proyecto'] = empleado.proyecto || 'Sin proyecto';
        fila['Área de Trabajo'] = empleado.areas_de_trabajo || 'Sin área';
        fila['Cargo'] = empleado.cargo;
        fila['Categoría'] = empleado.categoria;
        // En planilla RH no se exportan Régimen Laboral, AFP, Tipo de AFP ni CUSPP
        if (!esPlanillaRHExport) {
          fila['Régimen Laboral'] = empleado.regimenLaboral;
          fila['AFP'] = empleado.tipoAporte === 'AFP' ? (empleado.afp || 'Sin AFP') : 'ONP';
          fila['Tipo de AFP'] = empleado.tipoAporte === 'AFP' ? (empleado.tipoAfp || 'No especificado') : '';
          fila['CUSPP'] = empleado.tipoAporte === 'AFP' ? (empleado.cuspp || 'No disponible') : '';
        }
        fila['Banco'] = empleado.banco || 'No disponible';
        fila['Cuenta Bancaria'] = empleado.cuenta_bancaria || 'No disponible';
        fila['CCI'] = empleado.cci || 'No disponible';
        
        // 1.1 RESUMEN DE TAREOS - Información General
        fila['Registros Tareos'] = empleado.resumenTareos?.total_tareos || 0;
        fila['Días Trabajados'] = empleado.tareos?.diasTrabajados || 0;
        fila['Días Programados'] = empleado.tareos?.diasProgramados || 0;
        fila['Horas Ordinarias'] = empleado.tareos?.horasOrdinarias || 0;
        fila['Horas Extra 25%'] = empleado.tareos?.horasExtra25 || 0;
        fila['Horas Extra 35%'] = empleado.tareos?.horasExtra35 || 0;
        fila['Total Horas Extras'] = (empleado.tareos?.horasExtra25 || 0) + (empleado.tareos?.horasExtra35 || 0);
        
        // 1.2 RESUMEN DE TAREOS - Detalles por Tipo
        fila['Faltas'] = empleado.tareos?.faltas || 0;
        fila['Tardanzas'] = empleado.tareos?.tardanzas || 0;
        fila['Permisos'] = empleado.tareos?.permisos || 0;
        fila['Suspensiones'] = empleado.tareos?.suspensiones || 0;
        fila['Vacaciones'] = empleado.tareos?.vacaciones || 0;
        fila['Descanso Médico'] = empleado.tareos?.descansoMedico || 0;
        fila['Reposo Médico'] = empleado.tareos?.reposoMedico || 0;
        fila['Subsidio por Enfermedad'] = empleado.tareos?.subsidioPorEnfermedad || 0;
        fila['Licencia con Goce de Haber'] = empleado.tareos?.licenciaConGoceHaber || 0;
        fila['Feriados'] = empleado.tareos?.feriados || 0;
        fila['Feriados Laborados'] = empleado.tareos?.feriadosLaborados || 0;
        fila['Descansos'] = empleado.tareos?.descansos || 0;
        fila['Descansos Laborados'] = empleado.tareos?.descansosLaborados || 0;
        
        // 1.3 RESUMEN DE TAREOS - Estado
        const estadoTareo = empleado.tareos?.asistenciaPerfecta ? 'Asistencia Perfecta' : 'Con Incidencias';
        fila['Estado Tareo'] = estadoTareo;
        
        // 2. INGRESOS (en orden de conceptos únicos)
        conceptosUnicos.ingresos.forEach(conceptoUnico => {
          const conceptoEmpleado = empleado.conceptos?.ingresos?.find(
            ing => (ing.descripcion || ing.concepto) === conceptoUnico.descripcion
          );
          fila[conceptoUnico.descripcion] = parseFloat(conceptoEmpleado?.monto || 0);
        });

        // 2b. Viáticos / grati (dentro de ingresos, no suman al TOTAL INGRESOS)
        const ingresosDecl = ingresosDeclaracionDeEmpleado(
          empleado.id ?? empleado.empleado_id,
          boletaDeclaracionPrincipal
        );
        conceptosDeclaracionUnicos.forEach((conceptoUnico) => {
          const concepto = ingresosDecl.find(
            (c) =>
              (c.descripcion || c.concepto) === conceptoUnico.descripcion
          );
          fila[conceptoUnico.descripcion] = parseFloat(concepto?.monto) || 0;
        });
        
        // 3. TOTAL INGRESOS
        fila['TOTAL INGRESOS'] = parseFloat(empleado.totales?.totalIngresos || 0);
        
        // 4. DESCUENTOS (en orden de conceptos únicos)
        conceptosUnicos.descuentos.forEach(conceptoUnico => {
          const conceptoEmpleado = empleado.conceptos?.descuentos?.find(
            desc => (desc.descripcion || desc.concepto) === conceptoUnico.descripcion
          );
          fila[conceptoUnico.descripcion] = parseFloat(conceptoEmpleado?.monto || 0);
        });
        
        // 5. TOTAL DESCUENTOS
        fila['TOTAL DESCUENTOS'] = parseFloat(empleado.totales?.totalDescuentos || 0);
        
        // 6. NETO A PAGAR (al lado de Total Descuentos)
        fila['NETO A PAGAR'] = parseFloat(empleado.totales?.netoAPagar || 0);
        
        // 7. APORTES (en orden de conceptos únicos, sin total)
        conceptosUnicos.aportes.forEach(conceptoUnico => {
          const conceptoEmpleado = empleado.conceptos?.aportes?.find(
            aporte => (aporte.descripcion || aporte.concepto) === conceptoUnico.descripcion
          );
          fila[conceptoUnico.descripcion] = parseFloat(conceptoEmpleado?.monto || 0);
        });
        
        return fila;
      });
      
      // Crear libro con ExcelJS (diseño profesional)
      const workbook = new ExcelJS.Workbook();
      workbook.creator = 'Sistema Planillas';
      workbook.created = new Date();

      const periodoNombre = planillaParaVista.periodo || planillaParaVista.nombre || 'Planilla';
      const headers = datosExcel.length ? Object.keys(datosExcel[0]) : [];

      const wsDetalle = workbook.addWorksheet(
        planillaAlternativaActiva
          ? (filtroTipoBoleta === 'interna' ? 'Planilla Interna' : 'Planilla PLAME')
          : 'Planilla Detallada',
        {
        views: [{ state: 'frozen', ySplit: 4, activeCell: 'A5' }],
        properties: { defaultRowHeight: 20 }
      });

      // Título
      const rowTitulo = wsDetalle.getRow(1);
      rowTitulo.getCell(1).value = `${planillaAlternativaActiva && filtroTipoBoleta === 'interna' ? 'PLANILLA INTERNA' : (planillaAlternativaActiva ? 'PLANILLA PLAME' : 'PLANILLA DETALLADA')} - ${periodoNombre}`;
      wsDetalle.mergeCells(1, 1, 1, Math.max(headers.length, 1));
      rowTitulo.getCell(1).font = { size: 16, bold: true, color: { argb: 'FFFFFFFF' } };
      rowTitulo.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0F766E' } };
      rowTitulo.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
      rowTitulo.height = 28;

      // Subtítulo (fechas)
      const rowSub = wsDetalle.getRow(2);
      const fechaIni = planillaParaVista.fecha_inicio ? formatDateToDDMMYYYY(planillaParaVista.fecha_inicio) : 'N/A';
      const fechaFin = planillaParaVista.fecha_fin ? formatDateToDDMMYYYY(planillaParaVista.fecha_fin) : 'N/A';
      rowSub.getCell(1).value = `Período: ${fechaIni} - ${fechaFin}  |  Exportado: ${new Date().toLocaleDateString('es-PE')}`;
      wsDetalle.mergeCells(2, 1, 2, Math.max(headers.length, 1));
      rowSub.getCell(1).font = { size: 10, color: { argb: 'FF6B7280' } };
      rowSub.getCell(1).alignment = { horizontal: 'center' };
      rowSub.height = 20;

      // Fila vacía
      wsDetalle.getRow(3).height = 8;

      // Encabezados
      const rowHeader = wsDetalle.getRow(4);
      headers.forEach((h, i) => {
        const cell = rowHeader.getCell(i + 1);
        cell.value = h;
        cell.font = { bold: true, size: 11, color: { argb: 'FFFFFFFF' } };
        cell.fill = declHeadersSet.has(h)
          ? fillDeclHeader
          : { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0D9488' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });
      rowHeader.height = 22;

      // Columnas numéricas (montos y cantidades)
      const numericKeys = new Set([
        'Registros Tareos', 'Días Trabajados', 'Días Programados',
        'Horas Ordinarias', 'Horas Extra 25%', 'Horas Extra 35%', 'Total Horas Extras',
        'Faltas', 'Tardanzas', 'Permisos', 'Suspensiones', 'Vacaciones', 'Descanso Médico', 'Reposo Médico', 'Subsidio por Enfermedad',
        'Licencia con Goce de Haber',
        'Feriados', 'Feriados Laborados', 'Descansos', 'Descansos Laborados',
        'TOTAL INGRESOS', 'TOTAL DESCUENTOS', 'NETO A PAGAR'
      ]);
      conceptosUnicos.ingresos.forEach(c => numericKeys.add(c.descripcion));
      conceptosDeclaracionUnicos.forEach(c => numericKeys.add(c.descripcion));
      conceptosUnicos.descuentos.forEach(c => numericKeys.add(c.descripcion));
      conceptosUnicos.aportes.forEach(c => numericKeys.add(c.descripcion));

      // Datos
      datosExcel.forEach((fila, idx) => {
        const row = wsDetalle.getRow(5 + idx);
        headers.forEach((key, i) => {
          const cell = row.getCell(i + 1);
          const val = fila[key];
          cell.value = val;
          if (numericKeys.has(key) && typeof val === 'number') {
            cell.numFmt = '#,##0.00';
            cell.alignment = { horizontal: 'right' };
          }
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          if (declHeadersSet.has(key)) {
            cell.fill = idx % 2 === 1 ? fillDeclAlt : fillDeclData;
          } else if (idx % 2 === 1) {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF0FDF4' } };
          }
        });
      });

      // Fila de TOTALES al final (etiqueta "TOTALES" y sumas desde "Estado Tareo" en adelante)
      const indiceEstadoTareo = headers.findIndex(h => h === 'Estado Tareo');
      const totalesRowIndex = 5 + datosExcel.length;
      const rowTotales = wsDetalle.getRow(totalesRowIndex);
      const columnaInicioTotales = indiceEstadoTareo >= 0 ? indiceEstadoTareo : 0;
      headers.forEach((key, i) => {
        const cell = rowTotales.getCell(i + 1);
        const antesDeInicio = i < columnaInicioTotales;
        if (antesDeInicio) {
          cell.value = '';
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFCCFBF1' } };
        } else if (i === columnaInicioTotales) {
          cell.value = 'TOTALES';
          cell.font = { bold: true, size: 11, color: { argb: 'FFFFFFFF' } };
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0F766E' } };
          cell.alignment = { horizontal: 'left', vertical: 'middle' };
        } else if (numericKeys.has(key)) {
          const total = datosExcel.reduce((sum, fila) => sum + (Number(fila[key]) || 0), 0);
          cell.value = total;
          cell.numFmt = '#,##0.00';
          cell.font = { bold: true };
          cell.fill = declHeadersSet.has(key)
            ? fillDeclTotal
            : { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFCCFBF1' } };
          cell.alignment = { horizontal: 'right', vertical: 'middle' };
        } else {
          cell.value = '';
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFCCFBF1' } };
        }
        cell.border = { top: { style: 'medium' }, left: { style: 'thin' }, bottom: { style: 'medium' }, right: { style: 'thin' } };
      });
      rowTotales.height = 24;

      // Anchos de columna
      const anchoColumnas = [
        12, 30, 15, 25, 35, 15, 25, 20, 20, 18, 20, 15, 15, 18, 20, 20, 20
      ];
      for (let i = 0; i < 16; i++) anchoColumnas.push(14);
      conceptosUnicos.ingresos.forEach(() => anchoColumnas.push(16));
      conceptosDeclaracionUnicos.forEach(() => anchoColumnas.push(16));
      anchoColumnas.push(16);
      conceptosUnicos.descuentos.forEach(() => anchoColumnas.push(16));
      anchoColumnas.push(16);
      anchoColumnas.push(16);
      conceptosUnicos.aportes.forEach(() => anchoColumnas.push(16));
      headers.forEach((_, i) => {
        wsDetalle.getColumn(i + 1).width = anchoColumnas[i] || 14;
      });
      
      // Calcular totales de tareos
      const totalesTareos = empleadosFiltrados.reduce((acc, empleado) => {
        return {
          totalRegistros: acc.totalRegistros + (empleado.resumenTareos?.total_tareos || 0),
          totalDiasTrabajados: acc.totalDiasTrabajados + (empleado.resumenTareos?.total_tareos || 0),
          totalDiasProgramados: acc.totalDiasProgramados + (empleado.tareos?.diasProgramados || 0),
          totalHorasOrdinarias: acc.totalHorasOrdinarias + (empleado.tareos?.horasOrdinarias || 0),
          totalHorasExtra25: acc.totalHorasExtra25 + (empleado.tareos?.horasExtra25 || 0),
          totalHorasExtra35: acc.totalHorasExtra35 + (empleado.tareos?.horasExtra35 || 0),
          totalFaltas: acc.totalFaltas + (empleado.tareos?.faltas || 0),
          totalTardanzas: acc.totalTardanzas + (empleado.tareos?.tardanzas || 0),
          totalPermisos: acc.totalPermisos + (empleado.tareos?.permisos || 0),
          totalSuspensiones: acc.totalSuspensiones + (empleado.tareos?.suspensiones || 0),
          totalVacaciones: acc.totalVacaciones + (empleado.tareos?.vacaciones || 0),
          totalDescansoMedico: acc.totalDescansoMedico + (empleado.tareos?.descansoMedico || 0),
          totalFeriados: acc.totalFeriados + (empleado.tareos?.feriados || 0),
          totalFeriadosLaborados: acc.totalFeriadosLaborados + (empleado.tareos?.feriadosLaborados || 0),
          totalDescansos: acc.totalDescansos + (empleado.tareos?.descansos || 0),
          totalDescansosLaborados: acc.totalDescansosLaborados + (empleado.tareos?.descansosLaborados || 0),
          empleadosConAsistenciaPerfecta: acc.empleadosConAsistenciaPerfecta + (empleado.tareos?.asistenciaPerfecta ? 1 : 0)
        };
      }, {
        totalRegistros: 0,
        totalDiasTrabajados: 0,
        totalDiasProgramados: 0,
        totalHorasOrdinarias: 0,
        totalHorasExtra25: 0,
        totalHorasExtra35: 0,
        totalFaltas: 0,
        totalTardanzas: 0,
        totalPermisos: 0,
        totalSuspensiones: 0,
        totalVacaciones: 0,
        totalDescansoMedico: 0,
        totalFeriados: 0,
        totalFeriadosLaborados: 0,
        totalDescansos: 0,
        totalDescansosLaborados: 0,
        empleadosConAsistenciaPerfecta: 0
      });

      // Crear hoja de resumen
      const g = resumenSistemasPensionarios.gratificaciones || {};
      const v = resumenSistemasPensionarios.viaticos || {};
      const m = resumenSistemasPensionarios.movilidades || {};
      const mostrarDeclSeparado =
        planillaAlternativaActiva && filtroTipoBoleta === 'todas';
      const totalGratificacionesDecl = g.totalMonto || 0;
      const totalViaticosDecl = v.totalMonto || 0;
      const totalMovilidadDecl = m.totalMonto || 0;
      const hayDeclaracion =
        totalGratificacionesDecl > 0
        || totalViaticosDecl > 0
        || totalMovilidadDecl > 0
        || (g.totalMontoPlame || 0) > 0
        || (g.totalMontoInterna || 0) > 0
        || (v.totalMontoPlame || 0) > 0
        || (v.totalMontoInterna || 0) > 0
        || (m.totalMontoPlame || 0) > 0
        || (m.totalMontoInterna || 0) > 0;

      const filasDeclaracionResumen = (() => {
        if (!hayDeclaracion) return [];
        const filas = [
          ['CONCEPTOS QUE NO INGRESAN AL PAGO', ''],
          ['════════════════════════════════════', ''],
        ];
        if (mostrarDeclSeparado) {
          if ((g.totalMontoPlame || 0) > 0) {
            filas.push(['TOTAL GRATIFICACIONES PLAME:', g.totalMontoPlame || 0]);
          }
          if ((g.totalMontoInterna || 0) > 0) {
            filas.push(['TOTAL GRATIFICACIONES INTERNA:', g.totalMontoInterna || 0]);
          }
          if ((v.totalMontoPlame || 0) > 0) {
            filas.push(['TOTAL VIÁTICOS PLAME:', v.totalMontoPlame || 0]);
          }
          if ((v.totalMontoInterna || 0) > 0) {
            filas.push(['TOTAL VIÁTICOS INTERNA:', v.totalMontoInterna || 0]);
          }
          if ((m.totalMontoPlame || 0) > 0) {
            filas.push(['TOTAL MOVILIDADES PLAME:', m.totalMontoPlame || 0]);
          }
          if ((m.totalMontoInterna || 0) > 0) {
            filas.push(['TOTAL MOVILIDADES INTERNA:', m.totalMontoInterna || 0]);
          }
        } else {
          if (totalGratificacionesDecl > 0) {
            filas.push(['TOTAL GRATIFICACIONES:', totalGratificacionesDecl]);
          }
          if (totalViaticosDecl > 0) {
            filas.push(['TOTAL VIÁTICOS:', totalViaticosDecl]);
          }
          if (totalMovilidadDecl > 0) {
            filas.push(['TOTAL MOVILIDADES:', totalMovilidadDecl]);
          }
          if (totalGratificacionesDecl > 0 && totalViaticosDecl > 0) {
            filas.push(['TOTAL GRATI + VIÁTICOS:', totalGratificacionesDecl + totalViaticosDecl]);
          }
        }
        filas.push(['']);
        return filas;
      })();

      const datosResumen = [
        ['RESUMEN DE PLANILLA', ''],
        ['════════════════════════════════════', ''],
        ['Período:', planillaParaVista.periodo || planillaParaVista.nombre || 'N/A'],
        ['Fecha Inicio:', planillaParaVista.fecha_inicio ? formatDateToDDMMYYYY(planillaParaVista.fecha_inicio) : 'N/A'],
        ['Fecha Fin:', planillaParaVista.fecha_fin ? formatDateToDDMMYYYY(planillaParaVista.fecha_fin) : 'N/A'],
        ['Total Empleados:', empleadosFiltrados.length],
        ['Estado:', planillaParaVista.estado || 'N/A'],
        ['Fecha de Exportación:', new Date().toLocaleDateString('es-PE')],
        [''],
        ['TOTALES FINANCIEROS', ''],
        ['════════════════════════════════════', ''],
        ['TOTAL INGRESOS:', totalesGenerales.ingresoTotal || 0],
        ['TOTAL DESCUENTOS:', totalesGenerales.descuentoTotal || 0],
        ['NETO TOTAL A PAGAR:', totalesGenerales.netoTotal || 0],
        [''],
        ...filasDeclaracionResumen,
        ['RESUMEN DE TAREOS', ''],
        ['════════════════════════════════════', ''],
        ['📋 Total Registros de Tareos:', totalesTareos.totalRegistros],
        ['✅ Total Días Trabajados:', totalesTareos.totalDiasTrabajados],
        ['📅 Total Días Programados:', totalesTareos.totalDiasProgramados],
        ['📊 Promedio de Asistencia:', `${(totalesTareos.totalDiasTrabajados / Math.max(totalesTareos.totalDiasProgramados, 1) * 100).toFixed(1)}%`],
        ['⏰ Total Horas Ordinarias:', totalesTareos.totalHorasOrdinarias],
        ['⚡ Total Horas Extra 25%:', totalesTareos.totalHorasExtra25],
        ['⚡ Total Horas Extra 35%:', totalesTareos.totalHorasExtra35],
        ['🔥 Total Horas Extras:', totalesTareos.totalHorasExtra25 + totalesTareos.totalHorasExtra35],
        [''],
        ['INCIDENCIAS', ''],
        ['════════════════════════════════════', ''],
        ['❌ Total Faltas:', totalesTareos.totalFaltas],
        ['⏱️ Total Tardanzas:', totalesTareos.totalTardanzas],
        ['📋 Total Permisos:', totalesTareos.totalPermisos],
        ['⛔ Total Suspensiones:', totalesTareos.totalSuspensiones],
        ['🏖️ Total Vacaciones:', totalesTareos.totalVacaciones],
        ['🏥 Total Descanso Médico:', totalesTareos.totalDescansoMedico],
        ['🎉 Total Feriados:', totalesTareos.totalFeriados],
        ['💼 Total Feriados Laborados:', totalesTareos.totalFeriadosLaborados],
        ['😴 Total Descansos:', totalesTareos.totalDescansos],
        ['⚡ Total Descansos Laborados:', totalesTareos.totalDescansosLaborados],
        [''],
        ['ESTADÍSTICAS FINALES', ''],
        ['════════════════════════════════════', ''],
        ['👥 Empleados con Asistencia Perfecta:', totalesTareos.empleadosConAsistenciaPerfecta],
        ['📈 % Empleados con Asistencia Perfecta:', `${(totalesTareos.empleadosConAsistenciaPerfecta / Math.max(empleadosFiltrados.length, 1) * 100).toFixed(1)}%`],
        ['🎯 Efectividad General:', totalesTareos.totalFaltas === 0 && totalesTareos.totalTardanzas === 0 ? 'EXCELENTE' : 
          totalesTareos.totalFaltas <= 5 && totalesTareos.totalTardanzas <= 10 ? 'BUENA' : 'MEJORABLE'],
                 [''],
         ['RESUMEN POR TIPO DE AFP - DESCUENTOS', ''],
         ['════════════════════════════════════', ''],
         ...(resumenSistemasPensionarios.tieneRegimenMinero
           ? [
             ['AFP', 'Empleados', 'AFP Normal', 'Trabajador 0611', 'Empleador 0809', 'Total AFP'],
             ...Object.entries(resumenSistemasPensionarios.afp).map(([afp, data]) => [
               afp,
               data.totalEmpleados,
               formatCurrency(data.totalDescuentosAfp),
               formatCurrency(data.aportacionTrabajador0611),
               formatCurrency(data.aporteEmpleador0809),
               formatCurrency(data.totalDescuentosAfp + data.aportacionTrabajador0611 + data.aporteEmpleador0809),
             ]),
             ['TOTAL GENERAL AFP', '', '', '', '', formatCurrency(resumenSistemasPensionarios.totalGeneralAfp)],
           ]
           : [
         ['AFP', 'Empleados', 'Aportación Obligatoria', 'Comisión', 'Prima Seguro', 'Total AFP'],
         ...Object.entries(resumenSistemasPensionarios.afp).map(([afp, data]) => [
           afp, 
           data.totalEmpleados, 
           formatCurrency(data.aportacionObligatoria),
           formatCurrency(data.comisionPorcentual),
           formatCurrency(data.primaSeguro),
               formatCurrency(data.totalDescuentosAfp),
             ]),
         ]),
         [''],
         ['RESUMEN ONP', ''],
         ['════════════════════════════════════', ''],
         ['Empleados ONP', resumenSistemasPensionarios.onp.totalEmpleados],
         ['Descuentos ONP', formatCurrency(resumenSistemasPensionarios.onp.totalDescuentos)],
         ['Neto Total ONP', formatCurrency(resumenSistemasPensionarios.onp.totalNeto)],
         [''],
         ['RESUMEN ESSALUD', ''],
         ['════════════════════════════════════', ''],
         ['Empleados ESSALUD', resumenSistemasPensionarios.essalud.totalEmpleados],
         ['Total Aporte ESSALUD', formatCurrency(resumenSistemasPensionarios.essalud.totalAporte)],
         ...(resumenSistemasPensionarios.renta.totalDescuentos > 0
           ? [
             [''],
             ['RESUMEN RENTA 5TA (0605)', ''],
             ['════════════════════════════════════', ''],
             ['Empleados con retención', resumenSistemasPensionarios.renta.totalEmpleados],
             ['Total Renta', formatCurrency(resumenSistemasPensionarios.renta.totalDescuentos)],
           ]
           : []),
         ...(resumenSistemasPensionarios.tieneRegimenMinero
           ? [
             [''],
             ['RESUMEN FCJMUS (0616) - RÉGIMEN MINERO', ''],
             ['════════════════════════════════════', ''],
             ['Empleados con 0616', resumenSistemasPensionarios.fcjmus0616.totalEmpleados],
             ['Total Aporte FCJMUS (0616)', formatCurrency(resumenSistemasPensionarios.fcjmus0616.totalAporte)],
           ]
           : []),
      ];
      
      // Hoja Resumen con diseño
      const wsResumen = workbook.addWorksheet('Resumen de Tareos', {
        properties: { defaultRowHeight: 20 }
      });
      wsResumen.getColumn(1).width = 38;
      wsResumen.getColumn(2).width = 28;

      datosResumen.forEach((fila, idx) => {
        const row = wsResumen.getRow(idx + 1);
        const [col1, col2] = fila;
        const isTitle = typeof col1 === 'string' && (col1 === 'RESUMEN DE PLANILLA' || col1 === 'TOTALES FINANCIEROS' || col1 === 'CONCEPTOS QUE NO INGRESAN AL PAGO' || col1 === 'RESUMEN DE TAREOS' || col1 === 'INCIDENCIAS' || col1 === 'ESTADÍSTICAS FINALES' || col1 === 'RESUMEN POR TIPO DE AFP - DESCUENTOS' || col1 === 'RESUMEN ONP' || col1 === 'RESUMEN ESSALUD');
        const isSeparator = typeof col1 === 'string' && col1.startsWith('═');
        const isSubtitle = typeof col1 === 'string' && col1.endsWith(':');
        row.getCell(1).value = col1;
        row.getCell(2).value = col2 !== undefined && col2 !== '' ? col2 : '';
        if (isTitle) {
          row.getCell(1).font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
          row.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0F766E' } };
          wsResumen.mergeCells(idx + 1, 1, idx + 1, 2);
        } else if (isSeparator) {
          row.getCell(1).font = { italic: true, color: { argb: 'FF9CA3AF' } };
          wsResumen.mergeCells(idx + 1, 1, idx + 1, 2);
        } else if (isSubtitle) {
          row.getCell(1).font = { bold: true };
          row.getCell(2).alignment = { horizontal: 'right' };
        }
        row.getCell(1).border = { bottom: { style: isSeparator ? 'none' : 'thin' } };
        row.getCell(2).border = { bottom: { style: 'thin' } };
      });

      // Segunda hoja: boleta interna (cuando PA activa y filtro "todas")
      if (planillaAlternativaActiva && filtroTipoBoleta === 'todas') {
        const empleadosInterna = empleadosParaVistaHaberesBase
          .filter((emp) => canalesBoletaDe(emp).interna)
          .map((emp) => ({
            ...emp,
            conceptos: emp.conceptosInternos || { ingresos: [], descuentos: [], aportes: [] },
            totales: emp.totalesInternos || emp.totales,
          }))
          .sort((a, b) => (a.nombre || '').localeCompare(b.nombre || '', 'es'));

        const conceptosUnicosInterna = obtenerConceptosUnicos(empleadosInterna);
        const empleadosParaDeclInterna = empleadosParaVista
          .filter((e) =>
            empleadosInterna.some(
              (ei) => String(ei.id ?? ei.empleado_id) === String(e.id ?? e.empleado_id)
            )
          )
          .map((emp) => ({
            ...emp,
            conceptos: emp.conceptosInternos || { ingresos: [], descuentos: [], aportes: [] },
          }));
        const conceptosDeclaracionInterna = obtenerConceptosUnicosDeclaracion(empleadosParaDeclInterna);
        const declHeadersInterna = new Set(
          conceptosDeclaracionInterna.map((c) => c.descripcion).filter(Boolean)
        );
        const datosExcelInterna = empleadosInterna.map((empleado) => {
          const fila = {};
          fila['DNI'] = empleado.documento;
          fila['Empleado'] = empleado.nombre;
          fila['Fecha de Nacimiento'] = (() => {
            const fechaNac = extraerFechaNacimientoEmpleado(empleado);
            return fechaNac ? formatFechaSoloDiaDdMmYyyy(fechaNac, 'No disponible') : 'No disponible';
          })();
          fila['Teléfono'] = empleado.telefono || 'No disponible';
          fila['Email'] = empleado.email || 'No disponible';
          fila['Dirección'] = empleado.direccion || 'No disponible';
          fila['Descuento Descanso'] = empleado.descuento_descanso ? 'Sí' : 'No';
          fila['Proyecto'] = empleado.proyecto || 'Sin proyecto';
          fila['Área de Trabajo'] = empleado.areas_de_trabajo || 'Sin área';
          fila['Cargo'] = empleado.cargo;
          fila['Categoría'] = empleado.categoria;
          fila['Tipo Planilla'] = empleado.tipo_planilla || '';
          fila['Banco'] = empleado.banco || 'No disponible';
          fila['Cuenta Bancaria'] = empleado.cuenta_bancaria || 'No disponible';
          fila['CCI'] = empleado.cci || 'No disponible';

          // Eventos / resumen de tareos (mismo set que hoja PLAME)
          fila['Registros Tareos'] = empleado.resumenTareos?.total_tareos || 0;
          fila['Días Trabajados'] = empleado.tareos?.diasTrabajados || 0;
          fila['Días Programados'] = empleado.tareos?.diasProgramados || 0;
          fila['Horas Ordinarias'] = empleado.tareos?.horasOrdinarias || 0;
          fila['Horas Extra 25%'] = empleado.tareos?.horasExtra25 || 0;
          fila['Horas Extra 35%'] = empleado.tareos?.horasExtra35 || 0;
          fila['Total Horas Extras'] = (empleado.tareos?.horasExtra25 || 0) + (empleado.tareos?.horasExtra35 || 0);
          fila['Faltas'] = empleado.tareos?.faltas || 0;
          fila['Tardanzas'] = empleado.tareos?.tardanzas || 0;
          fila['Permisos'] = empleado.tareos?.permisos || 0;
          fila['Suspensiones'] = empleado.tareos?.suspensiones || 0;
          fila['Vacaciones'] = empleado.tareos?.vacaciones || 0;
          fila['Descanso Médico'] = empleado.tareos?.descansoMedico || 0;
          fila['Reposo Médico'] = empleado.tareos?.reposoMedico || 0;
          fila['Subsidio por Enfermedad'] = empleado.tareos?.subsidioPorEnfermedad || 0;
          fila['Licencia con Goce de Haber'] = empleado.tareos?.licenciaConGoceHaber || 0;
          fila['Feriados'] = empleado.tareos?.feriados || 0;
          fila['Feriados Laborados'] = empleado.tareos?.feriadosLaborados || 0;
          fila['Descansos'] = empleado.tareos?.descansos || 0;
          fila['Descansos Laborados'] = empleado.tareos?.descansosLaborados || 0;
          fila['Estado Tareo'] = empleado.tareos?.asistenciaPerfecta ? 'Asistencia Perfecta' : 'Con Incidencias';

          conceptosUnicosInterna.ingresos.forEach((conceptoUnico) => {
            const conceptoEmpleado = empleado.conceptos?.ingresos?.find(
              (ing) => (ing.descripcion || ing.concepto) === conceptoUnico.descripcion
            );
            fila[conceptoUnico.descripcion] = parseFloat(conceptoEmpleado?.monto || 0);
          });
          const ingresosDeclI = ingresosDeclaracionDeEmpleado(
            empleado.id ?? empleado.empleado_id,
            'interna'
          );
          conceptosDeclaracionInterna.forEach((conceptoUnico) => {
            const concepto = ingresosDeclI.find(
              (c) => (c.descripcion || c.concepto) === conceptoUnico.descripcion
            );
            fila[conceptoUnico.descripcion] = parseFloat(concepto?.monto) || 0;
          });
          fila['TOTAL INGRESOS'] = parseFloat(empleado.totales?.totalIngresos || 0);
          conceptosUnicosInterna.descuentos.forEach((conceptoUnico) => {
            const conceptoEmpleado = empleado.conceptos?.descuentos?.find(
              (desc) => (desc.descripcion || desc.concepto) === conceptoUnico.descripcion
            );
            fila[conceptoUnico.descripcion] = parseFloat(conceptoEmpleado?.monto || 0);
          });
          fila['TOTAL DESCUENTOS'] = parseFloat(empleado.totales?.totalDescuentos || 0);
          fila['NETO A PAGAR'] = parseFloat(empleado.totales?.netoAPagar || 0);
          conceptosUnicosInterna.aportes.forEach((conceptoUnico) => {
            const conceptoEmpleado = empleado.conceptos?.aportes?.find(
              (aporte) => (aporte.descripcion || aporte.concepto) === conceptoUnico.descripcion
            );
            fila[conceptoUnico.descripcion] = parseFloat(conceptoEmpleado?.monto || 0);
          });
          return fila;
        });

        const headersInterna = datosExcelInterna.length ? Object.keys(datosExcelInterna[0]) : ['DNI', 'Empleado'];
        const wsInterna = workbook.addWorksheet('Planilla Interna', {
          views: [{ state: 'frozen', ySplit: 4, activeCell: 'A5' }],
          properties: { defaultRowHeight: 20 },
        });
        const rowTituloI = wsInterna.getRow(1);
        rowTituloI.getCell(1).value = `PLANILLA INTERNA (CONTROL) - ${periodoNombre}`;
        wsInterna.mergeCells(1, 1, 1, Math.max(headersInterna.length, 1));
        rowTituloI.getCell(1).font = { size: 16, bold: true, color: { argb: 'FFFFFFFF' } };
        rowTituloI.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFB45309' } };
        rowTituloI.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
        rowTituloI.height = 28;

        const rowSubI = wsInterna.getRow(2);
        rowSubI.getCell(1).value = `Período: ${fechaIni} - ${fechaFin}  |  Exportado: ${new Date().toLocaleDateString('es-PE')}`;
        wsInterna.mergeCells(2, 1, 2, Math.max(headersInterna.length, 1));
        rowSubI.getCell(1).font = { size: 10, color: { argb: 'FF6B7280' } };
        rowSubI.getCell(1).alignment = { horizontal: 'center' };
        wsInterna.getRow(3).height = 8;

        const rowHeaderI = wsInterna.getRow(4);
        headersInterna.forEach((h, i) => {
          const cell = rowHeaderI.getCell(i + 1);
          cell.value = h;
          cell.font = { bold: true, size: 11, color: { argb: 'FFFFFFFF' } };
          cell.fill = declHeadersInterna.has(h)
            ? fillDeclHeader
            : { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD97706' } };
          cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });
        rowHeaderI.height = 22;

        const numericKeysI = new Set([
          'Registros Tareos', 'Días Trabajados', 'Días Programados',
          'Horas Ordinarias', 'Horas Extra 25%', 'Horas Extra 35%', 'Total Horas Extras',
          'Faltas', 'Tardanzas', 'Permisos', 'Suspensiones', 'Vacaciones',
          'Descanso Médico', 'Reposo Médico', 'Subsidio por Enfermedad',
          'Licencia con Goce de Haber',
          'Feriados', 'Feriados Laborados', 'Descansos', 'Descansos Laborados',
          'TOTAL INGRESOS', 'TOTAL DESCUENTOS', 'NETO A PAGAR',
        ]);
        conceptosUnicosInterna.ingresos.forEach((c) => numericKeysI.add(c.descripcion));
        conceptosDeclaracionInterna.forEach((c) => numericKeysI.add(c.descripcion));
        conceptosUnicosInterna.descuentos.forEach((c) => numericKeysI.add(c.descripcion));
        conceptosUnicosInterna.aportes.forEach((c) => numericKeysI.add(c.descripcion));

        datosExcelInterna.forEach((fila, idx) => {
          const row = wsInterna.getRow(5 + idx);
          headersInterna.forEach((key, i) => {
            const cell = row.getCell(i + 1);
            const val = fila[key];
            cell.value = val;
            if (numericKeysI.has(key) && typeof val === 'number') {
              cell.numFmt = '#,##0.00';
              cell.alignment = { horizontal: 'right' };
            }
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            if (declHeadersInterna.has(key)) {
              cell.fill = idx % 2 === 1 ? fillDeclAlt : fillDeclData;
            } else if (idx % 2 === 1) {
              cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFBEB' } };
            }
          });
        });

        // Fila TOTALES (desde Estado Tareo en adelante, igual que hoja PLAME)
        const indiceEstadoTareoI = headersInterna.findIndex((h) => h === 'Estado Tareo');
        const totalesRowIndexI = 5 + datosExcelInterna.length;
        const rowTotalesI = wsInterna.getRow(totalesRowIndexI);
        const columnaInicioTotalesI = indiceEstadoTareoI >= 0 ? indiceEstadoTareoI : 0;
        headersInterna.forEach((key, i) => {
          const cell = rowTotalesI.getCell(i + 1);
          if (i < columnaInicioTotalesI) {
            cell.value = '';
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFEF3C7' } };
          } else if (i === columnaInicioTotalesI) {
            cell.value = 'TOTALES';
            cell.font = { bold: true, size: 11, color: { argb: 'FFFFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFB45309' } };
            cell.alignment = { horizontal: 'left', vertical: 'middle' };
          } else if (numericKeysI.has(key)) {
            const total = datosExcelInterna.reduce((sum, fila) => sum + (Number(fila[key]) || 0), 0);
            cell.value = total;
            cell.numFmt = '#,##0.00';
            cell.font = { bold: true };
            cell.fill = declHeadersInterna.has(key)
              ? fillDeclTotal
              : { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFEF3C7' } };
            cell.alignment = { horizontal: 'right', vertical: 'middle' };
          } else {
            cell.value = '';
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFEF3C7' } };
          }
          cell.border = { top: { style: 'medium' }, left: { style: 'thin' }, bottom: { style: 'medium' }, right: { style: 'thin' } };
        });
        rowTotalesI.height = 24;

        headersInterna.forEach((_, i) => {
          wsInterna.getColumn(i + 1).width = i < 2 ? 28 : 14;
        });
      }

      // Generar nombre del archivo y descargar
      const fechaActual = new Date().toISOString().split('T')[0];
      const nombreArchivo = `Planilla_con_Tareos_${periodoNombre.replace(/\s+/g, '_')}_${fechaActual}.xlsx`;
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = nombreArchivo;
      a.click();
      URL.revokeObjectURL(url);
      
      alert('Archivo Excel generado exitosamente');
      
    } catch (error) {
      console.error('Error generando Excel:', error);
      alert('Error al generar el archivo Excel: ' + error.message);
    } finally {
      setGenerandoExcel(false);
    }
  };

  // 📄 FUNCIÓN PARA GENERAR BOLETA INDIVIDUAL
  // tipoBoleta: 'plame' | 'interna' — solo afecta el formato visual (no los montos).
  // accion: 'descargar' | 'imprimir'
  // Dual: la boleta interna debe verse igual que la de un empleado solo_interna.
  const generarBoletaIndividual = async (empleado, tipoBoleta = 'plame', accion = 'descargar') => {
    try {
      setGenerandoBoletaIndividual(true);
      
      const esBoletaInternaPdf =
        String(tipoBoleta || '').toLowerCase() === 'interna'
        || esEmpleadoSoloInterna(empleado);
      const esImprimir = String(accion || '').toLowerCase() === 'imprimir';
              
      const listaBoletas = aplicarFiltros(empleadosParaVista);
      const idEmp = empleado.id ?? empleado.empleado_id;
      const idxNum = listaBoletas.findIndex(
        (e) => (e.id ?? e.empleado_id) != null && idEmp != null && String(e.id ?? e.empleado_id) === String(idEmp)
      );
      const numeroBoleta = idxNum >= 0 ? idxNum + 1 : 1;
      const totalBoletas = Math.max(listaBoletas.length, 1);

      const empleadoBase = empleadoParaBoletaOrdinaria(empleado);
      if (!empleadoBase.tareosEmpleado?.length) {
        const vistaEmp = listaBoletas.find(
          (e) => idEmp != null && String(e.id ?? e.empleado_id) === String(idEmp)
        );
        const tareosVista = vistaEmp?.tareosEmpleadoFiltrados || vistaEmp?.tareosEmpleado || [];
        if (tareosVista.length) empleadoBase.tareosEmpleado = tareosVista;
      }
      const partesBoleta = esBoletaInternaPdf
        ? [empleadoBase]
        : partirEmpleadoMixtoParaPdf(empleadoBase);

      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = 210;
      const pageHeight = 297;
      const margin = 4;
      const maxW = pageWidth - margin * 2;
      const maxH = pageHeight - margin * 2;

      for (let i = 0; i < partesBoleta.length; i += 1) {
        const parte = partesBoleta[i];
        const htmlBoleta = generarHtmlBoletaPago({
          empleado: parte,
          empresa: selectedCompany,
          planilla: planillaParaBoletaMixto(planillaParaVista, parte),
          numeroBoleta,
          totalBoletas,
          boletaEstandar: estiloBoletaActiva === 'estandar',
          estiloBoleta: estiloBoletaActiva,
          logoBase64: esBoletaInternaPdf ? null : logoEmpresaBase64,
          firmaBase64: firmaEmpresaBase64,
          formatCurrency,
          formatDate: formatDateToDDMMYYYY,
          esSoloInterna: esBoletaInternaPdf,
          subtituloBoleta: parte.subtituloBoleta || '',
          aclaracionSueldoPartido: (() => {
            const jornalTxt = parte.tramoMixto
              ? (parte.pagoJornal?.aclaracion || '')
              : (empleado.pagoJornal?.aclaracion || '');
            if (!esBoletaInternaPdf) {
              return parte.tramoMixto === 'mensual' || parte.tramoMixto === 'jornal' || parte.tramoMixto === 'completo'
                ? jornalTxt
                : '';
            }
            if (empleado.detalleSueldoTramoNumero) {
              const n = Number(empleado.detalleSueldoTramoNumero) === 2 ? 2 : 1;
              const tramoTxt = textoSueldoTramoInterna({
                numero: n,
                sueldo: empleado.sueldoInternoTramo
                  ?? (n === 2 ? (empleado.sueldoInterno2 ?? empleado.sueldo_interno_2) : (empleado.sueldoInterno1 ?? empleado.sueldo_interno_1)),
                dias: n === 2
                  ? (empleado.diasInterna2 ?? empleado.dias_interna_2)
                  : (empleado.diasInterna1 ?? empleado.dias_interna_1),
                formatCurrency,
              });
              return [tramoTxt, jornalTxt].filter(Boolean).join(' ');
            }
            if (empleado.boletaInternaPartida || empleado.boleta_interna_partida) return jornalTxt;
            const partidoTxt = textoAclaracionSueldoPartido({
              ...(empleado.sueldoPartido || empleado.sueldo_partido || {}),
              dias1: empleado.sueldoPartido?.dias1 ?? empleado.diasInterna1 ?? empleado.dias_interna_1,
              dias2: empleado.sueldoPartido?.dias2 ?? empleado.diasInterna2 ?? empleado.dias_interna_2,
              formatCurrency,
            });
            return [partidoTxt, jornalTxt].filter(Boolean).join(' ');
          })(),
        });

        const contenedorTemporal = document.createElement('div');
        contenedorTemporal.style.position = 'absolute';
        contenedorTemporal.style.left = '-9999px';
        contenedorTemporal.style.top = '0';
        contenedorTemporal.style.width = '900px';
        contenedorTemporal.style.backgroundColor = 'white';
        contenedorTemporal.style.padding = '12px';
        contenedorTemporal.style.fontFamily = 'Arial, sans-serif';
        contenedorTemporal.innerHTML = htmlBoleta;

        document.body.appendChild(contenedorTemporal);

        const canvas = await html2canvas(contenedorTemporal, {
          scale: 2,
          useCORS: true,
          backgroundColor: '#ffffff',
        });

        document.body.removeChild(contenedorTemporal);

        const imgData = canvas.toDataURL('image/png');
        let imgW = maxW;
        let imgH = (canvas.height * imgW) / canvas.width;
        if (imgH > maxH) {
          imgH = maxH;
          imgW = (canvas.width * imgH) / canvas.height;
        }
        const offsetX = (pageWidth - imgW) / 2;
        const offsetY = margin;
        if (i > 0) pdf.addPage();
        pdf.addImage(imgData, 'PNG', offsetX, offsetY, imgW, imgH);
      }

      if (esImprimir) {
        const blobUrl = pdf.output('bloburl');
        const iframe = document.createElement('iframe');
        iframe.setAttribute(
          'title',
          esBoletaInternaPdf ? 'Imprimir Boleta Interna' : 'Imprimir Boleta'
        );
        iframe.style.cssText =
          'position:fixed;right:0;bottom:0;width:0;height:0;border:0;opacity:0;pointer-events:none;';
        document.body.appendChild(iframe);

        const limpiar = () => {
          try {
            if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
          } catch (_) { /* ignore */ }
          try {
            URL.revokeObjectURL(blobUrl);
          } catch (_) { /* ignore */ }
        };

        iframe.onload = () => {
          try {
            iframe.contentWindow?.focus();
            iframe.contentWindow?.print();
          } catch (err) {
            limpiar();
            throw err;
          }
          setTimeout(limpiar, 60_000);
        };
        iframe.src = blobUrl;
        return;
      }

      const fechaActual = new Date().toISOString().split('T')[0];
      const prefijo = esBoletaInternaPdf ? 'BoletaInterna' : 'Boleta';
      const nombreArchivo = `${prefijo}_${String(numeroBoleta).padStart(3, '0')}_${empleado.nombre.replace(/\s+/g, '_')}_${fechaActual}.pdf`;
      
      pdf.save(nombreArchivo);
      alert(partesBoleta.length > 1
        ? 'Boleta completa, mensual y jornal generadas (una hoja A4 cada una)'
        : 'Boleta generada exitosamente (una hoja A4)');
      
    } catch (error) {
      console.error('Error generando boleta individual:', error);
      alert('Error al generar la boleta: ' + error.message);
    } finally {
      setGenerandoBoletaIndividual(false);
    }
  };

  // 📄 FUNCIÓN PARA GENERAR PDF CON TODAS LAS BOLETAS CON PROGRESO Y DIVISIÓN AUTOMÁTICA
  const exportarTodasLasBoletas = async () => {
    try {
      setGenerandoBoletas(true);
      
      console.log(`🎯 === GENERANDO BOLETAS PDF MASIVAS ===`);
              console.log(`🔒 Es Planilla Cerrada:`, planillaCerrada);
        console.log(`📊 Empleados para vista:`, empleadosParaVista.length);
        console.log(`🖼️ Firma Empresa disponible:`, firmaEmpresa ? 'SÍ - ' + firmaEmpresa : 'NO');
      
      const empleadosFiltradosRaw = aplicarFiltros(empleadosParaVista);
      const descargaBoletaInterna =
        planillaAlternativaActiva && filtroTipoBoleta === 'interna';
      const empleadosFiltrados = descargaBoletaInterna
        ? empleadosFiltradosRaw.map((emp) => ({
            ...emp,
            conceptos: emp.conceptosInternos || emp.conceptos,
            totales: emp.totalesInternos || emp.totales,
          }))
        : empleadosFiltradosRaw;
      const totalEmpleados = empleadosFiltrados.length;
      
      // 🔢 CONFIGURACIÓN PARA DIVISIÓN DE PDFs
      const totalPDFs = Math.ceil(totalEmpleados / EMPLEADOS_POR_PDF);
      
      console.log(`📊 Total empleados: ${totalEmpleados}`);
      console.log(`📁 Se generarán ${totalPDFs} archivo(s) PDF`);
      
      // 📊 CREAR MODAL DE PROGRESO
      const crearModalProgreso = () => {
        const modal = document.createElement('div');
        modal.id = 'modal-progreso-boletas';
        modal.style.cssText = `
          position: fixed; top: 0; left: 0; width: 100%; height: 100%; 
          background: rgba(0,0,0,0.8); z-index: 9999; display: flex; 
          justify-content: center; align-items: center; backdrop-filter: blur(4px);
        `;
        
        modal.innerHTML = `
          <div style="background: white; padding: 40px; border-radius: 16px; text-align: center; min-width: 450px; box-shadow: 0 20px 50px rgba(0,0,0,0.4);">
            <div style="margin-bottom: 20px;">
              <div style="width: 60px; height: 60px; margin: 0 auto 15px; background: linear-gradient(45deg, #10b981, #059669); border-radius: 50%; display: flex; align-items: center; justify-content: center;">
                <svg width="30" height="30" fill="white" viewBox="0 0 24 24">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <h3 style="margin: 0 0 10px 0; color: #374151; font-size: 20px; font-weight: bold;">Generando Boletas PDF</h3>
              <p id="info-pdfs" style="margin: 0; color: #6b7280; font-size: 14px;">Procesando ${totalEmpleados} empleados en ${totalPDFs} archivo(s)</p>
            </div>
            
            <div style="margin-bottom: 25px;">
              <div style="background: #f3f4f6; border-radius: 12px; padding: 6px; margin-bottom: 15px;">
                <div id="barra-progreso" style="background: linear-gradient(90deg, #10b981, #059669); height: 24px; border-radius: 8px; width: 0%; transition: width 0.3s ease; display: flex; align-items: center; justify-content: center; color: white; font-size: 12px; font-weight: bold;"></div>
              </div>
              <p id="texto-progreso" style="margin: 5px 0; color: #6b7280; font-size: 14px;">Preparando...</p>
              <p id="nombre-empleado" style="margin: 5px 0; color: #374151; font-weight: bold; min-height: 20px; font-size: 16px;">Iniciando proceso...</p>
              <p id="archivo-actual" style="margin: 5px 0; color: #059669; font-size: 12px; font-weight: 600;">📁 Archivo 1 de ${totalPDFs}</p>
            </div>
            
            <div style="margin-top: 25px;">
              <div style="display: inline-block; width: 24px; height: 24px; border: 3px solid #e5e7eb; border-top: 3px solid #10b981; border-radius: 50%; animation: spin 1s linear infinite;"></div>
            </div>
            
            <style>
              @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
            </style>
          </div>
        `;
        
        document.body.appendChild(modal);
        return modal;
      };
      
      // 📊 ACTUALIZAR PROGRESO
      const actualizarProgreso = (indice, nombreEmpleado, archivoActual) => {
        const porcentaje = Math.round(((indice + 1) / totalEmpleados) * 100);
        const barraProgreso = document.getElementById('barra-progreso');
        const textoProgreso = document.getElementById('texto-progreso');
        const nombreEmpleadoEl = document.getElementById('nombre-empleado');
        const archivoActualEl = document.getElementById('archivo-actual');
        
        if (barraProgreso) {
          barraProgreso.style.width = `${porcentaje}%`;
          barraProgreso.textContent = `${porcentaje}%`;
        }
        if (textoProgreso) textoProgreso.textContent = `Procesando empleado ${indice + 1} de ${totalEmpleados}`;
        if (nombreEmpleadoEl) nombreEmpleadoEl.textContent = nombreEmpleado;
        if (archivoActualEl) archivoActualEl.textContent = `📁 Archivo ${archivoActual} de ${totalPDFs}`;
      };
      
      const modalProgreso = crearModalProgreso();
      
      // ⏳ PEQUEÑO DELAY PARA QUE SE MUESTRE EL MODAL
      await new Promise(resolve => setTimeout(resolve, 200));
      
      // 📁 GENERAR PDFs POR LOTES
      const archivosGenerados = [];
      
      for (let pdfIndex = 0; pdfIndex < totalPDFs; pdfIndex++) {
        const inicioLote = pdfIndex * EMPLEADOS_POR_PDF;
        const finLote = Math.min(inicioLote + EMPLEADOS_POR_PDF, totalEmpleados);
        const empleadosLote = empleadosFiltrados.slice(inicioLote, finLote);
        
        console.log(`📄 Generando PDF ${pdfIndex + 1}/${totalPDFs} - Empleados ${inicioLote + 1} al ${finLote}`);
        
        const pdf = new jsPDF('p', 'mm', 'a4');
        
        for (let i = 0; i < empleadosLote.length; i++) {
          const empleado = empleadosLote[i];
          const indiceGlobal = inicioLote + i;
          
          try {
            // 📊 ACTUALIZAR PROGRESO
            actualizarProgreso(indiceGlobal, empleado.nombre, pdfIndex + 1);
            
            // ⏳ PEQUEÑO DELAY PARA EVITAR BLOQUEO DE UI
            await new Promise(resolve => setTimeout(resolve, 100));

            const esInternaLote = descargaBoletaInterna || esEmpleadoSoloInterna(empleado);
            const empleadoBaseLote = empleadoParaBoletaOrdinaria(empleado);
            if (!empleadoBaseLote.tareosEmpleado?.length) {
              const tareosVista = empleado.tareosEmpleadoFiltrados || empleado.tareosEmpleado || [];
              if (tareosVista.length) empleadoBaseLote.tareosEmpleado = tareosVista;
            }
            const partesLote = esInternaLote
              ? [empleadoBaseLote]
              : partirEmpleadoMixtoParaPdf(empleadoBaseLote);

            for (let p = 0; p < partesLote.length; p += 1) {
              const parte = partesLote[p];
              const contenedorTemporal = document.createElement('div');
              contenedorTemporal.style.position = 'absolute';
              contenedorTemporal.style.left = '-9999px';
              contenedorTemporal.style.top = '0';
              contenedorTemporal.style.width = '900px';
              contenedorTemporal.style.backgroundColor = 'white';
              contenedorTemporal.style.padding = '20px';
              contenedorTemporal.style.fontFamily = 'Arial, sans-serif';
              contenedorTemporal.innerHTML = generarHtmlBoletaPago({
                empleado: parte,
                empresa: selectedCompany,
                planilla: planillaParaBoletaMixto(planillaParaVista, parte),
                numeroBoleta: indiceGlobal + 1,
                totalBoletas: totalEmpleados,
                boletaEstandar: estiloBoletaActiva === 'estandar',
                estiloBoleta: estiloBoletaActiva,
                logoBase64: esInternaLote ? null : logoEmpresaBase64,
                firmaBase64: firmaEmpresaBase64,
                formatCurrency,
                formatDate: formatDateToDDMMYYYY,
                esSoloInterna: esInternaLote,
                subtituloBoleta: parte.subtituloBoleta || '',
                aclaracionSueldoPartido: parte.tramoMixto ? (parte.pagoJornal?.aclaracion || '') : '',
              });

              document.body.appendChild(contenedorTemporal);

              const canvas = await html2canvas(contenedorTemporal, {
                scale: 2,
                useCORS: true,
                backgroundColor: '#ffffff'
              });

              document.body.removeChild(contenedorTemporal);

              if (i > 0 || p > 0) {
                pdf.addPage();
              }

              const imgData = canvas.toDataURL('image/png');
              const imgWidth = 210;
              const maxHeight = 280;
              let imgHeight = (canvas.height * imgWidth) / canvas.width;
              if (imgHeight > maxHeight) {
                imgHeight = maxHeight;
              }
              pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
            }
            
          } catch (empleadoError) {
            console.error(`❌ Error procesando empleado ${empleado.nombre}:`, empleadoError);
            // Continuar con el siguiente empleado en caso de error
          }
        }
        
        // 💾 GUARDAR PDF DEL LOTE ACTUAL
        const fechaActual = new Date().toISOString().split('T')[0];
        const periodoNombre = planillaParaVista.periodo || planillaParaVista.nombre || 'Planilla';
        
        let nombreArchivo;
        if (totalPDFs === 1) {
          // Un solo archivo
          nombreArchivo = `Boletas_${periodoNombre.replace(/\s+/g, '_')}_${fechaActual}.pdf`;
        } else {
          // Varios archivos
          nombreArchivo = `Boletas_${periodoNombre.replace(/\s+/g, '_')}_Parte${pdfIndex + 1}de${totalPDFs}_${fechaActual}.pdf`;
        }
        
        // Descargar el PDF del lote
        pdf.save(nombreArchivo);
        archivosGenerados.push(nombreArchivo);
        
        console.log(`✅ PDF ${pdfIndex + 1}/${totalPDFs} generado: ${nombreArchivo}`);
        
        // 🧹 LIBERAR MEMORIA ENTRE LOTES
        if (pdfIndex < totalPDFs - 1) {
          // Pequeña pausa para liberar memoria entre lotes
          await new Promise(resolve => setTimeout(resolve, 500));
        }
      }
      
      // 🔚 CERRAR MODAL DE PROGRESO
      const modal = document.getElementById('modal-progreso-boletas');
      if (modal) {
        modal.remove();
      }
      
      // 🎉 MENSAJE DE ÉXITO FINAL
      let mensajeFinal;
      if (totalPDFs === 1) {
        mensajeFinal = `✅ PDF con ${totalEmpleados} boletas generado exitosamente (Diseño A4 ampliado con secciones de firma)`;
      } else {
        mensajeFinal = `✅ ${totalPDFs} archivos PDF generados exitosamente con ${totalEmpleados} boletas en total (Diseño A4 ampliado con secciones de firma):\n\n${archivosGenerados.map((archivo, index) => `${index + 1}. ${archivo}`).join('\n')}`;
      }
      
      alert(mensajeFinal);
      console.log('🎉 PROCESO COMPLETADO:', archivosGenerados);
      
    } catch (error) {
      console.error('❌ Error generando PDF de boletas:', error);
      
      // Cerrar modal en caso de error
      const modal = document.getElementById('modal-progreso-boletas');
      if (modal) {
        modal.remove();
      }
      
      // Mensaje de error más detallado
      let mensajeError = 'Error al generar el PDF de boletas: ';
      if (error.message?.includes('Invalid string length')) {
        mensajeError += 'El contenido es demasiado grande. Intente filtrar menos empleados o contacte al administrador.';
      } else {
        mensajeError += error.message;
      }
      
      alert(mensajeError);
    } finally {
      setGenerandoBoletas(false);
    }
  };

  // Archivos oficiales SUNAT: boleta PLAME vigente en el periodo (nunca solo_interna ni dual solo-interna).
  const empleadosParaArchivosPlame = (empleadosParaVista || []).filter(empleadoEntraEnArchivosPlame);

  const conceptoEntraEnArchivoRem = (concepto) => {
    if (!concepto) return false;
    if (parseFloat(concepto.monto) < 0) return false;
    const codigo = String(concepto.codigoPlame || concepto.codigo || '');
    if (codigo === '0607' || codigo === '0804' || codigo === '0616') return false;
    if (concepto.exportable_plame === false || concepto.excluirRem || concepto.absorberEn0121) return false;
    if (esDescuentoAbsorbidoEn0121Jornal(concepto)) return false;
    if (codigo === 'ITS3' || codigo === '' || codigo === 'DOMJ' || codigo === 'TARJ') return false;
    if (String(concepto.tipo_boleta || '').toLowerCase() === 'interna') return false;
    return conceptoVaABoletaPlame(concepto);
  };

  const conceptosRemDeEmpleado = (empleado) => {
    const grupos = [
      ...(empleado?.conceptos?.ingresos || []),
      ...(empleado?.conceptos?.descuentos || []),
      ...(empleado?.conceptos?.aportes || []),
    ];
    return grupos.filter(conceptoEntraEnArchivoRem);
  };

  const lineasEstimadasArchivoRem = empleadosParaArchivosPlame.reduce((total, emp) => {
    const conceptos = conceptosRemDeEmpleado(emp);
    const yaTiene0605 = conceptos.some((c) => String(c.codigoPlame || c.codigo || '') === '0605');
    return total + conceptos.length + (yaTiene0605 ? 0 : 1);
  }, 0);

  // 📄 FUNCIONES PARA GENERAR ARCHIVOS PLAME TXT
  const generarArchivoREM = () => {
    try {
      console.log('🔄 Generando archivo .rem para PLAME (solo boleta PLAME)...');
      const empleadosParaPLAME = empleadosParaArchivosPlame;
      
      if (empleadosParaPLAME.length === 0) {
        console.log('⚠️ No hay empleados para generar archivo .rem (excluido régimen formación laboral)');
        return '';
      }

      let contenidoREM = '';
      
      // Procesar cada empleado y sus conceptos (sin régimen de formación laboral)
      empleadosParaPLAME.forEach((empleado, index) => {
        const tipoDoc = codigoTipoDocumentoPlame(
          empleado.tipo_documento || empleado.datosEmpleado?.tipo_documento
        );
        const documento = empleado.documento || '';
        
        console.log(`📋 Procesando empleado ${empleado.nombre} (${documento})`);

        const plameConsuRaw = empleado?.datosAPIs?.construccionCivil?.plame
          || construccionCivilDatos?.plame
          || [];
        const plamePorClave = Array.isArray(plameConsuRaw)
          ? plameConsuRaw.reduce((acc, row) => {
            if (row?.concepto_clave) acc[row.concepto_clave] = row;
            return acc;
          }, {})
          : (plameConsuRaw || {});
        
        conceptosRemDeEmpleado(empleado).forEach((concepto) => {
          const codigoPlame = codigoPlameParaDeclaracionRem(concepto, { plamePorClave }) || '0121';
          let montoNum = parseFloat(concepto.monto || 0);
          if (String(codigoPlame) === '0121') {
            const absorbed = montoAbsorbido0121Jornal(empleado.pagoJornal);
            if (absorbed > 0) montoNum = Math.max(0, montoNum - absorbed);
          }
          if (String(codigoPlame) === '0705') {
            const dominical0705 = montoDominicalFusionarEn0705(empleado);
            if (dominical0705 > 0) montoNum += dominical0705;
          }
          const monto = montoNum.toFixed(2);
              contenidoREM += `${tipoDoc}|${documento}|${codigoPlame}|${monto}|${monto}|\n`;
        });
        
        // Agregar código 0605 obligatorio para todos los empleados
        let monto0605 = '0.00';
        let tieneConcepto0605 = false;
        
        // Buscar si el empleado tiene concepto 0605 en cualquier categoría
        const concepto0605 = conceptosRemDeEmpleado(empleado).find((c) =>
          String(c.codigoPlame || c.codigo || '') === '0605'
        );
          if (concepto0605) {
            monto0605 = parseFloat(concepto0605.monto).toFixed(2);
            tieneConcepto0605 = true;
        }
        
        // Agregar línea obligatoria 0605 (no duplicar si ya fue procesado anteriormente)
        if (!tieneConcepto0605) {
          contenidoREM += `${tipoDoc}|${documento}|0605|${monto0605}|${monto0605}|\n`;
          console.log(`  🔧 Código 0605 OBLIGATORIO - Monto: ${monto0605} (AGREGADO POR DEFECTO)`);
        } else {
          console.log(`  🔧 Código 0605 OBLIGATORIO - Monto: ${monto0605} (YA PROCESADO EN CONCEPTOS)`);
        }
      });
      
      console.log('✅ Archivo .rem generado exitosamente');
      console.log(`📊 Total líneas: ${contenidoREM.split('\n').length - 1}`);
      console.log('⚠️ IMPORTANTE: Códigos 0607, 0804 y 0616 fueron EXCLUIDOS (autocalculados por PLAME)');
      console.log('🔧 IMPORTANTE: Código 0605 fue AGREGADO obligatoriamente para todos los empleados');
      console.log('📄 Contenido generado:');
      console.log(contenidoREM.substring(0, 500) + '...');
      
      return contenidoREM;
      
    } catch (error) {
      console.error('❌ Error generando archivo .rem:', error);
      return '';
    }
  };

  const generarArchivoJOR = () => {
    try {
      console.log('🔄 Generando archivo .jor para PLAME (solo boleta PLAME)...');
      const empleadosParaPLAME = empleadosParaArchivosPlame;
      
      if (empleadosParaPLAME.length === 0) {
        console.log('⚠️ No hay empleados para generar archivo .jor (excluido régimen formación laboral)');
        return '';
      }

      let contenidoJOR = '';
      
      // Procesar cada empleado para sus jornadas (sin régimen de formación laboral)
      empleadosParaPLAME.forEach((empleado, index) => {
        const tipoDoc = codigoTipoDocumentoPlame(
          empleado.tipo_documento || empleado.datosEmpleado?.tipo_documento
        );
        const documento = empleado.documento || '';
        
        // Calcular horas totales trabajadas basándose en los tareos
        let horasTotales = 0;
        
        // Si tiene datos de tareos detallados, usar esos
        if (empleado.tareos?.horasOrdinarias) {
          horasTotales = empleado.tareos.horasOrdinarias + 
                        (empleado.tareos.horasExtra25 || 0) + 
                        (empleado.tareos.horasExtra35 || 0);
        } 
        // Si tiene tareos individuales, sumar las horas de cada tareo
        else if (empleado.tareosEmpleado && empleado.tareosEmpleado.length > 0) {
          horasTotales = empleado.tareosEmpleado.reduce((total, tareo) => {
            return total + parseFloat(tareo.horas_planilla || tareo.horas_trabajadas || 0);
          }, 0);
        }
        // Fallback: usar días trabajados * 8 horas
        else if (empleado.tareos?.diasTrabajados) {
          horasTotales = empleado.tareos.diasTrabajados * 8;
        }
        // Último fallback: 208 horas (mes completo)
        else {
          horasTotales = 208;
        }
        
        // Redondear las horas a entero
        horasTotales = Math.round(horasTotales);
        
        // Formato: tipoDoc|documento|horasTotales|0|0|0|
        contenidoJOR += `${tipoDoc}|${documento}|${horasTotales}|0|0|0|\n`;
        
        console.log(`📋 Empleado: ${empleado.nombre} (${documento}) - Horas: ${horasTotales}`);
      });
      
      console.log('✅ Archivo .jor generado exitosamente');
      console.log(`📊 Total líneas: ${contenidoJOR.split('\n').length - 1}`);
      console.log('📄 Contenido generado:');
      console.log(contenidoJOR.substring(0, 500) + '...');
      
      return contenidoJOR;
      
    } catch (error) {
      console.error('❌ Error generando archivo .jor:', error);
      return '';
    }
  };

  const descargarArchivoTXT = (contenido, nombreArchivo, tipoArchivo) => {
    try {
      if (!contenido || contenido.trim() === '') {
        alert(`⚠️ No hay contenido para generar el archivo ${tipoArchivo}`);
        return;
      }

      // Convertir saltos de línea a formato Windows (CRLF) que requiere PLAME
      const contenidoWindows = contenido.replace(/\r?\n/g, '\r\n');
      
      // Crear blob con UTF-8 sin BOM (más compatible que Windows-1252)
      // PLAME acepta UTF-8 sin BOM
      const encoder = new TextEncoder();
      const contenidoBytes = encoder.encode(contenidoWindows);
      
      const blob = new Blob([contenidoBytes], { 
        type: 'text/plain;charset=utf-8' 
      });
      
      // Crear enlace de descarga
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = nombreArchivo;
      
      // Ejecutar descarga
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Liberar memoria
      window.URL.revokeObjectURL(url);
      
      console.log(`✅ Archivo ${nombreArchivo} descargado exitosamente`);
      console.log(`🔧 Formato: UTF-8 sin BOM, CRLF (compatible PLAME)`);
      console.log(`📏 Tamaño: ${contenidoBytes.length} bytes`);
      alert(`📄 Archivo ${nombreArchivo} descargado exitosamente\n🔧 Formato optimizado para PLAME`);
      
    } catch (error) {
      console.error(`❌ Error descargando archivo ${tipoArchivo}:`, error);
      alert(`❌ Error al descargar el archivo ${tipoArchivo}: ${error.message}`);
    }
  };

  const descargarREM = async () => {
    try {
      setGenerandoPLAME(true);
      console.log('🔄 Iniciando descarga de archivo REM...');
      
      const contenido = generarArchivoREM();
      
      // Generar nombre con formato PLAME: 0601[YYYY][MM][RUC]
      console.log('🔍 DEBUG - Extrayendo fecha para nombre de archivo REM:');
      console.log('  📅 planillaParaVista.fecha_inicio:', planillaParaVista.fecha_inicio);
      console.log('  📅 planillaParaVista.fecha_fin:', planillaParaVista.fecha_fin);
      
      // Extraer año y mes de forma más robusta
      let año, mes;
      if (planillaParaVista.fecha_inicio) {
        // Si la fecha viene en formato YYYY-MM-DD, extraer directamente
        const fechaStr = planillaParaVista.fecha_inicio.toString();
        if (fechaStr.match(/^\d{4}-\d{2}-\d{2}/)) {
          const partes = fechaStr.split('-');
          año = parseInt(partes[0]);
          mes = partes[1]; // Ya viene en formato 01-12
          console.log('  📅 Extracción directa desde string:', { año, mes });
        } else {
          // Fallback: usar Date object
          const fechaPlanilla = new Date(planillaParaVista.fecha_inicio);
          año = fechaPlanilla.getFullYear();
          mes = (fechaPlanilla.getMonth() + 1).toString().padStart(2, '0');
          console.log('  📅 Extracción desde Date object:', { año, mes });
        }
      } else {
        // Usar fecha actual
        const fechaActual = new Date();
        año = fechaActual.getFullYear();
        mes = (fechaActual.getMonth() + 1).toString().padStart(2, '0');
        console.log('  📅 Usando fecha actual:', { año, mes });
      }
      
      console.log('  📊 año final:', año);
      console.log('  📊 mes final:', mes);
      console.log('  📊 Mes en palabras:', ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'][parseInt(mes) - 1]);
      
      const empresaRUC = selectedCompany?.ruc || '20000000000';
      const nombreArchivo = `0601${año}${mes}${empresaRUC}.rem`;
      
      console.log(`📄 Generando archivo REM con nombre: ${nombreArchivo}`);
      console.log(`📅 Período: ${año}-${mes} | RUC: ${empresaRUC}`);
      
      // Simular un pequeño delay para UX
      await new Promise(resolve => setTimeout(resolve, 500));
      
      descargarArchivoTXT(contenido, nombreArchivo, 'REM (Remuneraciones)');
      
    } catch (error) {
      console.error('❌ Error descargando archivo REM:', error);
      alert('❌ Error al generar el archivo REM: ' + error.message);
    } finally {
      setGenerandoPLAME(false);
    }
  };

  const descargarJOR = async () => {
    try {
      setGenerandoPLAME(true);
      console.log('🔄 Iniciando descarga de archivo JOR...');
      
      const contenido = generarArchivoJOR();
      
      // Generar nombre con formato PLAME: 0601[YYYY][MM][RUC]
      console.log('🔍 DEBUG - Extrayendo fecha para nombre de archivo JOR:');
      console.log('  📅 planillaParaVista.fecha_inicio:', planillaParaVista.fecha_inicio);
      console.log('  📅 planillaParaVista.fecha_fin:', planillaParaVista.fecha_fin);
      
      // Extraer año y mes de forma más robusta
      let año, mes;
      if (planillaParaVista.fecha_inicio) {
        // Si la fecha viene en formato YYYY-MM-DD, extraer directamente
        const fechaStr = planillaParaVista.fecha_inicio.toString();
        if (fechaStr.match(/^\d{4}-\d{2}-\d{2}/)) {
          const partes = fechaStr.split('-');
          año = parseInt(partes[0]);
          mes = partes[1]; // Ya viene en formato 01-12
          console.log('  📅 Extracción directa desde string:', { año, mes });
        } else {
          // Fallback: usar Date object
          const fechaPlanilla = new Date(planillaParaVista.fecha_inicio);
          año = fechaPlanilla.getFullYear();
          mes = (fechaPlanilla.getMonth() + 1).toString().padStart(2, '0');
          console.log('  📅 Extracción desde Date object:', { año, mes });
        }
      } else {
        // Usar fecha actual
        const fechaActual = new Date();
        año = fechaActual.getFullYear();
        mes = (fechaActual.getMonth() + 1).toString().padStart(2, '0');
        console.log('  📅 Usando fecha actual:', { año, mes });
      }
      
      console.log('  📊 año final:', año);
      console.log('  📊 mes final:', mes);
      console.log('  📊 Mes en palabras:', ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'][parseInt(mes) - 1]);
      
      const empresaRUC = selectedCompany?.ruc || '20000000000';
      const nombreArchivo = `0601${año}${mes}${empresaRUC}.jor`;
      
      console.log(`📄 Generando archivo JOR con nombre: ${nombreArchivo}`);
      console.log(`📅 Período: ${año}-${mes} | RUC: ${empresaRUC}`);
      
      // Simular un pequeño delay para UX
      await new Promise(resolve => setTimeout(resolve, 500));
      
      descargarArchivoTXT(contenido, nombreArchivo, 'JOR (Jornadas)');
      
    } catch (error) {
      console.error('❌ Error descargando archivo JOR:', error);
      alert('❌ Error al generar el archivo JOR: ' + error.message);
    } finally {
      setGenerandoPLAME(false);
    }
  };

  const descargarAFPnet = async () => {
    try {
      setGenerandoPLAME(true);
      const resultado = await generarExcelAfpnet({
        empleados: empleadosParaArchivosPlame,
        planilla: planillaParaVista,
        empresa: selectedCompany,
      });

      const advertencia = resultado.sinBase > 0
        ? `\n⚠️ ${resultado.sinBase} trabajador(es) quedaron con remuneración asegurable 0.00; revise sus conceptos AFP.`
        : '';
      alert(
        `✅ Archivo AFPnet generado correctamente\n\n` +
        `Afiliados AFP: ${resultado.total}\n` +
        `Régimen normal: ${resultado.normales}\n` +
        `Régimen minero: ${resultado.mineros}` +
        advertencia
      );
    } catch (error) {
      console.error('❌ Error generando archivo AFPnet:', error);
      alert(`❌ Error al generar AFPnet: ${error.message}`);
    } finally {
      setGenerandoPLAME(false);
    }
  };

  // 📊 USAR DATOS REALES DE LA PLANILLA O FALLBACK CON VALIDACIÓN
  const planillaParaVista = planillaReal || planilla || {
    id: parseInt(id),
    nombre: 'Cargando...',
    periodo: 'Cargando...',
    fecha_inicio: null,
    fecha_fin: null,
    estado: 'proceso',
    total_empleados: 0,
    created_at: null
  };

  // Planilla RH (Recibo por Honorarios): ocultar ONP/RG y mostrar "RH" en lugar de "Original"
  const esPlanillaRH =
    planillaParaVista?.modalidad_planilla === 'planilla_rh' ||
    (planillaParaVista?.nombre &&
      (String(planillaParaVista.nombre).toUpperCase().trim() === 'RH' ||
        String(planillaParaVista.nombre).toUpperCase().includes('RH')));
  const ocultarHorasExtrasEnVista = false;
  
  const estadoConfig = getEstadoBadge(planillaParaVista.estado || 'proceso');

  return (
    <div className="space-y-3 lg:space-y-4">
      {/* Header */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
        <div className="flex items-center space-x-4">
          <button
            onClick={() => navigate('/planillas')}
            className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <div>
            <h1 className="text-xl lg:text-2xl font-bold text-gray-900">
              Planilla - {planillaParaVista.periodo || planillaParaVista.nombre || 'Planilla'}
            </h1>
            <p className="text-gray-600">{planillaParaVista.descripcion || 'Cargando información...'}</p>
          </div>
        </div>
        <div className="flex items-center space-x-3">
          {/* 📊 INDICADOR DE ESTADO - Solo visible si planilla NO está cerrada */}
          {!planillaCerrada && (
            <span className={`inline-flex items-center px-3 py-1 text-sm font-semibold rounded-full ${estadoConfig.class}`}>
              <span className="mr-1">{estadoConfig.icon}</span>
              {estadoConfig.text}
            </span>
          )}
          
          {/* 🔒 INDICADOR DE PLANILLA CERRADA */}
          {planillaCerrada && (
            <span className="inline-flex items-center px-3 py-1 text-sm font-semibold rounded-full bg-gray-100 text-gray-800 border-2 border-gray-300">
              <span className="mr-1">🔒</span>
              {empleadosEnAjustePosteriorIds.size > 0
                ? `Ajustes posteriores: ${empleadosEnAjustePosteriorIds.size} trabajador(es)`
                : 'Solo Lectura'}
            </span>
          )}
          {mostrarConexionJatsa(planillaReal?.jatsa_ingesta_enabled) && (
            <JatsaConexionBadge />
          )}
          {mostrarIngestaJatsa({
            planillaCerrada,
            enabled: planillaReal?.jatsa_ingesta_enabled,
          }) && (
            <JatsaIngestaEstado
              estado={planillaReal?.jatsa_estado}
              error={planillaReal?.jatsa_error}
              enviando={reenviandoJatsa}
              onReenviar={handleReenviarJatsa}
              conceptosEstado={planillaReal?.jatsa_conceptos_estado}
              conceptosError={planillaReal?.jatsa_conceptos_error}
              consultando={consultandoConceptosJatsa}
              aplicando={aplicandoConceptosJatsa}
              revirtiendo={revirtiendoJatsa}
              onConsultar={() => handleConsultarConceptosJatsa({ silencioso: false })}
              onAplicar={handleAplicarConceptosJatsa}
              onVerDatosApi={handleVerDatosConceptosJatsa}
              onRevertir={handleRevertirJatsa}
              hrefJatsa={urlFichaCerradaJatsa(
                planillaParaVista.periodo || planillaParaVista.nombre,
                ENV_CONFIG.JATSA_FRONTEND_URL,
              )}
              abriendoJatsa={abriendoJatsa}
              onAbrirJatsa={handleAbrirJatsa}
              puedeRevertir={haySincronizacionJatsaParaRevertir({
                estado: planillaReal?.jatsa_estado,
                conceptosEstado: planillaReal?.jatsa_conceptos_estado,
              })}
            />
          )}
          
          {/* ✅ INDICADOR DE DATOS CALCULADOS - Solo visible si planilla NO está cerrada */}
          {!planillaCerrada && empleadosFotografiadosIds.size > 0 && (
            <span className="inline-flex items-center px-3 py-1 text-sm font-semibold rounded-full bg-indigo-100 text-indigo-900">
              Pre-cierre: {empleadosFotografiadosIds.size} / {idsEsperadosPeriodoPlanilla().length || '—'}
            </span>
          )}
          {!planillaCerrada && empleadosConBoletasCalculadas.length > 0 && (
            <span className="inline-flex items-center px-3 py-1 text-sm font-semibold rounded-full bg-green-100 text-green-800">
              <span className="mr-1">✅</span>
              Datos Calculados
            </span>
          )}
          
          {/* 🧮 BOTÓN CALCULAR PLANILLA - Solo visible si planilla NO está cerrada */}
          {!planillaCerrada && planillaParaVista.estado === 'proceso' && empleadosActivosPlanilla.length > 0 && (
            <button
              onClick={procesarEmpleadosConPlanilla}
              disabled={loading || calculandoPlanilla}
              className={`flex items-center space-x-2 px-4 py-2 text-white rounded-lg transition-colors text-sm font-medium disabled:bg-gray-400 disabled:cursor-not-allowed ${
                empleadosConBoletasCalculadas.length > 0 
                  ? 'bg-orange-600 hover:bg-orange-700' 
                  : 'bg-blue-600 hover:bg-blue-700'
              }`}
              title={empleadosConBoletasCalculadas.length > 0 ? "Recalcular planilla" : "Calcular planilla completa"}
            >
              {calculandoPlanilla ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                  <span>Calculando...</span>
                </>
              ) : (
                <>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                  </svg>
                  <span>{empleadosConBoletasCalculadas.length > 0 ? "Recalcular" : "Calcular Planilla"}</span>
                </>
              )}
            </button>
          )}

          {/* 🔍 BOTÓN ANÁLISIS INDIVIDUAL - Solo visible si planilla NO está cerrada */}
          {!planillaCerrada && planillaParaVista.estado === 'proceso' && empleadosActivosPlanilla.length > 0 && (
            <button
              onClick={openAnalisisModal}
              disabled={loading}
              className="flex items-center space-x-2 px-4 py-2 text-white rounded-lg transition-colors text-sm font-medium disabled:bg-gray-400 disabled:cursor-not-allowed bg-indigo-600 hover:bg-indigo-700"
              title="Abrir análisis individual de empleados (solo logs internos)"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>Análisis Individual</span>
            </button>
          )}

          {/* 📄 BOTÓN DESCARGAR BOLETAS (masivo) — planilla abierta con cálculo o cerrada */}
          {empleadosConBoletasCalculadas.length > 0 && (
            <button
              onClick={exportarTodasLasBoletas}
              disabled={loading || generandoBoletas}
              className="flex items-center space-x-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors text-sm font-medium disabled:bg-gray-400 disabled:cursor-not-allowed"
              title={`Descargar PDF con ${aplicarFiltros(empleadosParaVista).length} boletas filtradas`}
            >
              {generandoBoletas ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                  <span>Generando...</span>
                </>
              ) : (
                <>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <span>Descargar Boletas</span>
                </>
              )}
            </button>
          )}
          
          {!planillaCerrada && planillaParaVista.estado === 'proceso' && (
            <button
              onClick={handleCerrarPlanilla}
              disabled={Boolean(progresoCierre?.visible)}
              className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm font-medium disabled:bg-gray-400 disabled:cursor-not-allowed"
            >
              {progresoCierre?.visible ? 'Cerrando...' : 'Cerrar Planilla'}
            </button>
          )}
        </div>
      </div>

      {/* Info Cards */}
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 lg:gap-4">
        <div className="bg-white rounded-xl p-3 lg:p-4 shadow-sm border border-gray-200">
          <div className="text-center">
            <p className="text-xs lg:text-sm font-medium text-gray-600">Período</p>
            <p className="text-sm lg:text-base font-bold text-gray-900">
              {planillaParaVista.fecha_inicio ? formatDateToDDMMYYYY(planillaParaVista.fecha_inicio) : 'N/A'} - {planillaParaVista.fecha_fin ? formatDateToDDMMYYYY(planillaParaVista.fecha_fin) : 'N/A'}
            </p>
          </div>
        </div>

        <div className="bg-white rounded-xl p-3 lg:p-4 shadow-sm border border-gray-200">
          <div className="text-center">
            <p className="text-xs lg:text-sm font-medium text-gray-600">Empleados Activos</p>
            <p className="text-lg lg:text-2xl font-bold text-blue-600">
              {filtrarEmpleadosPorComputoRh(empleadosActivosPlanilla).length || empleadosActivosPlanilla.length}
            </p>
          </div>
        </div>

        <div className="bg-white rounded-xl p-3 lg:p-4 shadow-sm border border-gray-200">
          <div className="text-center">
            <p className="text-xs lg:text-sm font-medium text-gray-600">Total Ingresos</p>
            {planillaAlternativaActiva ? (
              <div className="space-y-0.5">
                <p className="text-xs text-teal-700">
                  PLAME: <span className="font-bold">{formatCurrency(totalesGeneralesPlame.totalIngresos)}</span>
                </p>
                <p className="text-xs text-amber-800">
                  Interna: <span className="font-bold">{formatCurrency(totalesGeneralesInterna.totalIngresos)}</span>
                </p>
              </div>
            ) : (
            <p className="text-sm lg:text-lg font-bold text-green-600">{formatCurrency(totalesGenerales.totalIngresos)}</p>
            )}
          </div>
        </div>

        <div className="bg-white rounded-xl p-3 lg:p-4 shadow-sm border border-gray-200">
          <div className="text-center">
            <p className="text-xs lg:text-sm font-medium text-gray-600">Total Descuentos</p>
            {planillaAlternativaActiva ? (
              <div className="space-y-0.5">
                <p className="text-xs text-teal-700">
                  PLAME: <span className="font-bold">{formatCurrency(totalesGeneralesPlame.totalDescuentos)}</span>
                </p>
                <p className="text-xs text-amber-800">
                  Interna: <span className="font-bold">{formatCurrency(totalesGeneralesInterna.totalDescuentos)}</span>
                </p>
              </div>
            ) : (
            <p className="text-sm lg:text-lg font-bold text-red-600">{formatCurrency(totalesGenerales.totalDescuentos)}</p>
            )}
          </div>
        </div>

        <div className="bg-white rounded-xl p-3 lg:p-4 shadow-sm border border-gray-200">
          <div className="text-center">
            <p className="text-xs lg:text-sm font-medium text-gray-600">Neto a Pagar</p>
            {planillaAlternativaActiva ? (
              <div className="space-y-0.5">
                <p className="text-xs text-teal-700">
                  PLAME: <span className="font-bold">{formatCurrency(totalesGeneralesPlame.netoTotal)}</span>
                </p>
                <p className="text-xs text-amber-800">
                  Interna: <span className="font-bold">{formatCurrency(totalesGeneralesInterna.netoTotal)}</span>
                </p>
              </div>
            ) : (
            <p className="text-sm lg:text-lg font-bold text-teal-600">{formatCurrency(totalesGenerales.netoTotal)}</p>
            )}
          </div>
        </div>
      </div>



      {/* Tabs */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-4 lg:space-x-8 overflow-x-auto">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center space-x-2 py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${
                activeTab === tab.id
                  ? 'border-teal-500 text-teal-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <span>{tab.icon}</span>
              <span className="hidden sm:inline">{tab.name}</span>
            </button>
          ))}
        </nav>
      </div>

      {/* Content */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        {/* Resumen General */}
        {activeTab === 'resumen' && (
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-6">Resumen General de la Planilla</h3>
            
            {/* Filtros para Resumen General */}
            <div className="mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-4">
                <h4 className="text-md font-medium text-gray-700">🔍 Filtros de Empleados</h4>
                <div className="text-sm text-gray-600 mt-2 lg:mt-0">
                  <span className="font-semibold text-blue-600">{empleadosParaVista.length}</span> de {empleadosConBoletasCalculadas.length > 0 ? empleadosConBoletasCalculadas.length : empleadosActivosPlanilla.length} empleados mostrados
                </div>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                <MultiFiltroCargoComponent idSufijo="resumen" />
                <MultiFiltroAreaComponent idSufijo="resumen" />
                <MultiFiltroProyectoComponent idSufijo="resumen" />
              </div>
            </div>
            
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              {/* Ingresos */}
              <div className="bg-green-50 rounded-lg p-4">
                <div className="flex items-center justify-between mb-3">
                  <h4 className="font-semibold text-green-800">💰 Total Ingresos</h4>
                  {!planillaAlternativaActiva && (
                  <span className="text-lg font-bold text-green-600">{formatCurrency(totalesGenerales.totalIngresos)}</span>
                  )}
                </div>
                {planillaAlternativaActiva ? (
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between items-center">
                      <span className="text-teal-800 font-medium">PLAME</span>
                      <span className="font-bold text-teal-700">{formatCurrency(totalesGeneralesPlame.totalIngresos)}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-amber-900 font-medium">Interna</span>
                      <span className="font-bold text-amber-800">{formatCurrency(totalesGeneralesInterna.totalIngresos)}</span>
                    </div>
                  </div>
                ) : (
                <p className="text-sm text-green-700">Suma de todos los conceptos de ingresos</p>
                )}
              </div>

              {/* Descuentos */}
              <div className="bg-red-50 rounded-lg p-4">
                <div className="flex items-center justify-between mb-3">
                  <h4 className="font-semibold text-red-800">➖ Total Descuentos</h4>
                  {!planillaAlternativaActiva && (
                  <span className="text-lg font-bold text-red-600">{formatCurrency(totalesGenerales.totalDescuentos)}</span>
                  )}
                </div>
                {planillaAlternativaActiva ? (
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between items-center">
                      <span className="text-teal-800 font-medium">PLAME</span>
                      <span className="font-bold text-teal-700">{formatCurrency(totalesGeneralesPlame.totalDescuentos)}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-amber-900 font-medium">Interna</span>
                      <span className="font-bold text-amber-800">{formatCurrency(totalesGeneralesInterna.totalDescuentos)}</span>
                    </div>
                  </div>
                ) : (
                <p className="text-sm text-red-700">Suma de todos los descuentos aplicados</p>
                )}
              </div>

              {/* Aportes */}
              <div className="bg-blue-50 rounded-lg p-4">
                <div className="flex items-center justify-between mb-3">
                  <h4 className="font-semibold text-blue-800">🏛️ Total Aportes</h4>
                  {!planillaAlternativaActiva && (
                  <span className="text-lg font-bold text-blue-600">{formatCurrency(totalesGenerales.totalAportes)}</span>
                  )}
                </div>
                {planillaAlternativaActiva ? (
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between items-center">
                      <span className="text-teal-800 font-medium">PLAME</span>
                      <span className="font-bold text-teal-700">{formatCurrency(totalesGeneralesPlame.totalAportes)}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-amber-900 font-medium">Interna</span>
                      <span className="font-bold text-amber-800">{formatCurrency(totalesGeneralesInterna.totalAportes)}</span>
                    </div>
                  </div>
                ) : (
                <p className="text-sm text-blue-700">Aportes patronales (EsSalud, SCTR, etc.)</p>
                )}
              </div>
            </div>

            {/* Neto Total */}
            <div className="mt-6 bg-teal-50 rounded-lg p-4">
              {planillaAlternativaActiva ? (
                <div className="space-y-3">
                  <h4 className="text-lg font-semibold text-teal-800">💳 Neto Total a Pagar</h4>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div className="bg-white/70 rounded-lg border border-teal-200 p-3">
                      <p className="text-sm font-medium text-teal-800 mb-1">PLAME</p>
                      <p className="text-xl font-bold text-teal-700">{formatCurrency(totalesGeneralesPlame.netoTotal)}</p>
                    </div>
                    <div className="bg-white/70 rounded-lg border border-amber-200 p-3">
                      <p className="text-sm font-medium text-amber-900 mb-1">Interna (alternativa)</p>
                      <p className="text-xl font-bold text-amber-800">{formatCurrency(totalesGeneralesInterna.netoTotal)}</p>
                    </div>
                  </div>
                </div>
              ) : (
              <div className="flex items-center justify-between">
                <h4 className="text-lg font-semibold text-teal-800">💳 Neto Total a Pagar</h4>
                <span className="text-2xl font-bold text-teal-600">{formatCurrency(totalesGenerales.netoTotal)}</span>
              </div>
              )}
            </div>

            {/* Resumen por tipo de AFP, ONP y ESSALUD - No mostrar en planilla RH */}
            {!esPlanillaRH && (
            <div className="mt-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Resumen por Tipo de AFP, ONP, ESSALUD, Renta, Grati y Viáticos</h3>
              
                             {/* Resumen AFP */}
               <div className="mb-6">
                 <h4 className="text-md font-semibold text-gray-900 mb-2">📘 AFP - Descuentos por Sistema</h4>
                 {resumenSistemasPensionarios.tieneRegimenMinero && (
                   <p className="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 mb-3">
                     ⛏️ Planilla con régimen minero: el total AFP incluye aportación trabajador (0611) y aporte empleador (0809).
                   </p>
                 )}
                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                   {Object.entries(resumenSistemasPensionarios.afp).map(([afp, data]) => {
                     const totalAfpMinero = data.totalDescuentosAfp + data.aportacionTrabajador0611 + data.aporteEmpleador0809;
                     const totalMostrar = resumenSistemasPensionarios.tieneRegimenMinero
                       ? totalAfpMinero
                       : data.totalDescuentosAfp;

                     return (
                     <div key={afp} className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                       <div className="flex items-center justify-between mb-3">
                         <h5 className="font-semibold text-blue-800">{afp}</h5>
                         <span className="text-lg font-bold text-blue-600">{formatCurrency(totalMostrar)}</span>
                       </div>
                       {resumenSistemasPensionarios.tieneRegimenMinero && (
                         <div className="space-y-1 text-sm mb-3 border-b border-blue-200 pb-3">
                           <div className="flex justify-between text-blue-700">
                             <span>AFP normal (0608, 0601, 0606)</span>
                             <span className="font-medium">{formatCurrency(data.totalDescuentosAfp)}</span>
                           </div>
                           <div className="flex justify-between text-blue-700">
                             <span>Aportación trabajador (0611)</span>
                             <span className="font-medium">{formatCurrency(data.aportacionTrabajador0611)}</span>
                           </div>
                           <div className="flex justify-between text-blue-700">
                             <span>Aporte empleador (0809)</span>
                             <span className="font-medium">{formatCurrency(data.aporteEmpleador0809)}</span>
                           </div>
                         </div>
                       )}
                       <div className="flex justify-between">
                         <span className="text-blue-700">👥 Empleados:</span>
                         <span className="font-medium text-blue-800">
                           {data.totalEmpleados}
                           {resumenSistemasPensionarios.tieneRegimenMinero && data.empleadosMinero > 0
                             ? ` (${data.empleadosMinero} minero${data.empleadosMinero > 1 ? 's' : ''})`
                             : ''}
                         </span>
                       </div>
                     </div>
                   )})}
                 </div>
                 
                 {/* Total General AFP */}
                 {Object.keys(resumenSistemasPensionarios.afp).length > 0 && (
                   <div className="mt-4">
                     <div className="bg-blue-100 border-2 border-blue-300 rounded-lg p-4">
                       <div className="flex items-center justify-between mb-3">
                         <h5 className="font-bold text-blue-900">💰 TOTAL GENERAL AFP</h5>
                         <span className="text-xl font-bold text-blue-700">
                           {formatCurrency(resumenSistemasPensionarios.totalGeneralAfp)}
                         </span>
                       </div>
                       <div className="flex justify-between">
                         <span className="text-blue-800 font-medium">👥 Total Empleados AFP:</span>
                         <span className="font-bold text-blue-900">
                           {Object.values(resumenSistemasPensionarios.afp).reduce((sum, afp) => sum + afp.totalEmpleados, 0)}
                         </span>
                       </div>
                     </div>
                   </div>
                 )}
                 
                 {Object.keys(resumenSistemasPensionarios.afp).length === 0 && (
                   <div className="bg-gray-50 rounded-lg p-4 text-center">
                     <span className="text-gray-500">No hay empleados afiliados a AFP</span>
                   </div>
                 )}
               </div>

                                            {/* Resumen ONP */}
               <div className="mb-6">
                 <h4 className="text-md font-semibold text-gray-900 mb-2">🟣 ONP - Descuentos</h4>
                 <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
                   <div className="flex items-center justify-between mb-3">
                     <h5 className="font-semibold text-purple-800">Total ONP</h5>
                     <span className="text-lg font-bold text-purple-600">{formatCurrency(resumenSistemasPensionarios.onp.totalDescuentos)}</span>
                   </div>
                   <div className="flex justify-between">
                     <span className="text-purple-700">👥 Empleados:</span>
                     <span className="font-medium text-purple-800">{resumenSistemasPensionarios.onp.totalEmpleados}</span>
                   </div>
                 </div>
               </div>

               {/* Resumen ESSALUD */}
               <div className="mb-6">
                 <h4 className="text-md font-semibold text-gray-900 mb-2">🟢 ESSALUD</h4>
                 <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                   <div className="flex items-center justify-between mb-3">
                     <h5 className="font-semibold text-green-800">Total ESSALUD</h5>
                     <span className="text-lg font-bold text-green-600">{formatCurrency(resumenSistemasPensionarios.essalud.totalAporte)}</span>
                   </div>
                   <div className="flex justify-between">
                     <span className="text-green-700">👥 Empleados:</span>
                     <span className="font-medium text-green-800">{resumenSistemasPensionarios.essalud.totalEmpleados}</span>
                   </div>
                 </div>
               </div>

               {/* Resumen Renta 5ta - solo si hay retención */}
               {resumenSistemasPensionarios.renta.totalDescuentos > 0 && (
               <div className="mb-6">
                 <h4 className="text-md font-semibold text-gray-900 mb-2">🧾 Renta 5ta Categoría</h4>
                 <div className="bg-rose-50 border border-rose-200 rounded-lg p-4">
                   <div className="flex items-center justify-between mb-3">
                     <h5 className="font-semibold text-rose-800">Total Renta (0605)</h5>
                     <span className="text-lg font-bold text-rose-600">{formatCurrency(resumenSistemasPensionarios.renta.totalDescuentos)}</span>
                   </div>
                   <div className="flex justify-between">
                     <span className="text-rose-700">👥 Empleados con retención:</span>
                     <span className="font-medium text-rose-800">{resumenSistemasPensionarios.renta.totalEmpleados}</span>
                 </div>
               </div>
            </div>
            )}

               {/* Gratificaciones / Viáticos / Movilidad Jatsa: informativos, no entran al neto */}
               {(resumenSistemasPensionarios.gratificaciones.totalMontoPlame > 0
                 || resumenSistemasPensionarios.gratificaciones.totalMontoInterna > 0
                 || resumenSistemasPensionarios.viaticos.totalMontoPlame > 0
                 || resumenSistemasPensionarios.viaticos.totalMontoInterna > 0
                 || resumenSistemasPensionarios.movilidades.totalMontoPlame > 0
                 || resumenSistemasPensionarios.movilidades.totalMontoInterna > 0
                 || resumenSistemasPensionarios.gratificaciones.totalMonto > 0
                 || resumenSistemasPensionarios.viaticos.totalMonto > 0
                 || resumenSistemasPensionarios.movilidades.totalMonto > 0) && (
               <div className="mb-6">
                 <h4 className="text-md font-semibold text-gray-900 mb-2">Conceptos que no ingresan al pago</h4>
                 <p className="text-sm text-slate-600 mb-3">
                   Solo declaración (PLAME/REM). No afectan el neto a pagar.
                 </p>
                 <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                   {(resumenSistemasPensionarios.gratificaciones.totalMonto > 0
                     || resumenSistemasPensionarios.gratificaciones.totalMontoPlame > 0
                     || resumenSistemasPensionarios.gratificaciones.totalMontoInterna > 0) && (
                   <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                     <h5 className="font-semibold text-amber-900 mb-3">Total Gratificaciones</h5>
                     {planillaAlternativaActiva && filtroTipoBoleta === 'todas' ? (
                       <div className="space-y-2">
                         {resumenSistemasPensionarios.gratificaciones.totalMontoPlame > 0 && (
                           <>
                             <div className="flex items-center justify-between">
                               <span className="text-amber-800">PLAME:</span>
                               <span className="font-bold text-amber-700">
                                 {formatCurrency(resumenSistemasPensionarios.gratificaciones.totalMontoPlame)}
                               </span>
                             </div>
                             <div className="flex justify-between text-sm">
                               <span className="text-amber-700">Empleados PLAME:</span>
                               <span className="font-medium text-amber-900">
                                 {resumenSistemasPensionarios.gratificaciones.totalEmpleadosPlame}
                               </span>
                             </div>
                           </>
                         )}
                         {resumenSistemasPensionarios.gratificaciones.totalMontoInterna > 0 && (
                           <>
                             <div className={`flex items-center justify-between ${resumenSistemasPensionarios.gratificaciones.totalMontoPlame > 0 ? 'pt-1 border-t border-amber-200' : ''}`}>
                               <span className="text-amber-800">Interna:</span>
                               <span className="font-bold text-amber-700">
                                 {formatCurrency(resumenSistemasPensionarios.gratificaciones.totalMontoInterna)}
                               </span>
                             </div>
                             <div className="flex justify-between text-sm">
                               <span className="text-amber-700">Empleados Interna:</span>
                               <span className="font-medium text-amber-900">
                                 {resumenSistemasPensionarios.gratificaciones.totalEmpleadosInterna}
                               </span>
                             </div>
                           </>
                         )}
                       </div>
                     ) : (
                       <>
                         <div className="flex items-center justify-between mb-3">
                           <span className="text-lg font-bold text-amber-700">
                             {formatCurrency(resumenSistemasPensionarios.gratificaciones.totalMonto)}
                           </span>
                         </div>
                         <div className="flex justify-between">
                           <span className="text-amber-800">Empleados:</span>
                           <span className="font-medium text-amber-900">
                             {resumenSistemasPensionarios.gratificaciones.totalEmpleados}
                           </span>
                         </div>
                       </>
                     )}
                   </div>
                   )}
                   {(resumenSistemasPensionarios.viaticos.totalMonto > 0
                     || resumenSistemasPensionarios.viaticos.totalMontoPlame > 0
                     || resumenSistemasPensionarios.viaticos.totalMontoInterna > 0) && (
                   <div className="bg-sky-50 border border-sky-200 rounded-lg p-4">
                     <h5 className="font-semibold text-sky-900 mb-3">Total Viáticos</h5>
                     {planillaAlternativaActiva && filtroTipoBoleta === 'todas' ? (
                       <div className="space-y-2">
                         {resumenSistemasPensionarios.viaticos.totalMontoPlame > 0 && (
                           <>
                             <div className="flex items-center justify-between">
                               <span className="text-sky-800">PLAME:</span>
                               <span className="font-bold text-sky-700">
                                 {formatCurrency(resumenSistemasPensionarios.viaticos.totalMontoPlame)}
                               </span>
                             </div>
                             <div className="flex justify-between text-sm">
                               <span className="text-sky-700">Empleados PLAME:</span>
                               <span className="font-medium text-sky-900">
                                 {resumenSistemasPensionarios.viaticos.totalEmpleadosPlame}
                               </span>
                             </div>
                           </>
                         )}
                         {resumenSistemasPensionarios.viaticos.totalMontoInterna > 0 && (
                           <>
                             <div className={`flex items-center justify-between ${resumenSistemasPensionarios.viaticos.totalMontoPlame > 0 ? 'pt-1 border-t border-sky-200' : ''}`}>
                               <span className="text-sky-800">Interna:</span>
                               <span className="font-bold text-sky-700">
                                 {formatCurrency(resumenSistemasPensionarios.viaticos.totalMontoInterna)}
                               </span>
                             </div>
                             <div className="flex justify-between text-sm">
                               <span className="text-sky-700">Empleados Interna:</span>
                               <span className="font-medium text-sky-900">
                                 {resumenSistemasPensionarios.viaticos.totalEmpleadosInterna}
                               </span>
                             </div>
                           </>
                         )}
                       </div>
                     ) : (
                       <>
                         <div className="flex items-center justify-between mb-3">
                           <span className="text-lg font-bold text-sky-700">
                             {formatCurrency(resumenSistemasPensionarios.viaticos.totalMonto)}
                           </span>
                         </div>
                         <div className="flex justify-between">
                           <span className="text-sky-800">Empleados:</span>
                           <span className="font-medium text-sky-900">
                             {resumenSistemasPensionarios.viaticos.totalEmpleados}
                           </span>
                         </div>
                       </>
                     )}
                   </div>
                   )}
                   {(resumenSistemasPensionarios.movilidades.totalMonto > 0
                     || resumenSistemasPensionarios.movilidades.totalMontoPlame > 0
                     || resumenSistemasPensionarios.movilidades.totalMontoInterna > 0) && (
                   <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                     <h5 className="font-semibold text-blue-900 mb-3">🚗 Total Movilidades</h5>
                     {planillaAlternativaActiva && filtroTipoBoleta === 'todas' ? (
                       <div className="space-y-2">
                         {resumenSistemasPensionarios.movilidades.totalMontoPlame > 0 && (
                           <>
                             <div className="flex items-center justify-between">
                               <span className="text-blue-800">PLAME:</span>
                               <span className="font-bold text-blue-700">
                                 {formatCurrency(resumenSistemasPensionarios.movilidades.totalMontoPlame)}
                               </span>
                             </div>
                             <div className="flex justify-between text-sm">
                               <span className="text-blue-700">Empleados PLAME:</span>
                               <span className="font-medium text-blue-900">
                                 {resumenSistemasPensionarios.movilidades.totalEmpleadosPlame}
                               </span>
                             </div>
                           </>
                         )}
                         {resumenSistemasPensionarios.movilidades.totalMontoInterna > 0 && (
                           <>
                             <div className={`flex items-center justify-between ${resumenSistemasPensionarios.movilidades.totalMontoPlame > 0 ? 'pt-1 border-t border-blue-200' : ''}`}>
                               <span className="text-blue-800">Interna:</span>
                               <span className="font-bold text-blue-700">
                                 {formatCurrency(resumenSistemasPensionarios.movilidades.totalMontoInterna)}
                               </span>
                             </div>
                             <div className="flex justify-between text-sm">
                               <span className="text-blue-700">Empleados Interna:</span>
                               <span className="font-medium text-blue-900">
                                 {resumenSistemasPensionarios.movilidades.totalEmpleadosInterna}
                               </span>
                             </div>
                           </>
                         )}
                       </div>
                     ) : (
                       <>
                         <div className="flex items-center justify-between mb-3">
                           <span className="text-lg font-bold text-blue-700">
                             {formatCurrency(resumenSistemasPensionarios.movilidades.totalMonto)}
                           </span>
                         </div>
                         <div className="flex justify-between">
                           <span className="text-blue-800">Empleados:</span>
                           <span className="font-medium text-blue-900">
                             {resumenSistemasPensionarios.movilidades.totalEmpleados}
                           </span>
                         </div>
                       </>
                     )}
                   </div>
                   )}
                 </div>
               </div>
               )}

               {/* Resumen FCJMUS 0616 - solo régimen minero */}
               {resumenSistemasPensionarios.tieneRegimenMinero && (
               <div>
                 <h4 className="text-md font-semibold text-gray-900 mb-2">⛏️ FCJMUS - Ley 29741 (0616)</h4>
                 <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                   <div className="flex items-center justify-between mb-3">
                     <h5 className="font-semibold text-amber-800">Aporte Mensual al FCJMUS</h5>
                     <span className="text-lg font-bold text-amber-600">{formatCurrency(resumenSistemasPensionarios.fcjmus0616.totalAporte)}</span>
                   </div>
                   <div className="flex justify-between">
                     <span className="text-amber-700">👥 Empleados:</span>
                     <span className="font-medium text-amber-800">{resumenSistemasPensionarios.fcjmus0616.totalEmpleados}</span>
                   </div>
                 </div>
               </div>
               )}
            </div>
            )}
          </div>
        )}

        {/* Consideraciones Previas a la Planilla */}
        {activeTab === 'consideraciones' && (
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-6">Consideraciones Previas a la Planilla</h3>
            
            <div className="space-y-6">
              {(planillaCerrada || planillaReal?.estado === 'cerrada') && (
                <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                  <p className="text-amber-900 text-sm">
                    Planilla <strong>cerrada</strong>: esta pestaña solo lista trabajadores en{' '}
                    <strong>ajuste posterior</strong> (reabiertos desde su ficha). El resto sigue en solo lectura.
                  </p>
                </div>
              )}
              {/* Descripción */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <div className="flex items-start space-x-3">
                  <span className="text-blue-500 text-xl">ℹ️</span>
                  <div>
                    <h4 className="font-semibold text-blue-800 mb-2">Información Importante</h4>
                    <p className="text-blue-700 text-sm">
                      En esta sección puedes ingresar datos pendientes de meses anteriores y realizar ajustes previos al cálculo de la planilla.
                      Las configuraciones aplican a los trabajadores que aún no tienen{' '}
                      <strong>pre-cierre</strong> guardado; los congelados no se listan ni se modifican aquí.
                    </p>
                  </div>
                </div>
              </div>

              {empleadosFotografiadosIds.size > 0 && (
                <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4">
                  <div className="flex items-start space-x-3">
                    <span className="text-indigo-500 text-xl">🔒</span>
                    <div>
                      <h4 className="font-semibold text-indigo-900 mb-1">Pre-cierre activo</h4>
                      <p className="text-indigo-800 text-sm">
                        {empleadosFotografiadosIds.size} trabajador(es) con cálculo congelado no aparecen en ninguna
                        tarjeta de esta pestaña. Para editarlos, usa «Volver a recalcular» en su ficha.
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {/* Grid de opciones */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                
                {/* Compensaciones */}
                <div className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow">
                  <div className="flex items-center space-x-3 mb-4">
                    <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                      <span className="text-2xl">💤</span>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">Compensaciones de Meses Pasados</h4>
                      <p className="text-sm text-gray-600">Ingresar horas pendientes de meses anteriores</p>
                    </div>
                  </div>
                  
                  <p className="text-gray-700 text-sm mb-4">
                    Registra manualmente las horas de compensación pendientes de meses anteriores que deben añadirse en esta planilla.
                  </p>
                  
                  <button 
                    onClick={openCompensacionesModal}
                    className="w-full bg-orange-500 hover:bg-orange-600 text-white font-medium py-2 px-4 rounded-lg transition-colors"
                  >
                    <span className="flex items-center justify-center space-x-2">
                      <span>📅</span>
                      <span>Ingresar Compensaciones</span>
                    </span>
                  </button>
                  
                  {/* Info adicional */}
                  <div className="mt-3 space-y-1">
                    <div className="text-xs text-gray-500 flex items-center space-x-2">
                      <span>📊</span>
                      <span>Total empleados: {empleadosEditablesConsideraciones?.length || 0}</span>
                    </div>
                    <div className="text-xs text-orange-600 flex items-center space-x-2">
                      <span>⏳</span>
                      <span>Datos de períodos anteriores</span>
                    </div>
                  </div>
                </div>

                {/* Ajustes de Sueldos */}
                <div className="bg-white border border-gray-200 rounded-lg p-6">
                  <div className="flex items-center space-x-3 mb-4">
                    <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
                      <span className="text-2xl">💰</span>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">Ajustes de Sueldos</h4>
                      <p className="text-sm text-gray-600">Modificaciones temporales de sueldos</p>
                    </div>
                  </div>
                  
                  <p className="text-gray-700 text-sm mb-4">
                    Aplica aumentos, descuentos o ajustes temporales a los sueldos básicos para esta planilla específica.
                  </p>
                  {empleadosFotografiadosIds.size > 0 && (
                    <p className="text-xs text-indigo-800 bg-indigo-50 border border-indigo-100 rounded-lg px-3 py-2 mb-4">
                      Misma regla que el resto de consideraciones: sin trabajadores con pre-cierre congelado.
                    </p>
                  )}
                  
                  <button 
                    className="w-full bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 text-white font-medium py-2 px-4 rounded-lg transition-all duration-200"
                    onClick={openAjustesSueldosModal}
                  >
                    <span className="flex items-center justify-center space-x-2">
                      <span>💰</span>
                      <span>Ingresar Ajustes</span>
                    </span>
                  </button>
                  
                  {/* Info adicional */}
                  <div className="mt-3 space-y-1">
                    <div className="text-xs text-gray-500 flex items-center space-x-2">
                      <span>👥</span>
                      <span>Total empleados: {empleadosEditablesConsideraciones?.length || 0}</span>
                    </div>
                    {Object.keys(conceptosTemporales).filter((eid) => !empleadosFotografiadosIds.has(Number(eid))).length > 0 && (
                      <div className="text-xs text-green-600 flex items-center space-x-2">
                        <span>✅</span>
                        <span>
                          {Object.keys(conceptosTemporales).filter((eid) => !empleadosFotografiadosIds.has(Number(eid))).length} empleado
                          {Object.keys(conceptosTemporales).filter((eid) => !empleadosFotografiadosIds.has(Number(eid))).length > 1 ? 's' : ''} con ajustes
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                {(() => {
                  const modalidadActual = String(planillaReal?.modalidad_planilla || '');
                  const esPlanillaConstruccion = modalidadActual.includes('construccion');
                  const esPlanillaJornales = modalidadActual === 'planilla_jornales';
                  if (esPlanillaConstruccion || esPlanillaJornales) return null;
                  const empleadosJornal = filtrarEmpleadosEditablesPlanilla(
                    (empleadosActivosPlanilla || []).filter((emp) => (
                      !esRegimenConstruccionCivil(emp, regimenesLaborales)
                    )),
                  );
                  if (!empleadosJornal.length) return null;
                  const cantidadOverride = empleadosJornal.filter((emp) => formaPagoPlanillaDe(emp.id)).length;
                  return (
                    <div className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow md:col-span-2">
                      <div className="flex items-center space-x-3 mb-4">
                        <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center">
                          <span className="text-2xl">📅</span>
                        </div>
                        <div>
                          <h4 className="font-semibold text-gray-900">Pago por jornal</h4>
                          <p className="text-sm text-gray-600">
                            Elige por trabajador la forma de pago y si aplica el descuento dominical
                          </p>
                        </div>
                      </div>

                      <p className="text-gray-700 text-sm mb-4">
                        Por defecto se usa la ficha del empleado. En jornal o mixto puedes cambiarlo solo para esta planilla.
                      </p>

                      <button
                        type="button"
                        onClick={openPagoJornalModal}
                        className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
                      >
                        <span className="flex items-center justify-center space-x-2">
                          <span>📅</span>
                          <span>Configurar jornal</span>
                        </span>
                      </button>

                      <div className="mt-3 space-y-1">
                        <div className="text-xs text-gray-500 flex items-center space-x-2">
                          <span>👥</span>
                          <span>Total trabajadores: {empleadosJornal.length}</span>
                        </div>
                        {cantidadOverride > 0 && (
                          <div className="text-xs text-emerald-700 flex items-center space-x-2">
                            <span>✅</span>
                            <span>{cantidadOverride} trabajador(es) con override en esta planilla</span>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })()}

                {(() => {
                  const esPlanillaConstruccion = String(planillaReal?.modalidad_planilla || '').includes('construccion');
                  const empleadosConsu = filtrarEmpleadosEditablesPlanilla(
                    (empleadosActivosPlanilla || []).filter((emp) =>
                      esPlanillaConstruccion || esRegimenConstruccionCivil(emp, regimenesLaborales)
                    ),
                  );
                  if (!empleadosConsu.length) return null;
                  const cantidadForzada = empleadosConsu.filter((emp) => periodoGratiConsuDe(emp.id) !== 'auto').length;
                  return (
                    <div className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow">
                      <div className="flex items-center space-x-3 mb-4">
                        <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                          <span className="text-2xl">🏗️</span>
                        </div>
                        <div>
                          <h4 className="font-semibold text-gray-900">Gratificación construcción civil</h4>
                          <p className="text-sm text-gray-600">
                            Elige por trabajador enero–julio o agosto–diciembre
                          </p>
                        </div>
                      </div>

                      <p className="text-gray-700 text-sm mb-4">
                        Por defecto septiembre usa Navidad (÷5). Cámbialo por trabajador si aún pagan Fiestas Patrias.
                      </p>

                      <button
                        type="button"
                        onClick={openGratiConsuModal}
                        className="w-full bg-orange-600 hover:bg-orange-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
                      >
                        <span className="flex items-center justify-center space-x-2">
                          <span>🏗️</span>
                          <span>Configurar gratificación</span>
                        </span>
                      </button>

                      <div className="mt-3 space-y-1">
                        <div className="text-xs text-gray-500 flex items-center space-x-2">
                          <span>👥</span>
                          <span>Total trabajadores: {empleadosConsu.length}</span>
                        </div>
                        {cantidadForzada > 0 && (
                          <div className="text-xs text-orange-700 flex items-center space-x-2">
                            <span>✅</span>
                            <span>{cantidadForzada} trabajador(es) con periodo distinto</span>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })()}

                {(() => {
                  if (!esPlanillaModalidadConstruccion(planillaReal)) return null;
                  const empleadosConsu = filtrarEmpleadosEditablesPlanilla(empleadosActivosPlanilla || []);
                  if (!empleadosConsu.length) return null;
                  const inicioPlanilla = String(planillaReal?.fecha_inicio || '').slice(0, 10);
                  const finPlanilla = String(planillaReal?.fecha_fin || '').slice(0, 10);
                  const cantidadOverride = empleadosConsu.filter((emp) =>
                    Boolean(fechaCalculoDesdeDe(emp.id) || fechaCalculoHastaDe(emp.id))
                  ).length;
                  return (
                    <div className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow">
                      <div className="flex items-center space-x-3 mb-4">
                        <div className="w-12 h-12 bg-sky-100 rounded-lg flex items-center justify-center">
                          <span className="text-2xl">📅</span>
                        </div>
                        <div>
                          <h4 className="font-semibold text-gray-900">Periodo de cálculo</h4>
                          <p className="text-sm text-gray-600">
                            Fecha de cálculo por trabajador, dentro del periodo de la planilla
                          </p>
                        </div>
                      </div>

                      <p className="text-gray-700 text-sm mb-4">
                        Periodo general: {inicioPlanilla || '—'} a {finPlanilla || '—'}.
                        Si dejas un campo vacío se usa la fecha de la planilla.
                      </p>

                      <button
                        type="button"
                        onClick={openPeriodoCalculoConsuModal}
                        className="w-full bg-sky-600 hover:bg-sky-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
                      >
                        <span className="flex items-center justify-center space-x-2">
                          <span>📅</span>
                          <span>Configurar fechas</span>
                        </span>
                      </button>

                      <div className="mt-3 space-y-1">
                        <div className="text-xs text-gray-500 flex items-center space-x-2">
                          <span>👥</span>
                          <span>Total trabajadores: {empleadosConsu.length}</span>
                        </div>
                        {cantidadOverride > 0 && (
                          <div className="text-xs text-sky-700 flex items-center space-x-2">
                            <span>✅</span>
                            <span>{cantidadOverride} trabajador(es) con fecha distinta</span>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })()}

                {/* Seguros de planilla */}
                <div className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow md:col-span-2">
                  <div className="flex items-center space-x-3 mb-4">
                    <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center">
                      <span className="text-2xl">🛡️</span>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">Seguros de Planilla</h4>
                      <p className="text-sm text-gray-600">Aportes PLAME 0803, 0805, 0806 y 0810</p>
                    </div>
                  </div>

                  <p className="text-gray-700 text-sm mb-4">
                    Registra montos de seguros por trabajador. Puedes configurar varios tipos a la vez y cada uno se aplicará como aporte en el cálculo.
                  </p>

                  {segurosPlanillaResumen.length > 0 ? (
                    <div className="flex flex-wrap gap-2 mb-4">
                      {segurosPlanillaResumen.map((seguro) => (
                        <span
                          key={seguro.codigo_plame}
                          className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800 border border-indigo-200"
                        >
                          <span>{seguro.codigo_plame}</span>
                          <span>{obtenerDescripcionSeguro(seguro.codigo_plame)}</span>
                          <span className="font-semibold">
                            S/ {Number(seguro.total_monto || 0).toFixed(2)}
                          </span>
                        </span>
                      ))}
                    </div>
                  ) : (
                    <div className="text-xs text-gray-500 mb-4">
                      Aún no hay seguros registrados para esta planilla.
                    </div>
                  )}

                  <button
                    type="button"
                    onClick={openSegurosModal}
                    className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
                  >
                    <span className="flex items-center justify-center space-x-2">
                      <span>🛡️</span>
                      <span>Agregar Seguros</span>
                    </span>
                  </button>

                  <div className="mt-3 space-y-1">
                    <div className="text-xs text-gray-500 flex items-center space-x-2">
                      <span>👥</span>
                      <span>Total empleados: {empleadosEditablesConsideraciones?.length || 0}</span>
                    </div>
                    <div className="text-xs text-indigo-600 flex items-center space-x-2">
                      <span>🏷️</span>
                      <span>{segurosPlanillaResumen.length} seguro(s) activo(s)</span>
                    </div>
                  </div>
                </div>

                {/* Eventos distintos PLAME vs interna */}
                {planillaAlternativaActiva && !planillaCerrada && planillaReal?.estado !== 'cerrada' && (
                  <div className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow md:col-span-2">
                    <div className="flex items-center space-x-3 mb-4">
                      <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center">
                        <span className="text-2xl">🔀</span>
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-900">Eventos distintos por boleta</h4>
                        <p className="text-sm text-gray-600">Mismo día, tipo distinto en PLAME e interna</p>
                      </div>
                    </div>

                    <p className="text-gray-700 text-sm mb-4">
                      Por empleado y fecha puedes indicar un evento para PLAME y otro para la boleta interna
                      (p. ej. vacaciones ↔ asistió). El tareo original no se modifica.
                    </p>

                    {Object.keys(overridesTareoEvento || {}).length > 0 ? (
                      <div className="mb-4">
                        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800 border border-amber-200">
                          {Object.keys(overridesTareoEvento).length} día(s) con evento distinto
                        </span>
                      </div>
                    ) : (
                      <div className="text-xs text-gray-500 mb-4">
                        Sin cambios: se usa el tareo real en cada boleta.
                      </div>
                    )}

                    <button
                      type="button"
                      onClick={openEventosBoletaModal}
                      className="w-full bg-gradient-to-r from-teal-600 to-cyan-600 hover:from-teal-700 hover:to-cyan-700 text-white font-medium py-2 px-4 rounded-lg transition-all duration-200"
                    >
                      <span className="flex items-center justify-center space-x-2">
                        <span>🔀</span>
                        <span>Configurar eventos por boleta</span>
                      </span>
                    </button>
                  </div>
                )}

                {/* Cambio de sueldo a partir de un día (PLAME) */}
                {!planillaCerrada && planillaReal?.estado !== 'cerrada' && (
                  <div className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow md:col-span-2">
                    <div className="flex items-center space-x-3 mb-4">
                      <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center">
                        <span className="text-2xl">📅</span>
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-900">Cambio de sueldo a partir de un día</h4>
                        <p className="text-sm text-gray-600">
                          Hasta el día X un sueldo y el resto del mes otro — en PLAME, alternativa o ambas
                        </p>
                      </div>
                    </div>

                    <p className="text-gray-700 text-sm mb-4">
                      Ejemplo: hasta el 8 cobró S/ 1,500 y desde el 9 S/ 2,000. Elige si aplica a la boleta PLAME,
                      a la planilla alternativa, o a las dos.
                    </p>

                    {Object.entries(tramosSueldoPlame || {}).filter(
                      ([eid, t]) => t?.activo && !empleadosFotografiadosIds.has(Number(eid)),
                    ).length > 0 ? (
                      <div className="mb-4">
                        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800 border border-emerald-200">
                          {Object.entries(tramosSueldoPlame || {}).filter(
                            ([eid, t]) => t?.activo && !empleadosFotografiadosIds.has(Number(eid)),
                          ).length} empleado(s)
                          con cambio de sueldo
                        </span>
                      </div>
                    ) : (
                      <div className="text-xs text-gray-500 mb-4">
                        Sin cambio a mitad de mes: se usa el sueldo básico completo.
                      </div>
                    )}

                    <button
                      type="button"
                      onClick={openTramosSueldoModal}
                      className="w-full bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white font-medium py-2 px-4 rounded-lg transition-all duration-200"
                    >
                      <span className="flex items-center justify-center space-x-2">
                        <span>📅</span>
                        <span>Configurar cambio de sueldo</span>
                      </span>
                    </button>
                  </div>
                )}

                {planillaAlternativaActiva && !planillaCerrada && planillaReal?.estado !== 'cerrada' && (
                  <div className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow md:col-span-2">
                    <div className="flex items-center space-x-3 mb-4">
                      <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center">
                        <span className="text-2xl">📑</span>
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-900">Boleta interna en dos partes</h4>
                        <p className="text-sm text-gray-600">
                          Días con un sueldo y días con otro + destino del descuento PLAME
                        </p>
                      </div>
                    </div>

                    <p className="text-gray-700 text-sm mb-4">
                      Parte el período en dos boletas internas. Las faltas y eventos van a la parte
                      de su fecha. El descuento PLAME (ONP/AFP) se asigna a Interna 1 o 2.
                    </p>

                    {Object.entries(tramosBoletaInterna || {}).filter(
                      ([eid, t]) => t?.activo && !empleadosFotografiadosIds.has(Number(eid)),
                    ).length > 0 ? (
                      <div className="mb-4">
                        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800 border border-amber-200">
                          {Object.entries(tramosBoletaInterna || {}).filter(
                            ([eid, t]) => t?.activo && !empleadosFotografiadosIds.has(Number(eid)),
                          ).length} empleado(s)
                          con interna partida
                        </span>
                      </div>
                    ) : (
                      <div className="text-xs text-gray-500 mb-4">
                        Sin partición: una sola boleta interna por personal.
                      </div>
                    )}

                    <button
                      type="button"
                      onClick={openTramosInternaModal}
                      className="w-full bg-gradient-to-r from-amber-600 to-orange-500 hover:from-amber-700 hover:to-orange-600 text-white font-medium py-2 px-4 rounded-lg transition-all duration-200"
                    >
                      <span className="flex items-center justify-center space-x-2">
                        <span>📑</span>
                        <span>Configurar internas partidas</span>
                      </span>
                    </button>
                  </div>
                )}
                
              </div>

              {/* Nota informativa */}
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                <div className="flex items-start space-x-3">
                  <span className="text-amber-500 text-xl">⚠️</span>
                  <div>
                    <h4 className="font-semibold text-amber-800 mb-1">Importante</h4>
                    <p className="text-amber-700 text-sm">
                      Los datos ingresados en compensaciones corresponden a meses pasados y solo afectarán a la planilla actual. 
                      Estos ajustes no modifican los registros permanentes de los empleados.
                    </p>
                   </div>
                 </div>
               </div>
            </div>
          </div>
        )}

        {/* Por Empleado */}
        {activeTab === 'empleados' && (
          <div>
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4 sm:mb-0">Detalle por Empleado</h3>
              
              <div className="flex flex-row gap-6 flex-wrap">
              {/* 🔍 MULTIFILTRO POR CARGO */}
              <MultiFiltroCargoComponent idSufijo="empleados" />
                
                {/* 🏢 MULTIFILTRO POR ÁREA DE TRABAJO */}
                <MultiFiltroAreaComponent idSufijo="empleados" />
                
                {/* 📋 MULTIFILTRO POR PROYECTO */}
                <MultiFiltroProyectoComponent idSufijo="empleados" />

                <FiltroTipoBoletaControl idSufijo="empleados" />
              </div>
            </div>
            
            {/* Datos reales cargados desde el array unificado */}
            
            <div className="space-y-4">
              {empleadosParaVistaPorBoleta.length === 0 ? (
                <div className="text-center py-8">
                  <div className="text-gray-500 space-y-2">
                    {loading ? (
                      <>
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-500 mx-auto"></div>
                        <p>Cargando empleados activos...</p>
                      </>
                    ) : (
                      <>
                        <p>
                          {planillaAlternativaActiva && filtroTipoBoleta === 'plame'
                            ? 'No hay empleados con boleta PLAME para este filtro'
                            : planillaAlternativaActiva && filtroTipoBoleta === 'interna'
                              ? 'No hay empleados con boleta interna para este filtro'
                              : 'No hay empleados activos en el período de esta planilla'}
                        </p>
                        <p className="text-sm">Total empleados en empresa: {empleadosConConceptos.length}</p>
                        {planillaReal && (
                          <p className="text-sm">Período planilla: {planillaReal.fecha_inicio} - {planillaReal.fecha_fin}</p>
                        )}
                      </>
                    )}
                  </div>
                </div>
              ) : (
                empleadosParaVistaPorBoleta.map((empleadoFull) => {
                const empleado = empleadoParaBoletaOrdinaria(empleadoFull);
                return (
                <div key={empleado.id} className="border border-gray-200 rounded-lg p-4">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center">
                        <span className="text-white font-bold text-sm">
                          {empleado.nombre.charAt(0)}
                        </span>
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-900">{empleado.nombre}</h4>
                        <p className="text-sm text-gray-600">{empleado.proyecto || 'Sin proyecto'} • {empleado.areas_de_trabajo || 'Sin área'} • {empleado.cargo} • {empleado.categoria} • {empleado.documento}</p>
                        <div className="flex items-center space-x-2 mt-1">
                          {esPlanillaRH && (
                            <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-teal-100 text-teal-800">
                              RH
                            </span>
                          )}
                          {/* ONP/AFP: no mostrar en planilla RH, formación laboral ni solo interna */}
                          {!esPlanillaRH && !esRegimenFormacionLaboral(empleado) && !esEmpleadoSoloInterna(empleadoFull) && (
                          <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${
                            empleado.tipoAporte === 'ONP' 
                              ? 'bg-blue-100 text-blue-800' 
                              : 'bg-purple-100 text-purple-800'
                          }`}>
                            {empleado.tipoAporte === 'AFP' 
                              ? `${empleado.afp || 'Sin AFP'}${empleado.tipoHabitat ? ` ${empleado.tipoHabitat}` : ''}` 
                              : empleado.tipoAporte}
                          </span>
                          )}
                          {/* RG (régimen): no mostrar en planilla RH */}
                          {!esPlanillaRH && (
                          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                            {empleado.regimenLaboral}
                          </span>
                          )}
                          {(() => {
                            const cat = etiquetaCategoriaConsu(empleadoFull);
                            if (!cat) return null;
                            return (
                              <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${cat.className}`}>
                                {cat.texto}
                              </span>
                            );
                          })()}
                          {(() => {
                            const forma = etiquetaFormaPagoVista(empleadoFull);
                            if (!forma) return null;
                            return (
                              <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold ${forma.className}`}>
                                {forma.texto}
                              </span>
                            );
                          })()}
                          {!esPlanillaRH && empleadoTieneRentaQuinta(empleado) && (
                          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-amber-100 text-amber-800">
                            Renta 5ta
                          </span>
                          )}
                          
                          {/* Calculado / borrador (en RH la etiqueta va aparte) */}
                          {empleadosConBoletasCalculadas.find(emp => emp.id === empleado.id) ? (
                            <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                              ✅ Calculado
                            </span>
                          ) : (
                            !esPlanillaRH ? (
                              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800">
                                📋 Original
                              </span>
                            ) : null
                          )}
                          {(() => {
                            const textoInicio = textoFechaInicioReferencia(empleadoFull);
                            if (!textoInicio) return null;
                            return (
                              <span
                                className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-sky-50 text-sky-800 border border-sky-100"
                                title="Fecha de ingreso laboral (solo referencia; no modifica los montos calculados)"
                              >
                                Inicio {textoInicio}
                              </span>
                            );
                          })()}
                          {(() => {
                            const textoCese = textoFechaCeseReferencia(empleadoFull);
                            if (!textoCese) return null;
                            return (
                              <span
                                className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-amber-50 text-amber-900 border border-amber-100"
                                title="Fecha de cese dentro del periodo de esta planilla (solo referencia)"
                              >
                                Cese {textoCese}
                              </span>
                            );
                          })()}
                        </div>
                        {/* Información de Asistencia Detallada */}
                        <div className="mt-2 space-y-1">
                          {/* Primera línea: Registro general */}
                          <div className="flex items-center space-x-3 text-xs">
                            <span className="text-blue-600">
                              📋 {empleado.resumenTareos?.total_tareos || 0} registros
                            </span>
                          {empleado.tareos.asistenciaPerfecta && (
                            <span className="flex items-center text-green-600">
                              ✅ Asistencia Perfecta
                          </span>
                          )}
                          <span className="text-blue-600">
                            ⏰ {empleado.tareos.horasOrdinarias}h
                          </span>
                          </div>
                          
                          {/* Segunda línea: Detalles por tipo */}
                          <div className="flex items-center space-x-2 text-xs flex-wrap">
                            {empleado.tareos.diasTrabajados > 0 && (
                              <span className="text-green-600">✅ {empleado.tareos.diasTrabajados}</span>
                            )}
                            {empleado.tareos.faltas > 0 && (
                              <span className="text-red-600">❌ {empleado.tareos.faltas}</span>
                            )}
                            {empleado.tareos.vacaciones > 0 && (
                              <span className="text-yellow-600">🏖️ {empleado.tareos.vacaciones}</span>
                            )}
                            {empleado.tareos.permisos > 0 && (
                              <span className="text-purple-600">📋 {empleado.tareos.permisos}</span>
                            )}
                            {empleado.tareos.suspensiones > 0 && (
                              <span className="text-amber-600">⛔ {empleado.tareos.suspensiones}</span>
                            )}
                            {empleado.tareos.descansoMedico > 0 && (
                              <span className="text-pink-600">🏥 {empleado.tareos.descansoMedico}</span>
                            )}
                            {empleado.tareos.reposoMedico > 0 && (
                              <span className="text-rose-600">🛏️ {empleado.tareos.reposoMedico}</span>
                            )}
                            {empleado.tareos.subsidioPorEnfermedad > 0 && (
                              <span className="text-red-500">💊 {empleado.tareos.subsidioPorEnfermedad}</span>
                            )}
                            {empleado.tareos.licenciaConGoceHaber > 0 && (
                              <span className="text-indigo-600">🧾 {empleado.tareos.licenciaConGoceHaber}</span>
                            )}
                            {empleado.tareos.tardanzas > 0 && (
                              <span className="text-orange-600">⏱️ {empleado.tareos.tardanzas}</span>
                            )}
                            {empleado.tareos.feriados > 0 && (
                              <span className="text-blue-600">🎉 {empleado.tareos.feriados}</span>
                            )}
                            {empleado.tareos.feriadosLaborados > 0 && (
                              <span className="text-indigo-600">💼 {empleado.tareos.feriadosLaborados}</span>
                            )}
                            {empleado.tareos.descansos > 0 && (
                              <span className="text-gray-600">😴 {empleado.tareos.descansos}</span>
                            )}
                            {empleado.tareos.descansosLaborados > 0 && (
                              <span className="text-teal-600">⚡ {empleado.tareos.descansosLaborados}</span>
                            )}
                            {(() => {
                              const cuadre = getCuadreViaticosEmpleado(empleadoFull);
                              if (!cuadre) return null;
                              return (
                                <span
                                  className={
                                    cuadre.sinMontoEmpleado
                                      ? 'text-amber-600 font-medium'
                                      : cuadre.coincide
                                        ? 'text-green-700 font-medium'
                                        : 'text-red-600 font-medium'
                                  }
                                  title={cuadre.title}
                                >
                                  {etiquetaCuadreViaticos(cuadre)}
                                </span>
                              );
                            })()}
                            {empleadoTieneDeclaracionGratificacion(empleadoFull) && (
                              <span
                                className="text-amber-700 font-medium"
                                title="Gratificación / bonificación extraordinaria (declaración PLAME · no boleta ordinaria)"
                              >
                                🎁 Grati
                              </span>
                            )}
                            {empleadoTieneDeclaracionViatico(empleadoFull) && (
                              <span
                                className="text-amber-700 font-medium"
                                title="Viáticos (declaración · se informan, no afectan neto a pagar)"
                              >
                                🚕 Viático
                              </span>
                            )}
                            {empleadoTieneDeclaracionMovilidad(empleadoFull) && (
                              <span
                                className="text-blue-700 font-medium"
                                title="Movilidad Jatsa (declaración · se informa, no entra al pago)"
                              >
                                🚗 Movilidad
                              </span>
                            )}
                          </div>
                          

                        </div>
                      </div>
                    </div>
                    <div className="text-right space-y-2">
                      <div>
                        {(() => {
                          const tipo = String(empleadoFull.tipo_planilla || empleado.tipo_planilla || '').toLowerCase();
                          const esSoloInterna = planillaAlternativaActiva && tipo === 'solo_interna';
                          const canales = canalesBoletaDe(empleadoFull);
                          const tieneInterna = planillaAlternativaActiva && canales.interna;
                          const netoPlame = empleado.totales?.netoAPagar || 0;
                          const netoInterna =
                            empleado.totalesInternos?.netoAPagar ??
                            empleadoFull.totalesInternos?.netoAPagar ??
                            0;

                          const verPlame =
                            !planillaAlternativaActiva ||
                            (canales.plame && (
                              filtroTipoBoleta === 'plame' ||
                              filtroTipoBoleta === 'todas'
                            ));
                          const verInterna =
                            planillaAlternativaActiva &&
                            tieneInterna &&
                            (filtroTipoBoleta === 'interna' ||
                              filtroTipoBoleta === 'todas' ||
                              esSoloInterna);

                          if (planillaAlternativaActiva && (verPlame || verInterna) && (tieneInterna || esSoloInterna)) {
                            return (
                              <div className="space-y-1.5">
                                {verPlame && !esSoloInterna && (
                                  <div>
                                    <p className="text-xs text-gray-500">Neto PLAME</p>
                                    <p className="text-base font-bold text-teal-700 leading-tight">
                                      {formatCurrency(netoPlame)}
                                    </p>
                                  </div>
                                )}
                                {verInterna && (
                                  <div>
                                    {empleadoFull.boletaInternaPartida && empleadoFull.totalesInternos1 && empleadoFull.totalesInternos2 ? (
                                      <>
                                        <div>
                                          <p className="text-xs text-gray-500">
                                            Neto Interna 1
                                            {empleadoFull.diasInterna1 != null ? ` · ${empleadoFull.diasInterna1}d` : ''}
                                          </p>
                                          <p className="text-base font-bold text-amber-800 leading-tight">
                                            {formatCurrency(empleadoFull.totalesInternos1.netoAPagar || 0)}
                                          </p>
                                        </div>
                                        <div>
                                          <p className="text-xs text-gray-500">
                                            Neto Interna 2
                                            {empleadoFull.diasInterna2 != null ? ` · ${empleadoFull.diasInterna2}d` : ''}
                                          </p>
                                          <p className="text-base font-bold text-orange-800 leading-tight">
                                            {formatCurrency(empleadoFull.totalesInternos2.netoAPagar || 0)}
                                          </p>
                                        </div>
                                      </>
                                    ) : (
                                      <div>
                                        <p className="text-xs text-gray-500">Neto Interna</p>
                                        <p className="text-base font-bold text-amber-800 leading-tight">
                                          {formatCurrency(netoInterna)}
                                        </p>
                                        {empleadoFull.sueldoPartido ? (
                                          <p className="text-[10px] text-amber-800/80 mt-0.5 leading-tight">
                                            {textoAclaracionSueldoPartido({
                                              ...empleadoFull.sueldoPartido,
                                              formatCurrency,
                                            })}
                                          </p>
                                        ) : null}
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            );
                          }

                          return (
                            <>
                        <p className="text-sm text-gray-600">Neto a Pagar</p>
                              <p className="text-lg font-bold text-teal-600">{formatCurrency(netoPlame)}</p>
                              {empleadoFull.pagoJornal?.aclaracion ? (
                                <p className="text-xs text-emerald-700 mt-1">{empleadoFull.pagoJornal.aclaracion}</p>
                              ) : null}
                              {(() => {
                                const netoDia = netoPorDiaDeEmpleado(empleadoFull, empleado.totales);
                                if (!netoDia?.diasNeto) return null;
                                const periodo = periodoCalculoPersonalizadoDe(empleadoFull);
                                const textoPeriodo = textoPeriodoCalculoCorto(periodo);
                                return (
                                  <p className="text-xs text-teal-700 mt-1">
                                    Neto por día {formatCurrency(netoDia.netoPorDia)}
                                    <span className="text-gray-500"> · {netoDia.diasNeto}d</span>
                                    {textoPeriodo ? (
                                      <span className="text-sky-700"> · {textoPeriodo}</span>
                                    ) : null}
                                  </p>
                                );
                              })()}
                            </>
                          );
                        })()}
                      </div>
                      
                      {/* Estado del Tareo, pre-cierre y Ver Tareos */}
                      <div className="flex items-center justify-end space-x-2 flex-wrap gap-y-1">
                        {(() => {
                          const rango = fechasRangoTareoDe(empleadoFull);
                          const estado = getTareoStatus(empleado.tareos, empleado, rango.inicio, rango.fin);
                          const idEmp = Number(empleadoFull.id ?? empleadoFull.empleado_id);
                          const yaPreCierre = !planillaCerrada && empleadosFotografiadosIds.has(idEmp);
                          const enAjustePosterior = planillaCerrada && empleadosEnAjustePosteriorIds.has(idEmp);
                          const listoParaGuardar =
                            empleadoFull.boleta_calculada?.success || empleadoFull.totales?.netoAPagar;
                          return (
                            <>
                              {!planillaCerrada && yaPreCierre && (
                                <span
                                  className="inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold bg-violet-100 text-violet-900"
                                  title="Cálculo congelado; no se modifica al recalcular la planilla"
                                >
                                  Pre-cierre · congelado
                                </span>
                              )}
                              {planillaCerrada && enAjustePosterior && (
                                <span
                                  className="inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold bg-amber-100 text-amber-900"
                                  title="En ajuste posterior: puede usar consideraciones y recalcular"
                                >
                                  Ajuste posterior
                                </span>
                              )}
                              <div className="flex items-center space-x-1">
                                <span className={`text-xs font-medium ${estado.color}`}>
                                  {estado.icon}
                                </span>
                                <span className={`text-xs font-medium ${estado.color}`}>
                                  {estado.text}
                                </span>
                              </div>
                              <button
                                type="button"
                                onClick={() => openTareoModal(empleadoFull)}
                                className="px-2 py-1 text-xs bg-teal-100 text-teal-700 rounded hover:bg-teal-200 transition-colors font-medium"
                              >
                                Ver Tareos
                              </button>
                              {!planillaCerrada && yaPreCierre && (
                                <button
                                  type="button"
                                  disabled={reabriendoPreCierreId === idEmp}
                                  onClick={() => reabrirPreCierreEmpleado(idEmp)}
                                  className="px-2 py-1 text-xs font-medium bg-amber-100 text-amber-900 rounded hover:bg-amber-200 disabled:opacity-60 transition-colors"
                                  title="Elimina el snapshot y permite recalcular este trabajador"
                                >
                                  {reabriendoPreCierreId === idEmp ? 'Abriendo…' : 'Volver a recalcular'}
                                </button>
                              )}
                              {planillaCerrada && !enAjustePosterior && (
                                <button
                                  type="button"
                                  disabled={abriendoAjustePosteriorId === idEmp}
                                  onClick={() => abrirAjustePosteriorEmpleado(idEmp)}
                                  className="px-2 py-1 text-xs font-medium bg-sky-600 text-white rounded hover:bg-sky-700 disabled:opacity-60 transition-colors"
                                  title="Reabrir solo este trabajador para ajustes posteriores"
                                >
                                  {abriendoAjustePosteriorId === idEmp ? 'Abriendo…' : 'Reabrir'}
                                </button>
                              )}
                              {planillaCerrada && enAjustePosterior && (
                                <>
                                  <button
                                    type="button"
                                    disabled={calculandoPlanilla}
                                    onClick={() =>
                                      procesarEmpleadosConPlanilla({
                                        omitirConfirmacion: true,
                                        soloAjustePosteriorIds: [idEmp],
                                      })
                                    }
                                    className="px-2 py-1 text-xs font-medium bg-indigo-600 text-white rounded hover:bg-indigo-700 disabled:opacity-60 transition-colors"
                                  >
                                    {calculandoPlanilla ? 'Calculando…' : 'Recalcular'}
                                  </button>
                                  <button
                                    type="button"
                                    disabled={cerrandoAjustePosteriorId === idEmp}
                                    onClick={() => cerrarAjustePosteriorEmpleado(idEmp)}
                                    className="px-2 py-1 text-xs font-medium bg-emerald-600 text-white rounded hover:bg-emerald-700 disabled:opacity-60 transition-colors"
                                    title="Guarda la boleta y vuelve a solo lectura"
                                  >
                                    {cerrandoAjustePosteriorId === idEmp ? 'Guardando…' : 'Cerrar ajuste'}
                                  </button>
                                </>
                              )}
                              {!planillaCerrada && !yaPreCierre && estado.status === 'completo' && (
                                <button
                                  type="button"
                                  disabled={guardandoPreCierreId === idEmp || !listoParaGuardar}
                                  onClick={() => guardarPreCierreEmpleado(empleadoFull.id ?? empleadoFull.empleado_id)}
                                  className="px-2 py-1 text-xs font-medium bg-indigo-600 text-white rounded hover:bg-indigo-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
                                  title={
                                    listoParaGuardar
                                      ? 'Guarda el cálculo de este trabajador (pre-cierre)'
                                      : 'Calcula la planilla antes de guardar'
                                  }
                                >
                                  {guardandoPreCierreId === idEmp ? 'Guardando…' : 'Guardar pre-cierre'}
                                </button>
                              )}
                            </>
                          );
                        })()}
                      </div>
                    </div>
                  </div>

                  <div className="space-y-3">
                      {(() => {
                      const tipo = String(empleadoFull.tipo_planilla || empleado.tipo_planilla || '').toLowerCase();
                      const esSoloInterna = planillaAlternativaActiva && tipo === 'solo_interna';
                      const canales = canalesBoletaDe(empleadoFull);
                      const mostrarPlame =
                        !planillaAlternativaActiva ||
                        (canales.plame && (
                          filtroTipoBoleta === 'plame' ||
                          filtroTipoBoleta === 'todas'
                        ));
                      const mostrarInterna =
                        planillaAlternativaActiva &&
                        canales.interna &&
                        (filtroTipoBoleta === 'interna' ||
                          filtroTipoBoleta === 'todas' ||
                          esSoloInterna);

                        return (
                          <>
                          {mostrarPlame && !esSoloInterna &&
                            renderBloqueConceptosBoleta(
                              empleadoFull,
                              planillaAlternativaActiva ? 'Boleta PLAME' : 'Boleta',
                              'plame'
                            )}
                          {mostrarInterna &&
                            (empleadoFull.boletaInternaPartida && empleadoFull.conceptosInternos1 && empleadoFull.conceptosInternos2 ? (
                              <>
                                {renderBloqueConceptosBoleta(
                                  {
                                    ...empleadoFull,
                                    conceptosInternos: empleadoFull.conceptosInternos1,
                                    totalesInternos: empleadoFull.totalesInternos1,
                                  },
                                  `Boleta Interna 1${empleadoFull.diasInterna1 != null ? ` (${empleadoFull.diasInterna1} días)` : ''}`,
                                  'interna'
                                )}
                                {renderBloqueConceptosBoleta(
                                  {
                                    ...empleadoFull,
                                    conceptosInternos: empleadoFull.conceptosInternos2,
                                    totalesInternos: empleadoFull.totalesInternos2,
                                  },
                                  `Boleta Interna 2${empleadoFull.diasInterna2 != null ? ` (${empleadoFull.diasInterna2} días)` : ''}`,
                                  'interna'
                                )}
                              </>
                            ) : (
                              renderBloqueConceptosBoleta(
                                empleadoFull,
                                esSoloInterna ? 'Boleta Interna' : 'Boleta Interna (control)',
                                'interna',
                                textoAclaracionSueldoPartido({
                                  ...(empleadoFull.sueldoPartido || {}),
                                  dias1: empleadoFull.sueldoPartido?.dias1 ?? empleadoFull.diasInterna1,
                                  dias2: empleadoFull.sueldoPartido?.dias2 ?? empleadoFull.diasInterna2,
                                  formatCurrency,
                                }) || null
                              )
                            ))}
                          {!mostrarPlame && !mostrarInterna && (
                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                              <div className="bg-green-50 rounded p-3 col-span-full text-sm text-gray-500">
                                Sin conceptos para el filtro de boleta seleccionado.
                      </div>
                            </div>
                          )}
                          </>
                        );
                      })()}
                    </div>
                          </div>
                );
                })
              )}
            </div>
          </div>
        )}

        {/* Por Conceptos */}
        {activeTab === 'conceptos' && (
          <div>
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-6 space-y-4 lg:space-y-0">
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Consolidado por Conceptos</h3>
                <p className="text-gray-600">
                  Vista de haberes / boleta ordinaria
                  {planillaAlternativaActiva
                    ? ' · PLAME e Interna (dos consolidados)'
                    : ''}
                  {' · '}viáticos/grati dentro de ingresos (no suman al neto)
                </p>
              </div>
              
              <div className="flex flex-row sm:items-center gap-6 flex-wrap">
                {/* 🔍 MULTIFILTRO POR CARGO */}
                <MultiFiltroCargoComponent idSufijo="conceptos" />
                
                {/* 🏢 MULTIFILTRO POR ÁREA DE TRABAJO */}
                <MultiFiltroAreaComponent idSufijo="conceptos" />
                
                {/* 📋 MULTIFILTRO POR PROYECTO */}
                <MultiFiltroProyectoComponent idSufijo="conceptos" />

                <FiltroTipoBoletaControl idSufijo="conceptos" />
                
                </div>
                
              {/* 🔧 SECCIÓN DE BOTONES DE EXPORTACIÓN */}
              <div className="flex flex-wrap items-center gap-4 mt-4">
                {/* 📊 BOTÓN EXPORTAR A EXCEL */}
                <button
                  onClick={exportarDatosExcel}
                  disabled={generandoExcel || empleadosParaVista.length === 0}
                  className="flex items-center space-x-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm font-medium disabled:bg-gray-400 disabled:cursor-not-allowed"
                  title="Exportar datos a Excel"
                >
                  {generandoExcel ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                      <span>Generando...</span>
                    </>
                  ) : (
                    <>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      <span>Excel</span>
                    </>
                  )}
                </button>

                {/* 📄 BOTÓN EXPORTAR A PDF */}
                <button
                  onClick={exportarConceptosPDF}
                  disabled={generandoConceptosPDF || empleadosParaVista.length === 0}
                  className="flex items-center space-x-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium disabled:bg-gray-400 disabled:cursor-not-allowed"
                  title="Exportar conceptos a PDF"
                >
                  {generandoConceptosPDF ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                      <span>Generando...</span>
                    </>
                  ) : (
                    <>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      <span>PDF</span>
                    </>
                  )}
                </button>
              </div>
            </div>
            
            {(() => {
              // Con planilla alternativa activa: siempre PLAME + Interna (dos consolidados).
              // Sin PA: un solo consolidado clásico.
              const tablasConceptos = [];
              const mostrarPlame = true;
              const mostrarInterna = planillaAlternativaActiva;

              if (mostrarPlame) {
                const empsPlame = empleadosParaVistaHaberesBase
                  .filter((emp) => {
                    if (!planillaAlternativaActiva) return true;
                    // En consolidado PLAME no mezclar solo_interna ni contratación Interna
                    const tipo = String(emp?.tipo_planilla || '').toLowerCase();
                    const contratacion = String(
                      emp?.tipo_contratacion || emp?.datosEmpleado?.tipo_contratacion || ''
                    ).trim();
                    return tipo !== 'solo_interna' && contratacion !== 'Interno' && canalesBoletaDe(emp).plame;
                  })
                  .map((emp) => ({ ...emp, _boletaVista: 'plame' }));
                if (empsPlame.length > 0) {
                  tablasConceptos.push({
                    key: 'plame',
                    titulo: planillaAlternativaActiva ? 'Consolidado PLAME' : 'Consolidado por Conceptos',
                    badgeClass: 'bg-slate-700 text-white',
                    borderClass: 'border-slate-200',
                    empleados: empsPlame,
                  });
                }
              }
              if (mostrarInterna) {
                const empsInterna = empleadosParaVistaHaberesBase
                  .filter((emp) => canalesBoletaDe(emp).interna)
                  .map((emp) => {
                    const adaptado = {
                      ...emp,
                      conceptos: emp.conceptosInternos || { ingresos: [], descuentos: [], aportes: [] },
                      totales: emp.totalesInternos || emp.totales,
                    };
                    return {
                      ...empleadoParaBoletaOrdinaria(adaptado),
                      _boletaVista: 'interna',
                    };
                  });
                if (empsInterna.length > 0) {
                  tablasConceptos.push({
                    key: 'interna',
                    titulo: 'Consolidado Interna (control)',
                    badgeClass: 'bg-amber-100 text-amber-900',
                    borderClass: 'border-amber-200',
                    empleados: empsInterna,
                  });
                }
              }
              if (tablasConceptos.length === 0) {
                return (
                  <div className="text-center py-10 text-gray-500 text-sm">
                    No hay empleados para mostrar en el consolidado.
                  </div>
                );
              }

              return (
            <div className="w-full max-w-full space-y-8">
              {tablasConceptos.map((tablaCfg) => {
              const empleadosLista = tablaCfg.empleados;
              const conceptosUnicos = obtenerConceptosUnicos(empleadosLista, {
                ocultarConceptosHorasExtrasVista: ocultarHorasExtrasEnVista
              });
              const empleadosParaDecl = empleadosLista.map((emp) => {
                const full = empleadosParaVista.find(
                  (e) => String(e.id ?? e.empleado_id) === String(emp.id ?? emp.empleado_id)
                );
                if (!full) return emp;
                if (tablaCfg.key === 'interna') {
                  return {
                    ...full,
                    conceptos: full.conceptosInternos || { ingresos: [], descuentos: [], aportes: [] },
                  };
                }
                return full;
              });
              const conceptosDeclaracionUnicos = obtenerConceptosUnicosDeclaracion(empleadosParaDecl);
              const totalesTabla = empleadosLista.reduce((acc, emp) => ({
                totalIngresos: acc.totalIngresos + (emp?.totales?.totalIngresos || 0),
                totalDescuentos: acc.totalDescuentos + (emp?.totales?.totalDescuentos || 0),
                totalAportes: acc.totalAportes + (emp?.totales?.totalAportes || 0),
                netoTotal: acc.netoTotal + (emp?.totales?.netoAPagar || 0),
              }), { totalIngresos: 0, totalDescuentos: 0, totalAportes: 0, netoTotal: 0 });
              
              return (
            <div key={tablaCfg.key} className={`w-full max-w-full rounded-lg border ${tablaCfg.borderClass} overflow-hidden`}>
              {planillaAlternativaActiva && (
                <div className="px-4 py-2.5 bg-white border-b border-gray-100 flex items-center justify-between">
                  <span className={`inline-flex px-2.5 py-0.5 rounded text-xs font-semibold ${tablaCfg.badgeClass}`}>
                    {tablaCfg.titulo}
                  </span>
                  <span className="text-sm font-semibold text-gray-700">
                    Neto total: {formatCurrency(totalesTabla.netoTotal)}
                  </span>
                </div>
              )}
              <div className="planilla-table-container overflow-x-auto bg-white shadow-sm" style={{maxWidth: 'calc(100vw - 280px)'}}>
              <table className="min-w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="empleado-sticky-column px-3 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider sticky left-0 bg-gray-50 z-10 border-r border-gray-200 min-w-[220px]">
                      Empleado
                    </th>
                        
                        {/* Conceptos de Ingresos Dinámicos */}
                        {conceptosUnicos.ingresos.map((concepto, index) => (
                          <th key={`ingreso-${index}`} className="concepto-header px-2 py-3 text-center text-xs font-medium text-green-700 uppercase tracking-tight min-w-[120px] max-w-[140px] bg-green-50">
                            <div className="whitespace-normal break-words leading-tight">
                              {concepto.descripcion}
                            </div>
                    </th>
                        ))}

                        {/* Dentro de ingresos: declaración (no suman al total/neto) */}
                        {conceptosDeclaracionUnicos.map((concepto, index) => {
                          const estilo = estiloConceptoDeclaracion(concepto);
                          return (
                          <th
                            key={`decl-${index}`}
                            className={`concepto-header px-2 py-3 text-center text-xs font-medium uppercase tracking-tight min-w-[120px] max-w-[140px] border-l border-green-200 ${estilo.header}`}
                            title="Dentro de ingresos · no ingresa al pago (solo declaración)"
                          >
                            <div className="whitespace-normal break-words leading-tight">
                              {estilo.icono}{' '}
                              {concepto.descripcion}
                            </div>
                    </th>
                          );
                        })}
                        
                    {/* Total Ingresos */}
                                         <th className="px-3 py-3 text-center text-xs font-bold text-green-800 uppercase tracking-wider min-w-[120px] bg-green-200 border-l-2 border-green-300">
                      Total Ingresos
                    </th>
                        
                        {/* Conceptos de Descuentos Dinámicos */}
                        {conceptosUnicos.descuentos.map((concepto, index) => (
                          <th key={`descuento-${index}`} className="concepto-header px-2 py-3 text-center text-xs font-medium text-red-700 uppercase tracking-tight min-w-[120px] max-w-[140px] bg-red-50">
                            <div className="whitespace-normal break-words leading-tight">
                              {concepto.descripcion}
                            </div>
                    </th>
                        ))}
                        
                    {/* Total Descuentos */}
                                         <th className="px-3 py-3 text-center text-xs font-bold text-red-800 uppercase tracking-wider min-w-[120px] bg-red-200 border-l-2 border-red-300">
                      Total Descuentos
                    </th>
                        
                    {/* Neto a Pagar */}
                    <th className="px-3 py-3 text-center text-xs font-bold text-teal-800 uppercase tracking-wider min-w-[120px] bg-teal-200 border-l-2 border-teal-300">
                      Neto a Pagar
                    </th>
                        
                        {/* Conceptos de Aportes Dinámicos */}
                        {conceptosUnicos.aportes.map((concepto, index) => (
                          <th key={`aporte-${index}`} className="concepto-header px-2 py-3 text-center text-xs font-medium text-blue-700 uppercase tracking-tight min-w-[120px] max-w-[140px] bg-blue-50">
                            <div className="whitespace-normal break-words leading-tight">
                              {concepto.descripcion}
                            </div>
                    </th>
                        ))}

                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                      {empleadosLista.map((empleado, index) => (
                      <tr key={empleado.id} className={`table-row-hover hover:bg-gray-50 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-25'}`}>
                        {/* Empleado */}
                        <td className="empleado-sticky-column px-3 py-3 text-sm font-medium text-gray-900 sticky left-0 bg-white z-10 border-r border-gray-200">
                          <div className="space-y-1">
                            <div className="font-semibold text-gray-900 text-xs leading-tight">{empleado.nombre}</div>
                            <div className="text-xs text-gray-600">{empleado.proyecto || 'Sin proyecto'} • {empleado.areas_de_trabajo || 'Sin área'} • {empleado.cargo} • {empleado.categoria}</div>
                            <div className="flex flex-wrap gap-1">
                              {esPlanillaRH && (
                                <span className="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-teal-100 text-teal-800">
                                  RH
                                </span>
                              )}
                              {/* ONP/AFP: no mostrar en planilla RH, formación laboral ni solo interna */}
                              {!esPlanillaRH && !esRegimenFormacionLaboral(empleado) && !esEmpleadoSoloInterna(empleado) && (
                              <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium ${
                                empleado.tipoAporte === 'ONP' 
                                  ? 'bg-blue-100 text-blue-800' 
                                  : 'bg-purple-100 text-purple-800'
                              }`}>
                                {empleado.tipoAporte === 'AFP' 
                                  ? `${empleado.afp || 'Sin AFP'}${empleado.tipoHabitat ? ` ${empleado.tipoHabitat}` : ''}` 
                                  : empleado.tipoAporte}
                              </span>
                              )}
                              {!esPlanillaRH && (
                              <span className="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                                {empleado.regimenLaboral}
                              </span>
                              )}
                              {(() => {
                                const cat = etiquetaCategoriaConsu(empleado);
                                if (!cat) return null;
                                return (
                                  <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium ${cat.className}`}>
                                    {cat.texto}
                                  </span>
                                );
                              })()}
                              {!esPlanillaRH && empleadoTieneRentaQuinta(empleado) && (
                              <span className="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-amber-100 text-amber-800">
                                Renta 5ta
                              </span>
                              )}
                              {/* Calculado / borrador (en RH ya va la etiqueta RH arriba) */}
                              {empleadosConBoletasCalculadas.find(emp => emp.id === empleado.id) ? (
                                <span className="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                                  ✅
                                </span>
                              ) : (
                                !esPlanillaRH ? (
                                  <span className="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800">
                                    📋
                                  </span>
                                ) : null
                              )}
                            </div>
                            {/* Información de Asistencia Detallada */}
                            <div className="space-y-1 text-xs">
                              {/* Línea 1: Registros y días */}
                              <div className="flex items-center space-x-2">
                                <span className="text-blue-600">📋 {empleado.resumenTareos?.total_tareos || 0}</span>
                              {empleado.tareos.asistenciaPerfecta && (
                                <span className="flex items-center text-green-600">
                                  ✅ Asistencia Perfecta
                              </span>
                              )}
                              <span className="text-blue-600">
                                ⏰ {empleado.tareos.horasOrdinarias}h
                              </span>
                              </div>
                              
                              {/* Línea 2: Detalles por tipo (solo si hay eventos) */}
                              <div className="flex items-center space-x-1 flex-wrap">
                                {empleado.tareos.diasTrabajados > 0 && (
                                  <span className="text-green-600">✅{empleado.tareos.diasTrabajados}</span>
                                )}
                                {empleado.tareos.faltas > 0 && (
                                  <span className="text-red-600">❌{empleado.tareos.faltas}</span>
                                )}
                                {empleado.tareos.vacaciones > 0 && (
                                  <span className="text-yellow-600">🏖️{empleado.tareos.vacaciones}</span>
                                )}
                                {empleado.tareos.permisos > 0 && (
                                  <span className="text-purple-600">📋{empleado.tareos.permisos}</span>
                                )}
                                {empleado.tareos.suspensiones > 0 && (
                                  <span className="text-amber-600">⛔{empleado.tareos.suspensiones}</span>
                                )}
                                {empleado.tareos.descansoMedico > 0 && (
                                  <span className="text-pink-600">🏥{empleado.tareos.descansoMedico}</span>
                                )}
                                {empleado.tareos.reposoMedico > 0 && (
                                  <span className="text-rose-600">🛏️{empleado.tareos.reposoMedico}</span>
                                )}
                                {empleado.tareos.subsidioPorEnfermedad > 0 && (
                                  <span className="text-red-500">💊{empleado.tareos.subsidioPorEnfermedad}</span>
                                )}
                                {empleado.tareos.licenciaConGoceHaber > 0 && (
                                  <span className="text-indigo-600">🧾{empleado.tareos.licenciaConGoceHaber}</span>
                                )}
                                {empleado.tareos.tardanzas > 0 && (
                                  <span className="text-orange-600">⏱️{empleado.tareos.tardanzas}</span>
                                )}
                                {empleado.tareos.feriados > 0 && (
                                  <span className="text-blue-600">🎉{empleado.tareos.feriados}</span>
                                )}
                                {empleado.tareos.feriadosLaborados > 0 && (
                                  <span className="text-indigo-600">💼{empleado.tareos.feriadosLaborados}</span>
                                )}
                                {empleado.tareos.descansos > 0 && (
                                  <span className="text-gray-600">😴{empleado.tareos.descansos}</span>
                                )}
                                {empleado.tareos.descansosLaborados > 0 && (
                                  <span className="text-teal-600">⚡{empleado.tareos.descansosLaborados}</span>
                                )}
                                {(() => {
                                  const empFull =
                                    empleadosParaVista.find((e) => String(e.id) === String(empleado.id)) || empleado;
                                  const cuadre = getCuadreViaticosEmpleado(empFull);
                                  if (!cuadre) return null;
                                  return (
                                    <span
                                      className={
                                        cuadre.sinMontoEmpleado
                                          ? 'text-amber-600 font-medium'
                                          : cuadre.coincide
                                            ? 'text-green-700 font-medium'
                                            : 'text-red-600 font-medium'
                                      }
                                      title={cuadre.title}
                                    >
                                      {etiquetaCuadreViaticos(cuadre)}
                                    </span>
                                  );
                                })()}
                                {empleadoTieneDeclaracionGratificacion(
                                  empleadosParaVista.find((e) => e.id === empleado.id) || empleado
                                ) && (
                                  <span
                                    className="text-amber-700 font-medium"
                                    title="Gratificación / bonificación extraordinaria (declaración PLAME · no boleta ordinaria)"
                                  >
                                    🎁
                                  </span>
                                )}
                                {empleadoTieneDeclaracionViatico(
                                  empleadosParaVista.find((e) => e.id === empleado.id) || empleado
                                ) && (
                                  <span
                                    className="text-amber-700 font-medium"
                                    title="Viáticos (declaración · se informan, no afectan neto a pagar)"
                                  >
                                    🚕
                                  </span>
                                )}
                                {empleadoTieneDeclaracionMovilidad(
                                  empleadosParaVista.find((e) => e.id === empleado.id) || empleado
                                ) && (
                                  <span
                                    className="text-blue-700 font-medium"
                                    title="Movilidad Jatsa (declaración · se informa, no entra al pago)"
                                  >
                                    🚗
                                  </span>
                                )}
                              </div>
                            </div>
                            {/* Estado del Tareo y Botón */}
                            <div className="flex items-center justify-between mt-2">
                              <div className="flex items-center space-x-1">
                                <span className={`text-xs font-medium ${getTareoStatus(empleado.tareos, empleado, planillaParaVista.fecha_inicio, planillaParaVista.fecha_fin).color}`}>
                                  {getTareoStatus(empleado.tareos, empleado, planillaParaVista.fecha_inicio, planillaParaVista.fecha_fin).icon}
                                </span>
                                <span className={`text-xs font-medium ${getTareoStatus(empleado.tareos, empleado, planillaParaVista.fecha_inicio, planillaParaVista.fecha_fin).color}`}>
                                  {getTareoStatus(empleado.tareos, empleado, planillaParaVista.fecha_inicio, planillaParaVista.fecha_fin).text}
                                </span>
                              </div>
                              <button
                                onClick={() => {
                                  const empleadoFull =
                                    empleadosParaVista.find((e) => String(e.id) === String(empleado.id)) || empleado;
                                  openTareoModal(empleadoFull);
                                }}
                                className="px-1.5 py-0.5 text-xs bg-teal-100 text-teal-700 rounded hover:bg-teal-200 transition-colors font-medium"
                              >
                                Ver
                              </button>
                            </div>
                            <div className="text-xs text-gray-500">
                              {empleado.documento}{!esPlanillaRH && empleado.regimenLaboral ? ` • ${empleado.regimenLaboral}` : ''}
                            </div>
                          </div>
                        </td>
                        
                          {/* Conceptos de Ingresos Dinámicos */}
                          {conceptosUnicos.ingresos.map((conceptoUnico, conceptoIndex) => {
                            // ✅ BUSCAR CONCEPTO EN LA ESTRUCTURA CORRECTA CON LOGGING
                            const conceptosIngresos = empleado.conceptos?.ingresos || [];
                            console.log(`🔍 Buscando ingreso "${conceptoUnico.descripcion}" (${conceptoUnico.codigo}) para ${empleado.nombre}`);
                            console.log(`📋 Conceptos disponibles:`, conceptosIngresos.map(c => ({ 
                              desc: c.descripcion, 
                              cod: c.codigo, 
                              monto: c.monto 
                            })));
                            
                            const concepto = conceptosIngresos.find(c => {
                              const descripcionConcepto = c.descripcion;
                              
                              // ✅ USAR SOLO DESCRIPCIÓN PARA SER CONSISTENTE con obtenerConceptosUnicos
                              return descripcionConcepto?.trim().toLowerCase() === conceptoUnico.descripcion?.trim().toLowerCase();
                            });
                            
                            const monto = concepto?.monto || 0;
                            console.log(`💰 Resultado: ${concepto ? `encontrado S/ ${monto}` : 'no encontrado'}`);
                            
                            return (
                              <td key={`ingreso-${conceptoIndex}`} className="px-3 py-3 text-sm text-center bg-green-25">
                                {monto > 0 ? (
                                  <span className="font-semibold text-green-700">{formatCurrency(monto)}</span>
                          ) : (
                            <span className="text-gray-400">-</span>
                          )}
                        </td>
                            );
                          })}

                          {conceptosDeclaracionUnicos.map((conceptoUnico, conceptoIndex) => {
                            const ingresosDecl = ingresosDeclaracionDeEmpleado(
                              empleado.id ?? empleado.empleado_id,
                              tablaCfg.key === 'interna' ? 'interna' : 'plame'
                            );
                            const concepto = ingresosDecl.find(
                              (c) =>
                                (c.descripcion || c.concepto)?.trim().toLowerCase() ===
                                conceptoUnico.descripcion?.trim().toLowerCase()
                            );
                            const montoDecl = parseFloat(concepto?.monto) || 0;
                            const estiloDecl = estiloConceptoDeclaracion(conceptoUnico);
                            return (
                              <td
                                key={`decl-${conceptoIndex}`}
                                className={`px-3 py-3 text-sm text-center border-l border-green-100 ${estiloDecl.fondo}`}
                              >
                                {montoDecl > 0 ? (
                                  <span
                                    className={`font-semibold ${estiloDecl.monto}`}
                                  >
                                    {formatCurrency(montoDecl)}
                                  </span>
                          ) : (
                            <span className="text-gray-400">-</span>
                          )}
                        </td>
                            );
                          })}
                        
                        {/* Total Ingresos */}
                        <td className="px-3 py-3 text-sm text-center font-bold text-green-900 bg-green-200 border-l-2 border-green-300">
                          {formatCurrency(empleado.totales.totalIngresos)}
                        </td>
                        
                          {/* Conceptos de Descuentos Dinámicos */}
                          {conceptosUnicos.descuentos.map((conceptoUnico, conceptoIndex) => {
                            // ✅ BUSCAR CONCEPTO EN LA ESTRUCTURA CORRECTA CON LOGGING
                            const conceptosDescuentos = empleado.conceptos?.descuentos || [];
                            console.log(`🔍 Buscando descuento "${conceptoUnico.descripcion}" (${conceptoUnico.codigo}) para ${empleado.nombre}`);
                            console.log(`📋 Conceptos disponibles:`, conceptosDescuentos.map(c => ({ 
                              desc: c.descripcion, 
                              cod: c.codigo, 
                              monto: c.monto 
                            })));
                            
                            const concepto = conceptosDescuentos.find(c => {
                              const descripcionConcepto = c.descripcion;
                              
                              // ✅ USAR SOLO DESCRIPCIÓN PARA SER CONSISTENTE con obtenerConceptosUnicos
                              return descripcionConcepto?.trim().toLowerCase() === conceptoUnico.descripcion?.trim().toLowerCase();
                            });
                            
                            const monto = concepto?.monto || 0;
                            console.log(`💸 Resultado: ${concepto ? `encontrado S/ ${monto}` : 'no encontrado'}`);
                            
                            return (
                              <td key={`descuento-${conceptoIndex}`} className="px-3 py-3 text-sm text-center bg-red-25">
                                {monto > 0 ? (
                                  <span className="font-semibold text-red-700">{formatCurrency(monto)}</span>
                          ) : (
                            <span className="text-gray-400">-</span>
                          )}
                        </td>
                            );
                          })}
                        
                        {/* Total Descuentos */}
                        <td className="px-3 py-3 text-sm text-center font-bold text-red-900 bg-red-200 border-l-2 border-red-300">
                          {formatCurrency(empleado.totales.totalDescuentos)}
                        </td>
                        
                        {/* Neto a Pagar */}
                        <td className="px-3 py-3 text-sm text-center font-bold text-teal-900 bg-teal-200 border-l-2 border-teal-300">
                          {formatCurrency(empleado.totales.netoAPagar)}
                        </td>
                        
                          {/* Conceptos de Aportes Dinámicos */}
                          {conceptosUnicos.aportes.map((conceptoUnico, conceptoIndex) => {
                            // ✅ BUSCAR CONCEPTO EN LA ESTRUCTURA CORRECTA CON LOGGING
                            const conceptosAportes = empleado.conceptos?.aportes || [];
                            console.log(`🔍 Buscando aporte "${conceptoUnico.descripcion}" (${conceptoUnico.codigo}) para ${empleado.nombre}`);
                            console.log(`📋 Conceptos disponibles:`, conceptosAportes.map(c => ({ 
                              desc: c.descripcion, 
                              cod: c.codigo, 
                              monto: c.monto 
                            })));
                            
                            const concepto = conceptosAportes.find(c => {
                              const descripcionConcepto = c.descripcion;
                              
                              // ✅ USAR SOLO DESCRIPCIÓN PARA SER CONSISTENTE con obtenerConceptosUnicos
                              return descripcionConcepto?.trim().toLowerCase() === conceptoUnico.descripcion?.trim().toLowerCase();
                            });
                            
                            const monto = concepto?.monto || 0;
                            
                            return (
                              <td key={`aporte-${conceptoIndex}`} className="px-3 py-3 text-sm text-center bg-blue-25">
                                {monto > 0 ? (
                                  <span className="font-semibold text-blue-700">{formatCurrency(monto)}</span>
                          ) : (
                            <span className="text-gray-400">-</span>
                          )}
                        </td>
                    );
                  })}
                  
                        </tr>
                      ))}
                      
                      {/* Fila de totales dinámicos */}
                   <tr className="bg-gray-100 font-semibold border-t-2 border-gray-300">
                     <td className="empleado-sticky-column px-3 py-4 text-sm font-bold text-gray-900 sticky left-0 bg-gray-100 z-10 border-r border-gray-200">
                       TOTALES GENERALES
                     </td>
                     
                        {/* Totales por concepto de ingresos dinámicos */}
                        {conceptosUnicos.ingresos.map((conceptoUnico, conceptoIndex) => (
                          <td key={`total-ingreso-${conceptoIndex}`} className="px-3 py-4 text-sm text-center font-bold text-green-800 bg-green-100">
                            {formatCurrency(empleadosLista.reduce((sum, emp) => {
                              const conceptosIngresos = emp.conceptos?.ingresos || [];
                              const concepto = conceptosIngresos.find(c => {
                                const descripcionConcepto = c.descripcion;
                                
                                // ✅ USAR SOLO DESCRIPCIÓN PARA SER CONSISTENTE con obtenerConceptosUnicos
                                return descripcionConcepto?.trim().toLowerCase() === conceptoUnico.descripcion?.trim().toLowerCase();
                              });
                              return sum + (concepto?.monto || 0);
                            }, 0))}
                     </td>
                        ))}

                        {conceptosDeclaracionUnicos.map((conceptoUnico, conceptoIndex) => (
                          <td
                            key={`total-decl-${conceptoIndex}`}
                            className={`px-3 py-4 text-sm text-center font-bold border-l border-green-200 ${estiloConceptoDeclaracion(conceptoUnico).total}`}
                          >
                            {formatCurrency(
                              empleadosLista.reduce((sum, emp) => {
                                const ingresosDecl = ingresosDeclaracionDeEmpleado(
                                  emp.id ?? emp.empleado_id,
                                  tablaCfg.key === 'interna' ? 'interna' : 'plame'
                                );
                                const concepto = ingresosDecl.find(
                                  (c) =>
                                    (c.descripcion || c.concepto)?.trim().toLowerCase() ===
                                    conceptoUnico.descripcion?.trim().toLowerCase()
                                );
                                return sum + (parseFloat(concepto?.monto) || 0);
                              }, 0)
                            )}
                     </td>
                        ))}
                     
                     {/* Total Ingresos */}
                     <td className="px-3 py-4 text-sm text-center font-bold text-green-900 bg-green-200 border-l-2 border-green-300">
                       {formatCurrency(totalesTabla.totalIngresos)}
                     </td>
                     
                        {/* Totales por concepto de descuentos dinámicos */}
                        {conceptosUnicos.descuentos.map((conceptoUnico, conceptoIndex) => (
                          <td key={`total-descuento-${conceptoIndex}`} className="px-3 py-4 text-sm text-center font-bold text-red-800 bg-red-100">
                            {formatCurrency(empleadosLista.reduce((sum, emp) => {
                              const conceptosDescuentos = emp.conceptos?.descuentos || [];
                              const concepto = conceptosDescuentos.find(c => {
                                const descripcionConcepto = c.descripcion;
                                
                                // ✅ USAR SOLO DESCRIPCIÓN PARA SER CONSISTENTE con obtenerConceptosUnicos
                                return descripcionConcepto?.trim().toLowerCase() === conceptoUnico.descripcion?.trim().toLowerCase();
                              });
                              return sum + (concepto?.monto || 0);
                            }, 0))}
                     </td>
                        ))}
                     
                     {/* Total Descuentos */}
                     <td className="px-3 py-4 text-sm text-center font-bold text-red-900 bg-red-200 border-l-2 border-red-300">
                       {formatCurrency(totalesTabla.totalDescuentos)}
                     </td>
                     
                     {/* Neto a Pagar */}
                                           <td className="px-3 py-4 text-base text-center font-bold text-teal-900 bg-teal-200 border-l-2 border-teal-300">
                       {formatCurrency(totalesTabla.netoTotal)}
                     </td>
                     
                        {/* Totales por concepto de aportes dinámicos */}
                        {conceptosUnicos.aportes.map((conceptoUnico, conceptoIndex) => (
                          <td key={`total-aporte-${conceptoIndex}`} className="px-3 py-4 text-sm text-center font-bold text-blue-800 bg-blue-100">
                            {formatCurrency(empleadosLista.reduce((sum, emp) => {
                              const conceptosAportes = emp.conceptos?.aportes || [];
                              const concepto = conceptosAportes.find(c => {
                                const descripcionConcepto = c.descripcion;
                                
                                // ✅ USAR SOLO DESCRIPCIÓN PARA SER CONSISTENTE con obtenerConceptosUnicos
                                return descripcionConcepto?.trim().toLowerCase() === conceptoUnico.descripcion?.trim().toLowerCase();
                              });
                              return sum + (concepto?.monto || 0);
                            }, 0))}
                     </td>
                        ))}

                   </tr>
                </tbody>
              </table>
              </div>
            </div>
              );
              })}
            </div>
              );
            })()}
            
            {/* Indicador de scroll horizontal */}
            <div className="mt-4 text-center">
              <p className="text-sm text-gray-500 flex items-center justify-center">
                <span className="mr-2">↔️</span>
                <span>Desliza horizontalmente para ver todos los conceptos</span>
                <span className="ml-2">↔️</span>
              </p>
            </div>
            
            {/* Leyenda de colores */}
            <div className="mt-6 flex flex-wrap gap-4 justify-center text-sm">
              <div className="flex items-center">
                <div className="w-4 h-4 bg-green-100 border border-green-200 rounded mr-2"></div>
                <span className="text-gray-600">Ingresos</span>
              </div>
              <div className="flex items-center">
                <div className="w-4 h-4 bg-red-100 border border-red-200 rounded mr-2"></div>
                <span className="text-gray-600">Descuentos</span>
              </div>
              <div className="flex items-center">
                <div className="w-4 h-4 bg-blue-100 border border-blue-200 rounded mr-2"></div>
                <span className="text-gray-600">Aportes</span>
              </div>
              <div className="flex items-center">
                <div className="w-4 h-4 bg-teal-100 border border-teal-200 rounded mr-2"></div>
                <span className="text-gray-600">Totales</span>
              </div>

            </div>
          </div>
        )}

        {/* Netos a Pagar */}
        {activeTab === 'netos' && (
          <div>
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4 sm:mb-0">Netos a Pagar por Empleado</h3>
              
              <div className="flex flex-row gap-6 flex-wrap">
              {/* 🔍 MULTIFILTRO POR CARGO */}
              <MultiFiltroCargoComponent idSufijo="netos" />
                
                {/* 🏢 MULTIFILTRO POR ÁREA DE TRABAJO */}
                <MultiFiltroAreaComponent idSufijo="netos" />
                
                {/* 📋 MULTIFILTRO POR PROYECTO */}
                <MultiFiltroProyectoComponent idSufijo="netos" />
              </div>
            </div>
            
            <div className="space-y-6">
              {/* Información de empleados con netos a pagar */}
              <div>
                <h4 className="font-semibold text-gray-800 mb-3">💰 Resumen de Netos a Pagar</h4>
                {planillaAlternativaActiva && (
                  <p className="text-sm text-gray-500 mb-3">
                    Con planilla alternativa: se muestran neto PLAME y neto Interna por trabajador.
                  </p>
                )}
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">DNI</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Empleado</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-sky-700 normal-case bg-sky-50/60" title="Solo referencia visual">
                          Fecha inicio
                        </th>
                        {empleadosParaVista.some((e) => textoFechaCeseReferencia(e)) && (
                          <th className="px-4 py-2 text-left text-xs font-medium text-amber-800 normal-case bg-amber-50/60" title="Cese dentro del periodo de planilla">
                            Fecha cese
                          </th>
                        )}
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Proyecto</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Área</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Cargo</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Categoría</th>
                        {!esPlanillaRH && <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Régimen</th>}
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Pago</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Banco</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Cuenta Bancaria</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">CCI</th>
                        {planillaAlternativaActiva ? (
                          <>
                            <th className="px-4 py-2 text-right text-xs font-medium text-teal-700 uppercase bg-teal-50">Neto PLAME</th>
                            <th className="px-4 py-2 text-right text-xs font-medium text-amber-800 uppercase bg-amber-50">Neto Interna</th>
                          </>
                        ) : (
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Neto a Pagar</th>
                        )}
                        {empleadosParaVista.some((e) => netoPorDiaDeEmpleado(e)?.diasNeto) && (
                          <th className="px-4 py-2 text-right text-xs font-medium text-teal-700 uppercase bg-teal-50">Neto / día</th>
                        )}
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {empleadosParaVista.map((empleado) => {
                        const tipo = String(empleado?.tipo_planilla || '').toLowerCase();
                        const esSoloInterna = tipo === 'solo_interna';
                        const tieneInterna = empleadoTieneBoletaInterna(empleado) || esSoloInterna;
                        const netoPlame = esSoloInterna ? null : (empleado.totales?.netoAPagar ?? 0);
                        const netoInterna = tieneInterna
                          ? (empleado.totalesInternos?.netoAPagar ?? 0)
                          : null;

                        return (
                        <tr key={empleado.id}>
                          <td className="px-4 py-2 text-sm font-medium text-gray-600">{empleado.documento}</td>
                          <td className="px-4 py-2 text-sm text-gray-900 font-medium">{empleado.nombre}</td>
                          <td className="px-4 py-2 text-sm text-sky-800 bg-sky-50/30">
                            {textoFechaInicioReferencia(empleado) || '—'}
                          </td>
                          {empleadosParaVista.some((e) => textoFechaCeseReferencia(e)) && (
                            <td className="px-4 py-2 text-sm text-amber-900 bg-amber-50/30">
                              {textoFechaCeseReferencia(empleado) || '—'}
                            </td>
                          )}
                          <td className="px-4 py-2 text-sm text-gray-600">{empleado.proyecto || 'Sin proyecto'}</td>
                          <td className="px-4 py-2 text-sm text-gray-600">{empleado.areas_de_trabajo || 'Sin área'}</td>
                          <td className="px-4 py-2 text-sm text-gray-600">{empleado.cargo}</td>
                          <td className="px-4 py-2 text-sm text-gray-600">{empleado.categoria}</td>
                          {!esPlanillaRH && <td className="px-4 py-2 text-sm text-gray-600">{empleado.regimenLaboral}</td>}
                          <td className="px-4 py-2 text-sm">
                            {(() => {
                              const forma = etiquetaFormaPagoVista(empleado);
                              if (!forma) return <span className="text-gray-400">—</span>;
                              return (
                                <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold ${forma.className}`}>
                                  {forma.texto}
                                </span>
                              );
                            })()}
                          </td>
                          <td className="px-4 py-2 text-sm text-gray-600">{empleado.banco ?? '—'}</td>
                          <td className="px-4 py-2 text-sm text-gray-600">{empleado.cuenta_bancaria ?? '—'}</td>
                          <td className="px-4 py-2 text-sm text-gray-600">{empleado.cci ?? '—'}</td>
                          {planillaAlternativaActiva ? (
                            <>
                              <td className="px-4 py-2 text-sm font-bold text-teal-700 text-right bg-teal-50/40">
                                {netoPlame == null ? '—' : formatCurrency(netoPlame)}
                              </td>
                              <td className="px-4 py-2 text-sm font-bold text-amber-800 text-right bg-amber-50/40">
                                {netoInterna == null ? '—' : formatCurrency(netoInterna)}
                              </td>
                            </>
                          ) : (
                          <td className="px-4 py-2 text-sm font-bold text-green-700">{formatCurrency(empleado.totales.netoAPagar)}</td>
                          )}
                          {empleadosParaVista.some((e) => netoPorDiaDeEmpleado(e)?.diasNeto) && (
                            <td className="px-4 py-2 text-sm font-bold text-teal-700 text-right bg-teal-50/40">
                              {(() => {
                                const netoDia = netoPorDiaDeEmpleado(empleado);
                                if (!netoDia?.diasNeto) return '—';
                                const textoPeriodo = textoPeriodoCalculoCorto(periodoCalculoPersonalizadoDe(empleado));
                                return (
                                  <span>
                                    {formatCurrency(netoDia.netoPorDia)}
                                    <span className="text-gray-500 font-medium"> · {netoDia.diasNeto}d</span>
                                    {textoPeriodo ? (
                                      <span className="block text-[11px] font-medium text-sky-700">{textoPeriodo}</span>
                                    ) : null}
                                  </span>
                                );
                              })()}
                            </td>
                          )}
                        </tr>
                        );
                      })}
                    </tbody>
                    {planillaAlternativaActiva && empleadosParaVista.length > 0 && (
                      <tfoot className="bg-gray-50 border-t-2 border-gray-200">
                        <tr>
                          <td
                            colSpan={esPlanillaRH ? 9 : 10}
                            className="px-4 py-3 text-sm font-semibold text-gray-700 text-right"
                          >
                            TOTALES
                          </td>
                          <td className="px-4 py-3 text-sm font-bold text-teal-800 text-right bg-teal-50">
                            {formatCurrency(
                              empleadosParaVista.reduce((sum, emp) => {
                                const tipo = String(emp?.tipo_planilla || '').toLowerCase();
                                if (tipo === 'solo_interna') return sum;
                                return sum + (parseFloat(emp.totales?.netoAPagar) || 0);
                              }, 0)
                            )}
                          </td>
                          <td className="px-4 py-3 text-sm font-bold text-amber-900 text-right bg-amber-50">
                            {formatCurrency(
                              empleadosParaVista.reduce((sum, emp) => {
                                if (!empleadoTieneBoletaInterna(emp) &&
                                  String(emp?.tipo_planilla || '').toLowerCase() !== 'solo_interna') {
                                  return sum;
                                }
                                return sum + (parseFloat(emp.totalesInternos?.netoAPagar) || 0);
                              }, 0)
                            )}
                          </td>
                        </tr>
                      </tfoot>
                    )}
                  </table>
                </div>
              </div>

              {/* Botones de exportación */}
              <div className="space-y-4">
                {/* Botón de exportar netos a pagar */}
              <div className="bg-gray-50 rounded-lg p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <h5 className="font-medium text-gray-900">Exportar Netos a Pagar</h5>
                    <p className="text-sm text-gray-600">Generar reporte de netos a pagar en Excel (.xlsx)</p>
                  </div>
                  <button
                    onClick={exportarNetosExcel}
                    disabled={generandoPDF || empleadosParaVista.length === 0}
                    className={`px-4 py-2 text-white rounded-lg transition-colors text-sm font-medium ${
                      generandoPDF || empleadosParaVista.length === 0
                        ? 'bg-gray-400 cursor-not-allowed'
                        : 'bg-green-600 hover:bg-green-700'
                    }`}
                  >
                    {generandoPDF ? (
                      <>
                        <span className="animate-spin mr-2">⏳</span>
                        Generando Excel...
                      </>
                    ) : (
                      <>
                        📊 Exportar Excel
                      </>
                    )}
                  </button>
                </div>
              </div>


              </div>
            </div>
          </div>
        )}

        {/* Compensaciones */}
        {activeTab === 'compensaciones' && (
          <div>
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Compensaciones de Empleados</h3>
                <p className="text-gray-600">Análisis de horas trabajadas vs horas teóricas para compensaciones del próximo período</p>
              </div>
              
              <div className="flex items-center space-x-4">
                <span className="text-sm text-gray-500">
                  Mostrando todos los empleados con sus compensaciones calculadas
                </span>
                
                {/* Botón Exportar Excel */}
                <button
                  onClick={exportarCompensacionesExcel}
                  disabled={generandoExcelCompensaciones}
                  className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors text-sm font-medium ${
                    generandoExcelCompensaciones
                      ? 'bg-gray-400 text-white cursor-not-allowed'
                      : 'bg-green-600 text-white hover:bg-green-700'
                  }`}
                >
                  {generandoExcelCompensaciones ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                      <span>Generando...</span>
                    </>
                  ) : (
                    <>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      <span>📊 Exportar Excel</span>
                    </>
                  )}
                </button>
              </div>
            </div>

            {(() => {
              const compensacionesData = calcularCompensacionesTodosEmpleados();
              
              if (compensacionesData.length === 0) {
                return (
                  <div className="text-center py-12 bg-gray-50 rounded-lg">
                    <div className="text-gray-400 text-4xl mb-4">💤</div>
                    <h3 className="text-lg font-medium text-gray-900 mb-2">Sin datos de compensaciones</h3>
                    <p className="text-sm text-gray-600">
                      No se encontraron datos de compensaciones para mostrar.
                    </p>
                  </div>
                );
              }

              return (
                <div className="space-y-6">
                  {/* Resumen general */}
                  <div className="bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg p-6 border border-purple-200">
                    <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                      <span className="mr-3 text-2xl">📊</span>
                      Resumen General de Compensaciones
                    </h4>
                    
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                      <div className="text-center">
                        <p className="text-sm font-medium text-gray-600">Total Empleados</p>
                        <p className="text-2xl font-bold text-blue-600">{compensacionesData.length}</p>
                      </div>
                      <div className="text-center">
                        <p className="text-sm font-medium text-gray-600">A Favor</p>
                        <p className="text-2xl font-bold text-green-600">
                          {compensacionesData.filter(item => item.compensacion.totalProximoMes > 0).length}
                        </p>
                      </div>
                      <div className="text-center">
                        <p className="text-sm font-medium text-gray-600">En Contra</p>
                        <p className="text-2xl font-bold text-red-600">
                          {compensacionesData.filter(item => item.compensacion.totalProximoMes < 0).length}
                        </p>
                      </div>
                      <div className="text-center">
                        <p className="text-sm font-medium text-gray-600">No debe nada</p>
                        <p className="text-2xl font-bold text-gray-600">
                          {compensacionesData.filter(item => Math.abs(item.compensacion.totalProximoMes) < 0.01).length}
                        </p>
                      </div>
                      <div className="text-center">
                        <p className="text-sm font-medium text-gray-600">Total Horas</p>
                        {(() => {
                          const totalHoras = compensacionesData.reduce((sum, item) => sum + item.compensacion.totalProximoMes, 0);
                          const esCero = Math.abs(totalHoras) < 0.01;
                          const esPositivo = totalHoras > 0;
                          return (
                            <>
                              <p className={`text-2xl font-bold ${esCero ? 'text-gray-600' : esPositivo ? 'text-green-600' : 'text-red-600'}`}>
                                {esCero ? '' : esPositivo ? '+' : '-'}{formatHorasMinutos(Math.abs(totalHoras))}
                              </p>
                              <p className={`text-xs font-medium mt-0.5 ${esCero ? 'text-gray-500' : esPositivo ? 'text-green-600' : 'text-red-600'}`}>
                                {esCero ? 'No debe nada' : esPositivo ? 'A FAVOR' : 'EN CONTRA'}
                              </p>
                            </>
                          );
                        })()}
                      </div>
                    </div>
                  </div>

                  {/* Tabla de compensaciones */}
                  <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                    <div className="overflow-x-auto">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                          <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Empleado
                            </th>
                            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Meses Anteriores
                            </th>
                            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Este Mes
                            </th>
                            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Total Próximo Mes
                            </th>

                            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Estado
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {compensacionesData
                            .map((item, index) => {
                              const { empleado, compensacion } = item;
                              const esPositivo = compensacion.totalProximoMes > 0;
                              const esCero = Math.abs(compensacion.totalProximoMes) < 0.01;
                              
                              return (
                                <tr key={empleado.id} className={`hover:bg-gray-50 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-25'}`}>
                                  <td className="px-6 py-4 whitespace-nowrap">
                                    <div>
                                      <div className="text-sm font-medium text-gray-900">
                                        {empleado.nombre}
                                      </div>
                                      <div className="text-sm text-gray-500">
                                        {empleado.documento} • {empleado.cargo}
                                      </div>
                                      {empleado.areas_de_trabajo && (
                                        <div className="text-xs text-gray-400">
                                          📍 {empleado.areas_de_trabajo}
                                        </div>
                                      )}
                                    </div>
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-center text-sm">
                                    {compensacion.horasMesesAnteriores >= 0 ? (
                                      <span className="text-green-600 font-medium">
                                        +{formatHorasMinutos(Math.abs(compensacion.horasMesesAnteriores))}
                                      </span>
                                    ) : (
                                      <span className="text-red-600 font-medium">
                                        -{formatHorasMinutos(Math.abs(compensacion.horasMesesAnteriores))}
                                      </span>
                                    )}
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-center text-sm">
                                    {compensacion.horasGeneradasMes >= 0 ? (
                                      <span className="text-green-600 font-medium">
                                        +{formatHorasMinutos(Math.abs(compensacion.horasGeneradasMes))}
                                      </span>
                                    ) : (
                                      <span className="text-red-600 font-medium">
                                        -{formatHorasMinutos(Math.abs(compensacion.horasGeneradasMes))}
                                      </span>
                                    )}
                                    <div className="text-xs text-gray-500 mt-1">
                                      {compensacion.minutosExtrasMes >= 0 ? '+' : ''}{compensacion.minutosExtrasMes} min
                                    </div>
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-center text-sm">
                                    <div className={`font-bold text-lg ${
                                      esCero ? 'text-gray-600' : esPositivo ? 'text-green-700' : 'text-red-700'
                                    }`}>
                                      {esCero ? '' : esPositivo ? '+' : '-'}{formatHorasMinutos(Math.abs(compensacion.totalProximoMes))}
                                    </div>
                                  </td>

                                  <td className="px-6 py-4 whitespace-nowrap text-center">
                                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                                      esCero
                                        ? 'bg-gray-100 text-gray-700'
                                        : esPositivo 
                                        ? 'bg-green-100 text-green-800' 
                                        : 'bg-red-100 text-red-800'
                                    }`}>
                                      <span className="mr-1">{esCero ? '➖' : esPositivo ? '✅' : '⚠️'}</span>
                                      {esCero ? 'NO DEBE NADA' : esPositivo ? 'A FAVOR' : 'EN CONTRA'}
                                    </span>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Información explicativa */}
                  <div className="bg-blue-50 rounded-lg p-6 border-l-4 border-blue-400">
                    <div className="flex items-start">
                      <div className="text-blue-400 text-2xl mr-3">ℹ️</div>
                      <div>
                        <h5 className="font-medium text-blue-800 mb-2">Información sobre las Compensaciones</h5>
                        <div className="text-sm text-blue-700 space-y-2">
                          <p>
                            <strong>A FAVOR:</strong> El empleado trabajó más horas de las teóricas. Estas horas se trasladarán como compensación positiva al próximo mes.
                          </p>
                          <p>
                            <strong>EN CONTRA:</strong> El empleado trabajó menos horas de las teóricas. Debe estas horas al sistema para el próximo mes.
                          </p>
                          <p>
                            <strong>NO DEBE NADA:</strong> El empleado tiene balance cero; no tiene horas a favor ni en contra para el próximo mes.
                          </p>
                          <p>
                            <strong>Cálculo:</strong> Se comparan las horas reales trabajadas vs las horas teóricas basadas en horarios configurados (con descuento de almuerzo automático si trabajó más de 6 horas).
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })()}
          </div>
        )}

        {/* Archivos PLAME */}
        {activeTab === 'plame' && (
          <div>
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Generación de Archivos PLAME</h3>
              <p className="text-gray-600">Genera y descarga los archivos TXT requeridos por PLAME (.rem y .jor) basados en los datos calculados de la planilla.</p>
            </div>

            {/* Información de la planilla */}
            <div className="bg-blue-50 rounded-lg p-4 mb-6 border border-blue-200">
              <h4 className="font-semibold text-blue-900 mb-3">📋 Información de la Planilla</h4>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                <div>
                  <span className="font-medium text-blue-800">RUC:</span>
                  <p className="text-blue-700">{selectedCompany?.ruc || 'No disponible'}</p>
                </div>
                <div>
                  <span className="font-medium text-blue-800">Empresa:</span>
                  <p className="text-blue-700">{selectedCompany?.name || 'No disponible'}</p>
                </div>
                <div>
                  <span className="font-medium text-blue-800">Período:</span>
                  <p className="text-blue-700">
                    {planillaParaVista.fecha_inicio ? formatDateToDDMMYYYY(planillaParaVista.fecha_inicio) : 'N/A'} - 
                    {planillaParaVista.fecha_fin ? formatDateToDDMMYYYY(planillaParaVista.fecha_fin) : 'N/A'}
                  </p>
                </div>
                <div>
                  <span className="font-medium text-blue-800">Empleados:</span>
                  <p className="text-blue-700">{empleadosParaArchivosPlame.length} empleados PLAME</p>
                </div>
              </div>
            </div>



            {/* Archivos disponibles */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              {/* Archivo REM (Remuneraciones) */}
              <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-green-600 rounded-lg flex items-center justify-center">
                      <span className="text-white font-bold text-lg">REM</span>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">Archivo de Remuneraciones</h4>
                      <p className="text-sm text-gray-600">Solo boleta PLAME (sin planilla interna)</p>
                    </div>
                  </div>
                </div>
                
                <div className="space-y-3 mb-4">
                  <div className="text-sm text-gray-700">
                    <span className="font-medium">Contenido:</span>
                    <ul className="mt-1 ml-4 space-y-1 text-xs">
                      <li>• Tipo de documento y número</li>
                      <li>• Código PLAME del concepto</li>
                      <li>• Monto del concepto (formato oficial: se escribe dos veces)</li>
                      <li>• Una línea por cada concepto PLAME (incluye montos en 0)</li>
                      <li>• <span className="text-amber-700">No incluye empleados ni conceptos de boleta interna</span></li>
                      <li>• <strong>Código 0605 obligatorio para todos los empleados</strong></li>
                      <li>• Incluye 0406/0313 del módulo de gratificaciones cuando existan (mismo .rem)</li>
                      <li>• <span className="text-red-600">Códigos 0607, 0804 y 0616 EXCLUIDOS (autocalculados por PLAME)</span></li>
                      <li>• Formato: tipoDoc|documento|codigoPlame|monto|monto|</li>
                    </ul>
                  </div>
                  
                  <div className="text-sm">
                    <span className="font-medium text-gray-700">Formato:</span>
                    <code className="ml-2 text-xs bg-gray-100 px-2 py-1 rounded">.rem</code>
                  </div>
                  
                  <div className="text-sm">
                    <span className="font-medium text-gray-700">Registros estimados:</span>
                    <span className="ml-2 text-green-600 font-semibold">
                      {lineasEstimadasArchivoRem} líneas
                    </span>
                  </div>
                </div>
                
                <button
                  onClick={descargarREM}
                  disabled={empleadosParaArchivosPlame.length === 0 || generandoPLAME}
                  className="w-full flex items-center justify-center space-x-2 px-4 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium disabled:bg-gray-400 disabled:cursor-not-allowed"
                >
                  {generandoPLAME ? (
                    <>
                      <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                      <span>Generando REM...</span>
                    </>
                  ) : (
                    <>
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      <span>Descargar archivo .rem</span>
                    </>
                  )}
                </button>
              </div>

              {/* Archivo JOR (Jornadas) */}
              <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center">
                      <span className="text-white font-bold text-lg">JOR</span>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">Archivo de Jornadas</h4>
                      <p className="text-sm text-gray-600">Solo empleados de boleta PLAME</p>
                    </div>
                  </div>
                </div>
                
                <div className="space-y-3 mb-4">
                  <div className="text-sm text-gray-700">
                    <span className="font-medium">Contenido:</span>
                    <ul className="mt-1 ml-4 space-y-1 text-xs">
                      <li>• Tipo de documento y número</li>
                      <li>• Horas totales trabajadas en el período</li>
                      <li>• Tres campos adicionales con valor 0</li>
                      <li>• Cálculo automático desde tareos procesados</li>
                      <li>• Formato: tipoDoc|documento|horasTotales|0|0|0|</li>
                    </ul>
                  </div>
                  
                  <div className="text-sm">
                    <span className="font-medium text-gray-700">Formato:</span>
                    <code className="ml-2 text-xs bg-gray-100 px-2 py-1 rounded">.jor</code>
                  </div>
                  
                  <div className="text-sm">
                    <span className="font-medium text-gray-700">Registros estimados:</span>
                    <span className="ml-2 text-blue-600 font-semibold">{empleadosParaArchivosPlame.length} líneas</span>
                  </div>
                </div>
                
                <button
                  onClick={descargarJOR}
                  disabled={empleadosParaArchivosPlame.length === 0 || generandoPLAME}
                  className="w-full flex items-center justify-center space-x-2 px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium disabled:bg-gray-400 disabled:cursor-not-allowed"
                >
                  {generandoPLAME ? (
                    <>
                      <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                      <span>Generando JOR...</span>
                    </>
                  ) : (
                    <>
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      <span>Descargar archivo .jor</span>
                    </>
                  )}
                </button>
              </div>

              {/* Archivo AFPnet */}
              <div className="bg-white border border-purple-200 rounded-lg p-6 shadow-sm">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-purple-700 rounded-lg flex items-center justify-center">
                      <span className="text-white font-bold text-sm">AFP</span>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">Archivo AFPnet</h4>
                      <p className="text-sm text-gray-600">Solo AFP de boleta PLAME (sin interna)</p>
                    </div>
              </div>
            </div>

                <div className="space-y-3 mb-4">
                  <div className="text-sm text-gray-700">
                    <span className="font-medium">Contenido:</span>
                    <ul className="mt-1 ml-4 space-y-1 text-xs">
                      <li>• Solo trabajadores afiliados a AFP</li>
                      <li>• CUSPP, documento, apellidos y nombres</li>
                      <li>• Inicio, cese y vigencia de relación laboral</li>
                      <li>• Base imponible del aporte obligatorio 0608</li>
                      <li>• Régimen normal: tipo de trabajo <strong>N</strong></li>
                      <li>• Régimen minero: tipo de trabajo <strong>M</strong></li>
                      <li>• AFP en blanco para validación automática de AFPnet</li>
                    </ul>
                  </div>

                  <div className="text-sm">
                    <span className="font-medium text-gray-700">Formato:</span>
                    <code className="ml-2 text-xs bg-purple-50 px-2 py-1 rounded">.xlsx</code>
                  </div>

                  <div className="text-sm">
                    <span className="font-medium text-gray-700">Afiliados AFP:</span>
                    <span className="ml-2 text-purple-700 font-semibold">
                      {empleadosParaArchivosPlame.filter((emp) =>
                        String(emp.sistema_pensionario || emp.tipoAporte || '').toUpperCase() === 'AFP' ||
                        Boolean(emp.cuspp)
                      ).length} trabajadores
                    </span>
                  </div>
                </div>

                <button
                  onClick={descargarAFPnet}
                  disabled={empleadosParaArchivosPlame.length === 0 || generandoPLAME}
                  className="w-full flex items-center justify-center space-x-2 px-4 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors font-medium disabled:bg-gray-400 disabled:cursor-not-allowed"
                >
                  {generandoPLAME ? (
                    <>
                      <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                      <span>Generando AFPnet...</span>
                    </>
                  ) : (
                    <>
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      <span>Descargar AFPnet .xlsx</span>
                    </>
                  )}
                </button>
              </div>
            </div>





            {/* Vista previa del nombre de archivo */}
            <div className="mt-4 bg-gray-50 rounded-lg p-4 border border-gray-200">
              <h5 className="font-medium text-gray-900 mb-2">📝 Vista Previa del Nombre de Archivo</h5>
              <div className="space-y-2 text-sm">
                {(() => {
                  // Usar la misma lógica robusta de extracción de fechas
                  let año, mes;
                  if (planillaParaVista.fecha_inicio) {
                    const fechaStr = planillaParaVista.fecha_inicio.toString();
                    if (fechaStr.match(/^\d{4}-\d{2}-\d{2}/)) {
                      const partes = fechaStr.split('-');
                      año = parseInt(partes[0]);
                      mes = partes[1];
                    } else {
                      const fechaPlanilla = new Date(planillaParaVista.fecha_inicio);
                      año = fechaPlanilla.getFullYear();
                      mes = (fechaPlanilla.getMonth() + 1).toString().padStart(2, '0');
                    }
                  } else {
                    const fechaActual = new Date();
                    año = fechaActual.getFullYear();
                    mes = (fechaActual.getMonth() + 1).toString().padStart(2, '0');
                  }
                  
                  const empresaRUC = selectedCompany?.ruc || '20000000000';
                  const nombreREM = `0601${año}${mes}${empresaRUC}.rem`;
                  const nombreJOR = `0601${año}${mes}${empresaRUC}.jor`;
                  
                  return (
                    <>
                      <div className="flex items-center space-x-2">
                        <span className="font-medium text-gray-700">Archivo REM:</span>
                        <code className="bg-green-100 text-green-800 px-2 py-1 rounded text-xs font-mono">
                          {nombreREM}
                        </code>
                      </div>
                      <div className="flex items-center space-x-2">
                        <span className="font-medium text-gray-700">Archivo JOR:</span>
                        <code className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs font-mono">
                          {nombreJOR}
                        </code>
                      </div>
                      <div className="text-xs text-gray-600 mt-2">
                        <span className="font-medium">Estructura:</span> 0601 (fijo) + {año} (año) + {mes} (mes) + {empresaRUC} (RUC)
                      </div>
                    </>
                  );
                })()}
              </div>
            </div>
          </div>
        )}
      </div>

      {(autoRecerrandoJatsa || aplicandoConceptosJatsa || revirtiendoJatsa) && !progresoCierre?.visible && (
        <div className="fixed inset-0 z-[70] bg-black/50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-1">
              {revirtiendoJatsa || motivoRecierreJatsa === 'revertir' ? 'Revertir Jatsa' : 'Conceptos Jatsa'}
            </h3>
            <p className="text-sm text-gray-600 mb-2">
              {revirtiendoJatsa
                ? 'Retirando de Jatsa y quitando los conceptos que trajo...'
                : aplicandoConceptosJatsa
                  ? 'Cargando conceptos PLAME y reabriendo sin retirar de Jatsa...'
                  : motivoRecierreJatsa === 'revertir'
                    ? 'Recalculando sin conceptos Jatsa y recerrando sin reenviar...'
                    : 'Recalculando AFP/ESSALUD/IR y recerrando la planilla...'}
            </p>
            <p className="text-xs text-gray-500">No cierres esta ventana hasta que termine.</p>
          </div>
        </div>
      )}

      {progresoCierre?.visible && (
        <div className="fixed inset-0 z-[70] bg-black/50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-1">Cerrando planilla</h3>
            <p className="text-sm text-gray-600 mb-4">{progresoCierre.texto}</p>
            <div className="flex justify-between items-center mb-2">
              <span className="text-sm font-medium text-gray-700">Avance</span>
              <span className="text-sm font-medium text-teal-600">
                {Math.max(0, Math.min(100, progresoCierre.progreso || 0))}%
              </span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
              <div
                className="bg-gradient-to-r from-teal-500 to-teal-600 h-3 rounded-full transition-all duration-300"
                style={{ width: `${Math.max(0, Math.min(100, progresoCierre.progreso || 0))}%` }}
              />
            </div>
            <p className="text-xs text-gray-500 mt-3">No cierres esta ventana hasta que termine.</p>
          </div>
        </div>
      )}

      <JatsaConceptosApiModal
        isOpen={jatsaConceptosApiModalAbierto}
        onClose={() => setJatsaConceptosApiModalAbierto(false)}
        inspeccion={jatsaConceptosInspeccion}
        cargando={cargandoInspeccionJatsa}
      />

      {/* Modal de Confirmación */}
      <ConfirmModal
        isOpen={confirmModal.isOpen}
        onClose={closeConfirmModal}
        onConfirm={confirmModal.onConfirm}
        title={confirmModal.title}
        message={confirmModal.message}
        type={confirmModal.type}
        confirmText={confirmModal.confirmText || 'Cerrar Planilla'}
        cancelText="Cancelar"
      />

      {/* Modal de Tareos */}
      <TareoModal
        isOpen={tareoModal.isOpen}
        onClose={closeTareoModal}
        empleado={tareoModal.empleado}
        configuracionesPlame={configuracionesPlame}
        configuracionTareo={(() => {
          const cfgEmp = tareoModal.empleado?.configuracion_tareo || null;
          if (planillaCerrada && tareoModal.empleado) {
            return {
              ...(configuracionTareo || {}),
              ...(cfgEmp || {}),
              descontar_descansos:
                tareoModal.empleado.descuento_descanso
                ?? cfgEmp?.descontar_descansos
                ?? configuracionTareo?.descontar_descansos,
              es_planilla_cerrada: true,
            };
          }
          return cfgEmp || configuracionTareo;
        })()}
        planillaFechaInicio={planillaParaVista?.fecha_inicio}
        planillaFechaFin={planillaParaVista?.fecha_fin}
        autorizacionesPeriodo={autorizacionesPeriodo}
        generarBoletaIndividual={generarBoletaIndividual}
        generandoBoletaIndividual={generandoBoletaIndividual}
        planillaId={planillaReal?.id}
        planillaCerrada={planillaCerrada}
        empresaId={selectedCompany?.id}
      />

      {/* Modal de Compensaciones */}
      <CompensacionesModal
        isOpen={compensacionesModalOpen}
        onClose={closeCompensacionesModal}
        planillaId={planillaReal?.id}
        planillaNombre={planillaReal?.nombre || planilla?.nombre}
        onRecalcularPlanilla={procesarEmpleadosConPlanilla}
        empleadosActivos={empleadosEditablesConsideraciones}
      />

      <GratificacionConsuModal
        isOpen={gratiConsuModalOpen}
        onClose={closeGratiConsuModal}
        onRecalcular={() => procesarEmpleadosConPlanilla({ omitirConfirmacion: true })}
        empleados={filtrarEmpleadosEditablesPlanilla(
          (empleadosActivosPlanilla || []).filter((emp) => (
            String(planillaReal?.modalidad_planilla || '').includes('construccion')
            || esRegimenConstruccionCivil(emp, regimenesLaborales)
          )),
        )}
        planillaNombre={planillaReal?.nombre || planilla?.nombre}
        planillaCerrada={planillaCerrada}
        guardando={guardandoFlagOmitirDesc}
        recalculando={calculandoPlanilla}
        periodoGratiConsuDe={periodoGratiConsuDe}
        etiquetaPeriodoGratiConsu={etiquetaPeriodoGratiConsu}
        onCambiarPeriodo={cambiarPeriodoGratiConsu}
      />

      <PeriodoCalculoConsuModal
        isOpen={periodoCalculoConsuModalOpen}
        onClose={closePeriodoCalculoConsuModal}
        onRecalcular={() => procesarEmpleadosConPlanilla({ omitirConfirmacion: true })}
        empleados={filtrarEmpleadosEditablesPlanilla(empleadosActivosPlanilla)}
        planillaNombre={planillaReal?.nombre || planilla?.nombre}
        fechaInicio={planillaReal?.fecha_inicio}
        fechaFin={planillaReal?.fecha_fin}
        planillaCerrada={planillaCerrada}
        guardando={guardandoFlagOmitirDesc}
        recalculando={calculandoPlanilla}
        fechaCalculoDesdeDe={fechaCalculoDesdeDe}
        fechaCalculoHastaDe={fechaCalculoHastaDe}
        onCambiarFechas={cambiarFechaCalculoConsu}
      />

      <PagoJornalModal
        isOpen={pagoJornalModalOpen}
        onClose={closePagoJornalModal}
        onRecalcular={() => procesarEmpleadosConPlanilla({ omitirConfirmacion: true })}
        empleados={filtrarEmpleadosEditablesPlanilla(
          (empleadosActivosPlanilla || []).filter((emp) => (
            !esRegimenConstruccionCivil(emp, regimenesLaborales)
          )),
        )}
        planillaNombre={planillaReal?.nombre || planilla?.nombre}
        fechaInicio={planillaReal?.fecha_inicio}
        fechaFin={planillaReal?.fecha_fin}
        planillaCerrada={planillaCerrada}
        guardando={guardandoFlagOmitirDesc}
        recalculando={calculandoPlanilla}
        formaPagoPlanillaDe={formaPagoPlanillaDe}
        fechaDesdeJornalDe={fechaDesdeJornalDe}
        descuentoDominicalDe={descuentoDominicalDe}
        onCambiarFormaPago={cambiarFormaPagoJornal}
        onCambiarDescuentoDominical={cambiarDescuentoDominical}
      />

      <SegurosPlanillaModal
        isOpen={segurosModalOpen}
        onClose={closeSegurosModal}
        planillaId={planillaReal?.id}
        planillaNombre={planillaReal?.nombre || planilla?.nombre}
        empleados={empleadosEditablesConsideraciones}
        onActualizarResumen={handleActualizarResumenSeguros}
        onRecalcularPlanilla={() => procesarEmpleadosConPlanilla({ omitirConfirmacion: true })}
      />

      <EventosBoletaOverrideModal
        isOpen={eventosBoletaModalOpen}
        onClose={closeEventosBoletaModal}
        empleados={empleadosEditablesConsideraciones}
        tareosPeriodo={tareosPeriodo}
        overridesMap={overridesTareoEvento}
        onGuardar={handleGuardarOverridesTareoEvento}
        guardando={guardandoOverridesTareo}
      />

      <BoletaInternaTramosModal
        isOpen={tramosInternaModalOpen}
        onClose={closeTramosInternaModal}
        empleados={empleadosEditablesConsideraciones}
        tareosPeriodo={tareosPeriodo}
        tramosMap={tramosBoletaInterna}
        onGuardar={handleGuardarTramosBoletaInterna}
        guardando={guardandoTramosInterna}
      />

      <SueldoTramosPlameModal
        isOpen={tramosSueldoModalOpen}
        onClose={closeTramosSueldoModal}
        empleados={empleadosEditablesConsideraciones}
        tramosMap={tramosSueldoPlame}
        fechaInicioPlanilla={planillaReal?.fecha_inicio || planillaParaVista?.fecha_inicio}
        fechaFinPlanilla={planillaReal?.fecha_fin || planillaParaVista?.fecha_fin}
        planillaAlternativaActiva={planillaAlternativaActiva}
        onGuardar={handleGuardarTramosSueldoPlame}
        onRecalcular={() => procesarEmpleadosConPlanilla({ omitirConfirmacion: true })}
        guardando={guardandoTramosSueldo}
        recalculando={calculandoPlanilla}
      />

      {/* Modal Principal de Ajustes de Sueldos */}
      {ajustesSueldosModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col">
            {/* Header del Modal */}
            <div className="bg-gradient-to-r from-yellow-500 to-orange-500 p-6 text-white">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <span className="text-3xl">💰</span>
                  <div>
                    <h2 className="text-2xl font-bold">Ajustes de Sueldos</h2>
                    <p className="text-yellow-100">Modificaciones temporales para {planillaReal?.nombre || planilla?.nombre}</p>
                  </div>
                </div>
                <button
                  onClick={closeAjustesSueldosModal}
                  className="text-white hover:text-yellow-200 text-2xl p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors flex-shrink-0"
                >
                  ✕
                </button>
              </div>
            </div>

            {/* Contenido del Modal */}
            <div className="p-6 overflow-y-auto flex-1">
              {/* Información importante */}
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
                <div className="flex items-start space-x-3">
                  <span className="text-yellow-600 text-xl">⚠️</span>
                  <div>
                    <h4 className="font-semibold text-yellow-800 mb-1">Información Importante</h4>
                    <p className="text-yellow-700 text-sm">
                      Los ajustes realizados aquí son temporales y solo afectarán a esta planilla específica. 
                      No modificarán los registros permanentes de los empleados.
                    </p>
                  </div>
                </div>
              </div>

              {/* Lista de Empleados */}
              <div className="space-y-3">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Selecciona un empleado para ajustar sus conceptos de ingresos:
                </h3>
                
                {empleadosEditablesConsideraciones && empleadosEditablesConsideraciones.length > 0 ? (
                  <div className="grid gap-3">
                    {empleadosEditablesConsideraciones.map((empleado) => {
                      const tieneAjustes = conceptosTemporales[empleado.id];
                      const cantidadAjustes = tieneAjustes ? Object.keys(tieneAjustes).length : 0;
                      const omitirDescPlame = omitirDescuentosPlameInternaDe(empleado.id);
                      const muestraFlagInterna = empleadoTieneBoletaInternaParaFlag(empleado);
                      
                      return (
                        <div
                          key={empleado.id}
                          className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 cursor-pointer transition-colors"
                          onClick={() => openConceptosEmpleadoModal(empleado)}
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex items-center space-x-3">
                              <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full flex items-center justify-center text-white font-bold">
                                {empleado.nombre?.charAt(0)?.toUpperCase() || 'E'}
                              </div>
                              <div>
                                <h4 className="font-semibold text-gray-900">{empleado.nombre}</h4>
                                <div className="flex items-center space-x-4 text-sm text-gray-600">
                                  <span>📄 DNI: {empleado.documento}</span>
                                  <span>🏷️ {empleado.cargo}</span>
                                  <span>🏢 {empleado.areas_de_trabajo || 'Sin área'}</span>
                                </div>
                              </div>
                            </div>
                            
                            <div className="flex items-center space-x-3">
                              {muestraFlagInterna && omitirDescPlame && (
                                <div className="bg-amber-100 text-amber-800 px-3 py-1 rounded-full text-xs font-medium">
                                  Sin desc. PLAME en interna
                                </div>
                              )}
                              {tieneAjustes && (
                                <div className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
                                  ✅ {cantidadAjustes} ajuste{cantidadAjustes > 1 ? 's' : ''}
                                </div>
                              )}
                              <span className="text-gray-400">→</span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="text-center py-8 text-gray-500">
                    <span className="text-4xl mb-2 block">👥</span>
                    <p>No hay empleados disponibles para ajustar</p>
                  </div>
                )}
              </div>
            </div>

            {/* Footer del Modal */}
            <div className="bg-gray-50 px-6 py-4 border-t flex-shrink-0">
              <div className="flex items-center justify-between">
                <div className="text-sm text-gray-600">
                  📊 Total empleados: {empleadosEditablesConsideraciones?.length || 0} | 
                  ✅ Con ajustes: {Object.keys(conceptosTemporales).filter((eid) => !empleadosFotografiadosIds.has(Number(eid))).length}
                </div>
                <div className="flex items-center space-x-3">
                  <button
                    onClick={closeAjustesSueldosModal}
                    className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 font-medium transition-colors"
                  >
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Pequeño de Conceptos del Empleado */}
      {conceptosEmpleadoModalOpen && empleadoSeleccionadoAjustes && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]">
          <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[85vh] overflow-hidden">
            {/* Header del Modal */}
            <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-4 text-white">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center text-white font-bold">
                    {empleadoSeleccionadoAjustes.nombre?.charAt(0)?.toUpperCase() || 'E'}
                  </div>
                  <div>
                    <h3 className="text-lg font-bold">Conceptos del Empleado</h3>
                    <p className="text-blue-100 text-sm">{empleadoSeleccionadoAjustes.nombre}</p>
                  </div>
                </div>
                <button
                  onClick={closeConceptosEmpleadoModal}
                  className="text-white hover:text-blue-200 text-xl p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors flex-shrink-0"
                >
                  ✕
                </button>
              </div>
            </div>

            {/* Contenido del Modal */}
            <div className="p-4 overflow-y-auto max-h-[60vh]">
              {/* Información del Empleado */}
              <div className="bg-gray-50 rounded-lg p-3 mb-4">
                <div className="grid grid-cols-2 gap-3 text-sm">
                  <div>
                    <span className="text-gray-600">📄 DNI:</span>
                    <span className="ml-2 font-medium">{empleadoSeleccionadoAjustes.documento}</span>
                  </div>
                  <div>
                    <span className="text-gray-600">🏷️ Cargo:</span>
                    <span className="ml-2 font-medium">{empleadoSeleccionadoAjustes.cargo}</span>
                  </div>
                </div>
                {empleadoTieneBoletaInternaParaFlag(empleadoSeleccionadoAjustes) && (
                  <label
                    className="mt-3 flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900 cursor-pointer"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <input
                      type="checkbox"
                      className="mt-0.5"
                      checked={omitirDescuentosPlameInternaDe(empleadoSeleccionadoAjustes.id)}
                      disabled={guardandoFlagOmitirDesc || planillaCerrada}
                      onChange={(e) => {
                        e.stopPropagation();
                        toggleOmitirDescuentosPlameInterna(
                          empleadoSeleccionadoAjustes.id,
                          e.target.checked
                        );
                      }}
                    />
                    <span>
                      <span className="font-medium">No copiar descuentos PLAME a boleta interna</span>
                      <span className="block text-xs text-amber-800 mt-0.5">
                        Omite AFP/ONP/minera jalados desde PLAME. Se guarda al marcar y se respeta hasta que lo desactives. Recalcula la planilla para ver el efecto.
                      </span>
                    </span>
                  </label>
                )}
              </div>

              {/* Grupo: Ingresos */}
              <div className="space-y-3">
                <div className="flex items-center justify-between border-b border-gray-200 pb-2">
                  <h4 className="font-semibold text-gray-900 flex items-center space-x-2">
                    <span>💰</span>
                    <span>Ingresos</span>
                  </h4>
                  <button
                    onClick={openConceptosPlameModal}
                    className="px-3 py-1 text-sm bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 flex items-center space-x-2"
                  >
                    <span>➕</span>
                    <span>Agregar Conceptos PLAME</span>
                  </button>
                </div>

                {empleadoSeleccionadoAjustes.conceptos?.ingresos && empleadoSeleccionadoAjustes.conceptos.ingresos.length > 0 ? (
                  <div className="space-y-2">
                    {empleadoSeleccionadoAjustes.conceptos.ingresos.map((concepto) => {
                      const conceptoId = concepto.id || concepto.codigo;
                      const ajusteInfo = getAjusteTemporalConcepto(
                        empleadoSeleccionadoAjustes.id,
                        conceptoId,
                        concepto
                      );
                      const montoActual = ajusteInfo.monto;
                      const destinoActual = ajusteInfo.destino;
                      const tieneAjuste = ajusteInfo.tieneAjuste
                        || conceptosTemporales[empleadoSeleccionadoAjustes.id]?.[conceptoId] !== undefined;
                      const estaEliminado = conceptosEliminados[empleadoSeleccionadoAjustes.id]?.[conceptoId];
                      
                      // Códigos autocalculados (no editables)
                      // 0601: Comisión Porcentual AFP
                      // 0606: Prima de Seguro AFP
                      // 0607: ONP - Sistema Nacional de Pensiones
                      // 0608: Aportación Obligatoria AFP
                      // 0804: ESSALUD
                      const codigosAutocalculados = ['0601', '0606', '0607', '0608', '0804'];
                      const codigoConcepto = concepto.codigo || concepto.codigoPlame || '';
                      const esAutocalculado = codigosAutocalculados.includes(codigoConcepto);
                      const mostrarDestino = mostrarSelectorDestinoAjuste(empleadoSeleccionadoAjustes.id) && !esAutocalculado;
                      
                      if (estaEliminado) {
                        return (
                          <div
                            key={conceptoId}
                            className="border border-red-300 bg-red-50 rounded-lg p-3 opacity-60"
                          >
                            <div className="flex items-center justify-between mb-2">
                              <div className="flex-1">
                                <h5 className="font-medium text-gray-500 line-through">{concepto.descripcion || "Sin descripción"}</h5>
                                <p className="text-xs text-gray-500">Código: {concepto.codigo || concepto.codigoPlame || "0000"} - ELIMINADO</p>
                              </div>
                              <div className="flex items-center space-x-2">
                                <div className="text-xs bg-red-100 text-red-800 px-2 py-1 rounded-full">
                                  ❌ Eliminado
                                </div>
                                <button
                                  onClick={() => restaurarConcepto(empleadoSeleccionadoAjustes.id, conceptoId)}
                                  className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded hover:bg-green-200"
                                  title="Restaurar concepto"
                                >
                                  🔄 Restaurar
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      }
                      
                      // 🐛 DEBUG: Verificar datos que llegan al modal para renderizado
                      console.log(`🎨 RENDERIZANDO concepto ID ${conceptoId}:`, {
                        descripcion: concepto.descripcion,
                        codigo: concepto.codigo,
                        codigoPlame: concepto.codigoPlame,
                        plame_configuracion: concepto.plame_configuracion,
                        concepto_completo: concepto
                      });
                      
                      return (
                        <div
                          key={conceptoId}
                          className={`border rounded-lg p-3 ${
                            tieneAjuste ? 'border-green-300 bg-green-50' : 
                            concepto.esNuevo ? 'border-blue-300 bg-blue-50' : 
                            'border-gray-200'
                          }`}
                        >
                          <div className="flex items-center justify-between mb-2">
                            <div className="flex-1">
                              <h5 className="font-medium text-gray-900">{concepto.descripcion || "Sin descripción"}</h5>
                              <p className="text-xs text-gray-600">Código: {concepto.codigo || concepto.codigoPlame || "0000"}</p>
                            </div>
                            {esAutocalculado && (
                              <div className="text-xs bg-purple-100 text-purple-800 px-2 py-1 rounded-full flex items-center space-x-1">
                                <span>🔒</span>
                                <span>Autocalculado</span>
                              </div>
                            )}
                            {!esAutocalculado && tieneAjuste && (
                              <div className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full">
                                ✅ Ajustado{destinoActual === 'plame' ? ' PLAME' : destinoActual === 'interna' ? ' Interna' : ' Ambas'}
                              </div>
                            )}
                            {!esAutocalculado && concepto.esNuevo && (
                              <div className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
                                🆕 Nuevo
                              </div>
                            )}
                          </div>
                          
                          <div className="flex items-center space-x-3">
                            <div className="flex-1">
                              <label className="block text-xs text-gray-600 mb-1">Monto Original:</label>
                              <div className="text-sm font-medium text-gray-900">
                                S/ {parseFloat(concepto.monto || 0).toFixed(2)}
                              </div>
                            </div>
                            
                            <div className="flex-1">
                              <label className="block text-xs text-gray-600 mb-1">
                                {esAutocalculado ? 'Monto Calculado:' : 'Nuevo Monto:'}
                              </label>
                              <input
                                type="number"
                                step="0.01"
                                min="0"
                                value={montoActual || ''}
                                onChange={(e) => {
                                  const nuevoMonto = e.target.value;
                                  actualizarConceptoTemporal(
                                    empleadoSeleccionadoAjustes.id,
                                    conceptoId,
                                    nuevoMonto,
                                    destinoActual
                                  );
                                }}
                                disabled={esAutocalculado}
                                className={`w-full px-3 py-1 text-sm border rounded focus:outline-none ${
                                  esAutocalculado 
                                    ? 'bg-gray-100 border-gray-300 text-gray-600 cursor-not-allowed' 
                                    : 'border-gray-300 focus:ring-2 focus:ring-blue-500'
                                }`}
                                placeholder="0.00"
                                title={esAutocalculado ? 'Este concepto se calcula automáticamente' : ''}
                              />
                            </div>
                            
                            <div className="flex flex-col space-y-1">
                              {!esAutocalculado && (
                                <>
                              <button
                                onClick={() => {
                                  actualizarConceptoTemporal(
                                    empleadoSeleccionadoAjustes.id,
                                    conceptoId,
                                    concepto.monto,
                                    destinoActual
                                  );
                                }}
                                className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded hover:bg-blue-200"
                                title="Restaurar valor original"
                              >
                                🔄
                              </button>
                              
                              {tieneAjuste && (
                                <button
                                  onClick={() => {
                                    setConceptosTemporales(prev => {
                                      const nuevos = { ...prev };
                                      if (nuevos[empleadoSeleccionadoAjustes.id]) {
                                        delete nuevos[empleadoSeleccionadoAjustes.id][conceptoId];
                                        if (Object.keys(nuevos[empleadoSeleccionadoAjustes.id]).length === 0) {
                                          delete nuevos[empleadoSeleccionadoAjustes.id];
                                        }
                                      }
                                      return nuevos;
                                    });
                                  }}
                                  className="text-xs bg-orange-100 text-orange-700 px-2 py-1 rounded hover:bg-orange-200"
                                  title="Limpiar ajuste"
                                >
                                  🧹
                                </button>
                              )}
                              
                              <button
                                onClick={() => eliminarConcepto(empleadoSeleccionadoAjustes.id, conceptoId)}
                                className="text-xs bg-red-100 text-red-700 px-2 py-1 rounded hover:bg-red-200"
                                title="Eliminar concepto completamente"
                              >
                                ❌
                              </button>
                                </>
                              )}
                              {esAutocalculado && (
                                <div className="text-xs text-gray-500 text-center px-2 py-1">
                                  <span title="Este concepto se calcula automáticamente y no puede ser modificado">🔒</span>
                                </div>
                              )}
                            </div>
                          </div>
                          {mostrarDestino && (
                            <div className="mt-2 pt-2 border-t border-gray-100">
                              <label className="block text-xs text-gray-600 mb-1">Aplica a:</label>
                              <div className="flex flex-wrap gap-2">
                                {[
                                  { value: 'plame', label: 'PLAME' },
                                  { value: 'interna', label: 'Interna' },
                                  { value: 'ambas', label: 'Ambas' },
                                ].map((opt) => (
                                  <button
                                    key={opt.value}
                                    type="button"
                                    onClick={() => {
                                      actualizarConceptoTemporal(
                                        empleadoSeleccionadoAjustes.id,
                                        conceptoId,
                                        montoActual,
                                        opt.value
                                      );
                                    }}
                                    className={`text-xs px-2.5 py-1 rounded-full border transition-colors ${
                                      destinoActual === opt.value
                                        ? opt.value === 'plame'
                                          ? 'bg-teal-100 text-teal-800 border-teal-300'
                                          : opt.value === 'interna'
                                            ? 'bg-amber-100 text-amber-900 border-amber-300'
                                            : 'bg-indigo-100 text-indigo-800 border-indigo-300'
                                        : 'bg-white text-gray-600 border-gray-200 hover:bg-gray-50'
                                    }`}
                                  >
                                    {opt.label}
                                  </button>
                                ))}
                              </div>
                              <p className="text-[11px] text-gray-500 mt-1">
                                {destinoActual === 'plame'
                                  ? 'Solo modifica la boleta PLAME'
                                  : destinoActual === 'interna'
                                    ? 'Solo modifica la boleta interna (p. ej. sueldo interno)'
                                    : 'Modifica PLAME e interna'}
                              </p>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="text-center py-6 text-gray-500">
                    <span className="text-3xl mb-2 block">📋</span>
                    <p>No hay conceptos de ingresos disponibles para este empleado</p>
                  </div>
                )}
              </div>

              {/* Grupo: Descuentos */}
              <div className="space-y-3 mt-6">
                <div className="flex items-center justify-between border-b border-gray-200 pb-2">
                  <h4 className="font-semibold text-gray-900 flex items-center space-x-2">
                    <span>📉</span>
                    <span>Descuentos</span>
                  </h4>
                </div>

                {empleadoSeleccionadoAjustes.conceptos?.descuentos && empleadoSeleccionadoAjustes.conceptos.descuentos.length > 0 ? (
                  <div className="space-y-2">
                    {empleadoSeleccionadoAjustes.conceptos.descuentos.map((concepto) => {
                      const conceptoId = concepto.id || concepto.codigo;
                      const montoTemporal = conceptosTemporales[empleadoSeleccionadoAjustes.id]?.[conceptoId];
                      const montoActual = montoTemporal !== undefined ? getMontoDesdeAjuste(montoTemporal, concepto.monto) : concepto.monto;
                      const tieneAjuste = montoTemporal !== undefined;
                      const estaEliminado = conceptosEliminados[empleadoSeleccionadoAjustes.id]?.[conceptoId];

                      // Códigos autocalculados (no editables)
                      // 0601: Comisión Porcentual AFP
                      // 0606: Prima de Seguro AFP
                      // 0607: ONP - Sistema Nacional de Pensiones
                      // 0608: Aportación Obligatoria AFP
                      // 0804: ESSALUD
                      const codigosAutocalculados = ['0601', '0606', '0607', '0608', '0804'];
                      const codigoConcepto = concepto.codigo || concepto.codigoPlame || '';
                      const esAutocalculado = codigosAutocalculados.includes(codigoConcepto);

                      if (estaEliminado) {
                        return (
                          <div
                            key={conceptoId}
                            className="border border-red-300 bg-red-50 rounded-lg p-3 opacity-60"
                          >
                            <div className="flex items-center justify-between mb-2">
                              <div className="flex-1">
                                <h5 className="font-medium text-gray-500 line-through">{concepto.descripcion || "Sin descripción"}</h5>
                                <p className="text-xs text-gray-500">Código: {concepto.codigo || concepto.codigoPlame || "0000"} - ELIMINADO</p>
                              </div>
                              <div className="flex items-center space-x-2">
                                <div className="text-xs bg-red-100 text-red-800 px-2 py-1 rounded-full">❌ Eliminado</div>
                                <button
                                  onClick={() => restaurarConcepto(empleadoSeleccionadoAjustes.id, conceptoId)}
                                  className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded hover:bg-green-200"
                                  title="Restaurar concepto"
                                >
                                  🔄 Restaurar
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      }

                      return (
                        <div
                          key={conceptoId}
                          className={`border rounded-lg p-3 ${
                            esAutocalculado ? 'border-purple-200 bg-purple-50' :
                            tieneAjuste ? 'border-green-300 bg-green-50' :
                            concepto.esNuevo ? 'border-blue-300 bg-blue-50' :
                            'border-gray-200'
                          }`}
                        >
                          <div className="flex items-center justify-between mb-2">
                            <div className="flex-1">
                              <h5 className="font-medium text-gray-900">{concepto.descripcion || "Sin descripción"}</h5>
                              <p className="text-xs text-gray-600">Código: {concepto.codigo || concepto.codigoPlame || "0000"}</p>
                            </div>
                            {esAutocalculado && (
                              <div className="text-xs bg-purple-100 text-purple-800 px-2 py-1 rounded-full flex items-center space-x-1">
                                <span>🔒</span>
                                <span>Autocalculado</span>
                              </div>
                            )}
                            {!esAutocalculado && tieneAjuste && (
                              <div className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full">✅ Ajustado</div>
                            )}
                            {!esAutocalculado && concepto.esNuevo && (
                              <div className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">🆕 Nuevo</div>
                            )}
                          </div>
                          <div className="flex items-center space-x-3">
                            <div className="flex-1">
                              <label className="block text-xs text-gray-600 mb-1">Monto Original:</label>
                              <div className="text-sm font-medium text-gray-900">
                                S/ {parseFloat(concepto.monto || 0).toFixed(2)}
                              </div>
                            </div>
                            <div className="flex-1">
                              <label className="block text-xs text-gray-600 mb-1">
                                {esAutocalculado ? 'Monto Calculado:' : 'Nuevo Monto:'}
                              </label>
                              <input
                                type="number"
                                step="0.01"
                                min="0"
                                value={montoActual || ''}
                                onChange={(e) => actualizarConceptoTemporal(empleadoSeleccionadoAjustes.id, conceptoId, e.target.value)}
                                disabled={esAutocalculado}
                                className={`w-full px-3 py-1 text-sm border rounded focus:outline-none ${
                                  esAutocalculado 
                                    ? 'bg-gray-100 border-gray-300 text-gray-600 cursor-not-allowed' 
                                    : 'border-gray-300 focus:ring-2 focus:ring-blue-500'
                                }`}
                                placeholder="0.00"
                                title={esAutocalculado ? 'Este concepto se calcula automáticamente' : ''}
                              />
                            </div>
                            <div className="flex flex-col space-y-1">
                              {!esAutocalculado && (
                                <>
                                  <button
                                    onClick={() => actualizarConceptoTemporal(empleadoSeleccionadoAjustes.id, conceptoId, concepto.monto)}
                                    className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded hover:bg-blue-200"
                                    title="Restaurar valor original"
                                  >
                                    🔄
                                  </button>
                                  {tieneAjuste && (
                                    <button
                                      onClick={() => {
                                        setConceptosTemporales(prev => {
                                          const nuevos = { ...prev };
                                          if (nuevos[empleadoSeleccionadoAjustes.id]) {
                                            delete nuevos[empleadoSeleccionadoAjustes.id][conceptoId];
                                            if (Object.keys(nuevos[empleadoSeleccionadoAjustes.id]).length === 0) {
                                              delete nuevos[empleadoSeleccionadoAjustes.id];
                                            }
                                          }
                                          return nuevos;
                                        });
                                      }}
                                      className="text-xs bg-orange-100 text-orange-700 px-2 py-1 rounded hover:bg-orange-200"
                                      title="Limpiar ajuste"
                                    >
                                      🧹
                                    </button>
                                  )}
                                  <button
                                    onClick={() => eliminarConcepto(empleadoSeleccionadoAjustes.id, conceptoId)}
                                    className="text-xs bg-red-100 text-red-700 px-2 py-1 rounded hover:bg-red-200"
                                    title="Eliminar concepto"
                                  >
                                    ❌
                                  </button>
                                </>
                              )}
                              {esAutocalculado && (
                                <div className="text-xs text-gray-500 text-center px-2 py-1">
                                  <span title="Este concepto se calcula automáticamente y no puede ser modificado">🔒</span>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="text-center py-4 text-gray-500">
                    <span className="text-2xl mb-2 block">📉</span>
                    <p>No hay conceptos de descuentos para este empleado</p>
                  </div>
                )}
              </div>

              {/* Grupo: Aportes */}
              <div className="space-y-3 mt-6">
                <div className="flex items-center justify-between border-b border-gray-200 pb-2">
                  <h4 className="font-semibold text-gray-900 flex items-center space-x-2">
                    <span>📊</span>
                    <span>Aportes</span>
                  </h4>
                </div>

                {empleadoSeleccionadoAjustes.conceptos?.aportes && empleadoSeleccionadoAjustes.conceptos.aportes.length > 0 ? (
                  <div className="space-y-2">
                    {empleadoSeleccionadoAjustes.conceptos.aportes.map((concepto) => {
                      const conceptoId = concepto.id || concepto.codigo;
                      const montoTemporal = conceptosTemporales[empleadoSeleccionadoAjustes.id]?.[conceptoId];
                      const montoActual = montoTemporal !== undefined ? montoTemporal : concepto.monto;
                      const tieneAjuste = montoTemporal !== undefined;
                      const estaEliminado = conceptosEliminados[empleadoSeleccionadoAjustes.id]?.[conceptoId];

                      // Códigos autocalculados (no editables)
                      // 0601: Comisión Porcentual AFP
                      // 0606: Prima de Seguro AFP
                      // 0607: ONP - Sistema Nacional de Pensiones
                      // 0608: Aportación Obligatoria AFP
                      // 0804: ESSALUD
                      const codigosAutocalculados = ['0601', '0606', '0607', '0608', '0804'];
                      const codigoConcepto = concepto.codigo || concepto.codigoPlame || '';
                      const esAutocalculado = codigosAutocalculados.includes(codigoConcepto);

                      if (estaEliminado) {
                        return (
                          <div
                            key={conceptoId}
                            className="border border-red-300 bg-red-50 rounded-lg p-3 opacity-60"
                          >
                            <div className="flex items-center justify-between mb-2">
                              <div className="flex-1">
                                <h5 className="font-medium text-gray-500 line-through">{concepto.descripcion || "Sin descripción"}</h5>
                                <p className="text-xs text-gray-500">Código: {concepto.codigo || concepto.codigoPlame || "0000"} - ELIMINADO</p>
                              </div>
                              <div className="flex items-center space-x-2">
                                <div className="text-xs bg-red-100 text-red-800 px-2 py-1 rounded-full">❌ Eliminado</div>
                                <button
                                  onClick={() => restaurarConcepto(empleadoSeleccionadoAjustes.id, conceptoId)}
                                  className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded hover:bg-green-200"
                                  title="Restaurar concepto"
                                >
                                  🔄 Restaurar
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      }

                      return (
                        <div
                          key={conceptoId}
                          className={`border rounded-lg p-3 ${
                            esAutocalculado ? 'border-purple-200 bg-purple-50' :
                            tieneAjuste ? 'border-green-300 bg-green-50' :
                            concepto.esNuevo ? 'border-blue-300 bg-blue-50' :
                            'border-gray-200'
                          }`}
                        >
                          <div className="flex items-center justify-between mb-2">
                            <div className="flex-1">
                              <h5 className="font-medium text-gray-900">{concepto.descripcion || "Sin descripción"}</h5>
                              <p className="text-xs text-gray-600">Código: {concepto.codigo || concepto.codigoPlame || "0000"}</p>
                            </div>
                            {esAutocalculado && (
                              <div className="text-xs bg-purple-100 text-purple-800 px-2 py-1 rounded-full flex items-center space-x-1">
                                <span>🔒</span>
                                <span>Autocalculado</span>
                              </div>
                            )}
                            {!esAutocalculado && tieneAjuste && (
                              <div className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full">✅ Ajustado</div>
                            )}
                            {!esAutocalculado && concepto.esNuevo && (
                              <div className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">🆕 Nuevo</div>
                            )}
                          </div>
                          <div className="flex items-center space-x-3">
                            <div className="flex-1">
                              <label className="block text-xs text-gray-600 mb-1">Monto Original:</label>
                              <div className="text-sm font-medium text-gray-900">
                                S/ {parseFloat(concepto.monto || 0).toFixed(2)}
                              </div>
                            </div>
                            <div className="flex-1">
                              <label className="block text-xs text-gray-600 mb-1">
                                {esAutocalculado ? 'Monto Calculado:' : 'Nuevo Monto:'}
                              </label>
                              <input
                                type="number"
                                step="0.01"
                                min="0"
                                value={montoActual || ''}
                                onChange={(e) => actualizarConceptoTemporal(empleadoSeleccionadoAjustes.id, conceptoId, e.target.value)}
                                disabled={esAutocalculado}
                                className={`w-full px-3 py-1 text-sm border rounded focus:outline-none ${
                                  esAutocalculado 
                                    ? 'bg-gray-100 border-gray-300 text-gray-600 cursor-not-allowed' 
                                    : 'border-gray-300 focus:ring-2 focus:ring-blue-500'
                                }`}
                                placeholder="0.00"
                                title={esAutocalculado ? 'Este concepto se calcula automáticamente' : ''}
                              />
                            </div>
                            <div className="flex flex-col space-y-1">
                              {!esAutocalculado && (
                                <>
                                  <button
                                    onClick={() => actualizarConceptoTemporal(empleadoSeleccionadoAjustes.id, conceptoId, concepto.monto)}
                                    className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded hover:bg-blue-200"
                                    title="Restaurar valor original"
                                  >
                                    🔄
                                  </button>
                                  {tieneAjuste && (
                                    <button
                                      onClick={() => {
                                        setConceptosTemporales(prev => {
                                          const nuevos = { ...prev };
                                          if (nuevos[empleadoSeleccionadoAjustes.id]) {
                                            delete nuevos[empleadoSeleccionadoAjustes.id][conceptoId];
                                            if (Object.keys(nuevos[empleadoSeleccionadoAjustes.id]).length === 0) {
                                              delete nuevos[empleadoSeleccionadoAjustes.id];
                                            }
                                          }
                                          return nuevos;
                                        });
                                      }}
                                      className="text-xs bg-orange-100 text-orange-700 px-2 py-1 rounded hover:bg-orange-200"
                                      title="Limpiar ajuste"
                                    >
                                      🧹
                                    </button>
                                  )}
                                  <button
                                    onClick={() => eliminarConcepto(empleadoSeleccionadoAjustes.id, conceptoId)}
                                    className="text-xs bg-red-100 text-red-700 px-2 py-1 rounded hover:bg-red-200"
                                    title="Eliminar concepto"
                                  >
                                    ❌
                                  </button>
                                </>
                              )}
                              {esAutocalculado && (
                                <div className="text-xs text-gray-500 text-center px-2 py-1">
                                  <span title="Este concepto se calcula automáticamente y no puede ser modificado">🔒</span>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="text-center py-4 text-gray-500">
                    <span className="text-2xl mb-2 block">📊</span>
                    <p>No hay conceptos de aportes para este empleado</p>
                  </div>
                )}
              </div>
            </div>

            {/* Footer del Modal */}
            <div className="bg-gray-50 px-4 py-3 border-t">
              <div className="flex items-center justify-between">
                <div className="text-sm text-gray-600">
                  <span className="font-medium">Ingresos:</span> {empleadoSeleccionadoAjustes.conceptos?.ingresos?.length || 0}
                  {' | '}
                  <span className="font-medium">Descuentos:</span> {empleadoSeleccionadoAjustes.conceptos?.descuentos?.length || 0}
                  {' | '}
                  <span className="font-medium">Aportes:</span> {empleadoSeleccionadoAjustes.conceptos?.aportes?.length || 0}
                  {' | '}
                  <span className="text-green-600">{conceptosTemporales[empleadoSeleccionadoAjustes.id] ? Object.keys(conceptosTemporales[empleadoSeleccionadoAjustes.id]).length : 0} ajustados</span>
                  {empleadosConceptosRestaurados.has(empleadoSeleccionadoAjustes.id) && (
                    <span className="ml-2 text-purple-600 font-medium">
                      | 🔄 Restaurado (pendiente guardar)
                    </span>
                  )}
                </div>
                <div className="flex items-center space-x-3">
                  <button
                    onClick={() => restaurarConceptosOriginalesEmpleado(empleadoSeleccionadoAjustes.id)}
                    className="px-3 py-1 text-sm bg-purple-100 text-purple-700 rounded hover:bg-purple-200 flex items-center space-x-1"
                    title="Restaurar conceptos originales desde el backend"
                  >
                    <span>🔙</span>
                    <span>Restaurar Originales</span>
                  </button>
                  {conceptosTemporales[empleadoSeleccionadoAjustes.id] && (
                    <button
                      onClick={() => resetearAjustesEmpleado(empleadoSeleccionadoAjustes.id)}
                      className="px-3 py-1 text-sm bg-orange-100 text-orange-700 rounded hover:bg-orange-200"
                      title="Limpiar ajustes temporales sin restaurar desde backend"
                    >
                      🧹 Limpiar Ajustes
                    </button>
                  )}
                  <button
                    onClick={async () => {
                      // 🔄 NO cerrar el modal para permitir más ediciones
                      await recalcularPlanillaConAjustes();
                      
                      // 🔄 Refrescar los datos del empleado actual en el modal
                      if (empleadoSeleccionadoAjustes) {
                        console.log('🔄 Refrescando datos del empleado en el modal después del recálculo...');
                        try {
                          const response = await consideracionesConceptosService.obtenerConceptosEmpleado(
                            parseInt(id), 
                            empleadoSeleccionadoAjustes.id
                          );
                          
                          if (response.success) {
                            const empleadoActualizado = {
                              ...empleadoSeleccionadoAjustes,
                              conceptos: response.data.conceptos
                            };
                            setEmpleadoSeleccionadoAjustes(empleadoActualizado);
                            console.log('✅ Datos del empleado refrescados en el modal');
                          }
                        } catch (error) {
                          console.error('⚠️ Error refrescando datos del empleado:', error);
                        }
                      }
                    }}
                    className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 text-sm font-medium"
                    disabled={calculandoPlanilla}
                  >
                    {calculandoPlanilla ? (
                      <>🔄 Recalculando...</>
                    ) : (
                      <>✅ Guardar y Recalcular</>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Conceptos PLAME */}
      {conceptosPlameModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[70]">
          <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full mx-4 max-h-[85vh] overflow-hidden flex flex-col">
            {/* Header del Modal */}
            <div className="bg-gradient-to-r from-green-500 to-green-600 p-4 text-white">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <span className="text-2xl">📋</span>
                  <div>
                    <h3 className="text-lg font-bold">Conceptos PLAME</h3>
                    <p className="text-green-100 text-sm">Selecciona conceptos para agregar al empleado</p>
                  </div>
                </div>
                <button
                  onClick={closeConceptosPlameModal}
                  className="text-white hover:text-green-200 text-xl p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors flex-shrink-0"
                >
                  ✕
                </button>
              </div>
            </div>

            {/* Pestañas */}
            <div className="flex border-b border-gray-200 bg-gray-50">
              <button
                onClick={() => setTabPlameActiva('ingresos')}
                className={`flex-1 px-4 py-3 text-sm font-medium transition-colors ${
                  tabPlameActiva === 'ingresos'
                    ? 'border-b-2 border-green-500 text-green-600 bg-white'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
              >
                <span className="mr-2">💰</span>
                Ingresos
                <span className="ml-2 text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full">
                  {configuracionesPlame?.filter(c => c.clasificacion?.id_tipo === 1).length || 0}
                </span>
              </button>
              <button
                onClick={() => setTabPlameActiva('descuentos')}
                className={`flex-1 px-4 py-3 text-sm font-medium transition-colors ${
                  tabPlameActiva === 'descuentos'
                    ? 'border-b-2 border-red-500 text-red-600 bg-white'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
              >
                <span className="mr-2">📉</span>
                Descuentos
                <span className="ml-2 text-xs bg-red-100 text-red-800 px-2 py-0.5 rounded-full">
                  {configuracionesPlame?.filter(c => c.clasificacion?.id_tipo === 2).length || 0}
                </span>
              </button>
              <button
                onClick={() => setTabPlameActiva('aportes')}
                className={`flex-1 px-4 py-3 text-sm font-medium transition-colors ${
                  tabPlameActiva === 'aportes'
                    ? 'border-b-2 border-blue-500 text-blue-600 bg-white'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
              >
                <span className="mr-2">📊</span>
                Aportes
                <span className="ml-2 text-xs bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full">
                  {configuracionesPlame?.filter(c => c.clasificacion?.id_tipo === 3).length || 0}
                </span>
              </button>
            </div>

            {/* Contenido del Modal */}
            <div className="p-4 overflow-y-auto flex-1">
              {/* Buscador */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  🔍 Buscar concepto PLAME
                </label>
                <input
                  type="text"
                  value={busquedaConceptoPlame}
                  onChange={(e) => setBusquedaConceptoPlame(e.target.value)}
                  placeholder="Buscar por código o descripción..."
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                />
              </div>

              {/* Lista de Conceptos PLAME */}
              <div className="space-y-2">
                {configuracionesPlame && configuracionesPlame.length > 0 ? (
                  <div className="grid gap-2">
                    {configuracionesPlame
                      .filter(concepto => {
                        // Filtrar por tipo según la pestaña activa
                        const idTipo = concepto.clasificacion?.id_tipo;
                        if (tabPlameActiva === 'ingresos' && idTipo !== 1) return false;
                        if (tabPlameActiva === 'descuentos' && idTipo !== 2) return false;
                        if (tabPlameActiva === 'aportes' && idTipo !== 3) return false;
                        
                        // Filtrar por búsqueda
                        if (!busquedaConceptoPlame) return true;
                        const busqueda = busquedaConceptoPlame.toLowerCase();
                        const codigo = concepto.codigo_plame || concepto.codigo || '';
                        const descripcion = concepto.descripcion || '';
                        return codigo.toLowerCase().includes(busqueda) || 
                               descripcion.toLowerCase().includes(busqueda);
                      })
                      .slice(0, 20) // Mostrar máximo 20 resultados
                      .map((concepto) => {
                        // Verificar si ya existe en la sección correspondiente
                        const tipoSeccion = tabPlameActiva;
                        const yaExiste = empleadoSeleccionadoAjustes?.conceptos?.[tipoSeccion]?.some(
                          c => c.codigo === concepto.codigo_plame || c.codigo === concepto.codigo
                        );
                        
                        return (
                          <div
                            key={concepto.id}
                            className={`border rounded-lg p-3 transition-colors ${
                              yaExiste 
                                ? 'border-gray-300 bg-gray-100 opacity-60' 
                                : 'border-gray-200 hover:border-green-300 hover:bg-green-50 cursor-pointer'
                            }`}
                            onClick={() => {
                              if (!yaExiste) {
                                agregarConceptoPlameAlEmpleado(concepto);
                              }
                            }}
                          >
                            <div className="flex items-center justify-between">
                              <div className="flex-1">
                                <h5 className="font-medium text-gray-900">{concepto.descripcion || 'Sin descripción'}</h5>
                                <div className="text-xs text-gray-600 mt-1">
                                  📋 Código PLAME: <span className="font-mono bg-gray-100 px-1 rounded">{concepto.codigo_plame || concepto.codigo || 'N/A'}</span>
                                </div>
                              </div>
                              
                              <div className="flex items-center space-x-2">
                                {yaExiste ? (
                                  <div className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full">
                                    ✅ Ya existe
                                  </div>
                                ) : (
                                  <div className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded-full">
                                    ➕ Seleccionar
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                ) : (
                  <div className="text-center py-8 text-gray-500">
                    <span className="text-4xl mb-2 block">📋</span>
                    <p>No hay configuraciones PLAME disponibles</p>
                    <p className="text-xs mt-2">Verifica que las configuraciones PLAME estén cargadas</p>
                  </div>
                )}
              </div>
            </div>

            {/* Footer del Modal */}
            <div className="bg-gray-50 px-4 py-3 border-t flex-shrink-0">
              <div className="flex items-center justify-between">
                <div className="text-sm text-gray-600">
                  {(() => {
                    const idTipo = tabPlameActiva === 'ingresos' ? 1 : tabPlameActiva === 'descuentos' ? 2 : 3;
                    const conceptosFiltrados = configuracionesPlame?.filter(c => c.clasificacion?.id_tipo === idTipo) || [];
                    const tipoNombre = tabPlameActiva === 'ingresos' ? 'ingresos' : tabPlameActiva === 'descuentos' ? 'descuentos' : 'aportes';
                    
                    return (
                      <>
                        {conceptosFiltrados.length} conceptos de {tipoNombre} disponibles
                  {busquedaConceptoPlame && (
                    <span className="ml-2 text-green-600">
                            (Filtrado: {conceptosFiltrados.filter(c => {
                        const busqueda = busquedaConceptoPlame.toLowerCase();
                        const codigo = c.codigo_plame || c.codigo || '';
                        const descripcion = c.descripcion || '';
                        return codigo.toLowerCase().includes(busqueda) || 
                               descripcion.toLowerCase().includes(busqueda);
                            }).length} resultados)
                    </span>
                  )}
                      </>
                    );
                  })()}
                </div>
                <div className="flex items-center space-x-3">
                  <button
                    onClick={closeConceptosPlameModal}
                    className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 text-sm font-medium transition-colors"
                  >
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 🔍 Modal de Análisis Individual */}
      {modalAnalisisAbierto && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
            {/* Header del Modal */}
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <h3 className="text-lg font-semibold text-gray-900">
                🔍 Análisis Individual de Empleado
              </h3>
              <button
                onClick={closeAnalisisModal}
                className="text-gray-400 hover:text-gray-600 text-2xl font-bold"
              >
                ×
              </button>
            </div>

            {/* Contenido del Modal */}
            <div className="p-6">
              <div className="space-y-4">
                {/* Descripción */}
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <p className="text-sm text-blue-800">
                    <strong>¿Qué hace?</strong><br/>
                    Analiza un empleado específico enviando solo las 4 líneas del header + el empleado seleccionado al backend.
                  </p>
                  <p className="text-sm text-blue-600 mt-2">
                    <strong>Importante:</strong> Este análisis <strong>NO modifica la vista</strong>. Solo genera logs internos para revisión.
                  </p>
                </div>

                {/* Buscador de Empleado */}
                <div className="relative">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Buscar empleado para análisis:
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      value={busquedaEmpleado}
                      onChange={(e) => manejarBusquedaEmpleado(e.target.value)}
                      onFocus={() => {
                        if (empleadosFiltrados.length > 0) {
                          setMostrarSugerencias(true);
                        }
                      }}
                      onBlur={ocultarSugerencias}
                      placeholder="Buscar por nombre, documento o código..."
                      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 pr-10"
                      disabled={calculandoPlanilla}
                    />
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                      <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                    </div>
                  </div>

                  {/* Lista de Sugerencias */}
                  {mostrarSugerencias && empleadosFiltrados.length > 0 && (
                    <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                      {empleadosFiltrados.map(empleado => (
                        <div
                          key={empleado.id}
                          onClick={() => seleccionarEmpleado(empleado)}
                          className="px-3 py-2 cursor-pointer hover:bg-indigo-50 border-b border-gray-100 last:border-b-0"
                        >
                          <div className="flex flex-col">
                            <span className="font-medium text-gray-900 text-sm">
                              {empleado.nombre_completo}
                            </span>
                            <div className="flex text-xs text-gray-500 space-x-2">
                              {empleado.numero_documento && (
                                <span>Doc: {empleado.numero_documento}</span>
                              )}
                              {empleado.codigo_empleado && (
                                <span>Cód: {empleado.codigo_empleado}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Mensaje si no hay resultados */}
                  {busquedaEmpleado && empleadosFiltrados.length === 0 && mostrarSugerencias && (
                    <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg p-3">
                      <span className="text-sm text-gray-500">No se encontraron empleados</span>
                    </div>
                  )}
                </div>

                {/* Información adicional */}
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
                  <p className="text-xs text-yellow-800">
                    💡 <strong>Revisa la consola del navegador</strong> después del análisis para ver todos los logs detallados del procesamiento.
                  </p>
                </div>
              </div>
            </div>

            {/* Footer del Modal */}
            <div className="flex items-center justify-end space-x-3 p-6 border-t border-gray-200">
              <button
                onClick={closeAnalisisModal}
                disabled={calculandoPlanilla}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors disabled:opacity-50"
              >
                Cancelar
              </button>
              <button
                onClick={() => {
                  closeAnalisisModal();
                  procesarEmpleadosConPlanillaDuplicada();
                }}
                disabled={!empleadoSeleccionadoAnalisis || calculandoPlanilla}
                className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2"
              >
                {calculandoPlanilla ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    <span>Analizando...</span>
                  </>
                ) : (
                  <>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span>Analizar Empleado</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 📊 INFORMACIÓN DISCRETA DE APIS CARGADAS - solo dato esencial */}
      {!loading && cargandoProgreso.apisCompletadas.length > 0 && (
        <div className="mt-8 bg-gray-50 rounded-lg p-3 border border-gray-200">
          <div className="flex items-center justify-between">
            <h4 className="text-sm font-medium text-gray-700">📊 Información del Sistema</h4>
            <div className="text-xs">
              <span className="font-medium text-gray-600">APIs cargadas:</span>
              <span className="ml-1 text-green-700 font-semibold">
                {cargandoProgreso.apisCompletadas.length}/{Math.max(cargandoProgreso.total, cargandoProgreso.apisCompletadas.length)}
              </span>
              {conceptosEstaticos.length > 0 && (
                <span className="ml-2 text-purple-600 font-medium">
                  | {conceptosEstaticos.length} conceptos estáticos
                | {configuracionTareo ? 'configuración tareos' : 'sin config. tareos'}
                </span>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlanillaDetalle; 

// ✅ ESTILOS CSS PERSONALIZADOS PARA SCROLL HORIZONTAL ELEGANTE
const customStyles = `
  .planilla-table-container {
    /* Scroll horizontal más elegante */
    scrollbar-width: auto;
    scrollbar-color: #a0aec0 #f7fafc;
  }
  
  .planilla-table-container::-webkit-scrollbar {
    height: 12px;
  }
  
  .planilla-table-container::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 8px;
    margin: 0 8px;
  }
  
  .planilla-table-container::-webkit-scrollbar-thumb {
    background: linear-gradient(45deg, #14b8a6, #0d9488);
    border-radius: 8px;
    border: 2px solid #f1f5f9;
  }
  
  .planilla-table-container::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(45deg, #0d9488, #0f766e);
  }
  
  /* Sombra para indicar contenido desplazable */
  .planilla-table-container {
    position: relative;
  }
  
  .planilla-table-container::before {
    content: '';
    position: sticky;
    right: 0;
    top: 0;
    bottom: 0;
    width: 20px;
    background: linear-gradient(to left, rgba(255,255,255,0.8), transparent);
    pointer-events: none;
    z-index: 5;
  }
  
  /* Mejorar la columna fija del empleado */
  .empleado-sticky-column {
    box-shadow: 2px 0 4px rgba(0,0,0,0.1);
    border-right: 2px solid #e5e7eb !important;
  }
  
  /* Animación suave para el hover de las filas */
  .table-row-hover {
    transition: all 0.2s ease-in-out;
  }
  
  .table-row-hover:hover {
    transform: scale(1.002);
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
  
  /* Estilo para las cabeceras de conceptos */
  .concepto-header {
    min-width: 120px !important;
    max-width: 140px !important;
    word-wrap: break-word;
    hyphens: auto;
    line-height: 1.1;
    vertical-align: middle;
    position: relative;
  }
  
  .concepto-header div {
    white-space: normal;
    overflow-wrap: break-word;
    word-break: break-word;
    line-height: 1.2;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100%;
    text-align: center;
  }
`;

// Inyectar estilos en el head si no existen
if (typeof document !== 'undefined' && !document.getElementById('planilla-custom-styles')) {
  const styleSheet = document.createElement('style');
  styleSheet.id = 'planilla-custom-styles';
  styleSheet.textContent = customStyles;
  document.head.appendChild(styleSheet);
} 